(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8662"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8662"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jgg5e", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
var $ewv1T = parcelRequire("ewv1T");
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $ewv1T._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, $ewv1T._)(self)) == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(_$Object, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)['delete'](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data['delete'](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var _$result = value + '';
            return _$result == '0' && 1 / value == -INFINITY ? '-0' : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join('') : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) _$result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + '', array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case 'drop':
                        start += _$size;
                        break;
                    case 'dropRight':
                        end -= _$size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + _$size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $ewv1T._)(index);
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value);
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value);
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var _$result = value + '';
            return _$result == '0' && 1 / value == -INFINITY ? '-0' : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == 'function' ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value);
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && (typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + 'return ' + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (_$result.__dir__ < 0 ? 'Right' : '')
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == 'function' && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && (0, $ewv1T._)(define.amd) == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});
parcelRegister("ewv1T", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a92c1faf3a33b1f9$export$71511d61b312f219; });
function $a92c1faf3a33b1f9$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("4VdIx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $395720456d44d816$export$2e2bcd8739ae039; });

var $kNmtb = parcelRequire("kNmtb");

var $ewv1T = parcelRequire("ewv1T");
var htmx = function() {
    'use strict';
    // Public API
    var htmx = {
        // Tsc madness here, assigning the functions directly results in an invalid TypeScript output, but reassigning is fine
        /* Event processing */ /** @type {typeof onLoadHelper} */ onLoad: null,
        /** @type {typeof processNode} */ process: null,
        /** @type {typeof addEventListenerImpl} */ on: null,
        /** @type {typeof removeEventListenerImpl} */ off: null,
        /** @type {typeof triggerEvent} */ trigger: null,
        /** @type {typeof ajaxHelper} */ ajax: null,
        /* DOM querying helpers */ /** @type {typeof find} */ find: null,
        /** @type {typeof findAll} */ findAll: null,
        /** @type {typeof closest} */ closest: null,
        /**
     * Returns the input values that would resolve for a given element via the htmx value resolution mechanism
     *
     * @see https://htmx.org/api/#values
     *
     * @param {Element} elt the element to resolve values on
     * @param {HttpVerb} type the request type (e.g. **get** or **post**) non-GET's will include the enclosing form of the element. Defaults to **post**
     * @returns {Object}
     */ values: function values(elt, type) {
            var inputValues = getInputValues(elt, type || 'post');
            return inputValues.values;
        },
        /* DOM manipulation helpers */ /** @type {typeof removeElement} */ remove: null,
        /** @type {typeof addClassToElement} */ addClass: null,
        /** @type {typeof removeClassFromElement} */ removeClass: null,
        /** @type {typeof toggleClassOnElement} */ toggleClass: null,
        /** @type {typeof takeClassForElement} */ takeClass: null,
        /** @type {typeof swap} */ swap: null,
        /* Extension entrypoints */ /** @type {typeof defineExtension} */ defineExtension: null,
        /** @type {typeof removeExtension} */ removeExtension: null,
        /* Debugging */ /** @type {typeof logAll} */ logAll: null,
        /** @type {typeof logNone} */ logNone: null,
        /* Debugging */ /**
     * The logger htmx uses to log with
     *
     * @see https://htmx.org/api/#logger
     */ logger: null,
        /**
     * A property holding the configuration htmx uses at runtime.
     *
     * Note that using a [meta tag](https://htmx.org/docs/#config) is the preferred mechanism for setting these properties.
     *
     * @see https://htmx.org/api/#config
     */ config: {
            /**
       * Whether to use history.
       * @type boolean
       * @default true
       */ historyEnabled: true,
            /**
       * The number of pages to keep in **sessionStorage** for history support.
       * @type number
       * @default 10
       */ historyCacheSize: 10,
            /**
       * @type boolean
       * @default false
       */ refreshOnHistoryMiss: false,
            /**
       * The default swap style to use if **[hx-swap](https://htmx.org/attributes/hx-swap)** is omitted.
       * @type HtmxSwapStyle
       * @default 'innerHTML'
       */ defaultSwapStyle: 'innerHTML',
            /**
       * The default delay between receiving a response from the server and doing the swap.
       * @type number
       * @default 0
       */ defaultSwapDelay: 0,
            /**
       * The default delay between completing the content swap and settling attributes.
       * @type number
       * @default 20
       */ defaultSettleDelay: 20,
            /**
       * If true, htmx will inject a small amount of CSS into the page to make indicators invisible unless the **htmx-indicator** class is present.
       * @type boolean
       * @default true
       */ includeIndicatorStyles: true,
            /**
       * The class to place on indicators when a request is in flight.
       * @type string
       * @default 'htmx-indicator'
       */ indicatorClass: 'htmx-indicator',
            /**
       * The class to place on triggering elements when a request is in flight.
       * @type string
       * @default 'htmx-request'
       */ requestClass: 'htmx-request',
            /**
       * The class to temporarily place on elements that htmx has added to the DOM.
       * @type string
       * @default 'htmx-added'
       */ addedClass: 'htmx-added',
            /**
       * The class to place on target elements when htmx is in the settling phase.
       * @type string
       * @default 'htmx-settling'
       */ settlingClass: 'htmx-settling',
            /**
       * The class to place on target elements when htmx is in the swapping phase.
       * @type string
       * @default 'htmx-swapping'
       */ swappingClass: 'htmx-swapping',
            /**
       * Allows the use of eval-like functionality in htmx, to enable **hx-vars**, trigger conditions & script tag evaluation. Can be set to **false** for CSP compatibility.
       * @type boolean
       * @default true
       */ allowEval: true,
            /**
       * If set to false, disables the interpretation of script tags.
       * @type boolean
       * @default true
       */ allowScriptTags: true,
            /**
       * If set, the nonce will be added to inline scripts.
       * @type string
       * @default ''
       */ inlineScriptNonce: '',
            /**
       * If set, the nonce will be added to inline styles.
       * @type string
       * @default ''
       */ inlineStyleNonce: '',
            /**
       * The attributes to settle during the settling phase.
       * @type string[]
       * @default ['class', 'style', 'width', 'height']
       */ attributesToSettle: [
                'class',
                'style',
                'width',
                'height'
            ],
            /**
       * Allow cross-site Access-Control requests using credentials such as cookies, authorization headers or TLS client certificates.
       * @type boolean
       * @default false
       */ withCredentials: false,
            /**
       * @type number
       * @default 0
       */ timeout: 0,
            /**
       * The default implementation of **getWebSocketReconnectDelay** for reconnecting after unexpected connection loss by the event code **Abnormal Closure**, **Service Restart** or **Try Again Later**.
       * @type {'full-jitter' | ((retryCount:number) => number)}
       * @default "full-jitter"
       */ wsReconnectDelay: 'full-jitter',
            /**
       * The type of binary data being received over the WebSocket connection
       * @type BinaryType
       * @default 'blob'
       */ wsBinaryType: 'blob',
            /**
       * @type string
       * @default '[hx-disable], [data-hx-disable]'
       */ disableSelector: '[hx-disable], [data-hx-disable]',
            /**
       * @type {'auto' | 'instant' | 'smooth'}
       * @default 'instant'
       */ scrollBehavior: 'instant',
            /**
       * If the focused element should be scrolled into view.
       * @type boolean
       * @default false
       */ defaultFocusScroll: false,
            /**
       * If set to true htmx will include a cache-busting parameter in GET requests to avoid caching partial responses by the browser
       * @type boolean
       * @default false
       */ getCacheBusterParam: false,
            /**
       * If set to true, htmx will use the View Transition API when swapping in new content.
       * @type boolean
       * @default false
       */ globalViewTransitions: false,
            /**
       * htmx will format requests with these methods by encoding their parameters in the URL, not the request body
       * @type {(HttpVerb)[]}
       * @default ['get', 'delete']
       */ methodsThatUseUrlParams: [
                'get',
                'delete'
            ],
            /**
       * If set to true, disables htmx-based requests to non-origin hosts.
       * @type boolean
       * @default false
       */ selfRequestsOnly: true,
            /**
       * If set to true htmx will not update the title of the document when a title tag is found in new content
       * @type boolean
       * @default false
       */ ignoreTitle: false,
            /**
       * Whether the target of a boosted element is scrolled into the viewport.
       * @type boolean
       * @default true
       */ scrollIntoViewOnBoost: true,
            /**
       * The cache to store evaluated trigger specifications into.
       * You may define a simple object to use a never-clearing cache, or implement your own system using a [proxy object](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Proxy)
       * @type {Object|null}
       * @default null
       */ triggerSpecsCache: null,
            /** @type boolean */ disableInheritance: false,
            /** @type HtmxResponseHandlingConfig[] */ responseHandling: [
                {
                    code: '204',
                    swap: false
                },
                {
                    code: '[23]..',
                    swap: true
                },
                {
                    code: '[45]..',
                    swap: false,
                    error: true
                }
            ],
            /**
       * Whether to process OOB swaps on elements that are nested within the main response element.
       * @type boolean
       * @default true
       */ allowNestedOobSwaps: true,
            /**
       * Whether to treat history cache miss full page reload requests as a "HX-Request" by returning this response header
       * This should always be disabled when using HX-Request header to optionally return partial responses
       * @type boolean
       * @default true
       */ historyRestoreAsHxRequest: true,
            /**
       * Whether to report input validation errors to the end user and update focus to the first input that fails validation.
       * This should always be enabled as this matches default browser form submit behaviour
       * @type boolean
       * @default false
       */ reportValidityOfForms: false
        },
        /** @type {typeof parseInterval} */ parseInterval: null,
        /**
     * proxy of window.location used for page reload functions
     * @type location
     */ location: location,
        /** @type {typeof internalEval} */ _: null,
        version: '2.0.8'
    };
    // Tsc madness part 2
    htmx.onLoad = onLoadHelper;
    htmx.process = processNode;
    htmx.on = addEventListenerImpl;
    htmx.off = removeEventListenerImpl;
    htmx.trigger = triggerEvent;
    htmx.ajax = ajaxHelper;
    htmx.find = find;
    htmx.findAll = findAll;
    htmx.closest = closest;
    htmx.remove = removeElement;
    htmx.addClass = addClassToElement;
    htmx.removeClass = removeClassFromElement;
    htmx.toggleClass = toggleClassOnElement;
    htmx.takeClass = takeClassForElement;
    htmx.swap = swap;
    htmx.defineExtension = defineExtension;
    htmx.removeExtension = removeExtension;
    htmx.logAll = logAll;
    htmx.logNone = logNone;
    htmx.parseInterval = parseInterval;
    htmx._ = internalEval;
    var internalAPI = {
        addTriggerHandler: addTriggerHandler,
        bodyContains: bodyContains,
        canAccessLocalStorage: canAccessLocalStorage,
        findThisElement: findThisElement,
        filterValues: filterValues,
        swap: swap,
        hasAttribute: hasAttribute,
        getAttributeValue: getAttributeValue,
        getClosestAttributeValue: getClosestAttributeValue,
        getClosestMatch: getClosestMatch,
        getExpressionVars: getExpressionVars,
        getHeaders: getHeaders,
        getInputValues: getInputValues,
        getInternalData: getInternalData,
        getSwapSpecification: getSwapSpecification,
        getTriggerSpecs: getTriggerSpecs,
        getTarget: getTarget,
        makeFragment: makeFragment,
        mergeObjects: mergeObjects,
        makeSettleInfo: makeSettleInfo,
        oobSwap: oobSwap,
        querySelectorExt: querySelectorExt,
        settleImmediately: settleImmediately,
        shouldCancel: shouldCancel,
        triggerEvent: triggerEvent,
        triggerErrorEvent: triggerErrorEvent,
        withExtensions: withExtensions
    };
    var VERBS = [
        'get',
        'post',
        'put',
        'delete',
        'patch'
    ];
    var VERB_SELECTOR = VERBS.map(function(verb) {
        return '[hx-' + verb + '], [data-hx-' + verb + ']';
    }).join(', ');
    //= ===================================================================
    // Utilities
    //= ===================================================================
    /**
   * Parses an interval string consistent with the way htmx does. Useful for plugins that have timing-related attributes.
   *
   * Caution: Accepts an int followed by either **s** or **ms**. All other values use **parseFloat**
   *
   * @see https://htmx.org/api/#parseInterval
   *
   * @param {string} str timing string
   * @returns {number|undefined}
   */ function parseInterval(str) {
        if (str == undefined) return undefined;
        var interval = NaN;
        if (str.slice(-2) == 'ms') interval = parseFloat(str.slice(0, -2));
        else if (str.slice(-1) == 's') interval = parseFloat(str.slice(0, -1)) * 1000;
        else if (str.slice(-1) == 'm') interval = parseFloat(str.slice(0, -1)) * 60000;
        else interval = parseFloat(str);
        return isNaN(interval) ? undefined : interval;
    }
    /**
   * @param {Node} elt
   * @param {string} name
   * @returns {(string | null)}
   */ function getRawAttribute(elt, name) {
        return elt instanceof Element && elt.getAttribute(name);
    }
    /**
   * @param {Element} elt
   * @param {string} qualifiedName
   * @returns {boolean}
   */ // resolve with both hx and data-hx prefixes
    function hasAttribute(elt, qualifiedName) {
        return !!elt.hasAttribute && (elt.hasAttribute(qualifiedName) || elt.hasAttribute('data-' + qualifiedName));
    }
    /**
   *
   * @param {Node} elt
   * @param {string} qualifiedName
   * @returns {(string | null)}
   */ function getAttributeValue(elt, qualifiedName) {
        return getRawAttribute(elt, qualifiedName) || getRawAttribute(elt, 'data-' + qualifiedName);
    }
    /**
   * @param {Node} elt
   * @returns {Node | null}
   */ function parentElt(elt) {
        var parent = elt.parentElement;
        if (!parent && elt.parentNode instanceof ShadowRoot) return elt.parentNode;
        return parent;
    }
    /**
   * @returns {Document}
   */ function getDocument() {
        return document;
    }
    /**
   * @param {Node} elt
   * @param {boolean} global
   * @returns {Node|Document}
   */ function getRootNode(elt, global) {
        return elt.getRootNode ? elt.getRootNode({
            composed: global
        }) : getDocument();
    }
    /**
   * @param {Node} elt
   * @param {(e:Node) => boolean} condition
   * @returns {Node | null}
   */ function getClosestMatch(elt, condition) {
        while(elt && !condition(elt))elt = parentElt(elt);
        return elt || null;
    }
    /**
   * @param {Element} initialElement
   * @param {Element} ancestor
   * @param {string} attributeName
   * @returns {string|null}
   */ function getAttributeValueWithDisinheritance(initialElement, ancestor, attributeName) {
        var attributeValue = getAttributeValue(ancestor, attributeName);
        var disinherit = getAttributeValue(ancestor, 'hx-disinherit');
        var inherit = getAttributeValue(ancestor, 'hx-inherit');
        if (initialElement !== ancestor) {
            if (htmx.config.disableInheritance) {
                if (inherit && (inherit === '*' || inherit.split(' ').indexOf(attributeName) >= 0)) return attributeValue;
                else return null;
            }
            if (disinherit && (disinherit === '*' || disinherit.split(' ').indexOf(attributeName) >= 0)) return 'unset';
        }
        return attributeValue;
    }
    /**
   * @param {Element} elt
   * @param {string} attributeName
   * @returns {string | null}
   */ function getClosestAttributeValue(elt, attributeName) {
        var closestAttr = null;
        getClosestMatch(elt, function(e) {
            return !!(closestAttr = getAttributeValueWithDisinheritance(elt, asElement(e), attributeName));
        });
        if (closestAttr !== 'unset') return closestAttr;
    }
    /**
   * @param {Node} elt
   * @param {string} selector
   * @returns {boolean}
   */ function matches(elt, selector) {
        return elt instanceof Element && elt.matches(selector);
    }
    /**
   * @param {string} str
   * @returns {string}
   */ function getStartTag(str) {
        var tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        var match = tagMatcher.exec(str);
        if (match) return match[1].toLowerCase();
        else return '';
    }
    /**
   * @param {string} resp
   * @returns {Document}
   */ function parseHTML(resp) {
        if ('parseHTMLUnsafe' in Document) return Document.parseHTMLUnsafe(resp);
        var parser = new DOMParser();
        return parser.parseFromString(resp, 'text/html');
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {Node} elt
   */ function takeChildrenFor(fragment, elt) {
        while(elt.childNodes.length > 0)fragment.append(elt.childNodes[0]);
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {HTMLScriptElement}
   */ function duplicateScript(script) {
        var newScript = getDocument().createElement('script');
        forEach(script.attributes, function(attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        newScript.async = false;
        if (htmx.config.inlineScriptNonce) newScript.nonce = htmx.config.inlineScriptNonce;
        return newScript;
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {boolean}
   */ function isJavaScriptScriptNode(script) {
        return script.matches('script') && (script.type === 'text/javascript' || script.type === 'module' || script.type === '');
    }
    /**
   * we have to make new copies of script tags that we are going to insert because
   * SOME browsers (not saying who, but it involves an element and an animal) don't
   * execute scripts created in <template> tags when they are inserted into the DOM
   * and all the others do lmao
   * @param {DocumentFragment} fragment
   */ function normalizeScriptTags(fragment) {
        Array.from(fragment.querySelectorAll('script')).forEach(/** @param {HTMLScriptElement} script */ function(script) {
            if (isJavaScriptScriptNode(script)) {
                var newScript = duplicateScript(script);
                var parent = script.parentNode;
                try {
                    parent.insertBefore(newScript, script);
                } catch (e) {
                    logError(e);
                } finally{
                    script.remove();
                }
            }
        });
    }
    /**
   * @typedef {DocumentFragment & {title?: string}} DocumentFragmentWithTitle
   * @description  a document fragment representing the response HTML, including
   * a `title` property for any title information found
   */ /**
   * @param {string} response HTML
   * @returns {DocumentFragmentWithTitle}
   */ function makeFragment(response) {
        // strip head tag to determine shape of response we are dealing with
        var responseWithNoHead = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, '');
        var startTag = getStartTag(responseWithNoHead);
        /** @type DocumentFragmentWithTitle */ var fragment;
        if (startTag === 'html') {
            // if it is a full document, parse it and return the body
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            var doc = parseHTML(response);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else if (startTag === 'body') {
            // parse body w/o wrapping in template
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            var doc1 = parseHTML(responseWithNoHead);
            takeChildrenFor(fragment, doc1.body);
            fragment.title = doc1.title;
        } else {
            // otherwise we have non-body partial HTML content, so wrap it in a template to maximize parsing flexibility
            var doc2 = parseHTML('<body><template class="internal-htmx-wrapper">' + responseWithNoHead + '</template></body>');
            fragment = /** @type DocumentFragmentWithTitle */ doc2.querySelector('template').content;
            // extract title into fragment for later processing
            fragment.title = doc2.title;
            // for legacy reasons we support a title tag at the root level of non-body responses, so we need to handle it
            var titleElement = fragment.querySelector('title');
            if (titleElement && titleElement.parentNode === fragment) {
                titleElement.remove();
                fragment.title = titleElement.innerText;
            }
        }
        if (fragment) {
            if (htmx.config.allowScriptTags) normalizeScriptTags(fragment);
            else // remove all script tags if scripts are disabled
            fragment.querySelectorAll('script').forEach(function(script) {
                return script.remove();
            });
        }
        return fragment;
    }
    /**
   * @param {Function} func
   */ function maybeCall(func) {
        if (func) func();
    }
    /**
   * @param {any} o
   * @param {string} type
   * @returns
   */ function isType(o, type) {
        return Object.prototype.toString.call(o) === '[object ' + type + ']';
    }
    /**
   * @param {*} o
   * @returns {o is Function}
   */ function isFunction(o) {
        return typeof o === 'function';
    }
    /**
   * @param {*} o
   * @returns {o is Object}
   */ function isRawObject(o) {
        return isType(o, 'Object');
    }
    /**
   * @typedef {Object} OnHandler
   * @property {(keyof HTMLElementEventMap)|string} event
   * @property {EventListener} listener
   */ /**
   * @typedef {Object} ListenerInfo
   * @property {string} trigger
   * @property {EventListener} listener
   * @property {EventTarget} on
   */ /**
   * @typedef {Object} HtmxNodeInternalData
   * Element data
   * @property {number} [initHash]
   * @property {boolean} [boosted]
   * @property {OnHandler[]} [onHandlers]
   * @property {number} [timeout]
   * @property {ListenerInfo[]} [listenerInfos]
   * @property {boolean} [cancelled]
   * @property {boolean} [triggeredOnce]
   * @property {number} [delayed]
   * @property {number|null} [throttle]
   * @property {WeakMap<HtmxTriggerSpecification,WeakMap<EventTarget,string>>} [lastValue]
   * @property {boolean} [loaded]
   * @property {string} [path]
   * @property {string} [verb]
   * @property {boolean} [polling]
   * @property {HTMLButtonElement|HTMLInputElement|null} [lastButtonClicked]
   * @property {number} [requestCount]
   * @property {XMLHttpRequest} [xhr]
   * @property {(() => void)[]} [queuedRequests]
   * @property {boolean} [abortable]
   * @property {boolean} [firstInitCompleted]
   *
   * Event data
   * @property {HtmxTriggerSpecification} [triggerSpec]
   * @property {EventTarget[]} [handledFor]
   */ /**
   * getInternalData retrieves "private" data stored by htmx within an element
   * @param {EventTarget|Event} elt
   * @returns {HtmxNodeInternalData}
   */ function getInternalData(elt) {
        var dataProp = 'htmx-internal-data';
        var data = elt[dataProp];
        if (!data) data = elt[dataProp] = {};
        return data;
    }
    /**
   * toArray converts an ArrayLike object into a real array.
   * @template T
   * @param {ArrayLike<T>} arr
   * @returns {T[]}
   */ function toArray(arr) {
        var returnArr = [];
        if (arr) for(var i = 0; i < arr.length; i++)returnArr.push(arr[i]);
        return returnArr;
    }
    /**
   * @template T
   * @param {T[]|NamedNodeMap|HTMLCollection|HTMLFormControlsCollection|ArrayLike<T>} arr
   * @param {(T) => void} func
   */ function forEach(arr, func) {
        if (arr) for(var i = 0; i < arr.length; i++)func(arr[i]);
    }
    /**
   * @param {Element} el
   * @returns {boolean}
   */ function isScrolledIntoView(el) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    }
    /**
   * Checks whether the element is in the document (includes shadow roots).
   * This function this is a slight misnomer; it will return true even for elements in the head.
   *
   * @param {Node} elt
   * @returns {boolean}
   */ function bodyContains(elt) {
        return elt.getRootNode({
            composed: true
        }) === document;
    }
    /**
   * @param {string} trigger
   * @returns {string[]}
   */ function splitOnWhitespace(trigger) {
        return trigger.trim().split(/\s+/);
    }
    /**
   * mergeObjects takes all the keys from
   * obj2 and duplicates them into obj1
   * @template T1
   * @template T2
   * @param {T1} obj1
   * @param {T2} obj2
   * @returns {T1 & T2}
   */ function mergeObjects(obj1, obj2) {
        for(var key in obj2)if (obj2.hasOwnProperty(key)) // @ts-ignore tsc doesn't seem to properly handle types merging
        obj1[key] = obj2[key];
        // @ts-ignore tsc doesn't seem to properly handle types merging
        return obj1;
    }
    /**
   * @param {string} jString
   * @returns {any|null}
   */ function parseJSON(jString) {
        try {
            return JSON.parse(jString);
        } catch (error) {
            logError(error);
            return null;
        }
    }
    /**
   * @returns {boolean}
   */ function canAccessLocalStorage() {
        var test = 'htmx:sessionStorageTest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * @param {string} path
   * @returns {string}
   */ function normalizePath(path) {
        // use dummy base URL to allow normalize on path only
        var url = new URL(path, 'http://x');
        if (url) path = url.pathname + url.search;
        // remove trailing slash, unless index page
        if (path != '/') path = path.replace(/\/+$/, '');
        return path;
    }
    //= =========================================================================================
    // public API
    //= =========================================================================================
    /**
   * @param {string} str
   * @returns {any}
   */ function internalEval(str) {
        return maybeEval(getDocument().body, function() {
            return eval(str);
        });
    }
    /**
   * Adds a callback for the **htmx:load** event. This can be used to process new content, for example initializing the content with a javascript library
   *
   * @see https://htmx.org/api/#onLoad
   *
   * @param {(elt: Node) => void} callback the callback to call on newly loaded content
   * @returns {EventListener}
   */ function onLoadHelper(callback) {
        var value = htmx.on('htmx:load', /** @param {CustomEvent} evt */ function(evt) {
            callback(evt.detail.elt);
        });
        return value;
    }
    /**
   * Log all htmx events, useful for debugging.
   *
   * @see https://htmx.org/api/#logAll
   */ function logAll() {
        htmx.logger = function(elt, event, data) {
            if (console) console.log(event, elt, data);
        };
    }
    function logNone() {
        htmx.logger = null;
    }
    /**
   * Finds an element matching the selector
   *
   * @see https://htmx.org/api/#find
   *
   * @param {ParentNode|string} eltOrSelector  the root element to find the matching element in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {Element|null}
   */ function find(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelector(selector);
        else return find(getDocument(), eltOrSelector);
    }
    /**
   * Finds all elements matching the selector
   *
   * @see https://htmx.org/api/#findAll
   *
   * @param {ParentNode|string} eltOrSelector the root element to find the matching elements in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {NodeListOf<Element>}
   */ function findAll(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelectorAll(selector);
        else return findAll(getDocument(), eltOrSelector);
    }
    /**
   * @returns Window
   */ function getWindow() {
        return window;
    }
    /**
   * Removes an element from the DOM
   *
   * @see https://htmx.org/api/#remove
   *
   * @param {Node} elt
   * @param {number} [delay]
   */ function removeElement(elt, delay) {
        elt = resolveTarget(elt);
        if (delay) getWindow().setTimeout(function() {
            removeElement(elt);
            elt = null;
        }, delay);
        else parentElt(elt).removeChild(elt);
    }
    /**
   * @param {any} elt
   * @return {Element|null}
   */ function asElement(elt) {
        return elt instanceof Element ? elt : null;
    }
    /**
   * @param {any} elt
   * @return {HTMLElement|null}
   */ function asHtmlElement(elt) {
        return elt instanceof HTMLElement ? elt : null;
    }
    /**
   * @param {any} value
   * @return {string|null}
   */ function asString(value) {
        return typeof value === 'string' ? value : null;
    }
    /**
   * @param {EventTarget} elt
   * @return {ParentNode|null}
   */ function asParentNode(elt) {
        return elt instanceof Element || elt instanceof Document || elt instanceof DocumentFragment ? elt : null;
    }
    /**
   * This method adds a class to the given element.
   *
   * @see https://htmx.org/api/#addClass
   *
   * @param {Element|string} elt the element to add the class to
   * @param {string} clazz the class to add
   * @param {number} [delay] the delay (in milliseconds) before class is added
   */ function addClassToElement(elt, clazz, delay) {
        elt = asElement(resolveTarget(elt));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            addClassToElement(elt, clazz);
            elt = null;
        }, delay);
        else elt.classList && elt.classList.add(clazz);
    }
    /**
   * Removes a class from the given element
   *
   * @see https://htmx.org/api/#removeClass
   *
   * @param {Node|string} node element to remove the class from
   * @param {string} clazz the class to remove
   * @param {number} [delay] the delay (in milliseconds before class is removed)
   */ function removeClassFromElement(node, clazz, delay) {
        var elt = asElement(resolveTarget(node));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            removeClassFromElement(elt, clazz);
            elt = null;
        }, delay);
        else if (elt.classList) {
            elt.classList.remove(clazz);
            // if there are no classes left, remove the class attribute
            if (elt.classList.length === 0) elt.removeAttribute('class');
        }
    }
    /**
   * Toggles the given class on an element
   *
   * @see https://htmx.org/api/#toggleClass
   *
   * @param {Element|string} elt the element to toggle the class on
   * @param {string} clazz the class to toggle
   */ function toggleClassOnElement(elt, clazz) {
        elt = resolveTarget(elt);
        elt.classList.toggle(clazz);
    }
    /**
   * Takes the given class from its siblings, so that among its siblings, only the given element will have the class.
   *
   * @see https://htmx.org/api/#takeClass
   *
   * @param {Node|string} elt the element that will take the class
   * @param {string} clazz the class to take
   */ function takeClassForElement(elt, clazz) {
        elt = resolveTarget(elt);
        forEach(elt.parentElement.children, function(child) {
            removeClassFromElement(child, clazz);
        });
        addClassToElement(asElement(elt), clazz);
    }
    /**
   * Finds the closest matching element in the given elements parentage, inclusive of the element
   *
   * @see https://htmx.org/api/#closest
   *
   * @param {Element|string} elt the element to find the selector from
   * @param {string} selector the selector to find
   * @returns {Element|null}
   */ function closest(elt, selector) {
        elt = asElement(resolveTarget(elt));
        if (elt) return elt.closest(selector);
        return null;
    }
    /**
   * @param {string} str
   * @param {string} prefix
   * @returns {boolean}
   */ function startsWith(str, prefix) {
        return str.substring(0, prefix.length) === prefix;
    }
    /**
   * @param {string} str
   * @param {string} suffix
   * @returns {boolean}
   */ function endsWith(str, suffix) {
        return str.substring(str.length - suffix.length) === suffix;
    }
    /**
   * @param {string} selector
   * @returns {string}
   */ function normalizeSelector(selector) {
        var trimmedSelector = selector.trim();
        if (startsWith(trimmedSelector, '<') && endsWith(trimmedSelector, '/>')) return trimmedSelector.substring(1, trimmedSelector.length - 2);
        else return trimmedSelector;
    }
    /**
   * @param {Node|Element|Document|string} elt
   * @param {string} selector
   * @param {boolean=} global
   * @returns {(Node|Window)[]}
   */ function querySelectorAllExt(elt, selector, global) {
        if (selector.indexOf('global ') === 0) return querySelectorAllExt(elt, selector.slice(7), true);
        elt = resolveTarget(elt);
        var parts = [];
        {
            var chevronsCount = 0;
            var offset = 0;
            for(var i = 0; i < selector.length; i++){
                var char = selector[i];
                if (char === ',' && chevronsCount === 0) {
                    parts.push(selector.substring(offset, i));
                    offset = i + 1;
                    continue;
                }
                if (char === '<') chevronsCount++;
                else if (char === '/' && i < selector.length - 1 && selector[i + 1] === '>') chevronsCount--;
            }
            if (offset < selector.length) parts.push(selector.substring(offset));
        }
        var result = [];
        var unprocessedParts = [];
        while(parts.length > 0){
            var _$selector = normalizeSelector(parts.shift());
            var item = void 0;
            if (_$selector.indexOf('closest ') === 0) item = closest(asElement(elt), normalizeSelector(_$selector.slice(8)));
            else if (_$selector.indexOf('find ') === 0) item = find(asParentNode(elt), normalizeSelector(_$selector.slice(5)));
            else if (_$selector === 'next' || _$selector === 'nextElementSibling') item = asElement(elt).nextElementSibling;
            else if (_$selector.indexOf('next ') === 0) item = scanForwardQuery(elt, normalizeSelector(_$selector.slice(5)), !!global);
            else if (_$selector === 'previous' || _$selector === 'previousElementSibling') item = asElement(elt).previousElementSibling;
            else if (_$selector.indexOf('previous ') === 0) item = scanBackwardsQuery(elt, normalizeSelector(_$selector.slice(9)), !!global);
            else if (_$selector === 'document') item = document;
            else if (_$selector === 'window') item = window;
            else if (_$selector === 'body') item = document.body;
            else if (_$selector === 'root') item = getRootNode(elt, !!global);
            else if (_$selector === 'host') item = /** @type ShadowRoot */ elt.getRootNode().host;
            else unprocessedParts.push(_$selector);
            if (item) result.push(item);
        }
        if (unprocessedParts.length > 0) {
            var _result;
            var standardSelector = unprocessedParts.join(',');
            var rootNode = asParentNode(getRootNode(elt, !!global));
            (_result = result).push.apply(_result, (0, $kNmtb._)(toArray(rootNode.querySelectorAll(standardSelector))));
        }
        return result;
    }
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanForwardQuery = function scanForwardQuery(start, match, global) {
        var results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(var i = 0; i < results.length; i++){
            var elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) return elt;
        }
    };
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanBackwardsQuery = function scanBackwardsQuery(start, match, global) {
        var results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(var i = results.length - 1; i >= 0; i--){
            var elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_FOLLOWING) return elt;
        }
    };
    /**
   * @param {Node|string} eltOrSelector
   * @param {string=} selector
   * @returns {Node|Window}
   */ function querySelectorExt(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return querySelectorAllExt(eltOrSelector, selector)[0];
        else return querySelectorAllExt(getDocument().body, eltOrSelector)[0];
    }
    /**
   * @template {EventTarget} T
   * @param {T|string} eltOrSelector
   * @param {T} [context]
   * @returns {Element|T|null}
   */ function resolveTarget(eltOrSelector, context) {
        if (typeof eltOrSelector === 'string') return find(asParentNode(context) || document, eltOrSelector);
        else return eltOrSelector;
    }
    /**
   * @typedef {keyof HTMLElementEventMap|string} AnyEventName
   */ /**
   * @typedef {Object} EventArgs
   * @property {EventTarget} target
   * @property {AnyEventName} event
   * @property {EventListener} listener
   * @property {Object|boolean} options
   */ /**
   * @param {EventTarget|AnyEventName} arg1
   * @param {AnyEventName|EventListener} arg2
   * @param {EventListener|Object|boolean} [arg3]
   * @param {Object|boolean} [arg4]
   * @returns {EventArgs}
   */ function processEventArgs(arg1, arg2, arg3, arg4) {
        if (isFunction(arg2)) return {
            target: getDocument().body,
            event: asString(arg1),
            listener: arg2,
            options: arg3
        };
        else return {
            target: resolveTarget(arg1),
            event: asString(arg2),
            listener: arg3,
            options: arg4
        };
    }
    /**
   * Adds an event listener to an element
   *
   * @see https://htmx.org/api/#on
   *
   * @param {EventTarget|string} arg1 the element to add the listener to | the event name to add the listener for
   * @param {string|EventListener} arg2 the event name to add the listener for | the listener to add
   * @param {EventListener|Object|boolean} [arg3] the listener to add | options to add
   * @param {Object|boolean} [arg4] options to add
   * @returns {EventListener}
   */ function addEventListenerImpl(arg1, arg2, arg3, arg4) {
        ready(function() {
            var eventArgs = processEventArgs(arg1, arg2, arg3, arg4);
            eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener, eventArgs.options);
        });
        var b = isFunction(arg2);
        return b ? arg2 : arg3;
    }
    /**
   * Removes an event listener from an element
   *
   * @see https://htmx.org/api/#off
   *
   * @param {EventTarget|string} arg1 the element to remove the listener from | the event name to remove the listener from
   * @param {string|EventListener} arg2 the event name to remove the listener from | the listener to remove
   * @param {EventListener} [arg3] the listener to remove
   * @returns {EventListener}
   */ function removeEventListenerImpl(arg1, arg2, arg3) {
        ready(function() {
            var eventArgs = processEventArgs(arg1, arg2, arg3);
            eventArgs.target.removeEventListener(eventArgs.event, eventArgs.listener);
        });
        return isFunction(arg2) ? arg2 : arg3;
    }
    //= ===================================================================
    // Node processing
    //= ===================================================================
    var DUMMY_ELT = getDocument().createElement('output') // dummy element for bad selectors
    ;
    /**
   * @param {Element} elt
   * @param {string} attrName
   * @returns {(Node|Window)[]}
   */ function findAttributeTargets(elt, attrName) {
        var attrTarget = getClosestAttributeValue(elt, attrName);
        if (attrTarget) {
            if (attrTarget === 'this') return [
                findThisElement(elt, attrName)
            ];
            else {
                var result = querySelectorAllExt(elt, attrTarget);
                // find `inherit` whole word in value, make sure it's surrounded by commas or is at the start/end of string
                var shouldInherit = /(^|,)(\s*)inherit(\s*)($|,)/.test(attrTarget);
                if (shouldInherit) {
                    var _result;
                    var eltToInheritFrom = asElement(getClosestMatch(elt, function(parent) {
                        return parent !== elt && hasAttribute(asElement(parent), attrName);
                    }));
                    if (eltToInheritFrom) (_result = result).push.apply(_result, (0, $kNmtb._)(findAttributeTargets(eltToInheritFrom, attrName)));
                }
                if (result.length === 0) {
                    logError('The selector "' + attrTarget + '" on ' + attrName + ' returned no matches!');
                    return [
                        DUMMY_ELT
                    ];
                } else return result;
            }
        }
    }
    /**
   * @param {Element} elt
   * @param {string} attribute
   * @returns {Element|null}
   */ function findThisElement(elt, attribute) {
        return asElement(getClosestMatch(elt, function(elt) {
            return getAttributeValue(asElement(elt), attribute) != null;
        }));
    }
    /**
   * @param {Element} elt
   * @returns {Node|Window|null}
   */ function getTarget(elt) {
        var targetStr = getClosestAttributeValue(elt, 'hx-target');
        if (targetStr) {
            if (targetStr === 'this') return findThisElement(elt, 'hx-target');
            else return querySelectorExt(elt, targetStr);
        } else {
            var data = getInternalData(elt);
            if (data.boosted) return getDocument().body;
            else return elt;
        }
    }
    /**
   * @param {string} name
   * @returns {boolean}
   */ function shouldSettleAttribute(name) {
        return htmx.config.attributesToSettle.includes(name);
    }
    /**
   * @param {Element} mergeTo
   * @param {Element} mergeFrom
   */ function cloneAttributes(mergeTo, mergeFrom) {
        forEach(Array.from(mergeTo.attributes), function(attr) {
            if (!mergeFrom.hasAttribute(attr.name) && shouldSettleAttribute(attr.name)) mergeTo.removeAttribute(attr.name);
        });
        forEach(mergeFrom.attributes, function(attr) {
            if (shouldSettleAttribute(attr.name)) mergeTo.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} target
   * @returns {boolean}
   */ function isInlineSwap(swapStyle, target) {
        var extensions = getExtensions(target);
        for(var i = 0; i < extensions.length; i++){
            var extension = extensions[i];
            try {
                if (extension.isInlineSwap(swapStyle)) return true;
            } catch (e) {
                logError(e);
            }
        }
        return swapStyle === 'outerHTML';
    }
    /**
   * @param {string} oobValue
   * @param {Element} oobElement
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   * @returns
   */ function oobSwap(oobValue, oobElement, settleInfo, rootNode) {
        rootNode = rootNode || getDocument();
        var selector = '#' + CSS.escape(getRawAttribute(oobElement, 'id'));
        /** @type HtmxSwapStyle */ var swapStyle = 'outerHTML';
        if (oobValue === 'true') ;
        else if (oobValue.indexOf(':') > 0) {
            swapStyle = oobValue.substring(0, oobValue.indexOf(':'));
            selector = oobValue.substring(oobValue.indexOf(':') + 1);
        } else swapStyle = oobValue;
        oobElement.removeAttribute('hx-swap-oob');
        oobElement.removeAttribute('data-hx-swap-oob');
        var targets = querySelectorAllExt(rootNode, selector, false);
        if (targets.length) {
            forEach(targets, function(target) {
                var fragment;
                var oobElementClone = oobElement.cloneNode(true);
                fragment = getDocument().createDocumentFragment();
                fragment.appendChild(oobElementClone);
                if (!isInlineSwap(swapStyle, target)) fragment = asParentNode(oobElementClone) // if this is not an inline swap, we use the content of the node, not the node itself
                ;
                var beforeSwapDetails = {
                    shouldSwap: true,
                    target: target,
                    fragment: fragment
                };
                if (!triggerEvent(target, 'htmx:oobBeforeSwap', beforeSwapDetails)) return;
                target = beforeSwapDetails.target // allow re-targeting
                ;
                if (beforeSwapDetails.shouldSwap) {
                    handlePreservedElements(fragment);
                    swapWithStyle(swapStyle, target, target, fragment, settleInfo);
                    restorePreservedElements();
                }
                forEach(settleInfo.elts, function(elt) {
                    triggerEvent(elt, 'htmx:oobAfterSwap', beforeSwapDetails);
                });
            });
            oobElement.parentNode.removeChild(oobElement);
        } else {
            oobElement.parentNode.removeChild(oobElement);
            triggerErrorEvent(getDocument().body, 'htmx:oobErrorNoTarget', {
                content: oobElement
            });
        }
        return oobValue;
    }
    function restorePreservedElements() {
        var pantry = find('#--htmx-preserve-pantry--');
        if (pantry) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (0, $kNmtb._)(pantry.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var preservedElt = _step.value;
                    var existingElement = find('#' + preservedElt.id);
                    // @ts-ignore - use proposed moveBefore feature
                    existingElement.parentNode.moveBefore(preservedElt, existingElement);
                    existingElement.remove();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            pantry.remove();
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   */ function handlePreservedElements(fragment) {
        forEach(findAll(fragment, '[hx-preserve], [data-hx-preserve]'), function(preservedElt) {
            var id = getAttributeValue(preservedElt, 'id');
            var existingElement = getDocument().getElementById(id);
            if (existingElement != null) {
                if (preservedElt.moveBefore) {
                    // get or create a storage spot for stuff
                    var pantry = find('#--htmx-preserve-pantry--');
                    if (pantry == null) {
                        getDocument().body.insertAdjacentHTML('afterend', "<div id='--htmx-preserve-pantry--'></div>");
                        pantry = find('#--htmx-preserve-pantry--');
                    }
                    // @ts-ignore - use proposed moveBefore feature
                    pantry.moveBefore(existingElement, null);
                } else preservedElt.parentNode.replaceChild(existingElement, preservedElt);
            }
        });
    }
    /**
   * @param {Node} parentNode
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function handleAttributes(parentNode, fragment, settleInfo) {
        forEach(fragment.querySelectorAll('[id]'), function(newNode) {
            var id = getRawAttribute(newNode, 'id');
            if (id && id.length > 0) {
                var normalizedId = id.replace("'", "\\'");
                var normalizedTag = newNode.tagName.replace(':', '\\:');
                var parentElt = asParentNode(parentNode);
                var oldNode = parentElt && parentElt.querySelector(normalizedTag + "[id='" + normalizedId + "']");
                if (oldNode && oldNode !== parentElt) {
                    var newAttributes = newNode.cloneNode();
                    cloneAttributes(newNode, oldNode);
                    settleInfo.tasks.push(function() {
                        cloneAttributes(newNode, newAttributes);
                    });
                }
            }
        });
    }
    /**
   * @param {Node} child
   * @returns {HtmxSettleTask}
   */ function makeAjaxLoadTask(child) {
        return function() {
            removeClassFromElement(child, htmx.config.addedClass);
            processNode(asElement(child));
            processFocus(asParentNode(child));
            triggerEvent(child, 'htmx:load');
        };
    }
    /**
   * @param {ParentNode} child
   */ function processFocus(child) {
        var autofocus = '[autofocus]';
        var autoFocusedElt = asHtmlElement(matches(child, autofocus) ? child : child.querySelector(autofocus));
        if (autoFocusedElt != null) autoFocusedElt.focus();
    }
    /**
   * @param {Node} parentNode
   * @param {Node} insertBefore
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
        handleAttributes(parentNode, fragment, settleInfo);
        while(fragment.childNodes.length > 0){
            var child = fragment.firstChild;
            addClassToElement(asElement(child), htmx.config.addedClass);
            parentNode.insertBefore(child, insertBefore);
            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
        }
    }
    /**
   * based on https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0,
   * derived from Java's string hashcode implementation
   * @param {string} string
   * @param {number} hash
   * @returns {number}
   */ function stringHash(string, hash) {
        var char = 0;
        while(char < string.length)hash = (hash << 5) - hash + string.charCodeAt(char++) | 0 // bitwise or ensures we have a 32-bit int
        ;
        return hash;
    }
    /**
   * @param {Element} elt
   * @returns {number}
   */ function attributeHash(elt) {
        var hash = 0;
        for(var i = 0; i < elt.attributes.length; i++){
            var attribute = elt.attributes[i];
            if (attribute.value) {
                hash = stringHash(attribute.name, hash);
                hash = stringHash(attribute.value, hash);
            }
        }
        return hash;
    }
    /**
   * @param {EventTarget} elt
   */ function deInitOnHandlers(elt) {
        var internalData = getInternalData(elt);
        if (internalData.onHandlers) {
            for(var i = 0; i < internalData.onHandlers.length; i++){
                var handlerInfo = internalData.onHandlers[i];
                removeEventListenerImpl(elt, handlerInfo.event, handlerInfo.listener);
            }
            delete internalData.onHandlers;
        }
    }
    /**
   * @param {Node} element
   */ function deInitNode(element) {
        var internalData = getInternalData(element);
        if (internalData.timeout) clearTimeout(internalData.timeout);
        if (internalData.listenerInfos) forEach(internalData.listenerInfos, function(info) {
            if (info.on) removeEventListenerImpl(info.on, info.trigger, info.listener);
        });
        deInitOnHandlers(element);
        forEach(Object.keys(internalData), function(key) {
            if (key !== 'firstInitCompleted') delete internalData[key];
        });
    }
    /**
   * @param {Node} element
   */ function cleanUpElement(element) {
        triggerEvent(element, 'htmx:beforeCleanupElement');
        deInitNode(element);
        // @ts-ignore
        forEach(element.children, function(child) {
            cleanUpElement(child);
        });
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapOuterHTML(target, fragment, settleInfo) {
        if (target.tagName === 'BODY') return swapInnerHTML(target, fragment, settleInfo);
        /** @type {Node} */ var newElt;
        var eltBeforeNewContent = target.previousSibling;
        var parentNode = parentElt(target);
        if (!parentNode) return;
        insertNodesBefore(parentNode, target, fragment, settleInfo);
        if (eltBeforeNewContent == null) newElt = parentNode.firstChild;
        else newElt = eltBeforeNewContent.nextSibling;
        settleInfo.elts = settleInfo.elts.filter(function(e) {
            return e !== target;
        });
        // scan through all newly added content and add all elements to the settle info so we trigger
        // events properly on them
        while(newElt && newElt !== target){
            if (newElt instanceof Element) settleInfo.elts.push(newElt);
            newElt = newElt.nextSibling;
        }
        cleanUpElement(target);
        target.remove();
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterBegin(target, fragment, settleInfo) {
        return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeBegin(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeEnd(target, fragment, settleInfo) {
        return insertNodesBefore(target, null, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterEnd(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target.nextSibling, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   */ function swapDelete(target) {
        cleanUpElement(target);
        var parent = parentElt(target);
        if (parent) return parent.removeChild(target);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapInnerHTML(target, fragment, settleInfo) {
        var firstChild = target.firstChild;
        insertNodesBefore(target, firstChild, fragment, settleInfo);
        if (firstChild) {
            while(firstChild.nextSibling){
                cleanUpElement(firstChild.nextSibling);
                target.removeChild(firstChild.nextSibling);
            }
            cleanUpElement(firstChild);
            target.removeChild(firstChild);
        }
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} elt
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapWithStyle(swapStyle, elt, target, fragment, settleInfo) {
        switch(swapStyle){
            case 'none':
                return;
            case 'outerHTML':
                swapOuterHTML(target, fragment, settleInfo);
                return;
            case 'afterbegin':
                swapAfterBegin(target, fragment, settleInfo);
                return;
            case 'beforebegin':
                swapBeforeBegin(target, fragment, settleInfo);
                return;
            case 'beforeend':
                swapBeforeEnd(target, fragment, settleInfo);
                return;
            case 'afterend':
                swapAfterEnd(target, fragment, settleInfo);
                return;
            case 'delete':
                swapDelete(target);
                return;
            default:
                var extensions = getExtensions(elt);
                for(var i = 0; i < extensions.length; i++){
                    var ext = extensions[i];
                    try {
                        var newElements = ext.handleSwap(swapStyle, target, fragment, settleInfo);
                        if (newElements) {
                            if (Array.isArray(newElements)) // if handleSwap returns an array (like) of elements, we handle them
                            for(var j = 0; j < newElements.length; j++){
                                var child = newElements[j];
                                if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
                            }
                            return;
                        }
                    } catch (e) {
                        logError(e);
                    }
                }
                if (swapStyle === 'innerHTML') swapInnerHTML(target, fragment, settleInfo);
                else swapWithStyle(htmx.config.defaultSwapStyle, elt, target, fragment, settleInfo);
        }
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   */ function findAndSwapOobElements(fragment, settleInfo, rootNode) {
        var oobElts = findAll(fragment, '[hx-swap-oob], [data-hx-swap-oob]');
        forEach(oobElts, function(oobElement) {
            if (htmx.config.allowNestedOobSwaps || oobElement.parentElement === null) {
                var oobValue = getAttributeValue(oobElement, 'hx-swap-oob');
                if (oobValue != null) oobSwap(oobValue, oobElement, settleInfo, rootNode);
            } else {
                oobElement.removeAttribute('hx-swap-oob');
                oobElement.removeAttribute('data-hx-swap-oob');
            }
        });
        return oobElts.length > 0;
    }
    /**
   * Implements complete swapping pipeline, including: delay, view transitions, focus and selection preservation,
   * title updates, scroll, OOB swapping, normal swapping and settling
   * @param {string|Element} target
   * @param {string} content
   * @param {HtmxSwapSpecification} swapSpec
   * @param {SwapOptions} [swapOptions]
   */ function swap(target, content, swapSpec, swapOptions) {
        if (!swapOptions) swapOptions = {};
        // optional transition API promise callbacks
        var settleResolve = null;
        var settleReject = null;
        var doSwap = function doSwap() {
            maybeCall(swapOptions.beforeSwapCallback);
            target = resolveTarget(target);
            var rootNode = swapOptions.contextElement ? getRootNode(swapOptions.contextElement, false) : getDocument();
            // preserve focus and selection
            var activeElt = document.activeElement;
            var selectionInfo = {};
            selectionInfo = {
                elt: activeElt,
                // @ts-ignore
                start: activeElt ? activeElt.selectionStart : null,
                // @ts-ignore
                end: activeElt ? activeElt.selectionEnd : null
            };
            var settleInfo = makeSettleInfo(target);
            // For text content swaps, don't parse the response as HTML, just insert it
            if (swapSpec.swapStyle === 'textContent') target.textContent = content;
            else {
                var fragment = makeFragment(content);
                settleInfo.title = swapOptions.title || fragment.title;
                if (swapOptions.historyRequest) // @ts-ignore fragment can be a parentNode Element
                fragment = fragment.querySelector('[hx-history-elt],[data-hx-history-elt]') || fragment;
                // select-oob swaps
                if (swapOptions.selectOOB) {
                    var oobSelectValues = swapOptions.selectOOB.split(',');
                    for(var i = 0; i < oobSelectValues.length; i++){
                        var oobSelectValue = oobSelectValues[i].split(':', 2);
                        var id = oobSelectValue[0].trim();
                        if (id.indexOf('#') === 0) id = id.substring(1);
                        var oobValue = oobSelectValue[1] || 'true';
                        var oobElement = fragment.querySelector('#' + id);
                        if (oobElement) oobSwap(oobValue, oobElement, settleInfo, rootNode);
                    }
                }
                // oob swaps
                findAndSwapOobElements(fragment, settleInfo, rootNode);
                forEach(findAll(fragment, 'template'), /** @param {HTMLTemplateElement} template */ function(template) {
                    if (template.content && findAndSwapOobElements(template.content, settleInfo, rootNode)) // Avoid polluting the DOM with empty templates that were only used to encapsulate oob swap
                    template.remove();
                });
                // normal swap
                if (swapOptions.select) {
                    var newFragment = getDocument().createDocumentFragment();
                    forEach(fragment.querySelectorAll(swapOptions.select), function(node) {
                        newFragment.appendChild(node);
                    });
                    fragment = newFragment;
                }
                handlePreservedElements(fragment);
                swapWithStyle(swapSpec.swapStyle, swapOptions.contextElement, target, fragment, settleInfo);
                restorePreservedElements();
            }
            // apply saved focus and selection information to swapped content
            if (selectionInfo.elt && !bodyContains(selectionInfo.elt) && getRawAttribute(selectionInfo.elt, 'id')) {
                var newActiveElt = document.getElementById(getRawAttribute(selectionInfo.elt, 'id'));
                var focusOptions = {
                    preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !htmx.config.defaultFocusScroll
                };
                if (newActiveElt) {
                    // @ts-ignore
                    if (selectionInfo.start && newActiveElt.setSelectionRange) try {
                        // @ts-ignore
                        newActiveElt.setSelectionRange(selectionInfo.start, selectionInfo.end);
                    } catch (e) {
                    // the setSelectionRange method is present on fields that don't support it, so just let this fail
                    }
                    newActiveElt.focus(focusOptions);
                }
            }
            target.classList.remove(htmx.config.swappingClass);
            forEach(settleInfo.elts, function(elt) {
                if (elt.classList) elt.classList.add(htmx.config.settlingClass);
                triggerEvent(elt, 'htmx:afterSwap', swapOptions.eventInfo);
            });
            maybeCall(swapOptions.afterSwapCallback);
            // merge in new title after swap but before settle
            if (!swapSpec.ignoreTitle) handleTitle(settleInfo.title);
            // settle
            var doSettle = function doSettle() {
                forEach(settleInfo.tasks, function(task) {
                    task.call();
                });
                forEach(settleInfo.elts, function(elt) {
                    if (elt.classList) elt.classList.remove(htmx.config.settlingClass);
                    triggerEvent(elt, 'htmx:afterSettle', swapOptions.eventInfo);
                });
                if (swapOptions.anchor) {
                    var anchorTarget = asElement(resolveTarget('#' + swapOptions.anchor));
                    if (anchorTarget) anchorTarget.scrollIntoView({
                        block: 'start',
                        behavior: 'auto'
                    });
                }
                updateScrollState(settleInfo.elts, swapSpec);
                maybeCall(swapOptions.afterSettleCallback);
                maybeCall(settleResolve);
            };
            if (swapSpec.settleDelay > 0) getWindow().setTimeout(doSettle, swapSpec.settleDelay);
            else doSettle();
        };
        var shouldTransition = htmx.config.globalViewTransitions;
        if (swapSpec.hasOwnProperty('transition')) shouldTransition = swapSpec.transition;
        var elt = swapOptions.contextElement || getDocument();
        if (shouldTransition && triggerEvent(elt, 'htmx:beforeTransition', swapOptions.eventInfo) && typeof Promise !== 'undefined' && // @ts-ignore experimental feature atm
        document.startViewTransition) {
            var settlePromise = new Promise(function(_resolve, _reject) {
                settleResolve = _resolve;
                settleReject = _reject;
            });
            // wrap the original doSwap() in a call to startViewTransition()
            var innerDoSwap = doSwap;
            doSwap = function doSwap() {
                // @ts-ignore experimental feature atm
                document.startViewTransition(function() {
                    innerDoSwap();
                    return settlePromise;
                });
            };
        }
        try {
            if ((swapSpec === null || swapSpec === void 0 ? void 0 : swapSpec.swapDelay) && swapSpec.swapDelay > 0) getWindow().setTimeout(doSwap, swapSpec.swapDelay);
            else doSwap();
        } catch (e) {
            triggerErrorEvent(elt, 'htmx:swapError', swapOptions.eventInfo);
            maybeCall(settleReject);
            throw e;
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {EventTarget} elt
   */ function handleTriggerHeader(xhr, header, elt) {
        var triggerBody = xhr.getResponseHeader(header);
        if (triggerBody.indexOf('{') === 0) {
            var triggers = parseJSON(triggerBody);
            for(var eventName in triggers)if (triggers.hasOwnProperty(eventName)) {
                var detail = triggers[eventName];
                if (isRawObject(detail)) // @ts-ignore
                elt = detail.target !== undefined ? detail.target : elt;
                else detail = {
                    value: detail
                };
                triggerEvent(elt, eventName, detail);
            }
        } else {
            var eventNames = triggerBody.split(',');
            for(var i = 0; i < eventNames.length; i++)triggerEvent(elt, eventNames[i].trim(), []);
        }
    }
    var WHITESPACE = /\s/;
    var WHITESPACE_OR_COMMA = /[\s,]/;
    var SYMBOL_START = /[_$a-zA-Z]/;
    var SYMBOL_CONT = /[_$a-zA-Z0-9]/;
    var STRINGISH_START = [
        '"',
        "'",
        '/'
    ];
    var NOT_WHITESPACE = /[^\s]/;
    var COMBINED_SELECTOR_START = /[{(]/;
    var COMBINED_SELECTOR_END = /[})]/;
    /**
   * @param {string} str
   * @returns {string[]}
   */ function tokenizeString(str) {
        /** @type string[] */ var tokens = [];
        var position = 0;
        while(position < str.length){
            if (SYMBOL_START.exec(str.charAt(position))) {
                var startPosition = position;
                while(SYMBOL_CONT.exec(str.charAt(position + 1)))position++;
                tokens.push(str.substring(startPosition, position + 1));
            } else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
                var startChar = str.charAt(position);
                var startPosition = position;
                position++;
                while(position < str.length && str.charAt(position) !== startChar){
                    if (str.charAt(position) === '\\') position++;
                    position++;
                }
                tokens.push(str.substring(startPosition, position + 1));
            } else {
                var symbol = str.charAt(position);
                tokens.push(symbol);
            }
            position++;
        }
        return tokens;
    }
    /**
   * @param {string} token
   * @param {string|null} last
   * @param {string} paramName
   * @returns {boolean}
   */ function isPossibleRelativeReference(token, last, paramName) {
        return SYMBOL_START.exec(token.charAt(0)) && token !== 'true' && token !== 'false' && token !== 'this' && token !== paramName && last !== '.';
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string[]} tokens
   * @param {string} paramName
   * @returns {ConditionalFunction|null}
   */ function maybeGenerateConditional(elt, tokens, paramName) {
        if (tokens[0] === '[') {
            tokens.shift();
            var bracketCount = 1;
            var conditionalSource = ' return (function(' + paramName + '){ return (';
            var last = null;
            while(tokens.length > 0){
                var token = tokens[0];
                // @ts-ignore For some reason tsc doesn't understand the shift call, and thinks we're comparing the same value here, i.e. '[' vs ']'
                if (token === ']') {
                    bracketCount--;
                    if (bracketCount === 0) {
                        if (last === null) conditionalSource = conditionalSource + 'true';
                        tokens.shift();
                        conditionalSource += ')})';
                        try {
                            var conditionFunction = maybeEval(elt, function() {
                                return Function(conditionalSource)();
                            }, function() {
                                return true;
                            });
                            conditionFunction.source = conditionalSource;
                            return conditionFunction;
                        } catch (e) {
                            triggerErrorEvent(getDocument().body, 'htmx:syntax:error', {
                                error: e,
                                source: conditionalSource
                            });
                            return null;
                        }
                    }
                } else if (token === '[') bracketCount++;
                if (isPossibleRelativeReference(token, last, paramName)) conditionalSource += '((' + paramName + '.' + token + ') ? (' + paramName + '.' + token + ') : (window.' + token + '))';
                else conditionalSource = conditionalSource + token;
                last = tokens.shift();
            }
        }
    }
    /**
   * @param {string[]} tokens
   * @param {RegExp} match
   * @returns {string}
   */ function consumeUntil(tokens, match) {
        var result = '';
        while(tokens.length > 0 && !match.test(tokens[0]))result += tokens.shift();
        return result;
    }
    /**
   * @param {string[]} tokens
   * @returns {string}
   */ function consumeCSSSelector(tokens) {
        var result;
        if (tokens.length > 0 && COMBINED_SELECTOR_START.test(tokens[0])) {
            tokens.shift();
            result = consumeUntil(tokens, COMBINED_SELECTOR_END).trim();
            tokens.shift();
        } else result = consumeUntil(tokens, WHITESPACE_OR_COMMA);
        return result;
    }
    var INPUT_SELECTOR = 'input, textarea, select';
    /**
   * @param {Element} elt
   * @param {string} explicitTrigger
   * @param {Object} cache for trigger specs
   * @returns {HtmxTriggerSpecification[]}
   */ function parseAndCacheTrigger(elt, explicitTrigger, cache) {
        /** @type HtmxTriggerSpecification[] */ var triggerSpecs = [];
        var tokens = tokenizeString(explicitTrigger);
        do {
            consumeUntil(tokens, NOT_WHITESPACE);
            var initialLength = tokens.length;
            var trigger = consumeUntil(tokens, /[,\[\s]/);
            if (trigger !== '') {
                if (trigger === 'every') {
                    /** @type HtmxTriggerSpecification */ var every = {
                        trigger: 'every'
                    };
                    consumeUntil(tokens, NOT_WHITESPACE);
                    every.pollInterval = parseInterval(consumeUntil(tokens, /[,\[\s]/));
                    consumeUntil(tokens, NOT_WHITESPACE);
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) every.eventFilter = eventFilter;
                    triggerSpecs.push(every);
                } else {
                    /** @type HtmxTriggerSpecification */ var triggerSpec = {
                        trigger: trigger
                    };
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) triggerSpec.eventFilter = eventFilter;
                    consumeUntil(tokens, NOT_WHITESPACE);
                    while(tokens.length > 0 && tokens[0] !== ','){
                        var token = tokens.shift();
                        if (token === 'changed') triggerSpec.changed = true;
                        else if (token === 'once') triggerSpec.once = true;
                        else if (token === 'consume') triggerSpec.consume = true;
                        else if (token === 'delay' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.delay = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'from' && tokens[0] === ':') {
                            tokens.shift();
                            if (COMBINED_SELECTOR_START.test(tokens[0])) var from_arg = consumeCSSSelector(tokens);
                            else {
                                var from_arg = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                                if (from_arg === 'closest' || from_arg === 'find' || from_arg === 'next' || from_arg === 'previous') {
                                    tokens.shift();
                                    var selector = consumeCSSSelector(tokens);
                                    // `next` and `previous` allow a selector-less syntax
                                    if (selector.length > 0) from_arg += ' ' + selector;
                                }
                            }
                            triggerSpec.from = from_arg;
                        } else if (token === 'target' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.target = consumeCSSSelector(tokens);
                        } else if (token === 'throttle' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.throttle = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'queue' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.queue = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else if (token === 'root' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeCSSSelector(tokens);
                        } else if (token === 'threshold' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else triggerErrorEvent(elt, 'htmx:syntax:error', {
                            token: tokens.shift()
                        });
                        consumeUntil(tokens, NOT_WHITESPACE);
                    }
                    triggerSpecs.push(triggerSpec);
                }
            }
            if (tokens.length === initialLength) triggerErrorEvent(elt, 'htmx:syntax:error', {
                token: tokens.shift()
            });
            consumeUntil(tokens, NOT_WHITESPACE);
        }while (tokens[0] === ',' && tokens.shift());
        if (cache) cache[explicitTrigger] = triggerSpecs;
        return triggerSpecs;
    }
    /**
   * @param {Element} elt
   * @returns {HtmxTriggerSpecification[]}
   */ function getTriggerSpecs(elt) {
        var explicitTrigger = getAttributeValue(elt, 'hx-trigger');
        var triggerSpecs = [];
        if (explicitTrigger) {
            var cache = htmx.config.triggerSpecsCache;
            triggerSpecs = cache && cache[explicitTrigger] || parseAndCacheTrigger(elt, explicitTrigger, cache);
        }
        if (triggerSpecs.length > 0) return triggerSpecs;
        else if (matches(elt, 'form')) return [
            {
                trigger: 'submit'
            }
        ];
        else if (matches(elt, 'input[type="button"], input[type="submit"]')) return [
            {
                trigger: 'click'
            }
        ];
        else if (matches(elt, INPUT_SELECTOR)) return [
            {
                trigger: 'change'
            }
        ];
        else return [
            {
                trigger: 'click'
            }
        ];
    }
    /**
   * @param {Element} elt
   */ function cancelPolling(elt) {
        getInternalData(elt).cancelled = true;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxTriggerSpecification} spec
   */ function processPolling(elt, handler, spec) {
        var nodeData = getInternalData(elt);
        nodeData.timeout = getWindow().setTimeout(function() {
            if (bodyContains(elt) && nodeData.cancelled !== true) {
                if (!maybeFilterEvent(spec, elt, makeEvent('hx:poll:trigger', {
                    triggerSpec: spec,
                    target: elt
                }))) handler(elt);
                processPolling(elt, handler, spec);
            }
        }, spec.pollInterval);
    }
    /**
   * @param {HTMLAnchorElement} elt
   * @returns {boolean}
   */ function isLocalLink(elt) {
        return location.hostname === elt.hostname && getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') !== 0;
    }
    /**
   * @param {Element} elt
   */ function eltIsDisabled(elt) {
        return closest(elt, htmx.config.disableSelector);
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   */ function boostElement(elt, nodeData, triggerSpecs) {
        if (elt instanceof HTMLAnchorElement && isLocalLink(elt) && (elt.target === '' || elt.target === '_self') || elt.tagName === 'FORM' && String(getRawAttribute(elt, 'method')).toLowerCase() !== 'dialog') {
            nodeData.boosted = true;
            var verb, path;
            if (elt.tagName === 'A') {
                verb = /** @type HttpVerb */ 'get';
                path = getRawAttribute(elt, 'href');
            } else {
                var rawAttribute = getRawAttribute(elt, 'method');
                verb = /** @type HttpVerb */ rawAttribute ? rawAttribute.toLowerCase() : 'get';
                path = getRawAttribute(elt, 'action');
                if (path == null || path === '') // if there is no action attribute on the form set path to current href before the
                // following logic to properly clear parameters on a GET (not on a POST!)
                path = location.href;
                if (verb === 'get' && path.includes('?')) path = path.replace(/\?[^#]+/, '');
            }
            triggerSpecs.forEach(function(triggerSpec) {
                addEventListener(elt, function(node, evt) {
                    var _$elt = asElement(node);
                    if (eltIsDisabled(_$elt)) {
                        cleanUpElement(_$elt);
                        return;
                    }
                    issueAjaxRequest(verb, path, _$elt, evt);
                }, nodeData, triggerSpec, true);
            });
        }
    }
    /**
   * @param {Event} evt
   * @param {Element} elt
   * @returns {boolean}
   */ function shouldCancel(evt, elt) {
        if (evt.type === 'submit' && elt.tagName === 'FORM') return true;
        else if (evt.type === 'click') {
            // find button wrapping the trigger element
            var btn = /** @type {HTMLButtonElement|HTMLInputElement|null} */ elt.closest('input[type="submit"], button');
            // Do not cancel on buttons that 1) don't have a related form or 2) have a type attribute of 'reset'/'button'.
            if (btn && btn.form && btn.type === 'submit') return true;
            // find link wrapping the trigger element
            var link = elt.closest('a');
            // Allow links with href="#fragment" (anchors with content after #) to perform normal fragment navigation.
            // Cancel default action for links with href="#" (bare hash) to prevent scrolling to top and unwanted URL changes.
            var samePageAnchor = /^#.+/;
            if (link && link.href && !samePageAnchor.test(link.getAttribute('href'))) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @param {Event|MouseEvent|KeyboardEvent|TouchEvent} evt
   * @returns {boolean}
   */ function ignoreBoostedAnchorCtrlClick(elt, evt) {
        return getInternalData(elt).boosted && elt instanceof HTMLAnchorElement && evt.type === 'click' && // @ts-ignore this will resolve to undefined for events that don't define those properties, which is fine
        (evt.ctrlKey || evt.metaKey);
    }
    /**
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {Node} elt
   * @param {Event} evt
   * @returns {boolean}
   */ function maybeFilterEvent(triggerSpec, elt, evt) {
        var eventFilter = triggerSpec.eventFilter;
        if (eventFilter) try {
            return eventFilter.call(elt, evt) !== true;
        } catch (e) {
            var source = eventFilter.source;
            triggerErrorEvent(getDocument().body, 'htmx:eventFilter:error', {
                error: e,
                source: source
            });
            return true;
        }
        return false;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {boolean} [explicitCancel]
   */ function addEventListener(elt, handler, nodeData, triggerSpec, explicitCancel) {
        var elementData = getInternalData(elt);
        /** @type {(Node|Window)[]} */ var eltsToListenOn;
        if (triggerSpec.from) eltsToListenOn = querySelectorAllExt(elt, triggerSpec.from);
        else eltsToListenOn = [
            elt
        ];
        // store the initial values of the elements, so we can tell if they change
        if (triggerSpec.changed) {
            if (!('lastValue' in elementData)) elementData.lastValue = new WeakMap();
            eltsToListenOn.forEach(function(eltToListenOn) {
                if (!elementData.lastValue.has(triggerSpec)) elementData.lastValue.set(triggerSpec, new WeakMap());
                // @ts-ignore value will be undefined for non-input elements, which is fine
                elementData.lastValue.get(triggerSpec).set(eltToListenOn, eltToListenOn.value);
            });
        }
        forEach(eltsToListenOn, function(eltToListenOn) {
            /** @type EventListener */ var eventListener = function eventListener1(evt) {
                if (!bodyContains(elt)) {
                    eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
                    return;
                }
                if (ignoreBoostedAnchorCtrlClick(elt, evt)) return;
                if (explicitCancel || shouldCancel(evt, eltToListenOn)) evt.preventDefault();
                if (maybeFilterEvent(triggerSpec, elt, evt)) return;
                var eventData = getInternalData(evt);
                eventData.triggerSpec = triggerSpec;
                if (eventData.handledFor == null) eventData.handledFor = [];
                if (eventData.handledFor.indexOf(elt) < 0) {
                    eventData.handledFor.push(elt);
                    if (triggerSpec.consume) evt.stopPropagation();
                    if (triggerSpec.target && evt.target) {
                        if (!matches(asElement(evt.target), triggerSpec.target)) return;
                    }
                    if (triggerSpec.once) {
                        if (elementData.triggeredOnce) return;
                        else elementData.triggeredOnce = true;
                    }
                    if (triggerSpec.changed) {
                        var node = evt.target;
                        // @ts-ignore value will be undefined for non-input elements, which is fine
                        var value = node.value;
                        var lastValue = elementData.lastValue.get(triggerSpec);
                        if (lastValue.has(node) && lastValue.get(node) === value) return;
                        lastValue.set(node, value);
                    }
                    if (elementData.delayed) clearTimeout(elementData.delayed);
                    if (elementData.throttle) return;
                    if (triggerSpec.throttle > 0) {
                        if (!elementData.throttle) {
                            triggerEvent(elt, 'htmx:trigger');
                            handler(elt, evt);
                            elementData.throttle = getWindow().setTimeout(function() {
                                elementData.throttle = null;
                            }, triggerSpec.throttle);
                        }
                    } else if (triggerSpec.delay > 0) elementData.delayed = getWindow().setTimeout(function() {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }, triggerSpec.delay);
                    else {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }
                }
            };
            if (nodeData.listenerInfos == null) nodeData.listenerInfos = [];
            nodeData.listenerInfos.push({
                trigger: triggerSpec.trigger,
                listener: eventListener,
                on: eltToListenOn
            });
            eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
        });
    }
    var windowIsScrolling = false // used by initScrollHandler
    ;
    var scrollHandler = null;
    function initScrollHandler() {
        if (!scrollHandler) {
            scrollHandler = function scrollHandler1() {
                windowIsScrolling = true;
            };
            window.addEventListener('scroll', scrollHandler);
            window.addEventListener('resize', scrollHandler);
            setInterval(function() {
                if (windowIsScrolling) {
                    windowIsScrolling = false;
                    forEach(getDocument().querySelectorAll("[hx-trigger*='revealed'],[data-hx-trigger*='revealed']"), function(elt) {
                        maybeReveal(elt);
                    });
                }
            }, 200);
        }
    }
    /**
   * @param {Element} elt
   */ function maybeReveal(elt) {
        if (!hasAttribute(elt, 'data-hx-revealed') && isScrolledIntoView(elt)) {
            elt.setAttribute('data-hx-revealed', 'true');
            var nodeData = getInternalData(elt);
            if (nodeData.initHash) triggerEvent(elt, 'revealed');
            else // if the node isn't initialized, wait for it before triggering the request
            elt.addEventListener('htmx:afterProcessNode', function() {
                triggerEvent(elt, 'revealed');
            }, {
                once: true
            });
        }
    }
    //= ===================================================================
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {number} delay
   */ function loadImmediately(elt, handler, nodeData, delay) {
        var load = function load() {
            if (!nodeData.loaded) {
                nodeData.loaded = true;
                triggerEvent(elt, 'htmx:trigger');
                handler(elt);
            }
        };
        if (delay > 0) getWindow().setTimeout(load, delay);
        else load();
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   * @returns {boolean}
   */ function processVerbs(elt, nodeData, triggerSpecs) {
        var explicitAction = false;
        forEach(VERBS, function(verb) {
            if (hasAttribute(elt, 'hx-' + verb)) {
                var path = getAttributeValue(elt, 'hx-' + verb);
                explicitAction = true;
                nodeData.path = path;
                nodeData.verb = verb;
                triggerSpecs.forEach(function(triggerSpec) {
                    addTriggerHandler(elt, triggerSpec, nodeData, function(node, evt) {
                        var _$elt = asElement(node);
                        if (eltIsDisabled(_$elt)) {
                            cleanUpElement(_$elt);
                            return;
                        }
                        issueAjaxRequest(verb, path, _$elt, evt);
                    });
                });
            }
        });
        return explicitAction;
    }
    /**
   * @callback TriggerHandler
   * @param {Element} elt
   * @param {Event} [evt]
   */ /**
   * @param {Element} elt
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {HtmxNodeInternalData} nodeData
   * @param {TriggerHandler} handler
   */ function addTriggerHandler(elt, triggerSpec, nodeData, handler) {
        if (triggerSpec.trigger === 'revealed') {
            initScrollHandler();
            addEventListener(elt, handler, nodeData, triggerSpec);
            maybeReveal(asElement(elt));
        } else if (triggerSpec.trigger === 'intersect') {
            var observerOptions = {};
            if (triggerSpec.root) observerOptions.root = querySelectorExt(elt, triggerSpec.root);
            if (triggerSpec.threshold) observerOptions.threshold = parseFloat(triggerSpec.threshold);
            var observer = new IntersectionObserver(function(entries) {
                for(var i = 0; i < entries.length; i++){
                    var entry = entries[i];
                    if (entry.isIntersecting) {
                        triggerEvent(elt, 'intersect');
                        break;
                    }
                }
            }, observerOptions);
            observer.observe(asElement(elt));
            addEventListener(asElement(elt), handler, nodeData, triggerSpec);
        } else if (!nodeData.firstInitCompleted && triggerSpec.trigger === 'load') {
            if (!maybeFilterEvent(triggerSpec, elt, makeEvent('load', {
                elt: elt
            }))) loadImmediately(asElement(elt), handler, nodeData, triggerSpec.delay);
        } else if (triggerSpec.pollInterval > 0) {
            nodeData.polling = true;
            processPolling(asElement(elt), handler, triggerSpec);
        } else addEventListener(elt, handler, nodeData, triggerSpec);
    }
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function shouldProcessHxOn(node) {
        var elt = asElement(node);
        if (!elt) return false;
        var attributes = elt.attributes;
        for(var j = 0; j < attributes.length; j++){
            var attrName = attributes[j].name;
            if (startsWith(attrName, 'hx-on:') || startsWith(attrName, 'data-hx-on:') || startsWith(attrName, 'hx-on-') || startsWith(attrName, 'data-hx-on-')) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @returns {Element[]}
   */ var HX_ON_QUERY = new XPathEvaluator().createExpression('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]');
    function processHXOnRoot(elt, elements) {
        if (shouldProcessHxOn(elt)) elements.push(asElement(elt));
        var iter = HX_ON_QUERY.evaluate(elt);
        var node = null;
        while(node = iter.iterateNext())elements.push(asElement(node));
    }
    function findHxOnWildcardElements(elt) {
        /** @type {Element[]} */ var elements = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (elt instanceof DocumentFragment) try {
            for(var _iterator = elt.childNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                processHXOnRoot(child, elements);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else processHXOnRoot(elt, elements);
        return elements;
    }
    /**
   * @param {Element} elt
   * @returns {NodeListOf<Element>|[]}
   */ function findElementsToProcess(elt) {
        if (elt.querySelectorAll) {
            var boostedSelector = ', [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]';
            var extensionSelectors = [];
            for(var e in extensions){
                var extension = extensions[e];
                if (extension.getSelectors) {
                    var selectors = extension.getSelectors();
                    if (selectors) extensionSelectors.push(selectors);
                }
            }
            var results = elt.querySelectorAll(VERB_SELECTOR + boostedSelector + ", form, [type='submit']," + ' [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger]' + extensionSelectors.flat().map(function(s) {
                return ', ' + s;
            }).join(''));
            return results;
        } else return [];
    }
    /**
   * Handle submit buttons/inputs that have the form attribute set
   * see https://developer.mozilla.org/docs/Web/HTML/Element/button
   * @param {Event} evt
   */ function maybeSetLastButtonClicked(evt) {
        var elt = getTargetButton(evt.target);
        var internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = elt;
    }
    /**
   * @param {Event} evt
   */ function maybeUnsetLastButtonClicked(evt) {
        var internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = null;
    }
    /**
   * @param {EventTarget} target
   * @returns {HTMLButtonElement|HTMLInputElement|null}
   */ function getTargetButton(target) {
        return /** @type {HTMLButtonElement|HTMLInputElement|null} */ closest(asElement(target), "button, input[type='submit']");
    }
    /**
   * @param {Element} elt
   * @returns {HTMLFormElement|null}
   */ function getRelatedForm(elt) {
        // @ts-ignore Get the related form if available, else find the closest parent form
        return elt.form || closest(elt, 'form');
    }
    /**
   * @param {Event} evt
   * @returns {HtmxNodeInternalData|undefined}
   */ function getRelatedFormData(evt) {
        var elt = getTargetButton(evt.target);
        if (!elt) return;
        var form = getRelatedForm(elt);
        if (!form) return;
        return getInternalData(form);
    }
    /**
   * @param {EventTarget} elt
   */ function initButtonTracking(elt) {
        // need to handle both click and focus in:
        //   focusin - in case someone tabs in to a button and hits the space bar
        //   click - on OSX buttons do not focus on click see https://bugs.webkit.org/show_bug.cgi?id=13724
        elt.addEventListener('click', maybeSetLastButtonClicked);
        elt.addEventListener('focusin', maybeSetLastButtonClicked);
        elt.addEventListener('focusout', maybeUnsetLastButtonClicked);
    }
    /**
   * @param {Element} elt
   * @param {string} eventName
   * @param {string} code
   */ function addHxOnEventHandler(elt, eventName, code) {
        var nodeData = getInternalData(elt);
        if (!Array.isArray(nodeData.onHandlers)) nodeData.onHandlers = [];
        var func;
        /** @type EventListener */ var listener = function listener(e) {
            maybeEval(elt, function() {
                if (eltIsDisabled(elt)) return;
                if (!func) func = new Function('event', code);
                func.call(elt, e);
            });
        };
        elt.addEventListener(eventName, listener);
        nodeData.onHandlers.push({
            event: eventName,
            listener: listener
        });
    }
    /**
   * @param {Element} elt
   */ function processHxOnWildcard(elt) {
        // wipe any previous on handlers so that this function takes precedence
        deInitOnHandlers(elt);
        for(var i = 0; i < elt.attributes.length; i++){
            var name = elt.attributes[i].name;
            var value = elt.attributes[i].value;
            if (startsWith(name, 'hx-on') || startsWith(name, 'data-hx-on')) {
                var afterOnPosition = name.indexOf('-on') + 3;
                var nextChar = name.slice(afterOnPosition, afterOnPosition + 1);
                if (nextChar === '-' || nextChar === ':') {
                    var eventName = name.slice(afterOnPosition + 1);
                    // if the eventName starts with a colon or dash, prepend "htmx" for shorthand support
                    if (startsWith(eventName, ':')) eventName = 'htmx' + eventName;
                    else if (startsWith(eventName, '-')) eventName = 'htmx:' + eventName.slice(1);
                    else if (startsWith(eventName, 'htmx-')) eventName = 'htmx:' + eventName.slice(5);
                    addHxOnEventHandler(elt, eventName, value);
                }
            }
        }
    }
    /**
   * @param {Element|HTMLInputElement} elt
   */ function initNode(elt) {
        triggerEvent(elt, 'htmx:beforeProcessNode');
        var nodeData = getInternalData(elt);
        var triggerSpecs = getTriggerSpecs(elt);
        var hasExplicitHttpAction = processVerbs(elt, nodeData, triggerSpecs);
        if (!hasExplicitHttpAction) {
            if (getClosestAttributeValue(elt, 'hx-boost') === 'true') boostElement(elt, nodeData, triggerSpecs);
            else if (hasAttribute(elt, 'hx-trigger')) triggerSpecs.forEach(function(triggerSpec) {
                // For "naked" triggers, don't do anything at all
                addTriggerHandler(elt, triggerSpec, nodeData, function() {});
            });
        }
        // Handle submit buttons/inputs that have the form attribute set
        // see https://developer.mozilla.org/docs/Web/HTML/Element/button
        if (elt.tagName === 'FORM' || getRawAttribute(elt, 'type') === 'submit' && hasAttribute(elt, 'form')) initButtonTracking(elt);
        nodeData.firstInitCompleted = true;
        triggerEvent(elt, 'htmx:afterProcessNode');
    }
    /**
   * @param {Element} elt
   * @returns {boolean}
   */ function maybeDeInitAndHash(elt) {
        // Ensure only valid Elements and not shadow DOM roots are inited
        if (!(elt instanceof Element)) return false;
        var nodeData = getInternalData(elt);
        var hash = attributeHash(elt);
        if (nodeData.initHash !== hash) {
            deInitNode(elt);
            nodeData.initHash = hash;
            return true;
        }
        return false;
    }
    /**
   * Processes new content, enabling htmx behavior. This can be useful if you have content that is added to the DOM outside of the normal htmx request cycle but still want htmx attributes to work.
   *
   * @see https://htmx.org/api/#process
   *
   * @param {Element|string} elt element to process
   */ function processNode(elt) {
        elt = resolveTarget(elt);
        if (eltIsDisabled(elt)) {
            cleanUpElement(elt);
            return;
        }
        var elementsToInit = [];
        if (maybeDeInitAndHash(elt)) elementsToInit.push(elt);
        forEach(findElementsToProcess(elt), function(child) {
            if (eltIsDisabled(child)) {
                cleanUpElement(child);
                return;
            }
            if (maybeDeInitAndHash(child)) elementsToInit.push(child);
        });
        forEach(findHxOnWildcardElements(elt), processHxOnWildcard);
        forEach(elementsToInit, initNode);
    }
    //= ===================================================================
    // Event/Log Support
    //= ===================================================================
    /**
   * @param {string} str
   * @returns {string}
   */ function kebabEventName(str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
   * @param {string} eventName
   * @param {any} detail
   * @returns {CustomEvent}
   */ function makeEvent(eventName, detail) {
        // TODO: `composed: true` here is a hack to make global event handlers work with events in shadow DOM
        // This breaks expected encapsulation but needs to be here until decided otherwise by core devs
        return new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string} eventName
   * @param {any=} detail
   */ function triggerErrorEvent(elt, eventName, detail) {
        triggerEvent(elt, eventName, mergeObjects({
            error: eventName
        }, detail));
    }
    /**
   * @param {string} eventName
   * @returns {boolean}
   */ function ignoreEventForLogging(eventName) {
        return eventName === 'htmx:afterProcessNode';
    }
    /**
   * `withExtensions` locates all active extensions for a provided element, then
   * executes the provided function using each of the active extensions. You can filter
   * the element's extensions by giving it a list of extensions to ignore. It should
   * be called internally at every extendable execution point in htmx.
   *
   * @param {Element} elt
   * @param {(extension:HtmxExtension) => void} toDo
   * @param {string[]=} extensionsToIgnore
   * @returns void
   */ function withExtensions(elt, toDo, extensionsToIgnore) {
        forEach(getExtensions(elt, [], extensionsToIgnore), function(extension) {
            try {
                toDo(extension);
            } catch (e) {
                logError(e);
            }
        });
    }
    function logError(msg) {
        console.error(msg);
    }
    /**
   * Triggers a given event on an element
   *
   * @see https://htmx.org/api/#trigger
   *
   * @param {EventTarget|string} elt the element to trigger the event on
   * @param {string} eventName the name of the event to trigger
   * @param {any=} detail details for the event
   * @returns {boolean}
   */ function triggerEvent(elt, eventName, detail) {
        elt = resolveTarget(elt);
        if (detail == null) detail = {};
        detail.elt = elt;
        var event = makeEvent(eventName, detail);
        if (htmx.logger && !ignoreEventForLogging(eventName)) htmx.logger(elt, eventName, detail);
        if (detail.error) {
            logError(detail.error);
            triggerEvent(elt, 'htmx:error', {
                errorInfo: detail
            });
        }
        var eventResult = elt.dispatchEvent(event);
        var kebabName = kebabEventName(eventName);
        if (eventResult && kebabName !== eventName) {
            var kebabedEvent = makeEvent(kebabName, event.detail);
            eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
        }
        withExtensions(asElement(elt), function(extension) {
            eventResult = eventResult && extension.onEvent(eventName, event) !== false && !event.defaultPrevented;
        });
        return eventResult;
    }
    //= ===================================================================
    // History Support
    //= ===================================================================
    var currentPathForHistory;
    /**
   * @param {string} path
   */ function setCurrentPathForHistory(path) {
        currentPathForHistory = path;
        if (canAccessLocalStorage()) sessionStorage.setItem('htmx-current-path-for-history', path);
    }
    setCurrentPathForHistory(location.pathname + location.search);
    /**
   * @returns {Element}
   */ function getHistoryElement() {
        var historyElt = getDocument().querySelector('[hx-history-elt],[data-hx-history-elt]');
        return historyElt || getDocument().body;
    }
    /**
   * @param {string} url
   * @param {Element} rootElt
   */ function saveToHistoryCache(url, rootElt) {
        if (!canAccessLocalStorage()) return;
        // get state to save
        var innerHTML = cleanInnerHtmlForHistory(rootElt);
        var title = getDocument().title;
        var scroll = window.scrollY;
        if (htmx.config.historyCacheSize <= 0) {
            // make sure that an eventually already existing cache is purged
            sessionStorage.removeItem('htmx-history-cache');
            return;
        }
        url = normalizePath(url);
        var historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(var i = 0; i < historyCache.length; i++)if (historyCache[i].url === url) {
            historyCache.splice(i, 1);
            break;
        }
        /** @type HtmxHistoryItem */ var newHistoryItem = {
            url: url,
            content: innerHTML,
            title: title,
            scroll: scroll
        };
        triggerEvent(getDocument().body, 'htmx:historyItemCreated', {
            item: newHistoryItem,
            cache: historyCache
        });
        historyCache.push(newHistoryItem);
        while(historyCache.length > htmx.config.historyCacheSize)historyCache.shift();
        // keep trying to save the cache until it succeeds or is empty
        while(historyCache.length > 0)try {
            sessionStorage.setItem('htmx-history-cache', JSON.stringify(historyCache));
            break;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:historyCacheError', {
                cause: e,
                cache: historyCache
            });
            historyCache.shift() // shrink the cache and retry
            ;
        }
    }
    /**
   * @typedef {Object} HtmxHistoryItem
   * @property {string} url
   * @property {string} content
   * @property {string} title
   * @property {number} scroll
   */ /**
   * @param {string} url
   * @returns {HtmxHistoryItem|null}
   */ function getCachedHistory(url) {
        if (!canAccessLocalStorage()) return null;
        url = normalizePath(url);
        var historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(var i = 0; i < historyCache.length; i++){
            if (historyCache[i].url === url) return historyCache[i];
        }
        return null;
    }
    /**
   * @param {Element} elt
   * @returns {string}
   */ function cleanInnerHtmlForHistory(elt) {
        var className = htmx.config.requestClass;
        var clone = /** @type Element */ elt.cloneNode(true);
        forEach(findAll(clone, '.' + className), function(child) {
            removeClassFromElement(child, className);
        });
        // remove the disabled attribute for any element disabled due to an htmx request
        forEach(findAll(clone, '[data-disabled-by-htmx]'), function(child) {
            child.removeAttribute('disabled');
        });
        return clone.innerHTML;
    }
    function saveCurrentPageToHistory() {
        var elt = getHistoryElement();
        var path = currentPathForHistory;
        if (canAccessLocalStorage()) path = sessionStorage.getItem('htmx-current-path-for-history');
        path = path || location.pathname + location.search;
        // Allow history snapshot feature to be disabled where hx-history="false"
        // is present *anywhere* in the current document we're about to save,
        // so we can prevent privileged data entering the cache.
        // The page will still be reachable as a history entry, but htmx will fetch it
        // live from the server onpopstate rather than look in the sessionStorage cache
        var disableHistoryCache = getDocument().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
        if (!disableHistoryCache) {
            triggerEvent(getDocument().body, 'htmx:beforeHistorySave', {
                path: path,
                historyElt: elt
            });
            saveToHistoryCache(path, elt);
        }
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, getDocument().title, location.href);
    }
    /**
   * @param {string} path
   */ function pushUrlIntoHistory(path) {
        // remove the cache buster parameter, if any
        if (htmx.config.getCacheBusterParam) {
            path = path.replace(/org\.htmx\.cache-buster=[^&]*&?/, '');
            if (endsWith(path, '&') || endsWith(path, '?')) path = path.slice(0, -1);
        }
        if (htmx.config.historyEnabled) history.pushState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {string} path
   */ function replaceUrlInHistory(path) {
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {HtmxSettleTask[]} tasks
   */ function settleImmediately(tasks) {
        forEach(tasks, function(task) {
            task.call(undefined);
        });
    }
    /**
   * @param {string} path
   */ function loadHistoryFromServer(path) {
        var request = new XMLHttpRequest();
        var swapSpec = {
            swapStyle: 'innerHTML',
            swapDelay: 0,
            settleDelay: 0
        };
        var details = {
            path: path,
            xhr: request,
            historyElt: getHistoryElement(),
            swapSpec: swapSpec
        };
        request.open('GET', path, true);
        if (htmx.config.historyRestoreAsHxRequest) request.setRequestHeader('HX-Request', 'true');
        request.setRequestHeader('HX-History-Restore-Request', 'true');
        request.setRequestHeader('HX-Current-URL', location.href);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                details.response = this.response;
                triggerEvent(getDocument().body, 'htmx:historyCacheMissLoad', details);
                swap(details.historyElt, details.response, swapSpec, {
                    contextElement: details.historyElt,
                    historyRequest: true
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', {
                    path: path,
                    cacheMiss: true,
                    serverResponse: details.response
                });
            } else triggerErrorEvent(getDocument().body, 'htmx:historyCacheMissLoadError', details);
        };
        if (triggerEvent(getDocument().body, 'htmx:historyCacheMiss', details)) request.send() // only send request if event not prevented
        ;
    }
    /**
   * @param {string} [path]
   */ function restoreHistory(path) {
        saveCurrentPageToHistory();
        path = path || location.pathname + location.search;
        var cached = getCachedHistory(path);
        if (cached) {
            var swapSpec = {
                swapStyle: 'innerHTML',
                swapDelay: 0,
                settleDelay: 0,
                scroll: cached.scroll
            };
            var details = {
                path: path,
                item: cached,
                historyElt: getHistoryElement(),
                swapSpec: swapSpec
            };
            if (triggerEvent(getDocument().body, 'htmx:historyCacheHit', details)) {
                swap(details.historyElt, cached.content, swapSpec, {
                    contextElement: details.historyElt,
                    title: cached.title
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', details);
            }
        } else if (htmx.config.refreshOnHistoryMiss) // @ts-ignore: optional parameter in reload() function throws error
        // noinspection JSUnresolvedReference
        htmx.location.reload(true);
        else loadHistoryFromServer(path);
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function addRequestIndicatorClasses(elt) {
        var indicators = /** @type Element[] */ findAttributeTargets(elt, 'hx-indicator');
        if (indicators == null) indicators = [
            elt
        ];
        forEach(indicators, function(ic) {
            var internalData = getInternalData(ic);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            ic.classList.add.call(ic.classList, htmx.config.requestClass);
        });
        return indicators;
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function disableElements(elt) {
        var disabledElts = /** @type Element[] */ findAttributeTargets(elt, 'hx-disabled-elt');
        if (disabledElts == null) disabledElts = [];
        forEach(disabledElts, function(disabledElement) {
            var internalData = getInternalData(disabledElement);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            disabledElement.setAttribute('disabled', '');
            disabledElement.setAttribute('data-disabled-by-htmx', '');
        });
        return disabledElts;
    }
    /**
   * @param {Element[]} indicators
   * @param {Element[]} disabled
   */ function removeRequestIndicators(indicators, disabled) {
        forEach(indicators.concat(disabled), function(ele) {
            var internalData = getInternalData(ele);
            internalData.requestCount = (internalData.requestCount || 1) - 1;
        });
        forEach(indicators, function(ic) {
            var internalData = getInternalData(ic);
            if (internalData.requestCount === 0) ic.classList.remove.call(ic.classList, htmx.config.requestClass);
        });
        forEach(disabled, function(disabledElement) {
            var internalData = getInternalData(disabledElement);
            if (internalData.requestCount === 0) {
                disabledElement.removeAttribute('disabled');
                disabledElement.removeAttribute('data-disabled-by-htmx');
            }
        });
    }
    //= ===================================================================
    // Input Value Processing
    //= ===================================================================
    /**
   * @param {Element[]} processed
   * @param {Element} elt
   * @returns {boolean}
   */ function haveSeenNode(processed, elt) {
        for(var i = 0; i < processed.length; i++){
            var node = processed[i];
            if (node.isSameNode(elt)) return true;
        }
        return false;
    }
    /**
   * @param {Element} element
   * @return {boolean}
   */ function shouldInclude(element) {
        // Cast to trick tsc, undefined values will work fine here
        var elt = /** @type {HTMLInputElement} */ element;
        if (elt.name === '' || elt.name == null || elt.disabled || closest(elt, 'fieldset[disabled]')) return false;
        // ignore "submitter" types (see jQuery src/serialize.js)
        if (elt.type === 'button' || elt.type === 'submit' || elt.tagName === 'image' || elt.tagName === 'reset' || elt.tagName === 'file') return false;
        if (elt.type === 'checkbox' || elt.type === 'radio') return elt.checked;
        return true;
    }
    /**
   * @param {string} name
   * @param {string|Array|FormDataEntryValue} value
   * @param {FormData} formData */ function addValueToFormData(name, value, formData) {
        if (name != null && value != null) {
            if (Array.isArray(value)) value.forEach(function(v) {
                formData.append(name, v);
            });
            else formData.append(name, value);
        }
    }
    /**
   * @param {string} name
   * @param {string|Array} value
   * @param {FormData} formData */ function removeValueFromFormData(name, value, formData) {
        if (name != null && value != null) {
            var values = formData.getAll(name);
            if (Array.isArray(value)) values = values.filter(function(v) {
                return value.indexOf(v) < 0;
            });
            else values = values.filter(function(v) {
                return v !== value;
            });
            formData.delete(name);
            forEach(values, function(v) {
                return formData.append(name, v);
            });
        }
    }
    /**
   * @param {Element} elt
   * @returns {string|Array}
   */ function getValueFromInput(elt) {
        if (elt instanceof HTMLSelectElement && elt.multiple) return toArray(elt.querySelectorAll('option:checked')).map(function(e) {
            return /** @type HTMLOptionElement */ e.value;
        });
        // include file inputs
        if (elt instanceof HTMLInputElement && elt.files) return toArray(elt.files);
        // @ts-ignore value will be undefined for non-input elements, which is fine
        return elt.value;
    }
    /**
   * @param {Element[]} processed
   * @param {FormData} formData
   * @param {HtmxElementValidationError[]} errors
   * @param {Element|HTMLInputElement|HTMLSelectElement|HTMLFormElement} elt
   * @param {boolean} validate
   */ function processInputValue(processed, formData, errors, elt, validate) {
        if (elt == null || haveSeenNode(processed, elt)) return;
        else processed.push(elt);
        if (shouldInclude(elt)) {
            var name = getRawAttribute(elt, 'name');
            addValueToFormData(name, getValueFromInput(elt), formData);
            if (validate) validateElement(elt, errors);
        }
        if (elt instanceof HTMLFormElement) {
            forEach(elt.elements, function(input) {
                if (processed.indexOf(input) >= 0) // The input has already been processed and added to the values, but the FormData that will be
                //  constructed right after on the form, will include it once again. So remove that input's value
                //  now to avoid duplicates
                removeValueFromFormData(input.name, getValueFromInput(input), formData);
                else processed.push(input);
                if (validate) validateElement(input, errors);
            });
            new FormData(elt).forEach(function(value, name) {
                if (value instanceof File && value.name === '') return; // ignore no-name files
                addValueToFormData(name, value, formData);
            });
        }
    }
    /**
   * @param {Element} elt
   * @param {HtmxElementValidationError[]} errors
   */ function validateElement(elt, errors) {
        var element = /** @type {HTMLElement & ElementInternals} */ elt;
        if (element.willValidate) {
            triggerEvent(element, 'htmx:validation:validate');
            if (!element.checkValidity()) {
                if (triggerEvent(element, 'htmx:validation:failed', {
                    message: element.validationMessage,
                    validity: element.validity
                }) && !errors.length && htmx.config.reportValidityOfForms) element.reportValidity();
                errors.push({
                    elt: element,
                    message: element.validationMessage,
                    validity: element.validity
                });
            }
        }
    }
    /**
   * Override values in the one FormData with those from another.
   * @param {FormData} receiver the formdata that will be mutated
   * @param {FormData} donor the formdata that will provide the overriding values
   * @returns {FormData} the {@linkcode receiver}
   */ function overrideFormData(receiver, donor) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = donor.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                receiver.delete(key);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        donor.forEach(function(value, key) {
            receiver.append(key, value);
        });
        return receiver;
    }
    /**
 * @param {Element|HTMLFormElement} elt
 * @param {HttpVerb} verb
 * @returns {{errors: HtmxElementValidationError[], formData: FormData, values: Object}}
 */ function getInputValues(elt, verb) {
        /** @type Element[] */ var processed = [];
        var formData = new FormData();
        var priorityFormData = new FormData();
        /** @type HtmxElementValidationError[] */ var errors = [];
        var internalData = getInternalData(elt);
        if (internalData.lastButtonClicked && !bodyContains(internalData.lastButtonClicked)) internalData.lastButtonClicked = null;
        // only validate when form is directly submitted and novalidate or formnovalidate are not set
        // or if the element has an explicit hx-validate="true" on it
        var validate = elt instanceof HTMLFormElement && elt.noValidate !== true || getAttributeValue(elt, 'hx-validate') === 'true';
        if (internalData.lastButtonClicked) validate = validate && internalData.lastButtonClicked.formNoValidate !== true;
        // for a non-GET include the related form, which may or may not be a parent element of elt
        if (verb !== 'get') processInputValue(processed, priorityFormData, errors, getRelatedForm(elt), validate);
        // include the element itself
        processInputValue(processed, formData, errors, elt, validate);
        // if a button or submit was clicked last, include its value
        if (internalData.lastButtonClicked || elt.tagName === 'BUTTON' || elt.tagName === 'INPUT' && getRawAttribute(elt, 'type') === 'submit') {
            var button = internalData.lastButtonClicked || /** @type HTMLInputElement|HTMLButtonElement */ elt;
            var name = getRawAttribute(button, 'name');
            addValueToFormData(name, button.value, priorityFormData);
        }
        // include any explicit includes
        var includes = findAttributeTargets(elt, 'hx-include');
        forEach(includes, function(node) {
            processInputValue(processed, formData, errors, asElement(node), validate);
            // if a non-form is included, include any input values within it
            if (!matches(node, 'form')) forEach(asParentNode(node).querySelectorAll(INPUT_SELECTOR), function(descendant) {
                processInputValue(processed, formData, errors, descendant, validate);
            });
        });
        // values from a <form> take precedence, overriding the regular values
        overrideFormData(formData, priorityFormData);
        return {
            errors: errors,
            formData: formData,
            values: formDataProxy(formData)
        };
    }
    /**
   * @param {string} returnStr
   * @param {string} name
   * @param {any} realValue
   * @returns {string}
   */ function appendParam(returnStr, name, realValue) {
        if (returnStr !== '') returnStr += '&';
        if (String(realValue) === '[object Object]') realValue = JSON.stringify(realValue);
        var s = encodeURIComponent(realValue);
        returnStr += encodeURIComponent(name) + '=' + s;
        return returnStr;
    }
    /**
   * @param {FormData|Object} values
   * @returns string
   */ function urlEncode(values) {
        values = formDataFromObject(values);
        var returnStr = '';
        values.forEach(function(value, key) {
            returnStr = appendParam(returnStr, key, value);
        });
        return returnStr;
    }
    //= ===================================================================
    // Ajax
    //= ===================================================================
    /**
 * @param {Element} elt
 * @param {Element} target
 * @param {string} prompt
 * @returns {HtmxHeaderSpecification}
 */ function getHeaders(elt, target, prompt1) {
        /** @type HtmxHeaderSpecification */ var headers = {
            'HX-Request': 'true',
            'HX-Trigger': getRawAttribute(elt, 'id'),
            'HX-Trigger-Name': getRawAttribute(elt, 'name'),
            'HX-Target': getAttributeValue(target, 'id'),
            'HX-Current-URL': location.href
        };
        getValuesForElement(elt, 'hx-headers', false, headers);
        if (prompt1 !== undefined) headers['HX-Prompt'] = prompt1;
        if (getInternalData(elt).boosted) headers['HX-Boosted'] = 'true';
        return headers;
    }
    /**
 * filterValues takes an object containing form input values
 * and returns a new object that only contains keys that are
 * specified by the closest "hx-params" attribute
 * @param {FormData} inputValues
 * @param {Element} elt
 * @returns {FormData}
 */ function filterValues(inputValues, elt) {
        var paramsValue = getClosestAttributeValue(elt, 'hx-params');
        if (paramsValue) {
            if (paramsValue === 'none') return new FormData();
            else if (paramsValue === '*') return inputValues;
            else if (paramsValue.indexOf('not ') === 0) {
                forEach(paramsValue.slice(4).split(','), function(name) {
                    name = name.trim();
                    inputValues.delete(name);
                });
                return inputValues;
            } else {
                var newValues = new FormData();
                forEach(paramsValue.split(','), function(name) {
                    name = name.trim();
                    if (inputValues.has(name)) inputValues.getAll(name).forEach(function(value) {
                        newValues.append(name, value);
                    });
                });
                return newValues;
            }
        } else return inputValues;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function isAnchorLink(elt) {
        return !!getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') >= 0;
    }
    /**
 * @param {Element} elt
 * @param {HtmxSwapStyle} [swapInfoOverride]
 * @returns {HtmxSwapSpecification}
 */ function getSwapSpecification(elt, swapInfoOverride) {
        var swapInfo = swapInfoOverride || getClosestAttributeValue(elt, 'hx-swap');
        /** @type HtmxSwapSpecification */ var swapSpec = {
            swapStyle: getInternalData(elt).boosted ? 'innerHTML' : htmx.config.defaultSwapStyle,
            swapDelay: htmx.config.defaultSwapDelay,
            settleDelay: htmx.config.defaultSettleDelay
        };
        if (htmx.config.scrollIntoViewOnBoost && getInternalData(elt).boosted && !isAnchorLink(elt)) swapSpec.show = 'top';
        if (swapInfo) {
            var split = splitOnWhitespace(swapInfo);
            if (split.length > 0) for(var i = 0; i < split.length; i++){
                var value = split[i];
                if (value.indexOf('swap:') === 0) swapSpec.swapDelay = parseInterval(value.slice(5));
                else if (value.indexOf('settle:') === 0) swapSpec.settleDelay = parseInterval(value.slice(7));
                else if (value.indexOf('transition:') === 0) swapSpec.transition = value.slice(11) === 'true';
                else if (value.indexOf('ignoreTitle:') === 0) swapSpec.ignoreTitle = value.slice(12) === 'true';
                else if (value.indexOf('scroll:') === 0) {
                    var scrollSpec = value.slice(7);
                    var splitSpec = scrollSpec.split(':');
                    var scrollVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    // @ts-ignore
                    swapSpec.scroll = scrollVal;
                    swapSpec.scrollTarget = selectorVal;
                } else if (value.indexOf('show:') === 0) {
                    var showSpec = value.slice(5);
                    var splitSpec = showSpec.split(':');
                    var showVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    swapSpec.show = showVal;
                    swapSpec.showTarget = selectorVal;
                } else if (value.indexOf('focus-scroll:') === 0) {
                    var focusScrollVal = value.slice(13);
                    swapSpec.focusScroll = focusScrollVal == 'true';
                } else if (i == 0) swapSpec.swapStyle = value;
                else logError('Unknown modifier in hx-swap: ' + value);
            }
        }
        return swapSpec;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function usesFormData(elt) {
        return getClosestAttributeValue(elt, 'hx-encoding') === 'multipart/form-data' || matches(elt, 'form') && getRawAttribute(elt, 'enctype') === 'multipart/form-data';
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {Element} elt
   * @param {FormData} filteredParameters
   * @returns {*|string|null}
   */ function encodeParamsForBody(xhr, elt, filteredParameters) {
        var encodedParameters = null;
        withExtensions(elt, function(extension) {
            if (encodedParameters == null) encodedParameters = extension.encodeParameters(xhr, filteredParameters, elt);
        });
        if (encodedParameters != null) return encodedParameters;
        else {
            if (usesFormData(elt)) // Force conversion to an actual FormData object in case filteredParameters is a formDataProxy
            // See https://github.com/bigskysoftware/htmx/issues/2317
            return overrideFormData(new FormData(), formDataFromObject(filteredParameters));
            else return urlEncode(filteredParameters);
        }
    }
    /**
 *
 * @param {Element} target
 * @returns {HtmxSettleInfo}
 */ function makeSettleInfo(target) {
        return {
            tasks: [],
            elts: [
                target
            ]
        };
    }
    /**
   * @param {Element[]} content
   * @param {HtmxSwapSpecification} swapSpec
   */ function updateScrollState(content, swapSpec) {
        var first = content[0];
        var last = content[content.length - 1];
        if (swapSpec.scroll) {
            var target = null;
            if (swapSpec.scrollTarget) target = asElement(querySelectorExt(first, swapSpec.scrollTarget));
            if (swapSpec.scroll === 'top' && (first || target)) {
                target = target || first;
                target.scrollTop = 0;
            }
            if (swapSpec.scroll === 'bottom' && (last || target)) {
                target = target || last;
                target.scrollTop = target.scrollHeight;
            }
            if (typeof swapSpec.scroll === 'number') getWindow().setTimeout(function() {
                window.scrollTo(0, /** @type number */ swapSpec.scroll);
            }, 0) // next 'tick', so browser has time to render layout
            ;
        }
        if (swapSpec.show) {
            var target = null;
            if (swapSpec.showTarget) {
                var targetStr = swapSpec.showTarget;
                if (swapSpec.showTarget === 'window') targetStr = 'body';
                target = asElement(querySelectorExt(first, targetStr));
            }
            if (swapSpec.show === 'top' && (first || target)) {
                target = target || first;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'start',
                    behavior: htmx.config.scrollBehavior
                });
            }
            if (swapSpec.show === 'bottom' && (last || target)) {
                target = target || last;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'end',
                    behavior: htmx.config.scrollBehavior
                });
            }
        }
    }
    /**
 * @param {Element} elt
 * @param {string} attr
 * @param {boolean=} evalAsDefault
 * @param {Object=} values
 * @param {Event=} event
 * @returns {Object}
 */ function getValuesForElement(elt, attr, evalAsDefault, values, event) {
        if (values == null) values = {};
        if (elt == null) return values;
        var attributeValue = getAttributeValue(elt, attr);
        if (attributeValue) {
            var str = attributeValue.trim();
            var evaluateValue = evalAsDefault;
            if (str === 'unset') return null;
            if (str.indexOf('javascript:') === 0) {
                str = str.slice(11);
                evaluateValue = true;
            } else if (str.indexOf('js:') === 0) {
                str = str.slice(3);
                evaluateValue = true;
            }
            if (str.indexOf('{') !== 0) str = '{' + str + '}';
            var varsValues;
            if (evaluateValue) varsValues = maybeEval(elt, function() {
                if (event) return Function('event', 'return (' + str + ')').call(elt, event);
                else return Function('return (' + str + ')').call(elt);
            }, {});
            else varsValues = parseJSON(str);
            for(var key in varsValues){
                if (varsValues.hasOwnProperty(key)) {
                    if (values[key] == null) values[key] = varsValues[key];
                }
            }
        }
        return getValuesForElement(asElement(parentElt(elt)), attr, evalAsDefault, values, event);
    }
    /**
   * @param {EventTarget|string} elt
   * @param {() => any} toEval
   * @param {any=} defaultVal
   * @returns {any}
   */ function maybeEval(elt, toEval, defaultVal) {
        if (htmx.config.allowEval) return toEval();
        else {
            triggerErrorEvent(elt, 'htmx:evalDisallowedError');
            return defaultVal;
        }
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXVarsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vars', true, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXValsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vals', false, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @returns {FormData}
 */ function getExpressionVars(elt, event) {
        return mergeObjects(getHXVarsForElement(elt, event), getHXValsForElement(elt, event));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {string|null} headerValue
   */ function safelySetHeaderValue(xhr, header, headerValue) {
        if (headerValue !== null) try {
            xhr.setRequestHeader(header, headerValue);
        } catch (e) {
            // On an exception, try to set the header URI encoded instead
            xhr.setRequestHeader(header, encodeURIComponent(headerValue));
            xhr.setRequestHeader(header + '-URI-AutoEncoded', 'true');
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {string}
   */ function getPathFromResponse(xhr) {
        if (xhr.responseURL) try {
            var url = new URL(xhr.responseURL);
            return url.pathname + url.search;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:badResponseUrl', {
                url: xhr.responseURL
            });
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {RegExp} regexp
   * @return {boolean}
   */ function hasHeader(xhr, regexp) {
        return regexp.test(xhr.getAllResponseHeaders());
    }
    /**
   * Issues an htmx-style AJAX request
   *
   * @see https://htmx.org/api/#ajax
   *
   * @param {HttpVerb} verb
   * @param {string} path the URL path to make the AJAX
   * @param {Element|string|HtmxAjaxHelperContext} context the element to target (defaults to the **body**) | a selector for the target | a context object that contains any of the following
   * @return {Promise<void>} Promise that resolves immediately if no request is sent, or when the request is complete
   */ function ajaxHelper(verb, path, context) {
        verb = /** @type HttpVerb */ verb.toLowerCase();
        if (context) {
            if (context instanceof Element || typeof context === 'string') return issueAjaxRequest(verb, path, null, null, {
                targetOverride: resolveTarget(context) || DUMMY_ELT,
                returnPromise: true
            });
            else {
                var resolvedTarget = resolveTarget(context.target);
                // If target is supplied but can't resolve OR source is supplied but both target and source can't be resolved
                // then use DUMMY_ELT to abort the request with htmx:targetError to avoid it replacing body by mistake
                if (context.target && !resolvedTarget || context.source && !resolvedTarget && !resolveTarget(context.source)) resolvedTarget = DUMMY_ELT;
                return issueAjaxRequest(verb, path, resolveTarget(context.source), context.event, {
                    handler: context.handler,
                    headers: context.headers,
                    values: context.values,
                    targetOverride: resolvedTarget,
                    swapOverride: context.swap,
                    select: context.select,
                    returnPromise: true,
                    push: context.push,
                    replace: context.replace,
                    selectOOB: context.selectOOB
                });
            }
        } else return issueAjaxRequest(verb, path, null, null, {
            returnPromise: true
        });
    }
    /**
   * @param {Element} elt
   * @return {Element[]}
   */ function hierarchyForElt(elt) {
        var arr = [];
        while(elt){
            arr.push(elt);
            elt = elt.parentElement;
        }
        return arr;
    }
    /**
   * @param {Element} elt
   * @param {string} path
   * @param {HtmxRequestConfig} requestConfig
   * @return {boolean}
   */ function verifyPath(elt, path, requestConfig) {
        var url = new URL(path, location.protocol !== 'about:' ? location.href : window.origin);
        var origin = location.protocol !== 'about:' ? location.origin : window.origin;
        var sameHost = origin === url.origin;
        if (htmx.config.selfRequestsOnly) {
            if (!sameHost) return false;
        }
        return triggerEvent(elt, 'htmx:validateUrl', mergeObjects({
            url: url,
            sameHost: sameHost
        }, requestConfig));
    }
    /**
   * @param {Object|FormData} obj
   * @return {FormData}
   */ function formDataFromObject(obj) {
        var _loop = function(key) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] && typeof obj[key].forEach === 'function') obj[key].forEach(function(v) {
                    formData.append(key, v);
                });
                else if ((0, $ewv1T._)(obj[key]) === 'object' && !(obj[key] instanceof Blob)) formData.append(key, JSON.stringify(obj[key]));
                else formData.append(key, obj[key]);
            }
        };
        if (obj instanceof FormData) return obj;
        var formData = new FormData();
        for(var key in obj)_loop(key);
        return formData;
    }
    /**
   * @param {FormData} formData
   * @param {string} name
   * @param {Array} array
   * @returns {Array}
   */ function formDataArrayProxy(formData, name, array) {
        // mutating the array should mutate the underlying form data
        return new Proxy(array, {
            get: function get(target, key) {
                if (typeof key === 'number') return target[key];
                if (key === 'length') return target.length;
                if (key === 'push') return function(value) {
                    target.push(value);
                    formData.append(name, value);
                };
                if (typeof target[key] === 'function') return function() {
                    target[key].apply(target, arguments);
                    formData.delete(name);
                    target.forEach(function(v) {
                        formData.append(name, v);
                    });
                };
                if (target[key] && target[key].length === 1) return target[key][0];
                else return target[key];
            },
            set: function set(target, index, value) {
                target[index] = value;
                formData.delete(name);
                target.forEach(function(v) {
                    formData.append(name, v);
                });
                return true;
            }
        });
    }
    /**
   * @param {FormData} formData
   * @returns {Object}
   */ function formDataProxy(formData) {
        return new Proxy(formData, {
            get: function get(target, name) {
                if ((typeof name === "undefined" ? "undefined" : (0, $ewv1T._)(name)) === 'symbol') {
                    // Forward symbol calls to the FormData itself directly
                    var result = Reflect.get(target, name);
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof result === 'function') return function() {
                        return result.apply(formData, arguments);
                    };
                    else return result;
                }
                if (name === 'toJSON') // Support JSON.stringify call on proxy
                return function() {
                    return Object.fromEntries(formData);
                };
                if (name in target) {
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof target[name] === 'function') return function() {
                        return formData[name].apply(formData, arguments);
                    };
                }
                var array = formData.getAll(name);
                // Those 2 undefined & single value returns are for retro-compatibility as we weren't using FormData before
                if (array.length === 0) return undefined;
                else if (array.length === 1) return array[0];
                else return formDataArrayProxy(target, name, array);
            },
            set: function set(target, name, value) {
                if (typeof name !== 'string') return false;
                target.delete(name);
                if (value && typeof value.forEach === 'function') value.forEach(function(v) {
                    target.append(name, v);
                });
                else if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === 'object' && !(value instanceof Blob)) target.append(name, JSON.stringify(value));
                else target.append(name, value);
                return true;
            },
            deleteProperty: function deleteProperty(target, name) {
                if (typeof name === 'string') target.delete(name);
                return true;
            },
            // Support Object.assign call from proxy
            ownKeys: function ownKeys(target) {
                return Reflect.ownKeys(Object.fromEntries(target));
            },
            getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, prop) {
                return Reflect.getOwnPropertyDescriptor(Object.fromEntries(target), prop);
            }
        });
    }
    /**
   * @param {HttpVerb} verb
   * @param {string} path
   * @param {Element} elt
   * @param {Event} event
   * @param {HtmxAjaxEtc} [etc]
   * @param {boolean} [confirmed]
   * @return {Promise<void>}
   */ function issueAjaxRequest(verb, path, elt, event, etc, confirmed) {
        var resolve = null;
        var reject = null;
        etc = etc != null ? etc : {};
        if (etc.returnPromise && typeof Promise !== 'undefined') var promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
        if (elt == null) elt = getDocument().body;
        var responseHandler = etc.handler || handleAjaxResponse;
        var select = etc.select || null;
        if (!bodyContains(elt)) {
            // do not issue requests for elements removed from the DOM
            maybeCall(resolve);
            return promise;
        }
        var target = etc.targetOverride || asElement(getTarget(elt));
        if (target == null || target == DUMMY_ELT) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: getClosestAttributeValue(elt, 'hx-target')
            });
            maybeCall(reject);
            return promise;
        }
        var eltData = getInternalData(elt);
        var submitter = eltData.lastButtonClicked;
        if (submitter) {
            var buttonPath = getRawAttribute(submitter, 'formaction');
            if (buttonPath != null) path = buttonPath;
            var buttonVerb = getRawAttribute(submitter, 'formmethod');
            if (buttonVerb != null) {
                if (VERBS.includes(buttonVerb.toLowerCase())) verb = /** @type HttpVerb */ buttonVerb;
                else {
                    maybeCall(resolve);
                    return promise;
                }
            }
        }
        var confirmQuestion = getClosestAttributeValue(elt, 'hx-confirm');
        // allow event-based confirmation w/ a callback
        if (confirmed === undefined) {
            var issueRequest = function issueRequest(skipConfirmation) {
                return issueAjaxRequest(verb, path, elt, event, etc, !!skipConfirmation);
            };
            var confirmDetails = {
                target: target,
                elt: elt,
                path: path,
                verb: verb,
                triggeringEvent: event,
                etc: etc,
                issueRequest: issueRequest,
                question: confirmQuestion
            };
            if (triggerEvent(elt, 'htmx:confirm', confirmDetails) === false) {
                maybeCall(resolve);
                return promise;
            }
        }
        var syncElt = elt;
        var syncStrategy = getClosestAttributeValue(elt, 'hx-sync');
        var queueStrategy = null;
        var abortable = false;
        if (syncStrategy) {
            var syncStrings = syncStrategy.split(':');
            var selector = syncStrings[0].trim();
            if (selector === 'this') syncElt = findThisElement(elt, 'hx-sync');
            else syncElt = asElement(querySelectorExt(elt, selector));
            // default to the drop strategy
            syncStrategy = (syncStrings[1] || 'drop').trim();
            eltData = getInternalData(syncElt);
            if (syncStrategy === 'drop' && eltData.xhr && eltData.abortable !== true) {
                maybeCall(resolve);
                return promise;
            } else if (syncStrategy === 'abort') {
                if (eltData.xhr) {
                    maybeCall(resolve);
                    return promise;
                } else abortable = true;
            } else if (syncStrategy === 'replace') triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else if (syncStrategy.indexOf('queue') === 0) {
                var queueStrArray = syncStrategy.split(' ');
                queueStrategy = (queueStrArray[1] || 'last').trim();
            }
        }
        if (eltData.xhr) {
            if (eltData.abortable) triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else {
                if (queueStrategy == null) {
                    if (event) {
                        var eventData = getInternalData(event);
                        if (eventData && eventData.triggerSpec && eventData.triggerSpec.queue) queueStrategy = eventData.triggerSpec.queue;
                    }
                    if (queueStrategy == null) queueStrategy = 'last';
                }
                if (eltData.queuedRequests == null) eltData.queuedRequests = [];
                if (queueStrategy === 'first' && eltData.queuedRequests.length === 0) eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'all') eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'last') {
                    eltData.queuedRequests = [] // dump existing queue
                    ;
                    eltData.queuedRequests.push(function() {
                        issueAjaxRequest(verb, path, elt, event, etc);
                    });
                }
                maybeCall(resolve);
                return promise;
            }
        }
        var xhr = new XMLHttpRequest();
        eltData.xhr = xhr;
        eltData.abortable = abortable;
        var endRequestLock = function endRequestLock() {
            eltData.xhr = null;
            eltData.abortable = false;
            if (eltData.queuedRequests != null && eltData.queuedRequests.length > 0) {
                var queuedRequest = eltData.queuedRequests.shift();
                queuedRequest();
            }
        };
        var promptQuestion = getClosestAttributeValue(elt, 'hx-prompt');
        if (promptQuestion) {
            var promptResponse = prompt(promptQuestion);
            // prompt returns null if cancelled and empty string if accepted with no entry
            if (promptResponse === null || !triggerEvent(elt, 'htmx:prompt', {
                prompt: promptResponse,
                target: target
            })) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        if (confirmQuestion && !confirmed) {
            if (!confirm(confirmQuestion)) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        var headers = getHeaders(elt, target, promptResponse);
        if (verb !== 'get' && !usesFormData(elt)) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (etc.headers) headers = mergeObjects(headers, etc.headers);
        var results = getInputValues(elt, verb);
        var errors = results.errors;
        var rawFormData = results.formData;
        if (etc.values) overrideFormData(rawFormData, formDataFromObject(etc.values));
        var expressionVars = formDataFromObject(getExpressionVars(elt, event));
        var allFormData = overrideFormData(rawFormData, expressionVars);
        var filteredFormData = filterValues(allFormData, elt);
        if (htmx.config.getCacheBusterParam && verb === 'get') filteredFormData.set('org.htmx.cache-buster', getRawAttribute(target, 'id') || 'true');
        // behavior of anchors w/ empty href is to use the current URL
        if (path == null || path === '') path = location.href;
        /**
     * @type {Object}
     * @property {boolean} [credentials]
     * @property {number} [timeout]
     * @property {boolean} [noHeaders]
     */ var requestAttrValues = getValuesForElement(elt, 'hx-request');
        var eltIsBoosted = getInternalData(elt).boosted;
        var useUrlParams = htmx.config.methodsThatUseUrlParams.indexOf(verb) >= 0;
        /** @type HtmxRequestConfig */ var requestConfig = {
            boosted: eltIsBoosted,
            useUrlParams: useUrlParams,
            formData: filteredFormData,
            parameters: formDataProxy(filteredFormData),
            unfilteredFormData: allFormData,
            unfilteredParameters: formDataProxy(allFormData),
            headers: headers,
            elt: elt,
            target: target,
            verb: verb,
            errors: errors,
            withCredentials: etc.credentials || requestAttrValues.credentials || htmx.config.withCredentials,
            timeout: etc.timeout || requestAttrValues.timeout || htmx.config.timeout,
            path: path,
            triggeringEvent: event
        };
        if (!triggerEvent(elt, 'htmx:configRequest', requestConfig)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        // copy out in case the object was overwritten
        path = requestConfig.path;
        verb = requestConfig.verb;
        headers = requestConfig.headers;
        filteredFormData = formDataFromObject(requestConfig.parameters);
        errors = requestConfig.errors;
        useUrlParams = requestConfig.useUrlParams;
        if (errors && errors.length > 0) {
            triggerEvent(elt, 'htmx:validation:halted', requestConfig);
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var splitPath = path.split('#');
        var pathNoAnchor = splitPath[0];
        var anchor = splitPath[1];
        var finalPath = path;
        if (useUrlParams) {
            finalPath = pathNoAnchor;
            var hasValues = !filteredFormData.keys().next().done;
            if (hasValues) {
                if (finalPath.indexOf('?') < 0) finalPath += '?';
                else finalPath += '&';
                finalPath += urlEncode(filteredFormData);
                if (anchor) finalPath += '#' + anchor;
            }
        }
        if (!verifyPath(elt, finalPath, requestConfig)) {
            triggerErrorEvent(elt, 'htmx:invalidPath', requestConfig);
            maybeCall(reject);
            endRequestLock();
            return promise;
        }
        xhr.open(verb.toUpperCase(), finalPath, true);
        xhr.overrideMimeType('text/html');
        xhr.withCredentials = requestConfig.withCredentials;
        xhr.timeout = requestConfig.timeout;
        // request headers
        if (requestAttrValues.noHeaders) ;
        else {
            for(var header in headers)if (headers.hasOwnProperty(header)) {
                var headerValue = headers[header];
                safelySetHeaderValue(xhr, header, headerValue);
            }
        }
        /** @type {HtmxResponseInfo} */ var responseInfo = {
            xhr: xhr,
            target: target,
            requestConfig: requestConfig,
            etc: etc,
            boosted: eltIsBoosted,
            select: select,
            pathInfo: {
                requestPath: path,
                finalRequestPath: finalPath,
                responsePath: null,
                anchor: anchor
            }
        };
        xhr.onload = function() {
            try {
                var hierarchy = hierarchyForElt(elt);
                responseInfo.pathInfo.responsePath = getPathFromResponse(xhr);
                responseHandler(elt, responseInfo);
                if (responseInfo.keepIndicators !== true) removeRequestIndicators(indicators, disableElts);
                triggerEvent(elt, 'htmx:afterRequest', responseInfo);
                triggerEvent(elt, 'htmx:afterOnLoad', responseInfo);
                // if the body no longer contains the element, trigger the event on the closest parent
                // remaining in the DOM
                if (!bodyContains(elt)) {
                    var secondaryTriggerElt = null;
                    while(hierarchy.length > 0 && secondaryTriggerElt == null){
                        var parentEltInHierarchy = hierarchy.shift();
                        if (bodyContains(parentEltInHierarchy)) secondaryTriggerElt = parentEltInHierarchy;
                    }
                    if (secondaryTriggerElt) {
                        triggerEvent(secondaryTriggerElt, 'htmx:afterRequest', responseInfo);
                        triggerEvent(secondaryTriggerElt, 'htmx:afterOnLoad', responseInfo);
                    }
                }
                maybeCall(resolve);
            } catch (e) {
                triggerErrorEvent(elt, 'htmx:onLoadError', mergeObjects({
                    error: e
                }, responseInfo));
                throw e;
            } finally{
                endRequestLock();
            }
        };
        xhr.onerror = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendError', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.onabort = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendAbort', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.ontimeout = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:timeout', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        if (!triggerEvent(elt, 'htmx:beforeRequest', responseInfo)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var indicators = addRequestIndicatorClasses(elt);
        var disableElts = disableElements(elt);
        forEach([
            'loadstart',
            'loadend',
            'progress',
            'abort'
        ], function(eventName) {
            forEach([
                xhr,
                xhr.upload
            ], function(target) {
                target.addEventListener(eventName, function(event) {
                    triggerEvent(elt, 'htmx:xhr:' + eventName, {
                        lengthComputable: event.lengthComputable,
                        loaded: event.loaded,
                        total: event.total
                    });
                });
            });
        });
        triggerEvent(elt, 'htmx:beforeSend', responseInfo);
        var params = useUrlParams ? null : encodeParamsForBody(xhr, elt, filteredFormData);
        xhr.send(params);
        return promise;
    }
    /**
   * @typedef {Object} HtmxHistoryUpdate
   * @property {string|null} [type]
   * @property {string|null} [path]
   */ /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   * @return {HtmxHistoryUpdate}
   */ function determineHistoryUpdates(elt, responseInfo) {
        var xhr = responseInfo.xhr;
        //= ==========================================
        // First consult response headers
        //= ==========================================
        var pathFromHeaders = null;
        var typeFromHeaders = null;
        if (hasHeader(xhr, /HX-Push:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Push-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push-Url');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Replace-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Replace-Url');
            typeFromHeaders = 'replace';
        }
        // if there was a response header, that has priority
        if (pathFromHeaders) {
            if (pathFromHeaders === 'false') return {};
            else return {
                type: typeFromHeaders,
                path: pathFromHeaders
            };
        }
        //= ==========================================
        // Next resolve via DOM values
        //= ==========================================
        var requestPath = responseInfo.pathInfo.finalRequestPath;
        var responsePath = responseInfo.pathInfo.responsePath;
        var pushUrl = responseInfo.etc.push || getClosestAttributeValue(elt, 'hx-push-url');
        var replaceUrl = responseInfo.etc.replace || getClosestAttributeValue(elt, 'hx-replace-url');
        var elementIsBoosted = getInternalData(elt).boosted;
        var saveType = null;
        var path = null;
        if (pushUrl) {
            saveType = 'push';
            path = pushUrl;
        } else if (replaceUrl) {
            saveType = 'replace';
            path = replaceUrl;
        } else if (elementIsBoosted) {
            saveType = 'push';
            path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
        }
        if (path) {
            // false indicates no push, return empty object
            if (path === 'false') return {};
            // true indicates we want to follow wherever the server ended up sending us
            if (path === 'true') path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
            // restore any anchor associated with the request
            if (responseInfo.pathInfo.anchor && path.indexOf('#') === -1) path = path + '#' + responseInfo.pathInfo.anchor;
            return {
                type: saveType,
                path: path
            };
        } else return {};
    }
    /**
   * @param {HtmxResponseHandlingConfig} responseHandlingConfig
   * @param {number} status
   * @return {boolean}
   */ function codeMatches(responseHandlingConfig, status) {
        var regExp = new RegExp(responseHandlingConfig.code);
        return regExp.test(status.toString(10));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {HtmxResponseHandlingConfig}
   */ function resolveResponseHandling(xhr) {
        for(var i = 0; i < htmx.config.responseHandling.length; i++){
            /** @type HtmxResponseHandlingConfig */ var responseHandlingElement = htmx.config.responseHandling[i];
            if (codeMatches(responseHandlingElement, xhr.status)) return responseHandlingElement;
        }
        // no matches, return no swap
        return {
            swap: false
        };
    }
    /**
   * @param {string} title
   */ function handleTitle(title) {
        if (title) {
            var titleElt = find('title');
            if (titleElt) titleElt.textContent = title;
            else window.document.title = title;
        }
    }
    /**
   * Resove the Retarget selector and throw if not found
   * @param {Element} elt
   * @param {String} target
   * @returns {Element}
   */ function resolveRetarget(elt, target) {
        if (target === 'this') return elt;
        var resolvedTarget = asElement(querySelectorExt(elt, target));
        if (resolvedTarget == null) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: target
            });
            throw new Error("Invalid re-target ".concat(target));
        }
        return resolvedTarget;
    }
    /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   */ function handleAjaxResponse(elt, responseInfo) {
        var xhr = responseInfo.xhr;
        var target = responseInfo.target;
        var etc = responseInfo.etc;
        var responseInfoSelect = responseInfo.select;
        if (!triggerEvent(elt, 'htmx:beforeOnLoad', responseInfo)) return;
        if (hasHeader(xhr, /HX-Trigger:/i)) handleTriggerHeader(xhr, 'HX-Trigger', elt);
        if (hasHeader(xhr, /HX-Location:/i)) {
            var redirectPath = xhr.getResponseHeader('HX-Location');
            /** @type {HtmxAjaxHelperContext&{path?:string}} */ var redirectSwapSpec = {};
            if (redirectPath.indexOf('{') === 0) {
                redirectSwapSpec = parseJSON(redirectPath);
                // what's the best way to throw an error if the user didn't include this
                redirectPath = redirectSwapSpec.path;
                delete redirectSwapSpec.path;
            }
            redirectSwapSpec.push = redirectSwapSpec.push || 'true';
            ajaxHelper('get', redirectPath, redirectSwapSpec);
            return;
        }
        var shouldRefresh = hasHeader(xhr, /HX-Refresh:/i) && xhr.getResponseHeader('HX-Refresh') === 'true';
        if (hasHeader(xhr, /HX-Redirect:/i)) {
            responseInfo.keepIndicators = true;
            htmx.location.href = xhr.getResponseHeader('HX-Redirect');
            shouldRefresh && htmx.location.reload();
            return;
        }
        if (shouldRefresh) {
            responseInfo.keepIndicators = true;
            htmx.location.reload();
            return;
        }
        var historyUpdate = determineHistoryUpdates(elt, responseInfo);
        var responseHandling = resolveResponseHandling(xhr);
        var shouldSwap = responseHandling.swap;
        var isError = !!responseHandling.error;
        var ignoreTitle = htmx.config.ignoreTitle || responseHandling.ignoreTitle;
        var selectOverride = responseHandling.select;
        if (responseHandling.target) responseInfo.target = resolveRetarget(elt, responseHandling.target);
        var swapOverride = etc.swapOverride;
        if (swapOverride == null && responseHandling.swapOverride) swapOverride = responseHandling.swapOverride;
        // response headers override response handling config
        if (hasHeader(xhr, /HX-Retarget:/i)) responseInfo.target = resolveRetarget(elt, xhr.getResponseHeader('HX-Retarget'));
        if (hasHeader(xhr, /HX-Reswap:/i)) swapOverride = xhr.getResponseHeader('HX-Reswap');
        var serverResponse = xhr.response;
        /** @type HtmxBeforeSwapDetails */ var beforeSwapDetails = mergeObjects({
            shouldSwap: shouldSwap,
            serverResponse: serverResponse,
            isError: isError,
            ignoreTitle: ignoreTitle,
            selectOverride: selectOverride,
            swapOverride: swapOverride
        }, responseInfo);
        if (responseHandling.event && !triggerEvent(target, responseHandling.event, beforeSwapDetails)) return;
        if (!triggerEvent(target, 'htmx:beforeSwap', beforeSwapDetails)) return;
        target = beforeSwapDetails.target // allow re-targeting
        ;
        serverResponse = beforeSwapDetails.serverResponse // allow updating content
        ;
        isError = beforeSwapDetails.isError // allow updating error
        ;
        ignoreTitle = beforeSwapDetails.ignoreTitle // allow updating ignoring title
        ;
        selectOverride = beforeSwapDetails.selectOverride // allow updating select override
        ;
        swapOverride = beforeSwapDetails.swapOverride // allow updating swap override
        ;
        responseInfo.target = target // Make updated target available to response events
        ;
        responseInfo.failed = isError // Make failed property available to response events
        ;
        responseInfo.successful = !isError // Make successful property available to response events
        ;
        if (beforeSwapDetails.shouldSwap) {
            if (xhr.status === 286) cancelPolling(elt);
            withExtensions(elt, function(extension) {
                serverResponse = extension.transformResponse(serverResponse, xhr, elt);
            });
            // Save current page if there will be a history update
            if (historyUpdate.type) saveCurrentPageToHistory();
            var swapSpec = getSwapSpecification(elt, swapOverride);
            if (!swapSpec.hasOwnProperty('ignoreTitle')) swapSpec.ignoreTitle = ignoreTitle;
            target.classList.add(htmx.config.swappingClass);
            if (responseInfoSelect) selectOverride = responseInfoSelect;
            if (hasHeader(xhr, /HX-Reselect:/i)) selectOverride = xhr.getResponseHeader('HX-Reselect');
            var selectOOB = etc.selectOOB || getClosestAttributeValue(elt, 'hx-select-oob');
            var select = getClosestAttributeValue(elt, 'hx-select');
            swap(target, serverResponse, swapSpec, {
                select: selectOverride === 'unset' ? null : selectOverride || select,
                selectOOB: selectOOB,
                eventInfo: responseInfo,
                anchor: responseInfo.pathInfo.anchor,
                contextElement: elt,
                afterSwapCallback: function afterSwapCallback() {
                    if (hasHeader(xhr, /HX-Trigger-After-Swap:/i)) {
                        var finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Swap', finalElt);
                    }
                },
                afterSettleCallback: function afterSettleCallback() {
                    if (hasHeader(xhr, /HX-Trigger-After-Settle:/i)) {
                        var finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Settle', finalElt);
                    }
                },
                beforeSwapCallback: function beforeSwapCallback() {
                    // if we need to save history, do so, before swapping so that relative resources have the correct base URL
                    if (historyUpdate.type) {
                        triggerEvent(getDocument().body, 'htmx:beforeHistoryUpdate', mergeObjects({
                            history: historyUpdate
                        }, responseInfo));
                        if (historyUpdate.type === 'push') {
                            pushUrlIntoHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:pushedIntoHistory', {
                                path: historyUpdate.path
                            });
                        } else {
                            replaceUrlInHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:replacedInHistory', {
                                path: historyUpdate.path
                            });
                        }
                    }
                }
            });
        }
        if (isError) triggerErrorEvent(elt, 'htmx:responseError', mergeObjects({
            error: 'Response Status Error Code ' + xhr.status + ' from ' + responseInfo.pathInfo.requestPath
        }, responseInfo));
    }
    //= ===================================================================
    // Extensions API
    //= ===================================================================
    /** @type {Object<string, HtmxExtension>} */ var extensions = {};
    /**
   * extensionBase defines the default functions for all extensions.
   * @returns {HtmxExtension}
   */ function extensionBase() {
        return {
            init: function init(api) {
                return null;
            },
            getSelectors: function getSelectors() {
                return null;
            },
            onEvent: function onEvent(name, evt) {
                return true;
            },
            transformResponse: function transformResponse(text, xhr, elt) {
                return text;
            },
            isInlineSwap: function isInlineSwap(swapStyle) {
                return false;
            },
            handleSwap: function handleSwap(swapStyle, target, fragment, settleInfo) {
                return false;
            },
            encodeParameters: function encodeParameters(xhr, parameters, elt) {
                return null;
            }
        };
    }
    /**
   * defineExtension initializes the extension and adds it to the htmx registry
   *
   * @see https://htmx.org/api/#defineExtension
   *
   * @param {string} name the extension name
   * @param {Partial<HtmxExtension>} extension the extension definition
   */ function defineExtension(name, extension) {
        if (extension.init) extension.init(internalAPI);
        extensions[name] = mergeObjects(extensionBase(), extension);
    }
    /**
   * removeExtension removes an extension from the htmx registry
   *
   * @see https://htmx.org/api/#removeExtension
   *
   * @param {string} name
   */ function removeExtension(name) {
        delete extensions[name];
    }
    /**
   * getExtensions searches up the DOM tree to return all extensions that can be applied to a given element
   *
   * @param {Element} elt
   * @param {HtmxExtension[]=} extensionsToReturn
   * @param {string[]=} extensionsToIgnore
   * @returns {HtmxExtension[]}
   */ function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
        if (extensionsToReturn == undefined) extensionsToReturn = [];
        if (elt == undefined) return extensionsToReturn;
        if (extensionsToIgnore == undefined) extensionsToIgnore = [];
        var extensionsForElement = getAttributeValue(elt, 'hx-ext');
        if (extensionsForElement) forEach(extensionsForElement.split(','), function(extensionName) {
            extensionName = extensionName.replace(/ /g, '');
            if (extensionName.slice(0, 7) == 'ignore:') {
                extensionsToIgnore.push(extensionName.slice(7));
                return;
            }
            if (extensionsToIgnore.indexOf(extensionName) < 0) {
                var extension = extensions[extensionName];
                if (extension && extensionsToReturn.indexOf(extension) < 0) extensionsToReturn.push(extension);
            }
        });
        return getExtensions(asElement(parentElt(elt)), extensionsToReturn, extensionsToIgnore);
    }
    //= ===================================================================
    // Initialization
    //= ===================================================================
    var isReady = false;
    getDocument().addEventListener('DOMContentLoaded', function() {
        isReady = true;
    });
    /**
   * Execute a function now if DOMContentLoaded has fired, otherwise listen for it.
   *
   * This function uses isReady because there is no reliable way to ask the browser whether
   * the DOMContentLoaded event has already been fired; there's a gap between DOMContentLoaded
   * firing and readystate=complete.
   */ function ready(fn) {
        // Checking readyState here is a failsafe in case the htmx script tag entered the DOM by
        // some means other than the initial page load.
        if (isReady || getDocument().readyState === 'complete') fn();
        else getDocument().addEventListener('DOMContentLoaded', fn);
    }
    function insertIndicatorStyles() {
        if (htmx.config.includeIndicatorStyles !== false) {
            var nonceAttribute = htmx.config.inlineStyleNonce ? ' nonce="'.concat(htmx.config.inlineStyleNonce, '"') : '';
            var indicator = htmx.config.indicatorClass;
            var request = htmx.config.requestClass;
            getDocument().head.insertAdjacentHTML('beforeend', "<style".concat(nonceAttribute, ">") + ".".concat(indicator, "{opacity:0;visibility: hidden} ") + ".".concat(request, " .").concat(indicator, ", .").concat(request, ".").concat(indicator, "{opacity:1;visibility: visible;transition: opacity 200ms ease-in}") + '</style>');
        }
    }
    function getMetaConfig() {
        /** @type HTMLMetaElement */ var element = getDocument().querySelector('meta[name="htmx-config"]');
        if (element) return parseJSON(element.content);
        else return null;
    }
    function mergeMetaConfig() {
        var metaConfig = getMetaConfig();
        if (metaConfig) htmx.config = mergeObjects(htmx.config, metaConfig);
    }
    // initialize the document
    ready(function() {
        mergeMetaConfig();
        insertIndicatorStyles();
        var body = getDocument().body;
        processNode(body);
        var restoredElts = getDocument().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
        body.addEventListener('htmx:abort', function(evt) {
            var target = /** @type {CustomEvent} */ evt.detail.elt || evt.target;
            var internalData = getInternalData(target);
            if (internalData && internalData.xhr) internalData.xhr.abort();
        });
        /** @type {(ev: PopStateEvent) => any} */ var originalPopstate = window.onpopstate ? window.onpopstate.bind(window) : null;
        /** @type {(ev: PopStateEvent) => any} */ window.onpopstate = function(event) {
            if (event.state && event.state.htmx) {
                restoreHistory();
                forEach(restoredElts, function(elt) {
                    triggerEvent(elt, 'htmx:restored', {
                        document: getDocument(),
                        triggerEvent: triggerEvent
                    });
                });
            } else if (originalPopstate) originalPopstate(event);
        };
        getWindow().setTimeout(function() {
            triggerEvent(body, 'htmx:load', {}) // give ready handlers a chance to load up before firing this event
            ;
            body = null // kill reference for gc
            ;
        }, 0);
    });
    return htmx;
}();
var /** @typedef {'get'|'head'|'post'|'put'|'delete'|'connect'|'options'|'trace'|'patch'} HttpVerb */ /**
 * @typedef {Object} SwapOptions
 * @property {string} [select]
 * @property {string} [selectOOB]
 * @property {*} [eventInfo]
 * @property {string} [anchor]
 * @property {Element} [contextElement]
 * @property {swapCallback} [afterSwapCallback]
 * @property {swapCallback} [afterSettleCallback]
 * @property {swapCallback} [beforeSwapCallback]
 * @property {string} [title]
 * @property {boolean} [historyRequest]
 */ /**
 * @callback swapCallback
 */ /**
 * @typedef {'innerHTML' | 'outerHTML' | 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' | 'delete' | 'none' | string} HtmxSwapStyle
 */ /**
 * @typedef HtmxSwapSpecification
 * @property {HtmxSwapStyle} swapStyle
 * @property {number} swapDelay
 * @property {number} settleDelay
 * @property {boolean} [transition]
 * @property {boolean} [ignoreTitle]
 * @property {string} [head]
 * @property {'top' | 'bottom' | number } [scroll]
 * @property {string} [scrollTarget]
 * @property {string} [show]
 * @property {string} [showTarget]
 * @property {boolean} [focusScroll]
 */ /**
 * @typedef {((this:Node, evt:Event) => boolean) & {source: string}} ConditionalFunction
 */ /**
 * @typedef {Object} HtmxTriggerSpecification
 * @property {string} trigger
 * @property {number} [pollInterval]
 * @property {ConditionalFunction} [eventFilter]
 * @property {boolean} [changed]
 * @property {boolean} [once]
 * @property {boolean} [consume]
 * @property {number} [delay]
 * @property {string} [from]
 * @property {string} [target]
 * @property {number} [throttle]
 * @property {string} [queue]
 * @property {string} [root]
 * @property {string} [threshold]
 */ /**
 * @typedef {{elt: Element, message: string, validity: ValidityState}} HtmxElementValidationError
 */ /**
 * @typedef {Record<string, string>} HtmxHeaderSpecification
 * @property {'true'} HX-Request
 * @property {string|null} HX-Trigger
 * @property {string|null} HX-Trigger-Name
 * @property {string|null} HX-Target
 * @property {string} HX-Current-URL
 * @property {string} [HX-Prompt]
 * @property {'true'} [HX-Boosted]
 * @property {string} [Content-Type]
 * @property {'true'} [HX-History-Restore-Request]
 */ /**
 * @typedef HtmxAjaxHelperContext
 * @property {Element|string} [source]
 * @property {Event} [event]
 * @property {HtmxAjaxHandler} [handler]
 * @property {Element|string} [target]
 * @property {HtmxSwapStyle} [swap]
 * @property {Object|FormData} [values]
 * @property {Record<string,string>} [headers]
 * @property {string} [select]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxRequestConfig
 * @property {boolean} boosted
 * @property {boolean} useUrlParams
 * @property {FormData} formData
 * @property {Object} parameters formData proxy
 * @property {FormData} unfilteredFormData
 * @property {Object} unfilteredParameters unfilteredFormData proxy
 * @property {HtmxHeaderSpecification} headers
 * @property {Element} elt
 * @property {Element} target
 * @property {HttpVerb} verb
 * @property {HtmxElementValidationError[]} errors
 * @property {boolean} withCredentials
 * @property {number} timeout
 * @property {string} path
 * @property {Event} triggeringEvent
 */ /**
 * @typedef {Object} HtmxResponseInfo
 * @property {XMLHttpRequest} xhr
 * @property {Element} target
 * @property {HtmxRequestConfig} requestConfig
 * @property {HtmxAjaxEtc} etc
 * @property {boolean} boosted
 * @property {string} select
 * @property {{requestPath: string, finalRequestPath: string, responsePath: string|null, anchor: string}} pathInfo
 * @property {boolean} [failed]
 * @property {boolean} [successful]
 * @property {boolean} [keepIndicators]
 */ /**
 * @typedef {Object} HtmxAjaxEtc
 * @property {boolean} [returnPromise]
 * @property {HtmxAjaxHandler} [handler]
 * @property {string} [select]
 * @property {Element} [targetOverride]
 * @property {HtmxSwapStyle} [swapOverride]
 * @property {Record<string,string>} [headers]
 * @property {Object|FormData} [values]
 * @property {boolean} [credentials]
 * @property {number} [timeout]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxResponseHandlingConfig
 * @property {string} [code]
 * @property {boolean} swap
 * @property {boolean} [error]
 * @property {boolean} [ignoreTitle]
 * @property {string} [select]
 * @property {string} [target]
 * @property {string} [swapOverride]
 * @property {string} [event]
 */ /**
 * @typedef {HtmxResponseInfo & {shouldSwap: boolean, serverResponse: any, isError: boolean, ignoreTitle: boolean, selectOverride:string, swapOverride:string}} HtmxBeforeSwapDetails
 */ /**
 * @callback HtmxAjaxHandler
 * @param {Element} elt
 * @param {HtmxResponseInfo} responseInfo
 */ /**
 * @typedef {(() => void)} HtmxSettleTask
 */ /**
 * @typedef {Object} HtmxSettleInfo
 * @property {HtmxSettleTask[]} tasks
 * @property {Element[]} elts
 * @property {string} [title]
 */ /**
 * @see https://github.com/bigskysoftware/htmx-extensions/blob/main/README.md
 * @typedef {Object} HtmxExtension
 * @property {(api: any) => void} init
 * @property {(name: string, event: CustomEvent) => boolean} onEvent
 * @property {(text: string, xhr: XMLHttpRequest, elt: Element) => string} transformResponse
 * @property {(swapStyle: HtmxSwapStyle) => boolean} isInlineSwap
 * @property {(swapStyle: HtmxSwapStyle, target: Node, fragment: Node, settleInfo: HtmxSettleInfo) => boolean|Node[]} handleSwap
 * @property {(xhr: XMLHttpRequest, parameters: FormData, elt: Node) => *|string|null} encodeParameters
 * @property {() => string[]|null} getSelectors
 */ $395720456d44d816$export$2e2bcd8739ae039 = htmx;

});
parcelRegister("kNmtb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f239d049aca4226d$export$71511d61b312f219; });

var $f0Tta = parcelRequire("f0Tta");

var $eTFtC = parcelRequire("eTFtC");

var $fGBkt = parcelRequire("fGBkt");

var $c0Zyh = parcelRequire("c0Zyh");
function $f239d049aca4226d$export$71511d61b312f219(arr) {
    return (0, $f0Tta._)(arr) || (0, $eTFtC._)(arr) || (0, $c0Zyh._)(arr) || (0, $fGBkt._)();
}

});
parcelRegister("f0Tta", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $aee1e22cafb6ae46$export$71511d61b312f219; });

var $eNMON = parcelRequire("eNMON");
function $aee1e22cafb6ae46$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $eNMON._)(arr);
}

});
parcelRegister("eNMON", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ac6b829ce2db73d5$export$71511d61b312f219; });
function $ac6b829ce2db73d5$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("eTFtC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad86602b90b8bac6$export$71511d61b312f219; });
function $ad86602b90b8bac6$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("fGBkt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b6b7bc126ea23811$export$71511d61b312f219; });
function $b6b7bc126ea23811$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("c0Zyh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8bf53b0ec37d9e41$export$71511d61b312f219; });

var $eNMON = parcelRequire("eNMON");
function $8bf53b0ec37d9e41$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $eNMON._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $eNMON._)(o, minLen);
}

});



parcelRegister("jIak6", function(module, exports) {

$parcel$export(module.exports, "Chart", function () { return Chart; });
$parcel$export(module.exports, "ArcElement", function () { return ArcElement; });
$parcel$export(module.exports, "PointElement", function () { return PointElement; });
$parcel$export(module.exports, "BarElement", function () { return BarElement; });
$parcel$export(module.exports, "registerables", function () { return registerables; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("3zT2Z")).d; });
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $ctUVE = parcelRequire("ctUVE");

var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $6lD0P = parcelRequire("6lD0P");

var $9rJIv = parcelRequire("9rJIv");

var $2HbS2 = parcelRequire("2HbS2");

var $dqNF0 = parcelRequire("dqNF0");

var $8lZHN = parcelRequire("8lZHN");

var $3K9Jy = parcelRequire("3K9Jy");

var $esDIr = parcelRequire("esDIr");

var $kNmtb = parcelRequire("kNmtb");

var $ewv1T = parcelRequire("ewv1T");

var $6brDd = parcelRequire("6brDd");

var $3zT2Z = parcelRequire("3zT2Z");

var Animator = /*#__PURE__*/ function() {
    "use strict";
    function Animator() {
        (0, $ioD88._)(this, Animator);
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    (0, $6NCFa._)(Animator, [
        {
            key: "_notify",
            value: function _notify(chart, anims, date, type) {
                var callbacks = anims.listeners[type];
                var numSteps = anims.duration;
                callbacks.forEach(function(fn) {
                    return fn({
                        chart: chart,
                        initial: anims.initial,
                        numSteps: numSteps,
                        currentStep: Math.min(date - anims.start, numSteps)
                    });
                });
            }
        },
        {
            key: "_refresh",
            value: function _refresh() {
                var _this = this;
                if (this._request) return;
                this._running = true;
                this._request = (0, $3zT2Z.r).call(window, function() {
                    _this._update();
                    _this._request = null;
                    if (_this._running) _this._refresh();
                });
            }
        },
        {
            key: "_update",
            value: function _update() {
                var _this = this;
                var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                var remaining = 0;
                this._charts.forEach(function(anims, chart) {
                    if (!anims.running || !anims.items.length) return;
                    var items = anims.items;
                    var i = items.length - 1;
                    var draw = false;
                    var item;
                    for(; i >= 0; --i){
                        item = items[i];
                        if (item._active) {
                            if (item._total > anims.duration) anims.duration = item._total;
                            item.tick(date);
                            draw = true;
                        } else {
                            items[i] = items[items.length - 1];
                            items.pop();
                        }
                    }
                    if (draw) {
                        chart.draw();
                        _this._notify(chart, anims, date, 'progress');
                    }
                    if (!items.length) {
                        anims.running = false;
                        _this._notify(chart, anims, date, 'complete');
                        anims.initial = false;
                    }
                    remaining += items.length;
                });
                this._lastDate = date;
                if (remaining === 0) this._running = false;
            }
        },
        {
            key: "_getAnims",
            value: function _getAnims(chart) {
                var charts = this._charts;
                var anims = charts.get(chart);
                if (!anims) {
                    anims = {
                        running: false,
                        initial: true,
                        items: [],
                        listeners: {
                            complete: [],
                            progress: []
                        }
                    };
                    charts.set(chart, anims);
                }
                return anims;
            }
        },
        {
            key: "listen",
            value: function listen(chart, event, cb) {
                this._getAnims(chart).listeners[event].push(cb);
            }
        },
        {
            key: "add",
            value: function add(chart, items) {
                var _this__getAnims_items;
                if (!items || !items.length) return;
                (_this__getAnims_items = this._getAnims(chart).items).push.apply(_this__getAnims_items, (0, $kNmtb._)(items));
            }
        },
        {
            key: "has",
            value: function has(chart) {
                return this._getAnims(chart).items.length > 0;
            }
        },
        {
            key: "start",
            value: function start(chart) {
                var anims = this._charts.get(chart);
                if (!anims) return;
                anims.running = true;
                anims.start = Date.now();
                anims.duration = anims.items.reduce(function(acc, cur) {
                    return Math.max(acc, cur._duration);
                }, 0);
                this._refresh();
            }
        },
        {
            key: "running",
            value: function running(chart) {
                if (!this._running) return false;
                var anims = this._charts.get(chart);
                if (!anims || !anims.running || !anims.items.length) return false;
                return true;
            }
        },
        {
            key: "stop",
            value: function stop(chart) {
                var anims = this._charts.get(chart);
                if (!anims || !anims.items.length) return;
                var items = anims.items;
                var i = items.length - 1;
                for(; i >= 0; --i)items[i].cancel();
                anims.items = [];
                this._notify(chart, anims, Date.now(), 'complete');
            }
        },
        {
            key: "remove",
            value: function remove(chart) {
                return this._charts.delete(chart);
            }
        }
    ]);
    return Animator;
}();
var animator = /* #__PURE__ */ new Animator();
var transparent = 'transparent';
var interpolators = {
    boolean: function(from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color: function(from, to, factor) {
        var c0 = (0, $3zT2Z.c)(from || transparent);
        var c1 = c0.valid && (0, $3zT2Z.c)(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number: function(from, to, factor) {
        return from + (to - from) * factor;
    }
};
var Animation = /*#__PURE__*/ function() {
    "use strict";
    function Animation(cfg, target, prop, to) {
        (0, $ioD88._)(this, Animation);
        var currentValue = target[prop];
        to = (0, $3zT2Z.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        var from = (0, $3zT2Z.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || (typeof from === "undefined" ? "undefined" : (0, $ewv1T._)(from))];
        this._easing = (0, $3zT2Z.e)[cfg.easing] || (0, $3zT2Z.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    (0, $6NCFa._)(Animation, [
        {
            key: "active",
            value: function active() {
                return this._active;
            }
        },
        {
            key: "update",
            value: function update(cfg, to, date) {
                if (this._active) {
                    this._notify(false);
                    var currentValue = this._target[this._prop];
                    var elapsed = date - this._start;
                    var remain = this._duration - elapsed;
                    this._start = date;
                    this._duration = Math.floor(Math.max(remain, cfg.duration));
                    this._total += elapsed;
                    this._loop = !!cfg.loop;
                    this._to = (0, $3zT2Z.a)([
                        cfg.to,
                        to,
                        currentValue,
                        cfg.from
                    ]);
                    this._from = (0, $3zT2Z.a)([
                        cfg.from,
                        currentValue,
                        to
                    ]);
                }
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this._active) {
                    this.tick(Date.now());
                    this._active = false;
                    this._notify(false);
                }
            }
        },
        {
            key: "tick",
            value: function tick(date) {
                var elapsed = date - this._start;
                var duration = this._duration;
                var prop = this._prop;
                var from = this._from;
                var loop = this._loop;
                var to = this._to;
                var factor;
                this._active = from !== to && (loop || elapsed < duration);
                if (!this._active) {
                    this._target[prop] = to;
                    this._notify(true);
                    return;
                }
                if (elapsed < 0) {
                    this._target[prop] = from;
                    return;
                }
                factor = elapsed / duration % 2;
                factor = loop && factor > 1 ? 2 - factor : factor;
                factor = this._easing(Math.min(1, Math.max(0, factor)));
                this._target[prop] = this._fn(from, to, factor);
            }
        },
        {
            key: "wait",
            value: function wait() {
                var promises = this._promises || (this._promises = []);
                return new Promise(function(res, rej) {
                    promises.push({
                        res: res,
                        rej: rej
                    });
                });
            }
        },
        {
            key: "_notify",
            value: function _notify(resolved) {
                var method = resolved ? 'res' : 'rej';
                var promises = this._promises || [];
                for(var i = 0; i < promises.length; i++)promises[i][method]();
            }
        }
    ]);
    return Animation;
}();
var Animations = /*#__PURE__*/ function() {
    "use strict";
    function Animations(chart, config) {
        (0, $ioD88._)(this, Animations);
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    (0, $6NCFa._)(Animations, [
        {
            key: "configure",
            value: function configure(config) {
                if (!(0, $3zT2Z.i)(config)) return;
                var animationOptions = Object.keys((0, $3zT2Z.d).animation);
                var animatedProps = this._properties;
                Object.getOwnPropertyNames(config).forEach(function(key) {
                    var cfg = config[key];
                    if (!(0, $3zT2Z.i)(cfg)) return;
                    var resolved = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = animationOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var option = _step.value;
                            resolved[option] = cfg[option];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    ((0, $3zT2Z.b)(cfg.properties) && cfg.properties || [
                        key
                    ]).forEach(function(prop) {
                        if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
                    });
                });
            }
        },
        {
            key: "_animateOptions",
            value: function _animateOptions(target, values) {
                var newOptions = values.options;
                var options = resolveTargetOptions(target, newOptions);
                if (!options) return [];
                var animations = this._createAnimations(options, newOptions);
                if (newOptions.$shared) awaitAll(target.options.$animations, newOptions).then(function() {
                    target.options = newOptions;
                }, function() {});
                return animations;
            }
        },
        {
            key: "_createAnimations",
            value: function _createAnimations(target, values) {
                var animatedProps = this._properties;
                var animations = [];
                var running = target.$animations || (target.$animations = {});
                var props = Object.keys(values);
                var date = Date.now();
                var i;
                for(i = props.length - 1; i >= 0; --i){
                    var prop = props[i];
                    if (prop.charAt(0) === '$') continue;
                    if (prop === 'options') {
                        var _animations;
                        (_animations = animations).push.apply(_animations, (0, $kNmtb._)(this._animateOptions(target, values)));
                        continue;
                    }
                    var value = values[prop];
                    var animation = running[prop];
                    var cfg = animatedProps.get(prop);
                    if (animation) {
                        if (cfg && animation.active()) {
                            animation.update(cfg, value, date);
                            continue;
                        } else animation.cancel();
                    }
                    if (!cfg || !cfg.duration) {
                        target[prop] = value;
                        continue;
                    }
                    running[prop] = animation = new Animation(cfg, target, prop, value);
                    animations.push(animation);
                }
                return animations;
            }
        },
        {
            key: "update",
            value: function update(target, values) {
                if (this._properties.size === 0) {
                    Object.assign(target, values);
                    return;
                }
                var animations = this._createAnimations(target, values);
                if (animations.length) {
                    animator.add(this._chart, animations);
                    return true;
                }
            }
        }
    ]);
    return Animations;
}();
function awaitAll(animations, properties) {
    var running = [];
    var keys = Object.keys(properties);
    for(var i = 0; i < keys.length; i++){
        var anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    var options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function scaleClip(scale, allowedOverflow) {
    var opts = scale && scale.options || {};
    var reverse = opts.reverse;
    var min = opts.min === undefined ? allowedOverflow : 0;
    var max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    var x = scaleClip(xScale, allowedOverflow);
    var y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    var t, r, b, l;
    if ((0, $3zT2Z.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    var keys = [];
    var metasets = chart._getSortedDatasetMetas(filterVisible);
    var i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function applyStack(stack, value, dsIndex) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var keys = stack.keys;
    var singleMode = options.mode === 'single';
    var i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    var found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $3zT2Z.g)(otherValue) && (singleMode || value === 0 || (0, $3zT2Z.s)(value) === (0, $3zT2Z.s)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function convertObjectDataToArray(data, meta) {
    var iScale = meta.iScale, vScale = meta.vScale;
    var iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    var vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    var keys = Object.keys(data);
    var adata = new Array(keys.length);
    var i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        var _obj;
        adata[i] = (_obj = {}, (0, $6lD0P._)(_obj, iAxisKey, key), (0, $6lD0P._)(_obj, vAxisKey, data[key]), _obj);
    }
    return adata;
}
function isStacked(scale, meta) {
    var stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return "".concat(indexScale.id, ".").concat(valueScale.id, ".").concat(meta.stack || meta.type);
}
function getUserBounds(scale) {
    var _scale_getUserBounds = scale.getUserBounds(), min = _scale_getUserBounds.min, max = _scale_getUserBounds.max, minDefined = _scale_getUserBounds.minDefined, maxDefined = _scale_getUserBounds.maxDefined;
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    var subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = vScale.getMatchingVisibleMetas(type).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var meta = _step.value;
            var value = stack[meta.index];
            if (positive && value > 0 || !positive && value < 0) return meta.index;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function updateStacks(controller, parsed) {
    var chart = controller.chart, meta = controller._cachedMeta;
    var stacks = chart._stacks || (chart._stacks = {});
    var iScale = meta.iScale, vScale = meta.vScale, datasetIndex = meta.index;
    var iAxis = iScale.axis;
    var vAxis = vScale.axis;
    var key = getStackKey(iScale, vScale, meta);
    var ilen = parsed.length;
    var stack;
    for(var i = 0; i < ilen; ++i){
        var item = parsed[i];
        var index = item[iAxis], value = item[vAxis];
        var itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        var visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    var scales = chart.scales;
    return Object.keys(scales).filter(function(key) {
        return scales[key].axis === axis;
    }).shift();
}
function createDatasetContext(parent, index) {
    return (0, $3zT2Z.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function createDataContext(parent, index, element) {
    return (0, $3zT2Z.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function clearStacks(meta, items) {
    var datasetIndex = meta.controller.index;
    var axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var parsed = _step.value;
            var stacks = parsed._stacks;
            if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
            delete stacks[axis][datasetIndex];
            if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var isDirectUpdateMode = function(mode) {
    return mode === 'reset' || mode === 'none';
};
var cloneIfNotShared = function(cached, shared) {
    return shared ? cached : Object.assign({}, cached);
};
var createStack = function(canStack, meta, chart) {
    return canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
};
var DatasetController = /*#__PURE__*/ function _target() {
    "use strict";
    function DatasetController(chart, datasetIndex) {
        (0, $ioD88._)(this, DatasetController);
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = (this instanceof DatasetController ? this.constructor : void 0).datasetElementType;
        this.dataElementType = (this instanceof DatasetController ? this.constructor : void 0).dataElementType;
        this.initialize();
    }
    (0, $6NCFa._)(DatasetController, [
        {
            key: "initialize",
            value: function initialize() {
                var meta = this._cachedMeta;
                this.configure();
                this.linkScales();
                meta._stacked = isStacked(meta.vScale, meta);
                this.addElements();
                if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
            }
        },
        {
            key: "updateIndex",
            value: function updateIndex(datasetIndex) {
                if (this.index !== datasetIndex) clearStacks(this._cachedMeta);
                this.index = datasetIndex;
            }
        },
        {
            key: "linkScales",
            value: function linkScales() {
                var chart = this.chart;
                var meta = this._cachedMeta;
                var dataset = this.getDataset();
                var chooseId = function(axis, x, y, r) {
                    return axis === 'x' ? x : axis === 'r' ? r : y;
                };
                var xid = meta.xAxisID = (0, $3zT2Z.v)(dataset.xAxisID, getFirstScaleId(chart, 'x'));
                var yid = meta.yAxisID = (0, $3zT2Z.v)(dataset.yAxisID, getFirstScaleId(chart, 'y'));
                var rid = meta.rAxisID = (0, $3zT2Z.v)(dataset.rAxisID, getFirstScaleId(chart, 'r'));
                var indexAxis = meta.indexAxis;
                var iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
                var vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
                meta.xScale = this.getScaleForId(xid);
                meta.yScale = this.getScaleForId(yid);
                meta.rScale = this.getScaleForId(rid);
                meta.iScale = this.getScaleForId(iid);
                meta.vScale = this.getScaleForId(vid);
            }
        },
        {
            key: "getDataset",
            value: function getDataset() {
                return this.chart.data.datasets[this.index];
            }
        },
        {
            key: "getMeta",
            value: function getMeta() {
                return this.chart.getDatasetMeta(this.index);
            }
        },
        {
            key: "getScaleForId",
            value: function getScaleForId(scaleID) {
                return this.chart.scales[scaleID];
            }
        },
        {
            key: "_getOtherScale",
            value: function _getOtherScale(scale) {
                var meta = this._cachedMeta;
                return scale === meta.iScale ? meta.vScale : meta.iScale;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._update('reset');
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                var meta = this._cachedMeta;
                if (this._data) (0, $3zT2Z.u)(this._data, this);
                if (meta._stacked) clearStacks(meta);
            }
        },
        {
            key: "_dataCheck",
            value: function _dataCheck() {
                var dataset = this.getDataset();
                var data = dataset.data || (dataset.data = []);
                var _data = this._data;
                if ((0, $3zT2Z.i)(data)) {
                    var meta = this._cachedMeta;
                    this._data = convertObjectDataToArray(data, meta);
                } else if (_data !== data) {
                    if (_data) {
                        (0, $3zT2Z.u)(_data, this);
                        var meta1 = this._cachedMeta;
                        clearStacks(meta1);
                        meta1._parsed = [];
                    }
                    if (data && Object.isExtensible(data)) (0, $3zT2Z.l)(data, this);
                    this._syncList = [];
                    this._data = data;
                }
            }
        },
        {
            key: "addElements",
            value: function addElements() {
                var meta = this._cachedMeta;
                this._dataCheck();
                if (this.datasetElementType) meta.dataset = new this.datasetElementType();
            }
        },
        {
            key: "buildOrUpdateElements",
            value: function buildOrUpdateElements(resetNewElements) {
                var meta = this._cachedMeta;
                var dataset = this.getDataset();
                var stackChanged = false;
                this._dataCheck();
                var oldStacked = meta._stacked;
                meta._stacked = isStacked(meta.vScale, meta);
                if (meta.stack !== dataset.stack) {
                    stackChanged = true;
                    clearStacks(meta);
                    meta.stack = dataset.stack;
                }
                this._resyncElements(resetNewElements);
                if (stackChanged || oldStacked !== meta._stacked) {
                    updateStacks(this, meta._parsed);
                    meta._stacked = isStacked(meta.vScale, meta);
                }
            }
        },
        {
            key: "configure",
            value: function configure() {
                var config = this.chart.config;
                var scopeKeys = config.datasetScopeKeys(this._type);
                var scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
                this.options = config.createResolver(scopes, this.getContext());
                this._parsing = this.options.parsing;
                this._cachedDataOpts = {};
            }
        },
        {
            key: "parse",
            value: function parse(start, count) {
                var _this = this, meta = _this._cachedMeta, data = _this._data;
                var iScale = meta.iScale, _stacked = meta._stacked;
                var iAxis = iScale.axis;
                var sorted = start === 0 && count === data.length ? true : meta._sorted;
                var prev = start > 0 && meta._parsed[start - 1];
                var i, cur, parsed;
                if (this._parsing === false) {
                    meta._parsed = data;
                    meta._sorted = true;
                    parsed = data;
                } else {
                    if ((0, $3zT2Z.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
                    else if ((0, $3zT2Z.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
                    else parsed = this.parsePrimitiveData(meta, data, start, count);
                    var isNotInOrderComparedToPrev = function() {
                        return cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
                    };
                    for(i = 0; i < count; ++i){
                        meta._parsed[i + start] = cur = parsed[i];
                        if (sorted) {
                            if (isNotInOrderComparedToPrev()) sorted = false;
                            prev = cur;
                        }
                    }
                    meta._sorted = sorted;
                }
                if (_stacked) updateStacks(this, parsed);
            }
        },
        {
            key: "parsePrimitiveData",
            value: function parsePrimitiveData(meta, data, start, count) {
                var iScale = meta.iScale, vScale = meta.vScale;
                var iAxis = iScale.axis;
                var vAxis = vScale.axis;
                var labels = iScale.getLabels();
                var singleScale = iScale === vScale;
                var parsed = new Array(count);
                var i, ilen, index;
                for(i = 0, ilen = count; i < ilen; ++i){
                    index = i + start;
                    var _obj;
                    parsed[i] = (_obj = {}, (0, $6lD0P._)(_obj, iAxis, singleScale || iScale.parse(labels[index], index)), (0, $6lD0P._)(_obj, vAxis, vScale.parse(data[index], index)), _obj);
                }
                return parsed;
            }
        },
        {
            key: "parseArrayData",
            value: function parseArrayData(meta, data, start, count) {
                var xScale = meta.xScale, yScale = meta.yScale;
                var parsed = new Array(count);
                var i, ilen, index, item;
                for(i = 0, ilen = count; i < ilen; ++i){
                    index = i + start;
                    item = data[index];
                    parsed[i] = {
                        x: xScale.parse(item[0], index),
                        y: yScale.parse(item[1], index)
                    };
                }
                return parsed;
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                var xScale = meta.xScale, yScale = meta.yScale;
                var _this__parsing = this._parsing, _this__parsing_xAxisKey = _this__parsing.xAxisKey, xAxisKey = _this__parsing_xAxisKey === void 0 ? 'x' : _this__parsing_xAxisKey, _this__parsing_yAxisKey = _this__parsing.yAxisKey, yAxisKey = _this__parsing_yAxisKey === void 0 ? 'y' : _this__parsing_yAxisKey;
                var parsed = new Array(count);
                var i, ilen, index, item;
                for(i = 0, ilen = count; i < ilen; ++i){
                    index = i + start;
                    item = data[index];
                    parsed[i] = {
                        x: xScale.parse((0, $3zT2Z.f)(item, xAxisKey), index),
                        y: yScale.parse((0, $3zT2Z.f)(item, yAxisKey), index)
                    };
                }
                return parsed;
            }
        },
        {
            key: "getParsed",
            value: function getParsed(index) {
                return this._cachedMeta._parsed[index];
            }
        },
        {
            key: "getDataElement",
            value: function getDataElement(index) {
                return this._cachedMeta.data[index];
            }
        },
        {
            key: "applyStack",
            value: function applyStack1(scale, parsed, mode) {
                var chart = this.chart;
                var meta = this._cachedMeta;
                var value = parsed[scale.axis];
                var stack = {
                    keys: getSortedDatasetIndices(chart, true),
                    values: parsed._stacks[scale.axis]._visualValues
                };
                return applyStack(stack, value, meta.index, {
                    mode: mode
                });
            }
        },
        {
            key: "updateRangeFromParsed",
            value: function updateRangeFromParsed(range, scale, parsed, stack) {
                var parsedValue = parsed[scale.axis];
                var value = parsedValue === null ? NaN : parsedValue;
                var values = stack && parsed._stacks[scale.axis];
                if (stack && values) {
                    stack.values = values;
                    value = applyStack(stack, parsedValue, this._cachedMeta.index);
                }
                range.min = Math.min(range.min, value);
                range.max = Math.max(range.max, value);
            }
        },
        {
            key: "getMinMax",
            value: function getMinMax(scale, canStack) {
                var meta = this._cachedMeta;
                var _parsed = meta._parsed;
                var sorted = meta._sorted && scale === meta.iScale;
                var ilen = _parsed.length;
                var otherScale = this._getOtherScale(scale);
                var stack = createStack(canStack, meta, this.chart);
                var range = {
                    min: Number.POSITIVE_INFINITY,
                    max: Number.NEGATIVE_INFINITY
                };
                var _getUserBounds = getUserBounds(otherScale), otherMin = _getUserBounds.min, otherMax = _getUserBounds.max;
                var i, parsed;
                function _skip() {
                    parsed = _parsed[i];
                    var otherValue = parsed[otherScale.axis];
                    return !(0, $3zT2Z.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
                }
                for(i = 0; i < ilen; ++i){
                    if (_skip()) continue;
                    this.updateRangeFromParsed(range, scale, parsed, stack);
                    if (sorted) break;
                }
                if (sorted) for(i = ilen - 1; i >= 0; --i){
                    if (_skip()) continue;
                    this.updateRangeFromParsed(range, scale, parsed, stack);
                    break;
                }
                return range;
            }
        },
        {
            key: "getAllParsedValues",
            value: function getAllParsedValues(scale) {
                var parsed = this._cachedMeta._parsed;
                var values = [];
                var i, ilen, value;
                for(i = 0, ilen = parsed.length; i < ilen; ++i){
                    value = parsed[i][scale.axis];
                    if ((0, $3zT2Z.g)(value)) values.push(value);
                }
                return values;
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                return false;
            }
        },
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var iScale = meta.iScale;
                var vScale = meta.vScale;
                var parsed = this.getParsed(index);
                return {
                    label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
                    value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
                };
            }
        },
        {
            key: "_update",
            value: function _update(mode) {
                var meta = this._cachedMeta;
                this.update(mode || 'default');
                meta._clip = toClip((0, $3zT2Z.v)(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
            }
        },
        {
            key: "update",
            value: function update(mode) {}
        },
        {
            key: "draw",
            value: function draw() {
                var ctx = this._ctx;
                var chart = this.chart;
                var meta = this._cachedMeta;
                var elements = meta.data || [];
                var area = chart.chartArea;
                var active = [];
                var start = this._drawStart || 0;
                var count = this._drawCount || elements.length - start;
                var drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
                var i;
                if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
                for(i = start; i < start + count; ++i){
                    var element = elements[i];
                    if (element.hidden) continue;
                    if (element.active && drawActiveElementsOnTop) active.push(element);
                    else element.draw(ctx, area);
                }
                for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
            }
        },
        {
            key: "getStyle",
            value: function getStyle(index, active) {
                var mode = active ? 'active' : 'default';
                return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
            }
        },
        {
            key: "getContext",
            value: function getContext(index, active, mode) {
                var dataset = this.getDataset();
                var context;
                if (index >= 0 && index < this._cachedMeta.data.length) {
                    var element = this._cachedMeta.data[index];
                    context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
                    context.parsed = this.getParsed(index);
                    context.raw = dataset.data[index];
                    context.index = context.dataIndex = index;
                } else {
                    context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
                    context.dataset = dataset;
                    context.index = context.datasetIndex = this.index;
                }
                context.active = !!active;
                context.mode = mode;
                return context;
            }
        },
        {
            key: "resolveDatasetElementOptions",
            value: function resolveDatasetElementOptions(mode) {
                return this._resolveElementOptions(this.datasetElementType.id, mode);
            }
        },
        {
            key: "resolveDataElementOptions",
            value: function resolveDataElementOptions(index, mode) {
                return this._resolveElementOptions(this.dataElementType.id, mode, index);
            }
        },
        {
            key: "_resolveElementOptions",
            value: function _resolveElementOptions(elementType) {
                var _this = this;
                var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'default', index = arguments.length > 2 ? arguments[2] : void 0;
                var active = mode === 'active';
                var cache = this._cachedDataOpts;
                var cacheKey = elementType + '-' + mode;
                var cached = cache[cacheKey];
                var sharing = this.enableOptionSharing && (0, $3zT2Z.h)(index);
                if (cached) return cloneIfNotShared(cached, sharing);
                var config = this.chart.config;
                var scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
                var prefixes = active ? [
                    "".concat(elementType, "Hover"),
                    'hover',
                    elementType,
                    ''
                ] : [
                    elementType,
                    ''
                ];
                var scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
                var names = Object.keys((0, $3zT2Z.d).elements[elementType]);
                var context = function() {
                    return _this.getContext(index, active, mode);
                };
                var values = config.resolveNamedOptions(scopes, names, context, prefixes);
                if (values.$shared) {
                    values.$shared = sharing;
                    cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
                }
                return values;
            }
        },
        {
            key: "_resolveAnimations",
            value: function _resolveAnimations(index, transition, active) {
                var chart = this.chart;
                var cache = this._cachedDataOpts;
                var cacheKey = "animation-".concat(transition);
                var cached = cache[cacheKey];
                if (cached) return cached;
                var options;
                if (chart.options.animation !== false) {
                    var config = this.chart.config;
                    var scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
                    var scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
                    options = config.createResolver(scopes, this.getContext(index, active, transition));
                }
                var animations = new Animations(chart, options && options.animations);
                if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
                return animations;
            }
        },
        {
            key: "getSharedOptions",
            value: function getSharedOptions(options) {
                if (!options.$shared) return;
                return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
            }
        },
        {
            key: "includeOptions",
            value: function includeOptions(mode, sharedOptions) {
                return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
            }
        },
        {
            key: "_getSharedOptions",
            value: function _getSharedOptions(start, mode) {
                var firstOpts = this.resolveDataElementOptions(start, mode);
                var previouslySharedOptions = this._sharedOptions;
                var sharedOptions = this.getSharedOptions(firstOpts);
                var includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
                this.updateSharedOptions(sharedOptions, mode, firstOpts);
                return {
                    sharedOptions: sharedOptions,
                    includeOptions: includeOptions
                };
            }
        },
        {
            key: "updateElement",
            value: function updateElement(element, index, properties, mode) {
                if (isDirectUpdateMode(mode)) Object.assign(element, properties);
                else this._resolveAnimations(index, mode).update(element, properties);
            }
        },
        {
            key: "updateSharedOptions",
            value: function updateSharedOptions(sharedOptions, mode, newOptions) {
                if (sharedOptions && !isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
            }
        },
        {
            key: "_setStyle",
            value: function _setStyle(element, index, mode, active) {
                element.active = active;
                var options = this.getStyle(index, active);
                this._resolveAnimations(index, mode, active).update(element, {
                    options: !active && this.getSharedOptions(options) || options
                });
            }
        },
        {
            key: "removeHoverStyle",
            value: function removeHoverStyle(element, datasetIndex, index) {
                this._setStyle(element, index, 'active', false);
            }
        },
        {
            key: "setHoverStyle",
            value: function setHoverStyle(element, datasetIndex, index) {
                this._setStyle(element, index, 'active', true);
            }
        },
        {
            key: "_removeDatasetHoverStyle",
            value: function _removeDatasetHoverStyle() {
                var element = this._cachedMeta.dataset;
                if (element) this._setStyle(element, undefined, 'active', false);
            }
        },
        {
            key: "_setDatasetHoverStyle",
            value: function _setDatasetHoverStyle() {
                var element = this._cachedMeta.dataset;
                if (element) this._setStyle(element, undefined, 'active', true);
            }
        },
        {
            key: "_resyncElements",
            value: function _resyncElements(resetNewElements) {
                var data = this._data;
                var elements = this._cachedMeta.data;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._syncList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $esDIr._)(_step.value, 3), method = _step_value[0], arg1 = _step_value[1], arg2 = _step_value[2];
                        this[method](arg1, arg2);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._syncList = [];
                var numMeta = elements.length;
                var numData = data.length;
                var count = Math.min(numData, numMeta);
                if (count) this.parse(0, count);
                if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
                else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
            }
        },
        {
            key: "_insertElements",
            value: function _insertElements(start, count) {
                var resetNewElements = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var meta = this._cachedMeta;
                var data = meta.data;
                var end = start + count;
                var i;
                var move = function(arr) {
                    arr.length += count;
                    for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
                };
                move(data);
                for(i = start; i < end; ++i)data[i] = new this.dataElementType();
                if (this._parsing) move(meta._parsed);
                this.parse(start, count);
                if (resetNewElements) this.updateElements(data, start, count, 'reset');
            }
        },
        {
            key: "updateElements",
            value: function updateElements(element, start, count, mode) {}
        },
        {
            key: "_removeElements",
            value: function _removeElements(start, count) {
                var meta = this._cachedMeta;
                if (this._parsing) {
                    var removed = meta._parsed.splice(start, count);
                    if (meta._stacked) clearStacks(meta, removed);
                }
                meta.data.splice(start, count);
            }
        },
        {
            key: "_sync",
            value: function _sync(args) {
                if (this._parsing) this._syncList.push(args);
                else {
                    var _args = (0, $esDIr._)(args, 3), method = _args[0], arg1 = _args[1], arg2 = _args[2];
                    this[method](arg1, arg2);
                }
                this.chart._dataChanges.push([
                    this.index
                ].concat((0, $kNmtb._)(args)));
            }
        },
        {
            key: "_onDataPush",
            value: function _onDataPush() {
                var count = arguments.length;
                this._sync([
                    '_insertElements',
                    this.getDataset().data.length - count,
                    count
                ]);
            }
        },
        {
            key: "_onDataPop",
            value: function _onDataPop() {
                this._sync([
                    '_removeElements',
                    this._cachedMeta.data.length - 1,
                    1
                ]);
            }
        },
        {
            key: "_onDataShift",
            value: function _onDataShift() {
                this._sync([
                    '_removeElements',
                    0,
                    1
                ]);
            }
        },
        {
            key: "_onDataSplice",
            value: function _onDataSplice(start, count) {
                if (count) this._sync([
                    '_removeElements',
                    start,
                    count
                ]);
                var newCount = arguments.length - 2;
                if (newCount) this._sync([
                    '_insertElements',
                    start,
                    newCount
                ]);
            }
        },
        {
            key: "_onDataUnshift",
            value: function _onDataUnshift() {
                this._sync([
                    '_insertElements',
                    0,
                    arguments.length
                ]);
            }
        }
    ]);
    return DatasetController;
}();
(0, $6lD0P._)(DatasetController, "defaults", {});
(0, $6lD0P._)(DatasetController, "datasetElementType", null);
(0, $6lD0P._)(DatasetController, "dataElementType", null);
function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        var visibleMetas = scale.getMatchingVisibleMetas(type);
        var values = [];
        for(var i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $3zT2Z._)(values.sort(function(a, b) {
            return a - b;
        }));
    }
    return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
    var scale = meta.iScale;
    var values = getAllScaleValues(scale, meta.type);
    var min = scale._length;
    var i, ilen, curr, prev;
    var updateMinAndPrev = function() {
        if (curr === 32767 || curr === -32768) return;
        if ((0, $3zT2Z.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
    var thickness = options.barThickness;
    var size, ratio;
    if ((0, $3zT2Z.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    var pixels = ruler.pixels;
    var curr = pixels[index];
    var prev = index > 0 ? pixels[index - 1] : null;
    var next = index < pixels.length - 1 ? pixels[index + 1] : null;
    var percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    var start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    var size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    var startValue = vScale.parse(entry[0], i);
    var endValue = vScale.parse(entry[1], i);
    var min = Math.min(startValue, endValue);
    var max = Math.max(startValue, endValue);
    var barStart = min;
    var barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function parseValue(entry, item, vScale, i) {
    if ((0, $3zT2Z.b)(entry)) parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    var iScale = meta.iScale;
    var vScale = meta.vScale;
    var labels = iScale.getLabels();
    var singleScale = iScale === vScale;
    var parsed = [];
    var i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $3zT2Z.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    var reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    var edge = options.borderSkipped;
    var res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    var _borderProps = borderProps(properties), start = _borderProps.start, end = _borderProps.end, reverse = _borderProps.reverse, top = _borderProps.top, bottom = _borderProps.bottom;
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else edge = startEnd(edge, a, b);
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, param, ratio) {
    var inflateAmount = param.inflateAmount;
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
var BarController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $dqNF0._)(BarController, DatasetController);
    function BarController() {
        (0, $ioD88._)(this, BarController);
        return (0, $ctUVE._)(this, BarController, arguments);
    }
    (0, $6NCFa._)(BarController, [
        {
            key: "parsePrimitiveData",
            value: function parsePrimitiveData(meta, data, start, count) {
                return parseArrayOrPrimitive(meta, data, start, count);
            }
        },
        {
            key: "parseArrayData",
            value: function parseArrayData(meta, data, start, count) {
                return parseArrayOrPrimitive(meta, data, start, count);
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                var iScale = meta.iScale, vScale = meta.vScale;
                var _this__parsing = this._parsing, _this__parsing_xAxisKey = _this__parsing.xAxisKey, xAxisKey = _this__parsing_xAxisKey === void 0 ? 'x' : _this__parsing_xAxisKey, _this__parsing_yAxisKey = _this__parsing.yAxisKey, yAxisKey = _this__parsing_yAxisKey === void 0 ? 'y' : _this__parsing_yAxisKey;
                var iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
                var vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
                var parsed = [];
                var i, ilen, item, obj;
                for(i = start, ilen = start + count; i < ilen; ++i){
                    obj = data[i];
                    item = {};
                    item[iScale.axis] = iScale.parse((0, $3zT2Z.f)(obj, iAxisKey), i);
                    parsed.push(parseValue((0, $3zT2Z.f)(obj, vAxisKey), item, vScale, i));
                }
                return parsed;
            }
        },
        {
            key: "updateRangeFromParsed",
            value: function updateRangeFromParsed(range, scale, parsed, stack) {
                (0, $9rJIv._)((0, $2HbS2._)(BarController.prototype), "updateRangeFromParsed", this).call(this, range, scale, parsed, stack);
                var custom = parsed._custom;
                if (custom && scale === this._cachedMeta.vScale) {
                    range.min = Math.min(range.min, custom.min);
                    range.max = Math.max(range.max, custom.max);
                }
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                return 0;
            }
        },
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var iScale = meta.iScale, vScale = meta.vScale;
                var parsed = this.getParsed(index);
                var custom = parsed._custom;
                var value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
                return {
                    label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
                    value: value
                };
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                this.enableOptionSharing = true;
                (0, $9rJIv._)((0, $2HbS2._)(BarController.prototype), "initialize", this).call(this);
                var meta = this._cachedMeta;
                meta.stack = this.getDataset().stack;
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var meta = this._cachedMeta;
                this.updateElements(meta.data, 0, meta.data.length, mode);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(bars, start, count, mode) {
                var reset = mode === 'reset';
                var _this = this, index = _this.index, vScale = _this._cachedMeta.vScale;
                var base = vScale.getBasePixel();
                var horizontal = vScale.isHorizontal();
                var ruler = this._getRuler();
                var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
                for(var i = start; i < start + count; i++){
                    var parsed = this.getParsed(i);
                    var vpixels = reset || (0, $3zT2Z.k)(parsed[vScale.axis]) ? {
                        base: base,
                        head: base
                    } : this._calculateBarValuePixels(i);
                    var ipixels = this._calculateBarIndexPixels(i, ruler);
                    var stack = (parsed._stacks || {})[vScale.axis];
                    var properties = {
                        horizontal: horizontal,
                        base: vpixels.base,
                        enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                        x: horizontal ? vpixels.head : ipixels.center,
                        y: horizontal ? ipixels.center : vpixels.head,
                        height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                        width: horizontal ? Math.abs(vpixels.size) : ipixels.size
                    };
                    if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
                    var options = properties.options || bars[i].options;
                    setBorderSkipped(properties, options, stack, index);
                    setInflateAmount(properties, options, ruler.ratio);
                    this.updateElement(bars[i], i, properties, mode);
                }
            }
        },
        {
            key: "_getStacks",
            value: function _getStacks(last, dataIndex) {
                var iScale = this._cachedMeta.iScale;
                var metasets = iScale.getMatchingVisibleMetas(this._type).filter(function(meta) {
                    return meta.controller.options.grouped;
                });
                var stacked = iScale.options.stacked;
                var stacks = [];
                var currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
                var iScaleValue = currentParsed && currentParsed[iScale.axis];
                var skipNull = function(meta) {
                    var parsed = meta._parsed.find(function(item) {
                        return item[iScale.axis] === iScaleValue;
                    });
                    var val = parsed && parsed[meta.vScale.axis];
                    if ((0, $3zT2Z.k)(val) || isNaN(val)) return true;
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = metasets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var meta = _step.value;
                        if (dataIndex !== undefined && skipNull(meta)) continue;
                        if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                        if (meta.index === last) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!stacks.length) stacks.push(undefined);
                return stacks;
            }
        },
        {
            key: "_getStackCount",
            value: function _getStackCount(index) {
                return this._getStacks(undefined, index).length;
            }
        },
        {
            key: "_getAxisCount",
            value: function _getAxisCount() {
                return this._getAxis().length;
            }
        },
        {
            key: "getFirstScaleIdForIndexAxis",
            value: function getFirstScaleIdForIndexAxis() {
                var scales = this.chart.scales;
                var indexScaleId = this.chart.options.indexAxis;
                return Object.keys(scales).filter(function(key) {
                    return scales[key].axis === indexScaleId;
                }).shift();
            }
        },
        {
            key: "_getAxis",
            value: function _getAxis() {
                var axis = {};
                var firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.chart.data.datasets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataset = _step.value;
                        axis[(0, $3zT2Z.v)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Object.keys(axis);
            }
        },
        {
            key: "_getStackIndex",
            value: function _getStackIndex(datasetIndex, name, dataIndex) {
                var stacks = this._getStacks(datasetIndex, dataIndex);
                var index = name !== undefined ? stacks.indexOf(name) : -1;
                return index === -1 ? stacks.length - 1 : index;
            }
        },
        {
            key: "_getRuler",
            value: function _getRuler() {
                var opts = this.options;
                var meta = this._cachedMeta;
                var iScale = meta.iScale;
                var pixels = [];
                var i, ilen;
                for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
                var barThickness = opts.barThickness;
                var min = barThickness || computeMinSampleSize(meta);
                return {
                    min: min,
                    pixels: pixels,
                    start: iScale._startPixel,
                    end: iScale._endPixel,
                    stackCount: this._getStackCount(),
                    scale: iScale,
                    grouped: opts.grouped,
                    ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
                };
            }
        },
        {
            key: "_calculateBarValuePixels",
            value: function _calculateBarValuePixels(index) {
                var _this = this, _this__cachedMeta = _this._cachedMeta, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, datasetIndex = _this__cachedMeta.index, _this_options = _this.options, baseValue = _this_options.base, minBarLength = _this_options.minBarLength;
                var actualBase = baseValue || 0;
                var parsed = this.getParsed(index);
                var custom = parsed._custom;
                var floating = isFloatBar(custom);
                var value = parsed[vScale.axis];
                var start = 0;
                var length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
                var head, size;
                if (length !== value) {
                    start = length - value;
                    length = value;
                }
                if (floating) {
                    value = custom.barStart;
                    length = custom.barEnd - custom.barStart;
                    if (value !== 0 && (0, $3zT2Z.s)(value) !== (0, $3zT2Z.s)(custom.barEnd)) start = 0;
                    start += value;
                }
                var startValue = !(0, $3zT2Z.k)(baseValue) && !floating ? baseValue : start;
                var base = vScale.getPixelForValue(startValue);
                if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
                else head = base;
                size = head - base;
                if (Math.abs(size) < minBarLength) {
                    size = barSign(size, vScale, actualBase) * minBarLength;
                    if (value === actualBase) base -= size / 2;
                    var startPixel = vScale.getPixelForDecimal(0);
                    var endPixel = vScale.getPixelForDecimal(1);
                    var min = Math.min(startPixel, endPixel);
                    var max = Math.max(startPixel, endPixel);
                    base = Math.max(Math.min(base, max), min);
                    head = base + size;
                    if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
                }
                if (base === vScale.getPixelForValue(actualBase)) {
                    var halfGrid = (0, $3zT2Z.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
                    base += halfGrid;
                    size -= halfGrid;
                }
                return {
                    size: size,
                    base: base,
                    head: head,
                    center: head + size / 2
                };
            }
        },
        {
            key: "_calculateBarIndexPixels",
            value: function _calculateBarIndexPixels(index, ruler) {
                var scale = ruler.scale;
                var options = this.options;
                var skipNull = options.skipNull;
                var maxBarThickness = (0, $3zT2Z.v)(options.maxBarThickness, Infinity);
                var center, size;
                var axisCount = this._getAxisCount();
                if (ruler.grouped) {
                    var stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
                    var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
                    var axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
                    var axisNumber = this._getAxis().indexOf((0, $3zT2Z.v)(axisID, this.getFirstScaleIdForIndexAxis()));
                    var stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
                    center = range.start + range.chunk * stackIndex + range.chunk / 2;
                    size = Math.min(maxBarThickness, range.chunk * range.ratio);
                } else {
                    center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
                    size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
                }
                return {
                    base: center - size / 2,
                    head: center + size / 2,
                    center: center,
                    size: size
                };
            }
        },
        {
            key: "draw",
            value: function draw() {
                var meta = this._cachedMeta;
                var vScale = meta.vScale;
                var rects = meta.data;
                var ilen = rects.length;
                var i = 0;
                for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
            }
        }
    ]);
    return BarController;
}(DatasetController);
(0, $6lD0P._)(BarController, "id", 'bar');
(0, $6lD0P._)(BarController, "defaults", {
    datasetElementType: false,
    dataElementType: 'bar',
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'base',
                'width',
                'height'
            ]
        }
    }
});
(0, $6lD0P._)(BarController, "overrides", {
    scales: {
        _index_: {
            type: 'category',
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: 'linear',
            beginAtZero: true
        }
    }
});
var BubbleController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $dqNF0._)(BubbleController, DatasetController);
    function BubbleController() {
        (0, $ioD88._)(this, BubbleController);
        return (0, $ctUVE._)(this, BubbleController, arguments);
    }
    (0, $6NCFa._)(BubbleController, [
        {
            key: "initialize",
            value: function initialize() {
                this.enableOptionSharing = true;
                (0, $9rJIv._)((0, $2HbS2._)(BubbleController.prototype), "initialize", this).call(this);
            }
        },
        {
            key: "parsePrimitiveData",
            value: function parsePrimitiveData(meta, data, start, count) {
                var parsed = (0, $9rJIv._)((0, $2HbS2._)(BubbleController.prototype), "parsePrimitiveData", this).call(this, meta, data, start, count);
                for(var i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
                return parsed;
            }
        },
        {
            key: "parseArrayData",
            value: function parseArrayData(meta, data, start, count) {
                var parsed = (0, $9rJIv._)((0, $2HbS2._)(BubbleController.prototype), "parseArrayData", this).call(this, meta, data, start, count);
                for(var i = 0; i < parsed.length; i++){
                    var item = data[start + i];
                    parsed[i]._custom = (0, $3zT2Z.v)(item[2], this.resolveDataElementOptions(i + start).radius);
                }
                return parsed;
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                var parsed = (0, $9rJIv._)((0, $2HbS2._)(BubbleController.prototype), "parseObjectData", this).call(this, meta, data, start, count);
                for(var i = 0; i < parsed.length; i++){
                    var item = data[start + i];
                    parsed[i]._custom = (0, $3zT2Z.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
                }
                return parsed;
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                var data = this._cachedMeta.data;
                var max = 0;
                for(var i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
                return max > 0 && max;
            }
        },
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var labels = this.chart.data.labels || [];
                var xScale = meta.xScale, yScale = meta.yScale;
                var parsed = this.getParsed(index);
                var x = xScale.getLabelForValue(parsed.x);
                var y = yScale.getLabelForValue(parsed.y);
                var r = parsed._custom;
                return {
                    label: labels[index] || '',
                    value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
                };
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var points = this._cachedMeta.data;
                this.updateElements(points, 0, points.length, mode);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(points, start, count, mode) {
                var reset = mode === 'reset';
                var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale;
                var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
                var iAxis = iScale.axis;
                var vAxis = vScale.axis;
                for(var i = start; i < start + count; i++){
                    var point = points[i];
                    var parsed = !reset && this.getParsed(i);
                    var properties = {};
                    var iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
                    var vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
                    properties.skip = isNaN(iPixel) || isNaN(vPixel);
                    if (includeOptions) {
                        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                        if (reset) properties.options.radius = 0;
                    }
                    this.updateElement(point, i, properties, mode);
                }
            }
        },
        {
            key: "resolveDataElementOptions",
            value: function resolveDataElementOptions(index, mode) {
                var parsed = this.getParsed(index);
                var values = (0, $9rJIv._)((0, $2HbS2._)(BubbleController.prototype), "resolveDataElementOptions", this).call(this, index, mode);
                if (values.$shared) values = Object.assign({}, values, {
                    $shared: false
                });
                var radius = values.radius;
                if (mode !== 'active') values.radius = 0;
                values.radius += (0, $3zT2Z.v)(parsed && parsed._custom, radius);
                return values;
            }
        }
    ]);
    return BubbleController;
}(DatasetController);
(0, $6lD0P._)(BubbleController, "id", 'bubble');
(0, $6lD0P._)(BubbleController, "defaults", {
    datasetElementType: false,
    dataElementType: 'point',
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'borderWidth',
                'radius'
            ]
        }
    }
});
(0, $6lD0P._)(BubbleController, "overrides", {
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    }
});
function getRatioAndOffset(rotation, circumference, cutout) {
    var ratioX = 1;
    var ratioY = 1;
    var offsetX = 0;
    var offsetY = 0;
    if (circumference < (0, $3zT2Z.T)) {
        var startAngle = rotation;
        var endAngle = startAngle + circumference;
        var startX = Math.cos(startAngle);
        var startY = Math.sin(startAngle);
        var endX = Math.cos(endAngle);
        var endY = Math.sin(endAngle);
        var calcMax = function(angle, a, b) {
            return (0, $3zT2Z.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        };
        var calcMin = function(angle, a, b) {
            return (0, $3zT2Z.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        };
        var maxX = calcMax(0, startX, endX);
        var maxY = calcMax((0, $3zT2Z.H), startY, endY);
        var minX = calcMin((0, $3zT2Z.P), startX, endX);
        var minY = calcMin((0, $3zT2Z.P) + (0, $3zT2Z.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
var DoughnutController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $dqNF0._)(DoughnutController, DatasetController);
    function DoughnutController(chart, datasetIndex) {
        (0, $ioD88._)(this, DoughnutController);
        var _this;
        _this = (0, $ctUVE._)(this, DoughnutController, [
            chart,
            datasetIndex
        ]);
        _this.enableOptionSharing = true;
        _this.innerRadius = undefined;
        _this.outerRadius = undefined;
        _this.offsetX = undefined;
        _this.offsetY = undefined;
        return _this;
    }
    (0, $6NCFa._)(DoughnutController, [
        {
            key: "linkScales",
            value: function linkScales() {}
        },
        {
            key: "parse",
            value: function parse(start, count) {
                var data = this.getDataset().data;
                var meta = this._cachedMeta;
                if (this._parsing === false) meta._parsed = data;
                else {
                    var getter = function(i) {
                        return +data[i];
                    };
                    if ((0, $3zT2Z.i)(data[start])) {
                        var _this__parsing = this._parsing, _this__parsing_key = _this__parsing.key, key = _this__parsing_key === void 0 ? 'value' : _this__parsing_key;
                        getter = function(i) {
                            return +(0, $3zT2Z.f)(data[i], key);
                        };
                    }
                    var i, ilen;
                    for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
                }
            }
        },
        {
            key: "_getRotation",
            value: function _getRotation() {
                return (0, $3zT2Z.t)(this.options.rotation - 90);
            }
        },
        {
            key: "_getCircumference",
            value: function _getCircumference() {
                return (0, $3zT2Z.t)(this.options.circumference);
            }
        },
        {
            key: "_getRotationExtents",
            value: function _getRotationExtents() {
                var min = (0, $3zT2Z.T);
                var max = -(0, $3zT2Z.T);
                for(var i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
                    var controller = this.chart.getDatasetMeta(i).controller;
                    var rotation = controller._getRotation();
                    var circumference = controller._getCircumference();
                    min = Math.min(min, rotation);
                    max = Math.max(max, rotation + circumference);
                }
                return {
                    rotation: min,
                    circumference: max - min
                };
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var chart = this.chart;
                var chartArea = chart.chartArea;
                var meta = this._cachedMeta;
                var arcs = meta.data;
                var spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
                var maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
                var cutout = Math.min((0, $3zT2Z.m)(this.options.cutout, maxSize), 1);
                var chartWeight = this._getRingWeight(this.index);
                var _this__getRotationExtents = this._getRotationExtents(), circumference = _this__getRotationExtents.circumference, rotation = _this__getRotationExtents.rotation;
                var _getRatioAndOffset = getRatioAndOffset(rotation, circumference, cutout), ratioX = _getRatioAndOffset.ratioX, ratioY = _getRatioAndOffset.ratioY, offsetX = _getRatioAndOffset.offsetX, offsetY = _getRatioAndOffset.offsetY;
                var maxWidth = (chartArea.width - spacing) / ratioX;
                var maxHeight = (chartArea.height - spacing) / ratioY;
                var maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
                var outerRadius = (0, $3zT2Z.n)(this.options.radius, maxRadius);
                var innerRadius = Math.max(outerRadius * cutout, 0);
                var radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
                this.offsetX = offsetX * outerRadius;
                this.offsetY = offsetY * outerRadius;
                meta.total = this.calculateTotal();
                this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
                this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
                this.updateElements(arcs, 0, arcs.length, mode);
            }
        },
        {
            key: "_circumference",
            value: function _circumference(i, reset) {
                var opts = this.options;
                var meta = this._cachedMeta;
                var circumference = this._getCircumference();
                if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
                return this.calculateCircumference(meta._parsed[i] * circumference / (0, $3zT2Z.T));
            }
        },
        {
            key: "updateElements",
            value: function updateElements(arcs, start, count, mode) {
                var reset = mode === 'reset';
                var chart = this.chart;
                var chartArea = chart.chartArea;
                var opts = chart.options;
                var animationOpts = opts.animation;
                var centerX = (chartArea.left + chartArea.right) / 2;
                var centerY = (chartArea.top + chartArea.bottom) / 2;
                var animateScale = reset && animationOpts.animateScale;
                var innerRadius = animateScale ? 0 : this.innerRadius;
                var outerRadius = animateScale ? 0 : this.outerRadius;
                var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
                var startAngle = this._getRotation();
                var i;
                for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
                for(i = start; i < start + count; ++i){
                    var circumference = this._circumference(i, reset);
                    var arc = arcs[i];
                    var properties = {
                        x: centerX + this.offsetX,
                        y: centerY + this.offsetY,
                        startAngle: startAngle,
                        endAngle: startAngle + circumference,
                        circumference: circumference,
                        outerRadius: outerRadius,
                        innerRadius: innerRadius
                    };
                    if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
                    startAngle += circumference;
                    this.updateElement(arc, i, properties, mode);
                }
            }
        },
        {
            key: "calculateTotal",
            value: function calculateTotal() {
                var meta = this._cachedMeta;
                var metaData = meta.data;
                var total = 0;
                var i;
                for(i = 0; i < metaData.length; i++){
                    var value = meta._parsed[i];
                    if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
                }
                return total;
            }
        },
        {
            key: "calculateCircumference",
            value: function calculateCircumference(value) {
                var total = this._cachedMeta.total;
                if (total > 0 && !isNaN(value)) return (0, $3zT2Z.T) * (Math.abs(value) / total);
                return 0;
            }
        },
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var chart = this.chart;
                var labels = chart.data.labels || [];
                var value = (0, $3zT2Z.o)(meta._parsed[index], chart.options.locale);
                return {
                    label: labels[index] || '',
                    value: value
                };
            }
        },
        {
            key: "getMaxBorderWidth",
            value: function getMaxBorderWidth(arcs) {
                var max = 0;
                var chart = this.chart;
                var i, ilen, meta, controller, options;
                if (!arcs) {
                    for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                        meta = chart.getDatasetMeta(i);
                        arcs = meta.data;
                        controller = meta.controller;
                        break;
                    }
                }
                if (!arcs) return 0;
                for(i = 0, ilen = arcs.length; i < ilen; ++i){
                    options = controller.resolveDataElementOptions(i);
                    if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
                }
                return max;
            }
        },
        {
            key: "getMaxOffset",
            value: function getMaxOffset(arcs) {
                var max = 0;
                for(var i = 0, ilen = arcs.length; i < ilen; ++i){
                    var options = this.resolveDataElementOptions(i);
                    max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
                }
                return max;
            }
        },
        {
            key: "_getRingWeightOffset",
            value: function _getRingWeightOffset(datasetIndex) {
                var ringWeightOffset = 0;
                for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
                return ringWeightOffset;
            }
        },
        {
            key: "_getRingWeight",
            value: function _getRingWeight(datasetIndex) {
                return Math.max((0, $3zT2Z.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
            }
        },
        {
            key: "_getVisibleDatasetWeightTotal",
            value: function _getVisibleDatasetWeightTotal() {
                return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
            }
        }
    ]);
    return DoughnutController;
}(DatasetController);
(0, $6lD0P._)(DoughnutController, "id", 'doughnut');
(0, $6lD0P._)(DoughnutController, "defaults", {
    datasetElementType: false,
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'circumference',
                'endAngle',
                'innerRadius',
                'outerRadius',
                'startAngle',
                'x',
                'y',
                'offset',
                'borderWidth',
                'spacing'
            ]
        }
    },
    cutout: '50%',
    rotation: 0,
    circumference: 360,
    radius: '100%',
    spacing: 0,
    indexAxis: 'r'
});
(0, $6lD0P._)(DoughnutController, "descriptors", {
    _scriptable: function(name) {
        return name !== 'spacing';
    },
    _indexable: function(name) {
        return name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash');
    }
});
(0, $6lD0P._)(DoughnutController, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, pointStyle = _chart_legend_options_labels.pointStyle, textAlign = _chart_legend_options_labels.textAlign, color = _chart_legend_options_labels.color, useBorderRadius = _chart_legend_options_labels.useBorderRadius, borderRadius = _chart_legend_options_labels.borderRadius;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            fontColor: color,
                            hidden: !chart.getDataVisibility(i),
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            textAlign: textAlign,
                            pointStyle: pointStyle,
                            borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    }
});
var LineController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $dqNF0._)(LineController, DatasetController);
    function LineController() {
        (0, $ioD88._)(this, LineController);
        return (0, $ctUVE._)(this, LineController, arguments);
    }
    (0, $6NCFa._)(LineController, [
        {
            key: "initialize",
            value: function initialize() {
                this.enableOptionSharing = true;
                this.supportsDecimation = true;
                (0, $9rJIv._)((0, $2HbS2._)(LineController.prototype), "initialize", this).call(this);
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var meta = this._cachedMeta;
                var line = meta.dataset, tmp = meta.data, points = tmp === void 0 ? [] : tmp, _dataset = meta._dataset;
                var animationsDisabled = this.chart._animationsDisabled;
                var _$_getStartAndCountOfVisiblePoints = (0, $3zT2Z.q)(meta, points, animationsDisabled), start = _$_getStartAndCountOfVisiblePoints.start, count = _$_getStartAndCountOfVisiblePoints.count;
                this._drawStart = start;
                this._drawCount = count;
                if ((0, $3zT2Z.w)(meta)) {
                    start = 0;
                    count = points.length;
                }
                line._chart = this.chart;
                line._datasetIndex = this.index;
                line._decimated = !!_dataset._decimated;
                line.points = points;
                var options = this.resolveDatasetElementOptions(mode);
                if (!this.options.showLine) options.borderWidth = 0;
                options.segment = this.options.segment;
                this.updateElement(line, undefined, {
                    animated: !animationsDisabled,
                    options: options
                }, mode);
                this.updateElements(points, start, count, mode);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(points, start, count, mode) {
                var reset = mode === 'reset';
                var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, _dataset = _this__cachedMeta._dataset;
                var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
                var iAxis = iScale.axis;
                var vAxis = vScale.axis;
                var _this_options = this.options, spanGaps = _this_options.spanGaps, segment = _this_options.segment;
                var maxGapLength = (0, $3zT2Z.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
                var directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
                var end = start + count;
                var pointsCount = points.length;
                var prevParsed = start > 0 && this.getParsed(start - 1);
                for(var i = 0; i < pointsCount; ++i){
                    var point = points[i];
                    var properties = directUpdate ? point : {};
                    if (i < start || i >= end) {
                        properties.skip = true;
                        continue;
                    }
                    var parsed = this.getParsed(i);
                    var nullData = (0, $3zT2Z.k)(parsed[vAxis]);
                    var iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
                    var vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
                    properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
                    properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
                    if (segment) {
                        properties.parsed = parsed;
                        properties.raw = _dataset.data[i];
                    }
                    if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                    if (!directUpdate) this.updateElement(point, i, properties, mode);
                    prevParsed = parsed;
                }
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                var meta = this._cachedMeta;
                var dataset = meta.dataset;
                var border = dataset.options && dataset.options.borderWidth || 0;
                var data = meta.data || [];
                if (!data.length) return border;
                var firstPoint = data[0].size(this.resolveDataElementOptions(0));
                var lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
                return Math.max(border, firstPoint, lastPoint) / 2;
            }
        },
        {
            key: "draw",
            value: function draw() {
                var meta = this._cachedMeta;
                meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
                (0, $9rJIv._)((0, $2HbS2._)(LineController.prototype), "draw", this).call(this);
            }
        }
    ]);
    return LineController;
}(DatasetController);
(0, $6lD0P._)(LineController, "id", 'line');
(0, $6lD0P._)(LineController, "defaults", {
    datasetElementType: 'line',
    dataElementType: 'point',
    showLine: true,
    spanGaps: false
});
(0, $6lD0P._)(LineController, "overrides", {
    scales: {
        _index_: {
            type: 'category'
        },
        _value_: {
            type: 'linear'
        }
    }
});
var PolarAreaController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $dqNF0._)(PolarAreaController, DatasetController);
    function PolarAreaController(chart, datasetIndex) {
        (0, $ioD88._)(this, PolarAreaController);
        var _this;
        _this = (0, $ctUVE._)(this, PolarAreaController, [
            chart,
            datasetIndex
        ]);
        _this.innerRadius = undefined;
        _this.outerRadius = undefined;
        return _this;
    }
    (0, $6NCFa._)(PolarAreaController, [
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var chart = this.chart;
                var labels = chart.data.labels || [];
                var value = (0, $3zT2Z.o)(meta._parsed[index].r, chart.options.locale);
                return {
                    label: labels[index] || '',
                    value: value
                };
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                return (0, $3zT2Z.y).bind(this)(meta, data, start, count);
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var arcs = this._cachedMeta.data;
                this._updateRadius();
                this.updateElements(arcs, 0, arcs.length, mode);
            }
        },
        {
            key: "getMinMax",
            value: function getMinMax() {
                var _this = this;
                var meta = this._cachedMeta;
                var range = {
                    min: Number.POSITIVE_INFINITY,
                    max: Number.NEGATIVE_INFINITY
                };
                meta.data.forEach(function(element, index) {
                    var parsed = _this.getParsed(index).r;
                    if (!isNaN(parsed) && _this.chart.getDataVisibility(index)) {
                        if (parsed < range.min) range.min = parsed;
                        if (parsed > range.max) range.max = parsed;
                    }
                });
                return range;
            }
        },
        {
            key: "_updateRadius",
            value: function _updateRadius() {
                var chart = this.chart;
                var chartArea = chart.chartArea;
                var opts = chart.options;
                var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                var outerRadius = Math.max(minSize / 2, 0);
                var innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
                var radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
                this.outerRadius = outerRadius - radiusLength * this.index;
                this.innerRadius = this.outerRadius - radiusLength;
            }
        },
        {
            key: "updateElements",
            value: function updateElements(arcs, start, count, mode) {
                var reset = mode === 'reset';
                var chart = this.chart;
                var opts = chart.options;
                var animationOpts = opts.animation;
                var scale = this._cachedMeta.rScale;
                var centerX = scale.xCenter;
                var centerY = scale.yCenter;
                var datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $3zT2Z.P);
                var angle = datasetStartAngle;
                var i;
                var defaultAngle = 360 / this.countVisibleElements();
                for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
                for(i = start; i < start + count; i++){
                    var arc = arcs[i];
                    var startAngle = angle;
                    var endAngle = angle + this._computeAngle(i, mode, defaultAngle);
                    var outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
                    angle = endAngle;
                    if (reset) {
                        if (animationOpts.animateScale) outerRadius = 0;
                        if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
                    }
                    var properties = {
                        x: centerX,
                        y: centerY,
                        innerRadius: 0,
                        outerRadius: outerRadius,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
                    };
                    this.updateElement(arc, i, properties, mode);
                }
            }
        },
        {
            key: "countVisibleElements",
            value: function countVisibleElements() {
                var _this = this;
                var meta = this._cachedMeta;
                var count = 0;
                meta.data.forEach(function(element, index) {
                    if (!isNaN(_this.getParsed(index).r) && _this.chart.getDataVisibility(index)) count++;
                });
                return count;
            }
        },
        {
            key: "_computeAngle",
            value: function _computeAngle(index, mode, defaultAngle) {
                return this.chart.getDataVisibility(index) ? (0, $3zT2Z.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
            }
        }
    ]);
    return PolarAreaController;
}(DatasetController);
(0, $6lD0P._)(PolarAreaController, "id", 'polarArea');
(0, $6lD0P._)(PolarAreaController, "defaults", {
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'startAngle',
                'endAngle',
                'innerRadius',
                'outerRadius'
            ]
        }
    },
    indexAxis: 'r',
    startAngle: 0
});
(0, $6lD0P._)(PolarAreaController, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, pointStyle = _chart_legend_options_labels.pointStyle, color = _chart_legend_options_labels.color;
                        return data.labels.map(function(label, i) {
                            var meta = chart.getDatasetMeta(0);
                            var style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                fontColor: color,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick: function(e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    },
    scales: {
        r: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
});
var PieController = /*#__PURE__*/ function(DoughnutController) {
    "use strict";
    (0, $dqNF0._)(PieController, DoughnutController);
    function PieController() {
        (0, $ioD88._)(this, PieController);
        return (0, $ctUVE._)(this, PieController, arguments);
    }
    return PieController;
}(DoughnutController);
(0, $6lD0P._)(PieController, "id", 'pie');
(0, $6lD0P._)(PieController, "defaults", {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: '100%'
});
var RadarController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $dqNF0._)(RadarController, DatasetController);
    function RadarController() {
        (0, $ioD88._)(this, RadarController);
        return (0, $ctUVE._)(this, RadarController, arguments);
    }
    (0, $6NCFa._)(RadarController, [
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var vScale = this._cachedMeta.vScale;
                var parsed = this.getParsed(index);
                return {
                    label: vScale.getLabels()[index],
                    value: '' + vScale.getLabelForValue(parsed[vScale.axis])
                };
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                return (0, $3zT2Z.y).bind(this)(meta, data, start, count);
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var meta = this._cachedMeta;
                var line = meta.dataset;
                var points = meta.data || [];
                var labels = meta.iScale.getLabels();
                line.points = points;
                if (mode !== 'resize') {
                    var options = this.resolveDatasetElementOptions(mode);
                    if (!this.options.showLine) options.borderWidth = 0;
                    var properties = {
                        _loop: true,
                        _fullLoop: labels.length === points.length,
                        options: options
                    };
                    this.updateElement(line, undefined, properties, mode);
                }
                this.updateElements(points, 0, points.length, mode);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(points, start, count, mode) {
                var scale = this._cachedMeta.rScale;
                var reset = mode === 'reset';
                for(var i = start; i < start + count; i++){
                    var point = points[i];
                    var options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                    var pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
                    var x = reset ? scale.xCenter : pointPosition.x;
                    var y = reset ? scale.yCenter : pointPosition.y;
                    var properties = {
                        x: x,
                        y: y,
                        angle: pointPosition.angle,
                        skip: isNaN(x) || isNaN(y),
                        options: options
                    };
                    this.updateElement(point, i, properties, mode);
                }
            }
        }
    ]);
    return RadarController;
}(DatasetController);
(0, $6lD0P._)(RadarController, "id", 'radar');
(0, $6lD0P._)(RadarController, "defaults", {
    datasetElementType: 'line',
    dataElementType: 'point',
    indexAxis: 'r',
    showLine: true,
    elements: {
        line: {
            fill: 'start'
        }
    }
});
(0, $6lD0P._)(RadarController, "overrides", {
    aspectRatio: 1,
    scales: {
        r: {
            type: 'radialLinear'
        }
    }
});
var ScatterController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $dqNF0._)(ScatterController, DatasetController);
    function ScatterController() {
        (0, $ioD88._)(this, ScatterController);
        return (0, $ctUVE._)(this, ScatterController, arguments);
    }
    (0, $6NCFa._)(ScatterController, [
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var labels = this.chart.data.labels || [];
                var xScale = meta.xScale, yScale = meta.yScale;
                var parsed = this.getParsed(index);
                var x = xScale.getLabelForValue(parsed.x);
                var y = yScale.getLabelForValue(parsed.y);
                return {
                    label: labels[index] || '',
                    value: '(' + x + ', ' + y + ')'
                };
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var meta = this._cachedMeta;
                var tmp = meta.data, points = tmp === void 0 ? [] : tmp;
                var animationsDisabled = this.chart._animationsDisabled;
                var _$_getStartAndCountOfVisiblePoints = (0, $3zT2Z.q)(meta, points, animationsDisabled), start = _$_getStartAndCountOfVisiblePoints.start, count = _$_getStartAndCountOfVisiblePoints.count;
                this._drawStart = start;
                this._drawCount = count;
                if ((0, $3zT2Z.w)(meta)) {
                    start = 0;
                    count = points.length;
                }
                if (this.options.showLine) {
                    if (!this.datasetElementType) this.addElements();
                    var line = meta.dataset, _dataset = meta._dataset;
                    line._chart = this.chart;
                    line._datasetIndex = this.index;
                    line._decimated = !!_dataset._decimated;
                    line.points = points;
                    var options = this.resolveDatasetElementOptions(mode);
                    options.segment = this.options.segment;
                    this.updateElement(line, undefined, {
                        animated: !animationsDisabled,
                        options: options
                    }, mode);
                } else if (this.datasetElementType) {
                    delete meta.dataset;
                    this.datasetElementType = false;
                }
                this.updateElements(points, start, count, mode);
            }
        },
        {
            key: "addElements",
            value: function addElements() {
                var showLine = this.options.showLine;
                if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
                (0, $9rJIv._)((0, $2HbS2._)(ScatterController.prototype), "addElements", this).call(this);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(points, start, count, mode) {
                var reset = mode === 'reset';
                var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, _dataset = _this__cachedMeta._dataset;
                var firstOpts = this.resolveDataElementOptions(start, mode);
                var sharedOptions = this.getSharedOptions(firstOpts);
                var includeOptions = this.includeOptions(mode, sharedOptions);
                var iAxis = iScale.axis;
                var vAxis = vScale.axis;
                var _this_options = this.options, spanGaps = _this_options.spanGaps, segment = _this_options.segment;
                var maxGapLength = (0, $3zT2Z.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
                var directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
                var prevParsed = start > 0 && this.getParsed(start - 1);
                for(var i = start; i < start + count; ++i){
                    var point = points[i];
                    var parsed = this.getParsed(i);
                    var properties = directUpdate ? point : {};
                    var nullData = (0, $3zT2Z.k)(parsed[vAxis]);
                    var iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
                    var vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
                    properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
                    properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
                    if (segment) {
                        properties.parsed = parsed;
                        properties.raw = _dataset.data[i];
                    }
                    if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                    if (!directUpdate) this.updateElement(point, i, properties, mode);
                    prevParsed = parsed;
                }
                this.updateSharedOptions(sharedOptions, mode, firstOpts);
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                var meta = this._cachedMeta;
                var data = meta.data || [];
                if (!this.options.showLine) {
                    var max = 0;
                    for(var i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
                    return max > 0 && max;
                }
                var dataset = meta.dataset;
                var border = dataset.options && dataset.options.borderWidth || 0;
                if (!data.length) return border;
                var firstPoint = data[0].size(this.resolveDataElementOptions(0));
                var lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
                return Math.max(border, firstPoint, lastPoint) / 2;
            }
        }
    ]);
    return ScatterController;
}(DatasetController);
(0, $6lD0P._)(ScatterController, "id", 'scatter');
(0, $6lD0P._)(ScatterController, "defaults", {
    datasetElementType: false,
    dataElementType: 'point',
    showLine: false,
    fill: false
});
(0, $6lD0P._)(ScatterController, "overrides", {
    interaction: {
        mode: 'point'
    },
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    }
});
var controllers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: BarController,
    BubbleController: BubbleController,
    DoughnutController: DoughnutController,
    LineController: LineController,
    PieController: PieController,
    PolarAreaController: PolarAreaController,
    RadarController: RadarController,
    ScatterController: ScatterController
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ var DateAdapterBase = /*#__PURE__*/ function() {
    "use strict";
    function DateAdapterBase(options) {
        (0, $ioD88._)(this, DateAdapterBase);
        (0, $6lD0P._)(this, "options", void 0);
        this.options = options || {};
    }
    (0, $6NCFa._)(DateAdapterBase, [
        {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            key: "init",
            value: function init() {}
        },
        {
            key: "formats",
            value: function formats() {
                return abstract();
            }
        },
        {
            key: "parse",
            value: function parse() {
                return abstract();
            }
        },
        {
            key: "format",
            value: function format() {
                return abstract();
            }
        },
        {
            key: "add",
            value: function add() {
                return abstract();
            }
        },
        {
            key: "diff",
            value: function diff() {
                return abstract();
            }
        },
        {
            key: "startOf",
            value: function startOf() {
                return abstract();
            }
        },
        {
            key: "endOf",
            value: function endOf() {
                return abstract();
            }
        }
    ], [
        {
            key: "override",
            value: /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ function override(members) {
                Object.assign(DateAdapterBase.prototype, members);
            }
        }
    ]);
    return DateAdapterBase;
}();
var adapters = {
    _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
    var controller = metaset.controller, data = metaset.data, _sorted = metaset._sorted;
    var iScale = controller._cachedMeta.iScale;
    var spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        var lookupMethod = iScale._reversePixels ? (0, $3zT2Z.A) : (0, $3zT2Z.B);
        if (!intersect) {
            var result = lookupMethod(data, axis, value);
            if (spanGaps) {
                var vScale = controller._cachedMeta.vScale;
                var _parsed = metaset._parsed;
                var distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex(function(point) {
                    return !(0, $3zT2Z.k)(point[vScale.axis]);
                });
                result.lo -= Math.max(0, distanceToDefinedLo);
                var distanceToDefinedHi = _parsed.slice(result.hi).findIndex(function(point) {
                    return !(0, $3zT2Z.k)(point[vScale.axis]);
                });
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            var el = data[0];
            var range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                var start = lookupMethod(data, axis, value - range);
                var end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    var metasets = chart.getSortedVisibleDatasetMetas();
    var value = position[axis];
    for(var i = 0, ilen = metasets.length; i < ilen; ++i){
        var _metasets_i = metasets[i], index = _metasets_i.index, data = _metasets_i.data;
        var _binarySearch = binarySearch(metasets[i], axis, value, intersect), lo = _binarySearch.lo, hi = _binarySearch.hi;
        for(var j = lo; j <= hi; ++j){
            var element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function getDistanceMetricForAxis(axis) {
    var useX = axis.indexOf('x') !== -1;
    var useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    var items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    var evaluationFunc = function evaluationFunc(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $3zT2Z.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    var items = [];
    function evaluationFunc(element, datasetIndex, index) {
        var _element_getProps = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition), startAngle = _element_getProps.startAngle, endAngle = _element_getProps.endAngle;
        var angle = (0, $3zT2Z.D)(element, {
            x: position.x,
            y: position.y
        }).angle;
        if ((0, $3zT2Z.p)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    var items = [];
    var distanceMetric = getDistanceMetricForAxis(axis);
    var minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        var inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        var center = element.getCenterPoint(useFinalPosition);
        var pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        var distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    var items = [];
    var rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    var intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, function(element, datasetIndex, index) {
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var Interaction = {
    evaluateInteractionItems: evaluateInteractionItems,
    modes: {
        index: function(chart, e, options, useFinalPosition) {
            var position = (0, $3zT2Z.z)(e, chart);
            var axis = options.axis || 'x';
            var includeInvisible = options.includeInvisible || false;
            var items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            var elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach(function(meta) {
                var index = items[0].index;
                var element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset: function(chart, e, options, useFinalPosition) {
            var position = (0, $3zT2Z.z)(e, chart);
            var axis = options.axis || 'xy';
            var includeInvisible = options.includeInvisible || false;
            var items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                var datasetIndex = items[0].datasetIndex;
                var data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(var i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point: function(chart, e, options, useFinalPosition) {
            var position = (0, $3zT2Z.z)(e, chart);
            var axis = options.axis || 'xy';
            var includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest: function(chart, e, options, useFinalPosition) {
            var position = (0, $3zT2Z.z)(e, chart);
            var axis = options.axis || 'xy';
            var includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x: function(chart, e, options, useFinalPosition) {
            var position = (0, $3zT2Z.z)(e, chart);
            return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y: function(chart, e, options, useFinalPosition) {
            var position = (0, $3zT2Z.z)(e, chart);
            return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
var STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function filterByPosition(array, position) {
    return array.filter(function(v) {
        return v.pos === position;
    });
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter(function(v) {
        return STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis;
    });
}
function sortByWeight(array, reverse) {
    return array.sort(function(a, b) {
        var v0 = reverse ? b : a;
        var v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    var layoutBoxes = [];
    var i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        var ref, ref1, ref2;
        ref = box, pos = ref.position, ref1 = ref.options, stack = ref1.stack, ref2 = ref1.stackWeight, stackWeight = ref2 === void 0 ? 1 : ref2, ref1, ref;
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    var stacks = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = layouts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var wrap = _step.value;
            var stack = wrap.stack, pos = wrap.pos, stackWeight = wrap.stackWeight;
            if (!stack || !STATIC_POSITIONS.includes(pos)) continue;
            var _stack = stacks[stack] || (stacks[stack] = {
                count: 0,
                placed: 0,
                weight: 0,
                size: 0
            });
            _stack.count++;
            _stack.weight += stackWeight;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return stacks;
}
function setLayoutDims(layouts, params) {
    var stacks = buildStacks(layouts);
    var vBoxMaxWidth = params.vBoxMaxWidth, hBoxMaxHeight = params.hBoxMaxHeight;
    var i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        var fullSize = layout.box.fullSize;
        var stack = stacks[layout.stack];
        var factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    var layoutBoxes = wrapBoxes(boxes);
    var fullSize = sortByWeight(layoutBoxes.filter(function(wrap) {
        return wrap.box.fullSize;
    }), true);
    var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    var centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
    var centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    var pos = layout.pos, box = layout.box;
    var maxPadding = chartArea.maxPadding;
    if (!(0, $3zT2Z.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        var stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) updateMaxPadding(maxPadding, box.getPadding());
    var newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    var newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    var widthChanged = newWidth !== chartArea.w;
    var heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    var maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
    var maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        var margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach(function(pos) {
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    var refitBoxes = [];
    var i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        var _updateDims = updateDims(chartArea, params, layout, stacks), same = _updateDims.same, other = _updateDims.other;
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    var userPadding = params.padding;
    var x = chartArea.x, y = chartArea.y;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = boxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var layout = _step.value;
            var box = layout.box;
            var stack = stacks[layout.stack] || {
                count: 1,
                placed: 0,
                weight: 1
            };
            var weight = layout.stackWeight / stack.weight || 1;
            if (layout.horizontal) {
                var width = chartArea.w * weight;
                var height = stack.size || box.height;
                if ((0, $3zT2Z.h)(stack.start)) y = stack.start;
                if (box.fullSize) setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
                else setBoxDims(box, chartArea.left + stack.placed, y, width, height);
                stack.start = y;
                stack.placed += width;
                y = box.bottom;
            } else {
                var height1 = chartArea.h * weight;
                var width1 = stack.size || box.width;
                if ((0, $3zT2Z.h)(stack.start)) x = stack.start;
                if (box.fullSize) setBoxDims(box, x, userPadding.top, width1, params.outerHeight - userPadding.bottom - userPadding.top);
                else setBoxDims(box, x, chartArea.top + stack.placed, width1, height1);
                stack.start = x;
                stack.placed += height1;
                x = box.right;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
    addBox: function(chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw: function(chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox: function(chart, layoutItem) {
        var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure: function(chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update: function(chart, width, height, minPadding) {
        if (!chart) return;
        var padding = (0, $3zT2Z.E)(chart.options.layout.padding);
        var availableWidth = Math.max(width - padding.width, 0);
        var availableHeight = Math.max(height - padding.height, 0);
        var boxes = buildLayoutBoxes(chart.boxes);
        var verticalBoxes = boxes.vertical;
        var horizontalBoxes = boxes.horizontal;
        (0, $3zT2Z.F)(chart.boxes, function(box) {
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        var visibleVerticalBoxCount = verticalBoxes.reduce(function(total, wrap) {
            return wrap.box.options && wrap.box.options.display === false ? total : total + 1;
        }, 0) || 1;
        var params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        var maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, (0, $3zT2Z.E)(minPadding));
        var chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        var stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) fitBoxes(verticalBoxes, chartArea, params, stacks);
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $3zT2Z.F)(boxes.chartArea, function(layout) {
            var box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
var BasePlatform = /*#__PURE__*/ function() {
    "use strict";
    function BasePlatform() {
        (0, $ioD88._)(this, BasePlatform);
    }
    (0, $6NCFa._)(BasePlatform, [
        {
            key: "acquireContext",
            value: function acquireContext(canvas, aspectRatio) {}
        },
        {
            key: "releaseContext",
            value: function releaseContext(context) {
                return false;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(chart, type, listener) {}
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(chart, type, listener) {}
        },
        {
            key: "getDevicePixelRatio",
            value: function getDevicePixelRatio() {
                return 1;
            }
        },
        {
            key: "getMaximumSize",
            value: function getMaximumSize(element, width, height, aspectRatio) {
                width = Math.max(0, width || element.width);
                height = height || element.height;
                return {
                    width: width,
                    height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
                };
            }
        },
        {
            key: "isAttached",
            value: function isAttached(canvas) {
                return true;
            }
        },
        {
            key: "updateConfig",
            value: function updateConfig(config) {}
        }
    ]);
    return BasePlatform;
}();
var BasicPlatform = /*#__PURE__*/ function(BasePlatform) {
    "use strict";
    (0, $dqNF0._)(BasicPlatform, BasePlatform);
    function BasicPlatform() {
        (0, $ioD88._)(this, BasicPlatform);
        return (0, $ctUVE._)(this, BasicPlatform, arguments);
    }
    (0, $6NCFa._)(BasicPlatform, [
        {
            key: "acquireContext",
            value: function acquireContext(item) {
                return item && item.getContext && item.getContext('2d') || null;
            }
        },
        {
            key: "updateConfig",
            value: function updateConfig(config) {
                config.options.animation = false;
            }
        }
    ]);
    return BasicPlatform;
}(BasePlatform);
var EXPANDO_KEY = '$chartjs';
var EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
var isNullOrEmpty = function(value) {
    return value === null || value === '';
};
function initCanvas(canvas, aspectRatio) {
    var style = canvas.style;
    var renderHeight = canvas.getAttribute('height');
    var renderWidth = canvas.getAttribute('width');
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if (isNullOrEmpty(renderWidth)) {
        var displayWidth = (0, $3zT2Z.J)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            var displayHeight = (0, $3zT2Z.J)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
var eventListenerOptions = (0, $3zT2Z.K) ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
    var type = EVENT_TYPES[event.type] || event.type;
    var _getRelativePosition = (0, $3zT2Z.z)(event, chart), x = _getRelativePosition.x, y = _getRelativePosition.y;
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nodeList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (node === canvas || node.contains(canvas)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function createAttachObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var observer = new MutationObserver(function(entries) {
        var trigger = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                trigger = trigger || nodeListContains(entry.addedNodes, canvas);
                trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var observer = new MutationObserver(function(entries) {
        var trigger = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                trigger = trigger || nodeListContains(entry.removedNodes, canvas);
                trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
var drpListeningCharts = new Map();
var oldDevicePixelRatio = 0;
function onWindowResize() {
    var dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) return;
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach(function(resize, chart) {
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) window.addEventListener('resize', onWindowResize);
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) window.removeEventListener('resize', onWindowResize);
}
function createResizeObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var container = canvas && (0, $3zT2Z.I)(canvas);
    if (!container) return;
    var resize = (0, $3zT2Z.L)(function(width, height) {
        var w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    var observer = new ResizeObserver(function(entries) {
        var entry = entries[0];
        var width = entry.contentRect.width;
        var height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') unlistenDevicePixelRatioChanges(chart);
}
function createProxyAndListen(chart, type, listener) {
    var canvas = chart.canvas;
    var proxy = (0, $3zT2Z.L)(function(event) {
        if (chart.ctx !== null) listener(fromNativeEvent(event, chart));
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
var DomPlatform = /*#__PURE__*/ function(BasePlatform) {
    "use strict";
    (0, $dqNF0._)(DomPlatform, BasePlatform);
    function DomPlatform() {
        (0, $ioD88._)(this, DomPlatform);
        return (0, $ctUVE._)(this, DomPlatform, arguments);
    }
    (0, $6NCFa._)(DomPlatform, [
        {
            key: "acquireContext",
            value: function acquireContext(canvas, aspectRatio) {
                var context = canvas && canvas.getContext && canvas.getContext('2d');
                if (context && context.canvas === canvas) {
                    initCanvas(canvas, aspectRatio);
                    return context;
                }
                return null;
            }
        },
        {
            key: "releaseContext",
            value: function releaseContext(context) {
                var canvas = context.canvas;
                if (!canvas[EXPANDO_KEY]) return false;
                var initial = canvas[EXPANDO_KEY].initial;
                [
                    'height',
                    'width'
                ].forEach(function(prop) {
                    var value = initial[prop];
                    if ((0, $3zT2Z.k)(value)) canvas.removeAttribute(prop);
                    else canvas.setAttribute(prop, value);
                });
                var style = initial.style || {};
                Object.keys(style).forEach(function(key) {
                    canvas.style[key] = style[key];
                });
                canvas.width = canvas.width;
                delete canvas[EXPANDO_KEY];
                return true;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(chart, type, listener) {
                this.removeEventListener(chart, type);
                var proxies = chart.$proxies || (chart.$proxies = {});
                var handlers = {
                    attach: createAttachObserver,
                    detach: createDetachObserver,
                    resize: createResizeObserver
                };
                var handler = handlers[type] || createProxyAndListen;
                proxies[type] = handler(chart, type, listener);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(chart, type) {
                var proxies = chart.$proxies || (chart.$proxies = {});
                var proxy = proxies[type];
                if (!proxy) return;
                var handlers = {
                    attach: releaseObserver,
                    detach: releaseObserver,
                    resize: releaseObserver
                };
                var handler = handlers[type] || removeListener;
                handler(chart, type, proxy);
                proxies[type] = undefined;
            }
        },
        {
            key: "getDevicePixelRatio",
            value: function getDevicePixelRatio() {
                return window.devicePixelRatio;
            }
        },
        {
            key: "getMaximumSize",
            value: function getMaximumSize1(canvas, width, height, aspectRatio) {
                return (0, $3zT2Z.G)(canvas, width, height, aspectRatio);
            }
        },
        {
            key: "isAttached",
            value: function isAttached(canvas) {
                var container = canvas && (0, $3zT2Z.I)(canvas);
                return !!(container && container.isConnected);
            }
        }
    ]);
    return DomPlatform;
}(BasePlatform);
function _detectPlatform(canvas) {
    if (!(0, $3zT2Z.M)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return BasicPlatform;
    return DomPlatform;
}
var Element = /*#__PURE__*/ function() {
    "use strict";
    function Element() {
        (0, $ioD88._)(this, Element);
        (0, $6lD0P._)(this, "x", void 0);
        (0, $6lD0P._)(this, "y", void 0);
        (0, $6lD0P._)(this, "active", false);
        (0, $6lD0P._)(this, "options", void 0);
        (0, $6lD0P._)(this, "$animations", void 0);
    }
    (0, $6NCFa._)(Element, [
        {
            key: "tooltipPosition",
            value: function tooltipPosition(useFinalPosition) {
                var _this_getProps = this.getProps([
                    'x',
                    'y'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
                return {
                    x: x,
                    y: y
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                return (0, $3zT2Z.x)(this.x) && (0, $3zT2Z.x)(this.y);
            }
        },
        {
            key: "getProps",
            value: function getProps(props, final) {
                var _this = this;
                var anims = this.$animations;
                if (!final || !anims) // let's not create an object, if not needed
                return this;
                var ret = {};
                props.forEach(function(prop) {
                    ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : _this[prop];
                });
                return ret;
            }
        }
    ]);
    return Element;
}();
(0, $6lD0P._)(Element, "defaults", {});
(0, $6lD0P._)(Element, "defaultRoutes", undefined);
function autoSkip(scale, ticks) {
    var tickOpts = scale.options.ticks;
    var determinedMaxTicks = determineMaxTicks(scale);
    var ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    var numMajorIndices = majorIndices.length;
    var first = majorIndices[0];
    var last = majorIndices[numMajorIndices - 1];
    var newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    var spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        var i, ilen;
        var avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, (0, $3zT2Z.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        skip(ticks, newTicks, spacing, last, (0, $3zT2Z.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    var offset = scale.options.offset;
    var tickLength = scale._tickSize();
    var maxScale = scale._length / tickLength + (offset ? 0 : 1);
    var maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
    var evenMajorSpacing = getEvenSpacing(majorIndices);
    var spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    var factors = (0, $3zT2Z.N)(evenMajorSpacing);
    for(var i = 0, ilen = factors.length - 1; i < ilen; i++){
        var factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
    var result = [];
    var i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
    var count = 0;
    var next = majorIndices[0];
    var i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    var start = (0, $3zT2Z.v)(majorStart, 0);
    var end = Math.min((0, $3zT2Z.v)(majorEnd, ticks.length), ticks.length);
    var count = 0;
    var length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function getEvenSpacing(arr) {
    var len = arr.length;
    var i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
var reverseAlign = function(align) {
    return align === 'left' ? 'right' : align === 'right' ? 'left' : align;
};
var offsetFromEdge = function(scale, edge, offset) {
    return edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
};
var getTicksLimit = function(ticksLength, maxTicksLimit) {
    return Math.min(maxTicksLimit || ticksLength, ticksLength);
};
function sample(arr, numItems) {
    var result = [];
    var increment = arr.length / numItems;
    var len = arr.length;
    var i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
    var length = scale.ticks.length;
    var validIndex = Math.min(index, length - 1);
    var start = scale._startPixel;
    var end = scale._endPixel;
    var epsilon = 1e-6;
    var lineValue = scale.getPixelForTick(validIndex);
    var offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function garbageCollect(caches, length) {
    (0, $3zT2Z.F)(caches, function(cache) {
        var gc = cache.gc;
        var gcLen = gc.length / 2;
        var i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    var font = (0, $3zT2Z.a0)(options.font, fallback);
    var padding = (0, $3zT2Z.E)(options.padding);
    var lines = (0, $3zT2Z.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return (0, $3zT2Z.j)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function createTickContext(parent, index, tick) {
    return (0, $3zT2Z.j)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function titleAlign(align, position, reverse) {
    var ret = (0, $3zT2Z.a1)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = reverseAlign(ret);
    return ret;
}
function titleArgs(scale, offset, position, align) {
    var top = scale.top, left = scale.left, bottom = scale.bottom, right = scale.right, chart = scale.chart;
    var chartArea = chart.chartArea, scales = chart.scales;
    var rotation = 0;
    var maxWidth, titleX, titleY;
    var height = bottom - top;
    var width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $3zT2Z.a2)(align, left, right);
        if ((0, $3zT2Z.i)(position)) {
            var positionAxisID = Object.keys(position)[0];
            var value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $3zT2Z.i)(position)) {
            var positionAxisID1 = Object.keys(position)[0];
            var value1 = position[positionAxisID1];
            titleX = scales[positionAxisID1].getPixelForValue(value1) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = offsetFromEdge(scale, position, offset);
        titleY = (0, $3zT2Z.a2)(align, bottom, top);
        rotation = position === 'left' ? -(0, $3zT2Z.H) : (0, $3zT2Z.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
var Scale = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $dqNF0._)(Scale, Element);
    function Scale(cfg) {
        (0, $ioD88._)(this, Scale);
        var _this;
        _this = (0, $ctUVE._)(this, Scale);
        _this.id = cfg.id;
        _this.type = cfg.type;
        _this.options = undefined;
        _this.ctx = cfg.ctx;
        _this.chart = cfg.chart;
        _this.top = undefined;
        _this.bottom = undefined;
        _this.left = undefined;
        _this.right = undefined;
        _this.width = undefined;
        _this.height = undefined;
        _this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        _this.maxWidth = undefined;
        _this.maxHeight = undefined;
        _this.paddingTop = undefined;
        _this.paddingBottom = undefined;
        _this.paddingLeft = undefined;
        _this.paddingRight = undefined;
        _this.axis = undefined;
        _this.labelRotation = undefined;
        _this.min = undefined;
        _this.max = undefined;
        _this._range = undefined;
        _this.ticks = [];
        _this._gridLineItems = null;
        _this._labelItems = null;
        _this._labelSizes = null;
        _this._length = 0;
        _this._maxLength = 0;
        _this._longestTextCache = {};
        _this._startPixel = undefined;
        _this._endPixel = undefined;
        _this._reversePixels = false;
        _this._userMax = undefined;
        _this._userMin = undefined;
        _this._suggestedMax = undefined;
        _this._suggestedMin = undefined;
        _this._ticksLength = 0;
        _this._borderValue = 0;
        _this._cache = {};
        _this._dataLimitsCached = false;
        _this.$context = undefined;
        return _this;
    }
    (0, $6NCFa._)(Scale, [
        {
            key: "init",
            value: function init(options) {
                this.options = options.setContext(this.getContext());
                this.axis = options.axis;
                this._userMin = this.parse(options.min);
                this._userMax = this.parse(options.max);
                this._suggestedMin = this.parse(options.suggestedMin);
                this._suggestedMax = this.parse(options.suggestedMax);
            }
        },
        {
            key: "parse",
            value: function parse(raw, index) {
                return raw;
            }
        },
        {
            key: "getUserBounds",
            value: function getUserBounds() {
                var _this = this, _userMin = _this._userMin, _userMax = _this._userMax, _suggestedMin = _this._suggestedMin, _suggestedMax = _this._suggestedMax;
                _userMin = (0, $3zT2Z.O)(_userMin, Number.POSITIVE_INFINITY);
                _userMax = (0, $3zT2Z.O)(_userMax, Number.NEGATIVE_INFINITY);
                _suggestedMin = (0, $3zT2Z.O)(_suggestedMin, Number.POSITIVE_INFINITY);
                _suggestedMax = (0, $3zT2Z.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
                return {
                    min: (0, $3zT2Z.O)(_userMin, _suggestedMin),
                    max: (0, $3zT2Z.O)(_userMax, _suggestedMax),
                    minDefined: (0, $3zT2Z.g)(_userMin),
                    maxDefined: (0, $3zT2Z.g)(_userMax)
                };
            }
        },
        {
            key: "getMinMax",
            value: function getMinMax(canStack) {
                var _this_getUserBounds = this.getUserBounds(), min = _this_getUserBounds.min, max = _this_getUserBounds.max, minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                var range;
                if (minDefined && maxDefined) return {
                    min: min,
                    max: max
                };
                var metas = this.getMatchingVisibleMetas();
                for(var i = 0, ilen = metas.length; i < ilen; ++i){
                    range = metas[i].controller.getMinMax(this, canStack);
                    if (!minDefined) min = Math.min(min, range.min);
                    if (!maxDefined) max = Math.max(max, range.max);
                }
                min = maxDefined && min > max ? max : min;
                max = minDefined && min > max ? min : max;
                return {
                    min: (0, $3zT2Z.O)(min, (0, $3zT2Z.O)(max, min)),
                    max: (0, $3zT2Z.O)(max, (0, $3zT2Z.O)(min, max))
                };
            }
        },
        {
            key: "getPadding",
            value: function getPadding() {
                return {
                    left: this.paddingLeft || 0,
                    top: this.paddingTop || 0,
                    right: this.paddingRight || 0,
                    bottom: this.paddingBottom || 0
                };
            }
        },
        {
            key: "getTicks",
            value: function getTicks() {
                return this.ticks;
            }
        },
        {
            key: "getLabels",
            value: function getLabels() {
                var data = this.chart.data;
                return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
            }
        },
        {
            key: "getLabelItems",
            value: function getLabelItems() {
                var chartArea = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.chart.chartArea;
                var items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
                return items;
            }
        },
        {
            key: "beforeLayout",
            value: function beforeLayout() {
                this._cache = {};
                this._dataLimitsCached = false;
            }
        },
        {
            key: "beforeUpdate",
            value: function beforeUpdate() {
                (0, $3zT2Z.Q)(this.options.beforeUpdate, [
                    this
                ]);
            }
        },
        {
            key: "update",
            value: function update(maxWidth, maxHeight, margins) {
                var _this_options = this.options, beginAtZero = _this_options.beginAtZero, grace = _this_options.grace, tickOpts = _this_options.ticks;
                var sampleSize = tickOpts.sampleSize;
                this.beforeUpdate();
                this.maxWidth = maxWidth;
                this.maxHeight = maxHeight;
                this._margins = margins = Object.assign({
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }, margins);
                this.ticks = null;
                this._labelSizes = null;
                this._gridLineItems = null;
                this._labelItems = null;
                this.beforeSetDimensions();
                this.setDimensions();
                this.afterSetDimensions();
                this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
                if (!this._dataLimitsCached) {
                    this.beforeDataLimits();
                    this.determineDataLimits();
                    this.afterDataLimits();
                    this._range = (0, $3zT2Z.R)(this, grace, beginAtZero);
                    this._dataLimitsCached = true;
                }
                this.beforeBuildTicks();
                this.ticks = this.buildTicks() || [];
                this.afterBuildTicks();
                var samplingEnabled = sampleSize < this.ticks.length;
                this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
                this.configure();
                this.beforeCalculateLabelRotation();
                this.calculateLabelRotation();
                this.afterCalculateLabelRotation();
                if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
                    this.ticks = autoSkip(this, this.ticks);
                    this._labelSizes = null;
                    this.afterAutoSkip();
                }
                if (samplingEnabled) this._convertTicksToLabels(this.ticks);
                this.beforeFit();
                this.fit();
                this.afterFit();
                this.afterUpdate();
            }
        },
        {
            key: "configure",
            value: function configure() {
                var reversePixels = this.options.reverse;
                var startPixel, endPixel;
                if (this.isHorizontal()) {
                    startPixel = this.left;
                    endPixel = this.right;
                } else {
                    startPixel = this.top;
                    endPixel = this.bottom;
                    reversePixels = !reversePixels;
                }
                this._startPixel = startPixel;
                this._endPixel = endPixel;
                this._reversePixels = reversePixels;
                this._length = endPixel - startPixel;
                this._alignToPixels = this.options.alignToPixels;
            }
        },
        {
            key: "afterUpdate",
            value: function afterUpdate() {
                (0, $3zT2Z.Q)(this.options.afterUpdate, [
                    this
                ]);
            }
        },
        {
            key: "beforeSetDimensions",
            value: function beforeSetDimensions() {
                (0, $3zT2Z.Q)(this.options.beforeSetDimensions, [
                    this
                ]);
            }
        },
        {
            key: "setDimensions",
            value: function setDimensions() {
                if (this.isHorizontal()) {
                    this.width = this.maxWidth;
                    this.left = 0;
                    this.right = this.width;
                } else {
                    this.height = this.maxHeight;
                    this.top = 0;
                    this.bottom = this.height;
                }
                this.paddingLeft = 0;
                this.paddingTop = 0;
                this.paddingRight = 0;
                this.paddingBottom = 0;
            }
        },
        {
            key: "afterSetDimensions",
            value: function afterSetDimensions() {
                (0, $3zT2Z.Q)(this.options.afterSetDimensions, [
                    this
                ]);
            }
        },
        {
            key: "_callHooks",
            value: function _callHooks(name) {
                this.chart.notifyPlugins(name, this.getContext());
                (0, $3zT2Z.Q)(this.options[name], [
                    this
                ]);
            }
        },
        {
            key: "beforeDataLimits",
            value: function beforeDataLimits() {
                this._callHooks('beforeDataLimits');
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {}
        },
        {
            key: "afterDataLimits",
            value: function afterDataLimits() {
                this._callHooks('afterDataLimits');
            }
        },
        {
            key: "beforeBuildTicks",
            value: function beforeBuildTicks() {
                this._callHooks('beforeBuildTicks');
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                return [];
            }
        },
        {
            key: "afterBuildTicks",
            value: function afterBuildTicks() {
                this._callHooks('afterBuildTicks');
            }
        },
        {
            key: "beforeTickToLabelConversion",
            value: function beforeTickToLabelConversion() {
                (0, $3zT2Z.Q)(this.options.beforeTickToLabelConversion, [
                    this
                ]);
            }
        },
        {
            key: "generateTickLabels",
            value: function generateTickLabels(ticks) {
                var tickOpts = this.options.ticks;
                var i, ilen, tick;
                for(i = 0, ilen = ticks.length; i < ilen; i++){
                    tick = ticks[i];
                    tick.label = (0, $3zT2Z.Q)(tickOpts.callback, [
                        tick.value,
                        i,
                        ticks
                    ], this);
                }
            }
        },
        {
            key: "afterTickToLabelConversion",
            value: function afterTickToLabelConversion() {
                (0, $3zT2Z.Q)(this.options.afterTickToLabelConversion, [
                    this
                ]);
            }
        },
        {
            key: "beforeCalculateLabelRotation",
            value: function beforeCalculateLabelRotation() {
                (0, $3zT2Z.Q)(this.options.beforeCalculateLabelRotation, [
                    this
                ]);
            }
        },
        {
            key: "calculateLabelRotation",
            value: function calculateLabelRotation() {
                var options = this.options;
                var tickOpts = options.ticks;
                var numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
                var minRotation = tickOpts.minRotation || 0;
                var maxRotation = tickOpts.maxRotation;
                var labelRotation = minRotation;
                var tickWidth, maxHeight, maxLabelDiagonal;
                if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
                    this.labelRotation = minRotation;
                    return;
                }
                var labelSizes = this._getLabelSizes();
                var maxLabelWidth = labelSizes.widest.width;
                var maxLabelHeight = labelSizes.highest.height;
                var maxWidth = (0, $3zT2Z.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
                tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
                if (maxLabelWidth + 6 > tickWidth) {
                    tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                    maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
                    maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                    labelRotation = (0, $3zT2Z.U)(Math.min(Math.asin((0, $3zT2Z.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $3zT2Z.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $3zT2Z.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
                    labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
                }
                this.labelRotation = labelRotation;
            }
        },
        {
            key: "afterCalculateLabelRotation",
            value: function afterCalculateLabelRotation() {
                (0, $3zT2Z.Q)(this.options.afterCalculateLabelRotation, [
                    this
                ]);
            }
        },
        {
            key: "afterAutoSkip",
            value: function afterAutoSkip() {}
        },
        {
            key: "beforeFit",
            value: function beforeFit() {
                (0, $3zT2Z.Q)(this.options.beforeFit, [
                    this
                ]);
            }
        },
        {
            key: "fit",
            value: function fit() {
                var minSize = {
                    width: 0,
                    height: 0
                };
                var _this = this, chart = _this.chart, _this_options = _this.options, tickOpts = _this_options.ticks, titleOpts = _this_options.title, gridOpts = _this_options.grid;
                var display = this._isVisible();
                var isHorizontal = this.isHorizontal();
                if (display) {
                    var titleHeight = getTitleHeight(titleOpts, chart.options.font);
                    if (isHorizontal) {
                        minSize.width = this.maxWidth;
                        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
                    } else {
                        minSize.height = this.maxHeight;
                        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
                    }
                    if (tickOpts.display && this.ticks.length) {
                        var _this__getLabelSizes = this._getLabelSizes(), first = _this__getLabelSizes.first, last = _this__getLabelSizes.last, widest = _this__getLabelSizes.widest, highest = _this__getLabelSizes.highest;
                        var tickPadding = tickOpts.padding * 2;
                        var angleRadians = (0, $3zT2Z.t)(this.labelRotation);
                        var cos = Math.cos(angleRadians);
                        var sin = Math.sin(angleRadians);
                        if (isHorizontal) {
                            var labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                            minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                        } else {
                            var labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                            minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                        }
                        this._calculatePadding(first, last, sin, cos);
                    }
                }
                this._handleMargins();
                if (isHorizontal) {
                    this.width = this._length = chart.width - this._margins.left - this._margins.right;
                    this.height = minSize.height;
                } else {
                    this.width = minSize.width;
                    this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
                }
            }
        },
        {
            key: "_calculatePadding",
            value: function _calculatePadding(first, last, sin, cos) {
                var _this_options = this.options, _this_options_ticks = _this_options.ticks, align = _this_options_ticks.align, padding = _this_options_ticks.padding, position = _this_options.position;
                var isRotated = this.labelRotation !== 0;
                var labelsBelowTicks = position !== 'top' && this.axis === 'x';
                if (this.isHorizontal()) {
                    var offsetLeft = this.getPixelForTick(0) - this.left;
                    var offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
                    var paddingLeft = 0;
                    var paddingRight = 0;
                    if (isRotated) {
                        if (labelsBelowTicks) {
                            paddingLeft = cos * first.width;
                            paddingRight = sin * last.height;
                        } else {
                            paddingLeft = sin * first.height;
                            paddingRight = cos * last.width;
                        }
                    } else if (align === 'start') paddingRight = last.width;
                    else if (align === 'end') paddingLeft = first.width;
                    else if (align !== 'inner') {
                        paddingLeft = first.width / 2;
                        paddingRight = last.width / 2;
                    }
                    this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
                    this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
                } else {
                    var paddingTop = last.height / 2;
                    var paddingBottom = first.height / 2;
                    if (align === 'start') {
                        paddingTop = 0;
                        paddingBottom = first.height;
                    } else if (align === 'end') {
                        paddingTop = last.height;
                        paddingBottom = 0;
                    }
                    this.paddingTop = paddingTop + padding;
                    this.paddingBottom = paddingBottom + padding;
                }
            }
        },
        {
            key: "_handleMargins",
            value: function _handleMargins() {
                if (this._margins) {
                    this._margins.left = Math.max(this.paddingLeft, this._margins.left);
                    this._margins.top = Math.max(this.paddingTop, this._margins.top);
                    this._margins.right = Math.max(this.paddingRight, this._margins.right);
                    this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
                }
            }
        },
        {
            key: "afterFit",
            value: function afterFit() {
                (0, $3zT2Z.Q)(this.options.afterFit, [
                    this
                ]);
            }
        },
        {
            key: "isHorizontal",
            value: function isHorizontal() {
                var _this_options = this.options, axis = _this_options.axis, position = _this_options.position;
                return position === 'top' || position === 'bottom' || axis === 'x';
            }
        },
        {
            key: "isFullSize",
            value: function isFullSize() {
                return this.options.fullSize;
            }
        },
        {
            key: "_convertTicksToLabels",
            value: function _convertTicksToLabels(ticks) {
                this.beforeTickToLabelConversion();
                this.generateTickLabels(ticks);
                var i, ilen;
                for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $3zT2Z.k)(ticks[i].label)) {
                    ticks.splice(i, 1);
                    ilen--;
                    i--;
                }
                this.afterTickToLabelConversion();
            }
        },
        {
            key: "_getLabelSizes",
            value: function _getLabelSizes() {
                var labelSizes = this._labelSizes;
                if (!labelSizes) {
                    var sampleSize = this.options.ticks.sampleSize;
                    var ticks = this.ticks;
                    if (sampleSize < ticks.length) ticks = sample(ticks, sampleSize);
                    this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
                }
                return labelSizes;
            }
        },
        {
            key: "_computeLabelSizes",
            value: function _computeLabelSizes(ticks, length, maxTicksLimit) {
                var _this = this, ctx = _this.ctx, caches = _this._longestTextCache;
                var widths = [];
                var heights = [];
                var increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
                var widestLabelSize = 0;
                var highestLabelSize = 0;
                var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
                for(i = 0; i < length; i += increment){
                    label = ticks[i].label;
                    tickFont = this._resolveTickFontOptions(i);
                    ctx.font = fontString = tickFont.string;
                    cache = caches[fontString] = caches[fontString] || {
                        data: {},
                        gc: []
                    };
                    lineHeight = tickFont.lineHeight;
                    width = height = 0;
                    if (!(0, $3zT2Z.k)(label) && !(0, $3zT2Z.b)(label)) {
                        width = (0, $3zT2Z.V)(ctx, cache.data, cache.gc, width, label);
                        height = lineHeight;
                    } else if ((0, $3zT2Z.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                        nestedLabel = label[j];
                        if (!(0, $3zT2Z.k)(nestedLabel) && !(0, $3zT2Z.b)(nestedLabel)) {
                            width = (0, $3zT2Z.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                            height += lineHeight;
                        }
                    }
                    widths.push(width);
                    heights.push(height);
                    widestLabelSize = Math.max(width, widestLabelSize);
                    highestLabelSize = Math.max(height, highestLabelSize);
                }
                garbageCollect(caches, length);
                var widest = widths.indexOf(widestLabelSize);
                var highest = heights.indexOf(highestLabelSize);
                var valueAt = function(idx) {
                    return {
                        width: widths[idx] || 0,
                        height: heights[idx] || 0
                    };
                };
                return {
                    first: valueAt(0),
                    last: valueAt(length - 1),
                    widest: valueAt(widest),
                    highest: valueAt(highest),
                    widths: widths,
                    heights: heights
                };
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                return value;
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value, index) {
                return NaN;
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {}
        },
        {
            key: "getPixelForTick",
            value: function getPixelForTick(index) {
                var ticks = this.ticks;
                if (index < 0 || index > ticks.length - 1) return null;
                return this.getPixelForValue(ticks[index].value);
            }
        },
        {
            key: "getPixelForDecimal",
            value: function getPixelForDecimal(decimal) {
                if (this._reversePixels) decimal = 1 - decimal;
                var pixel = this._startPixel + decimal * this._length;
                return (0, $3zT2Z.W)(this._alignToPixels ? (0, $3zT2Z.X)(this.chart, pixel, 0) : pixel);
            }
        },
        {
            key: "getDecimalForPixel",
            value: function getDecimalForPixel(pixel) {
                var decimal = (pixel - this._startPixel) / this._length;
                return this._reversePixels ? 1 - decimal : decimal;
            }
        },
        {
            key: "getBasePixel",
            value: function getBasePixel() {
                return this.getPixelForValue(this.getBaseValue());
            }
        },
        {
            key: "getBaseValue",
            value: function getBaseValue() {
                var _this = this, min = _this.min, max = _this.max;
                return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
            }
        },
        {
            key: "getContext",
            value: function getContext(index) {
                var ticks = this.ticks || [];
                if (index >= 0 && index < ticks.length) {
                    var tick = ticks[index];
                    return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
                }
                return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
            }
        },
        {
            key: "_tickSize",
            value: function _tickSize() {
                var optionTicks = this.options.ticks;
                var rot = (0, $3zT2Z.t)(this.labelRotation);
                var cos = Math.abs(Math.cos(rot));
                var sin = Math.abs(Math.sin(rot));
                var labelSizes = this._getLabelSizes();
                var padding = optionTicks.autoSkipPadding || 0;
                var w = labelSizes ? labelSizes.widest.width + padding : 0;
                var h = labelSizes ? labelSizes.highest.height + padding : 0;
                return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
            }
        },
        {
            key: "_isVisible",
            value: function _isVisible() {
                var display = this.options.display;
                if (display !== 'auto') return !!display;
                return this.getMatchingVisibleMetas().length > 0;
            }
        },
        {
            key: "_computeGridLineItems",
            value: function _computeGridLineItems(chartArea) {
                var axis = this.axis;
                var chart = this.chart;
                var options = this.options;
                var grid = options.grid, position = options.position, border = options.border;
                var offset = grid.offset;
                var isHorizontal = this.isHorizontal();
                var ticks = this.ticks;
                var ticksLength = ticks.length + (offset ? 1 : 0);
                var tl = getTickMarkLength(grid);
                var items = [];
                var borderOpts = border.setContext(this.getContext());
                var axisWidth = borderOpts.display ? borderOpts.width : 0;
                var axisHalfWidth = axisWidth / 2;
                var alignBorderValue = function alignBorderValue(pixel) {
                    return (0, $3zT2Z.X)(chart, pixel, axisWidth);
                };
                var borderValue, i, lineValue, alignedLineValue;
                var tx1, ty1, tx2, ty2, x1, y1, x2, y2;
                if (position === 'top') {
                    borderValue = alignBorderValue(this.bottom);
                    ty1 = this.bottom - tl;
                    ty2 = borderValue - axisHalfWidth;
                    y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                    y2 = chartArea.bottom;
                } else if (position === 'bottom') {
                    borderValue = alignBorderValue(this.top);
                    y1 = chartArea.top;
                    y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                    ty1 = borderValue + axisHalfWidth;
                    ty2 = this.top + tl;
                } else if (position === 'left') {
                    borderValue = alignBorderValue(this.right);
                    tx1 = this.right - tl;
                    tx2 = borderValue - axisHalfWidth;
                    x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                    x2 = chartArea.right;
                } else if (position === 'right') {
                    borderValue = alignBorderValue(this.left);
                    x1 = chartArea.left;
                    x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                    tx1 = borderValue + axisHalfWidth;
                    tx2 = this.left + tl;
                } else if (axis === 'x') {
                    if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
                    else if ((0, $3zT2Z.i)(position)) {
                        var positionAxisID = Object.keys(position)[0];
                        var value = position[positionAxisID];
                        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
                    }
                    y1 = chartArea.top;
                    y2 = chartArea.bottom;
                    ty1 = borderValue + axisHalfWidth;
                    ty2 = ty1 + tl;
                } else if (axis === 'y') {
                    if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
                    else if ((0, $3zT2Z.i)(position)) {
                        var positionAxisID1 = Object.keys(position)[0];
                        var value1 = position[positionAxisID1];
                        borderValue = alignBorderValue(this.chart.scales[positionAxisID1].getPixelForValue(value1));
                    }
                    tx1 = borderValue - axisHalfWidth;
                    tx2 = tx1 - tl;
                    x1 = chartArea.left;
                    x2 = chartArea.right;
                }
                var limit = (0, $3zT2Z.v)(options.ticks.maxTicksLimit, ticksLength);
                var step = Math.max(1, Math.ceil(ticksLength / limit));
                for(i = 0; i < ticksLength; i += step){
                    var context = this.getContext(i);
                    var optsAtIndex = grid.setContext(context);
                    var optsAtIndexBorder = border.setContext(context);
                    var lineWidth = optsAtIndex.lineWidth;
                    var lineColor = optsAtIndex.color;
                    var borderDash = optsAtIndexBorder.dash || [];
                    var borderDashOffset = optsAtIndexBorder.dashOffset;
                    var tickWidth = optsAtIndex.tickWidth;
                    var tickColor = optsAtIndex.tickColor;
                    var tickBorderDash = optsAtIndex.tickBorderDash || [];
                    var tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
                    lineValue = getPixelForGridLine(this, i, offset);
                    if (lineValue === undefined) continue;
                    alignedLineValue = (0, $3zT2Z.X)(chart, lineValue, lineWidth);
                    if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                    else ty1 = ty2 = y1 = y2 = alignedLineValue;
                    items.push({
                        tx1: tx1,
                        ty1: ty1,
                        tx2: tx2,
                        ty2: ty2,
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        width: lineWidth,
                        color: lineColor,
                        borderDash: borderDash,
                        borderDashOffset: borderDashOffset,
                        tickWidth: tickWidth,
                        tickColor: tickColor,
                        tickBorderDash: tickBorderDash,
                        tickBorderDashOffset: tickBorderDashOffset
                    });
                }
                this._ticksLength = ticksLength;
                this._borderValue = borderValue;
                return items;
            }
        },
        {
            key: "_computeLabelItems",
            value: function _computeLabelItems(chartArea) {
                var axis = this.axis;
                var options = this.options;
                var position = options.position, optionTicks = options.ticks;
                var isHorizontal = this.isHorizontal();
                var ticks = this.ticks;
                var align = optionTicks.align, crossAlign = optionTicks.crossAlign, padding = optionTicks.padding, mirror = optionTicks.mirror;
                var tl = getTickMarkLength(options.grid);
                var tickAndPadding = tl + padding;
                var hTickAndPadding = mirror ? -padding : tickAndPadding;
                var rotation = -(0, $3zT2Z.t)(this.labelRotation);
                var items = [];
                var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
                var textBaseline = 'middle';
                if (position === 'top') {
                    y = this.bottom - hTickAndPadding;
                    textAlign = this._getXAxisLabelAlignment();
                } else if (position === 'bottom') {
                    y = this.top + hTickAndPadding;
                    textAlign = this._getXAxisLabelAlignment();
                } else if (position === 'left') {
                    var ret = this._getYAxisLabelAlignment(tl);
                    textAlign = ret.textAlign;
                    x = ret.x;
                } else if (position === 'right') {
                    var ret1 = this._getYAxisLabelAlignment(tl);
                    textAlign = ret1.textAlign;
                    x = ret1.x;
                } else if (axis === 'x') {
                    if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
                    else if ((0, $3zT2Z.i)(position)) {
                        var positionAxisID = Object.keys(position)[0];
                        var value = position[positionAxisID];
                        y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
                    }
                    textAlign = this._getXAxisLabelAlignment();
                } else if (axis === 'y') {
                    if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
                    else if ((0, $3zT2Z.i)(position)) {
                        var positionAxisID1 = Object.keys(position)[0];
                        var value1 = position[positionAxisID1];
                        x = this.chart.scales[positionAxisID1].getPixelForValue(value1);
                    }
                    textAlign = this._getYAxisLabelAlignment(tl).textAlign;
                }
                if (axis === 'y') {
                    if (align === 'start') textBaseline = 'top';
                    else if (align === 'end') textBaseline = 'bottom';
                }
                var labelSizes = this._getLabelSizes();
                for(i = 0, ilen = ticks.length; i < ilen; ++i){
                    tick = ticks[i];
                    label = tick.label;
                    var optsAtIndex = optionTicks.setContext(this.getContext(i));
                    pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
                    font = this._resolveTickFontOptions(i);
                    lineHeight = font.lineHeight;
                    lineCount = (0, $3zT2Z.b)(label) ? label.length : 1;
                    var halfCount = lineCount / 2;
                    var color = optsAtIndex.color;
                    var strokeColor = optsAtIndex.textStrokeColor;
                    var strokeWidth = optsAtIndex.textStrokeWidth;
                    var tickTextAlign = textAlign;
                    if (isHorizontal) {
                        x = pixel;
                        if (textAlign === 'inner') {
                            if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                            else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                            else tickTextAlign = 'center';
                        }
                        if (position === 'top') {
                            if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                            else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                            else textOffset = -labelSizes.highest.height + lineHeight / 2;
                        } else {
                            if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                            else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                            else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                        }
                        if (mirror) textOffset *= -1;
                        if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
                    } else {
                        y = pixel;
                        textOffset = (1 - lineCount) * lineHeight / 2;
                    }
                    var backdrop = void 0;
                    if (optsAtIndex.showLabelBackdrop) {
                        var labelPadding = (0, $3zT2Z.E)(optsAtIndex.backdropPadding);
                        var height = labelSizes.heights[i];
                        var width = labelSizes.widths[i];
                        var top = textOffset - labelPadding.top;
                        var left = 0 - labelPadding.left;
                        switch(textBaseline){
                            case 'middle':
                                top -= height / 2;
                                break;
                            case 'bottom':
                                top -= height;
                                break;
                        }
                        switch(textAlign){
                            case 'center':
                                left -= width / 2;
                                break;
                            case 'right':
                                left -= width;
                                break;
                            case 'inner':
                                if (i === ilen - 1) left -= width;
                                else if (i > 0) left -= width / 2;
                                break;
                        }
                        backdrop = {
                            left: left,
                            top: top,
                            width: width + labelPadding.width,
                            height: height + labelPadding.height,
                            color: optsAtIndex.backdropColor
                        };
                    }
                    items.push({
                        label: label,
                        font: font,
                        textOffset: textOffset,
                        options: {
                            rotation: rotation,
                            color: color,
                            strokeColor: strokeColor,
                            strokeWidth: strokeWidth,
                            textAlign: tickTextAlign,
                            textBaseline: textBaseline,
                            translation: [
                                x,
                                y
                            ],
                            backdrop: backdrop
                        }
                    });
                }
                return items;
            }
        },
        {
            key: "_getXAxisLabelAlignment",
            value: function _getXAxisLabelAlignment() {
                var _this_options = this.options, position = _this_options.position, ticks = _this_options.ticks;
                var rotation = -(0, $3zT2Z.t)(this.labelRotation);
                if (rotation) return position === 'top' ? 'left' : 'right';
                var align = 'center';
                if (ticks.align === 'start') align = 'left';
                else if (ticks.align === 'end') align = 'right';
                else if (ticks.align === 'inner') align = 'inner';
                return align;
            }
        },
        {
            key: "_getYAxisLabelAlignment",
            value: function _getYAxisLabelAlignment(tl) {
                var _this_options = this.options, position = _this_options.position, _this_options_ticks = _this_options.ticks, crossAlign = _this_options_ticks.crossAlign, mirror = _this_options_ticks.mirror, padding = _this_options_ticks.padding;
                var labelSizes = this._getLabelSizes();
                var tickAndPadding = tl + padding;
                var widest = labelSizes.widest.width;
                var textAlign;
                var x;
                if (position === 'left') {
                    if (mirror) {
                        x = this.right + padding;
                        if (crossAlign === 'near') textAlign = 'left';
                        else if (crossAlign === 'center') {
                            textAlign = 'center';
                            x += widest / 2;
                        } else {
                            textAlign = 'right';
                            x += widest;
                        }
                    } else {
                        x = this.right - tickAndPadding;
                        if (crossAlign === 'near') textAlign = 'right';
                        else if (crossAlign === 'center') {
                            textAlign = 'center';
                            x -= widest / 2;
                        } else {
                            textAlign = 'left';
                            x = this.left;
                        }
                    }
                } else if (position === 'right') {
                    if (mirror) {
                        x = this.left + padding;
                        if (crossAlign === 'near') textAlign = 'right';
                        else if (crossAlign === 'center') {
                            textAlign = 'center';
                            x -= widest / 2;
                        } else {
                            textAlign = 'left';
                            x -= widest;
                        }
                    } else {
                        x = this.left + tickAndPadding;
                        if (crossAlign === 'near') textAlign = 'left';
                        else if (crossAlign === 'center') {
                            textAlign = 'center';
                            x += widest / 2;
                        } else {
                            textAlign = 'right';
                            x = this.right;
                        }
                    }
                } else textAlign = 'right';
                return {
                    textAlign: textAlign,
                    x: x
                };
            }
        },
        {
            key: "_computeLabelArea",
            value: function _computeLabelArea() {
                if (this.options.ticks.mirror) return;
                var chart = this.chart;
                var position = this.options.position;
                if (position === 'left' || position === 'right') return {
                    top: 0,
                    left: this.left,
                    bottom: chart.height,
                    right: this.right
                };
                if (position === 'top' || position === 'bottom') return {
                    top: this.top,
                    left: 0,
                    bottom: this.bottom,
                    right: chart.width
                };
            }
        },
        {
            key: "drawBackground",
            value: function drawBackground() {
                var _this = this, ctx = _this.ctx, backgroundColor = _this.options.backgroundColor, left = _this.left, top = _this.top, width = _this.width, height = _this.height;
                if (backgroundColor) {
                    ctx.save();
                    ctx.fillStyle = backgroundColor;
                    ctx.fillRect(left, top, width, height);
                    ctx.restore();
                }
            }
        },
        {
            key: "getLineWidthForValue",
            value: function getLineWidthForValue(value) {
                var grid = this.options.grid;
                if (!this._isVisible() || !grid.display) return 0;
                var ticks = this.ticks;
                var index = ticks.findIndex(function(t) {
                    return t.value === value;
                });
                if (index >= 0) {
                    var opts = grid.setContext(this.getContext(index));
                    return opts.lineWidth;
                }
                return 0;
            }
        },
        {
            key: "drawGrid",
            value: function drawGrid(chartArea) {
                var grid = this.options.grid;
                var ctx = this.ctx;
                var items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
                var i, ilen;
                var drawLine = function(p1, p2, style) {
                    if (!style.width || !style.color) return;
                    ctx.save();
                    ctx.lineWidth = style.width;
                    ctx.strokeStyle = style.color;
                    ctx.setLineDash(style.borderDash || []);
                    ctx.lineDashOffset = style.borderDashOffset;
                    ctx.beginPath();
                    ctx.moveTo(p1.x, p1.y);
                    ctx.lineTo(p2.x, p2.y);
                    ctx.stroke();
                    ctx.restore();
                };
                if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
                    var item = items[i];
                    if (grid.drawOnChartArea) drawLine({
                        x: item.x1,
                        y: item.y1
                    }, {
                        x: item.x2,
                        y: item.y2
                    }, item);
                    if (grid.drawTicks) drawLine({
                        x: item.tx1,
                        y: item.ty1
                    }, {
                        x: item.tx2,
                        y: item.ty2
                    }, {
                        color: item.tickColor,
                        width: item.tickWidth,
                        borderDash: item.tickBorderDash,
                        borderDashOffset: item.tickBorderDashOffset
                    });
                }
            }
        },
        {
            key: "drawBorder",
            value: function drawBorder() {
                var _this = this, chart = _this.chart, ctx = _this.ctx, _this_options = _this.options, border = _this_options.border, grid = _this_options.grid;
                var borderOpts = border.setContext(this.getContext());
                var axisWidth = border.display ? borderOpts.width : 0;
                if (!axisWidth) return;
                var lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
                var borderValue = this._borderValue;
                var x1, x2, y1, y2;
                if (this.isHorizontal()) {
                    x1 = (0, $3zT2Z.X)(chart, this.left, axisWidth) - axisWidth / 2;
                    x2 = (0, $3zT2Z.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = (0, $3zT2Z.X)(chart, this.top, axisWidth) - axisWidth / 2;
                    y2 = (0, $3zT2Z.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.save();
                ctx.lineWidth = borderOpts.width;
                ctx.strokeStyle = borderOpts.color;
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
                ctx.restore();
            }
        },
        {
            key: "drawLabels",
            value: function drawLabels(chartArea) {
                var optionTicks = this.options.ticks;
                if (!optionTicks.display) return;
                var ctx = this.ctx;
                var area = this._computeLabelArea();
                if (area) (0, $3zT2Z.Y)(ctx, area);
                var items = this.getLabelItems(chartArea);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        var renderTextOptions = item.options;
                        var tickFont = item.font;
                        var label = item.label;
                        var y = item.textOffset;
                        (0, $3zT2Z.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (area) (0, $3zT2Z.$)(ctx);
            }
        },
        {
            key: "drawTitle",
            value: function drawTitle() {
                var _this = this, ctx = _this.ctx, _this_options = _this.options, position = _this_options.position, title = _this_options.title, reverse = _this_options.reverse;
                if (!title.display) return;
                var font = (0, $3zT2Z.a0)(title.font);
                var padding = (0, $3zT2Z.E)(title.padding);
                var align = title.align;
                var offset = font.lineHeight / 2;
                if (position === 'bottom' || position === 'center' || (0, $3zT2Z.i)(position)) {
                    offset += padding.bottom;
                    if ((0, $3zT2Z.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
                } else offset += padding.top;
                var _titleArgs = titleArgs(this, offset, position, align), titleX = _titleArgs.titleX, titleY = _titleArgs.titleY, maxWidth = _titleArgs.maxWidth, rotation = _titleArgs.rotation;
                (0, $3zT2Z.Z)(ctx, title.text, 0, 0, font, {
                    color: title.color,
                    maxWidth: maxWidth,
                    rotation: rotation,
                    textAlign: titleAlign(align, position, reverse),
                    textBaseline: 'middle',
                    translation: [
                        titleX,
                        titleY
                    ]
                });
            }
        },
        {
            key: "draw",
            value: function draw(chartArea) {
                if (!this._isVisible()) return;
                this.drawBackground();
                this.drawGrid(chartArea);
                this.drawBorder();
                this.drawTitle();
                this.drawLabels(chartArea);
            }
        },
        {
            key: "_layers",
            value: function _layers() {
                var _this = this;
                var opts = this.options;
                var tz = opts.ticks && opts.ticks.z || 0;
                var gz = (0, $3zT2Z.v)(opts.grid && opts.grid.z, -1);
                var bz = (0, $3zT2Z.v)(opts.border && opts.border.z, 0);
                if (!this._isVisible() || this.draw !== Scale.prototype.draw) return [
                    {
                        z: tz,
                        draw: function(chartArea) {
                            _this.draw(chartArea);
                        }
                    }
                ];
                return [
                    {
                        z: gz,
                        draw: function(chartArea) {
                            _this.drawBackground();
                            _this.drawGrid(chartArea);
                            _this.drawTitle();
                        }
                    },
                    {
                        z: bz,
                        draw: function() {
                            _this.drawBorder();
                        }
                    },
                    {
                        z: tz,
                        draw: function(chartArea) {
                            _this.drawLabels(chartArea);
                        }
                    }
                ];
            }
        },
        {
            key: "getMatchingVisibleMetas",
            value: function getMatchingVisibleMetas(type) {
                var metas = this.chart.getSortedVisibleDatasetMetas();
                var axisID = this.axis + 'AxisID';
                var result = [];
                var i, ilen;
                for(i = 0, ilen = metas.length; i < ilen; ++i){
                    var meta = metas[i];
                    if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
                }
                return result;
            }
        },
        {
            key: "_resolveTickFontOptions",
            value: function _resolveTickFontOptions(index) {
                var opts = this.options.ticks.setContext(this.getContext(index));
                return (0, $3zT2Z.a0)(opts.font);
            }
        },
        {
            key: "_maxDigits",
            value: function _maxDigits() {
                var fontSize = this._resolveTickFontOptions(0).lineHeight;
                return (this.isHorizontal() ? this.width : this.height) / fontSize;
            }
        }
    ]);
    return Scale;
}((0, $6brDd._)(Element));
var TypedRegistry = /*#__PURE__*/ function() {
    "use strict";
    function TypedRegistry(type, scope, override) {
        (0, $ioD88._)(this, TypedRegistry);
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    (0, $6NCFa._)(TypedRegistry, [
        {
            key: "isForType",
            value: function isForType(type) {
                return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
            }
        },
        {
            key: "register",
            value: function register(item) {
                var proto = Object.getPrototypeOf(item);
                var parentScope;
                if (isIChartComponent(proto)) parentScope = this.register(proto);
                var items = this.items;
                var id = item.id;
                var scope = this.scope + '.' + id;
                if (!id) throw new Error('class does not have id: ' + item);
                if (id in items) return scope;
                items[id] = item;
                registerDefaults(item, scope, parentScope);
                if (this.override) (0, $3zT2Z.d).override(item.id, item.overrides);
                return scope;
            }
        },
        {
            key: "get",
            value: function get(id) {
                return this.items[id];
            }
        },
        {
            key: "unregister",
            value: function unregister(item) {
                var items = this.items;
                var id = item.id;
                var scope = this.scope;
                if (id in items) delete items[id];
                if (scope && id in (0, $3zT2Z.d)[scope]) {
                    delete (0, $3zT2Z.d)[scope][id];
                    if (this.override) delete (0, $3zT2Z.a3)[id];
                }
            }
        }
    ]);
    return TypedRegistry;
}();
function registerDefaults(item, scope, parentScope) {
    var itemDefaults = (0, $3zT2Z.a4)(Object.create(null), [
        parentScope ? (0, $3zT2Z.d).get(parentScope) : {},
        (0, $3zT2Z.d).get(scope),
        item.defaults
    ]);
    (0, $3zT2Z.d).set(scope, itemDefaults);
    if (item.defaultRoutes) routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $3zT2Z.d).describe(scope, item.descriptors);
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach(function(property) {
        var propertyParts = property.split('.');
        var sourceName = propertyParts.pop();
        var sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        var parts = routes[property].split('.');
        var targetName = parts.pop();
        var targetScope = parts.join('.');
        (0, $3zT2Z.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
var Registry = /*#__PURE__*/ function() {
    "use strict";
    function Registry() {
        (0, $ioD88._)(this, Registry);
        this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
        this.elements = new TypedRegistry(Element, 'elements');
        this.plugins = new TypedRegistry(Object, 'plugins');
        this.scales = new TypedRegistry(Scale, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    (0, $6NCFa._)(Registry, [
        {
            key: "add",
            value: function add() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args);
            }
        },
        {
            key: "remove",
            value: function remove() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args);
            }
        },
        {
            key: "addControllers",
            value: function addControllers() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args, this.controllers);
            }
        },
        {
            key: "addElements",
            value: function addElements() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args, this.elements);
            }
        },
        {
            key: "addPlugins",
            value: function addPlugins() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args, this.plugins);
            }
        },
        {
            key: "addScales",
            value: function addScales() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args, this.scales);
            }
        },
        {
            key: "getController",
            value: function getController(id) {
                return this._get(id, this.controllers, 'controller');
            }
        },
        {
            key: "getElement",
            value: function getElement(id) {
                return this._get(id, this.elements, 'element');
            }
        },
        {
            key: "getPlugin",
            value: function getPlugin(id) {
                return this._get(id, this.plugins, 'plugin');
            }
        },
        {
            key: "getScale",
            value: function getScale(id) {
                return this._get(id, this.scales, 'scale');
            }
        },
        {
            key: "removeControllers",
            value: function removeControllers() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args, this.controllers);
            }
        },
        {
            key: "removeElements",
            value: function removeElements() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args, this.elements);
            }
        },
        {
            key: "removePlugins",
            value: function removePlugins() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args, this.plugins);
            }
        },
        {
            key: "removeScales",
            value: function removeScales() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args, this.scales);
            }
        },
        {
            key: "_each",
            value: function _each(method, args, typedRegistry) {
                var _this = this;
                (0, $kNmtb._)(args).forEach(function(arg) {
                    var reg = typedRegistry || _this._getRegistryForType(arg);
                    if (typedRegistry || reg.isForType(arg) || reg === _this.plugins && arg.id) _this._exec(method, reg, arg);
                    else (0, $3zT2Z.F)(arg, function(item) {
                        var itemReg = typedRegistry || _this._getRegistryForType(item);
                        _this._exec(method, itemReg, item);
                    });
                });
            }
        },
        {
            key: "_exec",
            value: function _exec(method, registry, component) {
                var camelMethod = (0, $3zT2Z.a5)(method);
                (0, $3zT2Z.Q)(component['before' + camelMethod], [], component);
                registry[method](component);
                (0, $3zT2Z.Q)(component['after' + camelMethod], [], component);
            }
        },
        {
            key: "_getRegistryForType",
            value: function _getRegistryForType(type) {
                for(var i = 0; i < this._typedRegistries.length; i++){
                    var reg = this._typedRegistries[i];
                    if (reg.isForType(type)) return reg;
                }
                return this.plugins;
            }
        },
        {
            key: "_get",
            value: function _get(id, typedRegistry, type) {
                var item = typedRegistry.get(id);
                if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
                return item;
            }
        }
    ]);
    return Registry;
}();
var registry = /* #__PURE__ */ new Registry();
var PluginService = /*#__PURE__*/ function() {
    "use strict";
    function PluginService() {
        (0, $ioD88._)(this, PluginService);
        this._init = undefined;
    }
    (0, $6NCFa._)(PluginService, [
        {
            key: "notify",
            value: function notify(chart, hook, args, filter) {
                if (hook === 'beforeInit') {
                    this._init = this._createDescriptors(chart, true);
                    this._notify(this._init, chart, 'install');
                }
                if (this._init === undefined) return;
                var descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
                var result = this._notify(descriptors, chart, hook, args);
                if (hook === 'afterDestroy') {
                    this._notify(descriptors, chart, 'stop');
                    this._notify(this._init, chart, 'uninstall');
                    this._init = undefined;
                }
                return result;
            }
        },
        {
            key: "_notify",
            value: function _notify(descriptors, chart, hook, args) {
                args = args || {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = descriptors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var descriptor = _step.value;
                        var plugin = descriptor.plugin;
                        var method = plugin[hook];
                        var params = [
                            chart,
                            args,
                            descriptor.options
                        ];
                        if ((0, $3zT2Z.Q)(method, params, plugin) === false && args.cancelable) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return true;
            }
        },
        {
            key: "invalidate",
            value: function invalidate() {
                if (!(0, $3zT2Z.k)(this._cache)) {
                    this._oldCache = this._cache;
                    this._cache = undefined;
                }
            }
        },
        {
            key: "_descriptors",
            value: function _descriptors(chart) {
                if (this._cache) return this._cache;
                var descriptors = this._cache = this._createDescriptors(chart);
                this._notifyStateChanges(chart);
                return descriptors;
            }
        },
        {
            key: "_createDescriptors",
            value: function _createDescriptors(chart, all) {
                var config = chart && chart.config;
                var options = (0, $3zT2Z.v)(config.options && config.options.plugins, {});
                var plugins = allPlugins(config);
                return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
            }
        },
        {
            key: "_notifyStateChanges",
            value: function _notifyStateChanges(chart) {
                var previousDescriptors = this._oldCache || [];
                var descriptors = this._cache;
                var diff = function(a, b) {
                    return a.filter(function(x) {
                        return !b.some(function(y) {
                            return x.plugin.id === y.plugin.id;
                        });
                    });
                };
                this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
                this._notify(diff(descriptors, previousDescriptors), chart, 'start');
            }
        }
    ]);
    return PluginService;
}();
function allPlugins(config) {
    var localIds = {};
    var plugins = [];
    var keys = Object.keys(registry.plugins.items);
    for(var i = 0; i < keys.length; i++)plugins.push(registry.getPlugin(keys[i]));
    var local = config.plugins || [];
    for(var i1 = 0; i1 < local.length; i1++){
        var plugin = local[i1];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function createDescriptors(chart, param, options, all) {
    var plugins = param.plugins, localIds = param.localIds;
    var result = [];
    var context = chart.getContext();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            var id = plugin.id;
            var opts = getOpts(options[id], all);
            if (opts === null) continue;
            result.push({
                plugin: plugin,
                options: pluginOpts(chart.config, {
                    plugin: plugin,
                    local: localIds[id]
                }, opts, context)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function pluginOpts(config, param, opts, context) {
    var plugin = param.plugin, local = param.local;
    var keys = config.pluginScopeKeys(plugin);
    var scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function getIndexAxis(type, options) {
    var datasetDefaults = (0, $3zT2Z.d).datasets[type] || {};
    var datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    var axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function determineAxis(id) {
    for(var _len = arguments.length, scaleOptions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        scaleOptions[_key - 1] = arguments[_key];
    }
    if (idMatchesAxis(id)) return id;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scaleOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var opts = _step.value;
            var axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
            if (axis) return axis;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error("Cannot determine type of '".concat(id, "' axis. Please provide 'axis' or 'position' option."));
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        var boundDs = config.data.datasets.filter(function(d) {
            return d.xAxisID === id || d.yAxisID === id;
        });
        if (boundDs.length) return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function mergeScaleConfig(config, options) {
    var chartDefaults = (0, $3zT2Z.a3)[config.type] || {
        scales: {}
    };
    var configScales = options.scales || {};
    var chartIndexAxis = getIndexAxis(config.type, options);
    var scales = Object.create(null);
    Object.keys(configScales).forEach(function(id) {
        var scaleConf = configScales[id];
        if (!(0, $3zT2Z.i)(scaleConf)) return console.error("Invalid scale configuration for scale: ".concat(id));
        if (scaleConf._proxy) return console.warn("Ignoring resolver passed as options for scale: ".concat(id));
        var axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), (0, $3zT2Z.d).scales[scaleConf.type]);
        var defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        var defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $3zT2Z.ab)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach(function(dataset) {
        var type = dataset.type || config.type;
        var indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        var datasetDefaults = (0, $3zT2Z.a3)[type] || {};
        var defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach(function(defaultID) {
            var axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            var id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $3zT2Z.ab)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach(function(key) {
        var scale = scales[key];
        (0, $3zT2Z.ab)(scale, [
            (0, $3zT2Z.d).scales[scale.type],
            (0, $3zT2Z.d).scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    var options = config.options || (config.options = {});
    options.plugins = (0, $3zT2Z.v)(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
var keyCache = new Map();
var keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    var keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
var addIfFound = function(set, obj, key) {
    var opts = (0, $3zT2Z.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
var Config = /*#__PURE__*/ function() {
    "use strict";
    function Config(config) {
        (0, $ioD88._)(this, Config);
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    (0, $6NCFa._)(Config, [
        {
            key: "platform",
            get: function get() {
                return this._config.platform;
            }
        },
        {
            key: "type",
            get: function get() {
                return this._config.type;
            },
            set: function set(type) {
                this._config.type = type;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._config.data;
            },
            set: function set(data) {
                this._config.data = initData(data);
            }
        },
        {
            key: "options",
            get: function get() {
                return this._config.options;
            },
            set: function set(options) {
                this._config.options = options;
            }
        },
        {
            key: "plugins",
            get: function get() {
                return this._config.plugins;
            }
        },
        {
            key: "update",
            value: function update() {
                var config = this._config;
                this.clearCache();
                initOptions(config);
            }
        },
        {
            key: "clearCache",
            value: function clearCache() {
                this._scopeCache.clear();
                this._resolverCache.clear();
            }
        },
        {
            key: "datasetScopeKeys",
            value: function datasetScopeKeys(datasetType) {
                return cachedKeys(datasetType, function() {
                    return [
                        [
                            "datasets.".concat(datasetType),
                            ''
                        ]
                    ];
                });
            }
        },
        {
            key: "datasetAnimationScopeKeys",
            value: function datasetAnimationScopeKeys(datasetType, transition) {
                return cachedKeys("".concat(datasetType, ".transition.").concat(transition), function() {
                    return [
                        [
                            "datasets.".concat(datasetType, ".transitions.").concat(transition),
                            "transitions.".concat(transition)
                        ],
                        [
                            "datasets.".concat(datasetType),
                            ''
                        ]
                    ];
                });
            }
        },
        {
            key: "datasetElementScopeKeys",
            value: function datasetElementScopeKeys(datasetType, elementType) {
                return cachedKeys("".concat(datasetType, "-").concat(elementType), function() {
                    return [
                        [
                            "datasets.".concat(datasetType, ".elements.").concat(elementType),
                            "datasets.".concat(datasetType),
                            "elements.".concat(elementType),
                            ''
                        ]
                    ];
                });
            }
        },
        {
            key: "pluginScopeKeys",
            value: function pluginScopeKeys(plugin) {
                var id = plugin.id;
                var type = this.type;
                return cachedKeys("".concat(type, "-plugin-").concat(id), function() {
                    return [
                        [
                            "plugins.".concat(id)
                        ].concat((0, $kNmtb._)(plugin.additionalOptionScopes || []))
                    ];
                });
            }
        },
        {
            key: "_cachedScopes",
            value: function _cachedScopes(mainScope, resetCache) {
                var _scopeCache = this._scopeCache;
                var cache = _scopeCache.get(mainScope);
                if (!cache || resetCache) {
                    cache = new Map();
                    _scopeCache.set(mainScope, cache);
                }
                return cache;
            }
        },
        {
            key: "getOptionScopes",
            value: function getOptionScopes(mainScope, keyLists, resetCache) {
                var _this = this, options = _this.options, type = _this.type;
                var cache = this._cachedScopes(mainScope, resetCache);
                var cached = cache.get(keyLists);
                if (cached) return cached;
                var scopes = new Set();
                keyLists.forEach(function(keys) {
                    if (mainScope) {
                        scopes.add(mainScope);
                        keys.forEach(function(key) {
                            return addIfFound(scopes, mainScope, key);
                        });
                    }
                    keys.forEach(function(key) {
                        return addIfFound(scopes, options, key);
                    });
                    keys.forEach(function(key) {
                        return addIfFound(scopes, (0, $3zT2Z.a3)[type] || {}, key);
                    });
                    keys.forEach(function(key) {
                        return addIfFound(scopes, (0, $3zT2Z.d), key);
                    });
                    keys.forEach(function(key) {
                        return addIfFound(scopes, (0, $3zT2Z.a6), key);
                    });
                });
                var array = Array.from(scopes);
                if (array.length === 0) array.push(Object.create(null));
                if (keysCached.has(keyLists)) cache.set(keyLists, array);
                return array;
            }
        },
        {
            key: "chartOptionScopes",
            value: function chartOptionScopes() {
                var _this = this, options = _this.options, type = _this.type;
                return [
                    options,
                    (0, $3zT2Z.a3)[type] || {},
                    (0, $3zT2Z.d).datasets[type] || {},
                    {
                        type: type
                    },
                    (0, $3zT2Z.d),
                    (0, $3zT2Z.a6)
                ];
            }
        },
        {
            key: "resolveNamedOptions",
            value: function resolveNamedOptions(scopes, names, context) {
                var prefixes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
                    ''
                ];
                var result = {
                    $shared: true
                };
                var _getResolver = getResolver(this._resolverCache, scopes, prefixes), resolver = _getResolver.resolver, subPrefixes = _getResolver.subPrefixes;
                var options = resolver;
                if (needContext(resolver, names)) {
                    result.$shared = false;
                    context = (0, $3zT2Z.a7)(context) ? context() : context;
                    var subResolver = this.createResolver(scopes, context, subPrefixes);
                    options = (0, $3zT2Z.a8)(resolver, context, subResolver);
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var prop = _step.value;
                        result[prop] = options[prop];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "createResolver",
            value: function createResolver(scopes, context) {
                var prefixes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    ''
                ], descriptorDefaults = arguments.length > 3 ? arguments[3] : void 0;
                var resolver = getResolver(this._resolverCache, scopes, prefixes).resolver;
                return (0, $3zT2Z.i)(context) ? (0, $3zT2Z.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
            }
        }
    ]);
    return Config;
}();
function getResolver(resolverCache, scopes, prefixes) {
    var cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    var cacheKey = prefixes.join();
    var cached = cache.get(cacheKey);
    if (!cached) {
        var resolver = (0, $3zT2Z.a9)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter(function(p) {
                return !p.toLowerCase().includes('hover');
            })
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
var hasFunction = function(value) {
    return (0, $3zT2Z.i)(value) && Object.getOwnPropertyNames(value).some(function(key) {
        return (0, $3zT2Z.a7)(value[key]);
    });
};
function needContext(proxy, names) {
    var _$_descriptors = (0, $3zT2Z.aa)(proxy), isScriptable = _$_descriptors.isScriptable, isIndexable = _$_descriptors.isIndexable;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            var scriptable = isScriptable(prop);
            var indexable = isIndexable(prop);
            var value = (indexable || scriptable) && proxy[prop];
            if (scriptable && ((0, $3zT2Z.a7)(value) || hasFunction(value)) || indexable && (0, $3zT2Z.b)(value)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
var version = "4.5.1";
var KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    var chart = context.chart;
    var animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $3zT2Z.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    var chart = context.chart;
    var animationOptions = chart.options.animation;
    (0, $3zT2Z.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function getCanvas(item) {
    if ((0, $3zT2Z.M)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
var instances = {};
var getChart = function(key) {
    var canvas = getCanvas(key);
    return Object.values(instances).filter(function(c) {
        return c.canvas === canvas;
    }).pop();
};
function moveNumericKeys(obj, start, move) {
    var keys = Object.keys(obj);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var intKey = +key;
            if (intKey >= start) {
                var value = obj[key];
                delete obj[key];
                if (move > 0 || intKey > start) obj[intKey + move] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
var Chart = /*#__PURE__*/ function() {
    "use strict";
    function Chart(item, userConfig) {
        var _this = this;
        (0, $ioD88._)(this, Chart);
        var config = this.config = new Config(userConfig);
        var initialCanvas = getCanvas(item);
        var existingChart = getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        var options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        var context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        var canvas = context && context.canvas;
        var height = canvas && canvas.height;
        var width = canvas && canvas.width;
        this.id = (0, $3zT2Z.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $3zT2Z.ad)(function(mode) {
            return _this.update(mode);
        }, options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, 'complete', onAnimationsComplete);
        animator.listen(this, 'progress', onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    (0, $6NCFa._)(Chart, [
        {
            key: "aspectRatio",
            get: function get() {
                var _this = this, _this_options = _this.options, aspectRatio = _this_options.aspectRatio, maintainAspectRatio = _this_options.maintainAspectRatio, width = _this.width, height = _this.height, _aspectRatio = _this._aspectRatio;
                if (!(0, $3zT2Z.k)(aspectRatio)) return aspectRatio;
                if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
                return height ? width / height : null;
            }
        },
        {
            key: "data",
            get: function get() {
                return this.config.data;
            },
            set: function set(data) {
                this.config.data = data;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._options;
            },
            set: function set(options) {
                this.config.options = options;
            }
        },
        {
            key: "registry",
            get: function get() {
                return registry;
            }
        },
        {
            key: "_initialize",
            value: function _initialize() {
                this.notifyPlugins('beforeInit');
                if (this.options.responsive) this.resize();
                else (0, $3zT2Z.ae)(this, this.options.devicePixelRatio);
                this.bindEvents();
                this.notifyPlugins('afterInit');
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                (0, $3zT2Z.af)(this.canvas, this.ctx);
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                animator.stop(this);
                return this;
            }
        },
        {
            key: "resize",
            value: function resize(width, height) {
                if (!animator.running(this)) this._resize(width, height);
                else this._resizeBeforeDraw = {
                    width: width,
                    height: height
                };
            }
        },
        {
            key: "_resize",
            value: function _resize(width, height) {
                var options = this.options;
                var canvas = this.canvas;
                var aspectRatio = options.maintainAspectRatio && this.aspectRatio;
                var newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
                var newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
                var mode = this.width ? 'resize' : 'attach';
                this.width = newSize.width;
                this.height = newSize.height;
                this._aspectRatio = this.aspectRatio;
                if (!(0, $3zT2Z.ae)(this, newRatio, true)) return;
                this.notifyPlugins('resize', {
                    size: newSize
                });
                (0, $3zT2Z.Q)(options.onResize, [
                    this,
                    newSize
                ], this);
                if (this.attached) {
                    if (this._doResize(mode)) this.render();
                }
            }
        },
        {
            key: "ensureScalesHaveIDs",
            value: function ensureScalesHaveIDs() {
                var options = this.options;
                var scalesOptions = options.scales || {};
                (0, $3zT2Z.F)(scalesOptions, function(axisOptions, axisID) {
                    axisOptions.id = axisID;
                });
            }
        },
        {
            key: "buildOrUpdateScales",
            value: function buildOrUpdateScales() {
                var _this = this;
                var options = this.options;
                var scaleOpts = options.scales;
                var scales = this.scales;
                var updated = Object.keys(scales).reduce(function(obj, id) {
                    obj[id] = false;
                    return obj;
                }, {});
                var items = [];
                if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map(function(id) {
                    var scaleOptions = scaleOpts[id];
                    var axis = determineAxis(id, scaleOptions);
                    var isRadial = axis === 'r';
                    var isHorizontal = axis === 'x';
                    return {
                        options: scaleOptions,
                        dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                        dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
                    };
                }));
                (0, $3zT2Z.F)(items, function(item) {
                    var scaleOptions = item.options;
                    var id = scaleOptions.id;
                    var axis = determineAxis(id, scaleOptions);
                    var scaleType = (0, $3zT2Z.v)(scaleOptions.type, item.dtype);
                    if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                    updated[id] = true;
                    var scale = null;
                    if (id in scales && scales[id].type === scaleType) scale = scales[id];
                    else {
                        var scaleClass = registry.getScale(scaleType);
                        scale = new scaleClass({
                            id: id,
                            type: scaleType,
                            ctx: _this.ctx,
                            chart: _this
                        });
                        scales[scale.id] = scale;
                    }
                    scale.init(scaleOptions, options);
                });
                (0, $3zT2Z.F)(updated, function(hasUpdated, id) {
                    if (!hasUpdated) delete scales[id];
                });
                (0, $3zT2Z.F)(scales, function(scale) {
                    layouts.configure(_this, scale, scale.options);
                    layouts.addBox(_this, scale);
                });
            }
        },
        {
            key: "_updateMetasets",
            value: function _updateMetasets() {
                var metasets = this._metasets;
                var numData = this.data.datasets.length;
                var numMeta = metasets.length;
                metasets.sort(function(a, b) {
                    return a.index - b.index;
                });
                if (numMeta > numData) {
                    for(var i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
                    metasets.splice(numData, numMeta - numData);
                }
                this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
            }
        },
        {
            key: "_removeUnreferencedMetasets",
            value: function _removeUnreferencedMetasets() {
                var _this = this;
                var _this1 = this, metasets = _this1._metasets, datasets = _this1.data.datasets;
                if (metasets.length > datasets.length) delete this._stacks;
                metasets.forEach(function(meta, index) {
                    if (datasets.filter(function(x) {
                        return x === meta._dataset;
                    }).length === 0) _this._destroyDatasetMeta(index);
                });
            }
        },
        {
            key: "buildOrUpdateControllers",
            value: function buildOrUpdateControllers() {
                var newControllers = [];
                var datasets = this.data.datasets;
                var i, ilen;
                this._removeUnreferencedMetasets();
                for(i = 0, ilen = datasets.length; i < ilen; i++){
                    var dataset = datasets[i];
                    var meta = this.getDatasetMeta(i);
                    var type = dataset.type || this.config.type;
                    if (meta.type && meta.type !== type) {
                        this._destroyDatasetMeta(i);
                        meta = this.getDatasetMeta(i);
                    }
                    meta.type = type;
                    meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
                    meta.order = dataset.order || 0;
                    meta.index = i;
                    meta.label = '' + dataset.label;
                    meta.visible = this.isDatasetVisible(i);
                    if (meta.controller) {
                        meta.controller.updateIndex(i);
                        meta.controller.linkScales();
                    } else {
                        var ControllerClass = registry.getController(type);
                        var _defaults_datasets_type = (0, $3zT2Z.d).datasets[type], datasetElementType = _defaults_datasets_type.datasetElementType, dataElementType = _defaults_datasets_type.dataElementType;
                        Object.assign(ControllerClass, {
                            dataElementType: registry.getElement(dataElementType),
                            datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                        });
                        meta.controller = new ControllerClass(this, i);
                        newControllers.push(meta.controller);
                    }
                }
                this._updateMetasets();
                return newControllers;
            }
        },
        {
            key: "_resetElements",
            value: function _resetElements() {
                var _this = this;
                (0, $3zT2Z.F)(this.data.datasets, function(dataset, datasetIndex) {
                    _this.getDatasetMeta(datasetIndex).controller.reset();
                }, this);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElements();
                this.notifyPlugins('reset');
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var config = this.config;
                config.update();
                var options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
                var animsDisabled = this._animationsDisabled = !options.animation;
                this._updateScales();
                this._checkEventBindings();
                this._updateHiddenIndices();
                this._plugins.invalidate();
                if (this.notifyPlugins('beforeUpdate', {
                    mode: mode,
                    cancelable: true
                }) === false) return;
                var newControllers = this.buildOrUpdateControllers();
                this.notifyPlugins('beforeElementsUpdate');
                var minPadding = 0;
                for(var i = 0, ilen = this.data.datasets.length; i < ilen; i++){
                    var controller = this.getDatasetMeta(i).controller;
                    var reset = !animsDisabled && newControllers.indexOf(controller) === -1;
                    controller.buildOrUpdateElements(reset);
                    minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
                }
                minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
                this._updateLayout(minPadding);
                if (!animsDisabled) (0, $3zT2Z.F)(newControllers, function(controller) {
                    controller.reset();
                });
                this._updateDatasets(mode);
                this.notifyPlugins('afterUpdate', {
                    mode: mode
                });
                this._layers.sort(compare2Level('z', '_idx'));
                var _this = this, _active = _this._active, _lastEvent = _this._lastEvent;
                if (_lastEvent) this._eventHandler(_lastEvent, true);
                else if (_active.length) this._updateHoverStyles(_active, _active, true);
                this.render();
            }
        },
        {
            key: "_updateScales",
            value: function _updateScales() {
                var _this = this;
                (0, $3zT2Z.F)(this.scales, function(scale) {
                    layouts.removeBox(_this, scale);
                });
                this.ensureScalesHaveIDs();
                this.buildOrUpdateScales();
            }
        },
        {
            key: "_checkEventBindings",
            value: function _checkEventBindings() {
                var options = this.options;
                var existingEvents = new Set(Object.keys(this._listeners));
                var newEvents = new Set(options.events);
                if (!(0, $3zT2Z.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
                    this.unbindEvents();
                    this.bindEvents();
                }
            }
        },
        {
            key: "_updateHiddenIndices",
            value: function _updateHiddenIndices() {
                var _hiddenIndices = this._hiddenIndices;
                var changes = this._getUniformDataChanges() || [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, method = _step_value.method, start = _step_value.start, count = _step_value.count;
                        var move = method === '_removeElements' ? -count : count;
                        moveNumericKeys(_hiddenIndices, start, move);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getUniformDataChanges",
            value: function _getUniformDataChanges() {
                var _dataChanges = this._dataChanges;
                if (!_dataChanges || !_dataChanges.length) return;
                this._dataChanges = [];
                var datasetCount = this.data.datasets.length;
                var makeSet = function(idx) {
                    return new Set(_dataChanges.filter(function(c) {
                        return c[0] === idx;
                    }).map(function(c, i) {
                        return i + ',' + c.splice(1).join(',');
                    }));
                };
                var changeSet = makeSet(0);
                for(var i = 1; i < datasetCount; i++){
                    if (!(0, $3zT2Z.ag)(changeSet, makeSet(i))) return;
                }
                return Array.from(changeSet).map(function(c) {
                    return c.split(',');
                }).map(function(a) {
                    return {
                        method: a[1],
                        start: +a[2],
                        count: +a[3]
                    };
                });
            }
        },
        {
            key: "_updateLayout",
            value: function _updateLayout(minPadding) {
                var _this = this;
                if (this.notifyPlugins('beforeLayout', {
                    cancelable: true
                }) === false) return;
                layouts.update(this, this.width, this.height, minPadding);
                var area = this.chartArea;
                var noArea = area.width <= 0 || area.height <= 0;
                this._layers = [];
                (0, $3zT2Z.F)(this.boxes, function(box) {
                    var _this__layers;
                    if (noArea && box.position === 'chartArea') return;
                    if (box.configure) box.configure();
                    (_this__layers = _this._layers).push.apply(_this__layers, (0, $kNmtb._)(box._layers()));
                }, this);
                this._layers.forEach(function(item, index) {
                    item._idx = index;
                });
                this.notifyPlugins('afterLayout');
            }
        },
        {
            key: "_updateDatasets",
            value: function _updateDatasets(mode) {
                if (this.notifyPlugins('beforeDatasetsUpdate', {
                    mode: mode,
                    cancelable: true
                }) === false) return;
                for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
                for(var i1 = 0, ilen1 = this.data.datasets.length; i1 < ilen1; ++i1)this._updateDataset(i1, (0, $3zT2Z.a7)(mode) ? mode({
                    datasetIndex: i1
                }) : mode);
                this.notifyPlugins('afterDatasetsUpdate', {
                    mode: mode
                });
            }
        },
        {
            key: "_updateDataset",
            value: function _updateDataset(index, mode) {
                var meta = this.getDatasetMeta(index);
                var args = {
                    meta: meta,
                    index: index,
                    mode: mode,
                    cancelable: true
                };
                if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
                meta.controller._update(mode);
                args.cancelable = false;
                this.notifyPlugins('afterDatasetUpdate', args);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.notifyPlugins('beforeRender', {
                    cancelable: true
                }) === false) return;
                if (animator.has(this)) {
                    if (this.attached && !animator.running(this)) animator.start(this);
                } else {
                    this.draw();
                    onAnimationsComplete({
                        chart: this
                    });
                }
            }
        },
        {
            key: "draw",
            value: function draw() {
                var i;
                if (this._resizeBeforeDraw) {
                    var _this__resizeBeforeDraw = this._resizeBeforeDraw, width = _this__resizeBeforeDraw.width, height = _this__resizeBeforeDraw.height;
                    this._resizeBeforeDraw = null;
                    this._resize(width, height);
                }
                this.clear();
                if (this.width <= 0 || this.height <= 0) return;
                if (this.notifyPlugins('beforeDraw', {
                    cancelable: true
                }) === false) return;
                var layers = this._layers;
                for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
                this._drawDatasets();
                for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
                this.notifyPlugins('afterDraw');
            }
        },
        {
            key: "_getSortedDatasetMetas",
            value: function _getSortedDatasetMetas(filterVisible) {
                var metasets = this._sortedMetasets;
                var result = [];
                var i, ilen;
                for(i = 0, ilen = metasets.length; i < ilen; ++i){
                    var meta = metasets[i];
                    if (!filterVisible || meta.visible) result.push(meta);
                }
                return result;
            }
        },
        {
            key: "getSortedVisibleDatasetMetas",
            value: function getSortedVisibleDatasetMetas() {
                return this._getSortedDatasetMetas(true);
            }
        },
        {
            key: "_drawDatasets",
            value: function _drawDatasets() {
                if (this.notifyPlugins('beforeDatasetsDraw', {
                    cancelable: true
                }) === false) return;
                var metasets = this.getSortedVisibleDatasetMetas();
                for(var i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
                this.notifyPlugins('afterDatasetsDraw');
            }
        },
        {
            key: "_drawDataset",
            value: function _drawDataset(meta) {
                var ctx = this.ctx;
                var args = {
                    meta: meta,
                    index: meta.index,
                    cancelable: true
                };
                var clip = (0, $3zT2Z.ah)(this, meta);
                if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
                if (clip) (0, $3zT2Z.Y)(ctx, clip);
                meta.controller.draw();
                if (clip) (0, $3zT2Z.$)(ctx);
                args.cancelable = false;
                this.notifyPlugins('afterDatasetDraw', args);
            }
        },
        {
            key: "isPointInArea",
            value: function isPointInArea(point) {
                return (0, $3zT2Z.C)(point, this.chartArea, this._minPadding);
            }
        },
        {
            key: "getElementsAtEventForMode",
            value: function getElementsAtEventForMode(e, mode, options, useFinalPosition) {
                var method = Interaction.modes[mode];
                if (typeof method === 'function') return method(this, e, options, useFinalPosition);
                return [];
            }
        },
        {
            key: "getDatasetMeta",
            value: function getDatasetMeta(datasetIndex) {
                var dataset = this.data.datasets[datasetIndex];
                var metasets = this._metasets;
                var meta = metasets.filter(function(x) {
                    return x && x._dataset === dataset;
                }).pop();
                if (!meta) {
                    meta = {
                        type: null,
                        data: [],
                        dataset: null,
                        controller: null,
                        hidden: null,
                        xAxisID: null,
                        yAxisID: null,
                        order: dataset && dataset.order || 0,
                        index: datasetIndex,
                        _dataset: dataset,
                        _parsed: [],
                        _sorted: false
                    };
                    metasets.push(meta);
                }
                return meta;
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.$context || (this.$context = (0, $3zT2Z.j)(null, {
                    chart: this,
                    type: 'chart'
                }));
            }
        },
        {
            key: "getVisibleDatasetCount",
            value: function getVisibleDatasetCount() {
                return this.getSortedVisibleDatasetMetas().length;
            }
        },
        {
            key: "isDatasetVisible",
            value: function isDatasetVisible(datasetIndex) {
                var dataset = this.data.datasets[datasetIndex];
                if (!dataset) return false;
                var meta = this.getDatasetMeta(datasetIndex);
                return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
            }
        },
        {
            key: "setDatasetVisibility",
            value: function setDatasetVisibility(datasetIndex, visible) {
                var meta = this.getDatasetMeta(datasetIndex);
                meta.hidden = !visible;
            }
        },
        {
            key: "toggleDataVisibility",
            value: function toggleDataVisibility(index) {
                this._hiddenIndices[index] = !this._hiddenIndices[index];
            }
        },
        {
            key: "getDataVisibility",
            value: function getDataVisibility(index) {
                return !this._hiddenIndices[index];
            }
        },
        {
            key: "_updateVisibility",
            value: function _updateVisibility(datasetIndex, dataIndex, visible) {
                var mode = visible ? 'show' : 'hide';
                var meta = this.getDatasetMeta(datasetIndex);
                var anims = meta.controller._resolveAnimations(undefined, mode);
                if ((0, $3zT2Z.h)(dataIndex)) {
                    meta.data[dataIndex].hidden = !visible;
                    this.update();
                } else {
                    this.setDatasetVisibility(datasetIndex, visible);
                    anims.update(meta, {
                        visible: visible
                    });
                    this.update(function(ctx) {
                        return ctx.datasetIndex === datasetIndex ? mode : undefined;
                    });
                }
            }
        },
        {
            key: "hide",
            value: function hide(datasetIndex, dataIndex) {
                this._updateVisibility(datasetIndex, dataIndex, false);
            }
        },
        {
            key: "show",
            value: function show(datasetIndex, dataIndex) {
                this._updateVisibility(datasetIndex, dataIndex, true);
            }
        },
        {
            key: "_destroyDatasetMeta",
            value: function _destroyDatasetMeta(datasetIndex) {
                var meta = this._metasets[datasetIndex];
                if (meta && meta.controller) meta.controller._destroy();
                delete this._metasets[datasetIndex];
            }
        },
        {
            key: "_stop",
            value: function _stop() {
                var i, ilen;
                this.stop();
                animator.remove(this);
                for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.notifyPlugins('beforeDestroy');
                var _this = this, canvas = _this.canvas, ctx = _this.ctx;
                this._stop();
                this.config.clearCache();
                if (canvas) {
                    this.unbindEvents();
                    (0, $3zT2Z.af)(canvas, ctx);
                    this.platform.releaseContext(ctx);
                    this.canvas = null;
                    this.ctx = null;
                }
                delete instances[this.id];
                this.notifyPlugins('afterDestroy');
            }
        },
        {
            key: "toBase64Image",
            value: function toBase64Image() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_canvas;
                return (_this_canvas = this.canvas).toDataURL.apply(_this_canvas, (0, $kNmtb._)(args));
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                this.bindUserEvents();
                if (this.options.responsive) this.bindResponsiveEvents();
                else this.attached = true;
            }
        },
        {
            key: "bindUserEvents",
            value: function bindUserEvents() {
                var _this = this;
                var listeners = this._listeners;
                var platform = this.platform;
                var _add = function(type, listener) {
                    platform.addEventListener(_this, type, listener);
                    listeners[type] = listener;
                };
                var listener = function(e, x, y) {
                    e.offsetX = x;
                    e.offsetY = y;
                    _this._eventHandler(e);
                };
                (0, $3zT2Z.F)(this.options.events, function(type) {
                    return _add(type, listener);
                });
            }
        },
        {
            key: "bindResponsiveEvents",
            value: function bindResponsiveEvents() {
                var _this = this;
                if (!this._responsiveListeners) this._responsiveListeners = {};
                var listeners = this._responsiveListeners;
                var platform = this.platform;
                var _add = function(type, listener) {
                    platform.addEventListener(_this, type, listener);
                    listeners[type] = listener;
                };
                var _remove = function(type, listener) {
                    if (listeners[type]) {
                        platform.removeEventListener(_this, type, listener);
                        delete listeners[type];
                    }
                };
                var listener = function(width, height) {
                    if (_this.canvas) _this.resize(width, height);
                };
                var detached;
                var attached = function() {
                    _remove('attach', attached);
                    _this.attached = true;
                    _this.resize();
                    _add('resize', listener);
                    _add('detach', detached);
                };
                detached = function() {
                    _this.attached = false;
                    _remove('resize', listener);
                    _this._stop();
                    _this._resize(0, 0);
                    _add('attach', attached);
                };
                if (platform.isAttached(this.canvas)) attached();
                else detached();
            }
        },
        {
            key: "unbindEvents",
            value: function unbindEvents() {
                var _this = this;
                (0, $3zT2Z.F)(this._listeners, function(listener, type) {
                    _this.platform.removeEventListener(_this, type, listener);
                });
                this._listeners = {};
                (0, $3zT2Z.F)(this._responsiveListeners, function(listener, type) {
                    _this.platform.removeEventListener(_this, type, listener);
                });
                this._responsiveListeners = undefined;
            }
        },
        {
            key: "updateHoverStyle",
            value: function updateHoverStyle(items, mode, enabled) {
                var prefix = enabled ? 'set' : 'remove';
                var meta, item, i, ilen;
                if (mode === 'dataset') {
                    meta = this.getDatasetMeta(items[0].datasetIndex);
                    meta.controller['_' + prefix + 'DatasetHoverStyle']();
                }
                for(i = 0, ilen = items.length; i < ilen; ++i){
                    item = items[i];
                    var controller = item && this.getDatasetMeta(item.datasetIndex).controller;
                    if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
                }
            }
        },
        {
            key: "getActiveElements",
            value: function getActiveElements() {
                return this._active || [];
            }
        },
        {
            key: "setActiveElements",
            value: function setActiveElements(activeElements) {
                var _this = this;
                var lastActive = this._active || [];
                var active = activeElements.map(function(param) {
                    var datasetIndex = param.datasetIndex, index = param.index;
                    var meta = _this.getDatasetMeta(datasetIndex);
                    if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
                    return {
                        datasetIndex: datasetIndex,
                        element: meta.data[index],
                        index: index
                    };
                });
                var changed = !(0, $3zT2Z.ai)(active, lastActive);
                if (changed) {
                    this._active = active;
                    this._lastEvent = null;
                    this._updateHoverStyles(active, lastActive);
                }
            }
        },
        {
            key: "notifyPlugins",
            value: function notifyPlugins(hook, args, filter) {
                return this._plugins.notify(this, hook, args, filter);
            }
        },
        {
            key: "isPluginEnabled",
            value: function isPluginEnabled(pluginId) {
                return this._plugins._cache.filter(function(p) {
                    return p.plugin.id === pluginId;
                }).length === 1;
            }
        },
        {
            key: "_updateHoverStyles",
            value: function _updateHoverStyles(active, lastActive, replay) {
                var hoverOptions = this.options.hover;
                var diff = function(a, b) {
                    return a.filter(function(x) {
                        return !b.some(function(y) {
                            return x.datasetIndex === y.datasetIndex && x.index === y.index;
                        });
                    });
                };
                var deactivated = diff(lastActive, active);
                var activated = replay ? active : diff(active, lastActive);
                if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
                if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
            }
        },
        {
            key: "_eventHandler",
            value: function _eventHandler(e, replay) {
                var _this = this;
                var args = {
                    event: e,
                    replay: replay,
                    cancelable: true,
                    inChartArea: this.isPointInArea(e)
                };
                var eventFilter = function(plugin) {
                    return (plugin.options.events || _this.options.events).includes(e.native.type);
                };
                if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
                var changed = this._handleEvent(e, replay, args.inChartArea);
                args.cancelable = false;
                this.notifyPlugins('afterEvent', args, eventFilter);
                if (changed || args.changed) this.render();
                return this;
            }
        },
        {
            key: "_handleEvent",
            value: function _handleEvent(e, replay, inChartArea) {
                var _this = this, tmp = _this._active, lastActive = tmp === void 0 ? [] : tmp, options = _this.options;
                var useFinalPosition = replay;
                var active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
                var isClick = (0, $3zT2Z.aj)(e);
                var lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
                if (inChartArea) {
                    this._lastEvent = null;
                    (0, $3zT2Z.Q)(options.onHover, [
                        e,
                        active,
                        this
                    ], this);
                    if (isClick) (0, $3zT2Z.Q)(options.onClick, [
                        e,
                        active,
                        this
                    ], this);
                }
                var changed = !(0, $3zT2Z.ai)(active, lastActive);
                if (changed || replay) {
                    this._active = active;
                    this._updateHoverStyles(active, lastActive, replay);
                }
                this._lastEvent = lastEvent;
                return changed;
            }
        },
        {
            key: "_getActiveElements",
            value: function _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
                if (e.type === 'mouseout') return [];
                if (!inChartArea) return lastActive;
                var hoverOptions = this.options.hover;
                return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
            }
        }
    ], [
        {
            key: "register",
            value: function register() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                var _registry;
                (_registry = registry).add.apply(_registry, (0, $kNmtb._)(items));
                invalidatePlugins();
            }
        },
        {
            key: "unregister",
            value: function unregister() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                var _registry;
                (_registry = registry).remove.apply(_registry, (0, $kNmtb._)(items));
                invalidatePlugins();
            }
        }
    ]);
    return Chart;
}();
(0, $6lD0P._)(Chart, "defaults", (0, $3zT2Z.d));
(0, $6lD0P._)(Chart, "instances", instances);
(0, $6lD0P._)(Chart, "overrides", (0, $3zT2Z.a3));
(0, $6lD0P._)(Chart, "registry", registry);
(0, $6lD0P._)(Chart, "version", version);
(0, $6lD0P._)(Chart, "getChart", getChart);
function invalidatePlugins() {
    return (0, $3zT2Z.F)(Chart.instances, function(chart) {
        return chart._plugins.invalidate();
    });
}
function clipSelf(ctx, element, endAngle) {
    var startAngle = element.startAngle, x = element.x, y = element.y, outerRadius = element.outerRadius, innerRadius = element.innerRadius, options = element.options;
    var borderWidth = options.borderWidth, borderJoinStyle = options.borderJoinStyle;
    var outerAngleClip = Math.min(borderWidth / outerRadius, (0, $3zT2Z.al)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        var innerAngleClip = Math.min(borderWidth / innerRadius, (0, $3zT2Z.al)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        var clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $3zT2Z.al)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $3zT2Z.P) / 2, startAngle + (0, $3zT2Z.P) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            var r = 2 * clipWidth * clipWidth;
            var endX = -r * Math.cos(endAngle + (0, $3zT2Z.P) / 2) + x;
            var endY = -r * Math.sin(endAngle + (0, $3zT2Z.P) / 2) + y;
            var startX = r * Math.cos(startAngle + (0, $3zT2Z.P) / 2) + x;
            var startY = r * Math.sin(startAngle + (0, $3zT2Z.P) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function clipArc(ctx, element, endAngle) {
    var startAngle = element.startAngle, pixelMargin = element.pixelMargin, x = element.x, y = element.y, outerRadius = element.outerRadius, innerRadius = element.innerRadius;
    var angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $3zT2Z.H), startAngle - (0, $3zT2Z.H));
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return (0, $3zT2Z.am)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    var o = toRadiusCorners(arc.options.borderRadius);
    var halfThickness = (outerRadius - innerRadius) / 2;
    var innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    var computeOuterLimit = function(val) {
        var outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $3zT2Z.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $3zT2Z.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $3zT2Z.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    var x = element.x, y = element.y, start = element.startAngle, pixelMargin = element.pixelMargin, innerR = element.innerRadius;
    var outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    var innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    var spacingOffset = 0;
    var alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        var noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        var noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        var avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        var adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    var beta = Math.max(0.001, alpha * outerRadius - offset / (0, $3zT2Z.P)) / outerRadius;
    var angleOffset = (alpha - beta) / 2;
    var startAngle = start + angleOffset + spacingOffset;
    var endAngle = end - angleOffset - spacingOffset;
    var _parseBorderRadius$1 = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle), outerStart = _parseBorderRadius$1.outerStart, outerEnd = _parseBorderRadius$1.outerEnd, innerStart = _parseBorderRadius$1.innerStart, innerEnd = _parseBorderRadius$1.innerEnd;
    var outerStartAdjustedRadius = outerRadius - outerStart;
    var outerEndAdjustedRadius = outerRadius - outerEnd;
    var outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    var outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    var innerStartAdjustedRadius = innerRadius + innerStart;
    var innerEndAdjustedRadius = innerRadius + innerEnd;
    var innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    var innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        var outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            var pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $3zT2Z.H));
        }
        // The line from point 3 to point 4
        var p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            var pCenter1 = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter1.x, pCenter1.y, innerEnd, endAngle + (0, $3zT2Z.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        var innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            var pCenter2 = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter2.x, pCenter2.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $3zT2Z.H));
        }
        // The line from point 7 to point 8
        var p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            var pCenter3 = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter3.x, pCenter3.y, outerStart, startAngle - (0, $3zT2Z.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        var outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        var outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        var outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        var outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    var fullCircles = element.fullCircles, startAngle = element.startAngle, circumference = element.circumference;
    var endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(var i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $3zT2Z.T) || (0, $3zT2Z.T));
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    var fullCircles = element.fullCircles, startAngle = element.startAngle, circumference = element.circumference, options = element.options;
    var borderWidth = options.borderWidth, borderJoinStyle = options.borderJoinStyle, borderDash = options.borderDash, borderDashOffset = options.borderDashOffset, borderRadius = options.borderRadius;
    var inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    var endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(var i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $3zT2Z.T) || (0, $3zT2Z.T));
    }
    if (inner) clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $3zT2Z.P) && borderRadius === 0 && borderJoinStyle !== 'miter') clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
var ArcElement = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $dqNF0._)(ArcElement, Element);
    function ArcElement(cfg) {
        (0, $ioD88._)(this, ArcElement);
        var _this;
        _this = (0, $ctUVE._)(this, ArcElement), (0, $6lD0P._)(_this, "circumference", void 0), (0, $6lD0P._)(_this, "endAngle", void 0), (0, $6lD0P._)(_this, "fullCircles", void 0), (0, $6lD0P._)(_this, "innerRadius", void 0), (0, $6lD0P._)(_this, "outerRadius", void 0), (0, $6lD0P._)(_this, "pixelMargin", void 0), (0, $6lD0P._)(_this, "startAngle", void 0);
        _this.options = undefined;
        _this.circumference = undefined;
        _this.startAngle = undefined;
        _this.endAngle = undefined;
        _this.innerRadius = undefined;
        _this.outerRadius = undefined;
        _this.pixelMargin = 0;
        _this.fullCircles = 0;
        if (cfg) Object.assign(_this, cfg);
        return _this;
    }
    (0, $6NCFa._)(ArcElement, [
        {
            key: "inRange",
            value: function inRange(chartX, chartY, useFinalPosition) {
                var point = this.getProps([
                    'x',
                    'y'
                ], useFinalPosition);
                var _getAngleFromPoint = (0, $3zT2Z.D)(point, {
                    x: chartX,
                    y: chartY
                }), angle = _getAngleFromPoint.angle, distance = _getAngleFromPoint.distance;
                var _this_getProps = this.getProps([
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'circumference'
                ], useFinalPosition), startAngle = _this_getProps.startAngle, endAngle = _this_getProps.endAngle, innerRadius = _this_getProps.innerRadius, outerRadius = _this_getProps.outerRadius, circumference = _this_getProps.circumference;
                var rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
                var _circumference = (0, $3zT2Z.v)(circumference, endAngle - startAngle);
                var nonZeroBetween = (0, $3zT2Z.p)(angle, startAngle, endAngle) && startAngle !== endAngle;
                var betweenAngles = _circumference >= (0, $3zT2Z.T) || nonZeroBetween;
                var withinRadius = (0, $3zT2Z.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
                return betweenAngles && withinRadius;
            }
        },
        {
            key: "getCenterPoint",
            value: function getCenterPoint(useFinalPosition) {
                var _this_getProps = this.getProps([
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y, startAngle = _this_getProps.startAngle, endAngle = _this_getProps.endAngle, innerRadius = _this_getProps.innerRadius, outerRadius = _this_getProps.outerRadius;
                var _this_options = this.options, offset = _this_options.offset, spacing = _this_options.spacing;
                var halfAngle = (startAngle + endAngle) / 2;
                var halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
                return {
                    x: x + Math.cos(halfAngle) * halfRadius,
                    y: y + Math.sin(halfAngle) * halfRadius
                };
            }
        },
        {
            key: "tooltipPosition",
            value: function tooltipPosition(useFinalPosition) {
                return this.getCenterPoint(useFinalPosition);
            }
        },
        {
            key: "draw",
            value: function draw(ctx) {
                var _this = this, options = _this.options, circumference = _this.circumference;
                var offset = (options.offset || 0) / 4;
                var spacing = (options.spacing || 0) / 2;
                var circular = options.circular;
                this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
                this.fullCircles = circumference > (0, $3zT2Z.T) ? Math.floor(circumference / (0, $3zT2Z.T)) : 0;
                if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
                ctx.save();
                var halfAngle = (this.startAngle + this.endAngle) / 2;
                ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
                var fix = 1 - Math.sin(Math.min((0, $3zT2Z.P), circumference || 0));
                var radiusOffset = offset * fix;
                ctx.fillStyle = options.backgroundColor;
                ctx.strokeStyle = options.borderColor;
                drawArc(ctx, this, radiusOffset, spacing, circular);
                drawBorder(ctx, this, radiusOffset, spacing, circular);
                ctx.restore();
            }
        }
    ]);
    return ArcElement;
}((0, $6brDd._)(Element));
(0, $6lD0P._)(ArcElement, "id", 'arc');
(0, $6lD0P._)(ArcElement, "defaults", {
    borderAlign: 'center',
    borderColor: '#fff',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true,
    selfJoin: false
});
(0, $6lD0P._)(ArcElement, "defaultRoutes", {
    backgroundColor: 'backgroundColor'
});
(0, $6lD0P._)(ArcElement, "descriptors", {
    _scriptable: true,
    _indexable: function(name) {
        return name !== 'borderDash';
    }
});
function setStyle(ctx, options) {
    var style = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : options;
    ctx.lineCap = (0, $3zT2Z.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $3zT2Z.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $3zT2Z.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $3zT2Z.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $3zT2Z.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $3zT2Z.v)(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
    if (options.stepped) return 0, $3zT2Z.at;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $3zT2Z.au;
    return lineTo;
}
function pathVars(points, segment) {
    var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var count = points.length;
    var tmp = params.start, paramsStart = tmp === void 0 ? 0 : tmp, tmp1 = params.end, paramsEnd = tmp1 === void 0 ? count - 1 : tmp1;
    var segmentStart = segment.start, segmentEnd = segment.end;
    var start = Math.max(paramsStart, segmentStart);
    var end = Math.min(paramsEnd, segmentEnd);
    var outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function pathSegment(ctx, line, segment, params) {
    var points = line.points, options = line.options;
    var _pathVars = pathVars(points, segment, params), count = _pathVars.count, start = _pathVars.start, loop = _pathVars.loop, ilen = _pathVars.ilen;
    var lineMethod = getLineMethod(options);
    var _ref = params || {}, _ref_move = _ref.move, move = _ref_move === void 0 ? true : _ref_move, reverse = _ref.reverse;
    var i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
    var points = line.points;
    var _pathVars = pathVars(points, segment, params), count = _pathVars.count, start = _pathVars.start, ilen = _pathVars.ilen;
    var _ref = params || {}, _ref_move = _ref.move, move = _ref_move === void 0 ? true : _ref_move, reverse = _ref.reverse;
    var avgX = 0;
    var countX = 0;
    var i, point, prevX, minY, maxY, lastY;
    var pointIndex = function(index) {
        return (start + (reverse ? ilen - index : index)) % count;
    };
    var drawX = function() {
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        var x = point.x;
        var y = point.y;
        var truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function _getSegmentMethod(line) {
    var opts = line.options;
    var borderDash = opts.borderDash && opts.borderDash.length;
    var useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
    if (options.stepped) return 0, $3zT2Z.aq;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $3zT2Z.ar;
    return 0, $3zT2Z.as;
}
function strokePathWithCache(ctx, line, start, count) {
    var path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    var segments = line.segments, options = line.options;
    var segmentMethod = _getSegmentMethod(line);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            setStyle(ctx, options, segment.style);
            ctx.beginPath();
            if (segmentMethod(ctx, line, segment, {
                start: start,
                end: start + count - 1
            })) ctx.closePath();
            ctx.stroke();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) strokePathWithCache(ctx, line, start, count);
    else strokePathDirect(ctx, line, start, count);
}
var LineElement = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $dqNF0._)(LineElement, Element);
    function LineElement(cfg) {
        (0, $ioD88._)(this, LineElement);
        var _this;
        _this = (0, $ctUVE._)(this, LineElement);
        _this.animated = true;
        _this.options = undefined;
        _this._chart = undefined;
        _this._loop = undefined;
        _this._fullLoop = undefined;
        _this._path = undefined;
        _this._points = undefined;
        _this._segments = undefined;
        _this._decimated = false;
        _this._pointsUpdated = false;
        _this._datasetIndex = undefined;
        if (cfg) Object.assign(_this, cfg);
        return _this;
    }
    (0, $6NCFa._)(LineElement, [
        {
            key: "updateControlPoints",
            value: function updateControlPoints(chartArea, indexAxis) {
                var options = this.options;
                if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
                    var loop = options.spanGaps ? this._loop : this._fullLoop;
                    (0, $3zT2Z.an)(this._points, options, chartArea, loop, indexAxis);
                    this._pointsUpdated = true;
                }
            }
        },
        {
            key: "points",
            get: function get() {
                return this._points;
            },
            set: function set(points) {
                this._points = points;
                delete this._segments;
                delete this._path;
                this._pointsUpdated = false;
            }
        },
        {
            key: "segments",
            get: function get() {
                return this._segments || (this._segments = (0, $3zT2Z.ao)(this, this.options.segment));
            }
        },
        {
            key: "first",
            value: function first() {
                var segments = this.segments;
                var points = this.points;
                return segments.length && points[segments[0].start];
            }
        },
        {
            key: "last",
            value: function last() {
                var segments = this.segments;
                var points = this.points;
                var count = segments.length;
                return count && points[segments[count - 1].end];
            }
        },
        {
            key: "interpolate",
            value: function interpolate(point, property) {
                var options = this.options;
                var value = point[property];
                var points = this.points;
                var segments = (0, $3zT2Z.ap)(this, {
                    property: property,
                    start: value,
                    end: value
                });
                if (!segments.length) return;
                var result = [];
                var _interpolate = _getInterpolationMethod(options);
                var i, ilen;
                for(i = 0, ilen = segments.length; i < ilen; ++i){
                    var _segments_i = segments[i], start = _segments_i.start, end = _segments_i.end;
                    var p1 = points[start];
                    var p2 = points[end];
                    if (p1 === p2) {
                        result.push(p1);
                        continue;
                    }
                    var t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
                    var interpolated = _interpolate(p1, p2, t, options.stepped);
                    interpolated[property] = point[property];
                    result.push(interpolated);
                }
                return result.length === 1 ? result[0] : result;
            }
        },
        {
            key: "pathSegment",
            value: function pathSegment(ctx, segment, params) {
                var segmentMethod = _getSegmentMethod(this);
                return segmentMethod(ctx, this, segment, params);
            }
        },
        {
            key: "path",
            value: function path(ctx, start, count) {
                var segments = this.segments;
                var segmentMethod = _getSegmentMethod(this);
                var loop = this._loop;
                start = start || 0;
                count = count || this.points.length - start;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var segment = _step.value;
                        loop &= segmentMethod(ctx, this, segment, {
                            start: start,
                            end: start + count - 1
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !!loop;
            }
        },
        {
            key: "draw",
            value: function draw1(ctx, chartArea, start, count) {
                var options = this.options || {};
                var points = this.points || [];
                if (points.length && options.borderWidth) {
                    ctx.save();
                    draw(ctx, this, start, count);
                    ctx.restore();
                }
                if (this.animated) {
                    this._pointsUpdated = false;
                    this._path = undefined;
                }
            }
        }
    ]);
    return LineElement;
}((0, $6brDd._)(Element));
(0, $6lD0P._)(LineElement, "id", 'line');
(0, $6lD0P._)(LineElement, "defaults", {
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: 'default',
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
});
(0, $6lD0P._)(LineElement, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
(0, $6lD0P._)(LineElement, "descriptors", {
    _scriptable: true,
    _indexable: function(name) {
        return name !== 'borderDash' && name !== 'fill';
    }
});
function inRange$1(el, pos, axis, useFinalPosition) {
    var options = el.options;
    var _el_getProps = el.getProps([
        axis
    ], useFinalPosition), value = _el_getProps[axis];
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
var PointElement = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $dqNF0._)(PointElement, Element);
    function PointElement(cfg) {
        (0, $ioD88._)(this, PointElement);
        var _this;
        _this = (0, $ctUVE._)(this, PointElement), (0, $6lD0P._)(_this, "parsed", void 0), (0, $6lD0P._)(_this, "skip", void 0), (0, $6lD0P._)(_this, "stop", void 0);
        _this.options = undefined;
        _this.parsed = undefined;
        _this.skip = undefined;
        _this.stop = undefined;
        if (cfg) Object.assign(_this, cfg);
        return _this;
    }
    (0, $6NCFa._)(PointElement, [
        {
            key: "inRange",
            value: function inRange(mouseX, mouseY, useFinalPosition) {
                var options = this.options;
                var _this_getProps = this.getProps([
                    'x',
                    'y'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
                return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
            }
        },
        {
            key: "inXRange",
            value: function inXRange(mouseX, useFinalPosition) {
                return inRange$1(this, mouseX, 'x', useFinalPosition);
            }
        },
        {
            key: "inYRange",
            value: function inYRange(mouseY, useFinalPosition) {
                return inRange$1(this, mouseY, 'y', useFinalPosition);
            }
        },
        {
            key: "getCenterPoint",
            value: function getCenterPoint(useFinalPosition) {
                var _this_getProps = this.getProps([
                    'x',
                    'y'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
                return {
                    x: x,
                    y: y
                };
            }
        },
        {
            key: "size",
            value: function size(options) {
                options = options || this.options || {};
                var radius = options.radius || 0;
                radius = Math.max(radius, radius && options.hoverRadius || 0);
                var borderWidth = radius && options.borderWidth || 0;
                return (radius + borderWidth) * 2;
            }
        },
        {
            key: "draw",
            value: function draw(ctx, area) {
                var options = this.options;
                if (this.skip || options.radius < 0.1 || !(0, $3zT2Z.C)(this, area, this.size(options) / 2)) return;
                ctx.strokeStyle = options.borderColor;
                ctx.lineWidth = options.borderWidth;
                ctx.fillStyle = options.backgroundColor;
                (0, $3zT2Z.av)(ctx, options, this.x, this.y);
            }
        },
        {
            key: "getRange",
            value: function getRange() {
                var options = this.options || {};
                // @ts-expect-error Fallbacks should never be hit in practice
                return options.radius + options.hitRadius;
            }
        }
    ]);
    return PointElement;
}((0, $6brDd._)(Element));
(0, $6lD0P._)(PointElement, "id", 'point');
/**
   * @type {any}
   */ (0, $6lD0P._)(PointElement, "defaults", {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: 'circle',
    radius: 3,
    rotation: 0
});
/**
   * @type {any}
   */ (0, $6lD0P._)(PointElement, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
function getBarBounds(bar, useFinalPosition) {
    var _bar_getProps = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition), x = _bar_getProps.x, y = _bar_getProps.y, base = _bar_getProps.base, width = _bar_getProps.width, height = _bar_getProps.height;
    var left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $3zT2Z.S)(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    var value = bar.options.borderWidth;
    var skip = bar.borderSkipped;
    var o = (0, $3zT2Z.ax)(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    var enableBorderRadius = bar.getProps([
        'enableBorderRadius'
    ]).enableBorderRadius;
    var value = bar.options.borderRadius;
    var o = (0, $3zT2Z.ay)(value);
    var maxR = Math.min(maxW, maxH);
    var skip = bar.borderSkipped;
    var enableBorder = enableBorderRadius || (0, $3zT2Z.i)(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    var bounds = getBarBounds(bar);
    var width = bounds.right - bounds.left;
    var height = bounds.bottom - bounds.top;
    var border = parseBorderWidth(bar, width / 2, height / 2);
    var radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    var skipX = x === null;
    var skipY = y === null;
    var skipBoth = skipX && skipY;
    var bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $3zT2Z.ak)(x, bounds.left, bounds.right)) && (skipY || (0, $3zT2Z.ak)(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount) {
    var refRect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var x = rect.x !== refRect.x ? -amount : 0;
    var y = rect.y !== refRect.y ? -amount : 0;
    var w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    var h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
var BarElement = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $dqNF0._)(BarElement, Element);
    function BarElement(cfg) {
        (0, $ioD88._)(this, BarElement);
        var _this;
        _this = (0, $ctUVE._)(this, BarElement);
        _this.options = undefined;
        _this.horizontal = undefined;
        _this.base = undefined;
        _this.width = undefined;
        _this.height = undefined;
        _this.inflateAmount = undefined;
        if (cfg) Object.assign(_this, cfg);
        return _this;
    }
    (0, $6NCFa._)(BarElement, [
        {
            key: "draw",
            value: function draw(ctx) {
                var _this = this, inflateAmount = _this.inflateAmount, _this_options = _this.options, borderColor = _this_options.borderColor, backgroundColor = _this_options.backgroundColor;
                var _boundingRects = boundingRects(this), inner = _boundingRects.inner, outer = _boundingRects.outer;
                var addRectPath = hasRadius(outer.radius) ? (0, $3zT2Z.aw) : addNormalRectPath;
                ctx.save();
                if (outer.w !== inner.w || outer.h !== inner.h) {
                    ctx.beginPath();
                    addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
                    ctx.clip();
                    addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
                    ctx.fillStyle = borderColor;
                    ctx.fill('evenodd');
                }
                ctx.beginPath();
                addRectPath(ctx, inflateRect(inner, inflateAmount));
                ctx.fillStyle = backgroundColor;
                ctx.fill();
                ctx.restore();
            }
        },
        {
            key: "inRange",
            value: function inRange1(mouseX, mouseY, useFinalPosition) {
                return inRange(this, mouseX, mouseY, useFinalPosition);
            }
        },
        {
            key: "inXRange",
            value: function inXRange(mouseX, useFinalPosition) {
                return inRange(this, mouseX, null, useFinalPosition);
            }
        },
        {
            key: "inYRange",
            value: function inYRange(mouseY, useFinalPosition) {
                return inRange(this, null, mouseY, useFinalPosition);
            }
        },
        {
            key: "getCenterPoint",
            value: function getCenterPoint(useFinalPosition) {
                var _this_getProps = this.getProps([
                    'x',
                    'y',
                    'base',
                    'horizontal'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y, base = _this_getProps.base, horizontal = _this_getProps.horizontal;
                return {
                    x: horizontal ? (x + base) / 2 : x,
                    y: horizontal ? y : (y + base) / 2
                };
            }
        },
        {
            key: "getRange",
            value: function getRange(axis) {
                return axis === 'x' ? this.width / 2 : this.height / 2;
            }
        }
    ]);
    return BarElement;
}((0, $6brDd._)(Element));
(0, $6lD0P._)(BarElement, "id", 'bar');
(0, $6lD0P._)(BarElement, "defaults", {
    borderSkipped: 'start',
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: 'auto',
    pointStyle: undefined
});
(0, $6lD0P._)(BarElement, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
var elements = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: ArcElement,
    BarElement: BarElement,
    LineElement: LineElement,
    PointElement: PointElement
});
var BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
var BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map(function(color) {
    return color.replace('rgb(', 'rgba(').replace(')', ', 0.5)');
});
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(function() {
        return getBorderColor(i++);
    });
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(function() {
        return getBackgroundColor(i++);
    });
    return i;
}
function getColorizer(chart) {
    var i = 0;
    return function(dataset, datasetIndex) {
        var controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) i = colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof PolarAreaController) i = colorizePolarAreaDataset(dataset, i);
        else if (controller) i = colorizeDefaultDataset(dataset, i);
    };
}
function containsColorsDefinitions(descriptors) {
    var k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function containsDefaultColorsDefenitions() {
    return (0, $3zT2Z.d).borderColor !== 'rgba(0,0,0,0.1)' || (0, $3zT2Z.d).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var plugin_colors = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout: function(chart, _args, options) {
        if (!options.enabled) return;
        var _chart_config = chart.config, datasets = _chart_config.data.datasets, chartOptions = _chart_config.options;
        var elements = chartOptions.elements;
        var containsColorDefenition = containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements) || containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        var colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function lttbDecimation(data, start, count, availableWidth, options) {
    var samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    var decimated = [];
    var bucketWidth = (count - 2) / (samples - 2);
    var sampledIndex = 0;
    var endIndex = start + count - 1;
    var a = start;
    var i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        var avgX = 0;
        var avgY = 0;
        var j = void 0;
        var avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        var avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        var avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        var rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        var rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        var _data_a = data[a], pointAx = _data_a.x, pointAy = _data_a.y;
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    var avgX = 0;
    var countX = 0;
    var i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    var decimated = [];
    var endIndex = start + count - 1;
    var xMin = data[start].x;
    var xMax = data[endIndex].x;
    var dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        var truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            var lastIndex = i - 1;
            if (!(0, $3zT2Z.k)(minIndex) && !(0, $3zT2Z.k)(maxIndex)) {
                var intermediateIndex1 = Math.min(minIndex, maxIndex);
                var intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push((0, $3K9Jy._)((0, $8lZHN._)({}, data[intermediateIndex1]), {
                    x: avgX
                }));
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push((0, $3K9Jy._)((0, $8lZHN._)({}, data[intermediateIndex2]), {
                    x: avgX
                }));
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        var data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach(function(dataset) {
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    var pointCount = points.length;
    var start = 0;
    var count;
    var iScale = meta.iScale;
    var _iScale_getUserBounds = iScale.getUserBounds(), min = _iScale_getUserBounds.min, max = _iScale_getUserBounds.max, minDefined = _iScale_getUserBounds.minDefined, maxDefined = _iScale_getUserBounds.maxDefined;
    if (minDefined) start = (0, $3zT2Z.S)((0, $3zT2Z.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $3zT2Z.S)((0, $3zT2Z.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var plugin_decimation = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: function(chart, args, options) {
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        var availableWidth = chart.width;
        chart.data.datasets.forEach(function(dataset, datasetIndex) {
            var _data = dataset._data, indexAxis = dataset.indexAxis;
            var meta = chart.getDatasetMeta(datasetIndex);
            var data = _data || dataset.data;
            if ((0, $3zT2Z.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            var xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            var _getStartAndCountOfVisiblePointsSimplified = getStartAndCountOfVisiblePointsSimplified(meta, data), start = _getStartAndCountOfVisiblePointsSimplified.start, count = _getStartAndCountOfVisiblePointsSimplified.count;
            var threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $3zT2Z.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function get() {
                        return this._decimated;
                    },
                    set: function set(d) {
                        this._data = d;
                    }
                });
            }
            var decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error("Unsupported decimation algorithm '".concat(options.algorithm, "'"));
            }
            dataset._decimated = decimated;
        });
    },
    destroy: function(chart) {
        cleanDecimatedData(chart);
    }
};
function _segments(line, target, property) {
    var segments = line.segments;
    var points = line.points;
    var tpoints = target.points;
    var parts = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var start = segment.start, end = segment.end;
            end = _findSegmentEnd(start, end, points);
            var bounds = _getBounds(property, points[start], points[end], segment.loop);
            if (!target.segments) {
                parts.push({
                    source: segment,
                    target: bounds,
                    start: points[start],
                    end: points[end]
                });
                continue;
            }
            var targetSegments = (0, $3zT2Z.ap)(target, bounds);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = targetSegments[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var tgt = _step1.value;
                    var subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
                    var fillSources = (0, $3zT2Z.az)(segment, points, subBounds);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = fillSources[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var fillSource = _step2.value;
                            parts.push({
                                source: fillSource,
                                target: tgt,
                                start: (0, $6lD0P._)({}, property, _getEdge(bounds, subBounds, 'start', Math.max)),
                                end: (0, $6lD0P._)({}, property, _getEdge(bounds, subBounds, 'end', Math.min))
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) return;
    var start = first[property];
    var end = last[property];
    if (property === 'angle') {
        start = (0, $3zT2Z.al)(start);
        end = (0, $3zT2Z.al)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function _pointsFromSegments(boundary, line) {
    var _ref = boundary || {}, _ref_x = _ref.x, x = _ref_x === void 0 ? null : _ref_x, _ref_y = _ref.y, y = _ref_y === void 0 ? null : _ref_y;
    var linePoints = line.points;
    var points = [];
    line.segments.forEach(function(param) {
        var start = param.start, end = param.end;
        end = _findSegmentEnd(start, end, linePoints);
        var first = linePoints[start];
        var last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        var point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
    var points = [];
    var _loop = false;
    if ((0, $3zT2Z.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = _pointsFromSegments(boundary, line);
    return points.length ? new LineElement({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
    var source = sources[index];
    var fill = source.fill;
    var visited = [
        index
    ];
    var target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $3zT2Z.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function _decodeFill(line, index, count) {
    var fill = parseFillOption(line);
    if ((0, $3zT2Z.i)(fill)) return isNaN(fill.value) ? false : fill;
    var target = parseFloat(fill);
    if ((0, $3zT2Z.g)(target) && Math.floor(target) === target) return decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function _getTargetPixel(fill, scale) {
    var pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $3zT2Z.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function _getTargetValue(fill, scale, startValue) {
    var value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $3zT2Z.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function parseFillOption(line) {
    var options = line.options;
    var fillOption = options.fill;
    var fill = (0, $3zT2Z.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function _buildStackLine(source) {
    var scale = source.scale, index = source.index, line = source.line;
    var points = [];
    var segments = line.segments;
    var sourcePoints = line.points;
    var linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        for(var j = segment.start; j <= segment.end; j++)addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new LineElement({
        points: points,
        options: {}
    });
}
function getLinesBelow(scale, index) {
    var below = [];
    var metas = scale.getMatchingVisibleMetas('line');
    for(var i = 0; i < metas.length; i++){
        var meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
    var _points;
    var postponed = [];
    for(var j = 0; j < linesBelow.length; j++){
        var line = linesBelow[j];
        var _findPoint = findPoint(line, sourcePoint, 'x'), first = _findPoint.first, last = _findPoint.last, point = _findPoint.point;
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    (_points = points).push.apply(_points, (0, $kNmtb._)(postponed));
}
function findPoint(line, sourcePoint, property) {
    var point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    var pointValue = point[property];
    var segments = line.segments;
    var linePoints = line.points;
    var first = false;
    var last = false;
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        var firstValue = linePoints[segment.start][property];
        var lastValue = linePoints[segment.end][property];
        if ((0, $3zT2Z.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
var simpleArc = /*#__PURE__*/ function() {
    "use strict";
    function simpleArc(opts) {
        (0, $ioD88._)(this, simpleArc);
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    (0, $6NCFa._)(simpleArc, [
        {
            key: "pathSegment",
            value: function pathSegment(ctx, bounds, opts) {
                var _this = this, x = _this.x, y = _this.y, radius = _this.radius;
                bounds = bounds || {
                    start: 0,
                    end: (0, $3zT2Z.T)
                };
                ctx.arc(x, y, radius, bounds.end, bounds.start, true);
                return !opts.bounds;
            }
        },
        {
            key: "interpolate",
            value: function interpolate(point) {
                var _this = this, x = _this.x, y = _this.y, radius = _this.radius;
                var angle = point.angle;
                return {
                    x: x + Math.cos(angle) * radius,
                    y: y + Math.sin(angle) * radius,
                    angle: angle
                };
            }
        }
    ]);
    return simpleArc;
}();
function _getTarget(source) {
    var chart = source.chart, fill = source.fill, line = source.line;
    if ((0, $3zT2Z.g)(fill)) return getLineByIndex(chart, fill);
    if (fill === 'stack') return _buildStackLine(source);
    if (fill === 'shape') return true;
    var boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) return boundary;
    return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
    var meta = chart.getDatasetMeta(index);
    var visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    var scale = source.scale || {};
    if (scale.getPointPositionForValue) return computeCircularBoundary(source);
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    var _source_scale = source.scale, scale = _source_scale === void 0 ? {} : _source_scale, fill = source.fill;
    var pixel = _getTargetPixel(fill, scale);
    if ((0, $3zT2Z.g)(pixel)) {
        var horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    var scale = source.scale, fill = source.fill;
    var options = scale.options;
    var length = scale.getLabels().length;
    var start = options.reverse ? scale.max : scale.min;
    var value = _getTargetValue(fill, scale, start);
    var target = [];
    if (options.grid.circular) {
        var center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(var i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function _drawfill(ctx, source, area) {
    var target = _getTarget(source);
    var chart = source.chart, index = source.index, line = source.line, scale = source.scale, axis = source.axis;
    var lineOpts = line.options;
    var fillOption = lineOpts.fill;
    var color = lineOpts.backgroundColor;
    var _ref = fillOption || {}, _ref_above = _ref.above, above = _ref_above === void 0 ? color : _ref_above, _ref_below = _ref.below, below = _ref_below === void 0 ? color : _ref_below;
    var meta = chart.getDatasetMeta(index);
    var clip = (0, $3zT2Z.ah)(chart, meta);
    if (target && line.points.length) {
        (0, $3zT2Z.Y)(ctx, area);
        doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $3zT2Z.$)(ctx);
    }
}
function doFill(ctx, cfg) {
    var line = cfg.line, target = cfg.target, above = cfg.above, below = cfg.below, area = cfg.area, scale = cfg.scale, clip = cfg.clip;
    var property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    var fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            clipVertical(ctx, target, area.top);
            fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            clipHorizontal(ctx, target, area.left);
            fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    var segments = target.segments, points = target.points;
    var first = true;
    var lineLoop = false;
    ctx.beginPath();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var start = segment.start, end = segment.end;
            var firstPoint = points[start];
            var lastPoint = points[_findSegmentEnd(start, end, points)];
            if (first) {
                ctx.moveTo(firstPoint.x, firstPoint.y);
                first = false;
            } else {
                ctx.lineTo(firstPoint.x, clipY);
                ctx.lineTo(firstPoint.x, firstPoint.y);
            }
            lineLoop = !!target.pathSegment(ctx, segment, {
                move: lineLoop
            });
            if (lineLoop) ctx.closePath();
            else ctx.lineTo(lastPoint.x, clipY);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function clipHorizontal(ctx, target, clipX) {
    var segments = target.segments, points = target.points;
    var first = true;
    var lineLoop = false;
    ctx.beginPath();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var start = segment.start, end = segment.end;
            var firstPoint = points[start];
            var lastPoint = points[_findSegmentEnd(start, end, points)];
            if (first) {
                ctx.moveTo(firstPoint.x, firstPoint.y);
                first = false;
            } else {
                ctx.lineTo(clipX, firstPoint.y);
                ctx.lineTo(firstPoint.x, firstPoint.y);
            }
            lineLoop = !!target.pathSegment(ctx, segment, {
                move: lineLoop
            });
            if (lineLoop) ctx.closePath();
            else ctx.lineTo(clipX, lastPoint.y);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    var line = cfg.line, target = cfg.target, property = cfg.property, color = cfg.color, scale = cfg.scale, clip = cfg.clip;
    var segments = _segments(line, target, property);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, src = _step_value.source, tgt = _step_value.target, start = _step_value.start, end = _step_value.end;
            var tmp = src.style, _ref = tmp === void 0 ? {} : tmp, _ref_backgroundColor = _ref.backgroundColor, backgroundColor = _ref_backgroundColor === void 0 ? color : _ref_backgroundColor;
            var notShape = target !== true;
            ctx.save();
            ctx.fillStyle = backgroundColor;
            clipBounds(ctx, scale, clip, notShape && _getBounds(property, start, end));
            ctx.beginPath();
            var lineLoop = !!line.pathSegment(ctx, src);
            var loop = void 0;
            if (notShape) {
                if (lineLoop) ctx.closePath();
                else interpolatedLineTo(ctx, target, end, property);
                var targetLoop = !!target.pathSegment(ctx, tgt, {
                    move: lineLoop,
                    reverse: true
                });
                loop = lineLoop && targetLoop;
                if (!loop) interpolatedLineTo(ctx, target, start, property);
            }
            ctx.closePath();
            ctx.fill(loop ? 'evenodd' : 'nonzero');
            ctx.restore();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function clipBounds(ctx, scale, clip, bounds) {
    var chartArea = scale.chart.chartArea;
    var _ref = bounds || {}, property = _ref.property, start = _ref.start, end = _ref.end;
    if (property === 'x' || property === 'y') {
        var left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    var interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var index = {
    id: 'filler',
    afterDatasetsUpdate: function(chart, _args, options) {
        var count = (chart.data.datasets || []).length;
        var sources = [];
        var meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: _decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw: function(chart, _args, options) {
        var draw = options.drawTime === 'beforeDraw';
        var metasets = chart.getSortedVisibleDatasetMetas();
        var area = chart.chartArea;
        for(var i = metasets.length - 1; i >= 0; --i){
            var source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) _drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw: function(chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        var metasets = chart.getSortedVisibleDatasetMetas();
        for(var i = metasets.length - 1; i >= 0; --i){
            var source = metasets[i].$filler;
            if (_shouldApplyFill(source)) _drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw: function(chart, args, options) {
        var source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
var getBoxSize = function(labelOpts, fontSize) {
    var _labelOpts_boxHeight = labelOpts.boxHeight, boxHeight = _labelOpts_boxHeight === void 0 ? fontSize : _labelOpts_boxHeight, _labelOpts_boxWidth = labelOpts.boxWidth, boxWidth = _labelOpts_boxWidth === void 0 ? fontSize : _labelOpts_boxWidth;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
var itemsEqual = function(a, b) {
    return a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
};
var Legend = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $dqNF0._)(Legend, Element);
    function Legend(config) {
        (0, $ioD88._)(this, Legend);
        var _this;
        _this = (0, $ctUVE._)(this, Legend);
        _this._added = false;
        _this.legendHitBoxes = [];
        _this._hoveredItem = null;
        _this.doughnutMode = false;
        _this.chart = config.chart;
        _this.options = config.options;
        _this.ctx = config.ctx;
        _this.legendItems = undefined;
        _this.columnSizes = undefined;
        _this.lineWidths = undefined;
        _this.maxHeight = undefined;
        _this.maxWidth = undefined;
        _this.top = undefined;
        _this.bottom = undefined;
        _this.left = undefined;
        _this.right = undefined;
        _this.height = undefined;
        _this.width = undefined;
        _this._margins = undefined;
        _this.position = undefined;
        _this.weight = undefined;
        _this.fullSize = undefined;
        return _this;
    }
    (0, $6NCFa._)(Legend, [
        {
            key: "update",
            value: function update(maxWidth, maxHeight, margins) {
                this.maxWidth = maxWidth;
                this.maxHeight = maxHeight;
                this._margins = margins;
                this.setDimensions();
                this.buildLabels();
                this.fit();
            }
        },
        {
            key: "setDimensions",
            value: function setDimensions() {
                if (this.isHorizontal()) {
                    this.width = this.maxWidth;
                    this.left = this._margins.left;
                    this.right = this.width;
                } else {
                    this.height = this.maxHeight;
                    this.top = this._margins.top;
                    this.bottom = this.height;
                }
            }
        },
        {
            key: "buildLabels",
            value: function buildLabels() {
                var _this = this;
                var labelOpts = this.options.labels || {};
                var legendItems = (0, $3zT2Z.Q)(labelOpts.generateLabels, [
                    this.chart
                ], this) || [];
                if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                    return labelOpts.filter(item, _this.chart.data);
                });
                if (labelOpts.sort) legendItems = legendItems.sort(function(a, b) {
                    return labelOpts.sort(a, b, _this.chart.data);
                });
                if (this.options.reverse) legendItems.reverse();
                this.legendItems = legendItems;
            }
        },
        {
            key: "fit",
            value: function fit() {
                var _this = this, options = _this.options, ctx = _this.ctx;
                if (!options.display) {
                    this.width = this.height = 0;
                    return;
                }
                var labelOpts = options.labels;
                var labelFont = (0, $3zT2Z.a0)(labelOpts.font);
                var fontSize = labelFont.size;
                var titleHeight = this._computeTitleHeight();
                var _getBoxSize = getBoxSize(labelOpts, fontSize), boxWidth = _getBoxSize.boxWidth, itemHeight = _getBoxSize.itemHeight;
                var width, height;
                ctx.font = labelFont.string;
                if (this.isHorizontal()) {
                    width = this.maxWidth;
                    height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
                } else {
                    height = this.maxHeight;
                    width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
                }
                this.width = Math.min(width, options.maxWidth || this.maxWidth);
                this.height = Math.min(height, options.maxHeight || this.maxHeight);
            }
        },
        {
            key: "_fitRows",
            value: function _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
                var _this = this, ctx = _this.ctx, maxWidth = _this.maxWidth, _this_options = _this.options, padding = _this_options.labels.padding;
                var hitboxes = this.legendHitBoxes = [];
                var lineWidths = this.lineWidths = [
                    0
                ];
                var lineHeight = itemHeight + padding;
                var totalHeight = titleHeight;
                ctx.textAlign = 'left';
                ctx.textBaseline = 'middle';
                var row = -1;
                var top = -lineHeight;
                this.legendItems.forEach(function(legendItem, i) {
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                        totalHeight += lineHeight;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                        top += lineHeight;
                        row++;
                    }
                    hitboxes[i] = {
                        left: 0,
                        top: top,
                        row: row,
                        width: itemWidth,
                        height: itemHeight
                    };
                    lineWidths[lineWidths.length - 1] += itemWidth + padding;
                });
                return totalHeight;
            }
        },
        {
            key: "_fitCols",
            value: function _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
                var _this = this, ctx = _this.ctx, maxHeight = _this.maxHeight, _this_options = _this.options, padding = _this_options.labels.padding;
                var hitboxes = this.legendHitBoxes = [];
                var columnSizes = this.columnSizes = [];
                var heightLimit = maxHeight - titleHeight;
                var totalWidth = padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                var left = 0;
                var col = 0;
                this.legendItems.forEach(function(legendItem, i) {
                    var _calculateItemSize = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight), itemWidth = _calculateItemSize.itemWidth, itemHeight = _calculateItemSize.itemHeight;
                    if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                        totalWidth += currentColWidth + padding;
                        columnSizes.push({
                            width: currentColWidth,
                            height: currentColHeight
                        });
                        left += currentColWidth + padding;
                        col++;
                        currentColWidth = currentColHeight = 0;
                    }
                    hitboxes[i] = {
                        left: left,
                        top: currentColHeight,
                        col: col,
                        width: itemWidth,
                        height: itemHeight
                    };
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += itemHeight + padding;
                });
                totalWidth += currentColWidth;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                return totalWidth;
            }
        },
        {
            key: "adjustHitBoxes",
            value: function adjustHitBoxes() {
                if (!this.options.display) return;
                var titleHeight = this._computeTitleHeight();
                var _this = this, hitboxes = _this.legendHitBoxes, _this_options = _this.options, align = _this_options.align, padding = _this_options.labels.padding, rtl = _this_options.rtl;
                var rtlHelper = (0, $3zT2Z.aA)(rtl, this.left, this.width);
                if (this.isHorizontal()) {
                    var row = 0;
                    var left = (0, $3zT2Z.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = hitboxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var hitbox = _step.value;
                            if (row !== hitbox.row) {
                                row = hitbox.row;
                                left = (0, $3zT2Z.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                            }
                            hitbox.top += this.top + titleHeight + padding;
                            hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                            left += hitbox.width + padding;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    var col = 0;
                    var top = (0, $3zT2Z.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = hitboxes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var hitbox1 = _step1.value;
                            if (hitbox1.col !== col) {
                                col = hitbox1.col;
                                top = (0, $3zT2Z.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                            }
                            hitbox1.top = top;
                            hitbox1.left += this.left + padding;
                            hitbox1.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox1.left), hitbox1.width);
                            top += hitbox1.height + padding;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "isHorizontal",
            value: function isHorizontal() {
                return this.options.position === 'top' || this.options.position === 'bottom';
            }
        },
        {
            key: "draw",
            value: function draw() {
                if (this.options.display) {
                    var ctx = this.ctx;
                    (0, $3zT2Z.Y)(ctx, this);
                    this._draw();
                    (0, $3zT2Z.$)(ctx);
                }
            }
        },
        {
            key: "_draw",
            value: function _draw() {
                var _this = this;
                var _this1 = this, opts = _this1.options, columnSizes = _this1.columnSizes, lineWidths = _this1.lineWidths, ctx = _this1.ctx;
                var align = opts.align, labelOpts = opts.labels;
                var defaultColor = (0, $3zT2Z.d).color;
                var rtlHelper = (0, $3zT2Z.aA)(opts.rtl, this.left, this.width);
                var labelFont = (0, $3zT2Z.a0)(labelOpts.font);
                var padding = labelOpts.padding;
                var fontSize = labelFont.size;
                var halfFontSize = fontSize / 2;
                var cursor;
                this.drawTitle();
                ctx.textAlign = rtlHelper.textAlign('left');
                ctx.textBaseline = 'middle';
                ctx.lineWidth = 0.5;
                ctx.font = labelFont.string;
                var _getBoxSize = getBoxSize(labelOpts, fontSize), boxWidth = _getBoxSize.boxWidth, boxHeight = _getBoxSize.boxHeight, itemHeight = _getBoxSize.itemHeight;
                var drawLegendBox = function drawLegendBox(x, y, legendItem) {
                    if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
                    ctx.save();
                    var lineWidth = (0, $3zT2Z.v)(legendItem.lineWidth, 1);
                    ctx.fillStyle = (0, $3zT2Z.v)(legendItem.fillStyle, defaultColor);
                    ctx.lineCap = (0, $3zT2Z.v)(legendItem.lineCap, 'butt');
                    ctx.lineDashOffset = (0, $3zT2Z.v)(legendItem.lineDashOffset, 0);
                    ctx.lineJoin = (0, $3zT2Z.v)(legendItem.lineJoin, 'miter');
                    ctx.lineWidth = lineWidth;
                    ctx.strokeStyle = (0, $3zT2Z.v)(legendItem.strokeStyle, defaultColor);
                    ctx.setLineDash((0, $3zT2Z.v)(legendItem.lineDash, []));
                    if (labelOpts.usePointStyle) {
                        var drawOptions = {
                            radius: boxHeight * Math.SQRT2 / 2,
                            pointStyle: legendItem.pointStyle,
                            rotation: legendItem.rotation,
                            borderWidth: lineWidth
                        };
                        var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                        var centerY = y + halfFontSize;
                        (0, $3zT2Z.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
                    } else {
                        var yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                        var xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                        var borderRadius = (0, $3zT2Z.ay)(legendItem.borderRadius);
                        ctx.beginPath();
                        if (Object.values(borderRadius).some(function(v) {
                            return v !== 0;
                        })) (0, $3zT2Z.aw)(ctx, {
                            x: xBoxLeft,
                            y: yBoxTop,
                            w: boxWidth,
                            h: boxHeight,
                            radius: borderRadius
                        });
                        else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                        ctx.fill();
                        if (lineWidth !== 0) ctx.stroke();
                    }
                    ctx.restore();
                };
                var fillText = function fillText(x, y, legendItem) {
                    (0, $3zT2Z.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                        strikethrough: legendItem.hidden,
                        textAlign: rtlHelper.textAlign(legendItem.textAlign)
                    });
                };
                var isHorizontal = this.isHorizontal();
                var titleHeight = this._computeTitleHeight();
                if (isHorizontal) cursor = {
                    x: (0, $3zT2Z.a2)(align, this.left + padding, this.right - lineWidths[0]),
                    y: this.top + padding + titleHeight,
                    line: 0
                };
                else cursor = {
                    x: this.left + padding,
                    y: (0, $3zT2Z.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
                    line: 0
                };
                (0, $3zT2Z.aB)(this.ctx, opts.textDirection);
                var lineHeight = itemHeight + padding;
                this.legendItems.forEach(function(legendItem, i) {
                    ctx.strokeStyle = legendItem.fontColor;
                    ctx.fillStyle = legendItem.fontColor;
                    var textWidth = ctx.measureText(legendItem.text).width;
                    var textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
                    var width = boxWidth + halfFontSize + textWidth;
                    var x = cursor.x;
                    var y = cursor.y;
                    rtlHelper.setWidth(_this.width);
                    if (isHorizontal) {
                        if (i > 0 && x + width + padding > _this.right) {
                            y = cursor.y += lineHeight;
                            cursor.line++;
                            x = cursor.x = (0, $3zT2Z.a2)(align, _this.left + padding, _this.right - lineWidths[cursor.line]);
                        }
                    } else if (i > 0 && y + lineHeight > _this.bottom) {
                        x = cursor.x = x + columnSizes[cursor.line].width + padding;
                        cursor.line++;
                        y = cursor.y = (0, $3zT2Z.a2)(align, _this.top + titleHeight + padding, _this.bottom - columnSizes[cursor.line].height);
                    }
                    var realX = rtlHelper.x(x);
                    drawLegendBox(realX, y, legendItem);
                    x = (0, $3zT2Z.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : _this.right, opts.rtl);
                    fillText(rtlHelper.x(x), y, legendItem);
                    if (isHorizontal) cursor.x += width + padding;
                    else if (typeof legendItem.text !== 'string') {
                        var fontLineHeight = labelFont.lineHeight;
                        cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
                    } else cursor.y += lineHeight;
                });
                (0, $3zT2Z.aD)(this.ctx, opts.textDirection);
            }
        },
        {
            key: "drawTitle",
            value: function drawTitle() {
                var opts = this.options;
                var titleOpts = opts.title;
                var titleFont = (0, $3zT2Z.a0)(titleOpts.font);
                var titlePadding = (0, $3zT2Z.E)(titleOpts.padding);
                if (!titleOpts.display) return;
                var rtlHelper = (0, $3zT2Z.aA)(opts.rtl, this.left, this.width);
                var ctx = this.ctx;
                var position = titleOpts.position;
                var halfFontSize = titleFont.size / 2;
                var topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
                var y;
                var left = this.left;
                var maxWidth = this.width;
                if (this.isHorizontal()) {
                    var _Math;
                    maxWidth = (_Math = Math).max.apply(_Math, (0, $kNmtb._)(this.lineWidths));
                    y = this.top + topPaddingPlusHalfFontSize;
                    left = (0, $3zT2Z.a2)(opts.align, left, this.right - maxWidth);
                } else {
                    var maxHeight = this.columnSizes.reduce(function(acc, size) {
                        return Math.max(acc, size.height);
                    }, 0);
                    y = topPaddingPlusHalfFontSize + (0, $3zT2Z.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
                }
                var x = (0, $3zT2Z.a2)(position, left, left + maxWidth);
                ctx.textAlign = rtlHelper.textAlign((0, $3zT2Z.a1)(position));
                ctx.textBaseline = 'middle';
                ctx.strokeStyle = titleOpts.color;
                ctx.fillStyle = titleOpts.color;
                ctx.font = titleFont.string;
                (0, $3zT2Z.Z)(ctx, titleOpts.text, x, y, titleFont);
            }
        },
        {
            key: "_computeTitleHeight",
            value: function _computeTitleHeight() {
                var titleOpts = this.options.title;
                var titleFont = (0, $3zT2Z.a0)(titleOpts.font);
                var titlePadding = (0, $3zT2Z.E)(titleOpts.padding);
                return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
            }
        },
        {
            key: "_getLegendItemAt",
            value: function _getLegendItemAt(x, y) {
                var i, hitBox, lh;
                if ((0, $3zT2Z.ak)(x, this.left, this.right) && (0, $3zT2Z.ak)(y, this.top, this.bottom)) {
                    lh = this.legendHitBoxes;
                    for(i = 0; i < lh.length; ++i){
                        hitBox = lh[i];
                        if ((0, $3zT2Z.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $3zT2Z.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
                    }
                }
                return null;
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(e) {
                var opts = this.options;
                if (!isListened(e.type, opts)) return;
                var hoveredItem = this._getLegendItemAt(e.x, e.y);
                if (e.type === 'mousemove' || e.type === 'mouseout') {
                    var previous = this._hoveredItem;
                    var sameItem = itemsEqual(previous, hoveredItem);
                    if (previous && !sameItem) (0, $3zT2Z.Q)(opts.onLeave, [
                        e,
                        previous,
                        this
                    ], this);
                    this._hoveredItem = hoveredItem;
                    if (hoveredItem && !sameItem) (0, $3zT2Z.Q)(opts.onHover, [
                        e,
                        hoveredItem,
                        this
                    ], this);
                } else if (hoveredItem) (0, $3zT2Z.Q)(opts.onClick, [
                    e,
                    hoveredItem,
                    this
                ], this);
            }
        }
    ]);
    return Legend;
}((0, $6brDd._)(Element));
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    var itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    var itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    var legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce(function(a, b) {
        return a.length > b.length ? a : b;
    });
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    var itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    var labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var plugin_legend = {
    id: 'legend',
    _element: Legend,
    start: function(chart, _args, options) {
        var legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop: function(chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate: function(chart, _args, options) {
        var legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate: function(chart) {
        var legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent: function(chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick: function(e, legendItem, legend) {
            var index = legendItem.datasetIndex;
            var ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: function(ctx) {
                return ctx.chart.options.color;
            },
            boxWidth: 40,
            padding: 10,
            generateLabels: function(chart) {
                var datasets = chart.data.datasets;
                var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, usePointStyle = _chart_legend_options_labels.usePointStyle, pointStyle = _chart_legend_options_labels.pointStyle, textAlign = _chart_legend_options_labels.textAlign, color = _chart_legend_options_labels.color, useBorderRadius = _chart_legend_options_labels.useBorderRadius, borderRadius = _chart_legend_options_labels.borderRadius;
                return chart._getSortedDatasetMetas().map(function(meta) {
                    var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    var borderWidth = (0, $3zT2Z.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: function(ctx) {
                return ctx.chart.options.color;
            },
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: function(name) {
            return !name.startsWith('on');
        },
        labels: {
            _scriptable: function(name) {
                return ![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name);
            }
        }
    }
};
var Title = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $dqNF0._)(Title, Element);
    function Title(config) {
        (0, $ioD88._)(this, Title);
        var _this;
        _this = (0, $ctUVE._)(this, Title);
        _this.chart = config.chart;
        _this.options = config.options;
        _this.ctx = config.ctx;
        _this._padding = undefined;
        _this.top = undefined;
        _this.bottom = undefined;
        _this.left = undefined;
        _this.right = undefined;
        _this.width = undefined;
        _this.height = undefined;
        _this.position = undefined;
        _this.weight = undefined;
        _this.fullSize = undefined;
        return _this;
    }
    (0, $6NCFa._)(Title, [
        {
            key: "update",
            value: function update(maxWidth, maxHeight) {
                var opts = this.options;
                this.left = 0;
                this.top = 0;
                if (!opts.display) {
                    this.width = this.height = this.right = this.bottom = 0;
                    return;
                }
                this.width = this.right = maxWidth;
                this.height = this.bottom = maxHeight;
                var lineCount = (0, $3zT2Z.b)(opts.text) ? opts.text.length : 1;
                this._padding = (0, $3zT2Z.E)(opts.padding);
                var textSize = lineCount * (0, $3zT2Z.a0)(opts.font).lineHeight + this._padding.height;
                if (this.isHorizontal()) this.height = textSize;
                else this.width = textSize;
            }
        },
        {
            key: "isHorizontal",
            value: function isHorizontal() {
                var pos = this.options.position;
                return pos === 'top' || pos === 'bottom';
            }
        },
        {
            key: "_drawArgs",
            value: function _drawArgs(offset) {
                var _this = this, top = _this.top, left = _this.left, bottom = _this.bottom, right = _this.right, options = _this.options;
                var align = options.align;
                var rotation = 0;
                var maxWidth, titleX, titleY;
                if (this.isHorizontal()) {
                    titleX = (0, $3zT2Z.a2)(align, left, right);
                    titleY = top + offset;
                    maxWidth = right - left;
                } else {
                    if (options.position === 'left') {
                        titleX = left + offset;
                        titleY = (0, $3zT2Z.a2)(align, bottom, top);
                        rotation = (0, $3zT2Z.P) * -0.5;
                    } else {
                        titleX = right - offset;
                        titleY = (0, $3zT2Z.a2)(align, top, bottom);
                        rotation = (0, $3zT2Z.P) * 0.5;
                    }
                    maxWidth = bottom - top;
                }
                return {
                    titleX: titleX,
                    titleY: titleY,
                    maxWidth: maxWidth,
                    rotation: rotation
                };
            }
        },
        {
            key: "draw",
            value: function draw() {
                var ctx = this.ctx;
                var opts = this.options;
                if (!opts.display) return;
                var fontOpts = (0, $3zT2Z.a0)(opts.font);
                var lineHeight = fontOpts.lineHeight;
                var offset = lineHeight / 2 + this._padding.top;
                var _this__drawArgs = this._drawArgs(offset), titleX = _this__drawArgs.titleX, titleY = _this__drawArgs.titleY, maxWidth = _this__drawArgs.maxWidth, rotation = _this__drawArgs.rotation;
                (0, $3zT2Z.Z)(ctx, opts.text, 0, 0, fontOpts, {
                    color: opts.color,
                    maxWidth: maxWidth,
                    rotation: rotation,
                    textAlign: (0, $3zT2Z.a1)(opts.align),
                    textBaseline: 'middle',
                    translation: [
                        titleX,
                        titleY
                    ]
                });
            }
        }
    ]);
    return Title;
}((0, $6brDd._)(Element));
function createTitle(chart, titleOpts) {
    var title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: 'title',
    _element: Title,
    start: function(chart, _args, options) {
        createTitle(chart, options);
    },
    stop: function(chart) {
        var titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate: function(chart, _args, options) {
        var title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
var map = new WeakMap();
var plugin_subtitle = {
    id: 'subtitle',
    start: function(chart, _args, options) {
        var title = new Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        map.set(chart, title);
    },
    stop: function(chart) {
        layouts.removeBox(chart, map.get(chart));
        map.delete(chart);
    },
    beforeUpdate: function(chart, _args, options) {
        var title = map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
var positioners = {
    average: function(items) {
        if (!items.length) return false;
        var i, len;
        var xSet = new Set();
        var y = 0;
        var count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            var el = items[i].element;
            if (el && el.hasValue()) {
                var pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        var xAverage = (0, $kNmtb._)(xSet).reduce(function(a, b) {
            return a + b;
        }) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest: function(items, eventPosition) {
        if (!items.length) return false;
        var x = eventPosition.x;
        var y = eventPosition.y;
        var minDistance = Number.POSITIVE_INFINITY;
        var i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            var el = items[i].element;
            if (el && el.hasValue()) {
                var center = el.getCenterPoint();
                var d = (0, $3zT2Z.aF)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            var tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $3zT2Z.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function createTooltipItem(chart, item) {
    var element = item.element, datasetIndex = item.datasetIndex, index = item.index;
    var controller = chart.getDatasetMeta(datasetIndex).controller;
    var _controller_getLabelAndValue = controller.getLabelAndValue(index), label = _controller_getLabelAndValue.label, value = _controller_getLabelAndValue.value;
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function getTooltipSize(tooltip, options) {
    var ctx = tooltip.chart.ctx;
    var body = tooltip.body, footer = tooltip.footer, title = tooltip.title;
    var boxWidth = options.boxWidth, boxHeight = options.boxHeight;
    var bodyFont = (0, $3zT2Z.a0)(options.bodyFont);
    var titleFont = (0, $3zT2Z.a0)(options.titleFont);
    var footerFont = (0, $3zT2Z.a0)(options.footerFont);
    var titleLineCount = title.length;
    var footerLineCount = footer.length;
    var bodyLineItemCount = body.length;
    var padding = (0, $3zT2Z.E)(options.padding);
    var height = padding.height;
    var width = 0;
    var combinedBodyLength = body.reduce(function(count, bodyItem) {
        return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
    }, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        var bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    var widthPadding = 0;
    var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $3zT2Z.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $3zT2Z.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $3zT2Z.F)(body, function(bodyItem) {
        (0, $3zT2Z.F)(bodyItem.before, maxLineWidth);
        (0, $3zT2Z.F)(bodyItem.lines, maxLineWidth);
        (0, $3zT2Z.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $3zT2Z.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function determineYAlign(chart, size) {
    var y = size.y, height = size.height;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    var x = size.x, width = size.width;
    var caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function determineXAlign(chart, options, size, yAlign) {
    var x = size.x, width = size.width;
    var chartWidth = chart.width, _chart_chartArea = chart.chartArea, left = _chart_chartArea.left, right = _chart_chartArea.right;
    var xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if (doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function determineAlignment(chart, options, size) {
    var yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function alignX(size, xAlign) {
    var x = size.x, width = size.width;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    var y = size.y, height = size.height;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
    var caretSize = options.caretSize, caretPadding = options.caretPadding, cornerRadius = options.cornerRadius;
    var xAlign = alignment.xAlign, yAlign = alignment.yAlign;
    var paddingAndSize = caretSize + caretPadding;
    var _toTRBLCorners = (0, $3zT2Z.ay)(cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
    var x = alignX(size, xAlign);
    var y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $3zT2Z.S)(x, 0, chart.width - size.width),
        y: (0, $3zT2Z.S)(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    var padding = (0, $3zT2Z.E)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $3zT2Z.j)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function overrideCallbacks(callbacks, context) {
    var override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
var defaultCallbacks = {
    beforeTitle: (0, $3zT2Z.aG),
    title: function(tooltipItems) {
        if (tooltipItems.length > 0) {
            var item = tooltipItems[0];
            var labels = item.chart.data.labels;
            var labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $3zT2Z.aG),
    beforeBody: (0, $3zT2Z.aG),
    beforeLabel: (0, $3zT2Z.aG),
    label: function(tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        var label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        var value = tooltipItem.formattedValue;
        if (!(0, $3zT2Z.k)(value)) label += value;
        return label;
    },
    labelColor: function(tooltipItem) {
        var meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        var options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor: function() {
        return this.options.bodyColor;
    },
    labelPointStyle: function(tooltipItem) {
        var meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        var options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $3zT2Z.aG),
    afterBody: (0, $3zT2Z.aG),
    beforeFooter: (0, $3zT2Z.aG),
    footer: (0, $3zT2Z.aG),
    afterFooter: (0, $3zT2Z.aG)
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    var result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return defaultCallbacks[name].call(ctx, arg);
    return result;
}
var Tooltip = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $dqNF0._)(Tooltip, Element);
    function Tooltip(config) {
        (0, $ioD88._)(this, Tooltip);
        var _this;
        _this = (0, $ctUVE._)(this, Tooltip);
        _this.opacity = 0;
        _this._active = [];
        _this._eventPosition = undefined;
        _this._size = undefined;
        _this._cachedAnimations = undefined;
        _this._tooltipItems = [];
        _this.$animations = undefined;
        _this.$context = undefined;
        _this.chart = config.chart;
        _this.options = config.options;
        _this.dataPoints = undefined;
        _this.title = undefined;
        _this.beforeBody = undefined;
        _this.body = undefined;
        _this.afterBody = undefined;
        _this.footer = undefined;
        _this.xAlign = undefined;
        _this.yAlign = undefined;
        _this.x = undefined;
        _this.y = undefined;
        _this.height = undefined;
        _this.width = undefined;
        _this.caretX = undefined;
        _this.caretY = undefined;
        _this.labelColors = undefined;
        _this.labelPointStyles = undefined;
        _this.labelTextColors = undefined;
        return _this;
    }
    (0, $6NCFa._)(Tooltip, [
        {
            key: "initialize",
            value: function initialize(options) {
                this.options = options;
                this._cachedAnimations = undefined;
                this.$context = undefined;
            }
        },
        {
            key: "_resolveAnimations",
            value: function _resolveAnimations() {
                var cached = this._cachedAnimations;
                if (cached) return cached;
                var chart = this.chart;
                var options = this.options.setContext(this.getContext());
                var opts = options.enabled && chart.options.animation && options.animations;
                var animations = new Animations(this.chart, opts);
                if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
                return animations;
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
            }
        },
        {
            key: "getTitle",
            value: function getTitle(context, options) {
                var callbacks = options.callbacks;
                var beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
                var title = invokeCallbackWithFallback(callbacks, 'title', this, context);
                var afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
                var lines = [];
                lines = pushOrConcat(lines, splitNewlines(beforeTitle));
                lines = pushOrConcat(lines, splitNewlines(title));
                lines = pushOrConcat(lines, splitNewlines(afterTitle));
                return lines;
            }
        },
        {
            key: "getBeforeBody",
            value: function getBeforeBody(tooltipItems, options) {
                return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
            }
        },
        {
            key: "getBody",
            value: function getBody(tooltipItems, options) {
                var _this = this;
                var callbacks = options.callbacks;
                var bodyItems = [];
                (0, $3zT2Z.F)(tooltipItems, function(context) {
                    var bodyItem = {
                        before: [],
                        lines: [],
                        after: []
                    };
                    var scoped = overrideCallbacks(callbacks, context);
                    pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', _this, context)));
                    pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', _this, context));
                    pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', _this, context)));
                    bodyItems.push(bodyItem);
                });
                return bodyItems;
            }
        },
        {
            key: "getAfterBody",
            value: function getAfterBody(tooltipItems, options) {
                return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
            }
        },
        {
            key: "getFooter",
            value: function getFooter(tooltipItems, options) {
                var callbacks = options.callbacks;
                var beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
                var footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
                var afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
                var lines = [];
                lines = pushOrConcat(lines, splitNewlines(beforeFooter));
                lines = pushOrConcat(lines, splitNewlines(footer));
                lines = pushOrConcat(lines, splitNewlines(afterFooter));
                return lines;
            }
        },
        {
            key: "_createItems",
            value: function _createItems(options) {
                var _this = this;
                var active = this._active;
                var data = this.chart.data;
                var labelColors = [];
                var labelPointStyles = [];
                var labelTextColors = [];
                var tooltipItems = [];
                var i, len;
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(this.chart, active[i]));
                if (options.filter) tooltipItems = tooltipItems.filter(function(element, index, array) {
                    return options.filter(element, index, array, data);
                });
                if (options.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return options.itemSort(a, b, data);
                });
                (0, $3zT2Z.F)(tooltipItems, function(context) {
                    var scoped = overrideCallbacks(options.callbacks, context);
                    labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', _this, context));
                    labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', _this, context));
                    labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', _this, context));
                });
                this.labelColors = labelColors;
                this.labelPointStyles = labelPointStyles;
                this.labelTextColors = labelTextColors;
                this.dataPoints = tooltipItems;
                return tooltipItems;
            }
        },
        {
            key: "update",
            value: function update(changed, replay) {
                var options = this.options.setContext(this.getContext());
                var active = this._active;
                var properties;
                var tooltipItems = [];
                if (!active.length) {
                    if (this.opacity !== 0) properties = {
                        opacity: 0
                    };
                } else {
                    var position = positioners[options.position].call(this, active, this._eventPosition);
                    tooltipItems = this._createItems(options);
                    this.title = this.getTitle(tooltipItems, options);
                    this.beforeBody = this.getBeforeBody(tooltipItems, options);
                    this.body = this.getBody(tooltipItems, options);
                    this.afterBody = this.getAfterBody(tooltipItems, options);
                    this.footer = this.getFooter(tooltipItems, options);
                    var size = this._size = getTooltipSize(this, options);
                    var positionAndSize = Object.assign({}, position, size);
                    var alignment = determineAlignment(this.chart, options, positionAndSize);
                    var backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
                    this.xAlign = alignment.xAlign;
                    this.yAlign = alignment.yAlign;
                    properties = {
                        opacity: 1,
                        x: backgroundPoint.x,
                        y: backgroundPoint.y,
                        width: size.width,
                        height: size.height,
                        caretX: position.x,
                        caretY: position.y
                    };
                }
                this._tooltipItems = tooltipItems;
                this.$context = undefined;
                if (properties) this._resolveAnimations().update(this, properties);
                if (changed && options.external) options.external.call(this, {
                    chart: this.chart,
                    tooltip: this,
                    replay: replay
                });
            }
        },
        {
            key: "drawCaret",
            value: function drawCaret(tooltipPoint, ctx, size, options) {
                var caretPosition = this.getCaretPosition(tooltipPoint, size, options);
                ctx.lineTo(caretPosition.x1, caretPosition.y1);
                ctx.lineTo(caretPosition.x2, caretPosition.y2);
                ctx.lineTo(caretPosition.x3, caretPosition.y3);
            }
        },
        {
            key: "getCaretPosition",
            value: function getCaretPosition(tooltipPoint, size, options) {
                var _this = this, xAlign = _this.xAlign, yAlign = _this.yAlign;
                var caretSize = options.caretSize, cornerRadius = options.cornerRadius;
                var _toTRBLCorners = (0, $3zT2Z.ay)(cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
                var ptX = tooltipPoint.x, ptY = tooltipPoint.y;
                var width = size.width, height = size.height;
                var x1, x2, x3, y1, y2, y3;
                if (yAlign === 'center') {
                    y2 = ptY + height / 2;
                    if (xAlign === 'left') {
                        x1 = ptX;
                        x2 = x1 - caretSize;
                        y1 = y2 + caretSize;
                        y3 = y2 - caretSize;
                    } else {
                        x1 = ptX + width;
                        x2 = x1 + caretSize;
                        y1 = y2 - caretSize;
                        y3 = y2 + caretSize;
                    }
                    x3 = x1;
                } else {
                    if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
                    else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
                    else x2 = this.caretX;
                    if (yAlign === 'top') {
                        y1 = ptY;
                        y2 = y1 - caretSize;
                        x1 = x2 - caretSize;
                        x3 = x2 + caretSize;
                    } else {
                        y1 = ptY + height;
                        y2 = y1 + caretSize;
                        x1 = x2 + caretSize;
                        x3 = x2 - caretSize;
                    }
                    y3 = y1;
                }
                return {
                    x1: x1,
                    x2: x2,
                    x3: x3,
                    y1: y1,
                    y2: y2,
                    y3: y3
                };
            }
        },
        {
            key: "drawTitle",
            value: function drawTitle(pt, ctx, options) {
                var title = this.title;
                var length = title.length;
                var titleFont, titleSpacing, i;
                if (length) {
                    var rtlHelper = (0, $3zT2Z.aA)(options.rtl, this.x, this.width);
                    pt.x = getAlignedX(this, options.titleAlign, options);
                    ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
                    ctx.textBaseline = 'middle';
                    titleFont = (0, $3zT2Z.a0)(options.titleFont);
                    titleSpacing = options.titleSpacing;
                    ctx.fillStyle = options.titleColor;
                    ctx.font = titleFont.string;
                    for(i = 0; i < length; ++i){
                        ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                        pt.y += titleFont.lineHeight + titleSpacing;
                        if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
                    }
                }
            }
        },
        {
            key: "_drawColorBox",
            value: function _drawColorBox(ctx, pt, i, rtlHelper, options) {
                var labelColor = this.labelColors[i];
                var labelPointStyle = this.labelPointStyles[i];
                var boxHeight = options.boxHeight, boxWidth = options.boxWidth;
                var bodyFont = (0, $3zT2Z.a0)(options.bodyFont);
                var colorX = getAlignedX(this, 'left', options);
                var rtlColorX = rtlHelper.x(colorX);
                var yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
                var colorY = pt.y + yOffSet;
                if (options.usePointStyle) {
                    var drawOptions = {
                        radius: Math.min(boxWidth, boxHeight) / 2,
                        pointStyle: labelPointStyle.pointStyle,
                        rotation: labelPointStyle.rotation,
                        borderWidth: 1
                    };
                    var centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
                    var centerY = colorY + boxHeight / 2;
                    ctx.strokeStyle = options.multiKeyBackground;
                    ctx.fillStyle = options.multiKeyBackground;
                    (0, $3zT2Z.av)(ctx, drawOptions, centerX, centerY);
                    ctx.strokeStyle = labelColor.borderColor;
                    ctx.fillStyle = labelColor.backgroundColor;
                    (0, $3zT2Z.av)(ctx, drawOptions, centerX, centerY);
                } else {
                    var _Math;
                    ctx.lineWidth = (0, $3zT2Z.i)(labelColor.borderWidth) ? (_Math = Math).max.apply(_Math, (0, $kNmtb._)(Object.values(labelColor.borderWidth))) : labelColor.borderWidth || 1;
                    ctx.strokeStyle = labelColor.borderColor;
                    ctx.setLineDash(labelColor.borderDash || []);
                    ctx.lineDashOffset = labelColor.borderDashOffset || 0;
                    var outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
                    var innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
                    var borderRadius = (0, $3zT2Z.ay)(labelColor.borderRadius);
                    if (Object.values(borderRadius).some(function(v) {
                        return v !== 0;
                    })) {
                        ctx.beginPath();
                        ctx.fillStyle = options.multiKeyBackground;
                        (0, $3zT2Z.aw)(ctx, {
                            x: outerX,
                            y: colorY,
                            w: boxWidth,
                            h: boxHeight,
                            radius: borderRadius
                        });
                        ctx.fill();
                        ctx.stroke();
                        ctx.fillStyle = labelColor.backgroundColor;
                        ctx.beginPath();
                        (0, $3zT2Z.aw)(ctx, {
                            x: innerX,
                            y: colorY + 1,
                            w: boxWidth - 2,
                            h: boxHeight - 2,
                            radius: borderRadius
                        });
                        ctx.fill();
                    } else {
                        ctx.fillStyle = options.multiKeyBackground;
                        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                        ctx.fillStyle = labelColor.backgroundColor;
                        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
                    }
                }
                ctx.fillStyle = this.labelTextColors[i];
            }
        },
        {
            key: "drawBody",
            value: function drawBody(pt, ctx, options) {
                var body = this.body;
                var bodySpacing = options.bodySpacing, bodyAlign = options.bodyAlign, displayColors = options.displayColors, boxHeight = options.boxHeight, boxWidth = options.boxWidth, boxPadding = options.boxPadding;
                var bodyFont = (0, $3zT2Z.a0)(options.bodyFont);
                var bodyLineHeight = bodyFont.lineHeight;
                var xLinePadding = 0;
                var rtlHelper = (0, $3zT2Z.aA)(options.rtl, this.x, this.width);
                var fillLineOfText = function fillLineOfText(line) {
                    ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
                    pt.y += bodyLineHeight + bodySpacing;
                };
                var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
                var bodyItem, textColor, lines, i, j, ilen, jlen;
                ctx.textAlign = bodyAlign;
                ctx.textBaseline = 'middle';
                ctx.font = bodyFont.string;
                pt.x = getAlignedX(this, bodyAlignForCalculation, options);
                ctx.fillStyle = options.bodyColor;
                (0, $3zT2Z.F)(this.beforeBody, fillLineOfText);
                xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
                for(i = 0, ilen = body.length; i < ilen; ++i){
                    bodyItem = body[i];
                    textColor = this.labelTextColors[i];
                    ctx.fillStyle = textColor;
                    (0, $3zT2Z.F)(bodyItem.before, fillLineOfText);
                    lines = bodyItem.lines;
                    if (displayColors && lines.length) {
                        this._drawColorBox(ctx, pt, i, rtlHelper, options);
                        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
                    }
                    for(j = 0, jlen = lines.length; j < jlen; ++j){
                        fillLineOfText(lines[j]);
                        bodyLineHeight = bodyFont.lineHeight;
                    }
                    (0, $3zT2Z.F)(bodyItem.after, fillLineOfText);
                }
                xLinePadding = 0;
                bodyLineHeight = bodyFont.lineHeight;
                (0, $3zT2Z.F)(this.afterBody, fillLineOfText);
                pt.y -= bodySpacing;
            }
        },
        {
            key: "drawFooter",
            value: function drawFooter(pt, ctx, options) {
                var footer = this.footer;
                var length = footer.length;
                var footerFont, i;
                if (length) {
                    var rtlHelper = (0, $3zT2Z.aA)(options.rtl, this.x, this.width);
                    pt.x = getAlignedX(this, options.footerAlign, options);
                    pt.y += options.footerMarginTop;
                    ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
                    ctx.textBaseline = 'middle';
                    footerFont = (0, $3zT2Z.a0)(options.footerFont);
                    ctx.fillStyle = options.footerColor;
                    ctx.font = footerFont.string;
                    for(i = 0; i < length; ++i){
                        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                        pt.y += footerFont.lineHeight + options.footerSpacing;
                    }
                }
            }
        },
        {
            key: "drawBackground",
            value: function drawBackground(pt, ctx, tooltipSize, options) {
                var _this = this, xAlign = _this.xAlign, yAlign = _this.yAlign;
                var x = pt.x, y = pt.y;
                var width = tooltipSize.width, height = tooltipSize.height;
                var _toTRBLCorners = (0, $3zT2Z.ay)(options.cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
                ctx.fillStyle = options.backgroundColor;
                ctx.strokeStyle = options.borderColor;
                ctx.lineWidth = options.borderWidth;
                ctx.beginPath();
                ctx.moveTo(x + topLeft, y);
                if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
                ctx.lineTo(x + width - topRight, y);
                ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
                if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
                ctx.lineTo(x + width, y + height - bottomRight);
                ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
                if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
                ctx.lineTo(x + bottomLeft, y + height);
                ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
                if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
                ctx.lineTo(x, y + topLeft);
                ctx.quadraticCurveTo(x, y, x + topLeft, y);
                ctx.closePath();
                ctx.fill();
                if (options.borderWidth > 0) ctx.stroke();
            }
        },
        {
            key: "_updateAnimationTarget",
            value: function _updateAnimationTarget(options) {
                var chart = this.chart;
                var anims = this.$animations;
                var animX = anims && anims.x;
                var animY = anims && anims.y;
                if (animX || animY) {
                    var position = positioners[options.position].call(this, this._active, this._eventPosition);
                    if (!position) return;
                    var size = this._size = getTooltipSize(this, options);
                    var positionAndSize = Object.assign({}, position, this._size);
                    var alignment = determineAlignment(chart, options, positionAndSize);
                    var point = getBackgroundPoint(options, positionAndSize, alignment, chart);
                    if (animX._to !== point.x || animY._to !== point.y) {
                        this.xAlign = alignment.xAlign;
                        this.yAlign = alignment.yAlign;
                        this.width = size.width;
                        this.height = size.height;
                        this.caretX = position.x;
                        this.caretY = position.y;
                        this._resolveAnimations().update(this, point);
                    }
                }
            }
        },
        {
            key: "_willRender",
            value: function _willRender() {
                return !!this.opacity;
            }
        },
        {
            key: "draw",
            value: function draw(ctx) {
                var options = this.options.setContext(this.getContext());
                var opacity = this.opacity;
                if (!opacity) return;
                this._updateAnimationTarget(options);
                var tooltipSize = {
                    width: this.width,
                    height: this.height
                };
                var pt = {
                    x: this.x,
                    y: this.y
                };
                opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
                var padding = (0, $3zT2Z.E)(options.padding);
                var hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
                if (options.enabled && hasTooltipContent) {
                    ctx.save();
                    ctx.globalAlpha = opacity;
                    this.drawBackground(pt, ctx, tooltipSize, options);
                    (0, $3zT2Z.aB)(ctx, options.textDirection);
                    pt.y += padding.top;
                    this.drawTitle(pt, ctx, options);
                    this.drawBody(pt, ctx, options);
                    this.drawFooter(pt, ctx, options);
                    (0, $3zT2Z.aD)(ctx, options.textDirection);
                    ctx.restore();
                }
            }
        },
        {
            key: "getActiveElements",
            value: function getActiveElements() {
                return this._active || [];
            }
        },
        {
            key: "setActiveElements",
            value: function setActiveElements(activeElements, eventPosition) {
                var _this = this;
                var lastActive = this._active;
                var active = activeElements.map(function(param) {
                    var datasetIndex = param.datasetIndex, index = param.index;
                    var meta = _this.chart.getDatasetMeta(datasetIndex);
                    if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
                    return {
                        datasetIndex: datasetIndex,
                        element: meta.data[index],
                        index: index
                    };
                });
                var changed = !(0, $3zT2Z.ai)(lastActive, active);
                var positionChanged = this._positionChanged(active, eventPosition);
                if (changed || positionChanged) {
                    this._active = active;
                    this._eventPosition = eventPosition;
                    this._ignoreReplayEvents = true;
                    this.update(true);
                }
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(e, replay) {
                var inChartArea = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                if (replay && this._ignoreReplayEvents) return false;
                this._ignoreReplayEvents = false;
                var options = this.options;
                var lastActive = this._active || [];
                var active = this._getActiveElements(e, lastActive, replay, inChartArea);
                var positionChanged = this._positionChanged(active, e);
                var changed = replay || !(0, $3zT2Z.ai)(active, lastActive) || positionChanged;
                if (changed) {
                    this._active = active;
                    if (options.enabled || options.external) {
                        this._eventPosition = {
                            x: e.x,
                            y: e.y
                        };
                        this.update(true, replay);
                    }
                }
                return changed;
            }
        },
        {
            key: "_getActiveElements",
            value: function _getActiveElements(e, lastActive, replay, inChartArea) {
                var _this = this;
                var options = this.options;
                if (e.type === 'mouseout') return [];
                if (!inChartArea) return lastActive.filter(function(i) {
                    return _this.chart.data.datasets[i.datasetIndex] && _this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined;
                });
                var active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
                if (options.reverse) active.reverse();
                return active;
            }
        },
        {
            key: "_positionChanged",
            value: function _positionChanged(active, e) {
                var _this = this, caretX = _this.caretX, caretY = _this.caretY, options = _this.options;
                var position = positioners[options.position].call(this, active, e);
                return position !== false && (caretX !== position.x || caretY !== position.y);
            }
        }
    ]);
    return Tooltip;
}((0, $6brDd._)(Element));
(0, $6lD0P._)(Tooltip, "positioners", positioners);
var plugin_tooltip = {
    id: 'tooltip',
    _element: Tooltip,
    positioners: positioners,
    afterInit: function(chart, _args, options) {
        if (options) chart.tooltip = new Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate: function(chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset: function(chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw: function(chart) {
        var tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            var args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', (0, $3K9Jy._)((0, $8lZHN._)({}, args), {
                cancelable: true
            })) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent: function(chart, args) {
        if (chart.tooltip) {
            var useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: function(ctx, opts) {
            return opts.bodyFont.size;
        },
        boxWidth: function(ctx, opts) {
            return opts.bodyFont.size;
        },
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: function(name) {
            return name !== 'filter' && name !== 'itemSort' && name !== 'external';
        },
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var plugins = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: plugin_colors,
    Decimation: plugin_decimation,
    Filler: index,
    Legend: plugin_legend,
    SubTitle: plugin_subtitle,
    Title: plugin_title,
    Tooltip: plugin_tooltip
});
var addIfString = function(labels, raw, index, addedLabels) {
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    var first = labels.indexOf(raw);
    if (first === -1) return addIfString(labels, raw, index, addedLabels);
    var last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
var validIndex = function(index, max) {
    return index === null ? null : (0, $3zT2Z.S)(Math.round(index), 0, max);
};
function _getLabelForValue(value) {
    var labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
var CategoryScale = /*#__PURE__*/ function(Scale) {
    "use strict";
    (0, $dqNF0._)(CategoryScale, Scale);
    function CategoryScale(cfg) {
        (0, $ioD88._)(this, CategoryScale);
        var _this;
        _this = (0, $ctUVE._)(this, CategoryScale, [
            cfg
        ]);
        _this._startValue = undefined;
        _this._valueRange = 0;
        _this._addedLabels = [];
        return _this;
    }
    (0, $6NCFa._)(CategoryScale, [
        {
            key: "init",
            value: function init(scaleOptions) {
                var added = this._addedLabels;
                if (added.length) {
                    var labels = this.getLabels();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = added[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _step.value, index = _step_value.index, label = _step_value.label;
                            if (labels[index] === label) labels.splice(index, 1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._addedLabels = [];
                }
                (0, $9rJIv._)((0, $2HbS2._)(CategoryScale.prototype), "init", this).call(this, scaleOptions);
            }
        },
        {
            key: "parse",
            value: function parse(raw, index) {
                if ((0, $3zT2Z.k)(raw)) return null;
                var labels = this.getLabels();
                index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, (0, $3zT2Z.v)(index, raw), this._addedLabels);
                return validIndex(index, labels.length - 1);
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
                if (this.options.bounds === 'ticks') {
                    if (!minDefined) min = 0;
                    if (!maxDefined) max = this.getLabels().length - 1;
                }
                this.min = min;
                this.max = max;
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                var min = this.min;
                var max = this.max;
                var offset = this.options.offset;
                var ticks = [];
                var labels = this.getLabels();
                labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
                this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
                this._startValue = this.min - (offset ? 0.5 : 0);
                for(var value = min; value <= max; value++)ticks.push({
                    value: value
                });
                return ticks;
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                return _getLabelForValue.call(this, value);
            }
        },
        {
            key: "configure",
            value: function configure() {
                (0, $9rJIv._)((0, $2HbS2._)(CategoryScale.prototype), "configure", this).call(this);
                if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value) {
                if (typeof value !== 'number') value = this.parse(value);
                return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
            }
        },
        {
            key: "getPixelForTick",
            value: function getPixelForTick(index) {
                var ticks = this.ticks;
                if (index < 0 || index > ticks.length - 1) return null;
                return this.getPixelForValue(ticks[index].value);
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
            }
        },
        {
            key: "getBasePixel",
            value: function getBasePixel() {
                return this.bottom;
            }
        }
    ]);
    return CategoryScale;
}(Scale);
(0, $6lD0P._)(CategoryScale, "id", 'category');
(0, $6lD0P._)(CategoryScale, "defaults", {
    ticks: {
        callback: _getLabelForValue
    }
});
function generateTicks$1(generationOptions, dataRange) {
    var ticks = [];
    var MIN_SPACING = 1e-14;
    var bounds = generationOptions.bounds, step = generationOptions.step, min = generationOptions.min, max = generationOptions.max, precision = generationOptions.precision, count = generationOptions.count, maxTicks = generationOptions.maxTicks, maxDigits = generationOptions.maxDigits, includeBounds = generationOptions.includeBounds;
    var unit = step || 1;
    var maxSpaces = maxTicks - 1;
    var rmin = dataRange.min, rmax = dataRange.max;
    var minDefined = !(0, $3zT2Z.k)(min);
    var maxDefined = !(0, $3zT2Z.k)(max);
    var countDefined = !(0, $3zT2Z.k)(count);
    var minSpacing = (rmax - rmin) / (maxDigits + 1);
    var spacing = (0, $3zT2Z.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    var factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $3zT2Z.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $3zT2Z.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $3zT2Z.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $3zT2Z.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    var decimalPlaces = Math.max((0, $3zT2Z.aL)(spacing), (0, $3zT2Z.aL)(niceMin));
    factor = Math.pow(10, (0, $3zT2Z.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    var j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $3zT2Z.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        var tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $3zT2Z.aK)(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function relativeLabelSize(value, minSpacing, param) {
    var horizontal = param.horizontal, minRotation = param.minRotation;
    var rad = (0, $3zT2Z.t)(minRotation);
    var ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    var length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
var LinearScaleBase = /*#__PURE__*/ function(Scale) {
    "use strict";
    (0, $dqNF0._)(LinearScaleBase, Scale);
    function LinearScaleBase(cfg) {
        (0, $ioD88._)(this, LinearScaleBase);
        var _this;
        _this = (0, $ctUVE._)(this, LinearScaleBase, [
            cfg
        ]);
        _this.start = undefined;
        _this.end = undefined;
        _this._startValue = undefined;
        _this._endValue = undefined;
        _this._valueRange = 0;
        return _this;
    }
    (0, $6NCFa._)(LinearScaleBase, [
        {
            key: "parse",
            value: function parse(raw, index) {
                if ((0, $3zT2Z.k)(raw)) return null;
                if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
                return +raw;
            }
        },
        {
            key: "handleTickRangeOptions",
            value: function handleTickRangeOptions() {
                var beginAtZero = this.options.beginAtZero;
                var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                var _this = this, min = _this.min, max = _this.max;
                var setMin = function(v) {
                    return min = minDefined ? min : v;
                };
                var setMax = function(v) {
                    return max = maxDefined ? max : v;
                };
                if (beginAtZero) {
                    var minSign = (0, $3zT2Z.s)(min);
                    var maxSign = (0, $3zT2Z.s)(max);
                    if (minSign < 0 && maxSign < 0) setMax(0);
                    else if (minSign > 0 && maxSign > 0) setMin(0);
                }
                if (min === max) {
                    var offset = max === 0 ? 1 : Math.abs(max * 0.05);
                    setMax(max + offset);
                    if (!beginAtZero) setMin(min - offset);
                }
                this.min = min;
                this.max = max;
            }
        },
        {
            key: "getTickLimit",
            value: function getTickLimit() {
                var tickOpts = this.options.ticks;
                var maxTicksLimit = tickOpts.maxTicksLimit, stepSize = tickOpts.stepSize;
                var maxTicks;
                if (stepSize) {
                    maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
                    if (maxTicks > 1000) {
                        console.warn("scales.".concat(this.id, ".ticks.stepSize: ").concat(stepSize, " would result generating up to ").concat(maxTicks, " ticks. Limiting to 1000."));
                        maxTicks = 1000;
                    }
                } else {
                    maxTicks = this.computeTickLimit();
                    maxTicksLimit = maxTicksLimit || 11;
                }
                if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
                return maxTicks;
            }
        },
        {
            key: "computeTickLimit",
            value: function computeTickLimit() {
                return Number.POSITIVE_INFINITY;
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                var opts = this.options;
                var tickOpts = opts.ticks;
                var maxTicks = this.getTickLimit();
                maxTicks = Math.max(2, maxTicks);
                var numericGeneratorOptions = {
                    maxTicks: maxTicks,
                    bounds: opts.bounds,
                    min: opts.min,
                    max: opts.max,
                    precision: tickOpts.precision,
                    step: tickOpts.stepSize,
                    count: tickOpts.count,
                    maxDigits: this._maxDigits(),
                    horizontal: this.isHorizontal(),
                    minRotation: tickOpts.minRotation || 0,
                    includeBounds: tickOpts.includeBounds !== false
                };
                var dataRange = this._range || this;
                var ticks = generateTicks$1(numericGeneratorOptions, dataRange);
                if (opts.bounds === 'ticks') (0, $3zT2Z.aH)(ticks, this, 'value');
                if (opts.reverse) {
                    ticks.reverse();
                    this.start = this.max;
                    this.end = this.min;
                } else {
                    this.start = this.min;
                    this.end = this.max;
                }
                return ticks;
            }
        },
        {
            key: "configure",
            value: function configure() {
                var ticks = this.ticks;
                var start = this.min;
                var end = this.max;
                (0, $9rJIv._)((0, $2HbS2._)(LinearScaleBase.prototype), "configure", this).call(this);
                if (this.options.offset && ticks.length) {
                    var offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                    start -= offset;
                    end += offset;
                }
                this._startValue = start;
                this._endValue = end;
                this._valueRange = end - start;
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                return (0, $3zT2Z.o)(value, this.chart.options.locale, this.options.ticks.format);
            }
        }
    ]);
    return LinearScaleBase;
}(Scale);
var LinearScale = /*#__PURE__*/ function(LinearScaleBase) {
    "use strict";
    (0, $dqNF0._)(LinearScale, LinearScaleBase);
    function LinearScale() {
        (0, $ioD88._)(this, LinearScale);
        return (0, $ctUVE._)(this, LinearScale, arguments);
    }
    (0, $6NCFa._)(LinearScale, [
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
                this.min = (0, $3zT2Z.g)(min) ? min : 0;
                this.max = (0, $3zT2Z.g)(max) ? max : 1;
                this.handleTickRangeOptions();
            }
        },
        {
            key: "computeTickLimit",
            value: function computeTickLimit() {
                var horizontal = this.isHorizontal();
                var length = horizontal ? this.width : this.height;
                var minRotation = (0, $3zT2Z.t)(this.options.ticks.minRotation);
                var ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
                var tickFont = this._resolveTickFontOptions(0);
                return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value) {
                return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
            }
        }
    ]);
    return LinearScale;
}(LinearScaleBase);
(0, $6lD0P._)(LinearScale, "id", 'linear');
(0, $6lD0P._)(LinearScale, "defaults", {
    ticks: {
        callback: (0, $3zT2Z.aM).formatters.numeric
    }
});
var log10Floor = function(v) {
    return Math.floor((0, $3zT2Z.aN)(v));
};
var changeExponent = function(v, m) {
    return Math.pow(10, log10Floor(v) + m);
};
function isMajor(tickVal) {
    var remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    var rangeStep = Math.pow(10, rangeExp);
    var start = Math.floor(min / rangeStep);
    var end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    var range = max - min;
    var rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10)rangeExp++;
    while(steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, param) {
    var min = param.min, max = param.max;
    min = (0, $3zT2Z.O)(generationOptions.min, min);
    var ticks = [];
    var minExp = log10Floor(min);
    var exp = startExp(min, max);
    var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    var stepSize = Math.pow(10, exp);
    var base = minExp > exp ? Math.pow(10, minExp) : 0;
    var start = Math.round((min - base) * precision) / precision;
    var offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    var significand = Math.floor((start - offset) / Math.pow(10, exp));
    var value = (0, $3zT2Z.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    var lastTick = (0, $3zT2Z.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
var LogarithmicScale = /*#__PURE__*/ function(Scale) {
    "use strict";
    (0, $dqNF0._)(LogarithmicScale, Scale);
    function LogarithmicScale(cfg) {
        (0, $ioD88._)(this, LogarithmicScale);
        var _this;
        _this = (0, $ctUVE._)(this, LogarithmicScale, [
            cfg
        ]);
        _this.start = undefined;
        _this.end = undefined;
        _this._startValue = undefined;
        _this._valueRange = 0;
        return _this;
    }
    (0, $6NCFa._)(LogarithmicScale, [
        {
            key: "parse",
            value: function parse(raw, index) {
                var value = LinearScaleBase.prototype.parse.apply(this, [
                    raw,
                    index
                ]);
                if (value === 0) {
                    this._zero = true;
                    return undefined;
                }
                return (0, $3zT2Z.g)(value) && value > 0 ? value : null;
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
                this.min = (0, $3zT2Z.g)(min) ? Math.max(0, min) : null;
                this.max = (0, $3zT2Z.g)(max) ? Math.max(0, max) : null;
                if (this.options.beginAtZero) this._zero = true;
                if (this._zero && this.min !== this._suggestedMin && !(0, $3zT2Z.g)(this._userMin)) this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
                this.handleTickRangeOptions();
            }
        },
        {
            key: "handleTickRangeOptions",
            value: function handleTickRangeOptions() {
                var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                var min = this.min;
                var max = this.max;
                var setMin = function(v) {
                    return min = minDefined ? min : v;
                };
                var setMax = function(v) {
                    return max = maxDefined ? max : v;
                };
                if (min === max) {
                    if (min <= 0) {
                        setMin(1);
                        setMax(10);
                    } else {
                        setMin(changeExponent(min, -1));
                        setMax(changeExponent(max, 1));
                    }
                }
                if (min <= 0) setMin(changeExponent(max, -1));
                if (max <= 0) setMax(changeExponent(min, 1));
                this.min = min;
                this.max = max;
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                var opts = this.options;
                var generationOptions = {
                    min: this._userMin,
                    max: this._userMax
                };
                var ticks = generateTicks(generationOptions, this);
                if (opts.bounds === 'ticks') (0, $3zT2Z.aH)(ticks, this, 'value');
                if (opts.reverse) {
                    ticks.reverse();
                    this.start = this.max;
                    this.end = this.min;
                } else {
                    this.start = this.min;
                    this.end = this.max;
                }
                return ticks;
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                return value === undefined ? '0' : (0, $3zT2Z.o)(value, this.chart.options.locale, this.options.ticks.format);
            }
        },
        {
            key: "configure",
            value: function configure() {
                var start = this.min;
                (0, $9rJIv._)((0, $2HbS2._)(LogarithmicScale.prototype), "configure", this).call(this);
                this._startValue = (0, $3zT2Z.aN)(start);
                this._valueRange = (0, $3zT2Z.aN)(this.max) - (0, $3zT2Z.aN)(start);
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value) {
                if (value === undefined || value === 0) value = this.min;
                if (value === null || isNaN(value)) return NaN;
                return this.getPixelForDecimal(value === this.min ? 0 : ((0, $3zT2Z.aN)(value) - this._startValue) / this._valueRange);
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                var decimal = this.getDecimalForPixel(pixel);
                return Math.pow(10, this._startValue + decimal * this._valueRange);
            }
        }
    ]);
    return LogarithmicScale;
}(Scale);
(0, $6lD0P._)(LogarithmicScale, "id", 'logarithmic');
(0, $6lD0P._)(LogarithmicScale, "defaults", {
    ticks: {
        callback: (0, $3zT2Z.aM).formatters.logarithmic,
        major: {
            enabled: true
        }
    }
});
function getTickBackdropHeight(opts) {
    var tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        var padding = (0, $3zT2Z.E)(tickOpts.backdropPadding);
        return (0, $3zT2Z.v)(tickOpts.font && tickOpts.font.size, (0, $3zT2Z.d).font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = (0, $3zT2Z.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $3zT2Z.aO)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function fitWithPointLabels(scale) {
    var orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    var limits = Object.assign({}, orig);
    var labelSizes = [];
    var padding = [];
    var valueCount = scale._pointLabels.length;
    var pointLabelOpts = scale.options.pointLabels;
    var additionalAngle = pointLabelOpts.centerPointLabels ? (0, $3zT2Z.P) / valueCount : 0;
    for(var i = 0; i < valueCount; i++){
        var opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        var pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        var plFont = (0, $3zT2Z.a0)(opts.font);
        var textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        var angleRadians = (0, $3zT2Z.al)(scale.getIndexAngle(i) + additionalAngle);
        var angle = Math.round((0, $3zT2Z.U)(angleRadians));
        var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    var sin = Math.abs(Math.sin(angle));
    var cos = Math.abs(Math.cos(angle));
    var x = 0;
    var y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    var outerDistance = scale.drawingArea;
    var extra = itemOpts.extra, additionalAngle = itemOpts.additionalAngle, padding = itemOpts.padding, size = itemOpts.size;
    var pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    var angle = Math.round((0, $3zT2Z.U)((0, $3zT2Z.al)(pointLabelPosition.angle + (0, $3zT2Z.H))));
    var y = yForAngle(pointLabelPosition.y, size.h, angle);
    var textAlign = getTextAlignForAngle(angle);
    var left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) return true;
    var left = item.left, top = item.top, right = item.right, bottom = item.bottom;
    var apexesInArea = (0, $3zT2Z.C)({
        x: left,
        y: top
    }, area) || (0, $3zT2Z.C)({
        x: left,
        y: bottom
    }, area) || (0, $3zT2Z.C)({
        x: right,
        y: top
    }, area) || (0, $3zT2Z.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    var items = [];
    var valueCount = scale._pointLabels.length;
    var opts = scale.options;
    var _opts_pointLabels = opts.pointLabels, centerPointLabels = _opts_pointLabels.centerPointLabels, display = _opts_pointLabels.display;
    var itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $3zT2Z.P) / valueCount : 0
    };
    var area;
    for(var i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        var item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    var left = item.left, top = item.top, right = item.right, bottom = item.bottom;
    var backdropColor = opts.backdropColor;
    if (!(0, $3zT2Z.k)(backdropColor)) {
        var borderRadius = (0, $3zT2Z.ay)(opts.borderRadius);
        var padding = (0, $3zT2Z.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        var backdropLeft = left - padding.left;
        var backdropTop = top - padding.top;
        var backdropWidth = right - left + padding.width;
        var backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some(function(v) {
            return v !== 0;
        })) {
            ctx.beginPath();
            (0, $3zT2Z.aw)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function drawPointLabels(scale, labelCount) {
    var ctx = scale.ctx, pointLabels = scale.options.pointLabels;
    for(var i = labelCount - 1; i >= 0; i--){
        var item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        var optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        var plFont = (0, $3zT2Z.a0)(optsAtIndex.font);
        var x = item.x, y = item.y, textAlign = item.textAlign;
        (0, $3zT2Z.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    var ctx = scale.ctx;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $3zT2Z.T));
    else {
        var pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(var i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    var ctx = scale.ctx;
    var circular = gridLineOpts.circular;
    var color = gridLineOpts.color, lineWidth = gridLineOpts.lineWidth;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return (0, $3zT2Z.j)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
var RadialLinearScale = /*#__PURE__*/ function(LinearScaleBase1) {
    "use strict";
    (0, $dqNF0._)(RadialLinearScale, LinearScaleBase1);
    function RadialLinearScale(cfg) {
        (0, $ioD88._)(this, RadialLinearScale);
        var _this;
        _this = (0, $ctUVE._)(this, RadialLinearScale, [
            cfg
        ]);
        _this.xCenter = undefined;
        _this.yCenter = undefined;
        _this.drawingArea = undefined;
        _this._pointLabels = [];
        _this._pointLabelItems = [];
        return _this;
    }
    (0, $6NCFa._)(RadialLinearScale, [
        {
            key: "setDimensions",
            value: function setDimensions() {
                var padding = this._padding = (0, $3zT2Z.E)(getTickBackdropHeight(this.options) / 2);
                var w = this.width = this.maxWidth - padding.width;
                var h = this.height = this.maxHeight - padding.height;
                this.xCenter = Math.floor(this.left + w / 2 + padding.left);
                this.yCenter = Math.floor(this.top + h / 2 + padding.top);
                this.drawingArea = Math.floor(Math.min(w, h) / 2);
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var _this_getMinMax = this.getMinMax(false), min = _this_getMinMax.min, max = _this_getMinMax.max;
                this.min = (0, $3zT2Z.g)(min) && !isNaN(min) ? min : 0;
                this.max = (0, $3zT2Z.g)(max) && !isNaN(max) ? max : 0;
                this.handleTickRangeOptions();
            }
        },
        {
            key: "computeTickLimit",
            value: function computeTickLimit() {
                return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
            }
        },
        {
            key: "generateTickLabels",
            value: function generateTickLabels(ticks) {
                var _this = this;
                LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
                this._pointLabels = this.getLabels().map(function(value, index) {
                    var label = (0, $3zT2Z.Q)(_this.options.pointLabels.callback, [
                        value,
                        index
                    ], _this);
                    return label || label === 0 ? label : '';
                }).filter(function(v, i) {
                    return _this.chart.getDataVisibility(i);
                });
            }
        },
        {
            key: "fit",
            value: function fit() {
                var opts = this.options;
                if (opts.display && opts.pointLabels.display) fitWithPointLabels(this);
                else this.setCenterPoint(0, 0, 0, 0);
            }
        },
        {
            key: "setCenterPoint",
            value: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
                this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
                this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
                this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
            }
        },
        {
            key: "getIndexAngle",
            value: function getIndexAngle(index) {
                var angleMultiplier = (0, $3zT2Z.T) / (this._pointLabels.length || 1);
                var startAngle = this.options.startAngle || 0;
                return (0, $3zT2Z.al)(index * angleMultiplier + (0, $3zT2Z.t)(startAngle));
            }
        },
        {
            key: "getDistanceFromCenterForValue",
            value: function getDistanceFromCenterForValue(value) {
                if ((0, $3zT2Z.k)(value)) return NaN;
                var scalingFactor = this.drawingArea / (this.max - this.min);
                if (this.options.reverse) return (this.max - value) * scalingFactor;
                return (value - this.min) * scalingFactor;
            }
        },
        {
            key: "getValueForDistanceFromCenter",
            value: function getValueForDistanceFromCenter(distance) {
                if ((0, $3zT2Z.k)(distance)) return NaN;
                var scaledDistance = distance / (this.drawingArea / (this.max - this.min));
                return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
            }
        },
        {
            key: "getPointLabelContext",
            value: function getPointLabelContext(index) {
                var pointLabels = this._pointLabels || [];
                if (index >= 0 && index < pointLabels.length) {
                    var pointLabel = pointLabels[index];
                    return createPointLabelContext(this.getContext(), index, pointLabel);
                }
            }
        },
        {
            key: "getPointPosition",
            value: function getPointPosition(index, distanceFromCenter) {
                var additionalAngle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var angle = this.getIndexAngle(index) - (0, $3zT2Z.H) + additionalAngle;
                return {
                    x: Math.cos(angle) * distanceFromCenter + this.xCenter,
                    y: Math.sin(angle) * distanceFromCenter + this.yCenter,
                    angle: angle
                };
            }
        },
        {
            key: "getPointPositionForValue",
            value: function getPointPositionForValue(index, value) {
                return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
            }
        },
        {
            key: "getBasePosition",
            value: function getBasePosition(index) {
                return this.getPointPositionForValue(index || 0, this.getBaseValue());
            }
        },
        {
            key: "getPointLabelPosition",
            value: function getPointLabelPosition(index) {
                var _this__pointLabelItems_index = this._pointLabelItems[index], left = _this__pointLabelItems_index.left, top = _this__pointLabelItems_index.top, right = _this__pointLabelItems_index.right, bottom = _this__pointLabelItems_index.bottom;
                return {
                    left: left,
                    top: top,
                    right: right,
                    bottom: bottom
                };
            }
        },
        {
            key: "drawBackground",
            value: function drawBackground() {
                var _this_options = this.options, backgroundColor = _this_options.backgroundColor, circular = _this_options.grid.circular;
                if (backgroundColor) {
                    var ctx = this.ctx;
                    ctx.save();
                    ctx.beginPath();
                    pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
                    ctx.closePath();
                    ctx.fillStyle = backgroundColor;
                    ctx.fill();
                    ctx.restore();
                }
            }
        },
        {
            key: "drawGrid",
            value: function drawGrid() {
                var _this = this;
                var ctx = this.ctx;
                var opts = this.options;
                var angleLines = opts.angleLines, grid = opts.grid, border = opts.border;
                var labelCount = this._pointLabels.length;
                var i, offset, position;
                if (opts.pointLabels.display) drawPointLabels(this, labelCount);
                if (grid.display) this.ticks.forEach(function(tick, index) {
                    if (index !== 0 || index === 0 && _this.min < 0) {
                        offset = _this.getDistanceFromCenterForValue(tick.value);
                        var context = _this.getContext(index);
                        var optsAtIndex = grid.setContext(context);
                        var optsAtIndexBorder = border.setContext(context);
                        drawRadiusLine(_this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
                    }
                });
                if (angleLines.display) {
                    ctx.save();
                    for(i = labelCount - 1; i >= 0; i--){
                        var optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                        var color = optsAtIndex.color, lineWidth = optsAtIndex.lineWidth;
                        if (!lineWidth || !color) continue;
                        ctx.lineWidth = lineWidth;
                        ctx.strokeStyle = color;
                        ctx.setLineDash(optsAtIndex.borderDash);
                        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                        offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                        position = this.getPointPosition(i, offset);
                        ctx.beginPath();
                        ctx.moveTo(this.xCenter, this.yCenter);
                        ctx.lineTo(position.x, position.y);
                        ctx.stroke();
                    }
                    ctx.restore();
                }
            }
        },
        {
            key: "drawBorder",
            value: function drawBorder() {}
        },
        {
            key: "drawLabels",
            value: function drawLabels() {
                var _this = this;
                var ctx = this.ctx;
                var opts = this.options;
                var tickOpts = opts.ticks;
                if (!tickOpts.display) return;
                var startAngle = this.getIndexAngle(0);
                var offset, width;
                ctx.save();
                ctx.translate(this.xCenter, this.yCenter);
                ctx.rotate(startAngle);
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                this.ticks.forEach(function(tick, index) {
                    if (index === 0 && _this.min >= 0 && !opts.reverse) return;
                    var optsAtIndex = tickOpts.setContext(_this.getContext(index));
                    var tickFont = (0, $3zT2Z.a0)(optsAtIndex.font);
                    offset = _this.getDistanceFromCenterForValue(_this.ticks[index].value);
                    if (optsAtIndex.showLabelBackdrop) {
                        ctx.font = tickFont.string;
                        width = ctx.measureText(tick.label).width;
                        ctx.fillStyle = optsAtIndex.backdropColor;
                        var padding = (0, $3zT2Z.E)(optsAtIndex.backdropPadding);
                        ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
                    }
                    (0, $3zT2Z.Z)(ctx, tick.label, 0, -offset, tickFont, {
                        color: optsAtIndex.color,
                        strokeColor: optsAtIndex.textStrokeColor,
                        strokeWidth: optsAtIndex.textStrokeWidth
                    });
                });
                ctx.restore();
            }
        },
        {
            key: "drawTitle",
            value: function drawTitle() {}
        }
    ]);
    return RadialLinearScale;
}(LinearScaleBase);
(0, $6lD0P._)(RadialLinearScale, "id", 'radialLinear');
(0, $6lD0P._)(RadialLinearScale, "defaults", {
    display: true,
    animate: true,
    position: 'chartArea',
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: (0, $3zT2Z.aM).formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback: function(label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
});
(0, $6lD0P._)(RadialLinearScale, "defaultRoutes", {
    'angleLines.color': 'borderColor',
    'pointLabels.color': 'color',
    'ticks.color': 'color'
});
(0, $6lD0P._)(RadialLinearScale, "descriptors", {
    angleLines: {
        _fallback: 'grid'
    }
});
var INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
var UNITS = /* #__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
    return a - b;
}
function parse(scale, input) {
    if ((0, $3zT2Z.k)(input)) return null;
    var adapter = scale._adapter;
    var _scale__parseOpts = scale._parseOpts, parser = _scale__parseOpts.parser, round = _scale__parseOpts.round, isoWeekday = _scale__parseOpts.isoWeekday;
    var value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $3zT2Z.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $3zT2Z.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    var ilen = UNITS.length;
    for(var i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        var interval = INTERVALS[UNITS[i]];
        var factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
    }
    return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(var i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        var unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
    for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) return UNITS[i];
    }
}
function addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        var _$_lookup = (0, $3zT2Z.aQ)(timestamps, time), lo = _$_lookup.lo, hi = _$_lookup.hi;
        var timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
    var adapter = scale._adapter;
    var first = +adapter.startOf(ticks[0].value, majorUnit);
    var last = ticks[ticks.length - 1].value;
    var major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
    var ticks = [];
    var map = {};
    var ilen = values.length;
    var i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
var TimeScale = /*#__PURE__*/ function(Scale) {
    "use strict";
    (0, $dqNF0._)(TimeScale, Scale);
    function TimeScale(props) {
        (0, $ioD88._)(this, TimeScale);
        var _this;
        _this = (0, $ctUVE._)(this, TimeScale, [
            props
        ]);
        _this._cache = {
            data: [],
            labels: [],
            all: []
        };
        _this._unit = 'day';
        _this._majorUnit = undefined;
        _this._offsets = {};
        _this._normalized = false;
        _this._parseOpts = undefined;
        return _this;
    }
    (0, $6NCFa._)(TimeScale, [
        {
            key: "init",
            value: function init(scaleOpts) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var time = scaleOpts.time || (scaleOpts.time = {});
                var adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
                adapter.init(opts);
                (0, $3zT2Z.ab)(time.displayFormats, adapter.formats());
                this._parseOpts = {
                    parser: time.parser,
                    round: time.round,
                    isoWeekday: time.isoWeekday
                };
                (0, $9rJIv._)((0, $2HbS2._)(TimeScale.prototype), "init", this).call(this, scaleOpts);
                this._normalized = opts.normalized;
            }
        },
        {
            key: "parse",
            value: function parse1(raw, index) {
                if (raw === undefined) return null;
                return parse(this, raw);
            }
        },
        {
            key: "beforeLayout",
            value: function beforeLayout() {
                (0, $9rJIv._)((0, $2HbS2._)(TimeScale.prototype), "beforeLayout", this).call(this);
                this._cache = {
                    data: [],
                    labels: [],
                    all: []
                };
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var options = this.options;
                var adapter = this._adapter;
                var unit = options.time.unit || 'day';
                var _this_getUserBounds = this.getUserBounds(), min = _this_getUserBounds.min, max = _this_getUserBounds.max, minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                function _applyBounds(bounds) {
                    if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
                    if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
                }
                if (!minDefined || !maxDefined) {
                    _applyBounds(this._getLabelBounds());
                    if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
                }
                min = (0, $3zT2Z.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
                max = (0, $3zT2Z.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
                this.min = Math.min(min, max - 1);
                this.max = Math.max(min + 1, max);
            }
        },
        {
            key: "_getLabelBounds",
            value: function _getLabelBounds() {
                var arr = this.getLabelTimestamps();
                var min = Number.POSITIVE_INFINITY;
                var max = Number.NEGATIVE_INFINITY;
                if (arr.length) {
                    min = arr[0];
                    max = arr[arr.length - 1];
                }
                return {
                    min: min,
                    max: max
                };
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                var options = this.options;
                var timeOpts = options.time;
                var tickOpts = options.ticks;
                var timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
                if (options.bounds === 'ticks' && timestamps.length) {
                    this.min = this._userMin || timestamps[0];
                    this.max = this._userMax || timestamps[timestamps.length - 1];
                }
                var min = this.min;
                var max = this.max;
                var ticks = (0, $3zT2Z.aP)(timestamps, min, max);
                this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
                this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
                this.initOffsets(timestamps);
                if (options.reverse) ticks.reverse();
                return ticksFromTimestamps(this, ticks, this._majorUnit);
            }
        },
        {
            key: "afterAutoSkip",
            value: function afterAutoSkip() {
                if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map(function(tick) {
                    return +tick.value;
                }));
            }
        },
        {
            key: "initOffsets",
            value: function initOffsets() {
                var timestamps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                var start = 0;
                var end = 0;
                var first, last;
                if (this.options.offset && timestamps.length) {
                    first = this.getDecimalForValue(timestamps[0]);
                    if (timestamps.length === 1) start = 1 - first;
                    else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
                    last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
                    if (timestamps.length === 1) end = last;
                    else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
                }
                var limit = timestamps.length < 3 ? 0.5 : 0.25;
                start = (0, $3zT2Z.S)(start, 0, limit);
                end = (0, $3zT2Z.S)(end, 0, limit);
                this._offsets = {
                    start: start,
                    end: end,
                    factor: 1 / (start + 1 + end)
                };
            }
        },
        {
            key: "_generate",
            value: function _generate() {
                var adapter = this._adapter;
                var min = this.min;
                var max = this.max;
                var options = this.options;
                var timeOpts = options.time;
                var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
                var stepSize = (0, $3zT2Z.v)(options.ticks.stepSize, 1);
                var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
                var hasWeekday = (0, $3zT2Z.x)(weekday) || weekday === true;
                var ticks = {};
                var first = min;
                var time, count;
                if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
                first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
                if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
                var timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
                for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)addTick(ticks, time, timestamps);
                if (time === max || options.bounds === 'ticks' || count === 1) addTick(ticks, time, timestamps);
                return Object.keys(ticks).sort(sorter).map(function(x) {
                    return +x;
                });
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                var adapter = this._adapter;
                var timeOpts = this.options.time;
                if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
                return adapter.format(value, timeOpts.displayFormats.datetime);
            }
        },
        {
            key: "format",
            value: function format(value, _format) {
                var options = this.options;
                var formats = options.time.displayFormats;
                var unit = this._unit;
                var fmt = _format || formats[unit];
                return this._adapter.format(value, fmt);
            }
        },
        {
            key: "_tickFormatFunction",
            value: function _tickFormatFunction(time, index, ticks, format) {
                var options = this.options;
                var formatter = options.ticks.callback;
                if (formatter) return (0, $3zT2Z.Q)(formatter, [
                    time,
                    index,
                    ticks
                ], this);
                var formats = options.time.displayFormats;
                var unit = this._unit;
                var majorUnit = this._majorUnit;
                var minorFormat = unit && formats[unit];
                var majorFormat = majorUnit && formats[majorUnit];
                var tick = ticks[index];
                var major = majorUnit && majorFormat && tick && tick.major;
                return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
            }
        },
        {
            key: "generateTickLabels",
            value: function generateTickLabels(ticks) {
                var i, ilen, tick;
                for(i = 0, ilen = ticks.length; i < ilen; ++i){
                    tick = ticks[i];
                    tick.label = this._tickFormatFunction(tick.value, i, ticks);
                }
            }
        },
        {
            key: "getDecimalForValue",
            value: function getDecimalForValue(value) {
                return value === null ? NaN : (value - this.min) / (this.max - this.min);
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value) {
                var offsets = this._offsets;
                var pos = this.getDecimalForValue(value);
                return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                var offsets = this._offsets;
                var pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
                return this.min + pos * (this.max - this.min);
            }
        },
        {
            key: "_getLabelSize",
            value: function _getLabelSize(label) {
                var ticksOpts = this.options.ticks;
                var tickLabelWidth = this.ctx.measureText(label).width;
                var angle = (0, $3zT2Z.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
                var cosRotation = Math.cos(angle);
                var sinRotation = Math.sin(angle);
                var tickFontSize = this._resolveTickFontOptions(0).size;
                return {
                    w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                    h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
                };
            }
        },
        {
            key: "_getLabelCapacity",
            value: function _getLabelCapacity(exampleTime) {
                var timeOpts = this.options.time;
                var displayFormats = timeOpts.displayFormats;
                var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
                var exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
                    exampleTime
                ], this._majorUnit), format);
                var size = this._getLabelSize(exampleLabel);
                var capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
                return capacity > 0 ? capacity : 1;
            }
        },
        {
            key: "getDataTimestamps",
            value: function getDataTimestamps() {
                var timestamps = this._cache.data || [];
                var i, ilen;
                if (timestamps.length) return timestamps;
                var metas = this.getMatchingVisibleMetas();
                if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
                for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
                return this._cache.data = this.normalize(timestamps);
            }
        },
        {
            key: "getLabelTimestamps",
            value: function getLabelTimestamps() {
                var timestamps = this._cache.labels || [];
                var i, ilen;
                if (timestamps.length) return timestamps;
                var labels = this.getLabels();
                for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push(parse(this, labels[i]));
                return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
            }
        },
        {
            key: "normalize",
            value: function normalize(values) {
                return (0, $3zT2Z._)(values.sort(sorter));
            }
        }
    ]);
    return TimeScale;
}(Scale);
(0, $6lD0P._)(TimeScale, "id", 'time');
(0, $6lD0P._)(TimeScale, "defaults", {
    bounds: 'data',
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
    },
    ticks: {
        source: 'auto',
        callback: false,
        major: {
            enabled: false
        }
    }
});
function interpolate(table, val, reverse) {
    var lo = 0;
    var hi = table.length - 1;
    var prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        var ref;
        if (val >= table[lo].pos && val <= table[hi].pos) ref = (0, $3zT2Z.B)(table, 'pos', val), lo = ref.lo, hi = ref.hi, ref;
        var ref1;
        ref1 = table[lo], prevSource = ref1.pos, prevTarget = ref1.time, ref1;
        var ref2;
        ref2 = table[hi], nextSource = ref2.pos, nextTarget = ref2.time, ref2;
    } else {
        var ref3;
        if (val >= table[lo].time && val <= table[hi].time) ref3 = (0, $3zT2Z.B)(table, 'time', val), lo = ref3.lo, hi = ref3.hi, ref3;
        var ref4;
        ref4 = table[lo], prevSource = ref4.time, prevTarget = ref4.pos, ref4;
        var ref5;
        ref5 = table[hi], nextSource = ref5.time, nextTarget = ref5.pos, ref5;
    }
    var span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
var TimeSeriesScale = /*#__PURE__*/ function(TimeScale) {
    "use strict";
    (0, $dqNF0._)(TimeSeriesScale, TimeScale);
    function TimeSeriesScale(props) {
        (0, $ioD88._)(this, TimeSeriesScale);
        var _this;
        _this = (0, $ctUVE._)(this, TimeSeriesScale, [
            props
        ]);
        _this._table = [];
        _this._minPos = undefined;
        _this._tableRange = undefined;
        return _this;
    }
    (0, $6NCFa._)(TimeSeriesScale, [
        {
            key: "initOffsets",
            value: function initOffsets() {
                var timestamps = this._getTimestampsForTable();
                var table = this._table = this.buildLookupTable(timestamps);
                this._minPos = interpolate(table, this.min);
                this._tableRange = interpolate(table, this.max) - this._minPos;
                (0, $9rJIv._)((0, $2HbS2._)(TimeSeriesScale.prototype), "initOffsets", this).call(this, timestamps);
            }
        },
        {
            key: "buildLookupTable",
            value: function buildLookupTable(timestamps) {
                var _this = this, min = _this.min, max = _this.max;
                var items = [];
                var table = [];
                var i, ilen, prev, curr, next;
                for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                    curr = timestamps[i];
                    if (curr >= min && curr <= max) items.push(curr);
                }
                if (items.length < 2) return [
                    {
                        time: min,
                        pos: 0
                    },
                    {
                        time: max,
                        pos: 1
                    }
                ];
                for(i = 0, ilen = items.length; i < ilen; ++i){
                    next = items[i + 1];
                    prev = items[i - 1];
                    curr = items[i];
                    if (Math.round((next + prev) / 2) !== curr) table.push({
                        time: curr,
                        pos: i / (ilen - 1)
                    });
                }
                return table;
            }
        },
        {
            key: "_generate",
            value: function _generate() {
                var min = this.min;
                var max = this.max;
                var timestamps = (0, $9rJIv._)((0, $2HbS2._)(TimeSeriesScale.prototype), "getDataTimestamps", this).call(this);
                if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
                if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
                return timestamps.sort(function(a, b) {
                    return a - b;
                });
            }
        },
        {
            key: "_getTimestampsForTable",
            value: function _getTimestampsForTable() {
                var timestamps = this._cache.all || [];
                if (timestamps.length) return timestamps;
                var data = this.getDataTimestamps();
                var label = this.getLabelTimestamps();
                if (data.length && label.length) timestamps = this.normalize(data.concat(label));
                else timestamps = data.length ? data : label;
                timestamps = this._cache.all = timestamps;
                return timestamps;
            }
        },
        {
            key: "getDecimalForValue",
            value: function getDecimalForValue(value) {
                return (interpolate(this._table, value) - this._minPos) / this._tableRange;
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                var offsets = this._offsets;
                var decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
                return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
            }
        }
    ]);
    return TimeSeriesScale;
}(TimeScale);
(0, $6lD0P._)(TimeSeriesScale, "id", 'timeseries');
(0, $6lD0P._)(TimeSeriesScale, "defaults", TimeScale.defaults);
var scales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: CategoryScale,
    LinearScale: LinearScale,
    LogarithmicScale: LogarithmicScale,
    RadialLinearScale: RadialLinearScale,
    TimeScale: TimeScale,
    TimeSeriesScale: TimeSeriesScale
});
var registerables = [
    controllers,
    elements,
    plugins,
    scales
];

});
parcelRegister("ctUVE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $91645a5aa8a14f2a$export$71511d61b312f219; });

var $2HbS2 = parcelRequire("2HbS2");

var $bpuGI = parcelRequire("bpuGI");

var $cnpFh = parcelRequire("cnpFh");
function $91645a5aa8a14f2a$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $2HbS2._)(derived);
    return (0, $cnpFh._)(_this, (0, $bpuGI._)() ? Reflect.construct(derived, args || [], (0, $2HbS2._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("2HbS2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1f68ce2a9dc749bd$export$71511d61b312f219; });
function $1f68ce2a9dc749bd$export$71511d61b312f219(o) {
    $1f68ce2a9dc749bd$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1f68ce2a9dc749bd$export$71511d61b312f219(o);
}

});

parcelRegister("bpuGI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $84e9d57d0540249a$export$71511d61b312f219; });
function $84e9d57d0540249a$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($84e9d57d0540249a$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("cnpFh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $902b8a85fbb8106d$export$71511d61b312f219; });

var $asyDM = parcelRequire("asyDM");

var $ewv1T = parcelRequire("ewv1T");
function $902b8a85fbb8106d$export$71511d61b312f219(self, call) {
    if (call && ((0, $ewv1T._)(call) === "object" || typeof call === "function")) return call;
    return (0, $asyDM._)(self);
}

});
parcelRegister("asyDM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $79d763cc9bc2b895$export$71511d61b312f219; });
function $79d763cc9bc2b895$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("ioD88", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d648d2503728a936$export$71511d61b312f219; });
function $d648d2503728a936$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6NCFa", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4f354f5729633883$export$71511d61b312f219; });
function $4f354f5729633883$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4f354f5729633883$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4f354f5729633883$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4f354f5729633883$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("6lD0P", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $49f2f74360d02b58$export$71511d61b312f219; });
function $49f2f74360d02b58$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("9rJIv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e0a191c247a587c$export$71511d61b312f219; });

var $irQ5y = parcelRequire("irQ5y");
function $6e0a191c247a587c$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $6e0a191c247a587c$export$71511d61b312f219 = Reflect.get;
    else $6e0a191c247a587c$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $irQ5y._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $6e0a191c247a587c$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("irQ5y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d6e327520f511648$export$71511d61b312f219; });

var $2HbS2 = parcelRequire("2HbS2");
function $d6e327520f511648$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $2HbS2._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("dqNF0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9c743995b495269e$export$71511d61b312f219; });

var $dWFBa = parcelRequire("dWFBa");
function $9c743995b495269e$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $dWFBa._)(subClass, superClass);
}

});
parcelRegister("dWFBa", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a270f5bb692d5a09$export$71511d61b312f219; });
function $a270f5bb692d5a09$export$71511d61b312f219(o, p) {
    $a270f5bb692d5a09$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a270f5bb692d5a09$export$71511d61b312f219(o, p);
}

});


parcelRegister("8lZHN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6150264c4b5b67db$export$71511d61b312f219; });

var $6lD0P = parcelRequire("6lD0P");
function $6150264c4b5b67db$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6lD0P._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("3K9Jy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2b9d37e208d43d55$export$71511d61b312f219; });
function $2b9d37e208d43d55$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2b9d37e208d43d55$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $2b9d37e208d43d55$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("esDIr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a8727cf449529550$export$71511d61b312f219; });

var $5LA6V = parcelRequire("5LA6V");

var $cibRZ = parcelRequire("cibRZ");

var $ljIix = parcelRequire("ljIix");

var $c0Zyh = parcelRequire("c0Zyh");
function $a8727cf449529550$export$71511d61b312f219(arr, i) {
    return (0, $5LA6V._)(arr) || (0, $cibRZ._)(arr, i) || (0, $c0Zyh._)(arr, i) || (0, $ljIix._)();
}

});
parcelRegister("5LA6V", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $432d5a6381d8ae9e$export$71511d61b312f219; });
function $432d5a6381d8ae9e$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("cibRZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8f305f95bd0532df$export$71511d61b312f219; });
function $8f305f95bd0532df$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("ljIix", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f84dbbf5dfef0fde$export$71511d61b312f219; });
function $f84dbbf5dfef0fde$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6brDd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $48093431a7ece65f$export$71511d61b312f219; });

var $6yyHG = parcelRequire("6yyHG");

var $2HbS2 = parcelRequire("2HbS2");

var $7bnj4 = parcelRequire("7bnj4");

var $dWFBa = parcelRequire("dWFBa");
function $48093431a7ece65f$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $48093431a7ece65f$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $7bnj4._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $6yyHG._)(Class, arguments, (0, $2HbS2._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $dWFBa._)(Wrapper, Class);
    };
    return $48093431a7ece65f$export$71511d61b312f219(Class);
}

});
parcelRegister("6yyHG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4c60d67338b1c4f0$export$71511d61b312f219; });

var $bpuGI = parcelRequire("bpuGI");

var $dWFBa = parcelRequire("dWFBa");
function $4c60d67338b1c4f0$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $bpuGI._)()) $4c60d67338b1c4f0$export$71511d61b312f219 = Reflect.construct;
    else $4c60d67338b1c4f0$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $dWFBa._)(instance, Class.prototype);
        return instance;
    };
    return $4c60d67338b1c4f0$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("7bnj4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53aba3afbfa52630$export$71511d61b312f219; });
function $53aba3afbfa52630$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("3zT2Z", function(module, exports) {

$parcel$export(module.exports, "aG", function () { return $29af573a5460390b$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "ac", function () { return $29af573a5460390b$export$2219238a014317b0; });
$parcel$export(module.exports, "k", function () { return $29af573a5460390b$export$342063e11d6c3cad; });
$parcel$export(module.exports, "b", function () { return $29af573a5460390b$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "i", function () { return $29af573a5460390b$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "g", function () { return $29af573a5460390b$export$39b482c5e57630a8; });
$parcel$export(module.exports, "O", function () { return $29af573a5460390b$export$c4ce752e73470fba; });
$parcel$export(module.exports, "v", function () { return $29af573a5460390b$export$90a7f3efeed30595; });
$parcel$export(module.exports, "m", function () { return $29af573a5460390b$export$953cecd6e717a553; });
$parcel$export(module.exports, "n", function () { return $29af573a5460390b$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "Q", function () { return $29af573a5460390b$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "F", function () { return $29af573a5460390b$export$d66501df72047452; });
$parcel$export(module.exports, "ai", function () { return $29af573a5460390b$export$f38c853ae54ed474; });
$parcel$export(module.exports, "a4", function () { return $29af573a5460390b$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "ab", function () { return $29af573a5460390b$export$555508cbc6add439; });
$parcel$export(module.exports, "f", function () { return $29af573a5460390b$export$2d1720544b23b823; });
$parcel$export(module.exports, "a5", function () { return $29af573a5460390b$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "h", function () { return $29af573a5460390b$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a7", function () { return $29af573a5460390b$export$a93c5207d687da10; });
$parcel$export(module.exports, "ag", function () { return $29af573a5460390b$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "aj", function () { return $29af573a5460390b$export$3b513254972cfc9c; });
$parcel$export(module.exports, "P", function () { return $29af573a5460390b$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "T", function () { return $29af573a5460390b$export$971d5caa766a69d7; });
$parcel$export(module.exports, "H", function () { return $29af573a5460390b$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "aN", function () { return $29af573a5460390b$export$faec65b429be379; });
$parcel$export(module.exports, "s", function () { return $29af573a5460390b$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "aK", function () { return $29af573a5460390b$export$23ebac1979863676; });
$parcel$export(module.exports, "aI", function () { return $29af573a5460390b$export$b9a6b53f9be3734; });
$parcel$export(module.exports, "N", function () { return $29af573a5460390b$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "x", function () { return $29af573a5460390b$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "aJ", function () { return $29af573a5460390b$export$a05254e7c3aeba6e; });
$parcel$export(module.exports, "aH", function () { return $29af573a5460390b$export$a33b77bbdbb8366c; });
$parcel$export(module.exports, "t", function () { return $29af573a5460390b$export$625550452a3fa3ec; });
$parcel$export(module.exports, "U", function () { return $29af573a5460390b$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "aL", function () { return $29af573a5460390b$export$91477dc880baac21; });
$parcel$export(module.exports, "D", function () { return $29af573a5460390b$export$96f57966bedc81b4; });
$parcel$export(module.exports, "aF", function () { return $29af573a5460390b$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "al", function () { return $29af573a5460390b$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "p", function () { return $29af573a5460390b$export$ffb5f4729a158638; });
$parcel$export(module.exports, "S", function () { return $29af573a5460390b$export$25ce5a424b770e84; });
$parcel$export(module.exports, "W", function () { return $29af573a5460390b$export$71cec2538cb2c617; });
$parcel$export(module.exports, "ak", function () { return $29af573a5460390b$export$21579262ef46735b; });
$parcel$export(module.exports, "aQ", function () { return $29af573a5460390b$export$f96d196f7728bb5; });
$parcel$export(module.exports, "B", function () { return $29af573a5460390b$export$ef35774e6d314e91; });
$parcel$export(module.exports, "A", function () { return $29af573a5460390b$export$ebd11618f299a286; });
$parcel$export(module.exports, "aP", function () { return $29af573a5460390b$export$2ed0fc6709e59212; });
$parcel$export(module.exports, "l", function () { return $29af573a5460390b$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $29af573a5460390b$export$3b14a55fb2447963; });
$parcel$export(module.exports, "_", function () { return $29af573a5460390b$export$71511d61b312f219; });
$parcel$export(module.exports, "r", function () { return $29af573a5460390b$export$43caf9889c228507; });
$parcel$export(module.exports, "L", function () { return $29af573a5460390b$export$61196ced6d74a310; });
$parcel$export(module.exports, "ad", function () { return $29af573a5460390b$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "a1", function () { return $29af573a5460390b$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "a2", function () { return $29af573a5460390b$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "aC", function () { return $29af573a5460390b$export$890c4ad488842ce7; });
$parcel$export(module.exports, "q", function () { return $29af573a5460390b$export$9e5f44173e64f162; });
$parcel$export(module.exports, "w", function () { return $29af573a5460390b$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "e", function () { return $29af573a5460390b$export$f1e1789686576879; });
$parcel$export(module.exports, "c", function () { return $29af573a5460390b$export$db3b6bfb95261072; });
$parcel$export(module.exports, "o", function () { return $29af573a5460390b$export$ae1af26003f05816; });
$parcel$export(module.exports, "aM", function () { return $29af573a5460390b$export$9f4f30ee63539e24; });
$parcel$export(module.exports, "a3", function () { return $29af573a5460390b$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "a6", function () { return $29af573a5460390b$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "d", function () { return $29af573a5460390b$export$4368d992c4eafac0; });
$parcel$export(module.exports, "V", function () { return $29af573a5460390b$export$e7c866399fa523f5; });
$parcel$export(module.exports, "aO", function () { return $29af573a5460390b$export$c03999cb2f36933f; });
$parcel$export(module.exports, "X", function () { return $29af573a5460390b$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "af", function () { return $29af573a5460390b$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "av", function () { return $29af573a5460390b$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "aE", function () { return $29af573a5460390b$export$158acd800e1ef08b; });
$parcel$export(module.exports, "C", function () { return $29af573a5460390b$export$e7094788287c5e9b; });
$parcel$export(module.exports, "Y", function () { return $29af573a5460390b$export$8743009a87fcb00f; });
$parcel$export(module.exports, "$", function () { return $29af573a5460390b$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "at", function () { return $29af573a5460390b$export$493d36ec626b6698; });
$parcel$export(module.exports, "au", function () { return $29af573a5460390b$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "Z", function () { return $29af573a5460390b$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "aw", function () { return $29af573a5460390b$export$92108d983e8ee699; });
$parcel$export(module.exports, "am", function () { return $29af573a5460390b$export$1a82df3d29112e01; });
$parcel$export(module.exports, "ax", function () { return $29af573a5460390b$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "ay", function () { return $29af573a5460390b$export$28f7fcd39efa255; });
$parcel$export(module.exports, "E", function () { return $29af573a5460390b$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "a0", function () { return $29af573a5460390b$export$34aec0b863436764; });
$parcel$export(module.exports, "a", function () { return $29af573a5460390b$export$407448d2b89b1813; });
$parcel$export(module.exports, "R", function () { return $29af573a5460390b$export$db202ddc8be9136; });
$parcel$export(module.exports, "j", function () { return $29af573a5460390b$export$35e795649ee09318; });
$parcel$export(module.exports, "a9", function () { return $29af573a5460390b$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "a8", function () { return $29af573a5460390b$export$c3950d9923825c02; });
$parcel$export(module.exports, "aa", function () { return $29af573a5460390b$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "y", function () { return $29af573a5460390b$export$4a5767248b18ef41; });
$parcel$export(module.exports, "an", function () { return $29af573a5460390b$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "M", function () { return $29af573a5460390b$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "I", function () { return $29af573a5460390b$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $29af573a5460390b$export$df995fae86a55f06; });
$parcel$export(module.exports, "G", function () { return $29af573a5460390b$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "ae", function () { return $29af573a5460390b$export$f787f51d84a910ad; });
$parcel$export(module.exports, "K", function () { return $29af573a5460390b$export$3466f893ebf79586; });
$parcel$export(module.exports, "J", function () { return $29af573a5460390b$export$b4171a6734a65d42; });
$parcel$export(module.exports, "as", function () { return $29af573a5460390b$export$6554612db691658e; });
$parcel$export(module.exports, "aq", function () { return $29af573a5460390b$export$8a5498727ef6be21; });
$parcel$export(module.exports, "ar", function () { return $29af573a5460390b$export$d24c54395ce0c509; });
$parcel$export(module.exports, "aA", function () { return $29af573a5460390b$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "aB", function () { return $29af573a5460390b$export$9d398bebfec1c039; });
$parcel$export(module.exports, "aD", function () { return $29af573a5460390b$export$24baa2b76016ce0e; });
$parcel$export(module.exports, "az", function () { return $29af573a5460390b$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "ap", function () { return $29af573a5460390b$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "ao", function () { return $29af573a5460390b$export$7a38258bbe170828; });
$parcel$export(module.exports, "ah", function () { return $29af573a5460390b$export$995eb9fca571757; });
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $6lD0P = parcelRequire("6lD0P");

var $kNmtb = parcelRequire("kNmtb");

var $ewv1T = parcelRequire("ewv1T");

var $6Xptx = parcelRequire("6Xptx");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $29af573a5460390b$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ var $29af573a5460390b$export$2219238a014317b0 = function() {
    var id = 0;
    return function() {
        return id++;
    };
}();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $29af573a5460390b$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $29af573a5460390b$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    var type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $29af573a5460390b$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $29af573a5460390b$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $29af573a5460390b$export$c4ce752e73470fba(value, defaultValue) {
    return $29af573a5460390b$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $29af573a5460390b$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
var $29af573a5460390b$export$953cecd6e717a553 = function(value, dimension) {
    return typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
};
var $29af573a5460390b$export$7ccc53e8f1e7dfc5 = function(value, dimension) {
    return typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
};
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $29af573a5460390b$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $29af573a5460390b$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    var i, len, keys;
    if ($29af573a5460390b$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($29af573a5460390b$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $29af573a5460390b$export$f38c853ae54ed474(a0, a1) {
    var i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $29af573a5460390b$export$667d3bf0c5f83305(source) {
    if ($29af573a5460390b$export$8b22cf2602fb60ce(source)) return source.map($29af573a5460390b$export$667d3bf0c5f83305);
    if ($29af573a5460390b$export$23f2a1d2818174ef(source)) {
        var target = Object.create(null);
        var keys = Object.keys(source);
        var klen = keys.length;
        var k = 0;
        for(; k < klen; ++k)target[keys[k]] = $29af573a5460390b$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $29af573a5460390b$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $29af573a5460390b$export$317a3d46287192d8(key, target, source, options) {
    if (!$29af573a5460390b$var$isValidKey(key)) return;
    var tval = target[key];
    var sval = source[key];
    if ($29af573a5460390b$export$23f2a1d2818174ef(tval) && $29af573a5460390b$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $29af573a5460390b$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $29af573a5460390b$export$667d3bf0c5f83305(sval);
}
function $29af573a5460390b$export$efca4cbe5dd06740(target, source, options) {
    var sources = $29af573a5460390b$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    var ilen = sources.length;
    if (!$29af573a5460390b$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    var merger = options.merger || $29af573a5460390b$export$317a3d46287192d8;
    var current;
    for(var i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$29af573a5460390b$export$23f2a1d2818174ef(current)) continue;
        var keys = Object.keys(current);
        for(var k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $29af573a5460390b$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $29af573a5460390b$export$efca4cbe5dd06740(target, source, {
        merger: $29af573a5460390b$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $29af573a5460390b$export$1ee57be6f6687d2c(key, target, source) {
    if (!$29af573a5460390b$var$isValidKey(key)) return;
    var tval = target[key];
    var sval = source[key];
    if ($29af573a5460390b$export$23f2a1d2818174ef(tval) && $29af573a5460390b$export$23f2a1d2818174ef(sval)) $29af573a5460390b$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $29af573a5460390b$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $29af573a5460390b$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
var $29af573a5460390b$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': function(v) {
        return v;
    },
    // default resolvers
    x: function(o) {
        return o.x;
    },
    y: function(o) {
        return o.y;
    }
};
/**
 * @private
 */ function $29af573a5460390b$export$1a8f5705751d8277(key) {
    var parts = key.split('.');
    var keys = [];
    var tmp = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            tmp += part;
            if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
            else {
                keys.push(tmp);
                tmp = '';
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return keys;
}
function $29af573a5460390b$var$_getKeyResolver(key) {
    var keys = $29af573a5460390b$export$1a8f5705751d8277(key);
    return function(obj) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                if (k === '') break;
                obj = obj && obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
}
function $29af573a5460390b$export$2d1720544b23b823(obj, key) {
    var resolver = $29af573a5460390b$var$keyResolvers[key] || ($29af573a5460390b$var$keyResolvers[key] = $29af573a5460390b$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $29af573a5460390b$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $29af573a5460390b$export$dda1d9f60106f0e9 = function(value) {
    return typeof value !== 'undefined';
};
var $29af573a5460390b$export$a93c5207d687da10 = function(value) {
    return typeof value === 'function';
};
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
var $29af573a5460390b$export$ee7c8ad385a60b7b = function(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (!b.has(item)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $29af573a5460390b$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ var $29af573a5460390b$export$56c0d5a1e737357d = Math.PI;
var $29af573a5460390b$export$971d5caa766a69d7 = 2 * $29af573a5460390b$export$56c0d5a1e737357d;
var $29af573a5460390b$export$2ec5befb9e6c97d4 = $29af573a5460390b$export$971d5caa766a69d7 + $29af573a5460390b$export$56c0d5a1e737357d;
var $29af573a5460390b$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
var $29af573a5460390b$export$39c1cc7c062529d4 = $29af573a5460390b$export$56c0d5a1e737357d / 180;
var $29af573a5460390b$export$7f8ddf7c7c20b3cd = $29af573a5460390b$export$56c0d5a1e737357d / 2;
var $29af573a5460390b$export$7a0bdf7d4a91ea88 = $29af573a5460390b$export$56c0d5a1e737357d / 4;
var $29af573a5460390b$export$c18d01048907ea92 = $29af573a5460390b$export$56c0d5a1e737357d * 2 / 3;
var $29af573a5460390b$export$faec65b429be379 = Math.log10;
var $29af573a5460390b$export$2408f22a0fab9ae5 = Math.sign;
function $29af573a5460390b$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $29af573a5460390b$export$b9a6b53f9be3734(range) {
    var roundedRange = Math.round(range);
    range = $29af573a5460390b$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    var niceRange = Math.pow(10, Math.floor($29af573a5460390b$export$faec65b429be379(range)));
    var fraction = range / niceRange;
    var niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $29af573a5460390b$export$a07804094c3ecf2d(value) {
    var result = [];
    var sqrt = Math.sqrt(value);
    var i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort(function(a, b) {
        return a - b;
    }).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $29af573a5460390b$var$isNonPrimitive(n) {
    return (typeof n === "undefined" ? "undefined" : (0, $ewv1T._)(n)) === 'symbol' || (typeof n === "undefined" ? "undefined" : (0, $ewv1T._)(n)) === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $29af573a5460390b$export$d141bba7fdc215a3(n) {
    return !$29af573a5460390b$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $29af573a5460390b$export$a05254e7c3aeba6e(x, epsilon) {
    var rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $29af573a5460390b$export$a33b77bbdbb8366c(array, target, property) {
    var i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $29af573a5460390b$export$625550452a3fa3ec(degrees) {
    return degrees * ($29af573a5460390b$export$56c0d5a1e737357d / 180);
}
function $29af573a5460390b$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $29af573a5460390b$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $29af573a5460390b$export$91477dc880baac21(x) {
    if (!$29af573a5460390b$export$39b482c5e57630a8(x)) return;
    var e = 1;
    var p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $29af573a5460390b$export$96f57966bedc81b4(centrePoint, anglePoint) {
    var distanceFromXCenter = anglePoint.x - centrePoint.x;
    var distanceFromYCenter = anglePoint.y - centrePoint.y;
    var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $29af573a5460390b$export$56c0d5a1e737357d) angle += $29af573a5460390b$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $29af573a5460390b$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $29af573a5460390b$export$f074adc9fbd50943(a, b) {
    return (a - b + $29af573a5460390b$export$2ec5befb9e6c97d4) % $29af573a5460390b$export$971d5caa766a69d7 - $29af573a5460390b$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $29af573a5460390b$export$ab83b03e4111b1d0(a) {
    return (a % $29af573a5460390b$export$971d5caa766a69d7 + $29af573a5460390b$export$971d5caa766a69d7) % $29af573a5460390b$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $29af573a5460390b$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    var a = $29af573a5460390b$export$ab83b03e4111b1d0(angle);
    var s = $29af573a5460390b$export$ab83b03e4111b1d0(start);
    var e = $29af573a5460390b$export$ab83b03e4111b1d0(end);
    var angleToStart = $29af573a5460390b$export$ab83b03e4111b1d0(s - a);
    var angleToEnd = $29af573a5460390b$export$ab83b03e4111b1d0(e - a);
    var startToAngle = $29af573a5460390b$export$ab83b03e4111b1d0(a - s);
    var endToAngle = $29af573a5460390b$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $29af573a5460390b$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $29af573a5460390b$export$71cec2538cb2c617(value) {
    return $29af573a5460390b$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $29af573a5460390b$export$21579262ef46735b(value, start, end) {
    var epsilon = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1e-6;
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $29af573a5460390b$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || function(index) {
        return table[index] < value;
    };
    var hi = table.length - 1;
    var lo = 0;
    var mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ var $29af573a5460390b$export$ef35774e6d314e91 = function(table, key, value, last) {
    return $29af573a5460390b$export$f96d196f7728bb5(table, value, last ? function(index) {
        var ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : function(index) {
        return table[index][key] < value;
    });
};
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ var $29af573a5460390b$export$ebd11618f299a286 = function(table, key, value) {
    return $29af573a5460390b$export$f96d196f7728bb5(table, value, function(index) {
        return table[index][key] >= value;
    });
};
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $29af573a5460390b$export$2ed0fc6709e59212(values, min, max) {
    var start = 0;
    var end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
var $29af573a5460390b$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $29af573a5460390b$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $29af573a5460390b$var$arrayEvents.forEach(function(key) {
        var method = '_onData' + $29af573a5460390b$export$a8550f7dbe79f93a(key);
        var base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var res = base.apply(this, args);
                array._chartjs.listeners.forEach(function(object) {
                    var _object;
                    if (typeof object[method] === 'function') (_object = object)[method].apply(_object, (0, $kNmtb._)(args));
                });
                return res;
            }
        });
    });
}
function $29af573a5460390b$export$3b14a55fb2447963(array, listener) {
    var stub = array._chartjs;
    if (!stub) return;
    var listeners = stub.listeners;
    var index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $29af573a5460390b$var$arrayEvents.forEach(function(key) {
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $29af573a5460390b$export$71511d61b312f219(items) {
    var set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $29af573a5460390b$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ var $29af573a5460390b$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $29af573a5460390b$export$61196ced6d74a310(fn, thisArg) {
    var argsToUse = [];
    var ticking = false;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $29af573a5460390b$export$43caf9889c228507.call(window, function() {
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $29af573a5460390b$export$4c3d22f3d993c33f(fn, delay) {
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ var $29af573a5460390b$export$3c2fa207a37baaea = function(align) {
    return align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
};
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ var $29af573a5460390b$export$ce26c07117d59d6a = function(align, start, end) {
    return align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
};
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ var $29af573a5460390b$export$890c4ad488842ce7 = function(align, left, right, rtl) {
    var check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $29af573a5460390b$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    var pointCount = points.length;
    var start = 0;
    var count = pointCount;
    if (meta._sorted) {
        var iScale = meta.iScale, vScale = meta.vScale, _parsed = meta._parsed;
        var spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        var axis = iScale.axis;
        var _iScale_getUserBounds = iScale.getUserBounds(), min = _iScale_getUserBounds.min, max = _iScale_getUserBounds.max, minDefined = _iScale_getUserBounds.minDefined, maxDefined = _iScale_getUserBounds.maxDefined;
        if (minDefined) {
            start = Math.min($29af573a5460390b$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $29af573a5460390b$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                var distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex(function(point) {
                    return !$29af573a5460390b$export$342063e11d6c3cad(point[vScale.axis]);
                });
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $29af573a5460390b$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            var end = Math.max($29af573a5460390b$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $29af573a5460390b$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                var distanceToDefinedHi = _parsed.slice(end - 1).findIndex(function(point) {
                    return !$29af573a5460390b$export$342063e11d6c3cad(point[vScale.axis]);
                });
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $29af573a5460390b$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $29af573a5460390b$export$efccba1c4a2ef57b(meta) {
    var xScale = meta.xScale, yScale = meta.yScale, _scaleRanges = meta._scaleRanges;
    var newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    var changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
var $29af573a5460390b$var$atEdge = function(t) {
    return t === 0 || t === 1;
};
var $29af573a5460390b$var$elasticIn = function(t, s, p) {
    return -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $29af573a5460390b$export$971d5caa766a69d7 / p));
};
var $29af573a5460390b$var$elasticOut = function(t, s, p) {
    return Math.pow(2, -10 * t) * Math.sin((t - s) * $29af573a5460390b$export$971d5caa766a69d7 / p) + 1;
};
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ var $29af573a5460390b$export$f1e1789686576879 = {
    linear: function(t) {
        return t;
    },
    easeInQuad: function(t) {
        return t * t;
    },
    easeOutQuad: function(t) {
        return -t * (t - 2);
    },
    easeInOutQuad: function(t) {
        return (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1);
    },
    easeInCubic: function(t) {
        return t * t * t;
    },
    easeOutCubic: function(t) {
        return (t -= 1) * t * t + 1;
    },
    easeInOutCubic: function(t) {
        return (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2);
    },
    easeInQuart: function(t) {
        return t * t * t * t;
    },
    easeOutQuart: function(t) {
        return -((t -= 1) * t * t * t - 1);
    },
    easeInOutQuart: function(t) {
        return (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2);
    },
    easeInQuint: function(t) {
        return t * t * t * t * t;
    },
    easeOutQuint: function(t) {
        return (t -= 1) * t * t * t * t + 1;
    },
    easeInOutQuint: function(t) {
        return (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2);
    },
    easeInSine: function(t) {
        return -Math.cos(t * $29af573a5460390b$export$7f8ddf7c7c20b3cd) + 1;
    },
    easeOutSine: function(t) {
        return Math.sin(t * $29af573a5460390b$export$7f8ddf7c7c20b3cd);
    },
    easeInOutSine: function(t) {
        return -0.5 * (Math.cos($29af573a5460390b$export$56c0d5a1e737357d * t) - 1);
    },
    easeInExpo: function(t) {
        return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
    },
    easeOutExpo: function(t) {
        return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
    },
    easeInOutExpo: function(t) {
        return $29af573a5460390b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2);
    },
    easeInCirc: function(t) {
        return t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1);
    },
    easeOutCirc: function(t) {
        return Math.sqrt(1 - (t -= 1) * t);
    },
    easeInOutCirc: function(t) {
        return (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
    },
    easeInElastic: function(t) {
        return $29af573a5460390b$var$atEdge(t) ? t : $29af573a5460390b$var$elasticIn(t, 0.075, 0.3);
    },
    easeOutElastic: function(t) {
        return $29af573a5460390b$var$atEdge(t) ? t : $29af573a5460390b$var$elasticOut(t, 0.075, 0.3);
    },
    easeInOutElastic: function(t) {
        var s = 0.1125;
        var p = 0.45;
        return $29af573a5460390b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $29af573a5460390b$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $29af573a5460390b$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack: function(t) {
        var s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack: function(t) {
        var s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack: function(t) {
        var s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: function(t) {
        return 1 - $29af573a5460390b$export$f1e1789686576879.easeOutBounce(1 - t);
    },
    easeOutBounce: function(t) {
        var m = 7.5625;
        var d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: function(t) {
        return t < 0.5 ? $29af573a5460390b$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $29af573a5460390b$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
    }
};
function $29af573a5460390b$export$738ab4df8bf92ae9(value) {
    if (value && (typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === 'object') {
        var type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $29af573a5460390b$export$db3b6bfb95261072(value) {
    return $29af573a5460390b$export$738ab4df8bf92ae9(value) ? value : new (0, $6Xptx.Color)(value);
}
function $29af573a5460390b$export$d377dcb2b61d6c4e(value) {
    return $29af573a5460390b$export$738ab4df8bf92ae9(value) ? value : new (0, $6Xptx.Color)(value).saturate(0.5).darken(0.1).hexString();
}
var $29af573a5460390b$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
var $29af573a5460390b$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $29af573a5460390b$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: function(name) {
            return name !== 'onProgress' && name !== 'onComplete' && name !== 'fn';
        }
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $29af573a5460390b$var$colors
        },
        numbers: {
            type: 'number',
            properties: $29af573a5460390b$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: function(v) {
                        return v | 0;
                    }
                }
            }
        }
    });
}
function $29af573a5460390b$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
var $29af573a5460390b$var$intlCache = new Map();
function $29af573a5460390b$var$getNumberFormat(locale, options) {
    options = options || {};
    var cacheKey = locale + JSON.stringify(options);
    var formatter = $29af573a5460390b$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $29af573a5460390b$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $29af573a5460390b$export$ae1af26003f05816(num, locale, options) {
    return $29af573a5460390b$var$getNumberFormat(locale, options).format(num);
}
var $29af573a5460390b$var$formatters = {
    values: function(value) {
        return $29af573a5460390b$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric: function(tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        var locale = this.chart.options.locale;
        var notation;
        var delta = tickValue;
        if (ticks.length > 1) {
            var maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $29af573a5460390b$var$calculateDelta(tickValue, ticks);
        }
        var logDelta = $29af573a5460390b$export$faec65b429be379(Math.abs(delta));
        var numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        var options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $29af573a5460390b$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic: function(tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        var remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($29af573a5460390b$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $29af573a5460390b$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $29af573a5460390b$var$calculateDelta(tickValue, ticks) {
    var delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $29af573a5460390b$export$9f4f30ee63539e24 = {
    formatters: $29af573a5460390b$var$formatters
};
function $29af573a5460390b$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: function(_ctx, options) {
                return options.lineWidth;
            },
            tickColor: function(_ctx, options) {
                return options.color;
            },
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $29af573a5460390b$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: function(name) {
            return !name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser';
        },
        _indexable: function(name) {
            return name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash';
        }
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: function(name) {
            return name !== 'backdropPadding' && name !== 'callback';
        },
        _indexable: function(name) {
            return name !== 'backdropPadding';
        }
    });
}
var $29af573a5460390b$export$6559d589eb85fbb6 = Object.create(null);
var $29af573a5460390b$export$2e2af4578d910ddf = Object.create(null);
function $29af573a5460390b$var$getScope$1(node, key) {
    if (!key) return node;
    var keys = key.split('.');
    for(var i = 0, n = keys.length; i < n; ++i){
        var k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $29af573a5460390b$var$set(root, scope, values) {
    if (typeof scope === 'string') return $29af573a5460390b$export$efca4cbe5dd06740($29af573a5460390b$var$getScope$1(root, scope), values);
    return $29af573a5460390b$export$efca4cbe5dd06740($29af573a5460390b$var$getScope$1(root, ''), scope);
}
var $29af573a5460390b$var$Defaults = /*#__PURE__*/ function() {
    "use strict";
    function Defaults(_descriptors, _appliers) {
        (0, $ioD88._)(this, Defaults);
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = function(context) {
            return context.chart.platform.getDevicePixelRatio();
        };
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = function(ctx, options) {
            return $29af573a5460390b$export$d377dcb2b61d6c4e(options.backgroundColor);
        };
        this.hoverBorderColor = function(ctx, options) {
            return $29af573a5460390b$export$d377dcb2b61d6c4e(options.borderColor);
        };
        this.hoverColor = function(ctx, options) {
            return $29af573a5460390b$export$d377dcb2b61d6c4e(options.color);
        };
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    (0, $6NCFa._)(Defaults, [
        {
            key: "set",
            value: function set1(scope, values) {
                return $29af573a5460390b$var$set(this, scope, values);
            }
        },
        {
            key: "get",
            value: function get(scope) {
                return $29af573a5460390b$var$getScope$1(this, scope);
            }
        },
        {
            key: "describe",
            value: function describe(scope, values) {
                return $29af573a5460390b$var$set($29af573a5460390b$export$2e2af4578d910ddf, scope, values);
            }
        },
        {
            key: "override",
            value: function override(scope, values) {
                return $29af573a5460390b$var$set($29af573a5460390b$export$6559d589eb85fbb6, scope, values);
            }
        },
        {
            key: "route",
            value: function route(scope, name, targetScope, targetName) {
                var scopeObject = $29af573a5460390b$var$getScope$1(this, scope);
                var targetScopeObject = $29af573a5460390b$var$getScope$1(this, targetScope);
                var privateName = '_' + name;
                var _obj;
                Object.defineProperties(scopeObject, (_obj = {}, (0, $6lD0P._)(_obj, privateName, {
                    value: scopeObject[name],
                    writable: true
                }), (0, $6lD0P._)(_obj, name, {
                    enumerable: true,
                    get: function() {
                        var local = this[privateName];
                        var target = targetScopeObject[targetName];
                        if ($29af573a5460390b$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                        return $29af573a5460390b$export$90a7f3efeed30595(local, target);
                    },
                    set: function(value) {
                        this[privateName] = value;
                    }
                }), _obj));
            }
        },
        {
            key: "apply",
            value: function apply(appliers) {
                var _this = this;
                appliers.forEach(function(apply) {
                    return apply(_this);
                });
            }
        }
    ]);
    return Defaults;
}();
var $29af573a5460390b$export$4368d992c4eafac0 = /* #__PURE__ */ new $29af573a5460390b$var$Defaults({
    _scriptable: function(name) {
        return !name.startsWith('on');
    },
    _indexable: function(name) {
        return name !== 'events';
    },
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $29af573a5460390b$var$applyAnimationsDefaults,
    $29af573a5460390b$var$applyLayoutsDefaults,
    $29af573a5460390b$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $29af573a5460390b$export$e171bab687b50e0(font) {
    if (!font || $29af573a5460390b$export$342063e11d6c3cad(font.size) || $29af573a5460390b$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $29af573a5460390b$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    var textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $29af573a5460390b$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    var data = cache.data = cache.data || {};
    var gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    var longest = 0;
    var ilen = arrayOfThings.length;
    var i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$29af573a5460390b$export$8b22cf2602fb60ce(thing)) longest = $29af573a5460390b$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($29af573a5460390b$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$29af573a5460390b$export$8b22cf2602fb60ce(nestedThing)) longest = $29af573a5460390b$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    var gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $29af573a5460390b$export$78acf4525d8a74c4(chart, pixel, width) {
    var devicePixelRatio = chart.currentDevicePixelRatio;
    var halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $29af573a5460390b$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $29af573a5460390b$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $29af573a5460390b$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $29af573a5460390b$export$158acd800e1ef08b(ctx, options, x, y, w) {
    var type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    var style = options.pointStyle;
    var rotation = options.rotation;
    var radius = options.radius;
    var rad = (rotation || 0) * $29af573a5460390b$export$39c1cc7c062529d4;
    if (style && (typeof style === "undefined" ? "undefined" : (0, $ewv1T._)(style)) === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $29af573a5460390b$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $29af573a5460390b$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $29af573a5460390b$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $29af573a5460390b$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $29af573a5460390b$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $29af573a5460390b$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $29af573a5460390b$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $29af573a5460390b$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $29af573a5460390b$export$56c0d5a1e737357d, rad - $29af573a5460390b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $29af573a5460390b$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $29af573a5460390b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $29af573a5460390b$export$7f8ddf7c7c20b3cd, rad + $29af573a5460390b$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $29af573a5460390b$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $29af573a5460390b$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $29af573a5460390b$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $29af573a5460390b$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $29af573a5460390b$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $29af573a5460390b$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $29af573a5460390b$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        var midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $29af573a5460390b$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $29af573a5460390b$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$29af573a5460390b$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $29af573a5460390b$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ var metrics = ctx.measureText(line);
        var left = x - metrics.actualBoundingBoxLeft;
        var right = x + metrics.actualBoundingBoxRight;
        var top = y - metrics.actualBoundingBoxAscent;
        var bottom = y + metrics.actualBoundingBoxDescent;
        var yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $29af573a5460390b$var$drawBackdrop(ctx, opts) {
    var oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $29af573a5460390b$export$dc98b0b04f4c7758(ctx, text, x, y, font) {
    var opts = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var lines = $29af573a5460390b$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    var stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    var i, line;
    ctx.save();
    ctx.font = font.string;
    $29af573a5460390b$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $29af573a5460390b$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$29af573a5460390b$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $29af573a5460390b$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $29af573a5460390b$export$92108d983e8ee699(ctx, rect) {
    var x = rect.x, y = rect.y, w = rect.w, h = rect.h, radius = rect.radius;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $29af573a5460390b$export$56c0d5a1e737357d, $29af573a5460390b$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $29af573a5460390b$export$56c0d5a1e737357d, $29af573a5460390b$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $29af573a5460390b$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$29af573a5460390b$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
var $29af573a5460390b$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
var $29af573a5460390b$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $29af573a5460390b$export$d29e374196577086(value, size) {
    var matches = ('' + value).match($29af573a5460390b$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
var $29af573a5460390b$var$numberOrZero = function(v) {
    return +v || 0;
};
function $29af573a5460390b$export$1a82df3d29112e01(value, props) {
    var ret = {};
    var objProps = $29af573a5460390b$export$23f2a1d2818174ef(props);
    var keys = objProps ? Object.keys(props) : props;
    var read = $29af573a5460390b$export$23f2a1d2818174ef(value) ? objProps ? function(prop) {
        return $29af573a5460390b$export$90a7f3efeed30595(value[prop], value[props[prop]]);
    } : function(prop) {
        return value[prop];
    } : function() {
        return value;
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            ret[prop] = $29af573a5460390b$var$numberOrZero(read(prop));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $29af573a5460390b$export$9fa96a7d116ea3ce(value) {
    return $29af573a5460390b$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $29af573a5460390b$export$28f7fcd39efa255(value) {
    return $29af573a5460390b$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $29af573a5460390b$export$a9c23c6ac3fc3eca(value) {
    var obj = $29af573a5460390b$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $29af573a5460390b$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $29af573a5460390b$export$4368d992c4eafac0.font;
    var size = $29af573a5460390b$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    var style = $29af573a5460390b$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($29af573a5460390b$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    var font = {
        family: $29af573a5460390b$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $29af573a5460390b$export$d29e374196577086($29af573a5460390b$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $29af573a5460390b$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $29af573a5460390b$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $29af573a5460390b$export$407448d2b89b1813(inputs, context, index, info) {
    var cacheable = true;
    var i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $29af573a5460390b$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $29af573a5460390b$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    var min = minmax.min, max = minmax.max;
    var change = $29af573a5460390b$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    var keepZero = function(value, add) {
        return beginAtZero && value === 0 ? 0 : value + add;
    };
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $29af573a5460390b$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $29af573a5460390b$export$a9c996f45e5784d0(scopes) {
    var prefixes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        ''
    ], rootScopes = arguments.length > 2 ? arguments[2] : void 0, fallback = arguments.length > 3 ? arguments[3] : void 0, getTarget = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
        return scopes[0];
    };
    var finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $29af573a5460390b$var$_resolve('_fallback', scopes);
    var _obj;
    var cache = (_obj = {}, (0, $6lD0P._)(_obj, Symbol.toStringTag, 'Object'), (0, $6lD0P._)(_obj, "_cacheable", true), (0, $6lD0P._)(_obj, "_scopes", scopes), (0, $6lD0P._)(_obj, "_rootScopes", finalRootScopes), (0, $6lD0P._)(_obj, "_fallback", fallback), (0, $6lD0P._)(_obj, "_getTarget", getTarget), (0, $6lD0P._)(_obj, "override", function(scope) {
        return $29af573a5460390b$export$a9c996f45e5784d0([
            scope
        ].concat((0, $kNmtb._)(scopes)), prefixes, finalRootScopes, fallback);
    }), _obj);
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty: function(target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get: function(target, prop) {
            return $29af573a5460390b$var$_cached(target, prop, function() {
                return $29af573a5460390b$var$_resolveWithPrefixes(prop, prefixes, scopes, target);
            });
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor: function(target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf: function() {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has: function(target, prop) {
            return $29af573a5460390b$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys: function(target) {
            return $29af573a5460390b$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set: function(target, prop, value) {
            var storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $29af573a5460390b$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    var cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $29af573a5460390b$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: function(ctx) {
            return $29af573a5460390b$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults);
        },
        override: function(scope) {
            return $29af573a5460390b$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults);
        }
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty: function(target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get: function(target, prop, receiver) {
            return $29af573a5460390b$var$_cached(target, prop, function() {
                return $29af573a5460390b$var$_resolveWithContext(target, prop, receiver);
            });
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor: function(target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf: function() {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has: function(target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys: function() {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set: function(target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $29af573a5460390b$export$7910e0436ed8d1de(proxy) {
    var defaults = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        scriptable: true,
        indexable: true
    };
    var _proxy__scriptable = proxy._scriptable, _scriptable = _proxy__scriptable === void 0 ? defaults.scriptable : _proxy__scriptable, _proxy__indexable = proxy._indexable, _indexable = _proxy__indexable === void 0 ? defaults.indexable : _proxy__indexable, _proxy__allKeys = proxy._allKeys, _allKeys = _proxy__allKeys === void 0 ? defaults.allKeys : _proxy__allKeys;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $29af573a5460390b$export$a93c5207d687da10(_scriptable) ? _scriptable : function() {
            return _scriptable;
        },
        isIndexable: $29af573a5460390b$export$a93c5207d687da10(_indexable) ? _indexable : function() {
            return _indexable;
        }
    };
}
var $29af573a5460390b$var$readKey = function(prefix, name) {
    return prefix ? prefix + $29af573a5460390b$export$a8550f7dbe79f93a(name) : name;
};
var $29af573a5460390b$var$needsSubResolver = function(prop, value) {
    return $29af573a5460390b$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
};
function $29af573a5460390b$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    var value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $29af573a5460390b$var$_resolveWithContext(target, prop, receiver) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, descriptors = target._descriptors;
    var value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($29af573a5460390b$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $29af573a5460390b$var$_resolveScriptable(prop, value, target, receiver);
    if ($29af573a5460390b$export$8b22cf2602fb60ce(value) && value.length) value = $29af573a5460390b$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($29af573a5460390b$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $29af573a5460390b$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $29af573a5460390b$var$_resolveScriptable(prop, getValue, target, receiver) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, _stack = target._stack;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    var value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($29af573a5460390b$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $29af573a5460390b$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $29af573a5460390b$var$_resolveArray(prop, value, target, isIndexable) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, descriptors = target._descriptors;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($29af573a5460390b$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        var arr = value;
        var scopes = _proxy._scopes.filter(function(s) {
            return s !== arr;
        });
        value = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var resolver = $29af573a5460390b$var$createSubResolver(scopes, _proxy, prop, item);
                value.push($29af573a5460390b$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return value;
}
function $29af573a5460390b$var$resolveFallback(fallback, prop, value) {
    return $29af573a5460390b$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
var $29af573a5460390b$var$getScope = function(key, parent) {
    return key === true ? parent : typeof key === 'string' ? $29af573a5460390b$export$2d1720544b23b823(parent, key) : undefined;
};
function $29af573a5460390b$var$addScopes(set, parentScopes, key, parentFallback, value) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parentScopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var parent = _step.value;
            var scope = $29af573a5460390b$var$getScope(key, parent);
            if (scope) {
                set.add(scope);
                var fallback = $29af573a5460390b$var$resolveFallback(scope._fallback, key, value);
                if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
                // The fallback will resume to that new scope.
                return fallback;
            } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
            // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
            return null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $29af573a5460390b$var$createSubResolver(parentScopes, resolver, prop, value) {
    var rootScopes = resolver._rootScopes;
    var fallback = $29af573a5460390b$var$resolveFallback(resolver._fallback, prop, value);
    var allScopes = (0, $kNmtb._)(parentScopes).concat((0, $kNmtb._)(rootScopes));
    var set = new Set();
    set.add(value);
    var key = $29af573a5460390b$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $29af573a5460390b$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $29af573a5460390b$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, function() {
        return $29af573a5460390b$var$subGetTarget(resolver, prop, value);
    });
}
function $29af573a5460390b$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $29af573a5460390b$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $29af573a5460390b$var$subGetTarget(resolver, prop, value) {
    var parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    var target = parent[prop];
    if ($29af573a5460390b$export$8b22cf2602fb60ce(target) && $29af573a5460390b$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $29af573a5460390b$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    var value;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prefix = _step.value;
            value = $29af573a5460390b$var$_resolve($29af573a5460390b$var$readKey(prefix, prop), scopes);
            if (typeof value !== 'undefined') return $29af573a5460390b$var$needsSubResolver(prop, value) ? $29af573a5460390b$var$createSubResolver(scopes, proxy, prop, value) : value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $29af573a5460390b$var$_resolve(key, scopes) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var scope = _step.value;
            if (!scope) continue;
            var value = scope[key];
            if (typeof value !== 'undefined') return value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $29af573a5460390b$var$getKeysFromAllScopes(target) {
    var keys = target._keys;
    if (!keys) keys = target._keys = $29af573a5460390b$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $29af573a5460390b$var$resolveKeysFromAllScopes(scopes) {
    var set = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = scopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var scope = _step.value;
            try {
                for(var _iterator1 = Object.keys(scope).filter(function(k) {
                    return !k.startsWith('_');
                })[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var key = _step1.value;
                    set.add(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return Array.from(set);
}
function $29af573a5460390b$export$4a5767248b18ef41(meta, data, start, count) {
    var iScale = meta.iScale;
    var _this__parsing = this._parsing, _this__parsing_key = _this__parsing.key, key = _this__parsing_key === void 0 ? 'r' : _this__parsing_key;
    var parsed = new Array(count);
    var i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($29af573a5460390b$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
var $29af573a5460390b$var$EPSILON = Number.EPSILON || 1e-14;
var $29af573a5460390b$var$getPoint = function(points, i) {
    return i < points.length && !points[i].skip && points[i];
};
var $29af573a5460390b$var$getValueAxis = function(indexAxis) {
    return indexAxis === 'x' ? 'y' : 'x';
};
function $29af573a5460390b$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    var previous = firstPoint.skip ? middlePoint : firstPoint;
    var current = middlePoint;
    var next = afterPoint.skip ? middlePoint : afterPoint;
    var d01 = $29af573a5460390b$export$cf2f7c5792f80b46(current, previous);
    var d12 = $29af573a5460390b$export$cf2f7c5792f80b46(next, current);
    var s01 = d01 / (d01 + d12);
    var s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    var fa = t * s01; // scaling factor for triangle Ta
    var fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $29af573a5460390b$var$monotoneAdjust(points, deltaK, mK) {
    var pointsLen = points.length;
    var alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    var pointAfter = $29af573a5460390b$var$getPoint(points, 0);
    for(var i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $29af573a5460390b$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($29af573a5460390b$export$23ebac1979863676(deltaK[i], 0, $29af573a5460390b$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $29af573a5460390b$var$monotoneCompute(points, mK) {
    var indexAxis = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'x';
    var valueAxis = $29af573a5460390b$var$getValueAxis(indexAxis);
    var pointsLen = points.length;
    var delta, pointBefore, pointCurrent;
    var pointAfter = $29af573a5460390b$var$getPoint(points, 0);
    for(var i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $29af573a5460390b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        var iPixel = pointCurrent[indexAxis];
        var vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent["cp1".concat(indexAxis)] = iPixel - delta;
            pointCurrent["cp1".concat(valueAxis)] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent["cp2".concat(indexAxis)] = iPixel + delta;
            pointCurrent["cp2".concat(valueAxis)] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $29af573a5460390b$export$a17c37559e1db147(points) {
    var indexAxis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'x';
    var valueAxis = $29af573a5460390b$var$getValueAxis(indexAxis);
    var pointsLen = points.length;
    var deltaK = Array(pointsLen).fill(0);
    var mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    var i, pointBefore, pointCurrent;
    var pointAfter = $29af573a5460390b$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $29af573a5460390b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            var slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $29af573a5460390b$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $29af573a5460390b$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $29af573a5460390b$var$monotoneAdjust(points, deltaK, mK);
    $29af573a5460390b$var$monotoneCompute(points, mK, indexAxis);
}
function $29af573a5460390b$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $29af573a5460390b$var$capBezierPoints(points, area) {
    var i, ilen, point, inArea, inAreaPrev;
    var inAreaNext = $29af573a5460390b$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $29af573a5460390b$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $29af573a5460390b$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $29af573a5460390b$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $29af573a5460390b$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $29af573a5460390b$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $29af573a5460390b$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    var i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter(function(pt) {
        return !pt.skip;
    });
    if (options.cubicInterpolationMode === 'monotone') $29af573a5460390b$export$a17c37559e1db147(points, indexAxis);
    else {
        var prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $29af573a5460390b$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $29af573a5460390b$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $29af573a5460390b$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $29af573a5460390b$export$9bb611d729802a56(domNode) {
    var parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $29af573a5460390b$var$parseMaxStyle(styleValue, node, parentProperty) {
    var valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
var $29af573a5460390b$var$getComputedStyle = function(element) {
    return element.ownerDocument.defaultView.getComputedStyle(element, null);
};
function $29af573a5460390b$export$fef3dfd9bad05307(el, property) {
    return $29af573a5460390b$var$getComputedStyle(el).getPropertyValue(property);
}
var $29af573a5460390b$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $29af573a5460390b$var$getPositionedStyle(styles, style, suffix) {
    var result = {};
    suffix = suffix ? '-' + suffix : '';
    for(var i = 0; i < 4; i++){
        var pos = $29af573a5460390b$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
var $29af573a5460390b$var$useOffsetPos = function(x, y, target) {
    return (x > 0 || y > 0) && (!target || !target.shadowRoot);
};
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $29af573a5460390b$var$getCanvasPosition(e, canvas) {
    var touches = e.touches;
    var source = touches && touches.length ? touches[0] : e;
    var offsetX = source.offsetX, offsetY = source.offsetY;
    var box = false;
    var x, y;
    if ($29af573a5460390b$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        var rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $29af573a5460390b$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    var canvas = chart.canvas, currentDevicePixelRatio = chart.currentDevicePixelRatio;
    var style = $29af573a5460390b$var$getComputedStyle(canvas);
    var borderBox = style.boxSizing === 'border-box';
    var paddings = $29af573a5460390b$var$getPositionedStyle(style, 'padding');
    var borders = $29af573a5460390b$var$getPositionedStyle(style, 'border', 'width');
    var _getCanvasPosition = $29af573a5460390b$var$getCanvasPosition(event, canvas), x = _getCanvasPosition.x, y = _getCanvasPosition.y, box = _getCanvasPosition.box;
    var xOffset = paddings.left + (box && borders.left);
    var yOffset = paddings.top + (box && borders.top);
    var width = chart.width, height = chart.height;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $29af573a5460390b$var$getContainerSize(canvas, width, height) {
    var maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        var container = canvas && $29af573a5460390b$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            var rect = container.getBoundingClientRect(); // this is the border box of the container
            var containerStyle = $29af573a5460390b$var$getComputedStyle(container);
            var containerBorder = $29af573a5460390b$var$getPositionedStyle(containerStyle, 'border', 'width');
            var containerPadding = $29af573a5460390b$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $29af573a5460390b$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $29af573a5460390b$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $29af573a5460390b$export$53c86fa97d611818,
        maxHeight: maxHeight || $29af573a5460390b$export$53c86fa97d611818
    };
}
var $29af573a5460390b$var$round1 = function(v) {
    return Math.round(v * 10) / 10;
};
// eslint-disable-next-line complexity
function $29af573a5460390b$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    var style = $29af573a5460390b$var$getComputedStyle(canvas);
    var margins = $29af573a5460390b$var$getPositionedStyle(style, 'margin');
    var maxWidth = $29af573a5460390b$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $29af573a5460390b$export$53c86fa97d611818;
    var maxHeight = $29af573a5460390b$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $29af573a5460390b$export$53c86fa97d611818;
    var containerSize = $29af573a5460390b$var$getContainerSize(canvas, bbWidth, bbHeight);
    var width = containerSize.width, height = containerSize.height;
    if (style.boxSizing === 'content-box') {
        var borders = $29af573a5460390b$var$getPositionedStyle(style, 'border', 'width');
        var paddings = $29af573a5460390b$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $29af573a5460390b$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $29af573a5460390b$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $29af573a5460390b$var$round1(width / 2);
    var maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $29af573a5460390b$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $29af573a5460390b$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    var pixelRatio = forceRatio || 1;
    var deviceHeight = $29af573a5460390b$var$round1(chart.height * pixelRatio);
    var deviceWidth = $29af573a5460390b$var$round1(chart.width * pixelRatio);
    chart.height = $29af573a5460390b$var$round1(chart.height);
    chart.width = $29af573a5460390b$var$round1(chart.width);
    var canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = "".concat(chart.height, "px");
        canvas.style.width = "".concat(chart.width, "px");
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var $29af573a5460390b$export$3466f893ebf79586 = function() {
    var passiveSupported = false;
    try {
        var options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($29af573a5460390b$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $29af573a5460390b$export$b4171a6734a65d42(element, property) {
    var value = $29af573a5460390b$export$fef3dfd9bad05307(element, property);
    var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $29af573a5460390b$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $29af573a5460390b$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $29af573a5460390b$export$d24c54395ce0c509(p1, p2, t, mode) {
    var cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    var cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    var a = $29af573a5460390b$export$6554612db691658e(p1, cp1, t);
    var b = $29af573a5460390b$export$6554612db691658e(cp1, cp2, t);
    var c = $29af573a5460390b$export$6554612db691658e(cp2, p2, t);
    var d = $29af573a5460390b$export$6554612db691658e(a, b, t);
    var e = $29af573a5460390b$export$6554612db691658e(b, c, t);
    return $29af573a5460390b$export$6554612db691658e(d, e, t);
}
var $29af573a5460390b$var$getRightToLeftAdapter = function getRightToLeftAdapter(rectX, width) {
    return {
        x: function(x) {
            return rectX + rectX + width - x;
        },
        setWidth: function(w) {
            width = w;
        },
        textAlign: function(align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus: function(x, value) {
            return x - value;
        },
        leftForLtr: function(x, itemWidth) {
            return x - itemWidth;
        }
    };
};
var $29af573a5460390b$var$getLeftToRightAdapter = function getLeftToRightAdapter() {
    return {
        x: function(x) {
            return x;
        },
        setWidth: function(w) {},
        textAlign: function(align) {
            return align;
        },
        xPlus: function(x, value) {
            return x + value;
        },
        leftForLtr: function(x, _itemWidth) {
            return x;
        }
    };
};
function $29af573a5460390b$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $29af573a5460390b$var$getRightToLeftAdapter(rectX, width) : $29af573a5460390b$var$getLeftToRightAdapter();
}
function $29af573a5460390b$export$9d398bebfec1c039(ctx, direction) {
    var style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $29af573a5460390b$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $29af573a5460390b$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $29af573a5460390b$export$ffb5f4729a158638,
        compare: $29af573a5460390b$export$f074adc9fbd50943,
        normalize: $29af573a5460390b$export$ab83b03e4111b1d0
    };
    return {
        between: $29af573a5460390b$export$21579262ef46735b,
        compare: function(a, b) {
            return a - b;
        },
        normalize: function(x) {
            return x;
        }
    };
}
function $29af573a5460390b$var$normalizeSegment(param) {
    var start = param.start, end = param.end, count = param.count, loop = param.loop, style = param.style;
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $29af573a5460390b$var$getSegment(segment, points, bounds) {
    var property = bounds.property, startBound = bounds.start, endBound = bounds.end;
    var _propertyFn = $29af573a5460390b$var$propertyFn(property), between = _propertyFn.between, normalize = _propertyFn.normalize;
    var count = points.length;
    var start = segment.start, end = segment.end, loop = segment.loop;
    var i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $29af573a5460390b$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    var property = bounds.property, startBound = bounds.start, endBound = bounds.end;
    var count = points.length;
    var _propertyFn = $29af573a5460390b$var$propertyFn(property), compare = _propertyFn.compare, between = _propertyFn.between, normalize = _propertyFn.normalize;
    var _getSegment = $29af573a5460390b$var$getSegment(segment, points, bounds), start = _getSegment.start, end = _getSegment.end, loop = _getSegment.loop, style = _getSegment.style;
    var result = [];
    var inside = false;
    var subStart = null;
    var value, point, prevValue;
    var startIsBefore = function() {
        return between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    };
    var endIsBefore = function() {
        return compare(endBound, value) === 0 || between(endBound, prevValue, value);
    };
    var shouldStart = function() {
        return inside || startIsBefore();
    };
    var shouldStop = function() {
        return !inside || endIsBefore();
    };
    for(var i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($29af573a5460390b$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($29af573a5460390b$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $29af573a5460390b$export$2f6ca3d3b1f80bf5(line, bounds) {
    var result = [];
    var segments = line.segments;
    for(var i = 0; i < segments.length; i++){
        var _result;
        var sub = $29af573a5460390b$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) (_result = result).push.apply(_result, (0, $kNmtb._)(sub));
    }
    return result;
}
function $29af573a5460390b$var$findStartAndEnd(points, count, loop, spanGaps) {
    var start = 0;
    var end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $29af573a5460390b$var$solidSegments(points, start, max, loop) {
    var count = points.length;
    var result = [];
    var last = start;
    var prev = points[start];
    var end;
    for(end = start + 1; end <= max; ++end){
        var cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $29af573a5460390b$export$7a38258bbe170828(line, segmentOptions) {
    var points = line.points;
    var spanGaps = line.options.spanGaps;
    var count = points.length;
    if (!count) return [];
    var loop = !!line._loop;
    var _findStartAndEnd = $29af573a5460390b$var$findStartAndEnd(points, count, loop, spanGaps), start = _findStartAndEnd.start, end = _findStartAndEnd.end;
    if (spanGaps === true) return $29af573a5460390b$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    var max = end < start ? end + count : end;
    var completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $29af573a5460390b$var$splitByStyles(line, $29af573a5460390b$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $29af573a5460390b$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $29af573a5460390b$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $29af573a5460390b$var$doSplitByStyles(line, segments, points, segmentOptions) {
    var chartContext = line._chart.getContext();
    var baseStyle = $29af573a5460390b$var$readStyle(line.options);
    var datasetIndex = line._datasetIndex, spanGaps = line.options.spanGaps;
    var count = points.length;
    var result = [];
    var prevStyle = baseStyle;
    var start = segments[0].start;
    var i = start;
    function addStyle(s, e, l, st) {
        var dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            start = spanGaps ? start : segment.start;
            var prev = points[start % count];
            var style = void 0;
            for(i = start + 1; i <= segment.end; i++){
                var pt = points[i % count];
                style = $29af573a5460390b$var$readStyle(segmentOptions.setContext($29af573a5460390b$export$35e795649ee09318(chartContext, {
                    type: 'segment',
                    p0: prev,
                    p1: pt,
                    p0DataIndex: (i - 1) % count,
                    p1DataIndex: i % count,
                    datasetIndex: datasetIndex
                })));
                if ($29af573a5460390b$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
                prev = pt;
                prevStyle = style;
            }
            if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $29af573a5460390b$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $29af573a5460390b$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    var cache = [];
    var replacer = function replacer(key, value) {
        if (!$29af573a5460390b$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $29af573a5460390b$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $29af573a5460390b$var$getDatasetArea(meta, chartArea) {
    var xScale = meta.xScale, yScale = meta.yScale;
    if (xScale && yScale) return {
        left: $29af573a5460390b$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $29af573a5460390b$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $29af573a5460390b$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $29af573a5460390b$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $29af573a5460390b$export$995eb9fca571757(chart, meta) {
    var clip = meta._clip;
    if (clip.disabled) return false;
    var area = $29af573a5460390b$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}

});
parcelRegister("6Xptx", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return $510c03abb27e9c51$export$892596cec99bc70e; });
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ 
var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $ewv1T = parcelRequire("ewv1T");
function $510c03abb27e9c51$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
var $510c03abb27e9c51$export$837ba5c449269406 = function(v, l, h) {
    return Math.max(Math.min(v, h), l);
};
function $510c03abb27e9c51$export$bcc6e673dfa14d36(v) {
    return $510c03abb27e9c51$export$837ba5c449269406($510c03abb27e9c51$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $510c03abb27e9c51$export$869b26d4e1bbdb63(v) {
    return $510c03abb27e9c51$export$837ba5c449269406($510c03abb27e9c51$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $510c03abb27e9c51$export$ed9bd8dcaeba14f6(v) {
    return $510c03abb27e9c51$export$837ba5c449269406($510c03abb27e9c51$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $510c03abb27e9c51$export$dbf961a8d278dbef(v) {
    return $510c03abb27e9c51$export$837ba5c449269406($510c03abb27e9c51$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $510c03abb27e9c51$export$aa35ef1f24408ab9(v) {
    return $510c03abb27e9c51$export$837ba5c449269406($510c03abb27e9c51$export$2077e0241d6afd3c(v * 100), 0, 100);
}
var $510c03abb27e9c51$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
var $510c03abb27e9c51$var$hex = Array.from('0123456789ABCDEF');
var $510c03abb27e9c51$var$h1 = function(b) {
    return $510c03abb27e9c51$var$hex[b & 0xF];
};
var $510c03abb27e9c51$var$h2 = function(b) {
    return $510c03abb27e9c51$var$hex[(b & 0xF0) >> 4] + $510c03abb27e9c51$var$hex[b & 0xF];
};
var $510c03abb27e9c51$var$eq = function(b) {
    return (b & 0xF0) >> 4 === (b & 0xF);
};
var $510c03abb27e9c51$var$isShort = function(v) {
    return $510c03abb27e9c51$var$eq(v.r) && $510c03abb27e9c51$var$eq(v.g) && $510c03abb27e9c51$var$eq(v.b) && $510c03abb27e9c51$var$eq(v.a);
};
function $510c03abb27e9c51$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $510c03abb27e9c51$var$map$1[str[1]] * 17,
            g: 255 & $510c03abb27e9c51$var$map$1[str[2]] * 17,
            b: 255 & $510c03abb27e9c51$var$map$1[str[3]] * 17,
            a: len === 5 ? $510c03abb27e9c51$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $510c03abb27e9c51$var$map$1[str[1]] << 4 | $510c03abb27e9c51$var$map$1[str[2]],
            g: $510c03abb27e9c51$var$map$1[str[3]] << 4 | $510c03abb27e9c51$var$map$1[str[4]],
            b: $510c03abb27e9c51$var$map$1[str[5]] << 4 | $510c03abb27e9c51$var$map$1[str[6]],
            a: len === 9 ? $510c03abb27e9c51$var$map$1[str[7]] << 4 | $510c03abb27e9c51$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
var $510c03abb27e9c51$var$alpha = function(a, f) {
    return a < 255 ? f(a) : '';
};
function $510c03abb27e9c51$export$1b06654353ef9f67(v) {
    var f = $510c03abb27e9c51$var$isShort(v) ? $510c03abb27e9c51$var$h1 : $510c03abb27e9c51$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $510c03abb27e9c51$var$alpha(v.a, f) : undefined;
}
var $510c03abb27e9c51$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $510c03abb27e9c51$var$hsl2rgbn(h, s, l) {
    var a = s * Math.min(l, 1 - l);
    var f = function(n) {
        var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $510c03abb27e9c51$var$hsv2rgbn(h, s, v) {
    var f = function(n) {
        var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 60) % 6;
        return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    };
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $510c03abb27e9c51$var$hwb2rgbn(h, w, b) {
    var rgb = $510c03abb27e9c51$var$hsl2rgbn(h, 1, 0.5);
    var i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $510c03abb27e9c51$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $510c03abb27e9c51$export$b5ba70b240f8f7f(v) {
    var range = 255;
    var r = v.r / range;
    var g = v.g / range;
    var b = v.b / range;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var l = (max + min) / 2;
    var h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $510c03abb27e9c51$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $510c03abb27e9c51$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($510c03abb27e9c51$export$ed9bd8dcaeba14f6);
}
function $510c03abb27e9c51$export$4c15bd42559b811d(h, s, l) {
    return $510c03abb27e9c51$var$calln($510c03abb27e9c51$var$hsl2rgbn, h, s, l);
}
function $510c03abb27e9c51$export$e2710022c70fc9ee(h, w, b) {
    return $510c03abb27e9c51$var$calln($510c03abb27e9c51$var$hwb2rgbn, h, w, b);
}
function $510c03abb27e9c51$export$b785a357c84e4a04(h, s, v) {
    return $510c03abb27e9c51$var$calln($510c03abb27e9c51$var$hsv2rgbn, h, s, v);
}
function $510c03abb27e9c51$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $510c03abb27e9c51$export$5e91288c399be4f9(str) {
    var m = $510c03abb27e9c51$var$HUE_RE.exec(str);
    var a = 255;
    var v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $510c03abb27e9c51$export$bcc6e673dfa14d36(+m[5]) : $510c03abb27e9c51$export$ed9bd8dcaeba14f6(+m[5]);
    var h = $510c03abb27e9c51$var$hue(+m[2]);
    var p1 = +m[3] / 100;
    var p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $510c03abb27e9c51$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $510c03abb27e9c51$export$b785a357c84e4a04(h, p1, p2);
    else v = $510c03abb27e9c51$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $510c03abb27e9c51$export$bb628a54ab399bc9(v, deg) {
    var h = $510c03abb27e9c51$export$b5ba70b240f8f7f(v);
    h[0] = $510c03abb27e9c51$var$hue(h[0] + deg);
    h = $510c03abb27e9c51$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $510c03abb27e9c51$export$a197af1c58e6260c(v) {
    if (!v) return;
    var a = $510c03abb27e9c51$export$b5ba70b240f8f7f(v);
    var h = a[0];
    var s = $510c03abb27e9c51$export$aa35ef1f24408ab9(a[1]);
    var l = $510c03abb27e9c51$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat($510c03abb27e9c51$export$dbf961a8d278dbef(v.a), ")") : "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
}
var $510c03abb27e9c51$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
var $510c03abb27e9c51$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $510c03abb27e9c51$var$unpack() {
    var unpacked = {};
    var keys = Object.keys($510c03abb27e9c51$var$names$1);
    var tkeys = Object.keys($510c03abb27e9c51$var$map);
    var i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $510c03abb27e9c51$var$map[k]);
        }
        k = parseInt($510c03abb27e9c51$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
var $510c03abb27e9c51$var$names;
function $510c03abb27e9c51$export$b2f06b640faad956(str) {
    if (!$510c03abb27e9c51$var$names) {
        $510c03abb27e9c51$var$names = $510c03abb27e9c51$var$unpack();
        $510c03abb27e9c51$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    var a = $510c03abb27e9c51$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
var $510c03abb27e9c51$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $510c03abb27e9c51$export$91aedb20f296e541(str) {
    var m = $510c03abb27e9c51$var$RGB_RE.exec(str);
    var a = 255;
    var r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        var v = +m[7];
        a = m[8] ? $510c03abb27e9c51$export$bcc6e673dfa14d36(v) : $510c03abb27e9c51$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $510c03abb27e9c51$export$bcc6e673dfa14d36(r) : $510c03abb27e9c51$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $510c03abb27e9c51$export$bcc6e673dfa14d36(g) : $510c03abb27e9c51$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $510c03abb27e9c51$export$bcc6e673dfa14d36(b) : $510c03abb27e9c51$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $510c03abb27e9c51$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? "rgba(".concat(v.r, ", ").concat(v.g, ", ").concat(v.b, ", ").concat($510c03abb27e9c51$export$dbf961a8d278dbef(v.a), ")") : "rgb(".concat(v.r, ", ").concat(v.g, ", ").concat(v.b, ")"));
}
var $510c03abb27e9c51$var$to = function(v) {
    return v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
};
var $510c03abb27e9c51$var$from = function(v) {
    return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
};
function $510c03abb27e9c51$var$interpolate(rgb1, rgb2, t) {
    var r = $510c03abb27e9c51$var$from($510c03abb27e9c51$export$dbf961a8d278dbef(rgb1.r));
    var g = $510c03abb27e9c51$var$from($510c03abb27e9c51$export$dbf961a8d278dbef(rgb1.g));
    var b = $510c03abb27e9c51$var$from($510c03abb27e9c51$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $510c03abb27e9c51$export$ed9bd8dcaeba14f6($510c03abb27e9c51$var$to(r + t * ($510c03abb27e9c51$var$from($510c03abb27e9c51$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $510c03abb27e9c51$export$ed9bd8dcaeba14f6($510c03abb27e9c51$var$to(g + t * ($510c03abb27e9c51$var$from($510c03abb27e9c51$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $510c03abb27e9c51$export$ed9bd8dcaeba14f6($510c03abb27e9c51$var$to(b + t * ($510c03abb27e9c51$var$from($510c03abb27e9c51$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $510c03abb27e9c51$var$modHSL(v, i, ratio) {
    if (v) {
        var tmp = $510c03abb27e9c51$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $510c03abb27e9c51$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $510c03abb27e9c51$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $510c03abb27e9c51$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $510c03abb27e9c51$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $510c03abb27e9c51$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $510c03abb27e9c51$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $510c03abb27e9c51$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $510c03abb27e9c51$export$91aedb20f296e541(str);
    return $510c03abb27e9c51$export$5e91288c399be4f9(str);
}
var $510c03abb27e9c51$export$892596cec99bc70e = /*#__PURE__*/ function() {
    "use strict";
    function Color(input) {
        (0, $ioD88._)(this, Color);
        if (input instanceof Color) return input;
        var type = typeof input === "undefined" ? "undefined" : (0, $ewv1T._)(input);
        var v;
        if (type === 'object') v = $510c03abb27e9c51$var$fromObject(input);
        else if (type === 'string') v = $510c03abb27e9c51$export$625a38b961e8b5e9(input) || $510c03abb27e9c51$export$b2f06b640faad956(input) || $510c03abb27e9c51$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    (0, $6NCFa._)(Color, [
        {
            key: "valid",
            get: function get() {
                return this._valid;
            }
        },
        {
            key: "rgb",
            get: function get() {
                var v = $510c03abb27e9c51$var$clone(this._rgb);
                if (v) v.a = $510c03abb27e9c51$export$dbf961a8d278dbef(v.a);
                return v;
            },
            set: function set(obj) {
                this._rgb = $510c03abb27e9c51$var$fromObject(obj);
            }
        },
        {
            key: "rgbString",
            value: function rgbString1() {
                return this._valid ? $510c03abb27e9c51$export$9595423f22cf925a(this._rgb) : undefined;
            }
        },
        {
            key: "hexString",
            value: function hexString1() {
                return this._valid ? $510c03abb27e9c51$export$1b06654353ef9f67(this._rgb) : undefined;
            }
        },
        {
            key: "hslString",
            value: function hslString1() {
                return this._valid ? $510c03abb27e9c51$export$a197af1c58e6260c(this._rgb) : undefined;
            }
        },
        {
            key: "mix",
            value: function mix(color, weight) {
                if (color) {
                    var c1 = this.rgb;
                    var c2 = color.rgb;
                    var w2;
                    var p = weight === w2 ? 0.5 : weight;
                    var w = 2 * p - 1;
                    var a = c1.a - c2.a;
                    var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
                    w2 = 1 - w1;
                    c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
                    c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
                    c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
                    c1.a = p * c1.a + (1 - p) * c2.a;
                    this.rgb = c1;
                }
                return this;
            }
        },
        {
            key: "interpolate",
            value: function interpolate1(color, t) {
                if (color) this._rgb = $510c03abb27e9c51$var$interpolate(this._rgb, color._rgb, t);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new Color(this.rgb);
            }
        },
        {
            key: "alpha",
            value: function alpha(a) {
                this._rgb.a = $510c03abb27e9c51$export$ed9bd8dcaeba14f6(a);
                return this;
            }
        },
        {
            key: "clearer",
            value: function clearer(ratio) {
                var rgb = this._rgb;
                rgb.a *= 1 - ratio;
                return this;
            }
        },
        {
            key: "greyscale",
            value: function greyscale() {
                var rgb = this._rgb;
                var val = $510c03abb27e9c51$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
                rgb.r = rgb.g = rgb.b = val;
                return this;
            }
        },
        {
            key: "opaquer",
            value: function opaquer(ratio) {
                var rgb = this._rgb;
                rgb.a *= 1 + ratio;
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                var v = this._rgb;
                v.r = 255 - v.r;
                v.g = 255 - v.g;
                v.b = 255 - v.b;
                return this;
            }
        },
        {
            key: "lighten",
            value: function lighten(ratio) {
                $510c03abb27e9c51$var$modHSL(this._rgb, 2, ratio);
                return this;
            }
        },
        {
            key: "darken",
            value: function darken(ratio) {
                $510c03abb27e9c51$var$modHSL(this._rgb, 2, -ratio);
                return this;
            }
        },
        {
            key: "saturate",
            value: function saturate(ratio) {
                $510c03abb27e9c51$var$modHSL(this._rgb, 1, ratio);
                return this;
            }
        },
        {
            key: "desaturate",
            value: function desaturate(ratio) {
                $510c03abb27e9c51$var$modHSL(this._rgb, 1, -ratio);
                return this;
            }
        },
        {
            key: "rotate",
            value: function rotate1(deg) {
                $510c03abb27e9c51$export$bb628a54ab399bc9(this._rgb, deg);
                return this;
            }
        }
    ]);
    return Color;
}();
function $510c03abb27e9c51$export$2e2bcd8739ae039(input) {
    return new $510c03abb27e9c51$export$892596cec99bc70e(input);
}

});




var $8lZHN = parcelRequire("8lZHN");

var $kNmtb = parcelRequire("kNmtb");











var $jgg5e = parcelRequire("jgg5e");
var $f64da8404daade49$exports = {};

var $ewv1T = parcelRequire("ewv1T");
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if ((0, $ewv1T._)($f64da8404daade49$exports) === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $f64da8404daade49$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function flat(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return (typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        even: function even() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function odd() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if ((typeof target === "undefined" ? "undefined" : (0, $ewv1T._)(target)) !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function globalEval(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function text(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function isXMLDoc(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function funescape(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function apply(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function call(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function ATTR(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function CHILD(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function PSEUDO(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function TAG(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function CLASS(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function ATTR(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function CHILD(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function PSEUDO(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function target(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function root(elem) {
                    return elem === documentElement;
                },
                focus: function focus(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function checked(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function selected(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function empty(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function parent(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function header(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function input(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function button(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function text(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, _$find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (_$find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = _$find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function dir(elem, _dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[_dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                ((typeof returned === "undefined" ? "undefined" : (0, $ewv1T._)(returned)) === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, _data) {
            return dataUser.access(elem, name, _data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if ((typeof key === "undefined" ? "undefined" : (0, $ewv1T._)(key)) === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if ((typeof types === "undefined" ? "undefined" : (0, $ewv1T._)(types)) === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, _handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = _handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = _handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < _handlers.length) handlerQueue.push({
                elem: cur,
                handlers: _handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function setup(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function trigger(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function _default(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function handler(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function setup() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function trigger() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function teardown() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function _default(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function setup() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if ((typeof types === "undefined" ? "undefined" : (0, $ewv1T._)(types)) === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html;
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function pixelBoxStyles() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function scrollboxSize() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function reliableTrDimensions() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value);
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function init(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function cur() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function run(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function get(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function set(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function set(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function linear(p) {
            return p;
        },
        swing: function swing(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function tick() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function createTween(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function stop(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function tweener(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function prefilter(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && (typeof speed === "undefined" ? "undefined" : (0, $ewv1T._)(speed)) === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function fadeTo(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function animate(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function doAnimation() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function stop(type, clearQueue, gotoEnd) {
            var stopQueue = function stopQueue(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function finish(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function removeClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var classNames, className, i, self, type = typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value), isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : (0, $ewv1T._)(event)) === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : (0, $ewv1T._)(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function ajax(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if ((typeof url === "undefined" ? "undefined" : (0, $ewv1T._)(url)) === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            _$completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (_$completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return _$completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (_$completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (_$completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function statusCode1(map) {
                    var code;
                    if (map) {
                        if (_$completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function abort(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (_$completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || _$completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (_$completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    _$completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (_$completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (_$completed) return;
                _$completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function dataFilter(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function send(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function abort() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function send(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function abort() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && (typeof params === "undefined" ? "undefined" : (0, $ewv1T._)(params)) === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function hover(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function proxy() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});



var $ewv1T = parcelRequire("ewv1T");

var $9dfdb671d882e02b$exports = {};

var $ewv1T = parcelRequire("ewv1T");
/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else $9dfdb671d882e02b$exports = factory();
})(undefined, function() {
    'use strict';
    var PhotoSwipe = function PhotoSwipe(template, UiClass, items, options) {
        /*>>framework-bridge*/ /**
 *
 * Set of generic functions used by gallery.
 * 
 * You're free to modify anything here as long as functionality is kept.
 * 
 */ var framework = {
            features: null,
            bind: function bind(target, type, listener, unbind) {
                var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
                type = type.split(' ');
                for(var i = 0; i < type.length; i++)if (type[i]) target[methodName](type[i], listener, false);
            },
            isArray: function isArray(obj) {
                return obj instanceof Array;
            },
            createEl: function createEl(classes, tag) {
                var el = document.createElement(tag || 'div');
                if (classes) el.className = classes;
                return el;
            },
            getScrollY: function getScrollY() {
                var yOffset = window.pageYOffset;
                return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
            },
            unbind: function unbind(target, type, listener) {
                framework.bind(target, type, listener, true);
            },
            removeClass: function removeClass(el, className) {
                var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
            },
            addClass: function addClass(el, className) {
                if (!framework.hasClass(el, className)) el.className += (el.className ? ' ' : '') + className;
            },
            hasClass: function hasClass(el, className) {
                return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
            },
            getChildByClass: function getChildByClass(parentEl, childClassName) {
                var node = parentEl.firstChild;
                while(node){
                    if (framework.hasClass(node, childClassName)) return node;
                    node = node.nextSibling;
                }
            },
            arraySearch: function arraySearch(array, value, key) {
                var i = array.length;
                while(i--){
                    if (array[i][key] === value) return i;
                }
                return -1;
            },
            extend: function extend(o1, o2, preventOverwrite) {
                for(var prop in o2)if (o2.hasOwnProperty(prop)) {
                    if (preventOverwrite && o1.hasOwnProperty(prop)) continue;
                    o1[prop] = o2[prop];
                }
            },
            easing: {
                sine: {
                    out: function out(k) {
                        return Math.sin(k * (Math.PI / 2));
                    },
                    inOut: function inOut(k) {
                        return -(Math.cos(Math.PI * k) - 1) / 2;
                    }
                },
                cubic: {
                    out: function out(k) {
                        return --k * k * k + 1;
                    }
                }
            },
            /**
	 * 
	 * @return {object}
	 * 
	 * {
	 *  raf : request animation frame function
	 *  caf : cancel animation frame function
	 *  transfrom : transform property key (with vendor), or null if not supported
	 *  oldIE : IE8 or below
	 * }
	 * 
	 */ detectFeatures: function detectFeatures() {
                if (framework.features) return framework.features;
                var helperEl = framework.createEl(), helperStyle = helperEl.style, vendor = '', features = {};
                // IE8 and below
                features.oldIE = document.all && !document.addEventListener;
                features.touch = 'ontouchstart' in window;
                if (window.requestAnimationFrame) {
                    features.raf = window.requestAnimationFrame;
                    features.caf = window.cancelAnimationFrame;
                }
                features.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled;
                // fix false-positive detection of old Android in new IE
                // (IE11 ua string contains "Android 4.0")
                if (!features.pointerEvent) {
                    var ua = navigator.userAgent;
                    // Detect if device is iPhone or iPod and if it's older than iOS 8
                    // http://stackoverflow.com/a/14223920
                    // 
                    // This detection is made because of buggy top/bottom toolbars
                    // that don't trigger window.resize event.
                    // For more info refer to _isFixedPosition variable in core.js
                    if (/iP(hone|od)/.test(navigator.platform)) {
                        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        if (v && v.length > 0) {
                            v = parseInt(v[1], 10);
                            if (v >= 1 && v < 8) features.isOldIOSPhone = true;
                        }
                    }
                    // Detect old Android (before KitKat)
                    // due to bugs related to position:fixed
                    // http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
                    var match = ua.match(/Android\s([0-9\.]*)/);
                    var androidversion = match ? match[1] : 0;
                    androidversion = parseFloat(androidversion);
                    if (androidversion >= 1) {
                        if (androidversion < 4.4) features.isOldAndroid = true; // for fixed position bug & performance
                        features.androidVersion = androidversion; // for touchend bug
                    }
                    features.isMobileOpera = /opera mini|opera mobi/i.test(ua);
                // p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
                }
                var styleChecks = [
                    'transform',
                    'perspective',
                    'animationName'
                ], vendors = [
                    '',
                    'webkit',
                    'Moz',
                    'ms',
                    'O'
                ], styleCheckItem, styleName;
                for(var i = 0; i < 4; i++){
                    vendor = vendors[i];
                    for(var a = 0; a < 3; a++){
                        styleCheckItem = styleChecks[a];
                        // uppercase first letter of property name, if vendor is present
                        styleName = vendor + (vendor ? styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : styleCheckItem);
                        if (!features[styleCheckItem] && styleName in helperStyle) features[styleCheckItem] = styleName;
                    }
                    if (vendor && !features.raf) {
                        vendor = vendor.toLowerCase();
                        features.raf = window[vendor + 'RequestAnimationFrame'];
                        if (features.raf) features.caf = window[vendor + 'CancelAnimationFrame'] || window[vendor + 'CancelRequestAnimationFrame'];
                    }
                }
                if (!features.raf) {
                    var lastTime = 0;
                    features.raf = function(fn) {
                        var currTime = new Date().getTime();
                        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                        var id = window.setTimeout(function() {
                            fn(currTime + timeToCall);
                        }, timeToCall);
                        lastTime = currTime + timeToCall;
                        return id;
                    };
                    features.caf = function(id) {
                        clearTimeout(id);
                    };
                }
                // Detect SVG support
                features.svg = !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
                framework.features = features;
                return features;
            }
        };
        framework.detectFeatures();
        // Override addEventListener for old versions of IE
        if (framework.features.oldIE) framework.bind = function(target, type, listener, unbind) {
            type = type.split(' ');
            var methodName = (unbind ? 'detach' : 'attach') + 'Event', evName, _handleEv = function _handleEv() {
                listener.handleEvent.call(listener);
            };
            for(var i = 0; i < type.length; i++){
                evName = type[i];
                if (evName) {
                    if ((typeof listener === "undefined" ? "undefined" : (0, $ewv1T._)(listener)) === 'object' && listener.handleEvent) {
                        if (!unbind) listener['oldIE' + evName] = _handleEv;
                        else {
                            if (!listener['oldIE' + evName]) return false;
                        }
                        target[methodName]('on' + evName, listener['oldIE' + evName]);
                    } else target[methodName]('on' + evName, listener);
                }
            }
        };
        /*>>framework-bridge*/ /*>>core*/ //function(template, UiClass, items, options)
        var self = this;
        /**
 * Static vars, don't change unless you know what you're doing.
 */ var DOUBLE_TAP_RADIUS = 25, NUM_HOLDERS = 3;
        /**
 * Options
 */ var _options = {
            allowPanToNext: true,
            spacing: 0.12,
            bgOpacity: 1,
            mouseUsed: false,
            loop: true,
            pinchToClose: true,
            closeOnScroll: true,
            closeOnVerticalDrag: true,
            verticalDragRange: 0.75,
            hideAnimationDuration: 333,
            showAnimationDuration: 333,
            showHideOpacity: false,
            focus: true,
            escKey: true,
            arrowKeys: true,
            mainScrollEndFriction: 0.35,
            panEndFriction: 0.35,
            isClickableElement: function isClickableElement(el) {
                return el.tagName === 'A';
            },
            getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
                if (isMouseClick) return 1;
                else return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            },
            maxSpreadZoom: 1.33,
            modal: true,
            // not fully implemented yet
            scaleMode: 'fit' // TODO
        };
        framework.extend(_options, options);
        /**
 * Private helper variables & functions
 */ var _getEmptyPoint = function _getEmptyPoint() {
            return {
                x: 0,
                y: 0
            };
        };
        var _isOpen, _isDestroying, _closedByScroll, _currentItemIndex, _containerStyle, _containerShiftIndex, _currPanDist = _getEmptyPoint(), _startPanOffset = _getEmptyPoint(), _panOffset = _getEmptyPoint(), _upMoveEvents, _downEvents, _globalEventHandlers, _viewportSize = {}, _currZoomLevel, _startZoomLevel, _translatePrefix, _translateSufix, _updateSizeInterval, _itemsNeedUpdate, _currPositionIndex = 0, _offset = {}, _slideSize = _getEmptyPoint(), _itemHolders, _prevItemIndex, _indexDiff = 0, _dragStartEvent, _dragMoveEvent, _dragEndEvent, _dragCancelEvent, _transformKey, _pointerEventEnabled, _isFixedPosition = true, _likelyTouchDevice, _modules = [], _requestAF, _cancelAF, _initalClassName, _initalWindowScrollY, _oldIE, _currentWindowScrollY, _features, _windowVisibleSize = {}, _renderMaxResolution = false, _orientationChangeTimeout, // Registers PhotoSWipe module (History, Controller ...)
        _registerModule = function _registerModule(name, module1) {
            framework.extend(self, module1.publicMethods);
            _modules.push(name);
        }, _getLoopedId = function _getLoopedId(index) {
            var numSlides = _getNumItems();
            if (index > numSlides - 1) return index - numSlides;
            else if (index < 0) return numSlides + index;
            return index;
        }, // Micro bind/trigger
        _listeners = {}, _listen = function _listen(name, fn) {
            if (!_listeners[name]) _listeners[name] = [];
            return _listeners[name].push(fn);
        }, _shout = function _shout(name) {
            var listeners = _listeners[name];
            if (listeners) {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                for(var i = 0; i < listeners.length; i++)listeners[i].apply(self, args);
            }
        }, _getCurrentTime = function _getCurrentTime() {
            return new Date().getTime();
        }, _applyBgOpacity = function _applyBgOpacity(opacity) {
            _bgOpacity = opacity;
            self.bg.style.opacity = opacity * _options.bgOpacity;
        }, _applyZoomTransform = function _applyZoomTransform(styleObj, x, y, zoom, item) {
            if (!_renderMaxResolution || item && item !== self.currItem) zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
            styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
        }, _applyCurrentZoomPan = function _applyCurrentZoomPan(allowRenderResolution) {
            if (_currZoomElementStyle) {
                if (allowRenderResolution) {
                    if (_currZoomLevel > self.currItem.fitRatio) {
                        if (!_renderMaxResolution) {
                            _setImageSize(self.currItem, false, true);
                            _renderMaxResolution = true;
                        }
                    } else if (_renderMaxResolution) {
                        _setImageSize(self.currItem);
                        _renderMaxResolution = false;
                    }
                }
                _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
            }
        }, _applyZoomPanToItem = function _applyZoomPanToItem(item) {
            if (item.container) _applyZoomTransform(item.container.style, item.initialPosition.x, item.initialPosition.y, item.initialZoomLevel, item);
        }, _setTranslateX = function _setTranslateX(x, elStyle) {
            elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
        }, _moveMainScroll = function _moveMainScroll(x, dragging) {
            if (!_options.loop && dragging) {
                var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x, delta = Math.round(x - _mainScrollPos.x);
                if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
            }
            _mainScrollPos.x = x;
            _setTranslateX(x, _containerStyle);
        }, _calculatePanOffset = function _calculatePanOffset(axis, zoomLevel) {
            var m = _midZoomPoint[axis] - _offset[axis];
            return _startPanOffset[axis] + _currPanDist[axis] + m - m * (zoomLevel / _startZoomLevel);
        }, _equalizePoints = function _equalizePoints(p1, p2) {
            p1.x = p2.x;
            p1.y = p2.y;
            if (p2.id) p1.id = p2.id;
        }, _roundPoint = function _roundPoint(p) {
            p.x = Math.round(p.x);
            p.y = Math.round(p.y);
        }, _mouseMoveTimeout = null, _onFirstMouseMove = function _onFirstMouseMove1() {
            // Wait until mouse move event is fired at least twice during 100ms
            // We do this, because some mobile browsers trigger it on touchstart
            if (_mouseMoveTimeout) {
                framework.unbind(document, 'mousemove', _onFirstMouseMove);
                framework.addClass(template, 'pswp--has_mouse');
                _options.mouseUsed = true;
                _shout('mouseUsed');
            }
            _mouseMoveTimeout = setTimeout(function() {
                _mouseMoveTimeout = null;
            }, 100);
        }, _bindEvents = function _bindEvents() {
            framework.bind(document, 'keydown', self);
            if (_features.transform) // don't bind click event in browsers that don't support transform (mostly IE8)
            framework.bind(self.scrollWrap, 'click', self);
            if (!_options.mouseUsed) framework.bind(document, 'mousemove', _onFirstMouseMove);
            framework.bind(window, 'resize scroll orientationchange', self);
            _shout('bindEvents');
        }, _unbindEvents = function _unbindEvents() {
            framework.unbind(window, 'resize scroll orientationchange', self);
            framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
            framework.unbind(document, 'keydown', self);
            framework.unbind(document, 'mousemove', _onFirstMouseMove);
            if (_features.transform) framework.unbind(self.scrollWrap, 'click', self);
            if (_isDragging) framework.unbind(window, _upMoveEvents, self);
            clearTimeout(_orientationChangeTimeout);
            _shout('unbindEvents');
        }, _calculatePanBounds = function _calculatePanBounds(zoomLevel, update) {
            var bounds = _calculateItemSize(self.currItem, _viewportSize, zoomLevel);
            if (update) _currPanBounds = bounds;
            return bounds;
        }, _getMinZoomLevel = function _getMinZoomLevel(item) {
            if (!item) item = self.currItem;
            return item.initialZoomLevel;
        }, _getMaxZoomLevel = function _getMaxZoomLevel(item) {
            if (!item) item = self.currItem;
            return item.w > 0 ? _options.maxSpreadZoom : 1;
        }, // Return true if offset is out of the bounds
        _modifyDestPanOffset = function _modifyDestPanOffset(axis, destPanBounds, destPanOffset, destZoomLevel) {
            if (destZoomLevel === self.currItem.initialZoomLevel) {
                destPanOffset[axis] = self.currItem.initialPosition[axis];
                return true;
            } else {
                destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);
                if (destPanOffset[axis] > destPanBounds.min[axis]) {
                    destPanOffset[axis] = destPanBounds.min[axis];
                    return true;
                } else if (destPanOffset[axis] < destPanBounds.max[axis]) {
                    destPanOffset[axis] = destPanBounds.max[axis];
                    return true;
                }
            }
            return false;
        }, _setupTransforms = function _setupTransforms() {
            if (_transformKey) {
                // setup 3d transforms
                var allow3dTransform = _features.perspective && !_likelyTouchDevice;
                _translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
                _translateSufix = _features.perspective ? ', 0px)' : ')';
                return;
            }
            // Override zoom/pan/move functions in case old browser is used (most likely IE)
            // (so they use left/top/width/height, instead of CSS transform)
            _transformKey = 'left';
            framework.addClass(template, 'pswp--ie');
            _setTranslateX = function _setTranslateX(x, elStyle) {
                elStyle.left = x + 'px';
            };
            _applyZoomPanToItem = function _applyZoomPanToItem(item) {
                var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, s = item.container.style, w = zoomRatio * item.w, h = zoomRatio * item.h;
                s.width = w + 'px';
                s.height = h + 'px';
                s.left = item.initialPosition.x + 'px';
                s.top = item.initialPosition.y + 'px';
            };
            _applyCurrentZoomPan = function _applyCurrentZoomPan() {
                if (_currZoomElementStyle) {
                    var s = _currZoomElementStyle, item = self.currItem, zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, w = zoomRatio * item.w, h = zoomRatio * item.h;
                    s.width = w + 'px';
                    s.height = h + 'px';
                    s.left = _panOffset.x + 'px';
                    s.top = _panOffset.y + 'px';
                }
            };
        }, _onKeyDown = function _onKeyDown(e) {
            var keydownAction = '';
            if (_options.escKey && e.keyCode === 27) keydownAction = 'close';
            else if (_options.arrowKeys) {
                if (e.keyCode === 37) keydownAction = 'prev';
                else if (e.keyCode === 39) keydownAction = 'next';
            }
            if (keydownAction) // don't do anything if special key pressed to prevent from overriding default browser actions
            // e.g. in Chrome on Mac cmd+arrow-left returns to previous page
            {
                if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                    self[keydownAction]();
                }
            }
        }, _onGlobalClick = function _onGlobalClick(e) {
            if (!e) return;
            // don't allow click event to pass through when triggering after drag or some other gesture
            if (_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, _updatePageScrollOffset = function _updatePageScrollOffset() {
            self.setScrollOffset(0, framework.getScrollY());
        };
        // Micro animation engine
        var _animations = {}, _numAnimations = 0, _stopAnimation = function _stopAnimation(name) {
            if (_animations[name]) {
                if (_animations[name].raf) _cancelAF(_animations[name].raf);
                _numAnimations--;
                delete _animations[name];
            }
        }, _registerStartAnimation = function _registerStartAnimation(name) {
            if (_animations[name]) _stopAnimation(name);
            if (!_animations[name]) {
                _numAnimations++;
                _animations[name] = {};
            }
        }, _stopAllAnimations = function _stopAllAnimations() {
            for(var prop in _animations)if (_animations.hasOwnProperty(prop)) _stopAnimation(prop);
        }, _animateProp = function _animateProp(name, b, endProp, d, easingFn, onUpdate, onComplete) {
            var startAnimTime = _getCurrentTime(), t;
            _registerStartAnimation(name);
            var animloop = function animloop1() {
                if (_animations[name]) {
                    t = _getCurrentTime() - startAnimTime; // time diff
                    //b - beginning (start prop)
                    //d - anim duration
                    if (t >= d) {
                        _stopAnimation(name);
                        onUpdate(endProp);
                        if (onComplete) onComplete();
                        return;
                    }
                    onUpdate((endProp - b) * easingFn(t / d) + b);
                    _animations[name].raf = _requestAF(animloop);
                }
            };
            animloop();
        };
        var publicMethods = {
            // make a few local variables and functions public
            shout: _shout,
            listen: _listen,
            viewportSize: _viewportSize,
            options: _options,
            isMainScrollAnimating: function isMainScrollAnimating() {
                return _mainScrollAnimating;
            },
            getZoomLevel: function getZoomLevel() {
                return _currZoomLevel;
            },
            getCurrentIndex: function getCurrentIndex() {
                return _currentItemIndex;
            },
            isDragging: function isDragging() {
                return _isDragging;
            },
            isZooming: function isZooming() {
                return _isZooming;
            },
            setScrollOffset: function setScrollOffset(x, y) {
                _offset.x = x;
                _currentWindowScrollY = _offset.y = y;
                _shout('updateScrollOffset', _offset);
            },
            applyZoomPan: function applyZoomPan(zoomLevel, panX, panY, allowRenderResolution) {
                _panOffset.x = panX;
                _panOffset.y = panY;
                _currZoomLevel = zoomLevel;
                _applyCurrentZoomPan(allowRenderResolution);
            },
            init: function init() {
                if (_isOpen || _isDestroying) return;
                var i;
                self.framework = framework; // basic functionality
                self.template = template; // root DOM element of PhotoSwipe
                self.bg = framework.getChildByClass(template, 'pswp__bg');
                _initalClassName = template.className;
                _isOpen = true;
                _features = framework.detectFeatures();
                _requestAF = _features.raf;
                _cancelAF = _features.caf;
                _transformKey = _features.transform;
                _oldIE = _features.oldIE;
                self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
                self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');
                _containerStyle = self.container.style; // for fast access
                // Objects that hold slides (there are only 3 in DOM)
                self.itemHolders = _itemHolders = [
                    {
                        el: self.container.children[0],
                        wrap: 0,
                        index: -1
                    },
                    {
                        el: self.container.children[1],
                        wrap: 0,
                        index: -1
                    },
                    {
                        el: self.container.children[2],
                        wrap: 0,
                        index: -1
                    }
                ];
                // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
                _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';
                _setupTransforms();
                // Setup global events
                _globalEventHandlers = {
                    resize: self.updateSize,
                    // Fixes: iOS 10.3 resize event
                    // does not update scrollWrap.clientWidth instantly after resize
                    // https://github.com/dimsemenov/PhotoSwipe/issues/1315
                    orientationchange: function orientationchange() {
                        clearTimeout(_orientationChangeTimeout);
                        _orientationChangeTimeout = setTimeout(function() {
                            if (_viewportSize.x !== self.scrollWrap.clientWidth) self.updateSize();
                        }, 500);
                    },
                    scroll: _updatePageScrollOffset,
                    keydown: _onKeyDown,
                    click: _onGlobalClick
                };
                // disable show/hide effects on old browsers that don't support CSS animations or transforms, 
                // old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
                var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
                if (!_features.animationName || !_features.transform || oldPhone) _options.showAnimationDuration = _options.hideAnimationDuration = 0;
                // init modules
                for(i = 0; i < _modules.length; i++)self['init' + _modules[i]]();
                // init
                if (UiClass) {
                    var ui = self.ui = new UiClass(self, framework);
                    ui.init();
                }
                _shout('firstUpdate');
                _currentItemIndex = _currentItemIndex || _options.index || 0;
                // validate index
                if (isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems()) _currentItemIndex = 0;
                self.currItem = _getItemAt(_currentItemIndex);
                if (_features.isOldIOSPhone || _features.isOldAndroid) _isFixedPosition = false;
                template.setAttribute('aria-hidden', 'false');
                if (_options.modal) {
                    if (!_isFixedPosition) {
                        template.style.position = 'absolute';
                        template.style.top = framework.getScrollY() + 'px';
                    } else template.style.position = 'fixed';
                }
                if (_currentWindowScrollY === undefined) {
                    _shout('initialLayout');
                    _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
                }
                // add classes to root element of PhotoSwipe
                var rootClasses = 'pswp--open ';
                if (_options.mainClass) rootClasses += _options.mainClass + ' ';
                if (_options.showHideOpacity) rootClasses += 'pswp--animate_opacity ';
                rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
                rootClasses += _features.animationName ? ' pswp--css_animation' : '';
                rootClasses += _features.svg ? ' pswp--svg' : '';
                framework.addClass(template, rootClasses);
                self.updateSize();
                // initial update
                _containerShiftIndex = -1;
                _indexDiff = null;
                for(i = 0; i < NUM_HOLDERS; i++)_setTranslateX((i + _containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
                if (!_oldIE) framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
                _listen('initialZoomInEnd', function() {
                    self.setContent(_itemHolders[0], _currentItemIndex - 1);
                    self.setContent(_itemHolders[2], _currentItemIndex + 1);
                    _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';
                    if (_options.focus) // focus causes layout, 
                    // which causes lag during the animation, 
                    // that's why we delay it untill the initial zoom transition ends
                    template.focus();
                    _bindEvents();
                });
                // set content for center slide (first time)
                self.setContent(_itemHolders[1], _currentItemIndex);
                self.updateCurrItem();
                _shout('afterInit');
                if (!_isFixedPosition) // On all versions of iOS lower than 8.0, we check size of viewport every second.
                // 
                // This is done to detect when Safari top & bottom bars appear, 
                // as this action doesn't trigger any events (like resize). 
                // 
                // On iOS8 they fixed this.
                // 
                // 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.
                _updateSizeInterval = setInterval(function() {
                    if (!_numAnimations && !_isDragging && !_isZooming && _currZoomLevel === self.currItem.initialZoomLevel) self.updateSize();
                }, 1000);
                framework.addClass(template, 'pswp--visible');
            },
            // Close the gallery, then destroy it
            close: function close() {
                if (!_isOpen) return;
                _isOpen = false;
                _isDestroying = true;
                _shout('close');
                _unbindEvents();
                _showOrHide(self.currItem, null, true, self.destroy);
            },
            // destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
            destroy: function destroy() {
                _shout('destroy');
                if (_showOrHideTimeout) clearTimeout(_showOrHideTimeout);
                template.setAttribute('aria-hidden', 'true');
                template.className = _initalClassName;
                if (_updateSizeInterval) clearInterval(_updateSizeInterval);
                framework.unbind(self.scrollWrap, _downEvents, self);
                // we unbind scroll event at the end, as closing animation may depend on it
                framework.unbind(window, 'scroll', self);
                _stopDragUpdateLoop();
                _stopAllAnimations();
                _listeners = null;
            },
            /**
	 * Pan image to position
	 * @param {Number} x     
	 * @param {Number} y     
	 * @param {Boolean} force Will ignore bounds if set to true.
	 */ panTo: function panTo(x, y, force) {
                if (!force) {
                    if (x > _currPanBounds.min.x) x = _currPanBounds.min.x;
                    else if (x < _currPanBounds.max.x) x = _currPanBounds.max.x;
                    if (y > _currPanBounds.min.y) y = _currPanBounds.min.y;
                    else if (y < _currPanBounds.max.y) y = _currPanBounds.max.y;
                }
                _panOffset.x = x;
                _panOffset.y = y;
                _applyCurrentZoomPan();
            },
            handleEvent: function handleEvent(e) {
                e = e || window.event;
                if (_globalEventHandlers[e.type]) _globalEventHandlers[e.type](e);
            },
            goTo: function goTo(index) {
                index = _getLoopedId(index);
                var diff = index - _currentItemIndex;
                _indexDiff = diff;
                _currentItemIndex = index;
                self.currItem = _getItemAt(_currentItemIndex);
                _currPositionIndex -= diff;
                _moveMainScroll(_slideSize.x * _currPositionIndex);
                _stopAllAnimations();
                _mainScrollAnimating = false;
                self.updateCurrItem();
            },
            next: function next() {
                self.goTo(_currentItemIndex + 1);
            },
            prev: function prev() {
                self.goTo(_currentItemIndex - 1);
            },
            // update current zoom/pan objects
            updateCurrZoomItem: function updateCurrZoomItem(emulateSetContent) {
                if (emulateSetContent) _shout('beforeChange', 0);
                // itemHolder[1] is middle (current) item
                if (_itemHolders[1].el.children.length) {
                    var zoomElement = _itemHolders[1].el.children[0];
                    if (framework.hasClass(zoomElement, 'pswp__zoom-wrap')) _currZoomElementStyle = zoomElement.style;
                    else _currZoomElementStyle = null;
                } else _currZoomElementStyle = null;
                _currPanBounds = self.currItem.bounds;
                _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                _panOffset.x = _currPanBounds.center.x;
                _panOffset.y = _currPanBounds.center.y;
                if (emulateSetContent) _shout('afterChange');
            },
            invalidateCurrItems: function invalidateCurrItems() {
                _itemsNeedUpdate = true;
                for(var i = 0; i < NUM_HOLDERS; i++)if (_itemHolders[i].item) _itemHolders[i].item.needsUpdate = true;
            },
            updateCurrItem: function updateCurrItem(beforeAnimation) {
                if (_indexDiff === 0) return;
                var diffAbs = Math.abs(_indexDiff), tempHolder;
                if (beforeAnimation && diffAbs < 2) return;
                self.currItem = _getItemAt(_currentItemIndex);
                _renderMaxResolution = false;
                _shout('beforeChange', _indexDiff);
                if (diffAbs >= NUM_HOLDERS) {
                    _containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
                    diffAbs = NUM_HOLDERS;
                }
                for(var i = 0; i < diffAbs; i++)if (_indexDiff > 0) {
                    tempHolder = _itemHolders.shift();
                    _itemHolders[NUM_HOLDERS - 1] = tempHolder; // move first to last
                    _containerShiftIndex++;
                    _setTranslateX((_containerShiftIndex + 2) * _slideSize.x, tempHolder.el.style);
                    self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
                } else {
                    tempHolder = _itemHolders.pop();
                    _itemHolders.unshift(tempHolder); // move last to first
                    _containerShiftIndex--;
                    _setTranslateX(_containerShiftIndex * _slideSize.x, tempHolder.el.style);
                    self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
                }
                // reset zoom/pan on previous item
                if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
                    var prevItem = _getItemAt(_prevItemIndex);
                    if (prevItem.initialZoomLevel !== _currZoomLevel) {
                        _calculateItemSize(prevItem, _viewportSize);
                        _setImageSize(prevItem);
                        _applyZoomPanToItem(prevItem);
                    }
                }
                // reset diff after update
                _indexDiff = 0;
                self.updateCurrZoomItem();
                _prevItemIndex = _currentItemIndex;
                _shout('afterChange');
            },
            updateSize: function updateSize(force) {
                if (!_isFixedPosition && _options.modal) {
                    var windowScrollY = framework.getScrollY();
                    if (_currentWindowScrollY !== windowScrollY) {
                        template.style.top = windowScrollY + 'px';
                        _currentWindowScrollY = windowScrollY;
                    }
                    if (!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) return;
                    _windowVisibleSize.x = window.innerWidth;
                    _windowVisibleSize.y = window.innerHeight;
                    //template.style.width = _windowVisibleSize.x + 'px';
                    template.style.height = _windowVisibleSize.y + 'px';
                }
                _viewportSize.x = self.scrollWrap.clientWidth;
                _viewportSize.y = self.scrollWrap.clientHeight;
                _updatePageScrollOffset();
                _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
                _slideSize.y = _viewportSize.y;
                _moveMainScroll(_slideSize.x * _currPositionIndex);
                _shout('beforeResize'); // even may be used for example to switch image sources
                // don't re-calculate size on inital size update
                if (_containerShiftIndex !== undefined) {
                    var holder, item, hIndex;
                    for(var i = 0; i < NUM_HOLDERS; i++){
                        holder = _itemHolders[i];
                        _setTranslateX((i + _containerShiftIndex) * _slideSize.x, holder.el.style);
                        hIndex = _currentItemIndex + i - 1;
                        if (_options.loop && _getNumItems() > 2) hIndex = _getLoopedId(hIndex);
                        // update zoom level on items and refresh source (if needsUpdate)
                        item = _getItemAt(hIndex);
                        // re-render gallery item if `needsUpdate`,
                        // or doesn't have `bounds` (entirely new slide object)
                        if (item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds)) {
                            self.cleanSlide(item);
                            self.setContent(holder, hIndex);
                            // if "center" slide
                            if (i === 1) {
                                self.currItem = item;
                                self.updateCurrZoomItem(true);
                            }
                            item.needsUpdate = false;
                        } else if (holder.index === -1 && hIndex >= 0) // add content first time
                        self.setContent(holder, hIndex);
                        if (item && item.container) {
                            _calculateItemSize(item, _viewportSize);
                            _setImageSize(item);
                            _applyZoomPanToItem(item);
                        }
                    }
                    _itemsNeedUpdate = false;
                }
                _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                _currPanBounds = self.currItem.bounds;
                if (_currPanBounds) {
                    _panOffset.x = _currPanBounds.center.x;
                    _panOffset.y = _currPanBounds.center.y;
                    _applyCurrentZoomPan(true);
                }
                _shout('resize');
            },
            // Zoom current item to
            zoomTo: function zoomTo(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
                /*
			if(destZoomLevel === 'fit') {
				destZoomLevel = self.currItem.fitRatio;
			} else if(destZoomLevel === 'fill') {
				destZoomLevel = self.currItem.fillRatio;
			}
		*/ if (centerPoint) {
                    _startZoomLevel = _currZoomLevel;
                    _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x;
                    _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y;
                    _equalizePoints(_startPanOffset, _panOffset);
                }
                var destPanBounds = _calculatePanBounds(destZoomLevel, false), destPanOffset = {};
                _modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
                _modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);
                var initialZoomLevel = _currZoomLevel;
                var initialPanOffset = {
                    x: _panOffset.x,
                    y: _panOffset.y
                };
                _roundPoint(destPanOffset);
                var onUpdate = function onUpdate(now) {
                    if (now === 1) {
                        _currZoomLevel = destZoomLevel;
                        _panOffset.x = destPanOffset.x;
                        _panOffset.y = destPanOffset.y;
                    } else {
                        _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                        _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
                        _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
                    }
                    if (updateFn) updateFn(now);
                    _applyCurrentZoomPan(now === 1);
                };
                if (speed) _animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
                else onUpdate(1);
            }
        };
        /*>>core*/ /*>>gestures*/ /**
 * Mouse/touch/pointer event handlers.
 * 
 * separated from @core.js for readability
 */ var MIN_SWIPE_DISTANCE = 30, DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe
        var _gestureStartTime, _gestureCheckSpeedTime, // pool of objects that are used during dragging of zooming
        p = {}, p2 = {}, delta = {}, _currPoint = {}, _startPoint = {}, _currPointers = [], _startMainScrollPos = {}, _releaseAnimData, _posPoints = [], _tempPoint = {}, _isZoomingIn, _verticalDragInitiated, _oldAndroidTouchEndTimeout, _currZoomedItemIndex = 0, _centerPoint = _getEmptyPoint(), _lastReleaseTime = 0, _isDragging, _isMultitouch, _zoomStarted, _moved, _dragAnimFrame, _mainScrollShifted, _currentPoints, _isZooming, _currPointsDistance, _startPointsDistance, _currPanBounds, _mainScrollPos = _getEmptyPoint(), _currZoomElementStyle, _mainScrollAnimating, _midZoomPoint = _getEmptyPoint(), _currCenterPoint = _getEmptyPoint(), _direction, _isFirstMove, _opacityChanged, _bgOpacity, _wasOverInitialZoom, _isEqualPoints = function _isEqualPoints(p1, p2) {
            return p1.x === p2.x && p1.y === p2.y;
        }, _isNearbyPoints = function _isNearbyPoints(touch0, touch1) {
            return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
        }, _calculatePointsDistance = function _calculatePointsDistance(p1, p2) {
            _tempPoint.x = Math.abs(p1.x - p2.x);
            _tempPoint.y = Math.abs(p1.y - p2.y);
            return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
        }, _stopDragUpdateLoop = function _stopDragUpdateLoop() {
            if (_dragAnimFrame) {
                _cancelAF(_dragAnimFrame);
                _dragAnimFrame = null;
            }
        }, _dragUpdateLoop = function _dragUpdateLoop1() {
            if (_isDragging) {
                _dragAnimFrame = _requestAF(_dragUpdateLoop);
                _renderMovement();
            }
        }, _canPan = function _canPan() {
            return !(_options.scaleMode === 'fit' && _currZoomLevel === self.currItem.initialZoomLevel);
        }, // find the closest parent DOM element
        _closestElement = function _closestElement1(el, fn) {
            if (!el || el === document) return false;
            // don't search elements above pswp__scroll-wrap
            if (el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1) return false;
            if (fn(el)) return el;
            return _closestElement(el.parentNode, fn);
        }, _preventObj = {}, _preventDefaultEventBehaviour = function _preventDefaultEventBehaviour(e, isDown) {
            _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);
            _shout('preventDragEvent', e, isDown, _preventObj);
            return _preventObj.prevent;
        }, _convertTouchToPoint = function _convertTouchToPoint(touch, p) {
            p.x = touch.pageX;
            p.y = touch.pageY;
            p.id = touch.identifier;
            return p;
        }, _findCenterOfPoints = function _findCenterOfPoints(p1, p2, pCenter) {
            pCenter.x = (p1.x + p2.x) * 0.5;
            pCenter.y = (p1.y + p2.y) * 0.5;
        }, _pushPosPoint = function _pushPosPoint(time, x, y) {
            if (time - _gestureCheckSpeedTime > 50) {
                var o = _posPoints.length > 2 ? _posPoints.shift() : {};
                o.x = x;
                o.y = y;
                _posPoints.push(o);
                _gestureCheckSpeedTime = time;
            }
        }, _calculateVerticalDragOpacityRatio = function _calculateVerticalDragOpacityRatio() {
            var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
            return 1 - Math.abs(yOffset / (_viewportSize.y / 2));
        }, // points pool, reused during touch events
        _ePoint1 = {}, _ePoint2 = {}, _tempPointsArr = [], _tempCounter, _getTouchPoints = function _getTouchPoints(e) {
            // clean up previous points, without recreating array
            while(_tempPointsArr.length > 0)_tempPointsArr.pop();
            if (!_pointerEventEnabled) {
                if (e.type.indexOf('touch') > -1) {
                    if (e.touches && e.touches.length > 0) {
                        _tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
                        if (e.touches.length > 1) _tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
                    }
                } else {
                    _ePoint1.x = e.pageX;
                    _ePoint1.y = e.pageY;
                    _ePoint1.id = '';
                    _tempPointsArr[0] = _ePoint1; //_ePoint1;
                }
            } else {
                _tempCounter = 0;
                // we can use forEach, as pointer events are supported only in modern browsers
                _currPointers.forEach(function(p) {
                    if (_tempCounter === 0) _tempPointsArr[0] = p;
                    else if (_tempCounter === 1) _tempPointsArr[1] = p;
                    _tempCounter++;
                });
            }
            return _tempPointsArr;
        }, _panOrMoveMainScroll = function _panOrMoveMainScroll(axis, delta) {
            var panFriction, overDiff = 0, newOffset = _panOffset[axis] + delta[axis], startOverDiff, dir = delta[axis] > 0, newMainScrollPosition = _mainScrollPos.x + delta.x, mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x, newPanPos, newMainScrollPos;
            // calculate fdistance over the bounds and friction
            if (newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) panFriction = _options.panEndFriction;
            else panFriction = 1;
            newOffset = _panOffset[axis] + delta[axis] * panFriction;
            // move main scroll or start panning
            if (_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {
                if (!_currZoomElementStyle) newMainScrollPos = newMainScrollPosition;
                else if (_direction === 'h' && axis === 'x' && !_zoomStarted) {
                    if (dir) {
                        if (newOffset > _currPanBounds.min[axis]) {
                            panFriction = _options.panEndFriction;
                            overDiff = _currPanBounds.min[axis] - newOffset;
                            startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
                        }
                        // drag right
                        if ((startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1) {
                            newMainScrollPos = newMainScrollPosition;
                            if (mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) newMainScrollPos = _startMainScrollPos.x;
                        } else if (_currPanBounds.min.x !== _currPanBounds.max.x) newPanPos = newOffset;
                    } else {
                        if (newOffset < _currPanBounds.max[axis]) {
                            panFriction = _options.panEndFriction;
                            overDiff = newOffset - _currPanBounds.max[axis];
                            startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
                        }
                        if ((startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1) {
                            newMainScrollPos = newMainScrollPosition;
                            if (mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) newMainScrollPos = _startMainScrollPos.x;
                        } else if (_currPanBounds.min.x !== _currPanBounds.max.x) newPanPos = newOffset;
                    }
                }
                if (axis === 'x') {
                    if (newMainScrollPos !== undefined) {
                        _moveMainScroll(newMainScrollPos, true);
                        if (newMainScrollPos === _startMainScrollPos.x) _mainScrollShifted = false;
                        else _mainScrollShifted = true;
                    }
                    if (_currPanBounds.min.x !== _currPanBounds.max.x) {
                        if (newPanPos !== undefined) _panOffset.x = newPanPos;
                        else if (!_mainScrollShifted) _panOffset.x += delta.x * panFriction;
                    }
                    return newMainScrollPos !== undefined;
                }
            }
            if (!_mainScrollAnimating) {
                if (!_mainScrollShifted) {
                    if (_currZoomLevel > self.currItem.fitRatio) _panOffset[axis] += delta[axis] * panFriction;
                }
            }
        }, // Pointerdown/touchstart/mousedown handler
        _onDragStart = function _onDragStart(e) {
            // Allow dragging only via left mouse button.
            // As this handler is not added in IE8 - we ignore e.which
            // 
            // http://www.quirksmode.org/js/events_properties.html
            // https://developer.mozilla.org/en-US/docs/Web/API/event.button
            if (e.type === 'mousedown' && e.button > 0) return;
            if (_initialZoomRunning) {
                e.preventDefault();
                return;
            }
            if (_oldAndroidTouchEndTimeout && e.type === 'mousedown') return;
            if (_preventDefaultEventBehaviour(e, true)) e.preventDefault();
            _shout('pointerDown');
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex < 0) pointerIndex = _currPointers.length;
                _currPointers[pointerIndex] = {
                    x: e.pageX,
                    y: e.pageY,
                    id: e.pointerId
                };
            }
            var startPointsList = _getTouchPoints(e), numPoints = startPointsList.length;
            _currentPoints = null;
            _stopAllAnimations();
            // init drag
            if (!_isDragging || numPoints === 1) {
                _isDragging = _isFirstMove = true;
                framework.bind(window, _upMoveEvents, self);
                _isZoomingIn = _wasOverInitialZoom = _opacityChanged = _verticalDragInitiated = _mainScrollShifted = _moved = _isMultitouch = _zoomStarted = false;
                _direction = null;
                _shout('firstTouchStart', startPointsList);
                _equalizePoints(_startPanOffset, _panOffset);
                _currPanDist.x = _currPanDist.y = 0;
                _equalizePoints(_currPoint, startPointsList[0]);
                _equalizePoints(_startPoint, _currPoint);
                //_equalizePoints(_startMainScrollPos, _mainScrollPos);
                _startMainScrollPos.x = _slideSize.x * _currPositionIndex;
                _posPoints = [
                    {
                        x: _currPoint.x,
                        y: _currPoint.y
                    }
                ];
                _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();
                //_mainScrollAnimationEnd(true);
                _calculatePanBounds(_currZoomLevel, true);
                // Start rendering
                _stopDragUpdateLoop();
                _dragUpdateLoop();
            }
            // init zoom
            if (!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
                _startZoomLevel = _currZoomLevel;
                _zoomStarted = false; // true if zoom changed at least once
                _isZooming = _isMultitouch = true;
                _currPanDist.y = _currPanDist.x = 0;
                _equalizePoints(_startPanOffset, _panOffset);
                _equalizePoints(p, startPointsList[0]);
                _equalizePoints(p2, startPointsList[1]);
                _findCenterOfPoints(p, p2, _currCenterPoint);
                _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
                _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
                _currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
            }
        }, // Pointermove/touchmove/mousemove handler
        _onDragMove = function _onDragMove(e) {
            e.preventDefault();
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex > -1) {
                    var p = _currPointers[pointerIndex];
                    p.x = e.pageX;
                    p.y = e.pageY;
                }
            }
            if (_isDragging) {
                var touchesList = _getTouchPoints(e);
                if (!_direction && !_moved && !_isZooming) {
                    if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) // if main scroll position is shifted – direction is always horizontal
                    _direction = 'h';
                    else {
                        var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
                        // check the direction of movement
                        if (Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
                            _direction = diff > 0 ? 'h' : 'v';
                            _currentPoints = touchesList;
                        }
                    }
                } else _currentPoints = touchesList;
            }
        }, // 
        _renderMovement = function _renderMovement() {
            if (!_currentPoints) return;
            var numPoints = _currentPoints.length;
            if (numPoints === 0) return;
            _equalizePoints(p, _currentPoints[0]);
            delta.x = p.x - _currPoint.x;
            delta.y = p.y - _currPoint.y;
            if (_isZooming && numPoints > 1) {
                // Handle behaviour for more than 1 point
                _currPoint.x = p.x;
                _currPoint.y = p.y;
                // check if one of two points changed
                if (!delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2)) return;
                _equalizePoints(p2, _currentPoints[1]);
                if (!_zoomStarted) {
                    _zoomStarted = true;
                    _shout('zoomGestureStarted');
                }
                // Distance between two points
                var pointsDistance = _calculatePointsDistance(p, p2);
                var zoomLevel = _calculateZoomLevel(pointsDistance);
                // slightly over the of initial zoom level
                if (zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) _wasOverInitialZoom = true;
                // Apply the friction if zoom level is out of the bounds
                var zoomFriction = 1, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
                if (zoomLevel < minZoomLevel) {
                    if (_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
                        // fade out background if zooming out
                        var minusDiff = minZoomLevel - zoomLevel;
                        var percent = 1 - minusDiff / (minZoomLevel / 1.2);
                        _applyBgOpacity(percent);
                        _shout('onPinchClose', percent);
                        _opacityChanged = true;
                    } else {
                        zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
                        if (zoomFriction > 1) zoomFriction = 1;
                        zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
                    }
                } else if (zoomLevel > maxZoomLevel) {
                    // 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
                    zoomFriction = (zoomLevel - maxZoomLevel) / (minZoomLevel * 6);
                    if (zoomFriction > 1) zoomFriction = 1;
                    zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
                }
                if (zoomFriction < 0) zoomFriction = 0;
                // distance between touch points after friction is applied
                _currPointsDistance = pointsDistance;
                // _centerPoint - The point in the middle of two pointers
                _findCenterOfPoints(p, p2, _centerPoint);
                // paning with two pointers pressed
                _currPanDist.x += _centerPoint.x - _currCenterPoint.x;
                _currPanDist.y += _centerPoint.y - _currCenterPoint.y;
                _equalizePoints(_currCenterPoint, _centerPoint);
                _panOffset.x = _calculatePanOffset('x', zoomLevel);
                _panOffset.y = _calculatePanOffset('y', zoomLevel);
                _isZoomingIn = zoomLevel > _currZoomLevel;
                _currZoomLevel = zoomLevel;
                _applyCurrentZoomPan();
            } else {
                // handle behaviour for one point (dragging or panning)
                if (!_direction) return;
                if (_isFirstMove) {
                    _isFirstMove = false;
                    // subtract drag distance that was used during the detection direction  
                    if (Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) delta.x -= _currentPoints[0].x - _startPoint.x;
                    if (Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) delta.y -= _currentPoints[0].y - _startPoint.y;
                }
                _currPoint.x = p.x;
                _currPoint.y = p.y;
                // do nothing if pointers position hasn't changed
                if (delta.x === 0 && delta.y === 0) return;
                if (_direction === 'v' && _options.closeOnVerticalDrag) {
                    if (!_canPan()) {
                        _currPanDist.y += delta.y;
                        _panOffset.y += delta.y;
                        var opacityRatio = _calculateVerticalDragOpacityRatio();
                        _verticalDragInitiated = true;
                        _shout('onVerticalDrag', opacityRatio);
                        _applyBgOpacity(opacityRatio);
                        _applyCurrentZoomPan();
                        return;
                    }
                }
                _pushPosPoint(_getCurrentTime(), p.x, p.y);
                _moved = true;
                _currPanBounds = self.currItem.bounds;
                var mainScrollChanged = _panOrMoveMainScroll('x', delta);
                if (!mainScrollChanged) {
                    _panOrMoveMainScroll('y', delta);
                    _roundPoint(_panOffset);
                    _applyCurrentZoomPan();
                }
            }
        }, // Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
        _onDragRelease = function _onDragRelease(e) {
            if (_features.isOldAndroid) {
                if (_oldAndroidTouchEndTimeout && e.type === 'mouseup') return;
                // on Android (v4.1, 4.2, 4.3 & possibly older) 
                // ghost mousedown/up event isn't preventable via e.preventDefault,
                // which causes fake mousedown event
                // so we block mousedown/up for 600ms
                if (e.type.indexOf('touch') > -1) {
                    clearTimeout(_oldAndroidTouchEndTimeout);
                    _oldAndroidTouchEndTimeout = setTimeout(function() {
                        _oldAndroidTouchEndTimeout = 0;
                    }, 600);
                }
            }
            _shout('pointerUp');
            if (_preventDefaultEventBehaviour(e, false)) e.preventDefault();
            var releasePoint;
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex > -1) {
                    releasePoint = _currPointers.splice(pointerIndex, 1)[0];
                    if (navigator.msPointerEnabled) {
                        var MSPOINTER_TYPES = {
                            4: 'mouse',
                            2: 'touch',
                            3: 'pen' // event.MSPOINTER_TYPE_PEN
                        };
                        releasePoint.type = MSPOINTER_TYPES[e.pointerType];
                        if (!releasePoint.type) releasePoint.type = e.pointerType || 'mouse';
                    } else releasePoint.type = e.pointerType || 'mouse';
                }
            }
            var touchList = _getTouchPoints(e), gestureType, numPoints = touchList.length;
            if (e.type === 'mouseup') numPoints = 0;
            // Do nothing if there were 3 touch points or more
            if (numPoints === 2) {
                _currentPoints = null;
                return true;
            }
            // if second pointer released
            if (numPoints === 1) _equalizePoints(_startPoint, touchList[0]);
            // pointer hasn't moved, send "tap release" point
            if (numPoints === 0 && !_direction && !_mainScrollAnimating) {
                if (!releasePoint) {
                    if (e.type === 'mouseup') releasePoint = {
                        x: e.pageX,
                        y: e.pageY,
                        type: 'mouse'
                    };
                    else if (e.changedTouches && e.changedTouches[0]) releasePoint = {
                        x: e.changedTouches[0].pageX,
                        y: e.changedTouches[0].pageY,
                        type: 'touch'
                    };
                }
                _shout('touchRelease', e, releasePoint);
            }
            // Difference in time between releasing of two last touch points (zoom gesture)
            var releaseTimeDiff = -1;
            // Gesture completed, no pointers left
            if (numPoints === 0) {
                _isDragging = false;
                framework.unbind(window, _upMoveEvents, self);
                _stopDragUpdateLoop();
                if (_isZooming) // Two points released at the same time
                releaseTimeDiff = 0;
                else if (_lastReleaseTime !== -1) releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
            }
            _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
            if (releaseTimeDiff !== -1 && releaseTimeDiff < 150) gestureType = 'zoom';
            else gestureType = 'swipe';
            if (_isZooming && numPoints < 2) {
                _isZooming = false;
                // Only second point released
                if (numPoints === 1) gestureType = 'zoomPointerUp';
                _shout('zoomGestureEnded');
            }
            _currentPoints = null;
            if (!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) // nothing to animate
            return;
            _stopAllAnimations();
            if (!_releaseAnimData) _releaseAnimData = _initDragReleaseAnimationData();
            _releaseAnimData.calculateSwipeSpeed('x');
            if (_verticalDragInitiated) {
                var opacityRatio = _calculateVerticalDragOpacityRatio();
                if (opacityRatio < _options.verticalDragRange) self.close();
                else {
                    var initalPanY = _panOffset.y, initialBgOpacity = _bgOpacity;
                    _animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {
                        _panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;
                        _applyBgOpacity((1 - initialBgOpacity) * now + initialBgOpacity);
                        _applyCurrentZoomPan();
                    });
                    _shout('onVerticalDrag', 1);
                }
                return;
            }
            // main scroll 
            if ((_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
                var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
                if (itemChanged) return;
                gestureType = 'zoomPointerUp';
            }
            // prevent zoom/pan animation when main scroll animation runs
            if (_mainScrollAnimating) return;
            // Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
            if (gestureType !== 'swipe') {
                _completeZoomGesture();
                return;
            }
            // Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
            if (!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) _completePanGesture(_releaseAnimData);
        }, // Returns object with data about gesture
        // It's created only once and then reused
        _initDragReleaseAnimationData = function _initDragReleaseAnimationData() {
            // temp local vars
            var lastFlickDuration, tempReleasePos;
            // s = this
            var s = {
                lastFlickOffset: {},
                lastFlickDist: {},
                lastFlickSpeed: {},
                slowDownRatio: {},
                slowDownRatioReverse: {},
                speedDecelerationRatio: {},
                speedDecelerationRatioAbs: {},
                distanceOffset: {},
                backAnimDestination: {},
                backAnimStarted: {},
                calculateSwipeSpeed: function calculateSwipeSpeed(axis) {
                    if (_posPoints.length > 1) {
                        lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
                        tempReleasePos = _posPoints[_posPoints.length - 2][axis];
                    } else {
                        lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
                        tempReleasePos = _startPoint[axis];
                    }
                    s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
                    s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
                    if (s.lastFlickDist[axis] > 20) s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
                    else s.lastFlickSpeed[axis] = 0;
                    if (Math.abs(s.lastFlickSpeed[axis]) < 0.1) s.lastFlickSpeed[axis] = 0;
                    s.slowDownRatio[axis] = 0.95;
                    s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                    s.speedDecelerationRatio[axis] = 1;
                },
                calculateOverBoundsAnimOffset: function calculateOverBoundsAnimOffset(axis, speed) {
                    if (!s.backAnimStarted[axis]) {
                        if (_panOffset[axis] > _currPanBounds.min[axis]) s.backAnimDestination[axis] = _currPanBounds.min[axis];
                        else if (_panOffset[axis] < _currPanBounds.max[axis]) s.backAnimDestination[axis] = _currPanBounds.max[axis];
                        if (s.backAnimDestination[axis] !== undefined) {
                            s.slowDownRatio[axis] = 0.7;
                            s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                            if (s.speedDecelerationRatioAbs[axis] < 0.05) {
                                s.lastFlickSpeed[axis] = 0;
                                s.backAnimStarted[axis] = true;
                                _animateProp('bounceZoomPan' + axis, _panOffset[axis], s.backAnimDestination[axis], speed || 300, framework.easing.sine.out, function(pos) {
                                    _panOffset[axis] = pos;
                                    _applyCurrentZoomPan();
                                });
                            }
                        }
                    }
                },
                // Reduces the speed by slowDownRatio (per 10ms)
                calculateAnimOffset: function calculateAnimOffset(axis) {
                    if (!s.backAnimStarted[axis]) {
                        s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + s.slowDownRatioReverse[axis] - s.slowDownRatioReverse[axis] * s.timeDiff / 10);
                        s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
                        s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
                        _panOffset[axis] += s.distanceOffset[axis];
                    }
                },
                panAnimLoop: function panAnimLoop() {
                    if (_animations.zoomPan) {
                        _animations.zoomPan.raf = _requestAF(s.panAnimLoop);
                        s.now = _getCurrentTime();
                        s.timeDiff = s.now - s.lastNow;
                        s.lastNow = s.now;
                        s.calculateAnimOffset('x');
                        s.calculateAnimOffset('y');
                        _applyCurrentZoomPan();
                        s.calculateOverBoundsAnimOffset('x');
                        s.calculateOverBoundsAnimOffset('y');
                        if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {
                            // round pan position
                            _panOffset.x = Math.round(_panOffset.x);
                            _panOffset.y = Math.round(_panOffset.y);
                            _applyCurrentZoomPan();
                            _stopAnimation('zoomPan');
                            return;
                        }
                    }
                }
            };
            return s;
        }, _completePanGesture = function _completePanGesture(animData) {
            // calculate swipe speed for Y axis (paanning)
            animData.calculateSwipeSpeed('y');
            _currPanBounds = self.currItem.bounds;
            animData.backAnimDestination = {};
            animData.backAnimStarted = {};
            // Avoid acceleration animation if speed is too low
            if (Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05) {
                animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;
                // Run pan drag release animation. E.g. if you drag image and release finger without momentum.
                animData.calculateOverBoundsAnimOffset('x');
                animData.calculateOverBoundsAnimOffset('y');
                return true;
            }
            // Animation loop that controls the acceleration after pan gesture ends
            _registerStartAnimation('zoomPan');
            animData.lastNow = _getCurrentTime();
            animData.panAnimLoop();
        }, _finishSwipeMainScrollGesture = function _finishSwipeMainScrollGesture(gestureType, _releaseAnimData) {
            var itemChanged;
            if (!_mainScrollAnimating) _currZoomedItemIndex = _currentItemIndex;
            var itemsDiff;
            if (gestureType === 'swipe') {
                var totalShiftDist = _currPoint.x - _startPoint.x, isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;
                // if container is shifted for more than MIN_SWIPE_DISTANCE, 
                // and last flick gesture was in right direction
                if (totalShiftDist > MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20)) // go to prev item
                itemsDiff = -1;
                else if (totalShiftDist < -MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20)) // go to next item
                itemsDiff = 1;
            }
            var nextCircle;
            if (itemsDiff) {
                _currentItemIndex += itemsDiff;
                if (_currentItemIndex < 0) {
                    _currentItemIndex = _options.loop ? _getNumItems() - 1 : 0;
                    nextCircle = true;
                } else if (_currentItemIndex >= _getNumItems()) {
                    _currentItemIndex = _options.loop ? 0 : _getNumItems() - 1;
                    nextCircle = true;
                }
                if (!nextCircle || _options.loop) {
                    _indexDiff += itemsDiff;
                    _currPositionIndex -= itemsDiff;
                    itemChanged = true;
                }
            }
            var animateToX = _slideSize.x * _currPositionIndex;
            var animateToDist = Math.abs(animateToX - _mainScrollPos.x);
            var finishAnimDuration;
            if (!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) // "return to current" duration, e.g. when dragging from slide 0 to -1
            finishAnimDuration = 333;
            else {
                finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 333;
                finishAnimDuration = Math.min(finishAnimDuration, 400);
                finishAnimDuration = Math.max(finishAnimDuration, 250);
            }
            if (_currZoomedItemIndex === _currentItemIndex) itemChanged = false;
            _mainScrollAnimating = true;
            _shout('mainScrollAnimStart');
            _animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, _moveMainScroll, function() {
                _stopAllAnimations();
                _mainScrollAnimating = false;
                _currZoomedItemIndex = -1;
                if (itemChanged || _currZoomedItemIndex !== _currentItemIndex) self.updateCurrItem();
                _shout('mainScrollAnimComplete');
            });
            if (itemChanged) self.updateCurrItem(true);
            return itemChanged;
        }, _calculateZoomLevel = function _calculateZoomLevel(touchesDistance) {
            return 1 / _startPointsDistance * touchesDistance * _startZoomLevel;
        }, // Resets zoom if it's out of bounds
        _completeZoomGesture = function _completeZoomGesture() {
            var destZoomLevel = _currZoomLevel, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
            if (_currZoomLevel < minZoomLevel) destZoomLevel = minZoomLevel;
            else if (_currZoomLevel > maxZoomLevel) destZoomLevel = maxZoomLevel;
            var destOpacity = 1, onUpdate, initialOpacity = _bgOpacity;
            if (_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
                //_closedByScroll = true;
                self.close();
                return true;
            }
            if (_opacityChanged) onUpdate = function onUpdate(now) {
                _applyBgOpacity((destOpacity - initialOpacity) * now + initialOpacity);
            };
            self.zoomTo(destZoomLevel, 0, 200, framework.easing.cubic.out, onUpdate);
            return true;
        };
        _registerModule('Gestures', {
            publicMethods: {
                initGestures: function initGestures() {
                    // helper function that builds touch/pointer/mouse events
                    var addEventNames = function addEventNames(pref, down, move, up, cancel) {
                        _dragStartEvent = pref + down;
                        _dragMoveEvent = pref + move;
                        _dragEndEvent = pref + up;
                        if (cancel) _dragCancelEvent = pref + cancel;
                        else _dragCancelEvent = '';
                    };
                    _pointerEventEnabled = _features.pointerEvent;
                    if (_pointerEventEnabled && _features.touch) // we don't need touch events, if browser supports pointer events
                    _features.touch = false;
                    if (_pointerEventEnabled) {
                        if (navigator.msPointerEnabled) // IE10 pointer events are case-sensitive
                        addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
                        else addEventNames('pointer', 'down', 'move', 'up', 'cancel');
                    } else if (_features.touch) {
                        addEventNames('touch', 'start', 'move', 'end', 'cancel');
                        _likelyTouchDevice = true;
                    } else addEventNames('mouse', 'down', 'move', 'up');
                    _upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent + ' ' + _dragCancelEvent;
                    _downEvents = _dragStartEvent;
                    if (_pointerEventEnabled && !_likelyTouchDevice) _likelyTouchDevice = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1;
                    // make variable public
                    self.likelyTouchDevice = _likelyTouchDevice;
                    _globalEventHandlers[_dragStartEvent] = _onDragStart;
                    _globalEventHandlers[_dragMoveEvent] = _onDragMove;
                    _globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken
                    if (_dragCancelEvent) _globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
                    // Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
                    if (_features.touch) {
                        _downEvents += ' mousedown';
                        _upMoveEvents += ' mousemove mouseup';
                        _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
                        _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
                        _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
                    }
                    if (!_likelyTouchDevice) // don't allow pan to next slide from zoomed state on Desktop
                    _options.allowPanToNext = false;
                }
            }
        });
        /*>>gestures*/ /*>>show-hide-transition*/ /**
 * show-hide-transition.js:
 *
 * Manages initial opening or closing transition.
 *
 * If you're not planning to use transition for gallery at all,
 * you may set options hideAnimationDuration and showAnimationDuration to 0,
 * and just delete startAnimation function.
 * 
 */ var _showOrHideTimeout, _showOrHide = function _showOrHide(item, img, out, completeFn) {
            if (_showOrHideTimeout) clearTimeout(_showOrHideTimeout);
            _initialZoomRunning = true;
            _initialContentSet = true;
            // dimensions of small thumbnail {x:,y:,w:}.
            // Height is optional, as calculated based on large image.
            var thumbBounds;
            if (item.initialLayout) {
                thumbBounds = item.initialLayout;
                item.initialLayout = null;
            } else thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
            var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
            var onComplete = function onComplete() {
                _stopAnimation('initialZoom');
                if (!out) {
                    _applyBgOpacity(1);
                    if (img) img.style.display = 'block';
                    framework.addClass(template, 'pswp--animated-in');
                    _shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
                } else {
                    self.template.removeAttribute('style');
                    self.bg.removeAttribute('style');
                }
                if (completeFn) completeFn();
                _initialZoomRunning = false;
            };
            // if bounds aren't provided, just open gallery without animation
            if (!duration || !thumbBounds || thumbBounds.x === undefined) {
                _shout('initialZoom' + (out ? 'Out' : 'In'));
                _currZoomLevel = item.initialZoomLevel;
                _equalizePoints(_panOffset, item.initialPosition);
                _applyCurrentZoomPan();
                template.style.opacity = out ? 0 : 1;
                _applyBgOpacity(1);
                if (duration) setTimeout(function() {
                    onComplete();
                }, duration);
                else onComplete();
                return;
            }
            var startAnimation = function startAnimation() {
                var closeWithRaf = _closedByScroll, fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;
                // apply hw-acceleration to image
                if (item.miniImg) item.miniImg.style.webkitBackfaceVisibility = 'hidden';
                if (!out) {
                    _currZoomLevel = thumbBounds.w / item.w;
                    _panOffset.x = thumbBounds.x;
                    _panOffset.y = thumbBounds.y - _initalWindowScrollY;
                    self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
                    _applyCurrentZoomPan();
                }
                _registerStartAnimation('initialZoom');
                if (out && !closeWithRaf) framework.removeClass(template, 'pswp--animated-in');
                if (fadeEverything) {
                    if (out) framework[(closeWithRaf ? 'remove' : 'add') + 'Class'](template, 'pswp--animate_opacity');
                    else setTimeout(function() {
                        framework.addClass(template, 'pswp--animate_opacity');
                    }, 30);
                }
                _showOrHideTimeout = setTimeout(function() {
                    _shout('initialZoom' + (out ? 'Out' : 'In'));
                    if (!out) {
                        // "in" animation always uses CSS transitions (instead of rAF).
                        // CSS transition work faster here, 
                        // as developer may also want to animate other things, 
                        // like ui on top of sliding area, which can be animated just via CSS
                        _currZoomLevel = item.initialZoomLevel;
                        _equalizePoints(_panOffset, item.initialPosition);
                        _applyCurrentZoomPan();
                        _applyBgOpacity(1);
                        if (fadeEverything) template.style.opacity = 1;
                        else _applyBgOpacity(1);
                        _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                    } else {
                        // "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
                        var destZoomLevel = thumbBounds.w / item.w, initialPanOffset = {
                            x: _panOffset.x,
                            y: _panOffset.y
                        }, initialZoomLevel = _currZoomLevel, initalBgOpacity = _bgOpacity, onUpdate = function onUpdate(now) {
                            if (now === 1) {
                                _currZoomLevel = destZoomLevel;
                                _panOffset.x = thumbBounds.x;
                                _panOffset.y = thumbBounds.y - _currentWindowScrollY;
                            } else {
                                _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                                _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
                                _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
                            }
                            _applyCurrentZoomPan();
                            if (fadeEverything) template.style.opacity = 1 - now;
                            else _applyBgOpacity(initalBgOpacity - now * initalBgOpacity);
                        };
                        if (closeWithRaf) _animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
                        else {
                            onUpdate(1);
                            _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                        }
                    }
                }, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
            // create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
            // Which avoids lag at the beginning of scale transition.
            };
            startAnimation();
        };
        /*>>show-hide-transition*/ /*>>items-controller*/ /**
*
* Controller manages gallery items, their dimensions, and their content.
* 
*/ var _items, _tempPanAreaSize = {}, _imagesToAppendPool = [], _initialContentSet, _initialZoomRunning, _controllerDefaultOptions = {
            index: 0,
            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
            forceProgressiveLoading: false,
            preload: [
                1,
                1
            ],
            getNumItemsFn: function getNumItemsFn() {
                return _items.length;
            }
        };
        var _getItemAt, _getNumItems, _initialIsLoop, _getZeroBounds = function _getZeroBounds() {
            return {
                center: {
                    x: 0,
                    y: 0
                },
                max: {
                    x: 0,
                    y: 0
                },
                min: {
                    x: 0,
                    y: 0
                }
            };
        }, _calculateSingleItemPanBounds = function _calculateSingleItemPanBounds(item, realPanElementW, realPanElementH) {
            var bounds = item.bounds;
            // position of element when it's centered
            bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
            bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;
            // maximum pan position
            bounds.max.x = realPanElementW > _tempPanAreaSize.x ? Math.round(_tempPanAreaSize.x - realPanElementW) : bounds.center.x;
            bounds.max.y = realPanElementH > _tempPanAreaSize.y ? Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : bounds.center.y;
            // minimum pan position
            bounds.min.x = realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x;
            bounds.min.y = realPanElementH > _tempPanAreaSize.y ? item.vGap.top : bounds.center.y;
        }, _calculateItemSize = function _calculateItemSize(item, viewportSize, zoomLevel) {
            if (item.src && !item.loadError) {
                var isInitial = !zoomLevel;
                if (isInitial) {
                    if (!item.vGap) item.vGap = {
                        top: 0,
                        bottom: 0
                    };
                    // allows overriding vertical margin for individual items
                    _shout('parseVerticalMargin', item);
                }
                _tempPanAreaSize.x = viewportSize.x;
                _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
                if (isInitial) {
                    var hRatio = _tempPanAreaSize.x / item.w;
                    var vRatio = _tempPanAreaSize.y / item.h;
                    item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
                    //item.fillRatio = hRatio > vRatio ? hRatio : vRatio;
                    var scaleMode = _options.scaleMode;
                    if (scaleMode === 'orig') zoomLevel = 1;
                    else if (scaleMode === 'fit') zoomLevel = item.fitRatio;
                    if (zoomLevel > 1) zoomLevel = 1;
                    item.initialZoomLevel = zoomLevel;
                    if (!item.bounds) // reuse bounds object
                    item.bounds = _getZeroBounds();
                }
                if (!zoomLevel) return;
                _calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
                if (isInitial && zoomLevel === item.initialZoomLevel) item.initialPosition = item.bounds.center;
                return item.bounds;
            } else {
                item.w = item.h = 0;
                item.initialZoomLevel = item.fitRatio = 1;
                item.bounds = _getZeroBounds();
                item.initialPosition = item.bounds.center;
                // if it's not image, we return zero bounds (content is not zoomable)
                return item.bounds;
            }
        }, _appendImage = function _appendImage(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
            if (item.loadError) return;
            if (img) {
                item.imageAppended = true;
                _setImageSize(item, img, item === self.currItem && _renderMaxResolution);
                baseDiv.appendChild(img);
                if (keepPlaceholder) setTimeout(function() {
                    if (item && item.loaded && item.placeholder) {
                        item.placeholder.style.display = 'none';
                        item.placeholder = null;
                    }
                }, 500);
            }
        }, _preloadImage = function _preloadImage(item) {
            item.loading = true;
            item.loaded = false;
            var img = item.img = framework.createEl('pswp__img', 'img');
            var onComplete = function onComplete() {
                item.loading = false;
                item.loaded = true;
                if (item.loadComplete) item.loadComplete(item);
                else item.img = null; // no need to store image object
                img.onload = img.onerror = null;
                img = null;
            };
            img.onload = onComplete;
            img.onerror = function() {
                item.loadError = true;
                onComplete();
            };
            img.src = item.src; // + '?a=' + Math.random();
            return img;
        }, _checkForError = function _checkForError(item, cleanUp) {
            if (item.src && item.loadError && item.container) {
                if (cleanUp) item.container.innerHTML = '';
                item.container.innerHTML = _options.errorMsg.replace('%url%', item.src);
                return true;
            }
        }, _setImageSize = function _setImageSize(item, img, maxRes) {
            if (!item.src) return;
            if (!img) img = item.container.lastChild;
            var w = maxRes ? item.w : Math.round(item.w * item.fitRatio), h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
            if (item.placeholder && !item.loaded) {
                item.placeholder.style.width = w + 'px';
                item.placeholder.style.height = h + 'px';
            }
            img.style.width = w + 'px';
            img.style.height = h + 'px';
        }, _appendImagesPool = function _appendImagesPool() {
            if (_imagesToAppendPool.length) {
                var poolItem;
                for(var i = 0; i < _imagesToAppendPool.length; i++){
                    poolItem = _imagesToAppendPool[i];
                    if (poolItem.holder.index === poolItem.index) _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
                }
                _imagesToAppendPool = [];
            }
        };
        _registerModule('Controller', {
            publicMethods: {
                lazyLoadItem: function lazyLoadItem(index) {
                    index = _getLoopedId(index);
                    var item = _getItemAt(index);
                    if (!item || (item.loaded || item.loading) && !_itemsNeedUpdate) return;
                    _shout('gettingData', index, item);
                    if (!item.src) return;
                    _preloadImage(item);
                },
                initController: function initController() {
                    framework.extend(_options, _controllerDefaultOptions, true);
                    self.items = _items = items;
                    _getItemAt = self.getItemAt;
                    _getNumItems = _options.getNumItemsFn; //self.getNumItems;
                    _initialIsLoop = _options.loop;
                    if (_getNumItems() < 3) _options.loop = false; // disable loop if less then 3 items
                    _listen('beforeChange', function(diff) {
                        var p = _options.preload, isNext = diff === null ? true : diff >= 0, preloadBefore = Math.min(p[0], _getNumItems()), preloadAfter = Math.min(p[1], _getNumItems()), i;
                        for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++)self.lazyLoadItem(_currentItemIndex + i);
                        for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++)self.lazyLoadItem(_currentItemIndex - i);
                    });
                    _listen('initialLayout', function() {
                        self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
                    });
                    _listen('mainScrollAnimComplete', _appendImagesPool);
                    _listen('initialZoomInEnd', _appendImagesPool);
                    _listen('destroy', function() {
                        var item;
                        for(var i = 0; i < _items.length; i++){
                            item = _items[i];
                            // remove reference to DOM elements, for GC
                            if (item.container) item.container = null;
                            if (item.placeholder) item.placeholder = null;
                            if (item.img) item.img = null;
                            if (item.preloader) item.preloader = null;
                            if (item.loadError) item.loaded = item.loadError = false;
                        }
                        _imagesToAppendPool = null;
                    });
                },
                getItemAt: function getItemAt(index) {
                    if (index >= 0) return _items[index] !== undefined ? _items[index] : false;
                    return false;
                },
                allowProgressiveImg: function allowProgressiveImg() {
                    // 1. Progressive image loading isn't working on webkit/blink 
                    //    when hw-acceleration (e.g. translateZ) is applied to IMG element.
                    //    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
                    //    
                    // 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
                    //    That's why it's disabled on touch devices (mainly because of swipe transition)
                    //    
                    // 3. Progressive image loading sometimes doesn't work in IE (up to 11).
                    // Don't allow progressive loading on non-large touch devices
                    return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
                // 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
                },
                setContent: function setContent(holder, index) {
                    if (_options.loop) index = _getLoopedId(index);
                    var prevItem = self.getItemAt(holder.index);
                    if (prevItem) prevItem.container = null;
                    var item = self.getItemAt(index), img;
                    if (!item) {
                        holder.el.innerHTML = '';
                        return;
                    }
                    // allow to override data
                    _shout('gettingData', index, item);
                    holder.index = index;
                    holder.item = item;
                    // base container DIV is created only once for each of 3 holders
                    var baseDiv = item.container = framework.createEl('pswp__zoom-wrap');
                    if (!item.src && item.html) {
                        if (item.html.tagName) baseDiv.appendChild(item.html);
                        else baseDiv.innerHTML = item.html;
                    }
                    _checkForError(item);
                    _calculateItemSize(item, _viewportSize);
                    if (item.src && !item.loadError && !item.loaded) {
                        item.loadComplete = function(item) {
                            // gallery closed before image finished loading
                            if (!_isOpen) return;
                            // check if holder hasn't changed while image was loading
                            if (holder && holder.index === index) {
                                if (_checkForError(item, true)) {
                                    item.loadComplete = item.img = null;
                                    _calculateItemSize(item, _viewportSize);
                                    _applyZoomPanToItem(item);
                                    if (holder.index === _currentItemIndex) // recalculate dimensions
                                    self.updateCurrZoomItem();
                                    return;
                                }
                                if (!item.imageAppended) {
                                    if (_features.transform && (_mainScrollAnimating || _initialZoomRunning)) _imagesToAppendPool.push({
                                        item: item,
                                        baseDiv: baseDiv,
                                        img: item.img,
                                        index: index,
                                        holder: holder,
                                        clearPlaceholder: true
                                    });
                                    else _appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
                                } else // remove preloader & mini-img
                                if (!_initialZoomRunning && item.placeholder) {
                                    item.placeholder.style.display = 'none';
                                    item.placeholder = null;
                                }
                            }
                            item.loadComplete = null;
                            item.img = null; // no need to store image element after it's added
                            _shout('imageLoadComplete', index, item);
                        };
                        if (framework.features.transform) {
                            var placeholderClassName = 'pswp__img pswp__img--placeholder';
                            placeholderClassName += item.msrc ? '' : ' pswp__img--placeholder--blank';
                            var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
                            if (item.msrc) placeholder.src = item.msrc;
                            _setImageSize(item, placeholder);
                            baseDiv.appendChild(placeholder);
                            item.placeholder = placeholder;
                        }
                        if (!item.loading) _preloadImage(item);
                        if (self.allowProgressiveImg()) {
                            // just append image
                            if (!_initialContentSet && _features.transform) _imagesToAppendPool.push({
                                item: item,
                                baseDiv: baseDiv,
                                img: item.img,
                                index: index,
                                holder: holder
                            });
                            else _appendImage(index, item, baseDiv, item.img, true, true);
                        }
                    } else if (item.src && !item.loadError) {
                        // image object is created every time, due to bugs of image loading & delay when switching images
                        img = framework.createEl('pswp__img', 'img');
                        img.style.opacity = 1;
                        img.src = item.src;
                        _setImageSize(item, img);
                        _appendImage(index, item, baseDiv, img, true);
                    }
                    if (!_initialContentSet && index === _currentItemIndex) {
                        _currZoomElementStyle = baseDiv.style;
                        _showOrHide(item, img || item.img);
                    } else _applyZoomPanToItem(item);
                    holder.el.innerHTML = '';
                    holder.el.appendChild(baseDiv);
                },
                cleanSlide: function cleanSlide(item) {
                    if (item.img) item.img.onload = item.img.onerror = null;
                    item.loaded = item.loading = item.img = item.imageAppended = false;
                }
            }
        });
        /*>>items-controller*/ /*>>tap*/ /**
 * tap.js:
 *
 * Displatches tap and double-tap events.
 * 
 */ var tapTimer, tapReleasePoint = {}, _dispatchTapEvent = function _dispatchTapEvent(origEvent, releasePoint, pointerType) {
            var e = document.createEvent('CustomEvent'), eDetail = {
                origEvent: origEvent,
                target: origEvent.target,
                releasePoint: releasePoint,
                pointerType: pointerType || 'touch'
            };
            e.initCustomEvent('pswpTap', true, true, eDetail);
            origEvent.target.dispatchEvent(e);
        };
        _registerModule('Tap', {
            publicMethods: {
                initTap: function initTap() {
                    _listen('firstTouchStart', self.onTapStart);
                    _listen('touchRelease', self.onTapRelease);
                    _listen('destroy', function() {
                        tapReleasePoint = {};
                        tapTimer = null;
                    });
                },
                onTapStart: function onTapStart(touchList) {
                    if (touchList.length > 1) {
                        clearTimeout(tapTimer);
                        tapTimer = null;
                    }
                },
                onTapRelease: function onTapRelease(e, releasePoint) {
                    if (!releasePoint) return;
                    if (!_moved && !_isMultitouch && !_numAnimations) {
                        var p0 = releasePoint;
                        if (tapTimer) {
                            clearTimeout(tapTimer);
                            tapTimer = null;
                            // Check if taped on the same place
                            if (_isNearbyPoints(p0, tapReleasePoint)) {
                                _shout('doubleTap', p0);
                                return;
                            }
                        }
                        if (releasePoint.type === 'mouse') {
                            _dispatchTapEvent(e, releasePoint, 'mouse');
                            return;
                        }
                        var clickedTagName = e.target.tagName.toUpperCase();
                        // avoid double tap delay on buttons and elements that have class pswp__single-tap
                        if (clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap')) {
                            _dispatchTapEvent(e, releasePoint);
                            return;
                        }
                        _equalizePoints(tapReleasePoint, p0);
                        tapTimer = setTimeout(function() {
                            _dispatchTapEvent(e, releasePoint);
                            tapTimer = null;
                        }, 300);
                    }
                }
            }
        });
        /*>>tap*/ /*>>desktop-zoom*/ /**
 *
 * desktop-zoom.js:
 *
 * - Binds mousewheel event for paning zoomed image.
 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
 *   (which are used for cursors and zoom icon)
 * - Adds toggleDesktopZoom function.
 * 
 */ var _wheelDelta;
        _registerModule('DesktopZoom', {
            publicMethods: {
                initDesktopZoom: function initDesktopZoom() {
                    if (_oldIE) // no zoom for old IE (<=8)
                    return;
                    if (_likelyTouchDevice) // if detected hardware touch support, we wait until mouse is used,
                    // and only then apply desktop-zoom features
                    _listen('mouseUsed', function() {
                        self.setupDesktopZoom();
                    });
                    else self.setupDesktopZoom(true);
                },
                setupDesktopZoom: function setupDesktopZoom(onInit) {
                    _wheelDelta = {};
                    var events = 'wheel mousewheel DOMMouseScroll';
                    _listen('bindEvents', function() {
                        framework.bind(template, events, self.handleMouseWheel);
                    });
                    _listen('unbindEvents', function() {
                        if (_wheelDelta) framework.unbind(template, events, self.handleMouseWheel);
                    });
                    self.mouseZoomedIn = false;
                    var hasDraggingClass, updateZoomable = function updateZoomable() {
                        if (self.mouseZoomedIn) {
                            framework.removeClass(template, 'pswp--zoomed-in');
                            self.mouseZoomedIn = false;
                        }
                        if (_currZoomLevel < 1) framework.addClass(template, 'pswp--zoom-allowed');
                        else framework.removeClass(template, 'pswp--zoom-allowed');
                        removeDraggingClass();
                    }, removeDraggingClass = function removeDraggingClass() {
                        if (hasDraggingClass) {
                            framework.removeClass(template, 'pswp--dragging');
                            hasDraggingClass = false;
                        }
                    };
                    _listen('resize', updateZoomable);
                    _listen('afterChange', updateZoomable);
                    _listen('pointerDown', function() {
                        if (self.mouseZoomedIn) {
                            hasDraggingClass = true;
                            framework.addClass(template, 'pswp--dragging');
                        }
                    });
                    _listen('pointerUp', removeDraggingClass);
                    if (!onInit) updateZoomable();
                },
                handleMouseWheel: function handleMouseWheel(e) {
                    if (_currZoomLevel <= self.currItem.fitRatio) {
                        if (_options.modal) {
                            if (!_options.closeOnScroll || _numAnimations || _isDragging) e.preventDefault();
                            else if (_transformKey && Math.abs(e.deltaY) > 2) {
                                // close PhotoSwipe
                                // if browser supports transforms & scroll changed enough
                                _closedByScroll = true;
                                self.close();
                            }
                        }
                        return true;
                    }
                    // allow just one event to fire
                    e.stopPropagation();
                    // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
                    _wheelDelta.x = 0;
                    if ('deltaX' in e) {
                        if (e.deltaMode === 1 /* DOM_DELTA_LINE */ ) {
                            // 18 - average line height
                            _wheelDelta.x = e.deltaX * 18;
                            _wheelDelta.y = e.deltaY * 18;
                        } else {
                            _wheelDelta.x = e.deltaX;
                            _wheelDelta.y = e.deltaY;
                        }
                    } else if ('wheelDelta' in e) {
                        if (e.wheelDeltaX) _wheelDelta.x = -0.16 * e.wheelDeltaX;
                        if (e.wheelDeltaY) _wheelDelta.y = -0.16 * e.wheelDeltaY;
                        else _wheelDelta.y = -0.16 * e.wheelDelta;
                    } else if ('detail' in e) _wheelDelta.y = e.detail;
                    else return;
                    _calculatePanBounds(_currZoomLevel, true);
                    var newPanX = _panOffset.x - _wheelDelta.x, newPanY = _panOffset.y - _wheelDelta.y;
                    // only prevent scrolling in nonmodal mode when not at edges
                    if (_options.modal || newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x && newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y) e.preventDefault();
                    // TODO: use rAF instead of mousewheel?
                    self.panTo(newPanX, newPanY);
                },
                toggleDesktopZoom: function toggleDesktopZoom(centerPoint) {
                    centerPoint = centerPoint || {
                        x: _viewportSize.x / 2 + _offset.x,
                        y: _viewportSize.y / 2 + _offset.y
                    };
                    var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
                    var zoomOut = _currZoomLevel === doubleTapZoomLevel;
                    self.mouseZoomedIn = !zoomOut;
                    self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
                    framework[(!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
                }
            }
        });
        /*>>desktop-zoom*/ /*>>history*/ /**
 *
 * history.js:
 *
 * - Back button to close gallery.
 * 
 * - Unique URL for each slide: example.com/&pid=1&gid=3
 *   (where PID is picture index, and GID and gallery index)
 *   
 * - Switch URL when slides change.
 * 
 */ var _historyDefaultOptions = {
            history: true,
            galleryUID: 1
        };
        var _historyUpdateTimeout, _hashChangeTimeout, _hashAnimCheckTimeout, _hashChangedByScript, _hashChangedByHistory, _hashReseted, _initialHash, _historyChanged, _closedFromURL, _urlChangedOnce, _windowLoc, _supportsPushState, _getHash = function _getHash() {
            return _windowLoc.hash.substring(1);
        }, _cleanHistoryTimeouts = function _cleanHistoryTimeouts() {
            if (_historyUpdateTimeout) clearTimeout(_historyUpdateTimeout);
            if (_hashAnimCheckTimeout) clearTimeout(_hashAnimCheckTimeout);
        }, // pid - Picture index
        // gid - Gallery index
        _parseItemIndexFromURL = function _parseItemIndexFromURL() {
            var hash = _getHash(), params = {};
            if (hash.length < 5) return params;
            var i, vars = hash.split('&');
            for(i = 0; i < vars.length; i++){
                if (!vars[i]) continue;
                var pair = vars[i].split('=');
                if (pair.length < 2) continue;
                params[pair[0]] = pair[1];
            }
            if (_options.galleryPIDs) {
                // detect custom pid in hash and search for it among the items collection
                var searchfor = params.pid;
                params.pid = 0; // if custom pid cannot be found, fallback to the first item
                for(i = 0; i < _items.length; i++)if (_items[i].pid === searchfor) {
                    params.pid = i;
                    break;
                }
            } else params.pid = parseInt(params.pid, 10) - 1;
            if (params.pid < 0) params.pid = 0;
            return params;
        }, _updateHash = function _updateHash1() {
            if (_hashAnimCheckTimeout) clearTimeout(_hashAnimCheckTimeout);
            if (_numAnimations || _isDragging) {
                // changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
                // that's why we update hash only when no animations running
                _hashAnimCheckTimeout = setTimeout(_updateHash, 500);
                return;
            }
            if (_hashChangedByScript) clearTimeout(_hashChangeTimeout);
            else _hashChangedByScript = true;
            var pid = _currentItemIndex + 1;
            var item = _getItemAt(_currentItemIndex);
            if (item.hasOwnProperty('pid')) // carry forward any custom pid assigned to the item
            pid = item.pid;
            var newHash = _initialHash + '&' + 'gid=' + _options.galleryUID + '&' + 'pid=' + pid;
            if (!_historyChanged) {
                if (_windowLoc.hash.indexOf(newHash) === -1) _urlChangedOnce = true;
            }
            var newURL = _windowLoc.href.split('#')[0] + '#' + newHash;
            if (_supportsPushState) {
                if ('#' + newHash !== window.location.hash) history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
            } else if (_historyChanged) _windowLoc.replace(newURL);
            else _windowLoc.hash = newHash;
            _historyChanged = true;
            _hashChangeTimeout = setTimeout(function() {
                _hashChangedByScript = false;
            }, 60);
        };
        _registerModule('History', {
            publicMethods: {
                initHistory: function initHistory() {
                    framework.extend(_options, _historyDefaultOptions, true);
                    if (!_options.history) return;
                    _windowLoc = window.location;
                    _urlChangedOnce = false;
                    _closedFromURL = false;
                    _historyChanged = false;
                    _initialHash = _getHash();
                    _supportsPushState = 'pushState' in history;
                    if (_initialHash.indexOf('gid=') > -1) {
                        _initialHash = _initialHash.split('&gid=')[0];
                        _initialHash = _initialHash.split('?gid=')[0];
                    }
                    _listen('afterChange', self.updateURL);
                    _listen('unbindEvents', function() {
                        framework.unbind(window, 'hashchange', self.onHashChange);
                    });
                    var returnToOriginal = function returnToOriginal() {
                        _hashReseted = true;
                        if (!_closedFromURL) {
                            if (_urlChangedOnce) history.back();
                            else {
                                if (_initialHash) _windowLoc.hash = _initialHash;
                                else if (_supportsPushState) // remove hash from url without refreshing it or scrolling to top
                                history.pushState('', document.title, _windowLoc.pathname + _windowLoc.search);
                                else _windowLoc.hash = '';
                            }
                        }
                        _cleanHistoryTimeouts();
                    };
                    _listen('unbindEvents', function() {
                        if (_closedByScroll) // if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
                        // this is done to keep the scroll position
                        returnToOriginal();
                    });
                    _listen('destroy', function() {
                        if (!_hashReseted) returnToOriginal();
                    });
                    _listen('firstUpdate', function() {
                        _currentItemIndex = _parseItemIndexFromURL().pid;
                    });
                    var index = _initialHash.indexOf('pid=');
                    if (index > -1) {
                        _initialHash = _initialHash.substring(0, index);
                        if (_initialHash.slice(-1) === '&') _initialHash = _initialHash.slice(0, -1);
                    }
                    setTimeout(function() {
                        if (_isOpen) framework.bind(window, 'hashchange', self.onHashChange);
                    }, 40);
                },
                onHashChange: function onHashChange() {
                    if (_getHash() === _initialHash) {
                        _closedFromURL = true;
                        self.close();
                        return;
                    }
                    if (!_hashChangedByScript) {
                        _hashChangedByHistory = true;
                        self.goTo(_parseItemIndexFromURL().pid);
                        _hashChangedByHistory = false;
                    }
                },
                updateURL: function updateURL() {
                    // Delay the update of URL, to avoid lag during transition, 
                    // and to not to trigger actions like "refresh page sound" or "blinking favicon" to often
                    _cleanHistoryTimeouts();
                    if (_hashChangedByHistory) return;
                    if (!_historyChanged) _updateHash(); // first time
                    else _historyUpdateTimeout = setTimeout(_updateHash, 800);
                }
            }
        });
        /*>>history*/ framework.extend(self, publicMethods);
    };
    return PhotoSwipe;
});


var $600a160352c63dd1$exports = {};
/**
*
* UI on top of main sliding area (caption, arrows, close button, etc.).
* Built just using public methods/properties of PhotoSwipe.
* 
*/ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else $600a160352c63dd1$exports = factory();
})($600a160352c63dd1$exports, function() {
    'use strict';
    var PhotoSwipeUI_Default = function PhotoSwipeUI_Default(pswp, framework) {
        var ui = this;
        var _overlayUIUpdated = false, _controlsVisible = true, _fullscrenAPI, _controls, _captionContainer, _fakeCaptionContainer, _indexIndicator, _shareButton, _shareModal, _shareModalHidden = true, _initalCloseOnScrollValue, _isIdle, _listen, _loadingIndicator, _loadingIndicatorHidden, _loadingIndicatorTimeout, _galleryHasOneSlide, _options, _defaultUIOptions = {
            barsSize: {
                top: 44,
                bottom: 'auto'
            },
            closeElClasses: [
                'item',
                'caption',
                'zoom-wrap',
                'ui',
                'top-bar'
            ],
            timeToIdle: 4000,
            timeToIdleOutside: 1000,
            loadingIndicatorDelay: 1000,
            addCaptionHTMLFn: function addCaptionHTMLFn(item, captionEl /*, isFake */ ) {
                if (!item.title) {
                    captionEl.children[0].innerHTML = '';
                    return false;
                }
                captionEl.children[0].innerHTML = item.title;
                return true;
            },
            closeEl: true,
            captionEl: true,
            fullscreenEl: true,
            zoomEl: true,
            shareEl: true,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true,
            tapToClose: false,
            tapToToggleControls: true,
            clickToCloseNonZoomable: true,
            shareButtons: [
                {
                    id: 'facebook',
                    label: 'Share on Facebook',
                    url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}'
                },
                {
                    id: 'twitter',
                    label: 'Tweet',
                    url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'
                },
                {
                    id: 'pinterest',
                    label: 'Pin it',
                    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                },
                {
                    id: 'download',
                    label: 'Download image',
                    url: '{{raw_image_url}}',
                    download: true
                }
            ],
            getImageURLForShare: function getImageURLForShare() {
                return pswp.currItem.src || '';
            },
            getPageURLForShare: function getPageURLForShare() {
                return window.location.href;
            },
            getTextForShare: function getTextForShare() {
                return pswp.currItem.title || '';
            },
            indexIndicatorSep: ' / ',
            fitControlsWidth: 1200
        }, _blockControlsTap, _blockControlsTapTimeout;
        var _onControlsTap = function _onControlsTap(e) {
            if (_blockControlsTap) return true;
            e = e || window.event;
            if (_options.timeToIdle && _options.mouseUsed && !_isIdle) // reset idle timer
            _onIdleMouseMove();
            var target = e.target || e.srcElement, uiElement, clickedClass = target.getAttribute('class') || '', found;
            for(var i = 0; i < _uiElements.length; i++){
                uiElement = _uiElements[i];
                if (uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name) > -1) {
                    uiElement.onTap();
                    found = true;
                }
            }
            if (found) {
                if (e.stopPropagation) e.stopPropagation();
                _blockControlsTap = true;
                // Some versions of Android don't prevent ghost click event 
                // when preventDefault() was called on touchstart and/or touchend.
                // 
                // This happens on v4.3, 4.2, 4.1, 
                // older versions strangely work correctly, 
                // but just in case we add delay on all of them)	
                var tapDelay = framework.features.isOldAndroid ? 600 : 30;
                _blockControlsTapTimeout = setTimeout(function() {
                    _blockControlsTap = false;
                }, tapDelay);
            }
        }, _fitControlsInViewport = function _fitControlsInViewport() {
            return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
        }, _togglePswpClass = function _togglePswpClass(el, cName, add) {
            framework[(add ? 'add' : 'remove') + 'Class'](el, 'pswp__' + cName);
        }, // add class when there is just one item in the gallery
        // (by default it hides left/right arrows and 1ofX counter)
        _countNumItems = function _countNumItems() {
            var hasOneSlide = _options.getNumItemsFn() === 1;
            if (hasOneSlide !== _galleryHasOneSlide) {
                _togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
                _galleryHasOneSlide = hasOneSlide;
            }
        }, _toggleShareModalClass = function _toggleShareModalClass() {
            _togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
        }, _toggleShareModal = function _toggleShareModal() {
            _shareModalHidden = !_shareModalHidden;
            if (!_shareModalHidden) {
                _toggleShareModalClass();
                setTimeout(function() {
                    if (!_shareModalHidden) framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
                }, 30);
            } else {
                framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
                setTimeout(function() {
                    if (_shareModalHidden) _toggleShareModalClass();
                }, 300);
            }
            if (!_shareModalHidden) _updateShareURLs();
            return false;
        }, _openWindowPopup = function _openWindowPopup(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            pswp.shout('shareLinkClick', e, target);
            if (!target.href) return false;
            if (target.hasAttribute('download')) return true;
            window.open(target.href, 'pswp_share', "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100));
            if (!_shareModalHidden) _toggleShareModal();
            return false;
        }, _updateShareURLs = function _updateShareURLs() {
            var shareButtonOut = '', shareButtonData, shareURL, image_url, page_url, share_text;
            for(var i = 0; i < _options.shareButtons.length; i++){
                shareButtonData = _options.shareButtons[i];
                image_url = _options.getImageURLForShare(shareButtonData);
                page_url = _options.getPageURLForShare(shareButtonData);
                share_text = _options.getTextForShare(shareButtonData);
                shareURL = shareButtonData.url.replace('{{url}}', encodeURIComponent(page_url)).replace('{{image_url}}', encodeURIComponent(image_url)).replace('{{raw_image_url}}', image_url).replace('{{text}}', encodeURIComponent(share_text));
                shareButtonOut += '<a href="' + shareURL + '" target="_blank" ' + 'class="pswp__share--' + shareButtonData.id + '"' + (shareButtonData.download ? 'download' : '') + '>' + shareButtonData.label + '</a>';
                if (_options.parseShareButtonOut) shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
            }
            _shareModal.children[0].innerHTML = shareButtonOut;
            _shareModal.children[0].onclick = _openWindowPopup;
        }, _hasCloseClass = function _hasCloseClass(target) {
            for(var i = 0; i < _options.closeElClasses.length; i++){
                if (framework.hasClass(target, 'pswp__' + _options.closeElClasses[i])) return true;
            }
        }, _idleInterval, _idleTimer, _idleIncrement = 0, _onIdleMouseMove = function _onIdleMouseMove() {
            clearTimeout(_idleTimer);
            _idleIncrement = 0;
            if (_isIdle) ui.setIdle(false);
        }, _onMouseLeaveWindow = function _onMouseLeaveWindow(e) {
            e = e ? e : window.event;
            var from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName === 'HTML') {
                clearTimeout(_idleTimer);
                _idleTimer = setTimeout(function() {
                    ui.setIdle(true);
                }, _options.timeToIdleOutside);
            }
        }, _setupFullscreenAPI = function _setupFullscreenAPI() {
            if (_options.fullscreenEl && !framework.features.isOldAndroid) {
                if (!_fullscrenAPI) _fullscrenAPI = ui.getFullscreenAPI();
                if (_fullscrenAPI) {
                    framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
                    ui.updateFullscreen();
                    framework.addClass(pswp.template, 'pswp--supports-fs');
                } else framework.removeClass(pswp.template, 'pswp--supports-fs');
            }
        }, _setupLoadingIndicator = function _setupLoadingIndicator() {
            // Setup loading indicator
            if (_options.preloaderEl) {
                _toggleLoadingIndicator(true);
                _listen('beforeChange', function() {
                    clearTimeout(_loadingIndicatorTimeout);
                    // display loading indicator with delay
                    _loadingIndicatorTimeout = setTimeout(function() {
                        if (pswp.currItem && pswp.currItem.loading) {
                            if (!pswp.allowProgressiveImg() || pswp.currItem.img && !pswp.currItem.img.naturalWidth) // show preloader if progressive loading is not enabled, 
                            // or image width is not defined yet (because of slow connection)
                            _toggleLoadingIndicator(false);
                        // items-controller.js function allowProgressiveImg
                        } else _toggleLoadingIndicator(true); // hide preloader
                    }, _options.loadingIndicatorDelay);
                });
                _listen('imageLoadComplete', function(index, item) {
                    if (pswp.currItem === item) _toggleLoadingIndicator(true);
                });
            }
        }, _toggleLoadingIndicator = function _toggleLoadingIndicator(hide) {
            if (_loadingIndicatorHidden !== hide) {
                _togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
                _loadingIndicatorHidden = hide;
            }
        }, _applyNavBarGaps = function _applyNavBarGaps(item) {
            var gap = item.vGap;
            if (_fitControlsInViewport()) {
                var bars = _options.barsSize;
                if (_options.captionEl && bars.bottom === 'auto') {
                    if (!_fakeCaptionContainer) {
                        _fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
                        _fakeCaptionContainer.appendChild(framework.createEl('pswp__caption__center'));
                        _controls.insertBefore(_fakeCaptionContainer, _captionContainer);
                        framework.addClass(_controls, 'pswp__ui--fit');
                    }
                    if (_options.addCaptionHTMLFn(item, _fakeCaptionContainer, true)) {
                        var captionSize = _fakeCaptionContainer.clientHeight;
                        gap.bottom = parseInt(captionSize, 10) || 44;
                    } else gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
                } else gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
                // height of top bar is static, no need to calculate it
                gap.top = bars.top;
            } else gap.top = gap.bottom = 0;
        }, _setupIdle = function _setupIdle() {
            // Hide controls when mouse is used
            if (_options.timeToIdle) _listen('mouseUsed', function() {
                framework.bind(document, 'mousemove', _onIdleMouseMove);
                framework.bind(document, 'mouseout', _onMouseLeaveWindow);
                _idleInterval = setInterval(function() {
                    _idleIncrement++;
                    if (_idleIncrement === 2) ui.setIdle(true);
                }, _options.timeToIdle / 2);
            });
        }, _setupHidingControlsDuringGestures = function _setupHidingControlsDuringGestures() {
            // Hide controls on vertical drag
            _listen('onVerticalDrag', function(now) {
                if (_controlsVisible && now < 0.95) ui.hideControls();
                else if (!_controlsVisible && now >= 0.95) ui.showControls();
            });
            // Hide controls when pinching to close
            var pinchControlsHidden;
            _listen('onPinchClose', function(now) {
                if (_controlsVisible && now < 0.9) {
                    ui.hideControls();
                    pinchControlsHidden = true;
                } else if (pinchControlsHidden && !_controlsVisible && now > 0.9) ui.showControls();
            });
            _listen('zoomGestureEnded', function() {
                pinchControlsHidden = false;
                if (pinchControlsHidden && !_controlsVisible) ui.showControls();
            });
        };
        var _uiElements = [
            {
                name: 'caption',
                option: 'captionEl',
                onInit: function onInit(el) {
                    _captionContainer = el;
                }
            },
            {
                name: 'share-modal',
                option: 'shareEl',
                onInit: function onInit(el) {
                    _shareModal = el;
                },
                onTap: function onTap() {
                    _toggleShareModal();
                }
            },
            {
                name: 'button--share',
                option: 'shareEl',
                onInit: function onInit(el) {
                    _shareButton = el;
                },
                onTap: function onTap() {
                    _toggleShareModal();
                }
            },
            {
                name: 'button--zoom',
                option: 'zoomEl',
                onTap: pswp.toggleDesktopZoom
            },
            {
                name: 'counter',
                option: 'counterEl',
                onInit: function onInit(el) {
                    _indexIndicator = el;
                }
            },
            {
                name: 'button--close',
                option: 'closeEl',
                onTap: pswp.close
            },
            {
                name: 'button--arrow--left',
                option: 'arrowEl',
                onTap: pswp.prev
            },
            {
                name: 'button--arrow--right',
                option: 'arrowEl',
                onTap: pswp.next
            },
            {
                name: 'button--fs',
                option: 'fullscreenEl',
                onTap: function onTap() {
                    if (_fullscrenAPI.isFullscreen()) _fullscrenAPI.exit();
                    else _fullscrenAPI.enter();
                }
            },
            {
                name: 'preloader',
                option: 'preloaderEl',
                onInit: function onInit(el) {
                    _loadingIndicator = el;
                }
            }
        ];
        var _setupUIElements = function _setupUIElements() {
            var item, classAttr, uiElement;
            var loopThroughChildElements = function loopThroughChildElements(sChildren) {
                if (!sChildren) return;
                var l = sChildren.length;
                for(var i = 0; i < l; i++){
                    item = sChildren[i];
                    classAttr = item.className;
                    for(var a = 0; a < _uiElements.length; a++){
                        uiElement = _uiElements[a];
                        if (classAttr.indexOf('pswp__' + uiElement.name) > -1) {
                            if (_options[uiElement.option]) {
                                framework.removeClass(item, 'pswp__element--disabled');
                                if (uiElement.onInit) uiElement.onInit(item);
                            //item.style.display = 'block';
                            } else framework.addClass(item, 'pswp__element--disabled');
                        }
                    }
                }
            };
            loopThroughChildElements(_controls.children);
            var topBar = framework.getChildByClass(_controls, 'pswp__top-bar');
            if (topBar) loopThroughChildElements(topBar.children);
        };
        ui.init = function() {
            // extend options
            framework.extend(pswp.options, _defaultUIOptions, true);
            // create local link for fast access
            _options = pswp.options;
            // find pswp__ui element
            _controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');
            // create local link
            _listen = pswp.listen;
            _setupHidingControlsDuringGestures();
            // update controls when slides change
            _listen('beforeChange', ui.update);
            // toggle zoom on double-tap
            _listen('doubleTap', function(point) {
                var initialZoomLevel = pswp.currItem.initialZoomLevel;
                if (pswp.getZoomLevel() !== initialZoomLevel) pswp.zoomTo(initialZoomLevel, point, 333);
                else pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
            });
            // Allow text selection in caption
            _listen('preventDragEvent', function(e, isDown, preventObj) {
                var t = e.target || e.srcElement;
                if (t && t.getAttribute('class') && e.type.indexOf('mouse') > -1 && (t.getAttribute('class').indexOf('__caption') > 0 || /(SMALL|STRONG|EM)/i.test(t.tagName))) preventObj.prevent = false;
            });
            // bind events for UI
            _listen('bindEvents', function() {
                framework.bind(_controls, 'pswpTap click', _onControlsTap);
                framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
                if (!pswp.likelyTouchDevice) framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
            });
            // unbind events for UI
            _listen('unbindEvents', function() {
                if (!_shareModalHidden) _toggleShareModal();
                if (_idleInterval) clearInterval(_idleInterval);
                framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
                framework.unbind(document, 'mousemove', _onIdleMouseMove);
                framework.unbind(_controls, 'pswpTap click', _onControlsTap);
                framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
                framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
                if (_fullscrenAPI) {
                    framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
                    if (_fullscrenAPI.isFullscreen()) {
                        _options.hideAnimationDuration = 0;
                        _fullscrenAPI.exit();
                    }
                    _fullscrenAPI = null;
                }
            });
            // clean up things when gallery is destroyed
            _listen('destroy', function() {
                if (_options.captionEl) {
                    if (_fakeCaptionContainer) _controls.removeChild(_fakeCaptionContainer);
                    framework.removeClass(_captionContainer, 'pswp__caption--empty');
                }
                if (_shareModal) _shareModal.children[0].onclick = null;
                framework.removeClass(_controls, 'pswp__ui--over-close');
                framework.addClass(_controls, 'pswp__ui--hidden');
                ui.setIdle(false);
            });
            if (!_options.showAnimationDuration) framework.removeClass(_controls, 'pswp__ui--hidden');
            _listen('initialZoomIn', function() {
                if (_options.showAnimationDuration) framework.removeClass(_controls, 'pswp__ui--hidden');
            });
            _listen('initialZoomOut', function() {
                framework.addClass(_controls, 'pswp__ui--hidden');
            });
            _listen('parseVerticalMargin', _applyNavBarGaps);
            _setupUIElements();
            if (_options.shareEl && _shareButton && _shareModal) _shareModalHidden = true;
            _countNumItems();
            _setupIdle();
            _setupFullscreenAPI();
            _setupLoadingIndicator();
        };
        ui.setIdle = function(isIdle) {
            _isIdle = isIdle;
            _togglePswpClass(_controls, 'ui--idle', isIdle);
        };
        ui.update = function() {
            // Don't update UI if it's hidden
            if (_controlsVisible && pswp.currItem) {
                ui.updateIndexIndicator();
                if (_options.captionEl) {
                    _options.addCaptionHTMLFn(pswp.currItem, _captionContainer);
                    _togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
                }
                _overlayUIUpdated = true;
            } else _overlayUIUpdated = false;
            if (!_shareModalHidden) _toggleShareModal();
            _countNumItems();
        };
        ui.updateFullscreen = function(e) {
            if (e) // some browsers change window scroll position during the fullscreen
            // so PhotoSwipe updates it just in case
            setTimeout(function() {
                pswp.setScrollOffset(0, framework.getScrollY());
            }, 50);
            // toogle pswp--fs class on root element
            framework[(_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class'](pswp.template, 'pswp--fs');
        };
        ui.updateIndexIndicator = function() {
            if (_options.counterEl) _indexIndicator.innerHTML = pswp.getCurrentIndex() + 1 + _options.indexIndicatorSep + _options.getNumItemsFn();
        };
        ui.onGlobalTap = function(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (_blockControlsTap) return;
            if (e.detail && e.detail.pointerType === 'mouse') {
                // close gallery if clicked outside of the image
                if (_hasCloseClass(target)) {
                    pswp.close();
                    return;
                }
                if (framework.hasClass(target, 'pswp__img')) {
                    if (pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
                        if (_options.clickToCloseNonZoomable) pswp.close();
                    } else pswp.toggleDesktopZoom(e.detail.releasePoint);
                }
            } else {
                // tap anywhere (except buttons) to toggle visibility of controls
                if (_options.tapToToggleControls) {
                    if (_controlsVisible) ui.hideControls();
                    else ui.showControls();
                }
                // tap to close gallery
                if (_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target))) {
                    pswp.close();
                    return;
                }
            }
        };
        ui.onMouseOver = function(e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            // add class when mouse is over an element that should close the gallery
            _togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
        };
        ui.hideControls = function() {
            framework.addClass(_controls, 'pswp__ui--hidden');
            _controlsVisible = false;
        };
        ui.showControls = function() {
            _controlsVisible = true;
            if (!_overlayUIUpdated) ui.update();
            framework.removeClass(_controls, 'pswp__ui--hidden');
        };
        ui.supportsFullscreen = function() {
            var d = document;
            return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
        };
        ui.getFullscreenAPI = function() {
            var dE = document.documentElement, api, tF = 'fullscreenchange';
            if (dE.requestFullscreen) api = {
                enterK: 'requestFullscreen',
                exitK: 'exitFullscreen',
                elementK: 'fullscreenElement',
                eventK: tF
            };
            else if (dE.mozRequestFullScreen) api = {
                enterK: 'mozRequestFullScreen',
                exitK: 'mozCancelFullScreen',
                elementK: 'mozFullScreenElement',
                eventK: 'moz' + tF
            };
            else if (dE.webkitRequestFullscreen) api = {
                enterK: 'webkitRequestFullscreen',
                exitK: 'webkitExitFullscreen',
                elementK: 'webkitFullscreenElement',
                eventK: 'webkit' + tF
            };
            else if (dE.msRequestFullscreen) api = {
                enterK: 'msRequestFullscreen',
                exitK: 'msExitFullscreen',
                elementK: 'msFullscreenElement',
                eventK: 'MSFullscreenChange'
            };
            if (api) {
                api.enter = function() {
                    // disable close-on-scroll in fullscreen
                    _initalCloseOnScrollValue = _options.closeOnScroll;
                    _options.closeOnScroll = false;
                    if (this.enterK === 'webkitRequestFullscreen') pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                    else return pswp.template[this.enterK]();
                };
                api.exit = function() {
                    _options.closeOnScroll = _initalCloseOnScrollValue;
                    return document[this.exitK]();
                };
                api.isFullscreen = function() {
                    return document[this.elementK];
                };
            }
            return api;
        };
    };
    return PhotoSwipeUI_Default;
});


var $21b3f89bf1a8b494$var$jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($f64da8404daade49$exports)));
(function($, PhotoSwipe) {
    'use strict';
    var PhotoGallery = function PhotoGallery1(element, options) {
        this.$element = $(element);
        this.options = $.extend({}, PhotoGallery.DEFAULTS, options);
        this.$items = this.$element.find(this.options.itemSelector);
        if (this.options.itemFilter) this.$items = this.$items.filter(this.options.itemFilter);
        this.$pswpElement = $(this.options.pswpElement);
        var that = this;
        this.pswpItems = this.$items.map(function() {
            var el = $(this);
            var size = el.data('size').split('x');
            return {
                src: el.attr('href'),
                w: size[0],
                h: size[1],
                el: el[0],
                title: el.parent().find(that.options.captionSelector).html()
            };
        }).get();
        var self = this;
        this.$element.on('click', this.options.itemSelector, function(e) {
            // build items array
            e.preventDefault();
            self.show(this);
        });
    };
    PhotoGallery.DEFAULTS = {
        ui: (0, (/*@__PURE__*/$parcel$interopDefault($600a160352c63dd1$exports))),
        pswpElement: '.pswp',
        itemSelector: 'a.gallery__enlarge',
        itemFilter: null,
        captionSelector: '.caption'
    };
    PhotoGallery.prototype.show = function(element) {
        // define options (if needed)
        var options = $.extend({}, this.options, {
            index: this.$items.index($(element))
        });
        // Initializes and opens PhotoSwipe
        var gallery = new PhotoSwipe(this.$pswpElement[0], this.options.ui, this.pswpItems, options);
        gallery.init();
    };
    // PLUGIN DEFINITION
    // ========================
    $.fn.photogallery = function(option) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('sr.photogallery');
            var options = (typeof option === "undefined" ? "undefined" : (0, $ewv1T._)(option)) === 'object' && option;
            if (!data) $this.data('sr.photogallery', data = new PhotoGallery(this, options));
        });
    };
    $.fn.photogallery.Constructor = PhotoGallery;
})($21b3f89bf1a8b494$var$jQuery, (0, (/*@__PURE__*/$parcel$interopDefault($9dfdb671d882e02b$exports))));



var $4VdIx = parcelRequire("4VdIx");

var $4VdIx = parcelRequire("4VdIx");
(function() {
    (0, $4VdIx.default).defineExtension('alpine-morph', {
        isInlineSwap: function isInlineSwap(swapStyle) {
            return swapStyle === 'morph';
        },
        handleSwap: function handleSwap(swapStyle, target, fragment) {
            if (swapStyle === 'morph') {
                if (fragment.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                    Alpine.morph(target, fragment.firstElementChild);
                    return [
                        target
                    ];
                } else {
                    Alpine.morph(target, fragment.outerHTML);
                    return [
                        target
                    ];
                }
            }
        }
    });
})();


// packages/morph/src/morph.js

var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $kNmtb = parcelRequire("kNmtb");
function $b9dbeb345f84b541$var$morph(from, toHtml, options) {
    $b9dbeb345f84b541$var$monkeyPatchDomSetAttributeToAllowAtSymbols();
    var context = $b9dbeb345f84b541$var$createMorphContext(options);
    var toEl = typeof toHtml === "string" ? $b9dbeb345f84b541$var$createElement(toHtml) : toHtml;
    if (window.Alpine && window.Alpine.closestDataStack && !from._x_dataStack) {
        toEl._x_dataStack = window.Alpine.closestDataStack(from);
        toEl._x_dataStack && window.Alpine.cloneNode(from, toEl);
    }
    context.patch(from, toEl);
    return from;
}
function $b9dbeb345f84b541$var$morphBetween(startMarker, endMarker, toHtml) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    $b9dbeb345f84b541$var$monkeyPatchDomSetAttributeToAllowAtSymbols();
    var context = $b9dbeb345f84b541$var$createMorphContext(options);
    var fromContainer = startMarker.parentNode;
    var fromBlock = new $b9dbeb345f84b541$var$Block(startMarker, endMarker);
    var toContainer = typeof toHtml === "string" ? function() {
        var container = document.createElement("div");
        container.insertAdjacentHTML("beforeend", toHtml);
        return container;
    }() : toHtml;
    var toStartMarker = document.createComment("[morph-start]");
    var toEndMarker = document.createComment("[morph-end]");
    toContainer.insertBefore(toStartMarker, toContainer.firstChild);
    toContainer.appendChild(toEndMarker);
    var toBlock = new $b9dbeb345f84b541$var$Block(toStartMarker, toEndMarker);
    if (window.Alpine && window.Alpine.closestDataStack) {
        toContainer._x_dataStack = window.Alpine.closestDataStack(fromContainer);
        toContainer._x_dataStack && window.Alpine.cloneNode(fromContainer, toContainer);
    }
    context.patchChildren(fromBlock, toBlock);
}
function $b9dbeb345f84b541$var$createMorphContext() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var defaultGetKey = function(el) {
        return el.getAttribute("key");
    };
    var noop = function() {};
    var context = {
        key: options.key || defaultGetKey,
        lookahead: options.lookahead || false,
        updating: options.updating || noop,
        updated: options.updated || noop,
        removing: options.removing || noop,
        removed: options.removed || noop,
        adding: options.adding || noop,
        added: options.added || noop
    };
    context.patch = function(from, to) {
        if (context.differentElementNamesTypesOrKeys(from, to)) return context.swapElements(from, to);
        var updateChildrenOnly = false;
        var skipChildren = false;
        var skipUntil = function(predicate) {
            return context.skipUntilCondition = predicate;
        };
        if ($b9dbeb345f84b541$var$shouldSkipChildren(context.updating, function() {
            return skipChildren = true;
        }, skipUntil, from, to, function() {
            return updateChildrenOnly = true;
        })) return;
        if (from.nodeType === 1 && window.Alpine) {
            window.Alpine.cloneNode(from, to);
            if (from._x_teleport && to._x_teleport) context.patch(from._x_teleport, to._x_teleport);
        }
        if ($b9dbeb345f84b541$var$textOrComment(to)) {
            context.patchNodeValue(from, to);
            context.updated(from, to);
            return;
        }
        if (!updateChildrenOnly) context.patchAttributes(from, to);
        context.updated(from, to);
        if (!skipChildren) context.patchChildren(from, to);
    };
    context.differentElementNamesTypesOrKeys = function(from, to) {
        return from.nodeType != to.nodeType || from.nodeName != to.nodeName || context.getKey(from) != context.getKey(to);
    };
    context.swapElements = function(from, to) {
        if ($b9dbeb345f84b541$var$shouldSkip(context.removing, from)) return;
        var toCloned = to.cloneNode(true);
        if ($b9dbeb345f84b541$var$shouldSkip(context.adding, toCloned)) return;
        from.replaceWith(toCloned);
        context.removed(from);
        context.added(toCloned);
    };
    context.patchNodeValue = function(from, to) {
        var value = to.nodeValue;
        if (from.nodeValue !== value) from.nodeValue = value;
    };
    context.patchAttributes = function(from, to) {
        if (from._x_transitioning) return;
        if (from._x_isShown && !to._x_isShown) return;
        if (!from._x_isShown && to._x_isShown) return;
        var domAttributes = Array.from(from.attributes);
        var toAttributes = Array.from(to.attributes);
        for(var i = domAttributes.length - 1; i >= 0; i--){
            var name = domAttributes[i].name;
            if (!to.hasAttribute(name)) from.removeAttribute(name);
        }
        for(var i1 = toAttributes.length - 1; i1 >= 0; i1--){
            var name1 = toAttributes[i1].name;
            var value = toAttributes[i1].value;
            if (from.getAttribute(name1) !== value) from.setAttribute(name1, value);
        }
    };
    context.patchChildren = function(from, to) {
        var fromKeys = context.keyToMap(from.children);
        var fromKeyHoldovers = {};
        var currentTo = $b9dbeb345f84b541$var$getFirstNode(to);
        var currentFrom = $b9dbeb345f84b541$var$getFirstNode(from);
        while(currentTo){
            $b9dbeb345f84b541$var$seedingMatchingId(currentTo, currentFrom);
            var toKey = context.getKey(currentTo);
            var fromKey = context.getKey(currentFrom);
            if (context.skipUntilCondition) {
                var fromDone = !currentFrom || context.skipUntilCondition(currentFrom);
                var toDone = !currentTo || context.skipUntilCondition(currentTo);
                if (fromDone && toDone) context.skipUntilCondition = null;
                else {
                    if (!fromDone) currentFrom = currentFrom && $b9dbeb345f84b541$var$getNextSibling(from, currentFrom);
                    if (!toDone) currentTo = currentTo && $b9dbeb345f84b541$var$getNextSibling(to, currentTo);
                    continue;
                }
            }
            if (!currentFrom) {
                if (toKey && fromKeyHoldovers[toKey]) {
                    var holdover = fromKeyHoldovers[toKey];
                    from.appendChild(holdover);
                    currentFrom = holdover;
                    fromKey = context.getKey(currentFrom);
                } else {
                    if (!$b9dbeb345f84b541$var$shouldSkip(context.adding, currentTo)) {
                        var clone = currentTo.cloneNode(true);
                        from.appendChild(clone);
                        context.added(clone);
                    }
                    currentTo = $b9dbeb345f84b541$var$getNextSibling(to, currentTo);
                    continue;
                }
            }
            var isIf = function(node) {
                return node && node.nodeType === 8 && node.textContent === "[if BLOCK]><![endif]";
            };
            var isEnd = function(node) {
                return node && node.nodeType === 8 && node.textContent === "[if ENDBLOCK]><![endif]";
            };
            if (isIf(currentTo) && isIf(currentFrom)) {
                var nestedIfCount = 0;
                var fromBlockStart = currentFrom;
                while(currentFrom){
                    var next = $b9dbeb345f84b541$var$getNextSibling(from, currentFrom);
                    if (isIf(next)) nestedIfCount++;
                    else if (isEnd(next) && nestedIfCount > 0) nestedIfCount--;
                    else if (isEnd(next) && nestedIfCount === 0) {
                        currentFrom = next;
                        break;
                    }
                    currentFrom = next;
                }
                var fromBlockEnd = currentFrom;
                nestedIfCount = 0;
                var toBlockStart = currentTo;
                while(currentTo){
                    var next1 = $b9dbeb345f84b541$var$getNextSibling(to, currentTo);
                    if (isIf(next1)) nestedIfCount++;
                    else if (isEnd(next1) && nestedIfCount > 0) nestedIfCount--;
                    else if (isEnd(next1) && nestedIfCount === 0) {
                        currentTo = next1;
                        break;
                    }
                    currentTo = next1;
                }
                var toBlockEnd = currentTo;
                var fromBlock = new $b9dbeb345f84b541$var$Block(fromBlockStart, fromBlockEnd);
                var toBlock = new $b9dbeb345f84b541$var$Block(toBlockStart, toBlockEnd);
                context.patchChildren(fromBlock, toBlock);
                continue;
            }
            if (currentFrom.nodeType === 1 && context.lookahead && !currentFrom.isEqualNode(currentTo)) {
                var nextToElementSibling = $b9dbeb345f84b541$var$getNextSibling(to, currentTo);
                var found = false;
                while(!found && nextToElementSibling){
                    if (nextToElementSibling.nodeType === 1 && currentFrom.isEqualNode(nextToElementSibling)) {
                        found = true;
                        currentFrom = context.addNodeBefore(from, currentTo, currentFrom);
                        fromKey = context.getKey(currentFrom);
                    }
                    nextToElementSibling = $b9dbeb345f84b541$var$getNextSibling(to, nextToElementSibling);
                }
            }
            if (toKey !== fromKey) {
                if (!toKey && fromKey) {
                    fromKeyHoldovers[fromKey] = currentFrom;
                    currentFrom = context.addNodeBefore(from, currentTo, currentFrom);
                    fromKeyHoldovers[fromKey].remove();
                    currentFrom = $b9dbeb345f84b541$var$getNextSibling(from, currentFrom);
                    currentTo = $b9dbeb345f84b541$var$getNextSibling(to, currentTo);
                    continue;
                }
                if (toKey && !fromKey) {
                    if (fromKeys[toKey]) {
                        currentFrom.replaceWith(fromKeys[toKey]);
                        currentFrom = fromKeys[toKey];
                        fromKey = context.getKey(currentFrom);
                    }
                }
                if (toKey && fromKey) {
                    var fromKeyNode = fromKeys[toKey];
                    if (fromKeyNode) {
                        fromKeyHoldovers[fromKey] = currentFrom;
                        currentFrom.replaceWith(fromKeyNode);
                        currentFrom = fromKeyNode;
                        fromKey = context.getKey(currentFrom);
                    } else {
                        fromKeyHoldovers[fromKey] = currentFrom;
                        currentFrom = context.addNodeBefore(from, currentTo, currentFrom);
                        fromKeyHoldovers[fromKey].remove();
                        currentFrom = $b9dbeb345f84b541$var$getNextSibling(from, currentFrom);
                        currentTo = $b9dbeb345f84b541$var$getNextSibling(to, currentTo);
                        continue;
                    }
                }
            }
            var currentFromNext = currentFrom && $b9dbeb345f84b541$var$getNextSibling(from, currentFrom);
            context.patch(currentFrom, currentTo);
            currentTo = currentTo && $b9dbeb345f84b541$var$getNextSibling(to, currentTo);
            currentFrom = currentFromNext;
        }
        var removals = [];
        while(currentFrom){
            if (!$b9dbeb345f84b541$var$shouldSkip(context.removing, currentFrom)) removals.push(currentFrom);
            currentFrom = $b9dbeb345f84b541$var$getNextSibling(from, currentFrom);
        }
        while(removals.length){
            var domForRemoval = removals.shift();
            domForRemoval.remove();
            context.removed(domForRemoval);
        }
    };
    context.getKey = function(el) {
        return el && el.nodeType === 1 && context.key(el);
    };
    context.keyToMap = function(els) {
        var map = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var el = _step.value;
                var theKey = context.getKey(el);
                if (theKey) map[theKey] = el;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return map;
    };
    context.addNodeBefore = function(parent, node, beforeMe) {
        if (!$b9dbeb345f84b541$var$shouldSkip(context.adding, node)) {
            var clone = node.cloneNode(true);
            parent.insertBefore(clone, beforeMe);
            context.added(clone);
            return clone;
        }
        return node;
    };
    return context;
}
$b9dbeb345f84b541$var$morph.step = function() {};
$b9dbeb345f84b541$var$morph.log = function() {};
function $b9dbeb345f84b541$var$shouldSkip(hook) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var skip = false;
    hook.apply(void 0, (0, $kNmtb._)(args).concat([
        function() {
            return skip = true;
        }
    ]));
    return skip;
}
function $b9dbeb345f84b541$var$shouldSkipChildren(hook, skipChildren, skipUntil) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        args[_key - 3] = arguments[_key];
    }
    var skip = false;
    hook.apply(void 0, (0, $kNmtb._)(args).concat([
        function() {
            return skip = true;
        },
        skipChildren,
        skipUntil
    ]));
    return skip;
}
var $b9dbeb345f84b541$var$patched = false;
function $b9dbeb345f84b541$var$createElement(html) {
    var template = document.createElement("template");
    template.innerHTML = html;
    return template.content.firstElementChild;
}
function $b9dbeb345f84b541$var$textOrComment(el) {
    return el.nodeType === 3 || el.nodeType === 8;
}
var $b9dbeb345f84b541$var$Block = /*#__PURE__*/ function() {
    "use strict";
    function Block(start, end) {
        (0, $ioD88._)(this, Block);
        this.startComment = start;
        this.endComment = end;
    }
    (0, $6NCFa._)(Block, [
        {
            key: "children",
            get: function get() {
                var children = [];
                var currentNode = this.startComment.nextSibling;
                while(currentNode && currentNode !== this.endComment){
                    children.push(currentNode);
                    currentNode = currentNode.nextSibling;
                }
                return children;
            }
        },
        {
            key: "appendChild",
            value: function appendChild(child) {
                this.endComment.before(child);
            }
        },
        {
            key: "firstChild",
            get: function get() {
                var first = this.startComment.nextSibling;
                if (first === this.endComment) return;
                return first;
            }
        },
        {
            key: "nextNode",
            value: function nextNode(reference) {
                var next = reference.nextSibling;
                if (next === this.endComment) return;
                return next;
            }
        },
        {
            key: "insertBefore",
            value: function insertBefore(newNode, reference) {
                reference.before(newNode);
                return newNode;
            }
        }
    ]);
    return Block;
}();
function $b9dbeb345f84b541$var$getFirstNode(parent) {
    return parent.firstChild;
}
function $b9dbeb345f84b541$var$getNextSibling(parent, reference) {
    var next;
    if (parent instanceof $b9dbeb345f84b541$var$Block) next = parent.nextNode(reference);
    else next = reference.nextSibling;
    return next;
}
function $b9dbeb345f84b541$var$monkeyPatchDomSetAttributeToAllowAtSymbols() {
    if ($b9dbeb345f84b541$var$patched) return;
    $b9dbeb345f84b541$var$patched = true;
    var original = Element.prototype.setAttribute;
    var hostDiv = document.createElement("div");
    Element.prototype.setAttribute = function newSetAttribute(name, value) {
        if (!name.includes("@")) return original.call(this, name, value);
        hostDiv.innerHTML = "<span ".concat(name, '="').concat(value, '"></span>');
        var attr = hostDiv.firstElementChild.getAttributeNode(name);
        hostDiv.firstElementChild.removeAttributeNode(attr);
        this.setAttributeNode(attr);
    };
}
function $b9dbeb345f84b541$var$seedingMatchingId(to, from) {
    var fromId = from && from._x_bindings && from._x_bindings.id;
    if (!fromId) return;
    if (!to.setAttribute) return;
    to.setAttribute("id", fromId);
    to.id = fromId;
}
// packages/morph/src/index.js
function $b9dbeb345f84b541$export$2e5e8c41f5d4e7c7(Alpine) {
    Alpine.morph = $b9dbeb345f84b541$var$morph;
    Alpine.morphBetween = $b9dbeb345f84b541$var$morphBetween;
}
// packages/morph/builds/module.js
var $b9dbeb345f84b541$export$2e2bcd8739ae039 = $b9dbeb345f84b541$export$2e5e8c41f5d4e7c7;


// packages/alpinejs/src/scheduler.js
function $e6fe89782e482601$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e6fe89782e482601$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $e6fe89782e482601$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e6fe89782e482601$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $6lD0P = parcelRequire("6lD0P");

var $8lZHN = parcelRequire("8lZHN");

var $esDIr = parcelRequire("esDIr");
function $d4b6be0ca7345616$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



var $kNmtb = parcelRequire("kNmtb");

var $ewv1T = parcelRequire("ewv1T");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $ewv1T = parcelRequire("ewv1T");
var $15f39fe0df078b1e$var$extendStatics = function extendStatics1(d, b) {
    $15f39fe0df078b1e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $15f39fe0df078b1e$var$extendStatics(d, b);
};
function $15f39fe0df078b1e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $15f39fe0df078b1e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $15f39fe0df078b1e$export$18ce0697a983be9b = function __assign1() {
    $15f39fe0df078b1e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15f39fe0df078b1e$export$18ce0697a983be9b.apply(this, arguments);
};
function $15f39fe0df078b1e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $15f39fe0df078b1e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $ewv1T._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $15f39fe0df078b1e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $15f39fe0df078b1e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $ewv1T._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $15f39fe0df078b1e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $15f39fe0df078b1e$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $ewv1T._)(x)) === "symbol" ? x : "".concat(x);
}
function $15f39fe0df078b1e$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $ewv1T._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $15f39fe0df078b1e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $ewv1T._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $15f39fe0df078b1e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $15f39fe0df078b1e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $15f39fe0df078b1e$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $15f39fe0df078b1e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $15f39fe0df078b1e$export$45d3717a4c69092e(o, m, p);
}
function $15f39fe0df078b1e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $15f39fe0df078b1e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $15f39fe0df078b1e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($15f39fe0df078b1e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $15f39fe0df078b1e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $15f39fe0df078b1e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $15f39fe0df078b1e$export$10c90e4f7922046c(v) {
    return this instanceof $15f39fe0df078b1e$export$10c90e4f7922046c ? (this.v = v, this) : new $15f39fe0df078b1e$export$10c90e4f7922046c(v);
}
function $15f39fe0df078b1e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $15f39fe0df078b1e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $15f39fe0df078b1e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $15f39fe0df078b1e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $15f39fe0df078b1e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $15f39fe0df078b1e$export$19a8beecd37a4c45 === "function" ? $15f39fe0df078b1e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $15f39fe0df078b1e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $15f39fe0df078b1e$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $15f39fe0df078b1e$var$ownKeys = function ownKeys1(o) {
    $15f39fe0df078b1e$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $15f39fe0df078b1e$var$ownKeys(o);
};
function $15f39fe0df078b1e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $15f39fe0df078b1e$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $15f39fe0df078b1e$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $15f39fe0df078b1e$var$__setModuleDefault(result, mod);
    return result;
}
function $15f39fe0df078b1e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $15f39fe0df078b1e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $15f39fe0df078b1e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $15f39fe0df078b1e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $ewv1T._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $15f39fe0df078b1e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $15f39fe0df078b1e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $15f39fe0df078b1e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $15f39fe0df078b1e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $15f39fe0df078b1e$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $15f39fe0df078b1e$export$2e2bcd8739ae039 = {
    __extends: $15f39fe0df078b1e$export$a8ba968b8961cb8a,
    __assign: $15f39fe0df078b1e$export$18ce0697a983be9b,
    __rest: $15f39fe0df078b1e$export$3c9a16f847548506,
    __decorate: $15f39fe0df078b1e$export$29e00dfd3077644b,
    __param: $15f39fe0df078b1e$export$d5ad3fd78186038f,
    __esDecorate: $15f39fe0df078b1e$export$3a84e1ae4e97e9b0,
    __runInitializers: $15f39fe0df078b1e$export$d831c04e792af3d,
    __propKey: $15f39fe0df078b1e$export$6a2a36740a146cb8,
    __setFunctionName: $15f39fe0df078b1e$export$d1a06452d3489bc7,
    __metadata: $15f39fe0df078b1e$export$f1db080c865becb9,
    __awaiter: $15f39fe0df078b1e$export$1050f835b63b671e,
    __generator: $15f39fe0df078b1e$export$67ebef60e6f28a6,
    __createBinding: $15f39fe0df078b1e$export$45d3717a4c69092e,
    __exportStar: $15f39fe0df078b1e$export$f33643c0debef087,
    __values: $15f39fe0df078b1e$export$19a8beecd37a4c45,
    __read: $15f39fe0df078b1e$export$8d051b38c9118094,
    __spread: $15f39fe0df078b1e$export$afc72e2116322959,
    __spreadArrays: $15f39fe0df078b1e$export$6388937ca91ccae8,
    __spreadArray: $15f39fe0df078b1e$export$1216008129fb82ed,
    __await: $15f39fe0df078b1e$export$10c90e4f7922046c,
    __asyncGenerator: $15f39fe0df078b1e$export$e427f37a30a4de9b,
    __asyncDelegator: $15f39fe0df078b1e$export$bbd80228419bb833,
    __asyncValues: $15f39fe0df078b1e$export$e3b29a3d6162315f,
    __makeTemplateObject: $15f39fe0df078b1e$export$4fb47efe1390b86f,
    __importStar: $15f39fe0df078b1e$export$c21735bcef00d192,
    __importDefault: $15f39fe0df078b1e$export$da59b14a69baef04,
    __classPrivateFieldGet: $15f39fe0df078b1e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $15f39fe0df078b1e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $15f39fe0df078b1e$export$81fdc39f203e4e04,
    __addDisposableResource: $15f39fe0df078b1e$export$88ac25d8e944e405,
    __disposeResources: $15f39fe0df078b1e$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $15f39fe0df078b1e$export$889dfb5d17574b0b
};


function $06dab374eda57fc5$var$_templateObject() {
    var _$data = (0, $d4b6be0ca7345616$export$71511d61b312f219)([
        "Cannot find directive `",
        "`. `",
        "` will use the default order of execution"
    ], [
        "Cannot find directive \\`",
        "\\`. \\`",
        "\\` will use the default order of execution"
    ]);
    $06dab374eda57fc5$var$_templateObject = function _templateObject() {
        return _$data;
    };
    return _$data;
}
var $06dab374eda57fc5$var$flushPending = false;
var $06dab374eda57fc5$var$flushing = false;
var $06dab374eda57fc5$var$queue = [];
var $06dab374eda57fc5$var$lastFlushedIndex = -1;
function $06dab374eda57fc5$var$scheduler(callback) {
    $06dab374eda57fc5$var$queueJob(callback);
}
function $06dab374eda57fc5$var$queueJob(job) {
    if (!$06dab374eda57fc5$var$queue.includes(job)) $06dab374eda57fc5$var$queue.push(job);
    $06dab374eda57fc5$var$queueFlush();
}
function $06dab374eda57fc5$var$dequeueJob(job) {
    var index = $06dab374eda57fc5$var$queue.indexOf(job);
    if (index !== -1 && index > $06dab374eda57fc5$var$lastFlushedIndex) $06dab374eda57fc5$var$queue.splice(index, 1);
}
function $06dab374eda57fc5$var$queueFlush() {
    if (!$06dab374eda57fc5$var$flushing && !$06dab374eda57fc5$var$flushPending) {
        $06dab374eda57fc5$var$flushPending = true;
        queueMicrotask($06dab374eda57fc5$var$flushJobs);
    }
}
function $06dab374eda57fc5$var$flushJobs() {
    $06dab374eda57fc5$var$flushPending = false;
    $06dab374eda57fc5$var$flushing = true;
    for(var i = 0; i < $06dab374eda57fc5$var$queue.length; i++){
        $06dab374eda57fc5$var$queue[i]();
        $06dab374eda57fc5$var$lastFlushedIndex = i;
    }
    $06dab374eda57fc5$var$queue.length = 0;
    $06dab374eda57fc5$var$lastFlushedIndex = -1;
    $06dab374eda57fc5$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $06dab374eda57fc5$var$reactive;
var $06dab374eda57fc5$var$effect;
var $06dab374eda57fc5$var$release;
var $06dab374eda57fc5$var$raw;
var $06dab374eda57fc5$var$shouldSchedule = true;
function $06dab374eda57fc5$var$disableEffectScheduling(callback) {
    $06dab374eda57fc5$var$shouldSchedule = false;
    callback();
    $06dab374eda57fc5$var$shouldSchedule = true;
}
function $06dab374eda57fc5$var$setReactivityEngine(engine) {
    $06dab374eda57fc5$var$reactive = engine.reactive;
    $06dab374eda57fc5$var$release = engine.release;
    $06dab374eda57fc5$var$effect = function(callback) {
        return engine.effect(callback, {
            scheduler: function(task) {
                if ($06dab374eda57fc5$var$shouldSchedule) $06dab374eda57fc5$var$scheduler(task);
                else task();
            }
        });
    };
    $06dab374eda57fc5$var$raw = engine.raw;
}
function $06dab374eda57fc5$var$overrideEffect(override) {
    $06dab374eda57fc5$var$effect = override;
}
function $06dab374eda57fc5$var$elementBoundEffect(el) {
    var cleanup2 = function() {};
    var wrappedEffect = function(callback) {
        var effectReference = $06dab374eda57fc5$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = function() {
                el._x_effects.forEach(function(i) {
                    return i();
                });
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = function() {
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $06dab374eda57fc5$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        function() {
            cleanup2();
        }
    ];
}
function $06dab374eda57fc5$var$watch(getter, callback) {
    var firstTime = true;
    var oldValue;
    var effectReference = $06dab374eda57fc5$var$effect(function() {
        var value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(function() {
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return function() {
        return $06dab374eda57fc5$var$release(effectReference);
    };
}
// packages/alpinejs/src/mutation.js
var $06dab374eda57fc5$var$onAttributeAddeds = [];
var $06dab374eda57fc5$var$onElRemoveds = [];
var $06dab374eda57fc5$var$onElAddeds = [];
function $06dab374eda57fc5$var$onElAdded(callback) {
    $06dab374eda57fc5$var$onElAddeds.push(callback);
}
function $06dab374eda57fc5$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $06dab374eda57fc5$var$onElRemoveds.push(callback);
    }
}
function $06dab374eda57fc5$var$onAttributesAdded(callback) {
    $06dab374eda57fc5$var$onAttributeAddeds.push(callback);
}
function $06dab374eda57fc5$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $06dab374eda57fc5$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(function(param) {
        var _param = (0, $esDIr._)(param, 2), name = _param[0], value = _param[1];
        if (names === void 0 || names.includes(name)) {
            value.forEach(function(i) {
                return i();
            });
            delete el._x_attributeCleanups[name];
        }
    });
}
function $06dab374eda57fc5$var$cleanupElement(el) {
    var _el__x_effects, _el__x_cleanups;
    (_el__x_effects = el._x_effects) === null || _el__x_effects === void 0 ? void 0 : _el__x_effects.forEach($06dab374eda57fc5$var$dequeueJob);
    while((_el__x_cleanups = el._x_cleanups) === null || _el__x_cleanups === void 0 ? void 0 : _el__x_cleanups.length)el._x_cleanups.pop()();
}
var $06dab374eda57fc5$var$observer = new MutationObserver($06dab374eda57fc5$var$onMutate);
var $06dab374eda57fc5$var$currentlyObserving = false;
function $06dab374eda57fc5$var$startObservingMutations() {
    $06dab374eda57fc5$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $06dab374eda57fc5$var$currentlyObserving = true;
}
function $06dab374eda57fc5$var$stopObservingMutations() {
    $06dab374eda57fc5$var$flushObserver();
    $06dab374eda57fc5$var$observer.disconnect();
    $06dab374eda57fc5$var$currentlyObserving = false;
}
var $06dab374eda57fc5$var$queuedMutations = [];
function $06dab374eda57fc5$var$flushObserver() {
    var records = $06dab374eda57fc5$var$observer.takeRecords();
    $06dab374eda57fc5$var$queuedMutations.push(function() {
        return records.length > 0 && $06dab374eda57fc5$var$onMutate(records);
    });
    var queueLengthWhenTriggered = $06dab374eda57fc5$var$queuedMutations.length;
    queueMicrotask(function() {
        if ($06dab374eda57fc5$var$queuedMutations.length === queueLengthWhenTriggered) while($06dab374eda57fc5$var$queuedMutations.length > 0)$06dab374eda57fc5$var$queuedMutations.shift()();
    });
}
function $06dab374eda57fc5$var$mutateDom(callback) {
    if (!$06dab374eda57fc5$var$currentlyObserving) return callback();
    $06dab374eda57fc5$var$stopObservingMutations();
    var result = callback();
    $06dab374eda57fc5$var$startObservingMutations();
    return result;
}
var $06dab374eda57fc5$var$isCollecting = false;
var $06dab374eda57fc5$var$deferredMutations = [];
function $06dab374eda57fc5$var$deferMutations() {
    $06dab374eda57fc5$var$isCollecting = true;
}
function $06dab374eda57fc5$var$flushAndStopDeferringMutations() {
    $06dab374eda57fc5$var$isCollecting = false;
    $06dab374eda57fc5$var$onMutate($06dab374eda57fc5$var$deferredMutations);
    $06dab374eda57fc5$var$deferredMutations = [];
}
function $06dab374eda57fc5$var$onMutate(mutations) {
    var _loop = function(i) {
        if (mutations[i].target._x_ignoreMutationObserver) return "continue";
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            var el = mutations[i].target;
            var name = mutations[i].attributeName;
            var oldValue = mutations[i].oldValue;
            var add2 = function() {
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            var remove = function() {
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    };
    if ($06dab374eda57fc5$var$isCollecting) {
        $06dab374eda57fc5$var$deferredMutations = $06dab374eda57fc5$var$deferredMutations.concat(mutations);
        return;
    }
    var addedNodes = [];
    var removedNodes = /* @__PURE__ */ new Set();
    var addedAttributes = /* @__PURE__ */ new Map();
    var removedAttributes = /* @__PURE__ */ new Map();
    for(var i = 0; i < mutations.length; i++)_loop(i);
    removedAttributes.forEach(function(attrs, el) {
        $06dab374eda57fc5$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach(function(attrs, el) {
        $06dab374eda57fc5$var$onAttributeAddeds.forEach(function(i) {
            return i(el, attrs);
        });
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop1 = function() {
            var node = _step.value;
            if (addedNodes.some(function(i) {
                return i.contains(node);
            })) return "continue";
            $06dab374eda57fc5$var$onElRemoveds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator = removedNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop2 = function() {
            var node = _step1.value;
            if (!node.isConnected) return "continue";
            $06dab374eda57fc5$var$onElAddeds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator1 = addedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop2();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $06dab374eda57fc5$var$scope(node) {
    return $06dab374eda57fc5$var$mergeProxies($06dab374eda57fc5$var$closestDataStack(node));
}
function $06dab374eda57fc5$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2
    ].concat((0, $kNmtb._)($06dab374eda57fc5$var$closestDataStack(referenceNode || node)));
    return function() {
        node._x_dataStack = node._x_dataStack.filter(function(i) {
            return i !== data2;
        });
    };
}
function $06dab374eda57fc5$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $06dab374eda57fc5$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $06dab374eda57fc5$var$closestDataStack(node.parentNode);
}
function $06dab374eda57fc5$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $06dab374eda57fc5$var$mergeProxyTrap);
}
var $06dab374eda57fc5$var$mergeProxyTrap = {
    ownKeys: function(param) {
        var objects = param.objects;
        return Array.from(new Set(objects.flatMap(function(i) {
            return Object.keys(i);
        })));
    },
    has: function(param, name) {
        var objects = param.objects;
        if (name == Symbol.unscopables) return false;
        return objects.some(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name);
        });
    },
    get: function(param, name, thisProxy) {
        var objects = param.objects;
        if (name == "toJSON") return $06dab374eda57fc5$var$collapseProxies;
        return Reflect.get(objects.find(function(obj) {
            return Reflect.has(obj, name);
        }) || {}, name, thisProxy);
    },
    set: function(param, name, value, thisProxy) {
        var objects = param.objects;
        var target = objects.find(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name);
        }) || objects[objects.length - 1];
        var descriptor = Object.getOwnPropertyDescriptor(target, name);
        if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.set) && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get)) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $06dab374eda57fc5$var$collapseProxies() {
    var _this = this;
    var keys = Reflect.ownKeys(this);
    return keys.reduce(function(acc, key) {
        acc[key] = Reflect.get(_this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $06dab374eda57fc5$var$initInterceptors(data2) {
    var isObject2 = function(val) {
        return (typeof val === "undefined" ? "undefined" : (0, $ewv1T._)(val)) === "object" && !Array.isArray(val) && val !== null;
    };
    var recurse = function(obj) {
        var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(function(param) {
            var _param = (0, $esDIr._)(param, 2), key = _param[0], _param_ = _param[1], value = _param_.value, enumerable = _param_.enumerable;
            if (enumerable === false || value === void 0) return;
            if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === "object" && value !== null && value.__v_skip) return;
            var path = basePath === "" ? key : "".concat(basePath, ".").concat(key);
            if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $06dab374eda57fc5$var$interceptor(callback) {
    var mutateObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize: function(data2, path, key) {
            return callback(this.initialValue, function() {
                return $06dab374eda57fc5$var$get(data2, path);
            }, function(value) {
                return $06dab374eda57fc5$var$set(data2, path, value);
            }, path, key);
        }
    };
    mutateObj(obj);
    return function(initialValue) {
        if ((typeof initialValue === "undefined" ? "undefined" : (0, $ewv1T._)(initialValue)) === "object" && initialValue !== null && initialValue._x_interceptor) {
            var initialize = obj.initialize.bind(obj);
            obj.initialize = function(data2, path, key) {
                var innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $06dab374eda57fc5$var$get(obj, path) {
    return path.split(".").reduce(function(carry, segment) {
        return carry[segment];
    }, obj);
}
function $06dab374eda57fc5$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $06dab374eda57fc5$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $06dab374eda57fc5$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $06dab374eda57fc5$var$magics = {};
function $06dab374eda57fc5$var$magic(name, callback) {
    $06dab374eda57fc5$var$magics[name] = callback;
}
function $06dab374eda57fc5$var$injectMagics(obj, el) {
    var memoizedUtilities = $06dab374eda57fc5$var$getUtilities(el);
    Object.entries($06dab374eda57fc5$var$magics).forEach(function(param) {
        var _param = (0, $esDIr._)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, "$".concat(name), {
            get: function() {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $06dab374eda57fc5$var$getUtilities(el) {
    var _getElementBoundUtilities = (0, $esDIr._)($06dab374eda57fc5$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    var utils = (0, $8lZHN._)({
        interceptor: $06dab374eda57fc5$var$interceptor
    }, utilities);
    $06dab374eda57fc5$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $06dab374eda57fc5$var$tryCatch(el, expression, callback) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        args[_key - 3] = arguments[_key];
    }
    try {
        return callback.apply(void 0, (0, $kNmtb._)(args));
    } catch (e) {
        $06dab374eda57fc5$var$handleError(e, el, expression);
    }
}
function $06dab374eda57fc5$var$handleError() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $06dab374eda57fc5$var$errorHandler.apply(void 0, (0, $kNmtb._)(args));
}
var $06dab374eda57fc5$var$errorHandler = $06dab374eda57fc5$var$normalErrorHandler;
function $06dab374eda57fc5$var$setErrorHandler(handler4) {
    $06dab374eda57fc5$var$errorHandler = handler4;
}
function $06dab374eda57fc5$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 !== null && error2 !== void 0 ? error2 : {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn("Alpine Expression Error: ".concat(error2.message, "\n\n").concat(expression ? 'Expression: "' + expression + '"\n\n' : ""), el);
    setTimeout(function() {
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $06dab374eda57fc5$var$shouldAutoEvaluateFunctions = true;
function $06dab374eda57fc5$var$dontAutoEvaluateFunctions(callback) {
    var cache = $06dab374eda57fc5$var$shouldAutoEvaluateFunctions;
    $06dab374eda57fc5$var$shouldAutoEvaluateFunctions = false;
    var result = callback();
    $06dab374eda57fc5$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $06dab374eda57fc5$var$evaluate(el, expression) {
    var extras = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var result;
    $06dab374eda57fc5$var$evaluateLater(el, expression)(function(value) {
        return result = value;
    }, extras);
    return result;
}
function $06dab374eda57fc5$var$evaluateLater() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $06dab374eda57fc5$var$theEvaluatorFunction.apply(void 0, (0, $kNmtb._)(args));
}
var $06dab374eda57fc5$var$theEvaluatorFunction = $06dab374eda57fc5$var$normalEvaluator;
function $06dab374eda57fc5$var$setEvaluator(newEvaluator) {
    $06dab374eda57fc5$var$theEvaluatorFunction = newEvaluator;
}
function $06dab374eda57fc5$var$normalEvaluator(el, expression) {
    var overriddenMagics = {};
    $06dab374eda57fc5$var$injectMagics(overriddenMagics, el);
    var dataStack = [
        overriddenMagics
    ].concat((0, $kNmtb._)($06dab374eda57fc5$var$closestDataStack(el)));
    var evaluator = typeof expression === "function" ? $06dab374eda57fc5$var$generateEvaluatorFromFunction(dataStack, expression) : $06dab374eda57fc5$var$generateEvaluatorFromString(dataStack, expression, el);
    return $06dab374eda57fc5$var$tryCatch.bind(null, el, expression, evaluator);
}
function $06dab374eda57fc5$var$generateEvaluatorFromFunction(dataStack, func) {
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params, context = _ref.context;
        var result = func.apply($06dab374eda57fc5$var$mergeProxies([
            scope2
        ].concat((0, $kNmtb._)(dataStack))), params);
        $06dab374eda57fc5$var$runIfTypeOfFunction(receiver, result);
    };
}
var $06dab374eda57fc5$var$evaluatorMemo = {};
function $06dab374eda57fc5$var$generateFunctionFromString(expression, el) {
    if ($06dab374eda57fc5$var$evaluatorMemo[expression]) return $06dab374eda57fc5$var$evaluatorMemo[expression];
    var AsyncFunction = Object.getPrototypeOf(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $e6fe89782e482601$export$71511d61b312f219)(function() {
            return (0, $15f39fe0df078b1e$export$67ebef60e6f28a6)(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    }).constructor;
    var rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? "(async()=>{ ".concat(expression, " })()") : expression;
    var safeAsyncFunction = function() {
        try {
            var func2 = new AsyncFunction([
                "__self",
                "scope"
            ], "with (scope) { __self.result = ".concat(rightSideSafeExpression, " }; __self.finished = true; return __self.result;"));
            Object.defineProperty(func2, "name", {
                value: "[Alpine] ".concat(expression)
            });
            return func2;
        } catch (error2) {
            $06dab374eda57fc5$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    var func = safeAsyncFunction();
    $06dab374eda57fc5$var$evaluatorMemo[expression] = func;
    return func;
}
function $06dab374eda57fc5$var$generateEvaluatorFromString(dataStack, expression, el) {
    var func = $06dab374eda57fc5$var$generateFunctionFromString(expression, el);
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params, context = _ref.context;
        func.result = void 0;
        func.finished = false;
        var completeScope = $06dab374eda57fc5$var$mergeProxies([
            scope2
        ].concat((0, $kNmtb._)(dataStack)));
        if (typeof func === "function") {
            var promise = func.call(context, func, completeScope).catch(function(error2) {
                return $06dab374eda57fc5$var$handleError(error2, el, expression);
            });
            if (func.finished) {
                $06dab374eda57fc5$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then(function(result) {
                $06dab374eda57fc5$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch(function(error2) {
                return $06dab374eda57fc5$var$handleError(error2, el, expression);
            }).finally(function() {
                return func.result = void 0;
            });
        }
    };
}
function $06dab374eda57fc5$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($06dab374eda57fc5$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        var result = value.apply(scope2, params);
        if (result instanceof Promise) result.then(function(i) {
            return $06dab374eda57fc5$var$runIfTypeOfFunction(receiver, i, scope2, params);
        }).catch(function(error2) {
            return $06dab374eda57fc5$var$handleError(error2, el, value);
        });
        else receiver(result);
    } else if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === "object" && value instanceof Promise) value.then(function(i) {
        return receiver(i);
    });
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $06dab374eda57fc5$var$prefixAsString = "x-";
function $06dab374eda57fc5$var$prefix() {
    var subject = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return $06dab374eda57fc5$var$prefixAsString + subject;
}
function $06dab374eda57fc5$var$setPrefix(newPrefix) {
    $06dab374eda57fc5$var$prefixAsString = newPrefix;
}
var $06dab374eda57fc5$var$directiveHandlers = {};
function $06dab374eda57fc5$var$directive(name, callback) {
    $06dab374eda57fc5$var$directiveHandlers[name] = callback;
    return {
        before: function(directive2) {
            if (!$06dab374eda57fc5$var$directiveHandlers[directive2]) {
                console.warn(String.raw($06dab374eda57fc5$var$_templateObject(), directive2, name));
                return;
            }
            var pos = $06dab374eda57fc5$var$directiveOrder.indexOf(directive2);
            $06dab374eda57fc5$var$directiveOrder.splice(pos >= 0 ? pos : $06dab374eda57fc5$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $06dab374eda57fc5$var$directiveExists(name) {
    return Object.keys($06dab374eda57fc5$var$directiveHandlers).includes(name);
}
function $06dab374eda57fc5$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        var vAttributes = Object.entries(el._x_virtualDirectives).map(function(param) {
            var _param = (0, $esDIr._)(param, 2), name = _param[0], value = _param[1];
            return {
                name: name,
                value: value
            };
        });
        var staticAttributes = $06dab374eda57fc5$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map(function(attribute) {
            if (staticAttributes.find(function(attr) {
                return attr.name === attribute.name;
            })) return {
                name: "x-bind:".concat(attribute.name),
                value: '"'.concat(attribute.value, '"')
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    var transformedAttributeMap = {};
    var directives2 = attributes.map($06dab374eda57fc5$var$toTransformedAttributes(function(newName, oldName) {
        return transformedAttributeMap[newName] = oldName;
    })).filter($06dab374eda57fc5$var$outNonAlpineAttributes).map($06dab374eda57fc5$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($06dab374eda57fc5$var$byPriority);
    return directives2.map(function(directive2) {
        return $06dab374eda57fc5$var$getDirectiveHandler(el, directive2);
    });
}
function $06dab374eda57fc5$var$attributesOnly(attributes) {
    return Array.from(attributes).map($06dab374eda57fc5$var$toTransformedAttributes()).filter(function(attr) {
        return !$06dab374eda57fc5$var$outNonAlpineAttributes(attr);
    });
}
var $06dab374eda57fc5$var$isDeferringHandlers = false;
var $06dab374eda57fc5$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $06dab374eda57fc5$var$currentHandlerStackKey = Symbol();
function $06dab374eda57fc5$var$deferHandlingDirectives(callback) {
    $06dab374eda57fc5$var$isDeferringHandlers = true;
    var key = Symbol();
    $06dab374eda57fc5$var$currentHandlerStackKey = key;
    $06dab374eda57fc5$var$directiveHandlerStacks.set(key, []);
    var flushHandlers = function() {
        while($06dab374eda57fc5$var$directiveHandlerStacks.get(key).length)$06dab374eda57fc5$var$directiveHandlerStacks.get(key).shift()();
        $06dab374eda57fc5$var$directiveHandlerStacks.delete(key);
    };
    var stopDeferring = function() {
        $06dab374eda57fc5$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $06dab374eda57fc5$var$getElementBoundUtilities(el) {
    var cleanups = [];
    var cleanup2 = function(callback) {
        return cleanups.push(callback);
    };
    var _elementBoundEffect = (0, $esDIr._)($06dab374eda57fc5$var$elementBoundEffect(el), 2), effect3 = _elementBoundEffect[0], cleanupEffect = _elementBoundEffect[1];
    cleanups.push(cleanupEffect);
    var utilities = {
        Alpine: $06dab374eda57fc5$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $06dab374eda57fc5$var$evaluateLater.bind($06dab374eda57fc5$var$evaluateLater, el),
        evaluate: $06dab374eda57fc5$var$evaluate.bind($06dab374eda57fc5$var$evaluate, el)
    };
    var doCleanup = function() {
        return cleanups.forEach(function(i) {
            return i();
        });
    };
    return [
        utilities,
        doCleanup
    ];
}
function $06dab374eda57fc5$var$getDirectiveHandler(el, directive2) {
    var noop = function() {};
    var handler4 = $06dab374eda57fc5$var$directiveHandlers[directive2.type] || noop;
    var _getElementBoundUtilities = (0, $esDIr._)($06dab374eda57fc5$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    $06dab374eda57fc5$var$onAttributeRemoved(el, directive2.original, cleanup2);
    var fullHandler = function() {
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $06dab374eda57fc5$var$isDeferringHandlers ? $06dab374eda57fc5$var$directiveHandlerStacks.get($06dab374eda57fc5$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $06dab374eda57fc5$var$startingWith = function(subject, replacement) {
    return function(param) {
        var name = param.name, value = param.value;
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
};
var $06dab374eda57fc5$var$into = function(i) {
    return i;
};
function $06dab374eda57fc5$var$toTransformedAttributes() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    return function(param) {
        var name = param.name, value = param.value;
        var _attributeTransformers_reduce = $06dab374eda57fc5$var$attributeTransformers.reduce(function(carry, transform) {
            return transform(carry);
        }, {
            name: name,
            value: value
        }), newName = _attributeTransformers_reduce.name, newValue = _attributeTransformers_reduce.value;
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $06dab374eda57fc5$var$attributeTransformers = [];
function $06dab374eda57fc5$var$mapAttributes(callback) {
    $06dab374eda57fc5$var$attributeTransformers.push(callback);
}
function $06dab374eda57fc5$var$outNonAlpineAttributes(param) {
    var name = param.name;
    return $06dab374eda57fc5$var$alpineAttributeRegex().test(name);
}
var $06dab374eda57fc5$var$alpineAttributeRegex = function() {
    return new RegExp("^".concat($06dab374eda57fc5$var$prefixAsString, "([^:^.]+)\\b"));
};
function $06dab374eda57fc5$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return function(param) {
        var name = param.name, value = param.value;
        var typeMatch = name.match($06dab374eda57fc5$var$alpineAttributeRegex());
        var valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        var modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        var original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map(function(i) {
                return i.replace(".", "");
            }),
            expression: value,
            original: original
        };
    };
}
var $06dab374eda57fc5$var$DEFAULT = "DEFAULT";
var $06dab374eda57fc5$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $06dab374eda57fc5$var$DEFAULT,
    "teleport"
];
function $06dab374eda57fc5$var$byPriority(a, b) {
    var typeA = $06dab374eda57fc5$var$directiveOrder.indexOf(a.type) === -1 ? $06dab374eda57fc5$var$DEFAULT : a.type;
    var typeB = $06dab374eda57fc5$var$directiveOrder.indexOf(b.type) === -1 ? $06dab374eda57fc5$var$DEFAULT : b.type;
    return $06dab374eda57fc5$var$directiveOrder.indexOf(typeA) - $06dab374eda57fc5$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $06dab374eda57fc5$var$dispatch(el, name) {
    var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $06dab374eda57fc5$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach(function(el2) {
            return $06dab374eda57fc5$var$walk(el2, callback);
        });
        return;
    }
    var skip = false;
    callback(el, function() {
        return skip = true;
    });
    if (skip) return;
    var node = el.firstElementChild;
    while(node){
        $06dab374eda57fc5$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $06dab374eda57fc5$var$warn(message) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "Alpine Warning: ".concat(message)
    ].concat((0, $kNmtb._)(args)));
}
// packages/alpinejs/src/lifecycle.js
var $06dab374eda57fc5$var$started = false;
function $06dab374eda57fc5$var$start() {
    if ($06dab374eda57fc5$var$started) $06dab374eda57fc5$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $06dab374eda57fc5$var$started = true;
    if (!document.body) $06dab374eda57fc5$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $06dab374eda57fc5$var$dispatch(document, "alpine:init");
    $06dab374eda57fc5$var$dispatch(document, "alpine:initializing");
    $06dab374eda57fc5$var$startObservingMutations();
    $06dab374eda57fc5$var$onElAdded(function(el) {
        return $06dab374eda57fc5$var$initTree(el, $06dab374eda57fc5$var$walk);
    });
    $06dab374eda57fc5$var$onElRemoved(function(el) {
        return $06dab374eda57fc5$var$destroyTree(el);
    });
    $06dab374eda57fc5$var$onAttributesAdded(function(el, attrs) {
        $06dab374eda57fc5$var$directives(el, attrs).forEach(function(handle) {
            return handle();
        });
    });
    var outNestedComponents = function(el) {
        return !$06dab374eda57fc5$var$closestRoot(el.parentElement, true);
    };
    Array.from(document.querySelectorAll($06dab374eda57fc5$var$allSelectors().join(","))).filter(outNestedComponents).forEach(function(el) {
        $06dab374eda57fc5$var$initTree(el);
    });
    $06dab374eda57fc5$var$dispatch(document, "alpine:initialized");
    setTimeout(function() {
        $06dab374eda57fc5$var$warnAboutMissingPlugins();
    });
}
var $06dab374eda57fc5$var$rootSelectorCallbacks = [];
var $06dab374eda57fc5$var$initSelectorCallbacks = [];
function $06dab374eda57fc5$var$rootSelectors() {
    return $06dab374eda57fc5$var$rootSelectorCallbacks.map(function(fn) {
        return fn();
    });
}
function $06dab374eda57fc5$var$allSelectors() {
    return $06dab374eda57fc5$var$rootSelectorCallbacks.concat($06dab374eda57fc5$var$initSelectorCallbacks).map(function(fn) {
        return fn();
    });
}
function $06dab374eda57fc5$var$addRootSelector(selectorCallback) {
    $06dab374eda57fc5$var$rootSelectorCallbacks.push(selectorCallback);
}
function $06dab374eda57fc5$var$addInitSelector(selectorCallback) {
    $06dab374eda57fc5$var$initSelectorCallbacks.push(selectorCallback);
}
function $06dab374eda57fc5$var$closestRoot(el) {
    var includeInitSelectors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $06dab374eda57fc5$var$findClosest(el, function(element) {
        var selectors = includeInitSelectors ? $06dab374eda57fc5$var$allSelectors() : $06dab374eda57fc5$var$rootSelectors();
        if (selectors.some(function(selector) {
            return element.matches(selector);
        })) return true;
    });
}
function $06dab374eda57fc5$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $06dab374eda57fc5$var$findClosest(el.parentElement, callback);
}
function $06dab374eda57fc5$var$isRoot(el) {
    return $06dab374eda57fc5$var$rootSelectors().some(function(selector) {
        return el.matches(selector);
    });
}
var $06dab374eda57fc5$var$initInterceptors2 = [];
function $06dab374eda57fc5$var$interceptInit(callback) {
    $06dab374eda57fc5$var$initInterceptors2.push(callback);
}
var $06dab374eda57fc5$var$markerDispenser = 1;
function $06dab374eda57fc5$var$initTree(el) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $06dab374eda57fc5$var$walk, intercept = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    if ($06dab374eda57fc5$var$findClosest(el, function(i) {
        return i._x_ignore;
    })) return;
    $06dab374eda57fc5$var$deferHandlingDirectives(function() {
        walker(el, function(el2, skip) {
            if (el2._x_marker) return;
            intercept(el2, skip);
            $06dab374eda57fc5$var$initInterceptors2.forEach(function(i) {
                return i(el2, skip);
            });
            $06dab374eda57fc5$var$directives(el2, el2.attributes).forEach(function(handle) {
                return handle();
            });
            if (!el2._x_ignore) el2._x_marker = $06dab374eda57fc5$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $06dab374eda57fc5$var$destroyTree(root) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $06dab374eda57fc5$var$walk;
    walker(root, function(el) {
        $06dab374eda57fc5$var$cleanupElement(el);
        $06dab374eda57fc5$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $06dab374eda57fc5$var$warnAboutMissingPlugins() {
    var pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(function(param) {
        var _param = (0, $esDIr._)(param, 3), plugin2 = _param[0], directive2 = _param[1], selectors = _param[2];
        if ($06dab374eda57fc5$var$directiveExists(directive2)) return;
        selectors.some(function(selector) {
            if (document.querySelector(selector)) {
                $06dab374eda57fc5$var$warn('found "'.concat(selector, '", but missing ').concat(plugin2, " plugin"));
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $06dab374eda57fc5$var$tickStack = [];
var $06dab374eda57fc5$var$isHolding = false;
function $06dab374eda57fc5$var$nextTick() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    queueMicrotask(function() {
        $06dab374eda57fc5$var$isHolding || setTimeout(function() {
            $06dab374eda57fc5$var$releaseNextTicks();
        });
    });
    return new Promise(function(res) {
        $06dab374eda57fc5$var$tickStack.push(function() {
            callback();
            res();
        });
    });
}
function $06dab374eda57fc5$var$releaseNextTicks() {
    $06dab374eda57fc5$var$isHolding = false;
    while($06dab374eda57fc5$var$tickStack.length)$06dab374eda57fc5$var$tickStack.shift()();
}
function $06dab374eda57fc5$var$holdNextTicks() {
    $06dab374eda57fc5$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $06dab374eda57fc5$var$setClasses(el, value) {
    if (Array.isArray(value)) return $06dab374eda57fc5$var$setClassesFromString(el, value.join(" "));
    else if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === "object" && value !== null) return $06dab374eda57fc5$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $06dab374eda57fc5$var$setClasses(el, value());
    return $06dab374eda57fc5$var$setClassesFromString(el, value);
}
function $06dab374eda57fc5$var$setClassesFromString(el, classString) {
    var split = function(classString2) {
        return classString2.split(" ").filter(Boolean);
    };
    var missingClasses = function(classString2) {
        return classString2.split(" ").filter(function(i) {
            return !el.classList.contains(i);
        }).filter(Boolean);
    };
    var addClassesAndReturnUndo = function(classes) {
        var _el_classList;
        (_el_classList = el.classList).add.apply(_el_classList, (0, $kNmtb._)(classes));
        return function() {
            var _el_classList;
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $kNmtb._)(classes));
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $06dab374eda57fc5$var$setClassesFromObject(el, classObject) {
    var split = function(classString) {
        return classString.split(" ").filter(Boolean);
    };
    var forAdd = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $esDIr._)(param, 2), classString = _param[0], bool = _param[1];
        return bool ? split(classString) : false;
    }).filter(Boolean);
    var forRemove = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $esDIr._)(param, 2), classString = _param[0], bool = _param[1];
        return !bool ? split(classString) : false;
    }).filter(Boolean);
    var added = [];
    var removed = [];
    forRemove.forEach(function(i) {
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach(function(i) {
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return function() {
        removed.forEach(function(i) {
            return el.classList.add(i);
        });
        added.forEach(function(i) {
            return el.classList.remove(i);
        });
    };
}
// packages/alpinejs/src/utils/styles.js
function $06dab374eda57fc5$var$setStyles(el, value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === "object" && value !== null) return $06dab374eda57fc5$var$setStylesFromObject(el, value);
    return $06dab374eda57fc5$var$setStylesFromString(el, value);
}
function $06dab374eda57fc5$var$setStylesFromObject(el, value) {
    var previousStyles = {};
    Object.entries(value).forEach(function(param) {
        var _param = (0, $esDIr._)(param, 2), key = _param[0], value2 = _param[1];
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $06dab374eda57fc5$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(function() {
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return function() {
        $06dab374eda57fc5$var$setStyles(el, previousStyles);
    };
}
function $06dab374eda57fc5$var$setStylesFromString(el, value) {
    var cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return function() {
        el.setAttribute("style", cache || "");
    };
}
function $06dab374eda57fc5$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $06dab374eda57fc5$var$once(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$06dab374eda57fc5$var$directive("transition", function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $06dab374eda57fc5$var$registerTransitionsFromHelper(el, modifiers, value);
    else $06dab374eda57fc5$var$registerTransitionsFromClassString(el, expression, value);
});
function $06dab374eda57fc5$var$registerTransitionsFromClassString(el, classString, stage) {
    $06dab374eda57fc5$var$registerTransitionObject(el, $06dab374eda57fc5$var$setClasses, "");
    var directiveStorageMap = {
        "enter": function(classes) {
            el._x_transition.enter.during = classes;
        },
        "enter-start": function(classes) {
            el._x_transition.enter.start = classes;
        },
        "enter-end": function(classes) {
            el._x_transition.enter.end = classes;
        },
        "leave": function(classes) {
            el._x_transition.leave.during = classes;
        },
        "leave-start": function(classes) {
            el._x_transition.leave.start = classes;
        },
        "leave-end": function(classes) {
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $06dab374eda57fc5$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $06dab374eda57fc5$var$registerTransitionObject(el, $06dab374eda57fc5$var$setStyles);
    var doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    var transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    var transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index < modifiers.indexOf("out");
    });
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index > modifiers.indexOf("out");
    });
    var wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    var wantsOpacity = wantsAll || modifiers.includes("opacity");
    var wantsScale = wantsAll || modifiers.includes("scale");
    var opacityValue = wantsOpacity ? 0 : 1;
    var scaleValue = wantsScale ? $06dab374eda57fc5$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    var delay = $06dab374eda57fc5$var$modifierValue(modifiers, "delay", 0) / 1e3;
    var origin = $06dab374eda57fc5$var$modifierValue(modifiers, "origin", "center");
    var property = "opacity, transform";
    var durationIn = $06dab374eda57fc5$var$modifierValue(modifiers, "duration", 150) / 1e3;
    var durationOut = $06dab374eda57fc5$var$modifierValue(modifiers, "duration", 75) / 1e3;
    var easing = "cubic-bezier(0.4, 0.0, 0.2, 1)";
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationIn, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: "scale(1)"
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationOut, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: "scale(1)"
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
    }
}
function $06dab374eda57fc5$var$registerTransitionObject(el, setFunction) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $06dab374eda57fc5$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $06dab374eda57fc5$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    var nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    var clickAwayCompatibleShow = function() {
        return nextTick2(show);
    };
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise(function(resolve, reject) {
        el._x_transition.out(function() {}, function() {
            return resolve(hide);
        });
        el._x_transitioning && el._x_transitioning.beforeCancel(function() {
            return reject({
                isFromCancelledTransition: true
            });
        });
    }) : Promise.resolve(hide);
    queueMicrotask(function() {
        var closest = $06dab374eda57fc5$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(function() {
            var hideAfterChildren = function(el2) {
                var carry = Promise.all([
                    el2._x_hidePromise
                ].concat((0, $kNmtb._)((el2._x_hideChildren || []).map(hideAfterChildren)))).then(function(param) {
                    var _param = (0, $esDIr._)(param, 1), i = _param[0];
                    return i === null || i === void 0 ? void 0 : i();
                });
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch(function(e) {
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $06dab374eda57fc5$var$closestHide(el) {
    var parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $06dab374eda57fc5$var$closestHide(parent);
}
function $06dab374eda57fc5$var$transition(el, setFunction) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, during = _ref.during, start2 = _ref.start, end = _ref.end, before = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {}, after = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {};
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    var undoStart, undoDuring, undoEnd;
    $06dab374eda57fc5$var$performTransition(el, {
        start: function() {
            undoStart = setFunction(el, start2);
        },
        during: function() {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end: function() {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup: function() {
            undoDuring();
            undoEnd();
        }
    });
}
function $06dab374eda57fc5$var$performTransition(el, stages) {
    var interrupted, reachedBefore, reachedEnd;
    var finish = $06dab374eda57fc5$var$once(function() {
        $06dab374eda57fc5$var$mutateDom(function() {
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $06dab374eda57fc5$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel: function(callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $06dab374eda57fc5$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $06dab374eda57fc5$var$mutateDom(function() {
        stages.start();
        stages.during();
    });
    $06dab374eda57fc5$var$holdNextTicks();
    requestAnimationFrame(function() {
        if (interrupted) return;
        var duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        var delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $06dab374eda57fc5$var$mutateDom(function() {
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(function() {
            if (interrupted) return;
            $06dab374eda57fc5$var$mutateDom(function() {
                stages.end();
            });
            $06dab374eda57fc5$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $06dab374eda57fc5$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    var rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        var match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $06dab374eda57fc5$var$isCloning = false;
function $06dab374eda57fc5$var$skipDuringClone(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $06dab374eda57fc5$var$isCloning ? fallback.apply(void 0, (0, $kNmtb._)(args)) : callback.apply(void 0, (0, $kNmtb._)(args));
    };
}
function $06dab374eda57fc5$var$onlyDuringClone(callback) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $06dab374eda57fc5$var$isCloning && callback.apply(void 0, (0, $kNmtb._)(args));
    };
}
var $06dab374eda57fc5$var$interceptors = [];
function $06dab374eda57fc5$var$interceptClone(callback) {
    $06dab374eda57fc5$var$interceptors.push(callback);
}
function $06dab374eda57fc5$var$cloneNode(from, to) {
    $06dab374eda57fc5$var$interceptors.forEach(function(i) {
        return i(from, to);
    });
    $06dab374eda57fc5$var$isCloning = true;
    $06dab374eda57fc5$var$dontRegisterReactiveSideEffects(function() {
        $06dab374eda57fc5$var$initTree(to, function(el, callback) {
            callback(el, function() {});
        });
    });
    $06dab374eda57fc5$var$isCloning = false;
}
var $06dab374eda57fc5$var$isCloningLegacy = false;
function $06dab374eda57fc5$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $06dab374eda57fc5$var$isCloning = true;
    $06dab374eda57fc5$var$isCloningLegacy = true;
    $06dab374eda57fc5$var$dontRegisterReactiveSideEffects(function() {
        $06dab374eda57fc5$var$cloneTree(newEl);
    });
    $06dab374eda57fc5$var$isCloning = false;
    $06dab374eda57fc5$var$isCloningLegacy = false;
}
function $06dab374eda57fc5$var$cloneTree(el) {
    var hasRunThroughFirstEl = false;
    var shallowWalker = function(el2, callback) {
        $06dab374eda57fc5$var$walk(el2, function(el3, skip) {
            if (hasRunThroughFirstEl && $06dab374eda57fc5$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $06dab374eda57fc5$var$initTree(el, shallowWalker);
}
function $06dab374eda57fc5$var$dontRegisterReactiveSideEffects(callback) {
    var cache = $06dab374eda57fc5$var$effect;
    $06dab374eda57fc5$var$overrideEffect(function(callback2, el) {
        var storedEffect = cache(callback2);
        $06dab374eda57fc5$var$release(storedEffect);
        return function() {};
    });
    callback();
    $06dab374eda57fc5$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $06dab374eda57fc5$var$bind(el, name, value) {
    var modifiers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (!el._x_bindings) el._x_bindings = $06dab374eda57fc5$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $06dab374eda57fc5$var$camelCase(name) : name;
    switch(name){
        case "value":
            $06dab374eda57fc5$var$bindInputValue(el, value);
            break;
        case "style":
            $06dab374eda57fc5$var$bindStyles(el, value);
            break;
        case "class":
            $06dab374eda57fc5$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $06dab374eda57fc5$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $06dab374eda57fc5$var$bindAttribute(el, name, value);
            break;
    }
}
function $06dab374eda57fc5$var$bindInputValue(el, value) {
    if ($06dab374eda57fc5$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $06dab374eda57fc5$var$safeParseBoolean(el.value) === value;
            else el.checked = $06dab374eda57fc5$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($06dab374eda57fc5$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some(function(val) {
            return $06dab374eda57fc5$var$checkedAttrLooseCompare(val, el.value);
        });
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $06dab374eda57fc5$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $06dab374eda57fc5$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $06dab374eda57fc5$var$setClasses(el, value);
}
function $06dab374eda57fc5$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $06dab374eda57fc5$var$setStyles(el, value);
}
function $06dab374eda57fc5$var$bindAttributeAndProperty(el, name, value) {
    $06dab374eda57fc5$var$bindAttribute(el, name, value);
    $06dab374eda57fc5$var$setPropertyIfChanged(el, name, value);
}
function $06dab374eda57fc5$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $06dab374eda57fc5$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($06dab374eda57fc5$var$isBooleanAttr(name)) value = name;
        $06dab374eda57fc5$var$setIfChanged(el, name, value);
    }
}
function $06dab374eda57fc5$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $06dab374eda57fc5$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $06dab374eda57fc5$var$updateSelect(el, value) {
    var arrayWrappedValue = [].concat(value).map(function(value2) {
        return value2 + "";
    });
    Array.from(el.options).forEach(function(option) {
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $06dab374eda57fc5$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $06dab374eda57fc5$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $06dab374eda57fc5$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $06dab374eda57fc5$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $06dab374eda57fc5$var$isBooleanAttr(attrName) {
    return $06dab374eda57fc5$var$booleanAttributes.has(attrName);
}
function $06dab374eda57fc5$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $06dab374eda57fc5$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $06dab374eda57fc5$var$getAttributeBinding(el, name, fallback);
}
function $06dab374eda57fc5$var$extractProp(el, name, fallback) {
    var extract = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        var binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $06dab374eda57fc5$var$dontAutoEvaluateFunctions(function() {
            return $06dab374eda57fc5$var$evaluate(el, binding.expression);
        });
    }
    return $06dab374eda57fc5$var$getAttributeBinding(el, name, fallback);
}
function $06dab374eda57fc5$var$getAttributeBinding(el, name, fallback) {
    var attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($06dab374eda57fc5$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $06dab374eda57fc5$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $06dab374eda57fc5$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $06dab374eda57fc5$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function later() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $06dab374eda57fc5$var$throttle(func, limit) {
    var inThrottle;
    return function() {
        var context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function() {
                return inThrottle = false;
            }, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $06dab374eda57fc5$var$entangle(param, param1) {
    var outerGet = param.get, outerSet = param.set, innerGet = param1.get, innerSet = param1.set;
    var firstRun = true;
    var outerHash;
    var innerHash;
    var reference = $06dab374eda57fc5$var$effect(function() {
        var outer = outerGet();
        var inner = innerGet();
        if (firstRun) {
            innerSet($06dab374eda57fc5$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            var outerHashLatest = JSON.stringify(outer);
            var innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($06dab374eda57fc5$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($06dab374eda57fc5$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return function() {
        $06dab374eda57fc5$var$release(reference);
    };
}
function $06dab374eda57fc5$var$cloneIfObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $06dab374eda57fc5$var$plugin(callback) {
    var callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach(function(i) {
        return i($06dab374eda57fc5$var$alpine_default);
    });
}
// packages/alpinejs/src/store.js
var $06dab374eda57fc5$var$stores = {};
var $06dab374eda57fc5$var$isReactive = false;
function $06dab374eda57fc5$var$store(name, value) {
    if (!$06dab374eda57fc5$var$isReactive) {
        $06dab374eda57fc5$var$stores = $06dab374eda57fc5$var$reactive($06dab374eda57fc5$var$stores);
        $06dab374eda57fc5$var$isReactive = true;
    }
    if (value === void 0) return $06dab374eda57fc5$var$stores[name];
    $06dab374eda57fc5$var$stores[name] = value;
    $06dab374eda57fc5$var$initInterceptors($06dab374eda57fc5$var$stores[name]);
    if ((typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $06dab374eda57fc5$var$stores[name].init();
}
function $06dab374eda57fc5$var$getStores() {
    return $06dab374eda57fc5$var$stores;
}
// packages/alpinejs/src/binds.js
var $06dab374eda57fc5$var$binds = {};
function $06dab374eda57fc5$var$bind2(name, bindings) {
    var getBindings = typeof bindings !== "function" ? function() {
        return bindings;
    } : bindings;
    if (name instanceof Element) return $06dab374eda57fc5$var$applyBindingsObject(name, getBindings());
    else $06dab374eda57fc5$var$binds[name] = getBindings;
    return function() {};
}
function $06dab374eda57fc5$var$injectBindingProviders(obj) {
    Object.entries($06dab374eda57fc5$var$binds).forEach(function(param) {
        var _param = (0, $esDIr._)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.apply(void 0, (0, $kNmtb._)(args));
                };
            }
        });
    });
    return obj;
}
function $06dab374eda57fc5$var$applyBindingsObject(el, obj, original) {
    var cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    var attributes = Object.entries(obj).map(function(param) {
        var _param = (0, $esDIr._)(param, 2), name = _param[0], value = _param[1];
        return {
            name: name,
            value: value
        };
    });
    var staticAttributes = $06dab374eda57fc5$var$attributesOnly(attributes);
    attributes = attributes.map(function(attribute) {
        if (staticAttributes.find(function(attr) {
            return attr.name === attribute.name;
        })) return {
            name: "x-bind:".concat(attribute.name),
            value: '"'.concat(attribute.value, '"')
        };
        return attribute;
    });
    $06dab374eda57fc5$var$directives(el, attributes, original).map(function(handle) {
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return function() {
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $06dab374eda57fc5$var$datas = {};
function $06dab374eda57fc5$var$data(name, callback) {
    $06dab374eda57fc5$var$datas[name] = callback;
}
function $06dab374eda57fc5$var$injectDataProviders(obj, context) {
    Object.entries($06dab374eda57fc5$var$datas).forEach(function(param) {
        var _param = (0, $esDIr._)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                var _this = this;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.bind(context).apply(_this, (0, $kNmtb._)(args));
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $06dab374eda57fc5$var$Alpine = {
    get reactive () {
        return $06dab374eda57fc5$var$reactive;
    },
    get release () {
        return $06dab374eda57fc5$var$release;
    },
    get effect () {
        return $06dab374eda57fc5$var$effect;
    },
    get raw () {
        return $06dab374eda57fc5$var$raw;
    },
    version: "3.15.2",
    flushAndStopDeferringMutations: $06dab374eda57fc5$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $06dab374eda57fc5$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $06dab374eda57fc5$var$disableEffectScheduling,
    startObservingMutations: $06dab374eda57fc5$var$startObservingMutations,
    stopObservingMutations: $06dab374eda57fc5$var$stopObservingMutations,
    setReactivityEngine: $06dab374eda57fc5$var$setReactivityEngine,
    onAttributeRemoved: $06dab374eda57fc5$var$onAttributeRemoved,
    onAttributesAdded: $06dab374eda57fc5$var$onAttributesAdded,
    closestDataStack: $06dab374eda57fc5$var$closestDataStack,
    skipDuringClone: $06dab374eda57fc5$var$skipDuringClone,
    onlyDuringClone: $06dab374eda57fc5$var$onlyDuringClone,
    addRootSelector: $06dab374eda57fc5$var$addRootSelector,
    addInitSelector: $06dab374eda57fc5$var$addInitSelector,
    setErrorHandler: $06dab374eda57fc5$var$setErrorHandler,
    interceptClone: $06dab374eda57fc5$var$interceptClone,
    addScopeToNode: $06dab374eda57fc5$var$addScopeToNode,
    deferMutations: $06dab374eda57fc5$var$deferMutations,
    mapAttributes: $06dab374eda57fc5$var$mapAttributes,
    evaluateLater: $06dab374eda57fc5$var$evaluateLater,
    interceptInit: $06dab374eda57fc5$var$interceptInit,
    setEvaluator: $06dab374eda57fc5$var$setEvaluator,
    mergeProxies: $06dab374eda57fc5$var$mergeProxies,
    extractProp: $06dab374eda57fc5$var$extractProp,
    findClosest: $06dab374eda57fc5$var$findClosest,
    onElRemoved: $06dab374eda57fc5$var$onElRemoved,
    closestRoot: $06dab374eda57fc5$var$closestRoot,
    destroyTree: $06dab374eda57fc5$var$destroyTree,
    interceptor: $06dab374eda57fc5$var$interceptor,
    // INTERNAL: not public API and is subject to change without major release.
    transition: $06dab374eda57fc5$var$transition,
    // INTERNAL
    setStyles: $06dab374eda57fc5$var$setStyles,
    // INTERNAL
    mutateDom: $06dab374eda57fc5$var$mutateDom,
    directive: $06dab374eda57fc5$var$directive,
    entangle: $06dab374eda57fc5$var$entangle,
    throttle: $06dab374eda57fc5$var$throttle,
    debounce: $06dab374eda57fc5$var$debounce,
    evaluate: $06dab374eda57fc5$var$evaluate,
    initTree: $06dab374eda57fc5$var$initTree,
    nextTick: $06dab374eda57fc5$var$nextTick,
    prefixed: $06dab374eda57fc5$var$prefix,
    prefix: $06dab374eda57fc5$var$setPrefix,
    plugin: $06dab374eda57fc5$var$plugin,
    magic: $06dab374eda57fc5$var$magic,
    store: $06dab374eda57fc5$var$store,
    start: $06dab374eda57fc5$var$start,
    clone: $06dab374eda57fc5$var$clone,
    // INTERNAL
    cloneNode: $06dab374eda57fc5$var$cloneNode,
    // INTERNAL
    bound: $06dab374eda57fc5$var$getBinding,
    $data: $06dab374eda57fc5$var$scope,
    watch: $06dab374eda57fc5$var$watch,
    walk: $06dab374eda57fc5$var$walk,
    data: $06dab374eda57fc5$var$data,
    bind: $06dab374eda57fc5$var$bind2
};
var $06dab374eda57fc5$var$alpine_default = $06dab374eda57fc5$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $06dab374eda57fc5$var$makeMap(str, expectsLowerCase) {
    var map = /* @__PURE__ */ Object.create(null);
    var list = str.split(",");
    for(var i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? function(val) {
        return !!map[val.toLowerCase()];
    } : function(val) {
        return !!map[val];
    };
}
var $06dab374eda57fc5$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $06dab374eda57fc5$var$isBooleanAttr2 = /* @__PURE__ */ $06dab374eda57fc5$var$makeMap($06dab374eda57fc5$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
var $06dab374eda57fc5$var$EMPTY_OBJ = Object.freeze({});
var $06dab374eda57fc5$var$EMPTY_ARR = Object.freeze([]);
var $06dab374eda57fc5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $06dab374eda57fc5$var$hasOwn = function(val, key) {
    return $06dab374eda57fc5$var$hasOwnProperty.call(val, key);
};
var $06dab374eda57fc5$var$isArray = Array.isArray;
var $06dab374eda57fc5$var$isMap = function(val) {
    return $06dab374eda57fc5$var$toTypeString(val) === "[object Map]";
};
var $06dab374eda57fc5$var$isString = function(val) {
    return typeof val === "string";
};
var $06dab374eda57fc5$var$isSymbol = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $ewv1T._)(val)) === "symbol";
};
var $06dab374eda57fc5$var$isObject = function(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, $ewv1T._)(val)) === "object";
};
var $06dab374eda57fc5$var$objectToString = Object.prototype.toString;
var $06dab374eda57fc5$var$toTypeString = function(value) {
    return $06dab374eda57fc5$var$objectToString.call(value);
};
var $06dab374eda57fc5$var$toRawType = function(value) {
    return $06dab374eda57fc5$var$toTypeString(value).slice(8, -1);
};
var $06dab374eda57fc5$var$isIntegerKey = function(key) {
    return $06dab374eda57fc5$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $06dab374eda57fc5$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $06dab374eda57fc5$var$camelizeRE = /-(\w)/g;
var $06dab374eda57fc5$var$camelize = $06dab374eda57fc5$var$cacheStringFunction(function(str) {
    return str.replace($06dab374eda57fc5$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $06dab374eda57fc5$var$hyphenateRE = /\B([A-Z])/g;
var $06dab374eda57fc5$var$hyphenate = $06dab374eda57fc5$var$cacheStringFunction(function(str) {
    return str.replace($06dab374eda57fc5$var$hyphenateRE, "-$1").toLowerCase();
});
var $06dab374eda57fc5$var$capitalize = $06dab374eda57fc5$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $06dab374eda57fc5$var$toHandlerKey = $06dab374eda57fc5$var$cacheStringFunction(function(str) {
    return str ? "on".concat($06dab374eda57fc5$var$capitalize(str)) : "";
});
var $06dab374eda57fc5$var$hasChanged = function(value, oldValue) {
    return value !== oldValue && (value === value || oldValue === oldValue);
};
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $06dab374eda57fc5$var$targetMap = /* @__PURE__ */ new WeakMap();
var $06dab374eda57fc5$var$effectStack = [];
var $06dab374eda57fc5$var$activeEffect;
var $06dab374eda57fc5$var$ITERATE_KEY = Symbol("iterate");
var $06dab374eda57fc5$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $06dab374eda57fc5$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $06dab374eda57fc5$var$effect2(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $06dab374eda57fc5$var$EMPTY_OBJ;
    if ($06dab374eda57fc5$var$isEffect(fn)) fn = fn.raw;
    var effect3 = $06dab374eda57fc5$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $06dab374eda57fc5$var$stop(effect3) {
    if (effect3.active) {
        $06dab374eda57fc5$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $06dab374eda57fc5$var$uid = 0;
function $06dab374eda57fc5$var$createReactiveEffect(fn, options) {
    var effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$06dab374eda57fc5$var$effectStack.includes(effect3)) {
            $06dab374eda57fc5$var$cleanup(effect3);
            try {
                $06dab374eda57fc5$var$enableTracking();
                $06dab374eda57fc5$var$effectStack.push(effect3);
                $06dab374eda57fc5$var$activeEffect = effect3;
                return fn();
            } finally{
                $06dab374eda57fc5$var$effectStack.pop();
                $06dab374eda57fc5$var$resetTracking();
                $06dab374eda57fc5$var$activeEffect = $06dab374eda57fc5$var$effectStack[$06dab374eda57fc5$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $06dab374eda57fc5$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $06dab374eda57fc5$var$cleanup(effect3) {
    var deps = effect3.deps;
    if (deps.length) {
        for(var i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $06dab374eda57fc5$var$shouldTrack = true;
var $06dab374eda57fc5$var$trackStack = [];
function $06dab374eda57fc5$var$pauseTracking() {
    $06dab374eda57fc5$var$trackStack.push($06dab374eda57fc5$var$shouldTrack);
    $06dab374eda57fc5$var$shouldTrack = false;
}
function $06dab374eda57fc5$var$enableTracking() {
    $06dab374eda57fc5$var$trackStack.push($06dab374eda57fc5$var$shouldTrack);
    $06dab374eda57fc5$var$shouldTrack = true;
}
function $06dab374eda57fc5$var$resetTracking() {
    var last = $06dab374eda57fc5$var$trackStack.pop();
    $06dab374eda57fc5$var$shouldTrack = last === void 0 ? true : last;
}
function $06dab374eda57fc5$var$track(target, type, key) {
    if (!$06dab374eda57fc5$var$shouldTrack || $06dab374eda57fc5$var$activeEffect === void 0) return;
    var depsMap = $06dab374eda57fc5$var$targetMap.get(target);
    if (!depsMap) $06dab374eda57fc5$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    var dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($06dab374eda57fc5$var$activeEffect)) {
        dep.add($06dab374eda57fc5$var$activeEffect);
        $06dab374eda57fc5$var$activeEffect.deps.push(dep);
        if ($06dab374eda57fc5$var$activeEffect.options.onTrack) $06dab374eda57fc5$var$activeEffect.options.onTrack({
            effect: $06dab374eda57fc5$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $06dab374eda57fc5$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = $06dab374eda57fc5$var$targetMap.get(target);
    if (!depsMap) return;
    var effects = /* @__PURE__ */ new Set();
    var add2 = function(effectsToAdd) {
        if (effectsToAdd) effectsToAdd.forEach(function(effect3) {
            if (effect3 !== $06dab374eda57fc5$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $06dab374eda57fc5$var$isArray(target)) depsMap.forEach(function(dep, key2) {
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$06dab374eda57fc5$var$isArray(target)) {
                    add2(depsMap.get($06dab374eda57fc5$var$ITERATE_KEY));
                    if ($06dab374eda57fc5$var$isMap(target)) add2(depsMap.get($06dab374eda57fc5$var$MAP_KEY_ITERATE_KEY));
                } else if ($06dab374eda57fc5$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$06dab374eda57fc5$var$isArray(target)) {
                    add2(depsMap.get($06dab374eda57fc5$var$ITERATE_KEY));
                    if ($06dab374eda57fc5$var$isMap(target)) add2(depsMap.get($06dab374eda57fc5$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($06dab374eda57fc5$var$isMap(target)) add2(depsMap.get($06dab374eda57fc5$var$ITERATE_KEY));
                break;
        }
    }
    var run = function(effect3) {
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $06dab374eda57fc5$var$isNonTrackableKeys = /* @__PURE__ */ $06dab374eda57fc5$var$makeMap("__proto__,__v_isRef,__isVue");
var $06dab374eda57fc5$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter($06dab374eda57fc5$var$isSymbol));
var $06dab374eda57fc5$var$get2 = /* @__PURE__ */ $06dab374eda57fc5$var$createGetter();
var $06dab374eda57fc5$var$readonlyGet = /* @__PURE__ */ $06dab374eda57fc5$var$createGetter(true);
var $06dab374eda57fc5$var$arrayInstrumentations = /* @__PURE__ */ $06dab374eda57fc5$var$createArrayInstrumentations();
function $06dab374eda57fc5$var$createArrayInstrumentations() {
    var instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _arr, _arr1;
            var arr = $06dab374eda57fc5$var$toRaw(this);
            for(var i = 0, l = this.length; i < l; i++)$06dab374eda57fc5$var$track(arr, "get", i + "");
            var res = (_arr = arr)[key].apply(_arr, (0, $kNmtb._)(args));
            if (res === -1 || res === false) return (_arr1 = arr)[key].apply(_arr1, (0, $kNmtb._)(args.map($06dab374eda57fc5$var$toRaw)));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            $06dab374eda57fc5$var$pauseTracking();
            var res = $06dab374eda57fc5$var$toRaw(this)[key].apply(this, args);
            $06dab374eda57fc5$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $06dab374eda57fc5$var$createGetter() {
    var isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $06dab374eda57fc5$var$shallowReadonlyMap : $06dab374eda57fc5$var$readonlyMap : shallow ? $06dab374eda57fc5$var$shallowReactiveMap : $06dab374eda57fc5$var$reactiveMap).get(target)) return target;
        var targetIsArray = $06dab374eda57fc5$var$isArray(target);
        if (!isReadonly && targetIsArray && $06dab374eda57fc5$var$hasOwn($06dab374eda57fc5$var$arrayInstrumentations, key)) return Reflect.get($06dab374eda57fc5$var$arrayInstrumentations, key, receiver);
        var res = Reflect.get(target, key, receiver);
        if ($06dab374eda57fc5$var$isSymbol(key) ? $06dab374eda57fc5$var$builtInSymbols.has(key) : $06dab374eda57fc5$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $06dab374eda57fc5$var$track(target, "get", key);
        if (shallow) return res;
        if ($06dab374eda57fc5$var$isRef(res)) {
            var shouldUnwrap = !targetIsArray || !$06dab374eda57fc5$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($06dab374eda57fc5$var$isObject(res)) return isReadonly ? $06dab374eda57fc5$var$readonly(res) : $06dab374eda57fc5$var$reactive2(res);
        return res;
    };
}
var $06dab374eda57fc5$var$set2 = /* @__PURE__ */ $06dab374eda57fc5$var$createSetter();
function $06dab374eda57fc5$var$createSetter() {
    var shallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return function set3(target, key, value, receiver) {
        var oldValue = target[key];
        if (!shallow) {
            value = $06dab374eda57fc5$var$toRaw(value);
            oldValue = $06dab374eda57fc5$var$toRaw(oldValue);
            if (!$06dab374eda57fc5$var$isArray(target) && $06dab374eda57fc5$var$isRef(oldValue) && !$06dab374eda57fc5$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        var hadKey = $06dab374eda57fc5$var$isArray(target) && $06dab374eda57fc5$var$isIntegerKey(key) ? Number(key) < target.length : $06dab374eda57fc5$var$hasOwn(target, key);
        var result = Reflect.set(target, key, value, receiver);
        if (target === $06dab374eda57fc5$var$toRaw(receiver)) {
            if (!hadKey) $06dab374eda57fc5$var$trigger(target, "add", key, value);
            else if ($06dab374eda57fc5$var$hasChanged(value, oldValue)) $06dab374eda57fc5$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $06dab374eda57fc5$var$deleteProperty(target, key) {
    var hadKey = $06dab374eda57fc5$var$hasOwn(target, key);
    var oldValue = target[key];
    var result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $06dab374eda57fc5$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $06dab374eda57fc5$var$has(target, key) {
    var result = Reflect.has(target, key);
    if (!$06dab374eda57fc5$var$isSymbol(key) || !$06dab374eda57fc5$var$builtInSymbols.has(key)) $06dab374eda57fc5$var$track(target, "has", key);
    return result;
}
function $06dab374eda57fc5$var$ownKeys(target) {
    $06dab374eda57fc5$var$track(target, "iterate", $06dab374eda57fc5$var$isArray(target) ? "length" : $06dab374eda57fc5$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $06dab374eda57fc5$var$mutableHandlers = {
    get: $06dab374eda57fc5$var$get2,
    set: $06dab374eda57fc5$var$set2,
    deleteProperty: $06dab374eda57fc5$var$deleteProperty,
    has: $06dab374eda57fc5$var$has,
    ownKeys: $06dab374eda57fc5$var$ownKeys
};
var $06dab374eda57fc5$var$readonlyHandlers = {
    get: $06dab374eda57fc5$var$readonlyGet,
    set: function(target, key) {
        console.warn('Set operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    },
    deleteProperty: function(target, key) {
        console.warn('Delete operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    }
};
var $06dab374eda57fc5$var$toReactive = function(value) {
    return $06dab374eda57fc5$var$isObject(value) ? $06dab374eda57fc5$var$reactive2(value) : value;
};
var $06dab374eda57fc5$var$toReadonly = function(value) {
    return $06dab374eda57fc5$var$isObject(value) ? $06dab374eda57fc5$var$readonly(value) : value;
};
var $06dab374eda57fc5$var$toShallow = function(value) {
    return value;
};
var $06dab374eda57fc5$var$getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function $06dab374eda57fc5$var$get$1(target, key) {
    var isReadonly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isShallow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    target = target["__v_raw"];
    var rawTarget = $06dab374eda57fc5$var$toRaw(target);
    var rawKey = $06dab374eda57fc5$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $06dab374eda57fc5$var$track(rawTarget, "get", key);
    !isReadonly && $06dab374eda57fc5$var$track(rawTarget, "get", rawKey);
    var _getProto = $06dab374eda57fc5$var$getProto(rawTarget), has2 = _getProto.has;
    var wrap = isShallow ? $06dab374eda57fc5$var$toShallow : isReadonly ? $06dab374eda57fc5$var$toReadonly : $06dab374eda57fc5$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $06dab374eda57fc5$var$has$1(key) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = this["__v_raw"];
    var rawTarget = $06dab374eda57fc5$var$toRaw(target);
    var rawKey = $06dab374eda57fc5$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $06dab374eda57fc5$var$track(rawTarget, "has", key);
    !isReadonly && $06dab374eda57fc5$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $06dab374eda57fc5$var$size(target) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    target = target["__v_raw"];
    !isReadonly && $06dab374eda57fc5$var$track($06dab374eda57fc5$var$toRaw(target), "iterate", $06dab374eda57fc5$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $06dab374eda57fc5$var$add(value) {
    value = $06dab374eda57fc5$var$toRaw(value);
    var target = $06dab374eda57fc5$var$toRaw(this);
    var proto = $06dab374eda57fc5$var$getProto(target);
    var hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $06dab374eda57fc5$var$trigger(target, "add", value, value);
    }
    return this;
}
function $06dab374eda57fc5$var$set$1(key, value) {
    value = $06dab374eda57fc5$var$toRaw(value);
    var target = $06dab374eda57fc5$var$toRaw(this);
    var _getProto = $06dab374eda57fc5$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $06dab374eda57fc5$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $06dab374eda57fc5$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $06dab374eda57fc5$var$trigger(target, "add", key, value);
    else if ($06dab374eda57fc5$var$hasChanged(value, oldValue)) $06dab374eda57fc5$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $06dab374eda57fc5$var$deleteEntry(key) {
    var target = $06dab374eda57fc5$var$toRaw(this);
    var _getProto = $06dab374eda57fc5$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $06dab374eda57fc5$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $06dab374eda57fc5$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3 ? get3.call(target, key) : void 0;
    var result = target.delete(key);
    if (hadKey) $06dab374eda57fc5$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $06dab374eda57fc5$var$clear() {
    var target = $06dab374eda57fc5$var$toRaw(this);
    var hadItems = target.size !== 0;
    var oldTarget = $06dab374eda57fc5$var$isMap(target) ? new Map(target) : new Set(target);
    var result = target.clear();
    if (hadItems) $06dab374eda57fc5$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $06dab374eda57fc5$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        var observed = this;
        var target = observed["__v_raw"];
        var rawTarget = $06dab374eda57fc5$var$toRaw(target);
        var wrap = isShallow ? $06dab374eda57fc5$var$toShallow : isReadonly ? $06dab374eda57fc5$var$toReadonly : $06dab374eda57fc5$var$toReactive;
        !isReadonly && $06dab374eda57fc5$var$track(rawTarget, "iterate", $06dab374eda57fc5$var$ITERATE_KEY);
        return target.forEach(function(value, key) {
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $06dab374eda57fc5$var$createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = $06dab374eda57fc5$var$toRaw(target);
        var targetIsMap = $06dab374eda57fc5$var$isMap(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $kNmtb._)(args));
        var wrap = isShallow ? $06dab374eda57fc5$var$toShallow : isReadonly ? $06dab374eda57fc5$var$toReadonly : $06dab374eda57fc5$var$toReactive;
        !isReadonly && $06dab374eda57fc5$var$track(rawTarget, "iterate", isKeyOnly ? $06dab374eda57fc5$var$MAP_KEY_ITERATE_KEY : $06dab374eda57fc5$var$ITERATE_KEY);
        return(// iterable protocol
        (0, $6lD0P._)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function $06dab374eda57fc5$var$createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        {
            var key = args[0] ? 'on key "'.concat(args[0], '" ') : "";
            console.warn("".concat($06dab374eda57fc5$var$capitalize(type), " operation ").concat(key, "failed: target is readonly."), $06dab374eda57fc5$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $06dab374eda57fc5$var$createInstrumentations() {
    var mutableInstrumentations2 = {
        get: function(key) {
            return $06dab374eda57fc5$var$get$1(this, key);
        },
        get size () {
            return $06dab374eda57fc5$var$size(this);
        },
        has: $06dab374eda57fc5$var$has$1,
        add: $06dab374eda57fc5$var$add,
        set: $06dab374eda57fc5$var$set$1,
        delete: $06dab374eda57fc5$var$deleteEntry,
        clear: $06dab374eda57fc5$var$clear,
        forEach: $06dab374eda57fc5$var$createForEach(false, false)
    };
    var shallowInstrumentations2 = {
        get: function(key) {
            return $06dab374eda57fc5$var$get$1(this, key, false, true);
        },
        get size () {
            return $06dab374eda57fc5$var$size(this);
        },
        has: $06dab374eda57fc5$var$has$1,
        add: $06dab374eda57fc5$var$add,
        set: $06dab374eda57fc5$var$set$1,
        delete: $06dab374eda57fc5$var$deleteEntry,
        clear: $06dab374eda57fc5$var$clear,
        forEach: $06dab374eda57fc5$var$createForEach(false, true)
    };
    var readonlyInstrumentations2 = {
        get: function(key) {
            return $06dab374eda57fc5$var$get$1(this, key, true);
        },
        get size () {
            return $06dab374eda57fc5$var$size(this, true);
        },
        has: function(key) {
            return $06dab374eda57fc5$var$has$1.call(this, key, true);
        },
        add: $06dab374eda57fc5$var$createReadonlyMethod("add"),
        set: $06dab374eda57fc5$var$createReadonlyMethod("set"),
        delete: $06dab374eda57fc5$var$createReadonlyMethod("delete"),
        clear: $06dab374eda57fc5$var$createReadonlyMethod("clear"),
        forEach: $06dab374eda57fc5$var$createForEach(true, false)
    };
    var shallowReadonlyInstrumentations2 = {
        get: function(key) {
            return $06dab374eda57fc5$var$get$1(this, key, true, true);
        },
        get size () {
            return $06dab374eda57fc5$var$size(this, true);
        },
        has: function(key) {
            return $06dab374eda57fc5$var$has$1.call(this, key, true);
        },
        add: $06dab374eda57fc5$var$createReadonlyMethod("add"),
        set: $06dab374eda57fc5$var$createReadonlyMethod("set"),
        delete: $06dab374eda57fc5$var$createReadonlyMethod("delete"),
        clear: $06dab374eda57fc5$var$createReadonlyMethod("clear"),
        forEach: $06dab374eda57fc5$var$createForEach(true, true)
    };
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        mutableInstrumentations2[method] = $06dab374eda57fc5$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $06dab374eda57fc5$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $06dab374eda57fc5$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $06dab374eda57fc5$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var /* @__PURE__ */ $06dab374eda57fc5$var$_createInstrumentations = (0, $esDIr._)($06dab374eda57fc5$var$createInstrumentations(), 4), $06dab374eda57fc5$var$mutableInstrumentations = $06dab374eda57fc5$var$_createInstrumentations[0], $06dab374eda57fc5$var$readonlyInstrumentations = $06dab374eda57fc5$var$_createInstrumentations[1], $06dab374eda57fc5$var$shallowInstrumentations = $06dab374eda57fc5$var$_createInstrumentations[2], $06dab374eda57fc5$var$shallowReadonlyInstrumentations = $06dab374eda57fc5$var$_createInstrumentations[3];
function $06dab374eda57fc5$var$createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = shallow ? isReadonly ? $06dab374eda57fc5$var$shallowReadonlyInstrumentations : $06dab374eda57fc5$var$shallowInstrumentations : isReadonly ? $06dab374eda57fc5$var$readonlyInstrumentations : $06dab374eda57fc5$var$mutableInstrumentations;
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($06dab374eda57fc5$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $06dab374eda57fc5$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $06dab374eda57fc5$var$createInstrumentationGetter(false, false)
};
var $06dab374eda57fc5$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $06dab374eda57fc5$var$createInstrumentationGetter(true, false)
};
function $06dab374eda57fc5$var$checkIdentityKeys(target, has2, key) {
    var rawKey = $06dab374eda57fc5$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        var type = $06dab374eda57fc5$var$toRawType(target);
        console.warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var $06dab374eda57fc5$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $06dab374eda57fc5$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $06dab374eda57fc5$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $06dab374eda57fc5$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $06dab374eda57fc5$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $06dab374eda57fc5$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $06dab374eda57fc5$var$targetTypeMap($06dab374eda57fc5$var$toRawType(value));
}
function $06dab374eda57fc5$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $06dab374eda57fc5$var$createReactiveObject(target, false, $06dab374eda57fc5$var$mutableHandlers, $06dab374eda57fc5$var$mutableCollectionHandlers, $06dab374eda57fc5$var$reactiveMap);
}
function $06dab374eda57fc5$var$readonly(target) {
    return $06dab374eda57fc5$var$createReactiveObject(target, true, $06dab374eda57fc5$var$readonlyHandlers, $06dab374eda57fc5$var$readonlyCollectionHandlers, $06dab374eda57fc5$var$readonlyMap);
}
function $06dab374eda57fc5$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$06dab374eda57fc5$var$isObject(target)) {
        console.warn("value cannot be made reactive: ".concat(String(target)));
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var targetType = $06dab374eda57fc5$var$getTargetType(target);
    if (targetType === 0) return target;
    var proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $06dab374eda57fc5$var$toRaw(observed) {
    return observed && $06dab374eda57fc5$var$toRaw(observed["__v_raw"]) || observed;
}
function $06dab374eda57fc5$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$06dab374eda57fc5$var$magic("nextTick", function() {
    return $06dab374eda57fc5$var$nextTick;
});
// packages/alpinejs/src/magics/$dispatch.js
$06dab374eda57fc5$var$magic("dispatch", function(el) {
    return $06dab374eda57fc5$var$dispatch.bind($06dab374eda57fc5$var$dispatch, el);
});
// packages/alpinejs/src/magics/$watch.js
$06dab374eda57fc5$var$magic("watch", function(el, param) {
    var evaluateLater2 = param.evaluateLater, cleanup2 = param.cleanup;
    return function(key, callback) {
        var evaluate2 = evaluateLater2(key);
        var getter = function() {
            var value;
            evaluate2(function(i) {
                return value = i;
            });
            return value;
        };
        var unwatch = $06dab374eda57fc5$var$watch(getter, callback);
        cleanup2(unwatch);
    };
});
// packages/alpinejs/src/magics/$store.js
$06dab374eda57fc5$var$magic("store", $06dab374eda57fc5$var$getStores);
// packages/alpinejs/src/magics/$data.js
$06dab374eda57fc5$var$magic("data", function(el) {
    return $06dab374eda57fc5$var$scope(el);
});
// packages/alpinejs/src/magics/$root.js
$06dab374eda57fc5$var$magic("root", function(el) {
    return $06dab374eda57fc5$var$closestRoot(el);
});
// packages/alpinejs/src/magics/$refs.js
$06dab374eda57fc5$var$magic("refs", function(el) {
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $06dab374eda57fc5$var$mergeProxies($06dab374eda57fc5$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $06dab374eda57fc5$var$getArrayOfRefObject(el) {
    var refObjects = [];
    $06dab374eda57fc5$var$findClosest(el, function(i) {
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $06dab374eda57fc5$var$globalIdMemo = {};
function $06dab374eda57fc5$var$findAndIncrementId(name) {
    if (!$06dab374eda57fc5$var$globalIdMemo[name]) $06dab374eda57fc5$var$globalIdMemo[name] = 0;
    return ++$06dab374eda57fc5$var$globalIdMemo[name];
}
function $06dab374eda57fc5$var$closestIdRoot(el, name) {
    return $06dab374eda57fc5$var$findClosest(el, function(element) {
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $06dab374eda57fc5$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $06dab374eda57fc5$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$06dab374eda57fc5$var$magic("id", function(el, param) {
    var cleanup2 = param.cleanup;
    return function(name) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var cacheKey = "".concat(name).concat(key ? "-".concat(key) : "");
        return $06dab374eda57fc5$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, function() {
            var root = $06dab374eda57fc5$var$closestIdRoot(el, name);
            var id = root ? root._x_ids[name] : $06dab374eda57fc5$var$findAndIncrementId(name);
            return key ? "".concat(name, "-").concat(id, "-").concat(key) : "".concat(name, "-").concat(id);
        });
    };
});
$06dab374eda57fc5$var$interceptClone(function(from, to) {
    if (from._x_id) to._x_id = from._x_id;
});
function $06dab374eda57fc5$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    var output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(function() {
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$06dab374eda57fc5$var$magic("el", function(el) {
    return el;
});
// packages/alpinejs/src/magics/index.js
$06dab374eda57fc5$var$warnMissingPluginMagic("Focus", "focus", "focus");
$06dab374eda57fc5$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $06dab374eda57fc5$var$warnMissingPluginMagic(name, magicName, slug) {
    $06dab374eda57fc5$var$magic(magicName, function(el) {
        return $06dab374eda57fc5$var$warn("You can't use [$".concat(magicName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/directives/x-modelable.js
$06dab374eda57fc5$var$directive("modelable", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater, cleanup2 = param1.cleanup;
    var func = evaluateLater2(expression);
    var innerGet = function() {
        var result;
        func(function(i) {
            return result = i;
        });
        return result;
    };
    var evaluateInnerSet = evaluateLater2("".concat(expression, " = __placeholder"));
    var innerSet = function(val) {
        return evaluateInnerSet(function() {}, {
            scope: {
                "__placeholder": val
            }
        });
    };
    var initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(function() {
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        var outerGet = el._x_model.get;
        var outerSet = el._x_model.set;
        var releaseEntanglement = $06dab374eda57fc5$var$entangle({
            get: function() {
                return outerGet();
            },
            set: function(value) {
                outerSet(value);
            }
        }, {
            get: function() {
                return innerGet();
            },
            set: function(value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$06dab374eda57fc5$var$directive("teleport", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $06dab374eda57fc5$var$warn("x-teleport can only be used on a <template> tag", el);
    var target = $06dab374eda57fc5$var$getTarget(expression);
    var clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach(function(eventName) {
        clone2.addEventListener(eventName, function(e) {
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $06dab374eda57fc5$var$addScopeToNode(clone2, {}, el);
    var placeInDom = function(clone3, target2, modifiers2) {
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $06dab374eda57fc5$var$mutateDom(function() {
        placeInDom(clone2, target, modifiers);
        $06dab374eda57fc5$var$skipDuringClone(function() {
            $06dab374eda57fc5$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = function() {
        var target2 = $06dab374eda57fc5$var$getTarget(expression);
        $06dab374eda57fc5$var$mutateDom(function() {
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(function() {
        return $06dab374eda57fc5$var$mutateDom(function() {
            clone2.remove();
            $06dab374eda57fc5$var$destroyTree(clone2);
        });
    });
});
var $06dab374eda57fc5$var$teleportContainerDuringClone = document.createElement("div");
function $06dab374eda57fc5$var$getTarget(expression) {
    var target = $06dab374eda57fc5$var$skipDuringClone(function() {
        return document.querySelector(expression);
    }, function() {
        return $06dab374eda57fc5$var$teleportContainerDuringClone;
    })();
    if (!target) $06dab374eda57fc5$var$warn('Cannot find x-teleport element for selector: "'.concat(expression, '"'));
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $06dab374eda57fc5$var$handler = function() {};
$06dab374eda57fc5$var$handler.inline = function(el, param, param1) {
    var modifiers = param.modifiers, cleanup2 = param1.cleanup;
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(function() {
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$06dab374eda57fc5$var$directive("ignore", $06dab374eda57fc5$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$06dab374eda57fc5$var$directive("effect", $06dab374eda57fc5$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect;
    effect3($06dab374eda57fc5$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $06dab374eda57fc5$var$on(el, event, modifiers, callback) {
    var listenerTarget = el;
    var handler4 = function(e) {
        return callback(e);
    };
    var options = {};
    var wrapHandler = function(callback2, wrapper) {
        return function(e) {
            return wrapper(callback2, e);
        };
    };
    if (modifiers.includes("dot")) event = $06dab374eda57fc5$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $06dab374eda57fc5$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        var nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        var wait = $06dab374eda57fc5$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $06dab374eda57fc5$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        var nextModifier1 = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        var wait1 = $06dab374eda57fc5$var$isNumeric(nextModifier1.split("ms")[0]) ? Number(nextModifier1.split("ms")[0]) : 250;
        handler4 = $06dab374eda57fc5$var$throttle(handler4, wait1);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, function(next, e) {
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, function(next, e) {
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, function(next, e) {
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, function(next, e) {
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, function(next, e) {
        e.target === el && next(e);
    });
    if ($06dab374eda57fc5$var$isKeyEvent(event) || $06dab374eda57fc5$var$isClickEvent(event)) handler4 = wrapHandler(handler4, function(next, e) {
        if ($06dab374eda57fc5$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return function() {
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $06dab374eda57fc5$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $06dab374eda57fc5$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $06dab374eda57fc5$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $06dab374eda57fc5$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $06dab374eda57fc5$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $06dab374eda57fc5$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some(function(i) {
        return event.includes(i);
    });
}
function $06dab374eda57fc5$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    var keyModifiers = modifiers.filter(function(i) {
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        var debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $06dab374eda57fc5$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        var debounceIndex1 = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex1, $06dab374eda57fc5$var$isNumeric((keyModifiers[debounceIndex1 + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $06dab374eda57fc5$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    var systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    var selectedSystemKeyModifiers = systemKeyModifiers.filter(function(modifier) {
        return keyModifiers.includes(modifier);
    });
    keyModifiers = keyModifiers.filter(function(i) {
        return !selectedSystemKeyModifiers.includes(i);
    });
    if (selectedSystemKeyModifiers.length > 0) {
        var activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter(function(modifier) {
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e["".concat(modifier, "Key")];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($06dab374eda57fc5$var$isClickEvent(e.type)) return false;
            if ($06dab374eda57fc5$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $06dab374eda57fc5$var$keyToModifiers(key) {
    if (!key) return [];
    key = $06dab374eda57fc5$var$kebabCase2(key);
    var modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map(function(modifier) {
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter(function(modifier) {
        return modifier;
    });
}
// packages/alpinejs/src/directives/x-model.js
$06dab374eda57fc5$var$directive("model", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    var evaluateGet = $06dab374eda57fc5$var$evaluateLater(scopeTarget, expression);
    var evaluateSet;
    if (typeof expression === "string") evaluateSet = $06dab374eda57fc5$var$evaluateLater(scopeTarget, "".concat(expression, " = __placeholder"));
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $06dab374eda57fc5$var$evaluateLater(scopeTarget, "".concat(expression(), " = __placeholder"));
    else evaluateSet = function() {};
    var getValue = function() {
        var result;
        evaluateGet(function(value) {
            return result = value;
        });
        return $06dab374eda57fc5$var$isGetterSetter(result) ? result.get() : result;
    };
    var setValue = function(value) {
        var result;
        evaluateGet(function(value2) {
            return result = value2;
        });
        if ($06dab374eda57fc5$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(function() {}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $06dab374eda57fc5$var$mutateDom(function() {
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    var removeListener = $06dab374eda57fc5$var$isCloning ? function() {} : $06dab374eda57fc5$var$on(el, event, modifiers, function(e) {
        setValue($06dab374eda57fc5$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $06dab374eda57fc5$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($06dab374eda57fc5$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(function() {
        return el._x_removeModelListeners["default"]();
    });
    if (el.form) {
        var removeResetListener = $06dab374eda57fc5$var$on(el.form, "reset", [], function(e) {
            $06dab374eda57fc5$var$nextTick(function() {
                return el._x_model && el._x_model.set($06dab374eda57fc5$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue()));
            });
        });
        cleanup2(function() {
            return removeResetListener();
        });
    }
    el._x_model = {
        get: function() {
            return getValue();
        },
        set: function(value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = function(value) {
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $06dab374eda57fc5$var$mutateDom(function() {
            return $06dab374eda57fc5$var$bind(el, "value", value);
        });
        delete window.fromModel;
    };
    effect3(function() {
        var value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $06dab374eda57fc5$var$getInputValue(el, modifiers, event, currentValue) {
    return $06dab374eda57fc5$var$mutateDom(function() {
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($06dab374eda57fc5$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                var newValue = null;
                if (modifiers.includes("number")) newValue = $06dab374eda57fc5$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $06dab374eda57fc5$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter(function(el2) {
                    return !$06dab374eda57fc5$var$checkedAttrLooseCompare2(el2, newValue);
                });
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $06dab374eda57fc5$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $06dab374eda57fc5$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map(function(option) {
                return option.value || option.text;
            });
        } else {
            var newValue1;
            if ($06dab374eda57fc5$var$isRadio(el)) {
                if (event.target.checked) newValue1 = event.target.value;
                else newValue1 = currentValue;
            } else newValue1 = event.target.value;
            if (modifiers.includes("number")) return $06dab374eda57fc5$var$safeParseNumber(newValue1);
            else if (modifiers.includes("boolean")) return $06dab374eda57fc5$var$safeParseBoolean(newValue1);
            else if (modifiers.includes("trim")) return newValue1.trim();
            else return newValue1;
        }
    });
}
function $06dab374eda57fc5$var$safeParseNumber(rawValue) {
    var number = rawValue ? parseFloat(rawValue) : null;
    return $06dab374eda57fc5$var$isNumeric2(number) ? number : rawValue;
}
function $06dab374eda57fc5$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $06dab374eda57fc5$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $06dab374eda57fc5$var$isGetterSetter(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)) === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$06dab374eda57fc5$var$directive("cloak", function(el) {
    return queueMicrotask(function() {
        return $06dab374eda57fc5$var$mutateDom(function() {
            return el.removeAttribute($06dab374eda57fc5$var$prefix("cloak"));
        });
    });
});
// packages/alpinejs/src/directives/x-init.js
$06dab374eda57fc5$var$addInitSelector(function() {
    return "[".concat($06dab374eda57fc5$var$prefix("init"), "]");
});
$06dab374eda57fc5$var$directive("init", $06dab374eda57fc5$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$06dab374eda57fc5$var$directive("text", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $06dab374eda57fc5$var$mutateDom(function() {
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$06dab374eda57fc5$var$directive("html", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $06dab374eda57fc5$var$mutateDom(function() {
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $06dab374eda57fc5$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$06dab374eda57fc5$var$mapAttributes($06dab374eda57fc5$var$startingWith(":", $06dab374eda57fc5$var$into($06dab374eda57fc5$var$prefix("bind:"))));
var $06dab374eda57fc5$var$handler2 = function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, original = param.original, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (!value) {
        var bindingProviders = {};
        $06dab374eda57fc5$var$injectBindingProviders(bindingProviders);
        var getBindings = $06dab374eda57fc5$var$evaluateLater(el, expression);
        getBindings(function(bindings) {
            $06dab374eda57fc5$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $06dab374eda57fc5$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    var evaluate2 = $06dab374eda57fc5$var$evaluateLater(el, expression);
    effect3(function() {
        return evaluate2(function(result) {
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $06dab374eda57fc5$var$mutateDom(function() {
                return $06dab374eda57fc5$var$bind(el, value, result, modifiers);
            });
        });
    });
    cleanup2(function() {
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$06dab374eda57fc5$var$handler2.inline = function(el, param) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression;
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$06dab374eda57fc5$var$directive("bind", $06dab374eda57fc5$var$handler2);
function $06dab374eda57fc5$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$06dab374eda57fc5$var$addRootSelector(function() {
    return "[".concat($06dab374eda57fc5$var$prefix("data"), "]");
});
$06dab374eda57fc5$var$directive("data", function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    if ($06dab374eda57fc5$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    var magicContext = {};
    $06dab374eda57fc5$var$injectMagics(magicContext, el);
    var dataProviderContext = {};
    $06dab374eda57fc5$var$injectDataProviders(dataProviderContext, magicContext);
    var data2 = $06dab374eda57fc5$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $06dab374eda57fc5$var$injectMagics(data2, el);
    var reactiveData = $06dab374eda57fc5$var$reactive(data2);
    $06dab374eda57fc5$var$initInterceptors(reactiveData);
    var undo = $06dab374eda57fc5$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $06dab374eda57fc5$var$evaluate(el, reactiveData["init"]);
    cleanup2(function() {
        reactiveData["destroy"] && $06dab374eda57fc5$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$06dab374eda57fc5$var$interceptClone(function(from, to) {
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $06dab374eda57fc5$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$06dab374eda57fc5$var$isCloning) return false;
    if ($06dab374eda57fc5$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$06dab374eda57fc5$var$directive("show", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect;
    var evaluate2 = $06dab374eda57fc5$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = function() {
        $06dab374eda57fc5$var$mutateDom(function() {
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = function() {
        $06dab374eda57fc5$var$mutateDom(function() {
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    var hide = function() {
        el._x_doHide();
        el._x_isShown = false;
    };
    var show = function() {
        el._x_doShow();
        el._x_isShown = true;
    };
    var clickAwayCompatibleShow = function() {
        return setTimeout(show);
    };
    var toggle = $06dab374eda57fc5$var$once(function(value) {
        return value ? show() : hide();
    }, function(value) {
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    var oldValue;
    var firstTime = true;
    effect3(function() {
        return evaluate2(function(value) {
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        });
    });
});
// packages/alpinejs/src/directives/x-for.js
$06dab374eda57fc5$var$directive("for", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var iteratorNames = $06dab374eda57fc5$var$parseForExpression(expression);
    var evaluateItems = $06dab374eda57fc5$var$evaluateLater(el, iteratorNames.items);
    var evaluateKey = $06dab374eda57fc5$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(function() {
        return $06dab374eda57fc5$var$loop(el, iteratorNames, evaluateItems, evaluateKey);
    });
    cleanup2(function() {
        Object.values(el._x_lookup).forEach(function(el2) {
            return $06dab374eda57fc5$var$mutateDom(function() {
                $06dab374eda57fc5$var$destroyTree(el2);
                el2.remove();
            });
        });
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $06dab374eda57fc5$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    var isObject2 = function(i) {
        return (typeof i === "undefined" ? "undefined" : (0, $ewv1T._)(i)) === "object" && !Array.isArray(i);
    };
    var templateEl = el;
    evaluateItems(function(items) {
        var _loop = function(i3) {
            var key = removes[i3];
            if (!(key in lookup)) return "continue";
            $06dab374eda57fc5$var$mutateDom(function() {
                $06dab374eda57fc5$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }, _loop1 = function(i4) {
            var _moves_i = (0, $esDIr._)(moves[i4], 2), keyInSpot = _moves_i[0], keyForSpot = _moves_i[1];
            var elInSpot = lookup[keyInSpot];
            var elForSpot = lookup[keyForSpot];
            var marker = document.createElement("div");
            $06dab374eda57fc5$var$mutateDom(function() {
                if (!elForSpot) $06dab374eda57fc5$var$warn('x-for ":key" is undefined or invalid', templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }, _loop2 = function(i5) {
            var _adds_i = (0, $esDIr._)(adds[i5], 2), lastKey2 = _adds_i[0], index = _adds_i[1];
            var lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            var scope2 = scopes[index];
            var key = keys[index];
            var clone2 = document.importNode(templateEl.content, true).firstElementChild;
            var reactiveScope = $06dab374eda57fc5$var$reactive(scope2);
            $06dab374eda57fc5$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = function(newScope) {
                Object.entries(newScope).forEach(function(param) {
                    var _param = (0, $esDIr._)(param, 2), key2 = _param[0], value = _param[1];
                    reactiveScope[key2] = value;
                });
            };
            $06dab374eda57fc5$var$mutateDom(function() {
                lastEl.after(clone2);
                $06dab374eda57fc5$var$skipDuringClone(function() {
                    return $06dab374eda57fc5$var$initTree(clone2);
                })();
            });
            if ((typeof key === "undefined" ? "undefined" : (0, $ewv1T._)(key)) === "object") $06dab374eda57fc5$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        };
        if ($06dab374eda57fc5$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), function(i) {
            return i + 1;
        });
        if (items === void 0) items = [];
        var lookup = el._x_lookup;
        var prevKeys = el._x_prevKeys;
        var scopes = [];
        var keys = [];
        if (isObject2(items)) items = Object.entries(items).map(function(param) {
            var _param = (0, $esDIr._)(param, 2), key = _param[0], value = _param[1];
            var scope2 = $06dab374eda57fc5$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey(function(value2) {
                if (keys.includes(value2)) $06dab374eda57fc5$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: (0, $8lZHN._)({
                    index: key
                }, scope2)
            });
            scopes.push(scope2);
        });
        else for(var i = 0; i < items.length; i++){
            var scope2 = $06dab374eda57fc5$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey(function(value) {
                if (keys.includes(value)) $06dab374eda57fc5$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: (0, $8lZHN._)({
                    index: i
                }, scope2)
            });
            scopes.push(scope2);
        }
        var adds = [];
        var moves = [];
        var removes = [];
        var sames = [];
        for(var i1 = 0; i1 < prevKeys.length; i1++){
            var key = prevKeys[i1];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter(function(key) {
            return !removes.includes(key);
        });
        var lastKey = "template";
        for(var i2 = 0; i2 < keys.length; i2++){
            var key1 = keys[i2];
            var prevIndex = prevKeys.indexOf(key1);
            if (prevIndex === -1) {
                prevKeys.splice(i2, 0, key1);
                adds.push([
                    lastKey,
                    i2
                ]);
            } else if (prevIndex !== i2) {
                var keyInSpot = prevKeys.splice(i2, 1)[0];
                var keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i2, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key1);
            lastKey = key1;
        }
        for(var i3 = 0; i3 < removes.length; i3++)_loop(i3);
        for(var i4 = 0; i4 < moves.length; i4++)_loop1(i4);
        for(var i5 = 0; i5 < adds.length; i5++)_loop2(i5);
        for(var i6 = 0; i6 < sames.length; i6++)lookup[sames[i6]]._x_refreshXForScope(scopes[keys.indexOf(sames[i6])]);
        templateEl._x_prevKeys = keys;
    });
}
function $06dab374eda57fc5$var$parseForExpression(expression) {
    var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    var stripParensRE = /^\s*\(|\)\s*$/g;
    var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    var inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    var res = {};
    res.items = inMatch[2].trim();
    var item = inMatch[1].replace(stripParensRE, "").trim();
    var iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $06dab374eda57fc5$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    var scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        var names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map(function(i) {
            return i.trim();
        });
        names.forEach(function(name, i) {
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && (typeof item === "undefined" ? "undefined" : (0, $ewv1T._)(item)) === "object") {
        var names1 = iteratorNames.item.replace("{", "").replace("}", "").split(",").map(function(i) {
            return i.trim();
        });
        names1.forEach(function(name) {
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $06dab374eda57fc5$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $06dab374eda57fc5$var$handler3() {}
$06dab374eda57fc5$var$handler3.inline = function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    var root = $06dab374eda57fc5$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(function() {
        return delete root._x_refs[expression];
    });
};
$06dab374eda57fc5$var$directive("ref", $06dab374eda57fc5$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$06dab374eda57fc5$var$directive("if", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $06dab374eda57fc5$var$warn("x-if can only be used on a <template> tag", el);
    var evaluate2 = $06dab374eda57fc5$var$evaluateLater(el, expression);
    var show = function() {
        if (el._x_currentIfEl) return el._x_currentIfEl;
        var clone2 = el.content.cloneNode(true).firstElementChild;
        $06dab374eda57fc5$var$addScopeToNode(clone2, {}, el);
        $06dab374eda57fc5$var$mutateDom(function() {
            el.after(clone2);
            $06dab374eda57fc5$var$skipDuringClone(function() {
                return $06dab374eda57fc5$var$initTree(clone2);
            })();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = function() {
            $06dab374eda57fc5$var$mutateDom(function() {
                $06dab374eda57fc5$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    var hide = function() {
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(function() {
        return evaluate2(function(value) {
            value ? show() : hide();
        });
    });
    cleanup2(function() {
        return el._x_undoIf && el._x_undoIf();
    });
});
// packages/alpinejs/src/directives/x-id.js
$06dab374eda57fc5$var$directive("id", function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    var names = evaluate2(expression);
    names.forEach(function(name) {
        return $06dab374eda57fc5$var$setIdRoot(el, name);
    });
});
$06dab374eda57fc5$var$interceptClone(function(from, to) {
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$06dab374eda57fc5$var$mapAttributes($06dab374eda57fc5$var$startingWith("@", $06dab374eda57fc5$var$into($06dab374eda57fc5$var$prefix("on:"))));
$06dab374eda57fc5$var$directive("on", $06dab374eda57fc5$var$skipDuringClone(function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    var evaluate2 = expression ? $06dab374eda57fc5$var$evaluateLater(el, expression) : function() {};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    var removeListener = $06dab374eda57fc5$var$on(el, value, modifiers, function(e) {
        evaluate2(function() {}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(function() {
        return removeListener();
    });
}));
// packages/alpinejs/src/directives/index.js
$06dab374eda57fc5$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$06dab374eda57fc5$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$06dab374eda57fc5$var$warnMissingPluginDirective("Focus", "trap", "focus");
$06dab374eda57fc5$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $06dab374eda57fc5$var$warnMissingPluginDirective(name, directiveName, slug) {
    $06dab374eda57fc5$var$directive(directiveName, function(el) {
        return $06dab374eda57fc5$var$warn("You can't use [x-".concat(directiveName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/index.js
$06dab374eda57fc5$var$alpine_default.setEvaluator($06dab374eda57fc5$var$normalEvaluator);
$06dab374eda57fc5$var$alpine_default.setReactivityEngine({
    reactive: $06dab374eda57fc5$var$reactive2,
    effect: $06dab374eda57fc5$var$effect2,
    release: $06dab374eda57fc5$var$stop,
    raw: $06dab374eda57fc5$var$toRaw
});
var $06dab374eda57fc5$export$b7ee041e4ad2afec = $06dab374eda57fc5$var$alpine_default;
// packages/alpinejs/builds/module.js
var $06dab374eda57fc5$export$2e2bcd8739ae039 = $06dab374eda57fc5$export$b7ee041e4ad2afec;


// packages/collapse/src/index.js
function $f2bdf6974bcee655$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = function(el, param) {
        var modifiers = param.modifiers;
        if (!modifiers.includes("min")) return;
        el._x_doShow = function() {};
        el._x_doHide = function() {};
    };
    function collapse(el, param) {
        var modifiers = param.modifiers;
        var duration = $f2bdf6974bcee655$var$modifierValue(modifiers, "duration", 250) / 1e3;
        var floor = $f2bdf6974bcee655$var$modifierValue(modifiers, "min", 0);
        var fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = "".concat(floor, "px");
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        var setFunction = function(el2, styles) {
            var revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? function() {} : revertFunction;
        };
        var transitionStyles = {
            transitionProperty: "height",
            transitionDuration: "".concat(duration, "s"),
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in: function() {
                var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                var current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                var full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, function() {
                    return el._x_isShown = true;
                }, function() {
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out: function() {
                var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
                var full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, function() {
                    return el.style.overflow = "hidden";
                }, function() {
                    el._x_isShown = false;
                    if (el.style.height == "".concat(floor, "px") && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $f2bdf6974bcee655$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    var rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        var match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        var match1 = rawValue.match(/([0-9]+)px/);
        if (match1) return match1[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $f2bdf6974bcee655$export$2e2bcd8739ae039 = $f2bdf6974bcee655$export$ec45920981e0ca9b;


var $4752ed738165a691$exports = {};
/**
 * Countable is a script to allow for live paragraph-, word- and character-
 * counting on an HTML element.
 *
 * @author   Sacha Schmid (<https://github.com/RadLikeWhoa>)
 * @version  3.0.1
 * @license  MIT
 * @see      <http://radlikewhoa.github.io/Countable/>
 */ /**
 * Note: For the purpose of this internal documentation, arguments of the type
 * {Nodes} are to be interpreted as either {NodeList} or {Element}.
 */ (function(global) {
    /**
   * @private
   *
   * `liveElements` holds all elements that have the live-counting
   * functionality bound to them.
   */ var liveElements = [];
    var each = Array.prototype.forEach;
    /**
   * `ucs2decode` function from the punycode.js library.
   *
   * Creates an array containing the decimal code points of each Unicode
   * character in the string. While JavaScript uses UCS-2 internally, this
   * function will convert a pair of surrogate halves (each of which UCS-2
   * exposes as separate characters) into a single code point, matching
   * UTF-16.
   *
   * @see     <http://goo.gl/8M09r>
   * @see     <http://goo.gl/u4UUC>
   *
   * @param   {String}  string   The Unicode input string (UCS-2).
   *
   * @return  {Array}   The new array of code points.
   */ function decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
   * `validateArguments` validates the arguments given to each function call.
   * Errors are logged to the console as warnings, but Countable fails
   * silently.
   *
   * @private
   *
   * @param   {Nodes|String}  targets   A (collection of) element(s) or a single
	 *                                    string to validate.
   *
   * @param   {Function}      callback  The callback function to validate.
   *
   * @return  {Boolean}       Returns whether all arguments are vaild.
   */ function validateArguments(targets, callback) {
        var nodes = Object.prototype.toString.call(targets);
        var targetsValid = typeof targets === 'string' || nodes === '[object NodeList]' || nodes === '[object HTMLCollection]' || targets.nodeType === 1;
        var callbackValid = typeof callback === 'function';
        if (!targetsValid) console.error('Countable: Not a valid target');
        if (!callbackValid) console.error('Countable: Not a valid callback function');
        return targetsValid && callbackValid;
    }
    /**
   * `count` trims an element's value, optionally strips HTML tags and counts
   * paragraphs, sentences, words, characters and characters plus spaces.
   *
   * @private
   *
   * @param   {Node|String}  target   The target for the count.
   *
   * @param   {Object}   	   options  The options to use for the counting.
   *
   * @return  {Object}       The object containing the number of paragraphs,
   *                         sentences, words, characters and characters
	 *                         plus spaces.
   */ function count(target, options) {
        var original = '' + (typeof target === 'string' ? target : 'value' in target ? target.value : target.textContent);
        options = options || {};
        /**
     * The initial implementation to allow for HTML tags stripping was created
     * @craniumslows while the current one was created by @Rob--W.
     *
     * @see <http://goo.gl/Exmlr>
     * @see <http://goo.gl/gFQQh>
     */ if (options.stripTags) original = original.replace(/<\/?[a-z][^>]*>/gi, '');
        if (options.ignore) each.call(options.ignore, function(i) {
            original = original.replace(i, '');
        });
        var trimmed = original.trim();
        /**
     * Most of the performance improvements are based on the works of @epmatsw.
     *
     * @see <http://goo.gl/SWOLB>
     */ return {
            paragraphs: trimmed ? (trimmed.match(options.hardReturns ? /\n{2,}/g : /\n+/g) || []).length + 1 : 0,
            sentences: trimmed ? (trimmed.match(/[.?!…]+./g) || []).length + 1 : 0,
            words: trimmed ? (trimmed.replace(/['";:,.?¿\-!¡]+/g, '').match(/\S+/g) || []).length : 0,
            characters: trimmed ? decode(trimmed.replace(/\s/g, '')).length : 0,
            all: decode(original).length
        };
    }
    /**
   * This is the main object that will later be exposed to other scripts. It
   * holds all the public methods that can be used to enable the Countable
   * functionality.
   *
   * Some methods accept an optional options parameter. This includes the
   * following options.
   *
   * {Boolean}      hardReturns  Use two returns to seperate a paragraph
   *                             instead of one. (default: false)
   * {Boolean}      stripTags    Strip HTML tags before counting the values.
   *                             (default: false)
   * {Array<Char>}  ignore       A list of characters that should be removed
   *                             ignored when calculating the counters.
   *                             (default: )
   */ var Countable = {
        /**
     * The `on` method binds the counting handler to all given elements. The
     * event is either `oninput` or `onkeydown`, based on the capabilities of
     * the browser.
     *
     * @param   {Nodes}     elements   All elements that should receive the
     *                                 Countable functionality.
     *
     * @param   {Function}  callback   The callback to fire whenever the
     *                                 element's value changes. The callback is
     *                                 called with the relevant element bound
     *                                 to `this` and the counted values as the
     *                                 single parameter.
     *
     * @param   {Object}    [options]  An object to modify Countable's
     *                                 behaviour.
     *
     * @return  {Object}    Returns the Countable object to allow for chaining.
     */ on: function on(elements, callback, options) {
            if (!validateArguments(elements, callback)) return;
            if (!Array.isArray(elements)) elements = [
                elements
            ];
            each.call(elements, function(e) {
                var handler = function handler() {
                    callback.call(e, count(e, options));
                };
                liveElements.push({
                    element: e,
                    handler: handler
                });
                handler();
                e.addEventListener('input', handler);
            });
            return this;
        },
        /**
     * The `off` method removes the Countable functionality from all given
     * elements.
     *
     * @param   {Nodes}   elements  All elements whose Countable functionality
     *                              should be unbound.
     *
     * @return  {Object}  Returns the Countable object to allow for chaining.
     */ off: function off(elements) {
            if (!validateArguments(elements, function() {})) return;
            if (!Array.isArray(elements)) elements = [
                elements
            ];
            liveElements.filter(function(e) {
                return elements.indexOf(e.element) !== -1;
            }).forEach(function(e) {
                e.element.removeEventListener('input', e.handler);
            });
            liveElements = liveElements.filter(function(e) {
                return elements.indexOf(e.element) === -1;
            });
            return this;
        },
        /**
     * The `count` method works mostly like the `live` method, but no events are
     * bound, the functionality is only executed once.
     *
     * @param   {Nodes|String}  targets   All elements that should be counted.
     *
     * @param   {Function}      callback   The callback to fire whenever the
     *                                     element's value changes. The callback
		 *                                     is called with the relevant element
		 *                                     bound to `this` and the counted values
		 *                                     as the single parameter.
     *
     * @param   {Object}        [options]  An object to modify Countable's
     *                                     behaviour.
     *
     * @return  {Object}    Returns the Countable object to allow for chaining.
     */ count: function count1(targets, callback, options) {
            if (!validateArguments(targets, callback)) return;
            if (!Array.isArray(targets)) targets = [
                targets
            ];
            each.call(targets, function(e) {
                callback.call(e, count(e, options));
            });
            return this;
        },
        /**
     * The `enabled` method checks if the live-counting functionality is bound
     * to an element.
     *
     * @param   {Node}     element  All elements that should be checked for the
     *                              Countable functionality.
     *
     * @return  {Boolean}  A boolean value representing whether Countable
     *                     functionality is bound to all given elements.
     */ enabled: function enabled(elements) {
            if (elements.length === undefined) elements = [
                elements
            ];
            return liveElements.filter(function(e) {
                return elements.indexOf(e.element) !== -1;
            }).length === elements.length;
        }
    };
    $4752ed738165a691$exports = Countable;
})($4752ed738165a691$exports);



var $ewv1T = parcelRequire("ewv1T");

var $ewv1T = parcelRequire("ewv1T");
var $556dc400cba9ff95$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $556dc400cba9ff95$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: (typeof window === "undefined" ? "undefined" : (0, $ewv1T._)(window)) === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function errorHandler(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function getWeek(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $a3ebfaafc1e66230$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function ordinal(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $a3ebfaafc1e66230$export$2e2bcd8739ae039 = $a3ebfaafc1e66230$export$33e6c23ebe2ee669;


var $e90282772c5bfe3f$export$5d04458e2a6c373e = function pad(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $e90282772c5bfe3f$export$7d260a2a5f8bc19e = function int(bool) {
    return bool === true ? 1 : 0;
};
function $e90282772c5bfe3f$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $e90282772c5bfe3f$export$3131421a7d01b4fb = function arrayify(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $6862e0bfc6888d9a$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $6862e0bfc6888d9a$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $6862e0bfc6888d9a$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $6862e0bfc6888d9a$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $6862e0bfc6888d9a$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $6862e0bfc6888d9a$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $6862e0bfc6888d9a$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $6862e0bfc6888d9a$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $6862e0bfc6888d9a$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $6862e0bfc6888d9a$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $6862e0bfc6888d9a$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $3a7a04b4bfac8db7$var$doNothing = function doNothing() {
    return undefined;
};
var $3a7a04b4bfac8db7$export$27a2dd9af757e89c = function monthToStr(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $3a7a04b4bfac8db7$export$9490b78b888a863f = {
    D: $3a7a04b4bfac8db7$var$doNothing,
    F: function F(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function G(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function H(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function J(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function K(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function M(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function S(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function U(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function W(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function Y(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function Z(_, ISODate) {
        return new Date(ISODate);
    },
    d: function d(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function h(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function i(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function j(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $3a7a04b4bfac8db7$var$doNothing,
    m: function m(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function n(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function s(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function u(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $3a7a04b4bfac8db7$var$doNothing,
    y: function y(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $3a7a04b4bfac8db7$export$55069460464ca7a9 = {
    Z: function Z(date) {
        return date.toISOString();
    },
    D: function D(date, locale, options) {
        return locale.weekdays.shorthand[$3a7a04b4bfac8db7$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function F(date, locale, options) {
        return $3a7a04b4bfac8db7$export$27a2dd9af757e89c($3a7a04b4bfac8db7$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function G(date, locale, options) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)($3a7a04b4bfac8db7$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function H(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function J(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function K(date, locale) {
        return locale.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function M(date, locale) {
        return $3a7a04b4bfac8db7$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function S(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function U(date) {
        return date.getTime() / 1000;
    },
    W: function W(date, _, options) {
        return options.getWeek(date);
    },
    Y: function Y(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function d(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function h(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function i(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function j(date) {
        return date.getDate();
    },
    l: function l(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function m(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function n(date) {
        return date.getMonth() + 1;
    },
    s: function s(date) {
        return date.getSeconds();
    },
    u: function u(date) {
        return date.getTime();
    },
    w: function w(date) {
        return date.getDay();
    },
    y: function y(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $1790eb92a3243d88$export$ff1a0b75284ac636 = function createDateFormatter(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $556dc400cba9ff95$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $a3ebfaafc1e66230$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $3a7a04b4bfac8db7$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $3a7a04b4bfac8db7$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $1790eb92a3243d88$export$cfa2ef2687faeda2 = function createDateParser(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $556dc400cba9ff95$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $a3ebfaafc1e66230$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $556dc400cba9ff95$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $3a7a04b4bfac8db7$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $1790eb92a3243d88$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $1790eb92a3243d88$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $1790eb92a3243d88$export$a4d69fb5f2026c35 = function isBetween(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $1790eb92a3243d88$export$9fafc166baa96839 = function calculateSecondsSinceMidnight(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $1790eb92a3243d88$export$a4ce0def660bfe9e = function parseSeconds(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $1790eb92a3243d88$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $1790eb92a3243d88$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function _loop_1(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $d57b7be5ef1ae277$var$__assign = undefined && undefined.__assign || function() {
    $d57b7be5ef1ae277$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d57b7be5ef1ae277$var$__assign.apply(this, arguments);
};
var $d57b7be5ef1ae277$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $d57b7be5ef1ae277$var$DEBOUNCED_CHANGE_MS = 300;
function $d57b7be5ef1ae277$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, (0, $556dc400cba9ff95$export$ebe90cb607ad99e)), $d57b7be5ef1ae277$var$flatpickr.defaultConfig),
        l10n: (0, $a3ebfaafc1e66230$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $1790eb92a3243d88$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function getDaysInMonth(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $1790eb92a3243d88$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $1790eb92a3243d88$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $1790eb92a3243d88$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $1790eb92a3243d88$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $1790eb92a3243d88$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $1790eb92a3243d88$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $1790eb92a3243d88$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $1790eb92a3243d88$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function remove() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $e90282772c5bfe3f$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $e90282772c5bfe3f$export$61fc7d43ac8f84b0)(triggerChange, $d57b7be5ef1ae277$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function selText(e) {
                return (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $6862e0bfc6888d9a$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $6862e0bfc6888d9a$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function shouldBuildMonth(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $3a7a04b4bfac8db7$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $6862e0bfc6888d9a$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $6862e0bfc6888d9a$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function get() {
                return self.__hidePrevMonthArrow;
            },
            set: function set(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function get() {
                return self.__hideNextMonthArrow;
            },
            set: function set(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $1790eb92a3243d88$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $6862e0bfc6888d9a$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $6862e0bfc6888d9a$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $6862e0bfc6888d9a$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $6862e0bfc6888d9a$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $d57b7be5ef1ae277$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $d57b7be5ef1ae277$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $1790eb92a3243d88$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $1790eb92a3243d88$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $1790eb92a3243d88$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if ((typeof d === "undefined" ? "undefined" : (0, $ewv1T._)(d)) === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $1790eb92a3243d88$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $1790eb92a3243d88$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function get() {
                return self.config._enable;
            },
            set: function set(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function get() {
                return self.config._disable;
            },
            set: function set(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $d57b7be5ef1ae277$var$flatpickr.defaultConfig.dateFormat || (0, $556dc400cba9ff95$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $d57b7be5ef1ae277$var$flatpickr.defaultConfig.altFormat || (0, $556dc400cba9ff95$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function get() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function get() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function minMaxTimeSetter(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function get() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function get() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $556dc400cba9ff95$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $e90282772c5bfe3f$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $556dc400cba9ff95$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $e90282772c5bfe3f$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if ((0, $ewv1T._)(self.config.locale) !== "object" && typeof $d57b7be5ef1ae277$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, $d57b7be5ef1ae277$var$flatpickr.l10ns.default), (0, $ewv1T._)(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? $d57b7be5ef1ae277$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $d57b7be5ef1ae277$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $1790eb92a3243d88$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $1790eb92a3243d88$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function isSelectable(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $6862e0bfc6888d9a$export$25245567f53f158f)((0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $1790eb92a3243d88$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && (typeof option === "undefined" ? "undefined" : (0, $ewv1T._)(option)) === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $556dc400cba9ff95$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $e90282772c5bfe3f$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && (typeof rule === "undefined" ? "undefined" : (0, $ewv1T._)(rule)) === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $1790eb92a3243d88$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $3a7a04b4bfac8db7$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(isHourElem) && (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $d57b7be5ef1ae277$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $d57b7be5ef1ae277$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $d57b7be5ef1ae277$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $d57b7be5ef1ae277$var$_flatpickr([
            this
        ], config);
    };
}
var $d57b7be5ef1ae277$var$flatpickr = function flatpickr(selector, config) {
    if (typeof selector === "string") return $d57b7be5ef1ae277$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $d57b7be5ef1ae277$var$_flatpickr([
        selector
    ], config);
    else return $d57b7be5ef1ae277$var$_flatpickr(selector, config);
};
$d57b7be5ef1ae277$var$flatpickr.defaultConfig = {};
$d57b7be5ef1ae277$var$flatpickr.l10ns = {
    en: $d57b7be5ef1ae277$var$__assign({}, (0, $a3ebfaafc1e66230$export$2e2bcd8739ae039)),
    default: $d57b7be5ef1ae277$var$__assign({}, (0, $a3ebfaafc1e66230$export$2e2bcd8739ae039))
};
$d57b7be5ef1ae277$var$flatpickr.localize = function(l10n) {
    $d57b7be5ef1ae277$var$flatpickr.l10ns.default = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, $d57b7be5ef1ae277$var$flatpickr.l10ns.default), l10n);
};
$d57b7be5ef1ae277$var$flatpickr.setDefaults = function(config) {
    $d57b7be5ef1ae277$var$flatpickr.defaultConfig = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, $d57b7be5ef1ae277$var$flatpickr.defaultConfig), config);
};
$d57b7be5ef1ae277$var$flatpickr.parseDate = (0, $1790eb92a3243d88$export$cfa2ef2687faeda2)({});
$d57b7be5ef1ae277$var$flatpickr.formatDate = (0, $1790eb92a3243d88$export$ff1a0b75284ac636)({});
$d57b7be5ef1ae277$var$flatpickr.compareDates = (0, $1790eb92a3243d88$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $d57b7be5ef1ae277$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $d57b7be5ef1ae277$var$flatpickr;
var $d57b7be5ef1ae277$export$2e2bcd8739ae039 = $d57b7be5ef1ae277$var$flatpickr;


var $c788bd62cabaec58$exports = {};
(function(global, factory) {
    factory($c788bd62cabaec58$exports);
})($c788bd62cabaec58$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var German = {
        weekdays: {
            shorthand: [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ],
            longhand: [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "M\xe4r",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez"
            ],
            longhand: [
                "Januar",
                "Februar",
                "M\xe4rz",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember"
            ]
        },
        firstDayOfWeek: 1,
        weekAbbreviation: "KW",
        rangeSeparator: " bis ",
        scrollTitle: "Zum \xc4ndern scrollen",
        toggleTitle: "Zum Umschalten klicken",
        time_24hr: true
    };
    fp.l10ns.de = German;
    var de = fp.l10ns;
    exports1.German = German;
    exports1.default = de;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



var $ctUVE = parcelRequire("ctUVE");

var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $6lD0P = parcelRequire("6lD0P");

var $dqNF0 = parcelRequire("dqNF0");

var $esDIr = parcelRequire("esDIr");

var $ewv1T = parcelRequire("ewv1T");
/**
 * MicroEvent - to make any js object an event emitter
 *
 * - pure javascript - server compatible, browser compatible
 * - dont rely on the browser doms
 * - super simple - you get it immediatly, no mistery, no magic involved
 *
 * @author Jerome Etienne (https://github.com/jeromeetienne)
 */ /**
 * Execute callback for each event in space separated list of event names
 *
 */ 
var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");
function $0be681fe05ff7223$var$forEvents(events, callback) {
    events.split(/\s+/).forEach(function(event) {
        callback(event);
    });
}
var $0be681fe05ff7223$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function MicroEvent() {
        (0, $ioD88._)(this, MicroEvent);
        this._events = {};
    }
    (0, $6NCFa._)(MicroEvent, [
        {
            key: "on",
            value: function on(events, fct) {
                var _this = this;
                $0be681fe05ff7223$var$forEvents(events, function(event) {
                    var event_array = _this._events[event] || [];
                    event_array.push(fct);
                    _this._events[event] = event_array;
                });
            }
        },
        {
            key: "off",
            value: function off(events, fct) {
                var _this = this;
                var n = arguments.length;
                if (n === 0) {
                    this._events = {};
                    return;
                }
                $0be681fe05ff7223$var$forEvents(events, function(event) {
                    if (n === 1) {
                        delete _this._events[event];
                        return;
                    }
                    var event_array = _this._events[event];
                    if (event_array === undefined) return;
                    event_array.splice(event_array.indexOf(fct), 1);
                    _this._events[event] = event_array;
                });
            }
        },
        {
            key: "trigger",
            value: function trigger(events) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var self = this;
                $0be681fe05ff7223$var$forEvents(events, function(event) {
                    var event_array = self._events[event];
                    if (event_array === undefined) return;
                    event_array.forEach(function(fct) {
                        fct.apply(self, args);
                    });
                });
            }
        }
    ]);
    return MicroEvent;
}();


/**
 * microplugin.js
 * Copyright (c) 2013 Brian Reavis & contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 * @author Brian Reavis <brian@thirdroute.com>
 */ 
var $ctUVE = parcelRequire("ctUVE");

var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $dqNF0 = parcelRequire("dqNF0");
function $b89836cef003ca5e$export$2e2bcd8739ae039(Interface) {
    Interface.plugins = {};
    return /*#__PURE__*/ function(Interface1) {
        "use strict";
        (0, $dqNF0._)(_class, Interface1);
        function _class() {
            (0, $ioD88._)(this, _class);
            var _this;
            _this = (0, $ctUVE._)(this, _class, arguments);
            _this.plugins = {
                names: [],
                settings: {},
                requested: {},
                loaded: {}
            };
            return _this;
        }
        (0, $6NCFa._)(_class, [
            {
                /**
         * Initializes the listed plugins (with options).
         * Acceptable formats:
         *
         * List (without options):
         *   ['a', 'b', 'c']
         *
         * List (with options):
         *   [{'name': 'a', options: {}}, {'name': 'b', options: {}}]
         *
         * Hash (with options):
         *   {'a': { ... }, 'b': { ... }, 'c': { ... }}
         *
         * @param {array|object} plugins
         */ key: "initializePlugins",
                value: function initializePlugins(plugins) {
                    var key, name;
                    var self = this;
                    var queue = [];
                    if (Array.isArray(plugins)) plugins.forEach(function(plugin) {
                        if (typeof plugin === 'string') queue.push(plugin);
                        else {
                            self.plugins.settings[plugin.name] = plugin.options;
                            queue.push(plugin.name);
                        }
                    });
                    else if (plugins) {
                        for(key in plugins)if (plugins.hasOwnProperty(key)) {
                            self.plugins.settings[key] = plugins[key];
                            queue.push(key);
                        }
                    }
                    while(name = queue.shift())self.require(name);
                }
            },
            {
                key: "loadPlugin",
                value: function loadPlugin(name) {
                    var self = this;
                    var plugins = self.plugins;
                    var plugin = Interface.plugins[name];
                    if (!Interface.plugins.hasOwnProperty(name)) throw new Error('Unable to find "' + name + '" plugin');
                    plugins.requested[name] = true;
                    plugins.loaded[name] = plugin.fn.apply(self, [
                        self.plugins.settings[name] || {}
                    ]);
                    plugins.names.push(name);
                }
            },
            {
                /**
         * Initializes a plugin.
         *
         */ key: "require",
                value: function require(name) {
                    var self = this;
                    var plugins = self.plugins;
                    if (!self.plugins.loaded.hasOwnProperty(name)) {
                        if (plugins.requested[name]) throw new Error('Plugin has circular dependency ("' + name + '")');
                        self.loadPlugin(name);
                    }
                    return plugins.loaded[name];
                }
            }
        ], [
            {
                key: "define",
                value: /**
         * Registers a plugin.
         *
         * @param {function} fn
         */ function define(name, fn) {
                    Interface.plugins[name] = {
                        'name': name,
                        'fn': fn
                    };
                }
            }
        ]);
        return _class;
    }(Interface);
}


var $bf7c2f5b0c0ee360$exports = {};

var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $esDIr = parcelRequire("esDIr");

var $ewv1T = parcelRequire("ewv1T");

/*! sifter.js | https://github.com/orchidjs/sifter.js | Apache License (v2) */ (function(global, factory) {
    factory($bf7c2f5b0c0ee360$exports);
})(undefined, function(exports1) {
    'use strict';
    /**
     * Convert array of strings to a regular expression
     *	ex ['ab','a'] => (?:ab|a)
     * 	ex ['a','b'] => [ab]
     */ var arrayToPattern = function(chars) {
        chars = chars.filter(Boolean);
        if (chars.length < 2) return chars[0] || '';
        return maxValueLength(chars) == 1 ? '[' + chars.join('') + ']' : '(?:' + chars.join('|') + ')';
    };
    var sequencePattern = function(array) {
        if (!hasDuplicates(array)) return array.join('');
        var pattern = '';
        var prev_char_count = 0;
        var prev_pattern = function() {
            if (prev_char_count > 1) pattern += '{' + prev_char_count + '}';
        };
        array.forEach(function(char, i) {
            if (char === array[i - 1]) {
                prev_char_count++;
                return;
            }
            prev_pattern();
            pattern += char;
            prev_char_count = 1;
        });
        prev_pattern();
        return pattern;
    };
    /**
     * Convert array of strings to a regular expression
     *	ex ['ab','a'] => (?:ab|a)
     * 	ex ['a','b'] => [ab]
     */ var setToPattern = function(chars) {
        var array = Array.from(chars);
        return arrayToPattern(array);
    };
    /**
     * https://stackoverflow.com/questions/7376598/in-javascript-how-do-i-check-if-an-array-has-duplicate-values
     */ var hasDuplicates = function(array) {
        return new Set(array).size !== array.length;
    };
    /**
     * https://stackoverflow.com/questions/63006601/why-does-u-throw-an-invalid-escape-error
     */ var escape_regex = function(str) {
        return (str + '').replace(/([\$\(-\+\.\?\[-\^\{-\}])/g, '\\$1');
    };
    /**
     * Return the max length of array values
     */ var maxValueLength = function(array) {
        return array.reduce(function(longest, value) {
            return Math.max(longest, unicodeLength(value));
        }, 0);
    };
    var unicodeLength = function(str) {
        return Array.from(str).length;
    };
    /**
     * Get all possible combinations of substrings that add up to the given string
     * https://stackoverflow.com/questions/30169587/find-all-the-combination-of-substrings-that-add-up-to-the-given-string
     */ var allSubstrings = function(input) {
        if (input.length === 1) return [
            [
                input
            ]
        ];
        var result = [];
        var start = input.substring(1);
        var suba = allSubstrings(start);
        suba.forEach(function(subresult) {
            var tmp = subresult.slice(0);
            tmp[0] = input.charAt(0) + tmp[0];
            result.push(tmp);
            tmp = subresult.slice(0);
            tmp.unshift(input.charAt(0));
            result.push(tmp);
        });
        return result;
    };
    var code_points = [
        [
            0,
            65535
        ]
    ];
    var accent_pat = "[\u0300-\u036F\xb7\u02BE\u02BC]";
    var unicode_map;
    var multi_char_reg;
    var max_char_length = 3;
    var latin_convert = {};
    var latin_condensed = {
        '/': "\u2044\u2215",
        '0': "\u07C0",
        "a": "\u2C65\u0250\u0251",
        "aa": "\uA733",
        "ae": "\xe6\u01FD\u01E3",
        "ao": "\uA735",
        "au": "\uA737",
        "av": "\uA739\uA73B",
        "ay": "\uA73D",
        "b": "\u0180\u0253\u0183",
        "c": "\uA73F\u0188\u023C\u2184",
        "d": "\u0111\u0257\u0256\u1D05\u018C\uABB7\u0501\u0266",
        "e": "\u025B\u01DD\u1D07\u0247",
        "f": "\uA77C\u0192",
        "g": "\u01E5\u0260\uA7A1\u1D79\uA77F\u0262",
        "h": "\u0127\u2C68\u2C76\u0265",
        "i": "\u0268\u0131",
        "j": "\u0249\u0237",
        "k": "\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
        "l": "\u0142\u019A\u026B\u2C61\uA749\uA747\uA781\u026D",
        "m": "\u0271\u026F\u03FB",
        "n": "\uA7A5\u019E\u0272\uA791\u1D0E\u043B\u0509",
        "o": "\xf8\u01FF\u0254\u0275\uA74B\uA74D\u1D11",
        "oe": "\u0153",
        "oi": "\u01A3",
        "oo": "\uA74F",
        "ou": "\u0223",
        "p": "\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
        "q": "\uA757\uA759\u024B",
        "r": "\u024D\u027D\uA75B\uA7A7\uA783",
        "s": "\xdf\u023F\uA7A9\uA785\u0282",
        "t": "\u0167\u01AD\u0288\u2C66\uA787",
        "th": "\xfe",
        "tz": "\uA729",
        "u": "\u0289",
        "v": "\u028B\uA75F\u028C",
        "vy": "\uA761",
        "w": "\u2C73",
        "y": "\u01B4\u024F\u1EFF",
        "z": "\u01B6\u0225\u0240\u2C6C\uA763",
        "hv": "\u0195"
    };
    for(var latin in latin_condensed){
        var unicode = latin_condensed[latin] || '';
        for(var i = 0; i < unicode.length; i++){
            var char = unicode.substring(i, i + 1);
            latin_convert[char] = latin;
        }
    }
    var convert_pat = new RegExp(Object.keys(latin_convert).join('|') + '|' + accent_pat, 'gu');
    /**
     * Initialize the unicode_map from the give code point ranges
     */ var initialize = function(_code_points) {
        if (unicode_map !== undefined) return;
        unicode_map = generateMap(code_points);
    };
    /**
     * Helper method for normalize a string
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
     */ var normalize = function(str) {
        var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'NFKD';
        return str.normalize(form);
    };
    /**
     * Remove accents without reordering string
     * calling str.normalize('NFKD') on \u{594}\u{595}\u{596} becomes \u{596}\u{594}\u{595}
     * via https://github.com/krisk/Fuse/issues/133#issuecomment-318692703
     */ var asciifold = function(str) {
        return Array.from(str).reduce(/**
       * @param {string} result
       * @param {string} char
       */ function(result, char) {
            return result + _asciifold(char);
        }, '');
    };
    var _asciifold = function(str) {
        str = normalize(str).toLowerCase().replace(convert_pat, function(/** @type {string} */ char) {
            return latin_convert[char] || '';
        });
        //return str;
        return normalize(str, 'NFC');
    };
    /**
     * Generate a list of unicode variants from the list of code points
     */ function generator(code_points) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, code_point_min, code_point_max, i, composed, folded, err;
        return (0, $15f39fe0df078b1e$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]);
                    _iterator = code_points[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    _step_value = (0, $esDIr._)(_step.value, 2), code_point_min = _step_value[0], code_point_max = _step_value[1];
                    i = code_point_min;
                    _state.label = 3;
                case 3:
                    if (!(i <= code_point_max)) return [
                        3,
                        6
                    ];
                    composed = String.fromCharCode(i);
                    folded = asciifold(composed);
                    if (folded == composed.toLowerCase()) return [
                        3,
                        5
                    ];
                    // skip when folded is a string longer than 3 characters long
                    // bc the resulting regex patterns will be long
                    // eg:
                    // folded صلى الله عليه وسلم length 18 code point 65018
                    // folded جل جلاله length 8 code point 65019
                    if (folded.length > max_char_length) return [
                        3,
                        5
                    ];
                    if (folded.length == 0) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        {
                            folded: folded,
                            composed: composed,
                            code_point: i
                        }
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    }
    /**
     * Generate a unicode map from the list of code points
     */ var generateSets = function(code_points) {
        var unicode_sets = {};
        var addMatching = function(folded, to_add) {
            /** @type {Set<string>} */ var folded_set = unicode_sets[folded] || new Set();
            var patt = new RegExp('^' + setToPattern(folded_set) + '$', 'iu');
            if (to_add.match(patt)) return;
            folded_set.add(escape_regex(to_add));
            unicode_sets[folded] = folded_set;
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = generator(code_points)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                addMatching(value.folded, value.folded);
                addMatching(value.folded, value.composed);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return unicode_sets;
    };
    /**
     * Generate a unicode map from the list of code points
     * ae => (?:(?:ae|Æ|Ǽ|Ǣ)|(?:A|Ⓐ|Ａ...)(?:E|ɛ|Ⓔ...))
     */ var generateMap = function(code_points) {
        var unicode_sets = generateSets(code_points);
        var unicode_map = {};
        var multi_char = [];
        for(var folded in unicode_sets){
            var set = unicode_sets[folded];
            if (set) unicode_map[folded] = setToPattern(set);
            if (folded.length > 1) multi_char.push(escape_regex(folded));
        }
        multi_char.sort(function(a, b) {
            return b.length - a.length;
        });
        var multi_char_patt = arrayToPattern(multi_char);
        multi_char_reg = new RegExp('^' + multi_char_patt, 'u');
        return unicode_map;
    };
    /**
     * Map each element of an array from its folded value to all possible unicode matches
     */ var mapSequence = function(strings) {
        var min_replacement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var chars_replaced = 0;
        strings = strings.map(function(str) {
            if (unicode_map[str]) chars_replaced += str.length;
            return unicode_map[str] || str;
        });
        if (chars_replaced >= min_replacement) return sequencePattern(strings);
        return '';
    };
    /**
     * Convert a short string and split it into all possible patterns
     * Keep a pattern only if min_replacement is met
     *
     * 'abc'
     * 		=> [['abc'],['ab','c'],['a','bc'],['a','b','c']]
     *		=> ['abc-pattern','ab-c-pattern'...]
     */ var substringsToPattern = function(str) {
        var min_replacement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        min_replacement = Math.max(min_replacement, str.length - 1);
        return arrayToPattern(allSubstrings(str).map(function(sub_pat) {
            return mapSequence(sub_pat, min_replacement);
        }));
    };
    /**
     * Convert an array of sequences into a pattern
     * [{start:0,end:3,length:3,substr:'iii'}...] => (?:iii...)
     */ var sequencesToPattern = function(sequences) {
        var all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var min_replacement = sequences.length > 1 ? 1 : 0;
        return arrayToPattern(sequences.map(function(sequence) {
            var seq = [];
            var len = all ? sequence.length() : sequence.length() - 1;
            for(var j = 0; j < len; j++)seq.push(substringsToPattern(sequence.substrs[j] || '', min_replacement));
            return sequencePattern(seq);
        }));
    };
    /**
     * Return true if the sequence is already in the sequences
     */ var inSequences = function(needle_seq, sequences) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var seq = _step.value;
                if (seq.start != needle_seq.start || seq.end != needle_seq.end) return "continue";
                if (seq.substrs.join('') !== needle_seq.substrs.join('')) return "continue";
                var needle_parts = needle_seq.parts;
                var filter = function(part) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = needle_parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var needle_part = _step.value;
                            if (needle_part.start === part.start && needle_part.substr === part.substr) return false;
                            if (part.length == 1 || needle_part.length == 1) continue;
                            // check for overlapping parts
                            // a = ['::=','==']
                            // b = ['::','===']
                            // a = ['r','sm']
                            // b = ['rs','m']
                            if (part.start < needle_part.start && part.end > needle_part.start) return true;
                            if (needle_part.start < part.start && needle_part.end > part.start) return true;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return false;
                };
                var filtered = seq.parts.filter(filter);
                if (filtered.length > 0) return "continue";
                return {
                    v: true
                };
            };
            for(var _iterator = sequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _ret = _loop();
                if ((0, $ewv1T._)(_ret) === "object") return _ret.v;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    var Sequence = /*#__PURE__*/ function() {
        function Sequence() {
            (0, $ioD88._)(this, Sequence);
            this.parts = void 0;
            this.substrs = void 0;
            this.start = void 0;
            this.end = void 0;
            this.parts = [];
            this.substrs = [];
            this.start = 0;
            this.end = 0;
        }
        (0, $6NCFa._)(Sequence, [
            {
                key: "add",
                value: function add(part) {
                    if (part) {
                        this.parts.push(part);
                        this.substrs.push(part.substr);
                        this.start = Math.min(part.start, this.start);
                        this.end = Math.max(part.end, this.end);
                    }
                }
            },
            {
                key: "last",
                value: function last() {
                    return this.parts[this.parts.length - 1];
                }
            },
            {
                key: "length",
                value: function length() {
                    return this.parts.length;
                }
            },
            {
                key: "clone",
                value: function clone(position, last_piece) {
                    var clone = new Sequence();
                    var parts = JSON.parse(JSON.stringify(this.parts));
                    var last_part = parts.pop();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var part = _step.value;
                            clone.add(part);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var last_substr = last_piece.substr.substring(0, position - last_part.start);
                    var clone_last_len = last_substr.length;
                    clone.add({
                        start: last_part.start,
                        end: last_part.start + clone_last_len,
                        length: clone_last_len,
                        substr: last_substr
                    });
                    return clone;
                }
            }
        ]);
        return Sequence;
    }();
    /**
     * Expand a regular expression pattern to include unicode variants
     * 	eg /a/ becomes /aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑAⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ/
     *
     * Issue:
     *  ﺊﺋ [ 'ﺊ = \\u{fe8a}', 'ﺋ = \\u{fe8b}' ]
     *	becomes:	ئئ [ 'ي = \\u{64a}', 'ٔ = \\u{654}', 'ي = \\u{64a}', 'ٔ = \\u{654}' ]
     *
     *	İĲ = IIJ = ⅡJ
     *
     * 	1/2/4
     */ var getPattern = function(str) {
        initialize();
        str = asciifold(str);
        var pattern = '';
        var sequences = [
            new Sequence()
        ];
        for(var i = 0; i < str.length; i++){
            var substr = str.substring(i);
            var match = substr.match(multi_char_reg);
            var char = str.substring(i, i + 1);
            var match_str = match ? match[0] : null;
            // loop through sequences
            // add either the char or multi_match
            var overlapping = [];
            var added_types = new Set();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sequence = _step.value;
                    var last_piece = sequence.last();
                    if (!last_piece || last_piece.length == 1 || last_piece.end <= i) {
                        // if we have a multi match
                        if (match_str) {
                            var len = match_str.length;
                            sequence.add({
                                start: i,
                                end: i + len,
                                length: len,
                                substr: match_str
                            });
                            added_types.add('1');
                        } else {
                            sequence.add({
                                start: i,
                                end: i + 1,
                                length: 1,
                                substr: char
                            });
                            added_types.add('2');
                        }
                    } else if (match_str) {
                        var clone = sequence.clone(i, last_piece);
                        var len1 = match_str.length;
                        clone.add({
                            start: i,
                            end: i + len1,
                            length: len1,
                            substr: match_str
                        });
                        overlapping.push(clone);
                    } else // don't add char
                    // adding would create invalid patterns: 234 => [2,34,4]
                    added_types.add('3');
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // if we have overlapping
            if (overlapping.length > 0) {
                // ['ii','iii'] before ['i','i','iii']
                overlapping = overlapping.sort(function(a, b) {
                    return a.length() - b.length();
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = overlapping[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var clone1 = _step1.value;
                        // don't add if we already have an equivalent sequence
                        if (inSequences(clone1, sequences)) continue;
                        sequences.push(clone1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                continue;
            }
            // if we haven't done anything unique
            // clean up the patterns
            // helps keep patterns smaller
            // if str = 'r₨㎧aarss', pattern will be 446 instead of 655
            if (i > 0 && added_types.size == 1 && !added_types.has('3')) {
                pattern += sequencesToPattern(sequences, false);
                var new_seq = new Sequence();
                var old_seq = sequences[0];
                if (old_seq) new_seq.add(old_seq.last());
                sequences = [
                    new_seq
                ];
            }
        }
        pattern += sequencesToPattern(sequences, true);
        return pattern;
    };
    /**
     * A property getter resolving dot-notation
     * @param  {Object}  obj     The root object to fetch property on
     * @param  {String}  name    The optionally dotted property name to fetch
     * @return {Object}          The resolved property value
     */ var getAttr = function(obj, name) {
        if (!obj) return;
        return obj[name];
    };
    /**
     * A property getter resolving dot-notation
     * @param  {Object}  obj     The root object to fetch property on
     * @param  {String}  name    The optionally dotted property name to fetch
     * @return {Object}          The resolved property value
     */ var getAttrNesting = function(obj, name) {
        if (!obj) return;
        var part, names = name.split(".");
        while((part = names.shift()) && (obj = obj[part]));
        return obj;
    };
    /**
     * Calculates how close of a match the
     * given value is against a search token.
     *
     */ var scoreValue = function(value, token, weight) {
        var score, pos;
        if (!value) return 0;
        value = value + '';
        if (token.regex == null) return 0;
        pos = value.search(token.regex);
        if (pos === -1) return 0;
        score = token.string.length / value.length;
        if (pos === 0) score += 0.5;
        return score * weight;
    };
    /**
     * Cast object property to an array if it exists and has a value
     *
     */ var propToArray = function(obj, key) {
        var value = obj[key];
        if (typeof value == 'function') return value;
        if (value && !Array.isArray(value)) obj[key] = [
            value
        ];
    };
    /**
     * Iterates over arrays and hashes.
     *
     * ```
     * iterate(this.items, function(item, id) {
     *    // invoked for each item
     * });
     * ```
     *
     */ var iterate = function(object, callback) {
        if (Array.isArray(object)) object.forEach(callback);
        else {
            for(var key in object)if (object.hasOwnProperty(key)) callback(object[key], key);
        }
    };
    var cmp = function(a, b) {
        if (typeof a === 'number' && typeof b === 'number') return a > b ? 1 : a < b ? -1 : 0;
        a = asciifold(a + '').toLowerCase();
        b = asciifold(b + '').toLowerCase();
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
    };
    /**
     * sifter.js
     * Copyright (c) 2013–2020 Brian Reavis & contributors
     *
     * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
     * file except in compliance with the License. You may obtain a copy of the License at:
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software distributed under
     * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
     * ANY KIND, either express or implied. See the License for the specific language
     * governing permissions and limitations under the License.
     *
     * @author Brian Reavis <brian@thirdroute.com>
     */ var Sifter = /*#__PURE__*/ function() {
        function Sifter(items, settings) {
            (0, $ioD88._)(this, Sifter);
            this.items = items;
            this.settings = settings || {
                diacritics: true
            };
        }
        (0, $6NCFa._)(Sifter, [
            {
                /**
       * Splits a search string into an array of individual
       * regexps to be used to match results.
       *
       */ key: "tokenize",
                value: function tokenize(query, respect_word_boundaries, weights) {
                    var _this = this;
                    if (!query || !query.length) return [];
                    var tokens = [];
                    var words = query.split(/\s+/);
                    var field_regex;
                    if (weights) field_regex = new RegExp('^(' + Object.keys(weights).map(escape_regex).join('|') + ')\:(.*)$');
                    words.forEach(function(word) {
                        var field_match;
                        var field = null;
                        var regex = null;
                        // look for "field:query" tokens
                        if (field_regex && (field_match = word.match(field_regex))) {
                            field = field_match[1];
                            word = field_match[2];
                        }
                        if (word.length > 0) {
                            if (_this.settings.diacritics) regex = getPattern(word) || null;
                            else regex = escape_regex(word);
                            if (regex && respect_word_boundaries) regex = "\\b" + regex;
                        }
                        tokens.push({
                            string: word,
                            regex: regex ? new RegExp(regex, 'iu') : null,
                            field: field
                        });
                    });
                    return tokens;
                }
            },
            {
                /**
       * Returns a function to be used to score individual results.
       *
       * Good matches will have a higher score than poor matches.
       * If an item is not a match, 0 will be returned by the function.
       *
       * @returns {T.ScoreFn}
       */ key: "getScoreFunction",
                value: function getScoreFunction(query, options) {
                    var search = this.prepareSearch(query, options);
                    return this._getScoreFunction(search);
                }
            },
            {
                /**
       * @returns {T.ScoreFn}
       *
       */ key: "_getScoreFunction",
                value: function _getScoreFunction(search) {
                    var tokens = search.tokens, token_count = tokens.length;
                    if (!token_count) return function() {
                        return 0;
                    };
                    var fields = search.options.fields, weights = search.weights, field_count = fields.length, getAttrFn = search.getAttrFn;
                    if (!field_count) return function() {
                        return 1;
                    };
                    /**
         * Calculates the score of an object
         * against the search query.
         *
         */ var scoreObject = function() {
                        if (field_count === 1) return function(token, data) {
                            var field = fields[0].field;
                            return scoreValue(getAttrFn(data, field), token, weights[field] || 1);
                        };
                        return function(token, data) {
                            var sum = 0;
                            // is the token specific to a field?
                            if (token.field) {
                                var value = getAttrFn(data, token.field);
                                if (!token.regex && value) sum += 1 / field_count;
                                else sum += scoreValue(value, token, 1);
                            } else iterate(weights, function(weight, field) {
                                sum += scoreValue(getAttrFn(data, field), token, weight);
                            });
                            return sum / field_count;
                        };
                    }();
                    if (token_count === 1) return function(data) {
                        return scoreObject(tokens[0], data);
                    };
                    if (search.options.conjunction === 'and') return function(data) {
                        var score, sum = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var token = _step.value;
                                score = scoreObject(token, data);
                                if (score <= 0) return 0;
                                sum += score;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return sum / token_count;
                    };
                    else return function(data) {
                        var sum = 0;
                        iterate(tokens, function(token) {
                            sum += scoreObject(token, data);
                        });
                        return sum / token_count;
                    };
                }
            },
            {
                /**
       * Returns a function that can be used to compare two
       * results, for sorting purposes. If no sorting should
       * be performed, `null` will be returned.
       *
       * @return function(a,b)
       */ key: "getSortFunction",
                value: function getSortFunction(query, options) {
                    var search = this.prepareSearch(query, options);
                    return this._getSortFunction(search);
                }
            },
            {
                key: "_getSortFunction",
                value: function _getSortFunction(search) {
                    var implicit_score, sort_flds = [];
                    var self = this, options = search.options, sort = !search.query && options.sort_empty ? options.sort_empty : options.sort;
                    if (typeof sort == 'function') return sort.bind(this);
                    /**
         * Fetches the specified sort field value
         * from a search result item.
         *
         */ var get_field = function get_field(name, result) {
                        if (name === '$score') return result.score;
                        return search.getAttrFn(self.items[result.id], name);
                    };
                    // parse options
                    if (sort) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = sort[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var s = _step.value;
                                if (search.query || s.field !== '$score') sort_flds.push(s);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    // the "$score" field is implied to be the primary
                    // sort field, unless it's manually specified
                    if (search.query) {
                        implicit_score = true;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = sort_flds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var fld = _step1.value;
                                if (fld.field === '$score') {
                                    implicit_score = false;
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        if (implicit_score) sort_flds.unshift({
                            field: '$score',
                            direction: 'desc'
                        });
                    // without a search.query, all items will have the same score
                    } else sort_flds = sort_flds.filter(function(fld) {
                        return fld.field !== '$score';
                    });
                    // build function
                    var sort_flds_count = sort_flds.length;
                    if (!sort_flds_count) return null;
                    return function(a, b) {
                        var result, field;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = sort_flds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var sort_fld = _step.value;
                                field = sort_fld.field;
                                var multiplier = sort_fld.direction === 'desc' ? -1 : 1;
                                result = multiplier * cmp(get_field(field, a), get_field(field, b));
                                if (result) return result;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return 0;
                    };
                }
            },
            {
                /**
       * Parses a search query and returns an object
       * with tokens and fields ready to be populated
       * with results.
       *
       */ key: "prepareSearch",
                value: function prepareSearch(query, optsUser) {
                    var weights = {};
                    var options = Object.assign({}, optsUser);
                    propToArray(options, 'sort');
                    propToArray(options, 'sort_empty');
                    // convert fields to new format
                    if (options.fields) {
                        propToArray(options, 'fields');
                        var fields = [];
                        options.fields.forEach(function(field) {
                            if (typeof field == 'string') field = {
                                field: field,
                                weight: 1
                            };
                            fields.push(field);
                            weights[field.field] = 'weight' in field ? field.weight : 1;
                        });
                        options.fields = fields;
                    }
                    return {
                        options: options,
                        query: query.toLowerCase().trim(),
                        tokens: this.tokenize(query, options.respect_word_boundaries, weights),
                        total: 0,
                        items: [],
                        weights: weights,
                        getAttrFn: options.nesting ? getAttrNesting : getAttr
                    };
                }
            },
            {
                /**
       * Searches through all items and returns a sorted array of matches.
       *
       */ key: "search",
                value: function search(query, options) {
                    var self = this, score, search;
                    search = this.prepareSearch(query, options);
                    options = search.options;
                    query = search.query;
                    // generate result scoring function
                    var fn_score = options.score || self._getScoreFunction(search);
                    // perform search and sort
                    if (query.length) iterate(self.items, function(item, id) {
                        score = fn_score(item);
                        if (options.filter === false || score > 0) search.items.push({
                            'score': score,
                            'id': id
                        });
                    });
                    else iterate(self.items, function(_, id) {
                        search.items.push({
                            'score': 1,
                            'id': id
                        });
                    });
                    var fn_sort = self._getSortFunction(search);
                    if (fn_sort) search.items.sort(fn_sort);
                    // apply limits
                    search.total = search.items.length;
                    if (typeof options.limit === 'number') search.items = search.items.slice(0, options.limit);
                    return search;
                }
            }
        ]);
        return Sifter;
    }();
    exports1.Sifter = Sifter;
    exports1.cmp = cmp;
    exports1.getAttr = getAttr;
    exports1.getAttrNesting = getAttrNesting;
    exports1.getPattern = getPattern;
    exports1.iterate = iterate;
    exports1.propToArray = propToArray;
    exports1.scoreValue = scoreValue;
});


var $213bbe7bd4fc8f54$exports = {};

var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $esDIr = parcelRequire("esDIr");

var $ewv1T = parcelRequire("ewv1T");

/*! @orchidjs/unicode-variants | https://github.com/orchidjs/unicode-variants | Apache License (v2) */ (function(global, factory) {
    factory($213bbe7bd4fc8f54$exports);
})(undefined, function(exports1) {
    'use strict';
    /**
	 * Convert array of strings to a regular expression
	 *	ex ['ab','a'] => (?:ab|a)
	 * 	ex ['a','b'] => [ab]
	 */ var arrayToPattern = function(chars) {
        chars = chars.filter(Boolean);
        if (chars.length < 2) return chars[0] || '';
        return maxValueLength(chars) == 1 ? '[' + chars.join('') + ']' : '(?:' + chars.join('|') + ')';
    };
    var sequencePattern = function(array) {
        if (!hasDuplicates(array)) return array.join('');
        var pattern = '';
        var prev_char_count = 0;
        var prev_pattern = function() {
            if (prev_char_count > 1) pattern += '{' + prev_char_count + '}';
        };
        array.forEach(function(char, i) {
            if (char === array[i - 1]) {
                prev_char_count++;
                return;
            }
            prev_pattern();
            pattern += char;
            prev_char_count = 1;
        });
        prev_pattern();
        return pattern;
    };
    /**
	 * Convert array of strings to a regular expression
	 *	ex ['ab','a'] => (?:ab|a)
	 * 	ex ['a','b'] => [ab]
	 */ var setToPattern = function(chars) {
        var array = Array.from(chars);
        return arrayToPattern(array);
    };
    /**
	 * https://stackoverflow.com/questions/7376598/in-javascript-how-do-i-check-if-an-array-has-duplicate-values
	 */ var hasDuplicates = function(array) {
        return new Set(array).size !== array.length;
    };
    /**
	 * https://stackoverflow.com/questions/63006601/why-does-u-throw-an-invalid-escape-error
	 */ var escape_regex = function(str) {
        return (str + '').replace(RegExp("([\\$\\(\\)\\*\\+\\.\\?\\[\\]\\^\\{\\|\\}\\\\])", "gu"), '\\$1');
    };
    /**
	 * Return the max length of array values
	 */ var maxValueLength = function(array) {
        return array.reduce(function(longest, value) {
            return Math.max(longest, unicodeLength(value));
        }, 0);
    };
    var unicodeLength = function(str) {
        return Array.from(str).length;
    };
    /**
	 * Get all possible combinations of substrings that add up to the given string
	 * https://stackoverflow.com/questions/30169587/find-all-the-combination-of-substrings-that-add-up-to-the-given-string
	 */ var allSubstrings = function(input) {
        if (input.length === 1) return [
            [
                input
            ]
        ];
        var result = [];
        var start = input.substring(1);
        var suba = allSubstrings(start);
        suba.forEach(function(subresult) {
            var tmp = subresult.slice(0);
            tmp[0] = input.charAt(0) + tmp[0];
            result.push(tmp);
            tmp = subresult.slice(0);
            tmp.unshift(input.charAt(0));
            result.push(tmp);
        });
        return result;
    };
    var code_points = [
        [
            0,
            65535
        ]
    ];
    var accent_pat = "[\u0300-\u036F\xb7\u02BE\u02BC]";
    exports1.unicode_map = void 0;
    var multi_char_reg;
    var max_char_length = 3;
    var latin_convert = {};
    var latin_condensed = {
        '/': "\u2044\u2215",
        '0': "\u07C0",
        "a": "\u2C65\u0250\u0251",
        "aa": "\uA733",
        "ae": "\xe6\u01FD\u01E3",
        "ao": "\uA735",
        "au": "\uA737",
        "av": "\uA739\uA73B",
        "ay": "\uA73D",
        "b": "\u0180\u0253\u0183",
        "c": "\uA73F\u0188\u023C\u2184",
        "d": "\u0111\u0257\u0256\u1D05\u018C\uABB7\u0501\u0266",
        "e": "\u025B\u01DD\u1D07\u0247",
        "f": "\uA77C\u0192",
        "g": "\u01E5\u0260\uA7A1\u1D79\uA77F\u0262",
        "h": "\u0127\u2C68\u2C76\u0265",
        "i": "\u0268\u0131",
        "j": "\u0249\u0237",
        "k": "\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
        "l": "\u0142\u019A\u026B\u2C61\uA749\uA747\uA781\u026D",
        "m": "\u0271\u026F\u03FB",
        "n": "\uA7A5\u019E\u0272\uA791\u1D0E\u043B\u0509",
        "o": "\xf8\u01FF\u0254\u0275\uA74B\uA74D\u1D11",
        "oe": "\u0153",
        "oi": "\u01A3",
        "oo": "\uA74F",
        "ou": "\u0223",
        "p": "\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
        "q": "\uA757\uA759\u024B",
        "r": "\u024D\u027D\uA75B\uA7A7\uA783",
        "s": "\xdf\u023F\uA7A9\uA785\u0282",
        "t": "\u0167\u01AD\u0288\u2C66\uA787",
        "th": "\xfe",
        "tz": "\uA729",
        "u": "\u0289",
        "v": "\u028B\uA75F\u028C",
        "vy": "\uA761",
        "w": "\u2C73",
        "y": "\u01B4\u024F\u1EFF",
        "z": "\u01B6\u0225\u0240\u2C6C\uA763",
        "hv": "\u0195"
    };
    for(var latin in latin_condensed){
        var unicode = latin_condensed[latin] || '';
        for(var i = 0; i < unicode.length; i++){
            var char = unicode.substring(i, i + 1);
            latin_convert[char] = latin;
        }
    }
    var convert_pat = new RegExp(Object.keys(latin_convert).join('|') + '|' + accent_pat, 'gu');
    /**
	 * Initialize the unicode_map from the give code point ranges
	 */ var initialize = function(_code_points) {
        if (exports1.unicode_map !== undefined) return;
        exports1.unicode_map = generateMap(_code_points || code_points);
    };
    /**
	 * Helper method for normalize a string
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
	 */ var normalize = function(str) {
        var form = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'NFKD';
        return str.normalize(form);
    };
    /**
	 * Remove accents without reordering string
	 * calling str.normalize('NFKD') on \u{594}\u{595}\u{596} becomes \u{596}\u{594}\u{595}
	 * via https://github.com/krisk/Fuse/issues/133#issuecomment-318692703
	 */ var asciifold = function(str) {
        return Array.from(str).reduce(/**
	   * @param {string} result
	   * @param {string} char
	   */ function(result, char) {
            return result + _asciifold(char);
        }, '');
    };
    var _asciifold = function(str) {
        str = normalize(str).toLowerCase().replace(convert_pat, function(/** @type {string} */ char) {
            return latin_convert[char] || '';
        });
        //return str;
        return normalize(str, 'NFC');
    };
    /**
	 * Generate a list of unicode variants from the list of code points
	 */ function generator(code_points) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, code_point_min, code_point_max, i, composed, folded, err;
        return (0, $15f39fe0df078b1e$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]);
                    _iterator = code_points[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    _step_value = (0, $esDIr._)(_step.value, 2), code_point_min = _step_value[0], code_point_max = _step_value[1];
                    i = code_point_min;
                    _state.label = 3;
                case 3:
                    if (!(i <= code_point_max)) return [
                        3,
                        6
                    ];
                    composed = String.fromCharCode(i);
                    folded = asciifold(composed);
                    if (folded == composed.toLowerCase()) return [
                        3,
                        5
                    ];
                    // skip when folded is a string longer than 3 characters long
                    // bc the resulting regex patterns will be long
                    // eg:
                    // folded صلى الله عليه وسلم length 18 code point 65018
                    // folded جل جلاله length 8 code point 65019
                    if (folded.length > max_char_length) return [
                        3,
                        5
                    ];
                    if (folded.length == 0) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        {
                            folded: folded,
                            composed: composed,
                            code_point: i
                        }
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    }
    /**
	 * Generate a unicode map from the list of code points
	 */ var generateSets = function(code_points) {
        var unicode_sets = {};
        var addMatching = function(folded, to_add) {
            /** @type {Set<string>} */ var folded_set = unicode_sets[folded] || new Set();
            var patt = new RegExp('^' + setToPattern(folded_set) + '$', 'iu');
            if (to_add.match(patt)) return;
            folded_set.add(escape_regex(to_add));
            unicode_sets[folded] = folded_set;
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = generator(code_points)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                addMatching(value.folded, value.folded);
                addMatching(value.folded, value.composed);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return unicode_sets;
    };
    /**
	 * Generate a unicode map from the list of code points
	 * ae => (?:(?:ae|Æ|Ǽ|Ǣ)|(?:A|Ⓐ|Ａ...)(?:E|ɛ|Ⓔ...))
	 */ var generateMap = function(code_points) {
        var unicode_sets = generateSets(code_points);
        var unicode_map = {};
        var multi_char = [];
        for(var folded in unicode_sets){
            var set = unicode_sets[folded];
            if (set) unicode_map[folded] = setToPattern(set);
            if (folded.length > 1) multi_char.push(escape_regex(folded));
        }
        multi_char.sort(function(a, b) {
            return b.length - a.length;
        });
        var multi_char_patt = arrayToPattern(multi_char);
        multi_char_reg = new RegExp('^' + multi_char_patt, 'u');
        return unicode_map;
    };
    /**
	 * Map each element of an array from its folded value to all possible unicode matches
	 */ var mapSequence = function(strings) {
        var min_replacement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var chars_replaced = 0;
        strings = strings.map(function(str) {
            if (exports1.unicode_map[str]) chars_replaced += str.length;
            return exports1.unicode_map[str] || str;
        });
        if (chars_replaced >= min_replacement) return sequencePattern(strings);
        return '';
    };
    /**
	 * Convert a short string and split it into all possible patterns
	 * Keep a pattern only if min_replacement is met
	 *
	 * 'abc'
	 * 		=> [['abc'],['ab','c'],['a','bc'],['a','b','c']]
	 *		=> ['abc-pattern','ab-c-pattern'...]
	 */ var substringsToPattern = function(str) {
        var min_replacement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        min_replacement = Math.max(min_replacement, str.length - 1);
        return arrayToPattern(allSubstrings(str).map(function(sub_pat) {
            return mapSequence(sub_pat, min_replacement);
        }));
    };
    /**
	 * Convert an array of sequences into a pattern
	 * [{start:0,end:3,length:3,substr:'iii'}...] => (?:iii...)
	 */ var sequencesToPattern = function(sequences) {
        var all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var min_replacement = sequences.length > 1 ? 1 : 0;
        return arrayToPattern(sequences.map(function(sequence) {
            var seq = [];
            var len = all ? sequence.length() : sequence.length() - 1;
            for(var j = 0; j < len; j++)seq.push(substringsToPattern(sequence.substrs[j] || '', min_replacement));
            return sequencePattern(seq);
        }));
    };
    /**
	 * Return true if the sequence is already in the sequences
	 */ var inSequences = function(needle_seq, sequences) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var seq = _step.value;
                if (seq.start != needle_seq.start || seq.end != needle_seq.end) return "continue";
                if (seq.substrs.join('') !== needle_seq.substrs.join('')) return "continue";
                var needle_parts = needle_seq.parts;
                var filter = function(part) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = needle_parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var needle_part = _step.value;
                            if (needle_part.start === part.start && needle_part.substr === part.substr) return false;
                            if (part.length == 1 || needle_part.length == 1) continue;
                            // check for overlapping parts
                            // a = ['::=','==']
                            // b = ['::','===']
                            // a = ['r','sm']
                            // b = ['rs','m']
                            if (part.start < needle_part.start && part.end > needle_part.start) return true;
                            if (needle_part.start < part.start && needle_part.end > part.start) return true;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return false;
                };
                var filtered = seq.parts.filter(filter);
                if (filtered.length > 0) return "continue";
                return {
                    v: true
                };
            };
            for(var _iterator = sequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _ret = _loop();
                if ((0, $ewv1T._)(_ret) === "object") return _ret.v;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    var Sequence = /*#__PURE__*/ function() {
        function Sequence() {
            (0, $ioD88._)(this, Sequence);
            this.parts = [];
            this.substrs = [];
            this.start = 0;
            this.end = 0;
        }
        (0, $6NCFa._)(Sequence, [
            {
                key: "add",
                value: function add(part) {
                    if (part) {
                        this.parts.push(part);
                        this.substrs.push(part.substr);
                        this.start = Math.min(part.start, this.start);
                        this.end = Math.max(part.end, this.end);
                    }
                }
            },
            {
                key: "last",
                value: function last() {
                    return this.parts[this.parts.length - 1];
                }
            },
            {
                key: "length",
                value: function length() {
                    return this.parts.length;
                }
            },
            {
                key: "clone",
                value: function clone(position, last_piece) {
                    var clone = new Sequence();
                    var parts = JSON.parse(JSON.stringify(this.parts));
                    var last_part = parts.pop();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var part = _step.value;
                            clone.add(part);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var last_substr = last_piece.substr.substring(0, position - last_part.start);
                    var clone_last_len = last_substr.length;
                    clone.add({
                        start: last_part.start,
                        end: last_part.start + clone_last_len,
                        length: clone_last_len,
                        substr: last_substr
                    });
                    return clone;
                }
            }
        ]);
        return Sequence;
    }();
    /**
	 * Expand a regular expression pattern to include unicode variants
	 * 	eg /a/ becomes /aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑAⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ/
	 *
	 * Issue:
	 *  ﺊﺋ [ 'ﺊ = \\u{fe8a}', 'ﺋ = \\u{fe8b}' ]
	 *	becomes:	ئئ [ 'ي = \\u{64a}', 'ٔ = \\u{654}', 'ي = \\u{64a}', 'ٔ = \\u{654}' ]
	 *
	 *	İĲ = IIJ = ⅡJ
	 *
	 * 	1/2/4
	 */ var getPattern = function(str) {
        initialize();
        str = asciifold(str);
        var pattern = '';
        var sequences = [
            new Sequence()
        ];
        for(var i = 0; i < str.length; i++){
            var substr = str.substring(i);
            var match = substr.match(multi_char_reg);
            var char = str.substring(i, i + 1);
            var match_str = match ? match[0] : null;
            // loop through sequences
            // add either the char or multi_match
            var overlapping = [];
            var added_types = new Set();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sequences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sequence = _step.value;
                    var last_piece = sequence.last();
                    if (!last_piece || last_piece.length == 1 || last_piece.end <= i) {
                        // if we have a multi match
                        if (match_str) {
                            var len = match_str.length;
                            sequence.add({
                                start: i,
                                end: i + len,
                                length: len,
                                substr: match_str
                            });
                            added_types.add('1');
                        } else {
                            sequence.add({
                                start: i,
                                end: i + 1,
                                length: 1,
                                substr: char
                            });
                            added_types.add('2');
                        }
                    } else if (match_str) {
                        var clone = sequence.clone(i, last_piece);
                        var len1 = match_str.length;
                        clone.add({
                            start: i,
                            end: i + len1,
                            length: len1,
                            substr: match_str
                        });
                        overlapping.push(clone);
                    } else // don't add char
                    // adding would create invalid patterns: 234 => [2,34,4]
                    added_types.add('3');
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // if we have overlapping
            if (overlapping.length > 0) {
                // ['ii','iii'] before ['i','i','iii']
                overlapping = overlapping.sort(function(a, b) {
                    return a.length() - b.length();
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = overlapping[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var clone1 = _step1.value;
                        // don't add if we already have an equivalent sequence
                        if (inSequences(clone1, sequences)) continue;
                        sequences.push(clone1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                continue;
            }
            // if we haven't done anything unique
            // clean up the patterns
            // helps keep patterns smaller
            // if str = 'r₨㎧aarss', pattern will be 446 instead of 655
            if (i > 0 && added_types.size == 1 && !added_types.has('3')) {
                pattern += sequencesToPattern(sequences, false);
                var new_seq = new Sequence();
                var old_seq = sequences[0];
                if (old_seq) new_seq.add(old_seq.last());
                sequences = [
                    new_seq
                ];
            }
        }
        pattern += sequencesToPattern(sequences, true);
        return pattern;
    };
    exports1._asciifold = _asciifold;
    exports1.asciifold = asciifold;
    exports1.code_points = code_points;
    exports1.escape_regex = escape_regex;
    exports1.generateMap = generateMap;
    exports1.generateSets = generateSets;
    exports1.generator = generator;
    exports1.getPattern = getPattern;
    exports1.initialize = initialize;
    exports1.mapSequence = mapSequence;
    exports1.normalize = normalize;
    exports1.substringsToPattern = substringsToPattern;
});


/**
 * highlight v3 | MIT license | Johann Burkard <jb@eaio.com>
 * Highlights arbitrary terms in a node.
 *
 * - Modified by Marshal <beatgates@gmail.com> 2011-6-24 (added regex)
 * - Modified by Brian Reavis <brian@thirdroute.com> 2012-8-27 (cleanup)
 */ /**
 * Converts a scalar to its best string representation
 * for hash keys and HTML attribute values.
 *
 * Transformations:
 *   'str'     -> 'str'
 *   null      -> ''
 *   undefined -> ''
 *   true      -> '1'
 *   false     -> '0'
 *   0         -> '0'
 *   1         -> '1'
 *
 */ var $45a9315df96c7449$export$4e00787be681ebe0 = function(value) {
    if (typeof value === 'undefined' || value === null) return null;
    return $45a9315df96c7449$export$e59fe9173a7a0aac(value);
};
var $45a9315df96c7449$export$e59fe9173a7a0aac = function(value) {
    if (typeof value === 'boolean') return value ? '1' : '0';
    return value + '';
};
var $45a9315df96c7449$export$1e6f422d3087f91c = function(str) {
    return (str + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};
var $45a9315df96c7449$export$83e74882c5df8fe1 = function(fn, timeout) {
    if (timeout > 0) return window.setTimeout(fn, timeout);
    fn.call(null);
    return null;
};
var $45a9315df96c7449$export$84b68745395ddf0b = function(fn, delay) {
    var timeout;
    return function loadDebounce(value, callback) {
        var self = this;
        if (timeout) {
            self.loading = Math.max(self.loading - 1, 0);
            clearTimeout(timeout);
        }
        timeout = setTimeout(function() {
            timeout = null;
            self.loadedSearches[value] = true;
            fn.call(self, value, callback);
        }, delay);
    };
};
var $45a9315df96c7449$export$2c9747a4208fe65f = function(self, types, fn) {
    var type;
    var trigger = self.trigger;
    var event_args = {};
    // override trigger method
    self.trigger = function debounce_events() {
        var type = arguments[0];
        if (types.indexOf(type) !== -1) event_args[type] = arguments;
        else return trigger.apply(self, arguments);
    };
    // invoke provided function
    fn.apply(self, []);
    self.trigger = trigger;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // trigger queued events
        for(var _iterator = types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            type = _step.value;
            if (type in event_args) trigger.apply(self, event_args[type]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var $45a9315df96c7449$export$ca798a7e6e94638c = function(input) {
    return {
        start: input.selectionStart || 0,
        length: (input.selectionEnd || 0) - (input.selectionStart || 0)
    };
};
var $45a9315df96c7449$export$fa3b29edae795ef4 = function(evt) {
    var stop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (evt) {
        evt.preventDefault();
        if (stop) evt.stopPropagation();
    }
};
var $45a9315df96c7449$export$f531f92e2a15358f = function(target, type, callback, options) {
    target.addEventListener(type, callback, options);
};
var $45a9315df96c7449$export$e7bf60a870f429b0 = function(key_name, evt) {
    if (!evt) return false;
    if (!evt[key_name]) return false;
    var count = (evt.altKey ? 1 : 0) + (evt.ctrlKey ? 1 : 0) + (evt.shiftKey ? 1 : 0) + (evt.metaKey ? 1 : 0);
    if (count === 1) return true;
    return false;
};
var $45a9315df96c7449$export$218c8c3169c024d2 = function(el, id) {
    var existing_id = el.getAttribute('id');
    if (existing_id) return existing_id;
    el.setAttribute('id', id);
    return id;
};
var $45a9315df96c7449$export$c34459d1aef61885 = function(str) {
    return str.replace(/[\\"']/g, '\\$&');
};
var $45a9315df96c7449$export$10d8903dec122b9d = function(parent, node) {
    if (node) parent.append(node);
};
var $45a9315df96c7449$export$c1a059043cc9c119 = function(object, callback) {
    if (Array.isArray(object)) object.forEach(callback);
    else {
        for(var key in object)if (object.hasOwnProperty(key)) callback(object[key], key);
    }
};


var $212e4671cfd200e3$export$6c34eab6e99e0f60 = function(query) {
    if (query.jquery) return query[0];
    if (query instanceof HTMLElement) return query;
    if ($212e4671cfd200e3$export$c59330865007bdef(query)) {
        var tpl = document.createElement('template');
        tpl.innerHTML = query.trim(); // Never return a text node of whitespace as the result
        return tpl.content.firstChild;
    }
    return document.querySelector(query);
};
var $212e4671cfd200e3$export$c59330865007bdef = function(arg) {
    if (typeof arg === 'string' && arg.indexOf('<') > -1) return true;
    return false;
};
var $212e4671cfd200e3$export$8ec014f0032c0767 = function(query) {
    return query.replace(/['"\\]/g, '\\$&');
};
var $212e4671cfd200e3$export$bf5e5f0a0e9ca89d = function(dom_el, event_name) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(event_name, true, false);
    dom_el.dispatchEvent(event);
};
var $212e4671cfd200e3$export$3a26aa64e59aeaff = function(dom_el, css) {
    Object.assign(dom_el.style, css);
};
var $212e4671cfd200e3$export$34a1a93008ee28b5 = function(elmts) {
    for(var _len = arguments.length, classes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        classes[_key - 1] = arguments[_key];
    }
    var norm_classes = $212e4671cfd200e3$export$ebf018fc05eb8290(classes);
    elmts = $212e4671cfd200e3$export$ca73cb1e19b0cfb8(elmts);
    elmts.map(function(el) {
        norm_classes.map(function(cls) {
            el.classList.add(cls);
        });
    });
};
var $212e4671cfd200e3$export$33233bd73e8de239 = function(elmts) {
    for(var _len = arguments.length, classes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        classes[_key - 1] = arguments[_key];
    }
    var norm_classes = $212e4671cfd200e3$export$ebf018fc05eb8290(classes);
    elmts = $212e4671cfd200e3$export$ca73cb1e19b0cfb8(elmts);
    elmts.map(function(el) {
        norm_classes.map(function(cls) {
            el.classList.remove(cls);
        });
    });
};
var $212e4671cfd200e3$export$ebf018fc05eb8290 = function(args) {
    var classes = [];
    (0, $45a9315df96c7449$export$c1a059043cc9c119)(args, function(_classes) {
        if (typeof _classes === 'string') _classes = _classes.trim().split(/[\t\n\f\r\s]/);
        if (Array.isArray(_classes)) classes = classes.concat(_classes);
    });
    return classes.filter(Boolean);
};
var $212e4671cfd200e3$export$ca73cb1e19b0cfb8 = function(arg) {
    if (!Array.isArray(arg)) arg = [
        arg
    ];
    return arg;
};
var $212e4671cfd200e3$export$f5dd2e7a81a974e9 = function(target, selector, wrapper) {
    if (wrapper && !wrapper.contains(target)) return;
    while(target && target.matches){
        if (target.matches(selector)) return target;
        target = target.parentNode;
    }
};
var $212e4671cfd200e3$export$22db25736bd2dc5f = function(list) {
    var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (direction > 0) return list[list.length - 1];
    return list[0];
};
var $212e4671cfd200e3$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
var $212e4671cfd200e3$export$e5c4cfab14d02c5d = function(el, amongst) {
    if (!el) return -1;
    amongst = amongst || el.nodeName;
    var i = 0;
    while(el = el.previousElementSibling)if (el.matches(amongst)) i++;
    return i;
};
var $212e4671cfd200e3$export$c609e428011345f3 = function(el, attrs) {
    (0, $45a9315df96c7449$export$c1a059043cc9c119)(attrs, function(val, attr) {
        if (val == null) el.removeAttribute(attr);
        else el.setAttribute(attr, '' + val);
    });
};
var $212e4671cfd200e3$export$5542201de9311ab2 = function(existing, replacement) {
    if (existing.parentNode) existing.parentNode.replaceChild(replacement, existing);
};


var $a62ab4d987017c24$export$e4043f67d36cbb26 = function(element, regex) {
    if (regex === null) return;
    // convet string to regex
    if (typeof regex === 'string') {
        if (!regex.length) return;
        regex = new RegExp(regex, 'i');
    }
    // Wrap matching part of text node with highlighting <span>, e.g.
    // Soccer  ->  <span class="highlight">Soc</span>cer  for regex = /soc/i
    var highlightText = function(node) {
        var match = node.data.match(regex);
        if (match && node.data.length > 0) {
            var spannode = document.createElement('span');
            spannode.className = 'highlight';
            var middlebit = node.splitText(match.index);
            middlebit.splitText(match[0].length);
            var middleclone = middlebit.cloneNode(true);
            spannode.appendChild(middleclone);
            (0, $212e4671cfd200e3$export$5542201de9311ab2)(middlebit, spannode);
            return 1;
        }
        return 0;
    };
    // Recurse element node, looking for child text nodes to highlight, unless element
    // is childless, <script>, <style>, or already highlighted: <span class="hightlight">
    var highlightChildren = function(node) {
        if (node.nodeType === 1 && node.childNodes && !/(script|style)/i.test(node.tagName) && (node.className !== 'highlight' || node.tagName !== 'SPAN')) Array.from(node.childNodes).forEach(function(element) {
            highlightRecursive(element);
        });
    };
    var highlightRecursive = function(node) {
        if (node.nodeType === 3) return highlightText(node);
        highlightChildren(node);
        return 0;
    };
    highlightRecursive(element);
};
var $a62ab4d987017c24$export$7854b6fa03b6c2ef = function(el) {
    var elements = el.querySelectorAll("span.highlight");
    Array.prototype.forEach.call(elements, function(el) {
        var parent = el.parentNode;
        parent.replaceChild(el.firstChild, el);
        parent.normalize();
    });
};


var $ce22d7b9dbf789f4$export$a62be707b936c199 = 65;
var $ce22d7b9dbf789f4$export$a38a780d07123ee = 13;
var $ce22d7b9dbf789f4$export$f0fcadf25a56f096 = 27;
var $ce22d7b9dbf789f4$export$fc4577f2a2af0ae3 = 37;
var $ce22d7b9dbf789f4$export$390330c10ff2b9a1 = 38;
var $ce22d7b9dbf789f4$export$c40f9845adc73fb5 = 39;
var $ce22d7b9dbf789f4$export$a80636c6f41931fe = 40;
var $ce22d7b9dbf789f4$export$7cd8f621642ff61e = 8;
var $ce22d7b9dbf789f4$export$1fd7871db6041a84 = 46;
var $ce22d7b9dbf789f4$export$10f6869ed0a7d75b = 9;
var $ce22d7b9dbf789f4$export$ff23e6b4c4401383 = typeof navigator === 'undefined' ? false : /Mac/.test(navigator.userAgent);
var $ce22d7b9dbf789f4$export$7f209867a1e996c7 = $ce22d7b9dbf789f4$export$ff23e6b4c4401383 ? 'metaKey' : 'ctrlKey'; // ctrl key or apple key for ma


var $ead480af15bfff85$export$2e2bcd8739ae039 = {
    options: [],
    optgroups: [],
    plugins: [],
    delimiter: ',',
    splitOn: null,
    persist: true,
    diacritics: true,
    create: null,
    createOnBlur: false,
    createFilter: null,
    highlight: true,
    openOnFocus: true,
    shouldOpen: null,
    maxOptions: 50,
    maxItems: null,
    hideSelected: null,
    duplicates: false,
    addPrecedence: false,
    selectOnTab: false,
    preload: null,
    allowEmptyOption: false,
    //closeAfterSelect: false,
    refreshThrottle: 300,
    loadThrottle: 300,
    loadingClass: 'loading',
    dataAttr: null,
    optgroupField: 'optgroup',
    valueField: 'value',
    labelField: 'text',
    disabledField: 'disabled',
    optgroupLabelField: 'label',
    optgroupValueField: 'value',
    lockOptgroupOrder: false,
    sortField: '$order',
    searchField: [
        'text'
    ],
    searchConjunction: 'and',
    mode: null,
    wrapperClass: 'ts-wrapper',
    controlClass: 'ts-control',
    dropdownClass: 'ts-dropdown',
    dropdownContentClass: 'ts-dropdown-content',
    itemClass: 'item',
    optionClass: 'option',
    dropdownParent: null,
    controlInput: '<input type="text" autocomplete="off" size="1" />',
    copyClassesToDropdown: false,
    placeholder: null,
    hidePlaceholder: null,
    shouldLoad: function shouldLoad(query) {
        return query.length > 0;
    },
    /*
    load                 : null, // function(query, callback) { ... }
    score                : null, // function(search) { ... }
    onInitialize         : null, // function() { ... }
    onChange             : null, // function(value) { ... }
    onItemAdd            : null, // function(value, $item) { ... }
    onItemRemove         : null, // function(value) { ... }
    onClear              : null, // function() { ... }
    onOptionAdd          : null, // function(value, data) { ... }
    onOptionRemove       : null, // function(value) { ... }
    onOptionClear        : null, // function() { ... }
    onOptionGroupAdd     : null, // function(id, data) { ... }
    onOptionGroupRemove  : null, // function(id) { ... }
    onOptionGroupClear   : null, // function() { ... }
    onDropdownOpen       : null, // function(dropdown) { ... }
    onDropdownClose      : null, // function(dropdown) { ... }
    onType               : null, // function(str) { ... }
    onDelete             : null, // function(values) { ... }
    */ render: {
    }
};



function $016f8c1d914a717a$export$2e2bcd8739ae039(input, settings_user) {
    var settings = Object.assign({}, (0, $ead480af15bfff85$export$2e2bcd8739ae039), settings_user);
    var attr_data = settings.dataAttr;
    var field_label = settings.labelField;
    var field_value = settings.valueField;
    var field_disabled = settings.disabledField;
    var field_optgroup = settings.optgroupField;
    var field_optgroup_label = settings.optgroupLabelField;
    var field_optgroup_value = settings.optgroupValueField;
    var tag_name = input.tagName.toLowerCase();
    var placeholder = input.getAttribute('placeholder') || input.getAttribute('data-placeholder');
    if (!placeholder && !settings.allowEmptyOption) {
        var option = input.querySelector('option[value=""]');
        if (option) placeholder = option.textContent;
    }
    var settings_element = {
        placeholder: placeholder,
        options: [],
        optgroups: [],
        items: [],
        maxItems: null
    };
    /**
     * Initialize from a <select> element.
     *
     */ var init_select = function() {
        var tagName;
        var options = settings_element.options;
        var optionsMap = {};
        var group_count = 1;
        var $order = 0;
        var readData = function(el) {
            var data = Object.assign({}, el.dataset); // get plain object from DOMStringMap
            var json = attr_data && data[attr_data];
            if (typeof json === 'string' && json.length) data = Object.assign(data, JSON.parse(json));
            return data;
        };
        var addOption = function(option, group) {
            var value = (0, $45a9315df96c7449$export$4e00787be681ebe0)(option.value);
            if (value == null) return;
            if (!value && !settings.allowEmptyOption) return;
            // if the option already exists, it's probably been
            // duplicated in another optgroup. in this case, push
            // the current group to the "optgroup" property on the
            // existing option so that it's rendered in both places.
            if (optionsMap.hasOwnProperty(value)) {
                if (group) {
                    var arr = optionsMap[value][field_optgroup];
                    if (!arr) optionsMap[value][field_optgroup] = group;
                    else if (!Array.isArray(arr)) optionsMap[value][field_optgroup] = [
                        arr,
                        group
                    ];
                    else arr.push(group);
                }
            } else {
                var option_data = readData(option);
                option_data[field_label] = option_data[field_label] || option.textContent;
                option_data[field_value] = option_data[field_value] || value;
                option_data[field_disabled] = option_data[field_disabled] || option.disabled;
                option_data[field_optgroup] = option_data[field_optgroup] || group;
                option_data.$option = option;
                option_data.$order = option_data.$order || ++$order;
                optionsMap[value] = option_data;
                options.push(option_data);
            }
            if (option.selected) settings_element.items.push(value);
        };
        var addGroup = function(optgroup) {
            var id, optgroup_data;
            optgroup_data = readData(optgroup);
            optgroup_data[field_optgroup_label] = optgroup_data[field_optgroup_label] || optgroup.getAttribute('label') || '';
            optgroup_data[field_optgroup_value] = optgroup_data[field_optgroup_value] || group_count++;
            optgroup_data[field_disabled] = optgroup_data[field_disabled] || optgroup.disabled;
            optgroup_data.$order = optgroup_data.$order || ++$order;
            settings_element.optgroups.push(optgroup_data);
            id = optgroup_data[field_optgroup_value];
            (0, $45a9315df96c7449$export$c1a059043cc9c119)(optgroup.children, function(option) {
                addOption(option, id);
            });
        };
        settings_element.maxItems = input.hasAttribute('multiple') ? null : 1;
        (0, $45a9315df96c7449$export$c1a059043cc9c119)(input.children, function(child) {
            tagName = child.tagName.toLowerCase();
            if (tagName === 'optgroup') addGroup(child);
            else if (tagName === 'option') addOption(child);
        });
    };
    /**
     * Initialize from a <input type="text"> element.
     *
     */ var init_textbox = function() {
        var data_raw = input.getAttribute(attr_data);
        if (!data_raw) {
            var value = input.value.trim() || '';
            if (!settings.allowEmptyOption && !value.length) return;
            var values = value.split(settings.delimiter);
            (0, $45a9315df96c7449$export$c1a059043cc9c119)(values, function(value) {
                var option = {};
                option[field_label] = value;
                option[field_value] = value;
                settings_element.options.push(option);
            });
            settings_element.items = values;
        } else {
            settings_element.options = JSON.parse(data_raw);
            (0, $45a9315df96c7449$export$c1a059043cc9c119)(settings_element.options, function(opt) {
                settings_element.items.push(opt[field_value]);
            });
        }
    };
    if (tag_name === 'select') init_select();
    else init_textbox();
    return Object.assign({}, (0, $ead480af15bfff85$export$2e2bcd8739ae039), settings_element, settings_user);
}




var $a5c702205a36cd19$var$instance_i = 0;
var $a5c702205a36cd19$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_MicroPlugin) {
    "use strict";
    (0, $dqNF0._)(TomSelect, _MicroPlugin);
    function TomSelect(input_arg, user_settings) {
        (0, $ioD88._)(this, TomSelect);
        var _this;
        _this = (0, $ctUVE._)(this, TomSelect);
        _this.order = 0;
        _this.isOpen = false;
        _this.isDisabled = false;
        _this.isReadOnly = false;
        _this.isInvalid = false; // @deprecated 1.8
        _this.isValid = true;
        _this.isLocked = false;
        _this.isFocused = false;
        _this.isInputHidden = false;
        _this.isSetup = false;
        _this.ignoreFocus = false;
        _this.ignoreHover = false;
        _this.hasOptions = false;
        _this.lastValue = '';
        _this.caretPos = 0;
        _this.loading = 0;
        _this.loadedSearches = {};
        _this.activeOption = null;
        _this.activeItems = [];
        _this.optgroups = {};
        _this.options = {};
        _this.userOptions = {};
        _this.items = [];
        _this.refreshTimeout = null;
        $a5c702205a36cd19$var$instance_i++;
        var dir;
        var input = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)(input_arg);
        if (input.tomselect) throw new Error('Tom Select already initialized on this element');
        input.tomselect = _this;
        // detect rtl environment
        var computedStyle = window.getComputedStyle && window.getComputedStyle(input, null);
        dir = computedStyle.getPropertyValue('direction');
        // setup default state
        var settings = (0, $016f8c1d914a717a$export$2e2bcd8739ae039)(input, user_settings);
        _this.settings = settings;
        _this.input = input;
        _this.tabIndex = input.tabIndex || 0;
        _this.is_select_tag = input.tagName.toLowerCase() === 'select';
        _this.rtl = /rtl/i.test(dir);
        _this.inputId = (0, $45a9315df96c7449$export$218c8c3169c024d2)(input, 'tomselect-' + $a5c702205a36cd19$var$instance_i);
        _this.isRequired = input.required;
        // search system
        _this.sifter = new (0, $bf7c2f5b0c0ee360$exports.Sifter)(_this.options, {
            diacritics: settings.diacritics
        });
        // option-dependent defaults
        settings.mode = settings.mode || (settings.maxItems === 1 ? 'single' : 'multi');
        if (typeof settings.hideSelected !== 'boolean') settings.hideSelected = settings.mode === 'multi';
        if (typeof settings.hidePlaceholder !== 'boolean') settings.hidePlaceholder = settings.mode !== 'multi';
        // set up createFilter callback
        var filter = settings.createFilter;
        if (typeof filter !== 'function') {
            if (typeof filter === 'string') filter = new RegExp(filter);
            if (filter instanceof RegExp) settings.createFilter = function(input) {
                return filter.test(input);
            };
            else settings.createFilter = function(value) {
                return _this.settings.duplicates || !_this.options[value];
            };
        }
        _this.initializePlugins(settings.plugins);
        _this.setupCallbacks();
        _this.setupTemplates();
        // Create all elements
        var wrapper = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)('<div>');
        var control = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)('<div>');
        var dropdown = _this._render('dropdown');
        var dropdown_content = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)('<div role="listbox" tabindex="-1">');
        var classes = _this.input.getAttribute('class') || '';
        var inputMode = settings.mode;
        var control_input;
        (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(wrapper, settings.wrapperClass, classes, inputMode);
        (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(control, settings.controlClass);
        (0, $45a9315df96c7449$export$10d8903dec122b9d)(wrapper, control);
        (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(dropdown, settings.dropdownClass, inputMode);
        if (settings.copyClassesToDropdown) (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(dropdown, classes);
        (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(dropdown_content, settings.dropdownContentClass);
        (0, $45a9315df96c7449$export$10d8903dec122b9d)(dropdown, dropdown_content);
        (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)(settings.dropdownParent || wrapper).appendChild(dropdown);
        // default controlInput
        if ((0, $212e4671cfd200e3$export$c59330865007bdef)(settings.controlInput)) {
            control_input = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)(settings.controlInput);
            // set attributes
            var attrs = [
                'autocorrect',
                'autocapitalize',
                'autocomplete',
                'spellcheck'
            ];
            (0, $45a9315df96c7449$export$c1a059043cc9c119)(attrs, function(attr) {
                if (input.getAttribute(attr)) (0, $212e4671cfd200e3$export$c609e428011345f3)(control_input, (0, $6lD0P._)({}, attr, input.getAttribute(attr)));
            });
            control_input.tabIndex = -1;
            control.appendChild(control_input);
            _this.focus_node = control_input;
        // dom element
        } else if (settings.controlInput) {
            control_input = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)(settings.controlInput);
            _this.focus_node = control_input;
        } else {
            control_input = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)('<input/>');
            _this.focus_node = control;
        }
        _this.wrapper = wrapper;
        _this.dropdown = dropdown;
        _this.dropdown_content = dropdown_content;
        _this.control = control;
        _this.control_input = control_input;
        _this.setup();
        return _this;
    }
    (0, $6NCFa._)(TomSelect, [
        {
            /**
     * set up event bindings.
     *
     */ key: "setup",
            value: function setup() {
                var self = this;
                var settings = self.settings;
                var control_input = self.control_input;
                var dropdown = self.dropdown;
                var dropdown_content = self.dropdown_content;
                var wrapper = self.wrapper;
                var control = self.control;
                var input = self.input;
                var focus_node = self.focus_node;
                var passive_event = {
                    passive: true
                };
                var listboxId = self.inputId + '-ts-dropdown';
                (0, $212e4671cfd200e3$export$c609e428011345f3)(dropdown_content, {
                    id: listboxId
                });
                (0, $212e4671cfd200e3$export$c609e428011345f3)(focus_node, {
                    role: 'combobox',
                    'aria-haspopup': 'listbox',
                    'aria-expanded': 'false',
                    'aria-controls': listboxId
                });
                var control_id = (0, $45a9315df96c7449$export$218c8c3169c024d2)(focus_node, self.inputId + '-ts-control');
                var query = "label[for='" + (0, $212e4671cfd200e3$export$8ec014f0032c0767)(self.inputId) + "']";
                var label = document.querySelector(query);
                var label_click = self.focus.bind(self);
                if (label) {
                    (0, $45a9315df96c7449$export$f531f92e2a15358f)(label, 'click', label_click);
                    (0, $212e4671cfd200e3$export$c609e428011345f3)(label, {
                        for: control_id
                    });
                    var label_id = (0, $45a9315df96c7449$export$218c8c3169c024d2)(label, self.inputId + '-ts-label');
                    (0, $212e4671cfd200e3$export$c609e428011345f3)(focus_node, {
                        'aria-labelledby': label_id
                    });
                    (0, $212e4671cfd200e3$export$c609e428011345f3)(dropdown_content, {
                        'aria-labelledby': label_id
                    });
                }
                wrapper.style.width = input.style.width;
                if (self.plugins.names.length) {
                    var classes_plugins = 'plugin-' + self.plugins.names.join(' plugin-');
                    (0, $212e4671cfd200e3$export$34a1a93008ee28b5)([
                        wrapper,
                        dropdown
                    ], classes_plugins);
                }
                if ((settings.maxItems === null || settings.maxItems > 1) && self.is_select_tag) (0, $212e4671cfd200e3$export$c609e428011345f3)(input, {
                    multiple: 'multiple'
                });
                if (settings.placeholder) (0, $212e4671cfd200e3$export$c609e428011345f3)(control_input, {
                    placeholder: settings.placeholder
                });
                // if splitOn was not passed in, construct it from the delimiter to allow pasting universally
                if (!settings.splitOn && settings.delimiter) settings.splitOn = new RegExp('\\s*' + (0, $213bbe7bd4fc8f54$exports.escape_regex)(settings.delimiter) + '+\\s*');
                // debounce user defined load() if loadThrottle > 0
                // after initializePlugins() so plugins can create/modify user defined loaders
                if (settings.load && settings.loadThrottle) settings.load = (0, $45a9315df96c7449$export$84b68745395ddf0b)(settings.load, settings.loadThrottle);
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(dropdown, 'mousemove', function() {
                    self.ignoreHover = false;
                });
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(dropdown, 'mouseenter', function(e) {
                    var target_match = (0, $212e4671cfd200e3$export$f5dd2e7a81a974e9)(e.target, '[data-selectable]', dropdown);
                    if (target_match) self.onOptionHover(e, target_match);
                }, {
                    capture: true
                });
                // clicking on an option should select it
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(dropdown, 'click', function(evt) {
                    var option = (0, $212e4671cfd200e3$export$f5dd2e7a81a974e9)(evt.target, '[data-selectable]');
                    if (option) {
                        self.onOptionSelect(evt, option);
                        (0, $45a9315df96c7449$export$fa3b29edae795ef4)(evt, true);
                    }
                });
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(control, 'click', function(evt) {
                    var target_match = (0, $212e4671cfd200e3$export$f5dd2e7a81a974e9)(evt.target, '[data-ts-item]', control);
                    if (target_match && self.onItemSelect(evt, target_match)) {
                        (0, $45a9315df96c7449$export$fa3b29edae795ef4)(evt, true);
                        return;
                    }
                    // retain focus (see control_input mousedown)
                    if (control_input.value != '') return;
                    self.onClick();
                    (0, $45a9315df96c7449$export$fa3b29edae795ef4)(evt, true);
                });
                // keydown on focus_node for arrow_down/arrow_up
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(focus_node, 'keydown', function(e) {
                    return self.onKeyDown(e);
                });
                // keypress and input/keyup
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(control_input, 'keypress', function(e) {
                    return self.onKeyPress(e);
                });
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(control_input, 'input', function(e) {
                    return self.onInput(e);
                });
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(focus_node, 'blur', function(e) {
                    return self.onBlur(e);
                });
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(focus_node, 'focus', function(e) {
                    return self.onFocus(e);
                });
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(control_input, 'paste', function(e) {
                    return self.onPaste(e);
                });
                var doc_mousedown = function(evt) {
                    // blur if target is outside of this instance
                    // dropdown is not always inside wrapper
                    var target = evt.composedPath()[0];
                    if (!wrapper.contains(target) && !dropdown.contains(target)) {
                        if (self.isFocused) self.blur();
                        self.inputState();
                        return;
                    }
                    // retain focus by preventing native handling. if the
                    // event target is the input it should not be modified.
                    // otherwise, text selection within the input won't work.
                    // Fixes bug #212 which is no covered by tests
                    if (target == control_input && self.isOpen) evt.stopPropagation();
                    else (0, $45a9315df96c7449$export$fa3b29edae795ef4)(evt, true);
                };
                var win_scroll = function() {
                    if (self.isOpen) self.positionDropdown();
                };
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(document, 'mousedown', doc_mousedown);
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(window, 'scroll', win_scroll, passive_event);
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(window, 'resize', win_scroll, passive_event);
                this._destroy = function() {
                    document.removeEventListener('mousedown', doc_mousedown);
                    window.removeEventListener('scroll', win_scroll);
                    window.removeEventListener('resize', win_scroll);
                    if (label) label.removeEventListener('click', label_click);
                };
                // store original html and tab index so that they can be
                // restored when the destroy() method is called.
                this.revertSettings = {
                    innerHTML: input.innerHTML,
                    tabIndex: input.tabIndex
                };
                input.tabIndex = -1;
                input.insertAdjacentElement('afterend', self.wrapper);
                self.sync(false);
                settings.items = [];
                delete settings.optgroups;
                delete settings.options;
                (0, $45a9315df96c7449$export$f531f92e2a15358f)(input, 'invalid', function() {
                    if (self.isValid) {
                        self.isValid = false;
                        self.isInvalid = true;
                        self.refreshState();
                    }
                });
                self.updateOriginalInput();
                self.refreshItems();
                self.close(false);
                self.inputState();
                self.isSetup = true;
                if (input.disabled) self.disable();
                else if (input.readOnly) self.setReadOnly(true);
                else self.enable(); //sets tabIndex
                self.on('change', this.onChange);
                (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(input, 'tomselected', 'ts-hidden-accessible');
                self.trigger('initialize');
                // preload options
                if (settings.preload === true) self.preload();
            }
        },
        {
            /**
     * Register options and optgroups
     *
     */ key: "setupOptions",
            value: function setupOptions() {
                var _this = this;
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], optgroups = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                // build options table
                this.addOptions(options);
                // build optgroup table
                (0, $45a9315df96c7449$export$c1a059043cc9c119)(optgroups, function(optgroup) {
                    _this.registerOptionGroup(optgroup);
                });
            }
        },
        {
            /**
     * Sets up default rendering functions.
     */ key: "setupTemplates",
            value: function setupTemplates() {
                var self = this;
                var field_label = self.settings.labelField;
                var field_optgroup = self.settings.optgroupLabelField;
                var templates = {
                    'optgroup': function(data) {
                        var optgroup = document.createElement('div');
                        optgroup.className = 'optgroup';
                        optgroup.appendChild(data.options);
                        return optgroup;
                    },
                    'optgroup_header': function(data, escape) {
                        return '<div class="optgroup-header">' + escape(data[field_optgroup]) + '</div>';
                    },
                    'option': function(data, escape) {
                        return '<div>' + escape(data[field_label]) + '</div>';
                    },
                    'item': function(data, escape) {
                        return '<div>' + escape(data[field_label]) + '</div>';
                    },
                    'option_create': function(data, escape) {
                        return '<div class="create">Add <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                    },
                    'no_results': function() {
                        return '<div class="no-results">No results found</div>';
                    },
                    'loading': function() {
                        return '<div class="spinner"></div>';
                    },
                    'not_loading': function() {},
                    'dropdown': function() {
                        return '<div></div>';
                    }
                };
                self.settings.render = Object.assign({}, templates, self.settings.render);
            }
        },
        {
            /**
     * Maps fired events to callbacks provided
     * in the settings used when creating the control.
     */ key: "setupCallbacks",
            value: function setupCallbacks() {
                var key, fn;
                var callbacks = {
                    'initialize': 'onInitialize',
                    'change': 'onChange',
                    'item_add': 'onItemAdd',
                    'item_remove': 'onItemRemove',
                    'item_select': 'onItemSelect',
                    'clear': 'onClear',
                    'option_add': 'onOptionAdd',
                    'option_remove': 'onOptionRemove',
                    'option_clear': 'onOptionClear',
                    'optgroup_add': 'onOptionGroupAdd',
                    'optgroup_remove': 'onOptionGroupRemove',
                    'optgroup_clear': 'onOptionGroupClear',
                    'dropdown_open': 'onDropdownOpen',
                    'dropdown_close': 'onDropdownClose',
                    'type': 'onType',
                    'load': 'onLoad',
                    'focus': 'onFocus',
                    'blur': 'onBlur'
                };
                for(key in callbacks){
                    fn = this.settings[callbacks[key]];
                    if (fn) this.on(key, fn);
                }
            }
        },
        {
            /**
     * Sync the Tom Select instance with the original input or select
     *
     */ key: "sync",
            value: function sync() {
                var get_settings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var self = this;
                var settings = get_settings ? (0, $016f8c1d914a717a$export$2e2bcd8739ae039)(self.input, {
                    delimiter: self.settings.delimiter
                }) : self.settings;
                self.setupOptions(settings.options, settings.optgroups);
                self.setValue(settings.items || [], true); // silent prevents recursion
                self.lastQuery = null; // so updated options will be displayed in dropdown
            }
        },
        {
            /**
     * Triggered when the main control element
     * has a click event.
     *
     */ key: "onClick",
            value: function onClick() {
                var self = this;
                if (self.activeItems.length > 0) {
                    self.clearActiveItems();
                    self.focus();
                    return;
                }
                if (self.isFocused && self.isOpen) self.blur();
                else self.focus();
            }
        },
        {
            /**
     * @deprecated v1.7
     *
     */ key: "onMouseDown",
            value: function onMouseDown() {}
        },
        {
            /**
     * Triggered when the value of the control has been changed.
     * This should propagate the event to the original DOM
     * input / select element.
     */ key: "onChange",
            value: function onChange() {
                (0, $212e4671cfd200e3$export$bf5e5f0a0e9ca89d)(this.input, 'input');
                (0, $212e4671cfd200e3$export$bf5e5f0a0e9ca89d)(this.input, 'change');
            }
        },
        {
            /**
     * Triggered on <input> paste.
     *
     */ key: "onPaste",
            value: function onPaste(e) {
                var _this = this;
                var self = this;
                if (self.isInputHidden || self.isLocked) {
                    (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                    return;
                }
                // If a regex or string is included, this will split the pasted
                // input and create Items for each separate value
                if (!self.settings.splitOn) return;
                // Wait for pasted text to be recognized in value
                setTimeout(function() {
                    var pastedText = self.inputValue();
                    if (!pastedText.match(self.settings.splitOn)) return;
                    var splitInput = pastedText.trim().split(self.settings.splitOn);
                    (0, $45a9315df96c7449$export$c1a059043cc9c119)(splitInput, function(piece) {
                        var hash = (0, $45a9315df96c7449$export$4e00787be681ebe0)(piece);
                        if (hash) {
                            if (_this.options[piece]) self.addItem(piece);
                            else self.createItem(piece);
                        }
                    });
                }, 0);
            }
        },
        {
            /**
     * Triggered on <input> keypress.
     *
     */ key: "onKeyPress",
            value: function onKeyPress(e) {
                var self = this;
                if (self.isLocked) {
                    (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                    return;
                }
                var character = String.fromCharCode(e.keyCode || e.which);
                if (self.settings.create && self.settings.mode === 'multi' && character === self.settings.delimiter) {
                    self.createItem();
                    (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                    return;
                }
            }
        },
        {
            /**
     * Triggered on <input> keydown.
     *
     */ key: "onKeyDown",
            value: function onKeyDown(e) {
                var self = this;
                self.ignoreHover = true;
                if (self.isLocked) {
                    if (e.keyCode !== $ce22d7b9dbf789f4$export$10f6869ed0a7d75b) (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                    return;
                }
                switch(e.keyCode){
                    // ctrl+A: select all
                    case $ce22d7b9dbf789f4$export$a62be707b936c199:
                        if ((0, $45a9315df96c7449$export$e7bf60a870f429b0)($ce22d7b9dbf789f4$export$7f209867a1e996c7, e)) {
                            if (self.control_input.value == '') {
                                (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                                self.selectAll();
                                return;
                            }
                        }
                        break;
                    // esc: close dropdown
                    case $ce22d7b9dbf789f4$export$f0fcadf25a56f096:
                        if (self.isOpen) {
                            (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e, true);
                            self.close();
                        }
                        self.clearActiveItems();
                        return;
                    // down: open dropdown or move selection down
                    case $ce22d7b9dbf789f4$export$a80636c6f41931fe:
                        if (!self.isOpen && self.hasOptions) self.open();
                        else if (self.activeOption) {
                            var next = self.getAdjacent(self.activeOption, 1);
                            if (next) self.setActiveOption(next);
                        }
                        (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                        return;
                    // up: move selection up
                    case $ce22d7b9dbf789f4$export$390330c10ff2b9a1:
                        if (self.activeOption) {
                            var prev = self.getAdjacent(self.activeOption, -1);
                            if (prev) self.setActiveOption(prev);
                        }
                        (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                        return;
                    // return: select active option
                    case $ce22d7b9dbf789f4$export$a38a780d07123ee:
                        if (self.canSelect(self.activeOption)) {
                            self.onOptionSelect(e, self.activeOption);
                            (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                        // if the option_create=null, the dropdown might be closed
                        } else if (self.settings.create && self.createItem()) (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                        else if (document.activeElement == self.control_input && self.isOpen) (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                        return;
                    // left: modifiy item selection to the left
                    case $ce22d7b9dbf789f4$export$fc4577f2a2af0ae3:
                        self.advanceSelection(-1, e);
                        return;
                    // right: modifiy item selection to the right
                    case $ce22d7b9dbf789f4$export$c40f9845adc73fb5:
                        self.advanceSelection(1, e);
                        return;
                    // tab: select active option and/or create item
                    case $ce22d7b9dbf789f4$export$10f6869ed0a7d75b:
                        if (self.settings.selectOnTab) {
                            if (self.canSelect(self.activeOption)) {
                                self.onOptionSelect(e, self.activeOption);
                                // prevent default [tab] behaviour of jump to the next field
                                // if select isFull, then the dropdown won't be open and [tab] will work normally
                                (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                            }
                            if (self.settings.create && self.createItem()) (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                        }
                        return;
                    // delete|backspace: delete items
                    case $ce22d7b9dbf789f4$export$7cd8f621642ff61e:
                    case $ce22d7b9dbf789f4$export$1fd7871db6041a84:
                        self.deleteSelection(e);
                        return;
                }
                // don't enter text in the control_input when active items are selected
                if (self.isInputHidden && !(0, $45a9315df96c7449$export$e7bf60a870f429b0)($ce22d7b9dbf789f4$export$7f209867a1e996c7, e)) (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
            }
        },
        {
            /**
     * Triggered on <input> keyup.
     *
     */ key: "onInput",
            value: function onInput(e) {
                var _this = this;
                if (this.isLocked) return;
                var value = this.inputValue();
                if (this.lastValue === value) return;
                this.lastValue = value;
                if (value == '') {
                    this._onInput();
                    return;
                }
                if (this.refreshTimeout) window.clearTimeout(this.refreshTimeout);
                this.refreshTimeout = (0, $45a9315df96c7449$export$83e74882c5df8fe1)(function() {
                    _this.refreshTimeout = null;
                    _this._onInput();
                }, this.settings.refreshThrottle);
            }
        },
        {
            key: "_onInput",
            value: function _onInput() {
                var value = this.lastValue;
                if (this.settings.shouldLoad.call(this, value)) this.load(value);
                this.refreshOptions();
                this.trigger('type', value);
            }
        },
        {
            /**
     * Triggered when the user rolls over
     * an option in the autocomplete dropdown menu.
     *
     */ key: "onOptionHover",
            value: function onOptionHover(evt, option) {
                if (this.ignoreHover) return;
                this.setActiveOption(option, false);
            }
        },
        {
            /**
     * Triggered on <input> focus.
     *
     */ key: "onFocus",
            value: function onFocus(e) {
                var self = this;
                var wasFocused = self.isFocused;
                if (self.isDisabled || self.isReadOnly) {
                    self.blur();
                    (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                    return;
                }
                if (self.ignoreFocus) return;
                self.isFocused = true;
                if (self.settings.preload === 'focus') self.preload();
                if (!wasFocused) self.trigger('focus');
                if (!self.activeItems.length) {
                    self.inputState();
                    self.refreshOptions(!!self.settings.openOnFocus);
                }
                self.refreshState();
            }
        },
        {
            /**
     * Triggered on <input> blur.
     *
     */ key: "onBlur",
            value: function onBlur(e) {
                if (document.hasFocus() === false) return;
                var self = this;
                if (!self.isFocused) return;
                self.isFocused = false;
                self.ignoreFocus = false;
                var deactivate = function() {
                    self.close();
                    self.setActiveItem();
                    self.setCaret(self.items.length);
                    self.trigger('blur');
                };
                if (self.settings.create && self.settings.createOnBlur) self.createItem(null, deactivate);
                else deactivate();
            }
        },
        {
            /**
     * Triggered when the user clicks on an option
     * in the autocomplete dropdown menu.
     *
     */ key: "onOptionSelect",
            value: function onOptionSelect(evt, option) {
                var value, self = this;
                // should not be possible to trigger a option under a disabled optgroup
                if (option.parentElement && option.parentElement.matches('[data-disabled]')) return;
                if (option.classList.contains('create')) self.createItem(null, function() {
                    if (self.settings.closeAfterSelect) self.close();
                });
                else {
                    value = option.dataset.value;
                    if (typeof value !== 'undefined') {
                        self.lastQuery = null;
                        self.addItem(value);
                        if (self.settings.closeAfterSelect) self.close();
                        if (!self.settings.hideSelected && evt.type && /click/.test(evt.type)) self.setActiveOption(option);
                    }
                }
            }
        },
        {
            /**
     * Return true if the given option can be selected
     *
     */ key: "canSelect",
            value: function canSelect(option) {
                if (this.isOpen && option && this.dropdown_content.contains(option)) return true;
                return false;
            }
        },
        {
            /**
     * Triggered when the user clicks on an item
     * that has been selected.
     *
     */ key: "onItemSelect",
            value: function onItemSelect(evt, item) {
                var self = this;
                if (!self.isLocked && self.settings.mode === 'multi') {
                    (0, $45a9315df96c7449$export$fa3b29edae795ef4)(evt);
                    self.setActiveItem(item, evt);
                    return true;
                }
                return false;
            }
        },
        {
            /**
     * Determines whether or not to invoke
     * the user-provided option provider / loader
     *
     * Note, there is a subtle difference between
     * this.canLoad() and this.settings.shouldLoad();
     *
     *	- settings.shouldLoad() is a user-input validator.
     *	When false is returned, the not_loading template
     *	will be added to the dropdown
     *
     *	- canLoad() is lower level validator that checks
     * 	the Tom Select instance. There is no inherent user
     *	feedback when canLoad returns false
     *
     */ key: "canLoad",
            value: function canLoad(value) {
                if (!this.settings.load) return false;
                if (this.loadedSearches.hasOwnProperty(value)) return false;
                return true;
            }
        },
        {
            /**
     * Invokes the user-provided option provider / loader.
     *
     */ key: "load",
            value: function load(value) {
                var self = this;
                if (!self.canLoad(value)) return;
                (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(self.wrapper, self.settings.loadingClass);
                self.loading++;
                var callback = self.loadCallback.bind(self);
                self.settings.load.call(self, value, callback);
            }
        },
        {
            /**
     * Invoked by the user-provided option provider
     *
     */ key: "loadCallback",
            value: function loadCallback(options, optgroups) {
                var self = this;
                self.loading = Math.max(self.loading - 1, 0);
                self.lastQuery = null;
                self.clearActiveOption(); // when new results load, focus should be on first option
                self.setupOptions(options, optgroups);
                self.refreshOptions(self.isFocused && !self.isInputHidden);
                if (!self.loading) (0, $212e4671cfd200e3$export$33233bd73e8de239)(self.wrapper, self.settings.loadingClass);
                self.trigger('load', options, optgroups);
            }
        },
        {
            key: "preload",
            value: function preload() {
                var classList = this.wrapper.classList;
                if (classList.contains('preloaded')) return;
                classList.add('preloaded');
                this.load('');
            }
        },
        {
            /**
     * Sets the input field of the control to the specified value.
     *
     */ key: "setTextboxValue",
            value: function setTextboxValue() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
                var input = this.control_input;
                var changed = input.value !== value;
                if (changed) {
                    input.value = value;
                    (0, $212e4671cfd200e3$export$bf5e5f0a0e9ca89d)(input, 'update');
                    this.lastValue = value;
                }
            }
        },
        {
            /**
     * Returns the value of the control. If multiple items
     * can be selected (e.g. <select multiple>), this returns
     * an array. If only one item can be selected, this
     * returns a string.
     *
     */ key: "getValue",
            value: function getValue() {
                if (this.is_select_tag && this.input.hasAttribute('multiple')) return this.items;
                return this.items.join(this.settings.delimiter);
            }
        },
        {
            /**
     * Resets the selected items to the given value.
     *
     */ key: "setValue",
            value: function setValue(value, silent) {
                var _this = this;
                var events = silent ? [] : [
                    'change'
                ];
                (0, $45a9315df96c7449$export$2c9747a4208fe65f)(this, events, function() {
                    _this.clear(silent);
                    _this.addItems(value, silent);
                });
            }
        },
        {
            /**
     * Resets the number of max items to the given value
     *
     */ key: "setMaxItems",
            value: function setMaxItems(value) {
                if (value === 0) value = null; //reset to unlimited items.
                this.settings.maxItems = value;
                this.refreshState();
            }
        },
        {
            /**
     * Sets the selected item.
     *
     */ key: "setActiveItem",
            value: function setActiveItem(item, e) {
                var self = this;
                var eventName;
                var i, begin, end, swap;
                var last;
                if (self.settings.mode === 'single') return;
                // clear the active selection
                if (!item) {
                    self.clearActiveItems();
                    if (self.isFocused) self.inputState();
                    return;
                }
                // modify selection
                eventName = e && e.type.toLowerCase();
                if (eventName === 'click' && (0, $45a9315df96c7449$export$e7bf60a870f429b0)('shiftKey', e) && self.activeItems.length) {
                    last = self.getLastActive();
                    begin = Array.prototype.indexOf.call(self.control.children, last);
                    end = Array.prototype.indexOf.call(self.control.children, item);
                    if (begin > end) {
                        swap = begin;
                        begin = end;
                        end = swap;
                    }
                    for(i = begin; i <= end; i++){
                        item = self.control.children[i];
                        if (self.activeItems.indexOf(item) === -1) self.setActiveItemClass(item);
                    }
                    (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e);
                } else if (eventName === 'click' && (0, $45a9315df96c7449$export$e7bf60a870f429b0)($ce22d7b9dbf789f4$export$7f209867a1e996c7, e) || eventName === 'keydown' && (0, $45a9315df96c7449$export$e7bf60a870f429b0)('shiftKey', e)) {
                    if (item.classList.contains('active')) self.removeActiveItem(item);
                    else self.setActiveItemClass(item);
                } else {
                    self.clearActiveItems();
                    self.setActiveItemClass(item);
                }
                // ensure control has focus
                self.inputState();
                if (!self.isFocused) self.focus();
            }
        },
        {
            /**
     * Set the active and last-active classes
     *
     */ key: "setActiveItemClass",
            value: function setActiveItemClass(item) {
                var self = this;
                var last_active = self.control.querySelector('.last-active');
                if (last_active) (0, $212e4671cfd200e3$export$33233bd73e8de239)(last_active, 'last-active');
                (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(item, 'active last-active');
                self.trigger('item_select', item);
                if (self.activeItems.indexOf(item) == -1) self.activeItems.push(item);
            }
        },
        {
            /**
     * Remove active item
     *
     */ key: "removeActiveItem",
            value: function removeActiveItem(item) {
                var idx = this.activeItems.indexOf(item);
                this.activeItems.splice(idx, 1);
                (0, $212e4671cfd200e3$export$33233bd73e8de239)(item, 'active');
            }
        },
        {
            /**
     * Clears all the active items
     *
     */ key: "clearActiveItems",
            value: function clearActiveItems() {
                (0, $212e4671cfd200e3$export$33233bd73e8de239)(this.activeItems, 'active');
                this.activeItems = [];
            }
        },
        {
            /**
     * Sets the selected item in the dropdown menu
     * of available options.
     *
     */ key: "setActiveOption",
            value: function setActiveOption(option) {
                var scroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (option === this.activeOption) return;
                this.clearActiveOption();
                if (!option) return;
                this.activeOption = option;
                (0, $212e4671cfd200e3$export$c609e428011345f3)(this.focus_node, {
                    'aria-activedescendant': option.getAttribute('id')
                });
                (0, $212e4671cfd200e3$export$c609e428011345f3)(option, {
                    'aria-selected': 'true'
                });
                (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(option, 'active');
                if (scroll) this.scrollToOption(option);
            }
        },
        {
            /**
     * Sets the dropdown_content scrollTop to display the option
     *
     */ key: "scrollToOption",
            value: function scrollToOption(option, behavior) {
                if (!option) return;
                var content = this.dropdown_content;
                var height_menu = content.clientHeight;
                var scrollTop = content.scrollTop || 0;
                var height_item = option.offsetHeight;
                var y = option.getBoundingClientRect().top - content.getBoundingClientRect().top + scrollTop;
                if (y + height_item > height_menu + scrollTop) this.scroll(y - height_menu + height_item, behavior);
                else if (y < scrollTop) this.scroll(y, behavior);
            }
        },
        {
            /**
     * Scroll the dropdown to the given position
     *
     */ key: "scroll",
            value: function scroll(scrollTop, behavior) {
                var content = this.dropdown_content;
                if (behavior) content.style.scrollBehavior = behavior;
                content.scrollTop = scrollTop;
                content.style.scrollBehavior = '';
            }
        },
        {
            /**
     * Clears the active option
     *
     */ key: "clearActiveOption",
            value: function clearActiveOption() {
                if (this.activeOption) {
                    (0, $212e4671cfd200e3$export$33233bd73e8de239)(this.activeOption, 'active');
                    (0, $212e4671cfd200e3$export$c609e428011345f3)(this.activeOption, {
                        'aria-selected': null
                    });
                }
                this.activeOption = null;
                (0, $212e4671cfd200e3$export$c609e428011345f3)(this.focus_node, {
                    'aria-activedescendant': null
                });
            }
        },
        {
            /**
     * Selects all items (CTRL + A).
     */ key: "selectAll",
            value: function selectAll() {
                var self = this;
                if (self.settings.mode === 'single') return;
                var activeItems = self.controlChildren();
                if (!activeItems.length) return;
                self.inputState();
                self.close();
                self.activeItems = activeItems;
                (0, $45a9315df96c7449$export$c1a059043cc9c119)(activeItems, function(item) {
                    self.setActiveItemClass(item);
                });
            }
        },
        {
            /**
     * Determines if the control_input should be in a hidden or visible state
     *
     */ key: "inputState",
            value: function inputState() {
                var self = this;
                if (!self.control.contains(self.control_input)) return;
                (0, $212e4671cfd200e3$export$c609e428011345f3)(self.control_input, {
                    placeholder: self.settings.placeholder
                });
                if (self.activeItems.length > 0 || !self.isFocused && self.settings.hidePlaceholder && self.items.length > 0) {
                    self.setTextboxValue();
                    self.isInputHidden = true;
                } else {
                    if (self.settings.hidePlaceholder && self.items.length > 0) (0, $212e4671cfd200e3$export$c609e428011345f3)(self.control_input, {
                        placeholder: ''
                    });
                    self.isInputHidden = false;
                }
                self.wrapper.classList.toggle('input-hidden', self.isInputHidden);
            }
        },
        {
            /**
     * Get the input value
     */ key: "inputValue",
            value: function inputValue() {
                return this.control_input.value.trim();
            }
        },
        {
            /**
     * Gives the control focus.
     */ key: "focus",
            value: function focus() {
                var self = this;
                if (self.isDisabled || self.isReadOnly) return;
                self.ignoreFocus = true;
                if (self.control_input.offsetWidth) self.control_input.focus();
                else self.focus_node.focus();
                setTimeout(function() {
                    self.ignoreFocus = false;
                    self.onFocus();
                }, 0);
            }
        },
        {
            /**
     * Forces the control out of focus.
     *
     */ key: "blur",
            value: function blur() {
                this.focus_node.blur();
                this.onBlur();
            }
        },
        {
            /**
     * Returns a function that scores an object
     * to show how good of a match it is to the
     * provided query.
     *
     * @return {function}
     */ key: "getScoreFunction",
            value: function getScoreFunction(query) {
                return this.sifter.getScoreFunction(query, this.getSearchOptions());
            }
        },
        {
            /**
     * Returns search options for sifter (the system
     * for scoring and sorting results).
     *
     * @see https://github.com/orchidjs/sifter.js
     * @return {object}
     */ key: "getSearchOptions",
            value: function getSearchOptions() {
                var settings = this.settings;
                var sort = settings.sortField;
                if (typeof settings.sortField === 'string') sort = [
                    {
                        field: settings.sortField
                    }
                ];
                return {
                    fields: settings.searchField,
                    conjunction: settings.searchConjunction,
                    sort: sort,
                    nesting: settings.nesting
                };
            }
        },
        {
            /**
     * Searches through available options and returns
     * a sorted array of matches.
     *
     */ key: "search",
            value: function search(query) {
                var result, calculateScore;
                var self = this;
                var options = this.getSearchOptions();
                // validate user-provided result scoring function
                if (self.settings.score) {
                    calculateScore = self.settings.score.call(self, query);
                    if (typeof calculateScore !== 'function') throw new Error('Tom Select "score" setting must be a function that returns a function');
                }
                // perform search
                if (query !== self.lastQuery) {
                    self.lastQuery = query;
                    result = self.sifter.search(query, Object.assign(options, {
                        score: calculateScore
                    }));
                    self.currentResults = result;
                } else result = Object.assign({}, self.currentResults);
                // filter out selected items
                if (self.settings.hideSelected) result.items = result.items.filter(function(item) {
                    var hashed = (0, $45a9315df96c7449$export$4e00787be681ebe0)(item.id);
                    return !(hashed && self.items.indexOf(hashed) !== -1);
                });
                return result;
            }
        },
        {
            /**
     * Refreshes the list of available options shown
     * in the autocomplete dropdown menu.
     *
     */ key: "refreshOptions",
            value: function refreshOptions() {
                var triggerDropdown = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var i, j, k, n, optgroup, optgroups, html, has_create_option, active_group;
                var create;
                var groups = {};
                var groups_order = [];
                var self = this;
                var query = self.inputValue();
                var same_query = query === self.lastQuery || query == '' && self.lastQuery == null;
                var results = self.search(query);
                var active_option = null;
                var show_dropdown = self.settings.shouldOpen || false;
                var dropdown_content = self.dropdown_content;
                if (same_query) {
                    active_option = self.activeOption;
                    if (active_option) active_group = active_option.closest('[data-group]');
                }
                // build markup
                n = results.items.length;
                if (typeof self.settings.maxOptions === 'number') n = Math.min(n, self.settings.maxOptions);
                if (n > 0) show_dropdown = true;
                // get fragment for group and the position of the group in group_order
                var getGroupFragment = function(optgroup, order) {
                    var group_order_i = groups[optgroup];
                    if (group_order_i !== undefined) {
                        var order_group = groups_order[group_order_i];
                        if (order_group !== undefined) return [
                            group_order_i,
                            order_group.fragment
                        ];
                    }
                    var group_fragment = document.createDocumentFragment();
                    group_order_i = groups_order.length;
                    groups_order.push({
                        fragment: group_fragment,
                        order: order,
                        optgroup: optgroup
                    });
                    return [
                        group_order_i,
                        group_fragment
                    ];
                };
                // render and group available options individually
                for(i = 0; i < n; i++){
                    // get option dom element
                    var item = results.items[i];
                    if (!item) continue;
                    var opt_value = item.id;
                    var option = self.options[opt_value];
                    if (option === undefined) continue;
                    var opt_hash = (0, $45a9315df96c7449$export$e59fe9173a7a0aac)(opt_value);
                    var option_el = self.getOption(opt_hash, true);
                    // toggle 'selected' class
                    if (!self.settings.hideSelected) option_el.classList.toggle('selected', self.items.includes(opt_hash));
                    optgroup = option[self.settings.optgroupField] || '';
                    optgroups = Array.isArray(optgroup) ? optgroup : [
                        optgroup
                    ];
                    for(j = 0, k = optgroups && optgroups.length; j < k; j++){
                        optgroup = optgroups[j];
                        var order = option.$order;
                        var self_optgroup = self.optgroups[optgroup];
                        if (self_optgroup === undefined) optgroup = '';
                        else order = self_optgroup.$order;
                        var _getGroupFragment = (0, $esDIr._)(getGroupFragment(optgroup, order), 2), group_order_i = _getGroupFragment[0], group_fragment = _getGroupFragment[1];
                        // nodes can only have one parent, so if the option is in mutple groups, we need a clone
                        if (j > 0) {
                            option_el = option_el.cloneNode(true);
                            (0, $212e4671cfd200e3$export$c609e428011345f3)(option_el, {
                                id: option.$id + '-clone-' + j,
                                'aria-selected': null
                            });
                            option_el.classList.add('ts-cloned');
                            (0, $212e4671cfd200e3$export$33233bd73e8de239)(option_el, 'active');
                            // make sure we keep the activeOption in the same group
                            if (self.activeOption && self.activeOption.dataset.value == opt_value) {
                                if (active_group && active_group.dataset.group === optgroup.toString()) active_option = option_el;
                            }
                        }
                        group_fragment.appendChild(option_el);
                        if (optgroup != '') groups[optgroup] = group_order_i;
                    }
                }
                // sort optgroups
                if (self.settings.lockOptgroupOrder) groups_order.sort(function(a, b) {
                    return a.order - b.order;
                });
                // render optgroup headers & join groups
                html = document.createDocumentFragment();
                (0, $45a9315df96c7449$export$c1a059043cc9c119)(groups_order, function(group_order) {
                    var group_fragment = group_order.fragment;
                    var optgroup = group_order.optgroup;
                    if (!group_fragment || !group_fragment.children.length) return;
                    var group_heading = self.optgroups[optgroup];
                    if (group_heading !== undefined) {
                        var group_options = document.createDocumentFragment();
                        var header = self.render('optgroup_header', group_heading);
                        (0, $45a9315df96c7449$export$10d8903dec122b9d)(group_options, header);
                        (0, $45a9315df96c7449$export$10d8903dec122b9d)(group_options, group_fragment);
                        var group_html = self.render('optgroup', {
                            group: group_heading,
                            options: group_options
                        });
                        (0, $45a9315df96c7449$export$10d8903dec122b9d)(html, group_html);
                    } else (0, $45a9315df96c7449$export$10d8903dec122b9d)(html, group_fragment);
                });
                dropdown_content.innerHTML = '';
                (0, $45a9315df96c7449$export$10d8903dec122b9d)(dropdown_content, html);
                // highlight matching terms inline
                if (self.settings.highlight) {
                    (0, $a62ab4d987017c24$export$7854b6fa03b6c2ef)(dropdown_content);
                    if (results.query.length && results.tokens.length) (0, $45a9315df96c7449$export$c1a059043cc9c119)(results.tokens, function(tok) {
                        (0, $a62ab4d987017c24$export$e4043f67d36cbb26)(dropdown_content, tok.regex);
                    });
                }
                // helper method for adding templates to dropdown
                var add_template = function(template) {
                    var content = self.render(template, {
                        input: query
                    });
                    if (content) {
                        show_dropdown = true;
                        dropdown_content.insertBefore(content, dropdown_content.firstChild);
                    }
                    return content;
                };
                // add loading message
                if (self.loading) add_template('loading');
                else if (!self.settings.shouldLoad.call(self, query)) add_template('not_loading');
                else if (results.items.length === 0) add_template('no_results');
                // add create option
                has_create_option = self.canCreate(query);
                if (has_create_option) create = add_template('option_create');
                // activate
                self.hasOptions = results.items.length > 0 || has_create_option;
                if (show_dropdown) {
                    if (results.items.length > 0) {
                        if (!active_option && self.settings.mode === 'single' && self.items[0] != undefined) active_option = self.getOption(self.items[0]);
                        if (!dropdown_content.contains(active_option)) {
                            var active_index = 0;
                            if (create && !self.settings.addPrecedence) active_index = 1;
                            active_option = self.selectable()[active_index];
                        }
                    } else if (create) active_option = create;
                    if (triggerDropdown && !self.isOpen) {
                        self.open();
                        self.scrollToOption(active_option, 'auto');
                    }
                    self.setActiveOption(active_option);
                } else {
                    self.clearActiveOption();
                    if (triggerDropdown && self.isOpen) self.close(false); // if create_option=null, we want the dropdown to close but not reset the textbox value
                }
            }
        },
        {
            /**
     * Return list of selectable options
     *
     */ key: "selectable",
            value: function selectable() {
                return this.dropdown_content.querySelectorAll('[data-selectable]');
            }
        },
        {
            /**
     * Adds an available option. If it already exists,
     * nothing will happen. Note: this does not refresh
     * the options list dropdown (use `refreshOptions`
     * for that).
     *
     * Usage:
     *
     *   this.addOption(data)
     *
     */ key: "addOption",
            value: function addOption(data) {
                var user_created = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var self = this;
                // @deprecated 1.7.7
                // use addOptions( array, user_created ) for adding multiple options
                if (Array.isArray(data)) {
                    self.addOptions(data, user_created);
                    return false;
                }
                var key = (0, $45a9315df96c7449$export$4e00787be681ebe0)(data[self.settings.valueField]);
                if (key === null || self.options.hasOwnProperty(key)) return false;
                data.$order = data.$order || ++self.order;
                data.$id = self.inputId + '-opt-' + data.$order;
                self.options[key] = data;
                self.lastQuery = null;
                if (user_created) {
                    self.userOptions[key] = user_created;
                    self.trigger('option_add', key, data);
                }
                return key;
            }
        },
        {
            /**
     * Add multiple options
     *
     */ key: "addOptions",
            value: function addOptions(data) {
                var _this = this;
                var user_created = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                (0, $45a9315df96c7449$export$c1a059043cc9c119)(data, function(dat) {
                    _this.addOption(dat, user_created);
                });
            }
        },
        {
            /**
     * @deprecated 1.7.7
     */ key: "registerOption",
            value: function registerOption(data) {
                return this.addOption(data);
            }
        },
        {
            /**
     * Registers an option group to the pool of option groups.
     *
     * @return {boolean|string}
     */ key: "registerOptionGroup",
            value: function registerOptionGroup(data) {
                var key = (0, $45a9315df96c7449$export$4e00787be681ebe0)(data[this.settings.optgroupValueField]);
                if (key === null) return false;
                data.$order = data.$order || ++this.order;
                this.optgroups[key] = data;
                return key;
            }
        },
        {
            /**
     * Registers a new optgroup for options
     * to be bucketed into.
     *
     */ key: "addOptionGroup",
            value: function addOptionGroup(id, data) {
                var hashed_id;
                data[this.settings.optgroupValueField] = id;
                if (hashed_id = this.registerOptionGroup(data)) this.trigger('optgroup_add', hashed_id, data);
            }
        },
        {
            /**
     * Removes an existing option group.
     *
     */ key: "removeOptionGroup",
            value: function removeOptionGroup(id) {
                if (this.optgroups.hasOwnProperty(id)) {
                    delete this.optgroups[id];
                    this.clearCache();
                    this.trigger('optgroup_remove', id);
                }
            }
        },
        {
            /**
     * Clears all existing option groups.
     */ key: "clearOptionGroups",
            value: function clearOptionGroups() {
                this.optgroups = {};
                this.clearCache();
                this.trigger('optgroup_clear');
            }
        },
        {
            /**
     * Updates an option available for selection. If
     * it is visible in the selected items or options
     * dropdown, it will be re-rendered automatically.
     *
     */ key: "updateOption",
            value: function updateOption(value, data) {
                var self = this;
                var item_new;
                var index_item;
                var value_old = (0, $45a9315df96c7449$export$4e00787be681ebe0)(value);
                var value_new = (0, $45a9315df96c7449$export$4e00787be681ebe0)(data[self.settings.valueField]);
                // sanity checks
                if (value_old === null) return;
                var data_old = self.options[value_old];
                if (data_old == undefined) return;
                if (typeof value_new !== 'string') throw new Error('Value must be set in option data');
                var option = self.getOption(value_old);
                var item = self.getItem(value_old);
                data.$order = data.$order || data_old.$order;
                delete self.options[value_old];
                // invalidate render cache
                // don't remove existing node yet, we'll remove it after replacing it
                self.uncacheValue(value_new);
                self.options[value_new] = data;
                // update the option if it's in the dropdown
                if (option) {
                    if (self.dropdown_content.contains(option)) {
                        var option_new = self._render('option', data);
                        (0, $212e4671cfd200e3$export$5542201de9311ab2)(option, option_new);
                        if (self.activeOption === option) self.setActiveOption(option_new);
                    }
                    option.remove();
                }
                // update the item if we have one
                if (item) {
                    index_item = self.items.indexOf(value_old);
                    if (index_item !== -1) self.items.splice(index_item, 1, value_new);
                    item_new = self._render('item', data);
                    if (item.classList.contains('active')) (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(item_new, 'active');
                    (0, $212e4671cfd200e3$export$5542201de9311ab2)(item, item_new);
                }
                // invalidate last query because we might have updated the sortField
                self.lastQuery = null;
            }
        },
        {
            /**
     * Removes a single option.
     *
     */ key: "removeOption",
            value: function removeOption(value, silent) {
                var self = this;
                value = (0, $45a9315df96c7449$export$e59fe9173a7a0aac)(value);
                self.uncacheValue(value);
                delete self.userOptions[value];
                delete self.options[value];
                self.lastQuery = null;
                self.trigger('option_remove', value);
                self.removeItem(value, silent);
            }
        },
        {
            /**
     * Clears all options.
     */ key: "clearOptions",
            value: function clearOptions(filter) {
                var boundFilter = (filter || this.clearFilter).bind(this);
                this.loadedSearches = {};
                this.userOptions = {};
                this.clearCache();
                var selected = {};
                (0, $45a9315df96c7449$export$c1a059043cc9c119)(this.options, function(option, key) {
                    if (boundFilter(option, key)) selected[key] = option;
                });
                this.options = this.sifter.items = selected;
                this.lastQuery = null;
                this.trigger('option_clear');
            }
        },
        {
            /**
     * Used by clearOptions() to decide whether or not an option should be removed
     * Return true to keep an option, false to remove
     *
     */ key: "clearFilter",
            value: function clearFilter(option, value) {
                if (this.items.indexOf(value) >= 0) return true;
                return false;
            }
        },
        {
            /**
     * Returns the dom element of the option
     * matching the given value.
     *
     */ key: "getOption",
            value: function getOption(value) {
                var create = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var hashed = (0, $45a9315df96c7449$export$4e00787be681ebe0)(value);
                if (hashed === null) return null;
                var option = this.options[hashed];
                if (option != undefined) {
                    if (option.$div) return option.$div;
                    if (create) return this._render('option', option);
                }
                return null;
            }
        },
        {
            /**
     * Returns the dom element of the next or previous dom element of the same type
     * Note: adjacent options may not be adjacent DOM elements (optgroups)
     *
     */ key: "getAdjacent",
            value: function getAdjacent(option, direction) {
                var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'option';
                var self = this, all;
                if (!option) return null;
                if (type == 'item') all = self.controlChildren();
                else all = self.dropdown_content.querySelectorAll('[data-selectable]');
                for(var i = 0; i < all.length; i++){
                    if (all[i] != option) continue;
                    if (direction > 0) return all[i + 1];
                    return all[i - 1];
                }
                return null;
            }
        },
        {
            /**
     * Returns the dom element of the item
     * matching the given value.
     *
     */ key: "getItem",
            value: function getItem(item) {
                if ((typeof item === "undefined" ? "undefined" : (0, $ewv1T._)(item)) == 'object') return item;
                var value = (0, $45a9315df96c7449$export$4e00787be681ebe0)(item);
                return value !== null ? this.control.querySelector('[data-value="'.concat((0, $45a9315df96c7449$export$c34459d1aef61885)(value), '"]')) : null;
            }
        },
        {
            /**
     * "Selects" multiple items at once. Adds them to the list
     * at the current caret position.
     *
     */ key: "addItems",
            value: function addItems(values, silent) {
                var self = this;
                var items = Array.isArray(values) ? values : [
                    values
                ];
                items = items.filter(function(x) {
                    return self.items.indexOf(x) === -1;
                });
                var last_item = items[items.length - 1];
                items.forEach(function(item) {
                    self.isPending = item !== last_item;
                    self.addItem(item, silent);
                });
            }
        },
        {
            /**
     * "Selects" an item. Adds it to the list
     * at the current caret position.
     *
     */ key: "addItem",
            value: function addItem(value, silent) {
                var _this = this;
                var events = silent ? [] : [
                    'change',
                    'dropdown_close'
                ];
                (0, $45a9315df96c7449$export$2c9747a4208fe65f)(this, events, function() {
                    var item, wasFull;
                    var self = _this;
                    var inputMode = self.settings.mode;
                    var hashed = (0, $45a9315df96c7449$export$4e00787be681ebe0)(value);
                    if (hashed && self.items.indexOf(hashed) !== -1) {
                        if (inputMode === 'single') self.close();
                        if (inputMode === 'single' || !self.settings.duplicates) return;
                    }
                    if (hashed === null || !self.options.hasOwnProperty(hashed)) return;
                    if (inputMode === 'single') self.clear(silent);
                    if (inputMode === 'multi' && self.isFull()) return;
                    item = self._render('item', self.options[hashed]);
                    if (self.control.contains(item)) item = item.cloneNode(true);
                    wasFull = self.isFull();
                    self.items.splice(self.caretPos, 0, hashed);
                    self.insertAtCaret(item);
                    if (self.isSetup) {
                        // update menu / remove the option (if this is not one item being added as part of series)
                        if (!self.isPending && self.settings.hideSelected) {
                            var option = self.getOption(hashed);
                            var next = self.getAdjacent(option, 1);
                            if (next) self.setActiveOption(next);
                        }
                        // refreshOptions after setActiveOption(),
                        // otherwise setActiveOption() will be called by refreshOptions() with the wrong value
                        if (!self.isPending && !self.settings.closeAfterSelect) self.refreshOptions(self.isFocused && inputMode !== 'single');
                        // hide the menu if the maximum number of items have been selected or no options are left
                        if (self.settings.closeAfterSelect != false && self.isFull()) self.close();
                        else if (!self.isPending) self.positionDropdown();
                        self.trigger('item_add', hashed, item);
                        if (!self.isPending) self.updateOriginalInput({
                            silent: silent
                        });
                    }
                    if (!self.isPending || !wasFull && self.isFull()) {
                        self.inputState();
                        self.refreshState();
                    }
                });
            }
        },
        {
            /**
     * Removes the selected item matching
     * the provided value.
     *
     */ key: "removeItem",
            value: function removeItem() {
                var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, silent = arguments.length > 1 ? arguments[1] : void 0;
                var self = this;
                item = self.getItem(item);
                if (!item) return;
                var i, idx;
                var value = item.dataset.value;
                i = (0, $212e4671cfd200e3$export$e5c4cfab14d02c5d)(item);
                item.remove();
                if (item.classList.contains('active')) {
                    idx = self.activeItems.indexOf(item);
                    self.activeItems.splice(idx, 1);
                    (0, $212e4671cfd200e3$export$33233bd73e8de239)(item, 'active');
                }
                self.items.splice(i, 1);
                self.lastQuery = null;
                if (!self.settings.persist && self.userOptions.hasOwnProperty(value)) self.removeOption(value, silent);
                if (i < self.caretPos) self.setCaret(self.caretPos - 1);
                self.updateOriginalInput({
                    silent: silent
                });
                self.refreshState();
                self.positionDropdown();
                self.trigger('item_remove', value, item);
            }
        },
        {
            /**
     * Invokes the `create` method provided in the
     * TomSelect options that should provide the data
     * for the new item, given the user input.
     *
     * Once this completes, it will be added
     * to the item list.
     *
     */ key: "createItem",
            value: function createItem() {
                var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
                // triggerDropdown parameter @deprecated 2.1.1
                if (arguments.length === 3) callback = arguments[2];
                if (typeof callback != 'function') callback = function() {};
                var self = this;
                var caret = self.caretPos;
                var output;
                input = input || self.inputValue();
                if (!self.canCreate(input)) {
                    callback();
                    return false;
                }
                self.lock();
                var created = false;
                var create = function(data) {
                    self.unlock();
                    if (!data || (typeof data === "undefined" ? "undefined" : (0, $ewv1T._)(data)) !== 'object') return callback();
                    var value = (0, $45a9315df96c7449$export$4e00787be681ebe0)(data[self.settings.valueField]);
                    if (typeof value !== 'string') return callback();
                    self.setTextboxValue();
                    self.addOption(data, true);
                    self.setCaret(caret);
                    self.addItem(value);
                    callback(data);
                    created = true;
                };
                var _obj;
                if (typeof self.settings.create === 'function') output = self.settings.create.call(this, input, create);
                else output = (_obj = {}, (0, $6lD0P._)(_obj, self.settings.labelField, input), (0, $6lD0P._)(_obj, self.settings.valueField, input), _obj);
                if (!created) create(output);
                return true;
            }
        },
        {
            /**
     * Re-renders the selected item lists.
     */ key: "refreshItems",
            value: function refreshItems() {
                var self = this;
                self.lastQuery = null;
                if (self.isSetup) self.addItems(self.items);
                self.updateOriginalInput();
                self.refreshState();
            }
        },
        {
            /**
     * Updates all state-dependent attributes
     * and CSS classes.
     */ key: "refreshState",
            value: function refreshState() {
                var self = this;
                self.refreshValidityState();
                var isFull = self.isFull();
                var isLocked = self.isLocked;
                self.wrapper.classList.toggle('rtl', self.rtl);
                var wrap_classList = self.wrapper.classList;
                wrap_classList.toggle('focus', self.isFocused);
                wrap_classList.toggle('disabled', self.isDisabled);
                wrap_classList.toggle('readonly', self.isReadOnly);
                wrap_classList.toggle('required', self.isRequired);
                wrap_classList.toggle('invalid', !self.isValid);
                wrap_classList.toggle('locked', isLocked);
                wrap_classList.toggle('full', isFull);
                wrap_classList.toggle('input-active', self.isFocused && !self.isInputHidden);
                wrap_classList.toggle('dropdown-active', self.isOpen);
                wrap_classList.toggle('has-options', (0, $212e4671cfd200e3$export$83b788b1a3698c03)(self.options));
                wrap_classList.toggle('has-items', self.items.length > 0);
            }
        },
        {
            /**
     * Update the `required` attribute of both input and control input.
     *
     * The `required` property needs to be activated on the control input
     * for the error to be displayed at the right place. `required` also
     * needs to be temporarily deactivated on the input since the input is
     * hidden and can't show errors.
     */ key: "refreshValidityState",
            value: function refreshValidityState() {
                var self = this;
                if (!self.input.validity) return;
                self.isValid = self.input.validity.valid;
                self.isInvalid = !self.isValid;
            }
        },
        {
            /**
     * Determines whether or not more items can be added
     * to the control without exceeding the user-defined maximum.
     *
     * @returns {boolean}
     */ key: "isFull",
            value: function isFull() {
                return this.settings.maxItems !== null && this.items.length >= this.settings.maxItems;
            }
        },
        {
            /**
     * Refreshes the original <select> or <input>
     * element to reflect the current state.
     *
     */ key: "updateOriginalInput",
            value: function updateOriginalInput() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var self = this;
                var option, label;
                var empty_option = self.input.querySelector('option[value=""]');
                if (self.is_select_tag) {
                    var AddSelected = function AddSelected(option_el, value, label) {
                        if (!option_el) option_el = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)('<option value="' + (0, $45a9315df96c7449$export$1e6f422d3087f91c)(value) + '">' + (0, $45a9315df96c7449$export$1e6f422d3087f91c)(label) + '</option>');
                        // don't move empty option from top of list
                        // fixes bug in firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1725293
                        if (option_el != empty_option) self.input.append(option_el);
                        selected.push(option_el);
                        // marking empty option as selected can break validation
                        // fixes https://github.com/orchidjs/tom-select/issues/303
                        if (option_el != empty_option || has_selected > 0) option_el.selected = true;
                        return option_el;
                    };
                    var selected = [];
                    var has_selected = self.input.querySelectorAll('option:checked').length;
                    // unselect all selected options
                    self.input.querySelectorAll('option:checked').forEach(function(option_el) {
                        option_el.selected = false;
                    });
                    // nothing selected?
                    if (self.items.length == 0 && self.settings.mode == 'single') AddSelected(empty_option, "", "");
                    else self.items.forEach(function(value) {
                        option = self.options[value];
                        label = option[self.settings.labelField] || '';
                        if (selected.includes(option.$option)) {
                            var reuse_opt = self.input.querySelector('option[value="'.concat((0, $45a9315df96c7449$export$c34459d1aef61885)(value), '"]:not(:checked)'));
                            AddSelected(reuse_opt, value, label);
                        } else option.$option = AddSelected(option.$option, value, label);
                    });
                } else self.input.value = self.getValue();
                if (self.isSetup) {
                    if (!opts.silent) self.trigger('change', self.getValue());
                }
            }
        },
        {
            /**
     * Shows the autocomplete dropdown containing
     * the available options.
     */ key: "open",
            value: function open() {
                var self = this;
                if (self.isLocked || self.isOpen || self.settings.mode === 'multi' && self.isFull()) return;
                self.isOpen = true;
                (0, $212e4671cfd200e3$export$c609e428011345f3)(self.focus_node, {
                    'aria-expanded': 'true'
                });
                self.refreshState();
                (0, $212e4671cfd200e3$export$3a26aa64e59aeaff)(self.dropdown, {
                    visibility: 'hidden',
                    display: 'block'
                });
                self.positionDropdown();
                (0, $212e4671cfd200e3$export$3a26aa64e59aeaff)(self.dropdown, {
                    visibility: 'visible',
                    display: 'block'
                });
                self.focus();
                self.trigger('dropdown_open', self.dropdown);
            }
        },
        {
            /**
     * Closes the autocomplete dropdown menu.
     */ key: "close",
            value: function close() {
                var setTextboxValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var self = this;
                var trigger = self.isOpen;
                if (setTextboxValue) {
                    // before blur() to prevent form onchange event
                    self.setTextboxValue();
                    if (self.settings.mode === 'single' && self.items.length) self.inputState();
                }
                self.isOpen = false;
                (0, $212e4671cfd200e3$export$c609e428011345f3)(self.focus_node, {
                    'aria-expanded': 'false'
                });
                (0, $212e4671cfd200e3$export$3a26aa64e59aeaff)(self.dropdown, {
                    display: 'none'
                });
                if (self.settings.hideSelected) self.clearActiveOption();
                self.refreshState();
                if (trigger) self.trigger('dropdown_close', self.dropdown);
            }
        },
        {
            /**
     * Calculates and applies the appropriate
     * position of the dropdown if dropdownParent = 'body'.
     * Otherwise, position is determined by css
     */ key: "positionDropdown",
            value: function positionDropdown() {
                if (this.settings.dropdownParent !== 'body') return;
                var context = this.control;
                var rect = context.getBoundingClientRect();
                var top = context.offsetHeight + rect.top + window.scrollY;
                var left = rect.left + window.scrollX;
                (0, $212e4671cfd200e3$export$3a26aa64e59aeaff)(this.dropdown, {
                    width: rect.width + 'px',
                    top: top + 'px',
                    left: left + 'px'
                });
            }
        },
        {
            /**
     * Resets / clears all selected items
     * from the control.
     *
     */ key: "clear",
            value: function clear(silent) {
                var self = this;
                if (!self.items.length) return;
                var items = self.controlChildren();
                (0, $45a9315df96c7449$export$c1a059043cc9c119)(items, function(item) {
                    self.removeItem(item, true);
                });
                self.inputState();
                if (!silent) self.updateOriginalInput();
                self.trigger('clear');
            }
        },
        {
            /**
     * A helper method for inserting an element
     * at the current caret position.
     *
     */ key: "insertAtCaret",
            value: function insertAtCaret(el) {
                var self = this;
                var caret = self.caretPos;
                var target = self.control;
                target.insertBefore(el, target.children[caret] || null);
                self.setCaret(caret + 1);
            }
        },
        {
            /**
     * Removes the current selected item(s).
     *
     */ key: "deleteSelection",
            value: function deleteSelection(e) {
                var direction, selection, caret, tail;
                var self = this;
                direction = e && e.keyCode === $ce22d7b9dbf789f4$export$7cd8f621642ff61e ? -1 : 1;
                selection = (0, $45a9315df96c7449$export$ca798a7e6e94638c)(self.control_input);
                // determine items that will be removed
                var rm_items = [];
                if (self.activeItems.length) {
                    tail = (0, $212e4671cfd200e3$export$22db25736bd2dc5f)(self.activeItems, direction);
                    caret = (0, $212e4671cfd200e3$export$e5c4cfab14d02c5d)(tail);
                    if (direction > 0) caret++;
                    (0, $45a9315df96c7449$export$c1a059043cc9c119)(self.activeItems, function(item) {
                        return rm_items.push(item);
                    });
                } else if ((self.isFocused || self.settings.mode === 'single') && self.items.length) {
                    var items = self.controlChildren();
                    var rm_item;
                    if (direction < 0 && selection.start === 0 && selection.length === 0) rm_item = items[self.caretPos - 1];
                    else if (direction > 0 && selection.start === self.inputValue().length) rm_item = items[self.caretPos];
                    if (rm_item !== undefined) rm_items.push(rm_item);
                }
                if (!self.shouldDelete(rm_items, e)) return false;
                (0, $45a9315df96c7449$export$fa3b29edae795ef4)(e, true);
                // perform removal
                if (typeof caret !== 'undefined') self.setCaret(caret);
                while(rm_items.length)self.removeItem(rm_items.pop());
                self.inputState();
                self.positionDropdown();
                self.refreshOptions(false);
                return true;
            }
        },
        {
            /**
     * Return true if the items should be deleted
     */ key: "shouldDelete",
            value: function shouldDelete(items, evt) {
                var values = items.map(function(item) {
                    return item.dataset.value;
                });
                // allow the callback to abort
                if (!values.length || typeof this.settings.onDelete === 'function' && this.settings.onDelete(values, evt) === false) return false;
                return true;
            }
        },
        {
            /**
     * Selects the previous / next item (depending on the `direction` argument).
     *
     * > 0 - right
     * < 0 - left
     *
     */ key: "advanceSelection",
            value: function advanceSelection(direction, e) {
                var last_active, adjacent, self = this;
                if (self.rtl) direction *= -1;
                if (self.inputValue().length) return;
                // add or remove to active items
                if ((0, $45a9315df96c7449$export$e7bf60a870f429b0)($ce22d7b9dbf789f4$export$7f209867a1e996c7, e) || (0, $45a9315df96c7449$export$e7bf60a870f429b0)('shiftKey', e)) {
                    last_active = self.getLastActive(direction);
                    if (last_active) {
                        if (!last_active.classList.contains('active')) adjacent = last_active;
                        else adjacent = self.getAdjacent(last_active, direction, 'item');
                    } else if (direction > 0) adjacent = self.control_input.nextElementSibling;
                    else adjacent = self.control_input.previousElementSibling;
                    if (adjacent) {
                        if (adjacent.classList.contains('active')) self.removeActiveItem(last_active);
                        self.setActiveItemClass(adjacent); // mark as last_active !! after removeActiveItem() on last_active
                    }
                // move caret to the left or right
                } else self.moveCaret(direction);
            }
        },
        {
            key: "moveCaret",
            value: function moveCaret(direction) {}
        },
        {
            /**
     * Get the last active item
     *
     */ key: "getLastActive",
            value: function getLastActive(direction) {
                var last_active = this.control.querySelector('.last-active');
                if (last_active) return last_active;
                var result = this.control.querySelectorAll('.active');
                if (result) return (0, $212e4671cfd200e3$export$22db25736bd2dc5f)(result, direction);
            }
        },
        {
            /**
     * Moves the caret to the specified index.
     *
     * The input must be moved by leaving it in place and moving the
     * siblings, due to the fact that focus cannot be restored once lost
     * on mobile webkit devices
     *
     */ key: "setCaret",
            value: function setCaret(new_pos) {
                this.caretPos = this.items.length;
            }
        },
        {
            /**
     * Return list of item dom elements
     *
     */ key: "controlChildren",
            value: function controlChildren() {
                return Array.from(this.control.querySelectorAll('[data-ts-item]'));
            }
        },
        {
            /**
     * Disables user input on the control. Used while
     * items are being asynchronously created.
     */ key: "lock",
            value: function lock() {
                this.setLocked(true);
            }
        },
        {
            /**
     * Re-enables user input on the control.
     */ key: "unlock",
            value: function unlock() {
                this.setLocked(false);
            }
        },
        {
            /**
     * Disable or enable user input on the control
     */ key: "setLocked",
            value: function setLocked() {
                var lock = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isReadOnly || this.isDisabled;
                this.isLocked = lock;
                this.refreshState();
            }
        },
        {
            /**
     * Disables user input on the control completely.
     * While disabled, it cannot receive focus.
     */ key: "disable",
            value: function disable() {
                this.setDisabled(true);
                this.close();
            }
        },
        {
            /**
     * Enables the control so that it can respond
     * to focus and user input.
     */ key: "enable",
            value: function enable() {
                this.setDisabled(false);
            }
        },
        {
            key: "setDisabled",
            value: function setDisabled(disabled) {
                this.focus_node.tabIndex = disabled ? -1 : this.tabIndex;
                this.isDisabled = disabled;
                this.input.disabled = disabled;
                this.control_input.disabled = disabled;
                this.setLocked();
            }
        },
        {
            key: "setReadOnly",
            value: function setReadOnly(isReadOnly) {
                this.isReadOnly = isReadOnly;
                this.input.readOnly = isReadOnly;
                this.control_input.readOnly = isReadOnly;
                this.setLocked();
            }
        },
        {
            /**
     * Completely destroys the control and
     * unbinds all event listeners so that it can
     * be garbage collected.
     */ key: "destroy",
            value: function destroy() {
                var self = this;
                var revertSettings = self.revertSettings;
                self.trigger('destroy');
                self.off();
                self.wrapper.remove();
                self.dropdown.remove();
                self.input.innerHTML = revertSettings.innerHTML;
                self.input.tabIndex = revertSettings.tabIndex;
                (0, $212e4671cfd200e3$export$33233bd73e8de239)(self.input, 'tomselected', 'ts-hidden-accessible');
                self._destroy();
                delete self.input.tomselect;
            }
        },
        {
            /**
     * A helper method for rendering "item" and
     * "option" templates, given the data.
     *
     */ key: "render",
            value: function render(templateName, data) {
                var id, html;
                var self = this;
                if (typeof this.settings.render[templateName] !== 'function') return null;
                // render markup
                html = self.settings.render[templateName].call(this, data, (0, $45a9315df96c7449$export$1e6f422d3087f91c));
                if (!html) return null;
                html = (0, $212e4671cfd200e3$export$6c34eab6e99e0f60)(html);
                // add mandatory attributes
                if (templateName === 'option' || templateName === 'option_create') {
                    if (data[self.settings.disabledField]) (0, $212e4671cfd200e3$export$c609e428011345f3)(html, {
                        'aria-disabled': 'true'
                    });
                    else (0, $212e4671cfd200e3$export$c609e428011345f3)(html, {
                        'data-selectable': ''
                    });
                } else if (templateName === 'optgroup') {
                    id = data.group[self.settings.optgroupValueField];
                    (0, $212e4671cfd200e3$export$c609e428011345f3)(html, {
                        'data-group': id
                    });
                    if (data.group[self.settings.disabledField]) (0, $212e4671cfd200e3$export$c609e428011345f3)(html, {
                        'data-disabled': ''
                    });
                }
                if (templateName === 'option' || templateName === 'item') {
                    var value = (0, $45a9315df96c7449$export$e59fe9173a7a0aac)(data[self.settings.valueField]);
                    (0, $212e4671cfd200e3$export$c609e428011345f3)(html, {
                        'data-value': value
                    });
                    // make sure we have some classes if a template is overwritten
                    if (templateName === 'item') {
                        (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(html, self.settings.itemClass);
                        (0, $212e4671cfd200e3$export$c609e428011345f3)(html, {
                            'data-ts-item': ''
                        });
                    } else {
                        (0, $212e4671cfd200e3$export$34a1a93008ee28b5)(html, self.settings.optionClass);
                        (0, $212e4671cfd200e3$export$c609e428011345f3)(html, {
                            role: 'option',
                            id: data.$id
                        });
                        // update cache
                        data.$div = html;
                        self.options[value] = data;
                    }
                }
                return html;
            }
        },
        {
            /**
     * Type guarded rendering
     *
     */ key: "_render",
            value: function _render(templateName, data) {
                var html = this.render(templateName, data);
                if (html == null) throw 'HTMLElement expected';
                return html;
            }
        },
        {
            /**
     * Clears the render cache for a template. If
     * no template is given, clears all render
     * caches.
     *
     */ key: "clearCache",
            value: function clearCache() {
                (0, $45a9315df96c7449$export$c1a059043cc9c119)(this.options, function(option) {
                    if (option.$div) {
                        option.$div.remove();
                        delete option.$div;
                    }
                });
            }
        },
        {
            /**
     * Removes a value from item and option caches
     *
     */ key: "uncacheValue",
            value: function uncacheValue(value) {
                var option_el = this.getOption(value);
                if (option_el) option_el.remove();
            }
        },
        {
            /**
     * Determines whether or not to display the
     * create item prompt, given a user input.
     *
     */ key: "canCreate",
            value: function canCreate(input) {
                return this.settings.create && input.length > 0 && this.settings.createFilter.call(this, input);
            }
        },
        {
            /**
     * Wraps this.`method` so that `new_fn` can be invoked 'before', 'after', or 'instead' of the original method
     *
     * this.hook('instead','onKeyDown',function( arg1, arg2 ...){
     *
     * });
     */ key: "hook",
            value: function hook(when, method, new_fn) {
                var self = this;
                var orig_method = self[method];
                self[method] = function() {
                    var result, result_new;
                    if (when === 'after') result = orig_method.apply(self, arguments);
                    result_new = new_fn.apply(self, arguments);
                    if (when === 'instead') return result_new;
                    if (when === 'before') result = orig_method.apply(self, arguments);
                    return result;
                };
            }
        }
    ]);
    return TomSelect;
}((0, $b89836cef003ca5e$export$2e2bcd8739ae039)((0, $0be681fe05ff7223$export$2e2bcd8739ae039)));


/**
* Tom Select v2.4.3
* Licensed under the Apache License, Version 2.0 (the "License");
*/ /**
 * Converts a scalar to its best string representation
 * for hash keys and HTML attribute values.
 *
 * Transformations:
 *   'str'     -> 'str'
 *   null      -> ''
 *   undefined -> ''
 *   true      -> '1'
 *   false     -> '0'
 *   0         -> '0'
 *   1         -> '1'
 *
 */ /**
 * Escapes a string for use within HTML.
 *
 */ var $3c2180c3d66c7fc7$var$escape_html = function(str) {
    return (str + '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};
/**
 * Prevent default
 *
 */ var $3c2180c3d66c7fc7$var$preventDefault = function(evt) {
    var stop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (evt) {
        evt.preventDefault();
        if (stop) evt.stopPropagation();
    }
};
/**
 * Add event helper
 *
 */ var $3c2180c3d66c7fc7$var$addEvent = function(target, type, callback, options) {
    target.addEventListener(type, callback, options);
};
/**
 * Return a dom element from either a dom query string, jQuery object, a dom element or html string
 * https://stackoverflow.com/questions/494143/creating-a-new-dom-element-from-an-html-string-using-built-in-dom-methods-or-pro/35385518#35385518
 *
 * param query should be {}
 */ var $3c2180c3d66c7fc7$var$getDom = function(query) {
    if (query.jquery) return query[0];
    if (query instanceof HTMLElement) return query;
    if ($3c2180c3d66c7fc7$var$isHtmlString(query)) {
        var tpl = document.createElement('template');
        tpl.innerHTML = query.trim(); // Never return a text node of whitespace as the result
        return tpl.content.firstChild;
    }
    return document.querySelector(query);
};
var $3c2180c3d66c7fc7$var$isHtmlString = function(arg) {
    if (typeof arg === 'string' && arg.indexOf('<') > -1) return true;
    return false;
};
/**
 * Plugin: "remove_button" (Tom Select)
 * Copyright (c) contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 */ function $3c2180c3d66c7fc7$export$2e2bcd8739ae039(userOptions) {
    var options = Object.assign({
        label: '&times;',
        title: 'Remove',
        className: 'remove',
        append: true
    }, userOptions);
    //options.className = 'remove-single';
    var self = this;
    // override the render method to add remove button to each item
    if (!options.append) return;
    var html = '<a href="javascript:void(0)" class="' + options.className + '" tabindex="-1" title="' + $3c2180c3d66c7fc7$var$escape_html(options.title) + '">' + options.label + '</a>';
    self.hook('after', 'setupTemplates', function() {
        var orig_render_item = self.settings.render.item;
        self.settings.render.item = function(data, escape) {
            var item = $3c2180c3d66c7fc7$var$getDom(orig_render_item.call(self, data, escape));
            var close_button = $3c2180c3d66c7fc7$var$getDom(html);
            item.appendChild(close_button);
            $3c2180c3d66c7fc7$var$addEvent(close_button, 'mousedown', function(evt) {
                $3c2180c3d66c7fc7$var$preventDefault(evt, true);
            });
            $3c2180c3d66c7fc7$var$addEvent(close_button, 'click', function(evt) {
                if (self.isLocked) return;
                // propagating will trigger the dropdown to show for single mode
                $3c2180c3d66c7fc7$var$preventDefault(evt, true);
                if (self.isLocked) return;
                if (!self.shouldDelete([
                    item
                ], evt)) return;
                self.removeItem(item);
                self.refreshOptions(false);
                self.inputState();
            });
            return item;
        };
    });
}




var $852297f7037c6a27$exports = {};

var $ewv1T = parcelRequire("ewv1T");
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $ctUVE = parcelRequire("ctUVE");

var $ioD88 = parcelRequire("ioD88");

var $6NCFa = parcelRequire("6NCFa");

var $dqNF0 = parcelRequire("dqNF0");

var $ewv1T = parcelRequire("ewv1T");
var $4bc8a9749307357e$export$a143d493d941bafc;
var $4bc8a9749307357e$export$e4cf37d7f6fb9e0a;
var $4bc8a9749307357e$export$f99ded8fe4b79145;
var $4bc8a9749307357e$export$599f31c3813fae4d;
'use strict';
var $0048d2429f6c26f6$export$a48f0734ac7c2329;
var $0048d2429f6c26f6$export$d622b2ad8d90c771;
var $0048d2429f6c26f6$export$6100ba28696e12de;
'use strict';
$0048d2429f6c26f6$export$a48f0734ac7c2329 = $0048d2429f6c26f6$var$byteLength;
$0048d2429f6c26f6$export$d622b2ad8d90c771 = $0048d2429f6c26f6$var$toByteArray;
$0048d2429f6c26f6$export$6100ba28696e12de = $0048d2429f6c26f6$var$fromByteArray;
var $0048d2429f6c26f6$var$lookup = [];
var $0048d2429f6c26f6$var$revLookup = [];
var $0048d2429f6c26f6$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $0048d2429f6c26f6$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $0048d2429f6c26f6$var$i = 0, $0048d2429f6c26f6$var$len = $0048d2429f6c26f6$var$code.length; $0048d2429f6c26f6$var$i < $0048d2429f6c26f6$var$len; ++$0048d2429f6c26f6$var$i){
    $0048d2429f6c26f6$var$lookup[$0048d2429f6c26f6$var$i] = $0048d2429f6c26f6$var$code[$0048d2429f6c26f6$var$i];
    $0048d2429f6c26f6$var$revLookup[$0048d2429f6c26f6$var$code.charCodeAt($0048d2429f6c26f6$var$i)] = $0048d2429f6c26f6$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0048d2429f6c26f6$var$revLookup['-'.charCodeAt(0)] = 62;
$0048d2429f6c26f6$var$revLookup['_'.charCodeAt(0)] = 63;
function $0048d2429f6c26f6$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0048d2429f6c26f6$var$byteLength(b64) {
    var lens = $0048d2429f6c26f6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0048d2429f6c26f6$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0048d2429f6c26f6$var$toByteArray(b64) {
    var tmp;
    var lens = $0048d2429f6c26f6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0048d2429f6c26f6$var$Arr($0048d2429f6c26f6$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i)] << 18 | $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i)] << 2 | $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i)] << 10 | $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0048d2429f6c26f6$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0048d2429f6c26f6$var$tripletToBase64(num) {
    return $0048d2429f6c26f6$var$lookup[num >> 18 & 0x3F] + $0048d2429f6c26f6$var$lookup[num >> 12 & 0x3F] + $0048d2429f6c26f6$var$lookup[num >> 6 & 0x3F] + $0048d2429f6c26f6$var$lookup[num & 0x3F];
}
function $0048d2429f6c26f6$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0048d2429f6c26f6$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $0048d2429f6c26f6$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0048d2429f6c26f6$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0048d2429f6c26f6$var$lookup[tmp >> 2] + $0048d2429f6c26f6$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0048d2429f6c26f6$var$lookup[tmp >> 10] + $0048d2429f6c26f6$var$lookup[tmp >> 4 & 0x3F] + $0048d2429f6c26f6$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ea1d0ed1582c3863$export$aafa59e2e03f2942;
var $ea1d0ed1582c3863$export$68d8715fc104d294;
$ea1d0ed1582c3863$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ea1d0ed1582c3863$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $4bc8a9749307357e$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$4bc8a9749307357e$export$a143d493d941bafc = $4bc8a9749307357e$var$Buffer;
$4bc8a9749307357e$export$e4cf37d7f6fb9e0a = $4bc8a9749307357e$var$SlowBuffer;
$4bc8a9749307357e$export$f99ded8fe4b79145 = 50;
var $4bc8a9749307357e$var$K_MAX_LENGTH = 0x7fffffff;
$4bc8a9749307357e$export$599f31c3813fae4d = $4bc8a9749307357e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $4bc8a9749307357e$var$Buffer.TYPED_ARRAY_SUPPORT = $4bc8a9749307357e$var$typedArraySupport();
if (!$4bc8a9749307357e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $4bc8a9749307357e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($4bc8a9749307357e$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$4bc8a9749307357e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($4bc8a9749307357e$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$4bc8a9749307357e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $4bc8a9749307357e$var$createBuffer(length) {
    if (length > $4bc8a9749307357e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $4bc8a9749307357e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $4bc8a9749307357e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $4bc8a9749307357e$var$allocUnsafe(arg);
    }
    return $4bc8a9749307357e$var$from(arg, encodingOrOffset, length);
}
$4bc8a9749307357e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $4bc8a9749307357e$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $4bc8a9749307357e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $4bc8a9749307357e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)));
    if ($4bc8a9749307357e$var$isInstance(value, ArrayBuffer) || value && $4bc8a9749307357e$var$isInstance(value.buffer, ArrayBuffer)) return $4bc8a9749307357e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($4bc8a9749307357e$var$isInstance(value, SharedArrayBuffer) || value && $4bc8a9749307357e$var$isInstance(value.buffer, SharedArrayBuffer))) return $4bc8a9749307357e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $4bc8a9749307357e$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $4bc8a9749307357e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $4bc8a9749307357e$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $ewv1T._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $4bc8a9749307357e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $4bc8a9749307357e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($4bc8a9749307357e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($4bc8a9749307357e$var$Buffer, Uint8Array);
function $4bc8a9749307357e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $4bc8a9749307357e$var$alloc(size, fill, encoding) {
    $4bc8a9749307357e$var$assertSize(size);
    if (size <= 0) return $4bc8a9749307357e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $4bc8a9749307357e$var$createBuffer(size).fill(fill, encoding) : $4bc8a9749307357e$var$createBuffer(size).fill(fill);
    return $4bc8a9749307357e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $4bc8a9749307357e$var$Buffer.alloc = function(size, fill, encoding) {
    return $4bc8a9749307357e$var$alloc(size, fill, encoding);
};
function $4bc8a9749307357e$var$allocUnsafe(size) {
    $4bc8a9749307357e$var$assertSize(size);
    return $4bc8a9749307357e$var$createBuffer(size < 0 ? 0 : $4bc8a9749307357e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $4bc8a9749307357e$var$Buffer.allocUnsafe = function(size) {
    return $4bc8a9749307357e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $4bc8a9749307357e$var$Buffer.allocUnsafeSlow = function(size) {
    return $4bc8a9749307357e$var$allocUnsafe(size);
};
function $4bc8a9749307357e$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$4bc8a9749307357e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $4bc8a9749307357e$var$byteLength(string, encoding) | 0;
    var buf = $4bc8a9749307357e$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $4bc8a9749307357e$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $4bc8a9749307357e$var$checked(array.length) | 0;
    var buf = $4bc8a9749307357e$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $4bc8a9749307357e$var$fromArrayView(arrayView) {
    if ($4bc8a9749307357e$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $4bc8a9749307357e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $4bc8a9749307357e$var$fromArrayLike(arrayView);
}
function $4bc8a9749307357e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $4bc8a9749307357e$var$Buffer.prototype);
    return buf;
}
function $4bc8a9749307357e$var$fromObject(obj) {
    if ($4bc8a9749307357e$var$Buffer.isBuffer(obj)) {
        var len = $4bc8a9749307357e$var$checked(obj.length) | 0;
        var buf = $4bc8a9749307357e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $4bc8a9749307357e$var$numberIsNaN(obj.length)) return $4bc8a9749307357e$var$createBuffer(0);
        return $4bc8a9749307357e$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $4bc8a9749307357e$var$fromArrayLike(obj.data);
}
function $4bc8a9749307357e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $4bc8a9749307357e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $4bc8a9749307357e$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $4bc8a9749307357e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $4bc8a9749307357e$var$Buffer.alloc(+length);
}
$4bc8a9749307357e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $4bc8a9749307357e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$4bc8a9749307357e$var$Buffer.compare = function compare(a, b) {
    if ($4bc8a9749307357e$var$isInstance(a, Uint8Array)) a = $4bc8a9749307357e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($4bc8a9749307357e$var$isInstance(b, Uint8Array)) b = $4bc8a9749307357e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$4bc8a9749307357e$var$Buffer.isBuffer(a) || !$4bc8a9749307357e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$4bc8a9749307357e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$4bc8a9749307357e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $4bc8a9749307357e$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $4bc8a9749307357e$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($4bc8a9749307357e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$4bc8a9749307357e$var$Buffer.isBuffer(buf)) buf = $4bc8a9749307357e$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$4bc8a9749307357e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $4bc8a9749307357e$var$byteLength(string, encoding) {
    if ($4bc8a9749307357e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $4bc8a9749307357e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $ewv1T._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $4bc8a9749307357e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $4bc8a9749307357e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $4bc8a9749307357e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$4bc8a9749307357e$var$Buffer.byteLength = $4bc8a9749307357e$var$byteLength;
function $4bc8a9749307357e$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $4bc8a9749307357e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $4bc8a9749307357e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $4bc8a9749307357e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $4bc8a9749307357e$var$latin1Slice(this, start, end);
        case 'base64':
            return $4bc8a9749307357e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4bc8a9749307357e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$4bc8a9749307357e$var$Buffer.prototype._isBuffer = true;
function $4bc8a9749307357e$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$4bc8a9749307357e$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$4bc8a9749307357e$var$swap(this, i, i + 1);
    return this;
};
$4bc8a9749307357e$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $4bc8a9749307357e$var$swap(this, i, i + 3);
        $4bc8a9749307357e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$4bc8a9749307357e$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $4bc8a9749307357e$var$swap(this, i, i + 7);
        $4bc8a9749307357e$var$swap(this, i + 1, i + 6);
        $4bc8a9749307357e$var$swap(this, i + 2, i + 5);
        $4bc8a9749307357e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$4bc8a9749307357e$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $4bc8a9749307357e$var$utf8Slice(this, 0, length);
    return $4bc8a9749307357e$var$slowToString.apply(this, arguments);
};
$4bc8a9749307357e$var$Buffer.prototype.toLocaleString = $4bc8a9749307357e$var$Buffer.prototype.toString;
$4bc8a9749307357e$var$Buffer.prototype.equals = function equals(b) {
    if (!$4bc8a9749307357e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $4bc8a9749307357e$var$Buffer.compare(this, b) === 0;
};
$4bc8a9749307357e$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $4bc8a9749307357e$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($4bc8a9749307357e$var$customInspectSymbol) $4bc8a9749307357e$var$Buffer.prototype[$4bc8a9749307357e$var$customInspectSymbol] = $4bc8a9749307357e$var$Buffer.prototype.inspect;
$4bc8a9749307357e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($4bc8a9749307357e$var$isInstance(target, Uint8Array)) target = $4bc8a9749307357e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$4bc8a9749307357e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $ewv1T._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $4bc8a9749307357e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($4bc8a9749307357e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $4bc8a9749307357e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($4bc8a9749307357e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $4bc8a9749307357e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $4bc8a9749307357e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $4bc8a9749307357e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$4bc8a9749307357e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$4bc8a9749307357e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $4bc8a9749307357e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$4bc8a9749307357e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $4bc8a9749307357e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $4bc8a9749307357e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($4bc8a9749307357e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $4bc8a9749307357e$var$utf8Write(buf, string, offset, length) {
    return $4bc8a9749307357e$var$blitBuffer($4bc8a9749307357e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $4bc8a9749307357e$var$asciiWrite(buf, string, offset, length) {
    return $4bc8a9749307357e$var$blitBuffer($4bc8a9749307357e$var$asciiToBytes(string), buf, offset, length);
}
function $4bc8a9749307357e$var$base64Write(buf, string, offset, length) {
    return $4bc8a9749307357e$var$blitBuffer($4bc8a9749307357e$var$base64ToBytes(string), buf, offset, length);
}
function $4bc8a9749307357e$var$ucs2Write(buf, string, offset, length) {
    return $4bc8a9749307357e$var$blitBuffer($4bc8a9749307357e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$4bc8a9749307357e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $4bc8a9749307357e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $4bc8a9749307357e$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $4bc8a9749307357e$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $4bc8a9749307357e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4bc8a9749307357e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$4bc8a9749307357e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $4bc8a9749307357e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $0048d2429f6c26f6$export$6100ba28696e12de(buf);
    else return $0048d2429f6c26f6$export$6100ba28696e12de(buf.slice(start, end));
}
function $4bc8a9749307357e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $4bc8a9749307357e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $4bc8a9749307357e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $4bc8a9749307357e$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $4bc8a9749307357e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $4bc8a9749307357e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $4bc8a9749307357e$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $4bc8a9749307357e$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $4bc8a9749307357e$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $4bc8a9749307357e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $4bc8a9749307357e$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$4bc8a9749307357e$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $4bc8a9749307357e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $4bc8a9749307357e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$4bc8a9749307357e$var$Buffer.prototype.readUintLE = $4bc8a9749307357e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$4bc8a9749307357e$var$Buffer.prototype.readUintBE = $4bc8a9749307357e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$4bc8a9749307357e$var$Buffer.prototype.readUint8 = $4bc8a9749307357e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$4bc8a9749307357e$var$Buffer.prototype.readUint16LE = $4bc8a9749307357e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$4bc8a9749307357e$var$Buffer.prototype.readUint16BE = $4bc8a9749307357e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$4bc8a9749307357e$var$Buffer.prototype.readUint32LE = $4bc8a9749307357e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$4bc8a9749307357e$var$Buffer.prototype.readUint32BE = $4bc8a9749307357e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$4bc8a9749307357e$var$Buffer.prototype.readBigUInt64LE = $4bc8a9749307357e$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $4bc8a9749307357e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $4bc8a9749307357e$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$4bc8a9749307357e$var$Buffer.prototype.readBigUInt64BE = $4bc8a9749307357e$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $4bc8a9749307357e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $4bc8a9749307357e$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$4bc8a9749307357e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4bc8a9749307357e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4bc8a9749307357e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$4bc8a9749307357e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4bc8a9749307357e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4bc8a9749307357e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$4bc8a9749307357e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$4bc8a9749307357e$var$Buffer.prototype.readBigInt64LE = $4bc8a9749307357e$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $4bc8a9749307357e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $4bc8a9749307357e$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$4bc8a9749307357e$var$Buffer.prototype.readBigInt64BE = $4bc8a9749307357e$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $4bc8a9749307357e$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $4bc8a9749307357e$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$4bc8a9749307357e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 4, this.length);
    return $ea1d0ed1582c3863$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$4bc8a9749307357e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 4, this.length);
    return $ea1d0ed1582c3863$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$4bc8a9749307357e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 8, this.length);
    return $ea1d0ed1582c3863$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$4bc8a9749307357e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkOffset(offset, 8, this.length);
    return $ea1d0ed1582c3863$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $4bc8a9749307357e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$4bc8a9749307357e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$4bc8a9749307357e$var$Buffer.prototype.writeUintLE = $4bc8a9749307357e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4bc8a9749307357e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4bc8a9749307357e$var$Buffer.prototype.writeUintBE = $4bc8a9749307357e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4bc8a9749307357e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4bc8a9749307357e$var$Buffer.prototype.writeUint8 = $4bc8a9749307357e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$4bc8a9749307357e$var$Buffer.prototype.writeUint16LE = $4bc8a9749307357e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4bc8a9749307357e$var$Buffer.prototype.writeUint16BE = $4bc8a9749307357e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4bc8a9749307357e$var$Buffer.prototype.writeUint32LE = $4bc8a9749307357e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$4bc8a9749307357e$var$Buffer.prototype.writeUint32BE = $4bc8a9749307357e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $4bc8a9749307357e$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $4bc8a9749307357e$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $4bc8a9749307357e$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $4bc8a9749307357e$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$4bc8a9749307357e$var$Buffer.prototype.writeBigUInt64LE = $4bc8a9749307357e$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $4bc8a9749307357e$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4bc8a9749307357e$var$Buffer.prototype.writeBigUInt64BE = $4bc8a9749307357e$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $4bc8a9749307357e$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4bc8a9749307357e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $4bc8a9749307357e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4bc8a9749307357e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $4bc8a9749307357e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4bc8a9749307357e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$4bc8a9749307357e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4bc8a9749307357e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4bc8a9749307357e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$4bc8a9749307357e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$4bc8a9749307357e$var$Buffer.prototype.writeBigInt64LE = $4bc8a9749307357e$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $4bc8a9749307357e$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$4bc8a9749307357e$var$Buffer.prototype.writeBigInt64BE = $4bc8a9749307357e$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $4bc8a9749307357e$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $4bc8a9749307357e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $4bc8a9749307357e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ea1d0ed1582c3863$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$4bc8a9749307357e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $4bc8a9749307357e$var$writeFloat(this, value, offset, true, noAssert);
};
$4bc8a9749307357e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $4bc8a9749307357e$var$writeFloat(this, value, offset, false, noAssert);
};
function $4bc8a9749307357e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4bc8a9749307357e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ea1d0ed1582c3863$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$4bc8a9749307357e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $4bc8a9749307357e$var$writeDouble(this, value, offset, true, noAssert);
};
$4bc8a9749307357e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $4bc8a9749307357e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$4bc8a9749307357e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$4bc8a9749307357e$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$4bc8a9749307357e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$4bc8a9749307357e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $4bc8a9749307357e$var$Buffer.isBuffer(val) ? val : $4bc8a9749307357e$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $4bc8a9749307357e$var$errors = {};
function $4bc8a9749307357e$var$E(sym, getMessage, Base) {
    $4bc8a9749307357e$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $dqNF0._)(NodeError, Base);
        function NodeError() {
            (0, $ioD88._)(this, NodeError);
            var _this;
            _this = (0, $ctUVE._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $6NCFa._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$4bc8a9749307357e$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$4bc8a9749307357e$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $ewv1T._)(actual));
}, TypeError);
$4bc8a9749307357e$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $4bc8a9749307357e$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $ewv1T._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $4bc8a9749307357e$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $4bc8a9749307357e$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $4bc8a9749307357e$var$checkBounds(buf, offset, byteLength) {
    $4bc8a9749307357e$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $4bc8a9749307357e$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $4bc8a9749307357e$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $ewv1T._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $4bc8a9749307357e$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $4bc8a9749307357e$var$checkBounds(buf, offset, byteLength);
}
function $4bc8a9749307357e$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $4bc8a9749307357e$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $4bc8a9749307357e$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $4bc8a9749307357e$var$validateNumber(value, type);
        throw new $4bc8a9749307357e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $4bc8a9749307357e$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $4bc8a9749307357e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $4bc8a9749307357e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $4bc8a9749307357e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($4bc8a9749307357e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $4bc8a9749307357e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $4bc8a9749307357e$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $4bc8a9749307357e$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $4bc8a9749307357e$var$base64ToBytes(str) {
    return $0048d2429f6c26f6$export$d622b2ad8d90c771($4bc8a9749307357e$var$base64clean(str));
}
function $4bc8a9749307357e$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $4bc8a9749307357e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $4bc8a9749307357e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $4bc8a9749307357e$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $4bc8a9749307357e$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $4bc8a9749307357e$var$BufferBigIntNotDefined : fn;
}
function $4bc8a9749307357e$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $852297f7037c6a27$require$Buffer = $4bc8a9749307357e$export$a143d493d941bafc;
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $852297f7037c6a27$exports = factory();
})(typeof self !== 'undefined' ? self : undefined, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 109);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var format_1 = __webpack_require__(18);
            var leaf_1 = __webpack_require__(19);
            var scroll_1 = __webpack_require__(45);
            var inline_1 = __webpack_require__(46);
            var block_1 = __webpack_require__(47);
            var embed_1 = __webpack_require__(48);
            var text_1 = __webpack_require__(49);
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var store_1 = __webpack_require__(31);
            var Registry = __webpack_require__(1);
            var Parchment = {
                Scope: Registry.Scope,
                create: Registry.create,
                find: Registry.find,
                query: Registry.query,
                register: Registry.register,
                Container: container_1.default,
                Format: format_1.default,
                Leaf: leaf_1.default,
                Embed: embed_1.default,
                Scroll: scroll_1.default,
                Block: block_1.default,
                Inline: inline_1.default,
                Text: text_1.default,
                Attributor: {
                    Attribute: attributor_1.default,
                    Class: class_1.default,
                    Style: style_1.default,
                    Store: store_1.default
                }
            };
            exports.default = Parchment;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var ParchmentError = /** @class */ function(_super) {
                __extends(ParchmentError, _super);
                function ParchmentError(message) {
                    var _this = this;
                    message = '[Parchment] ' + message;
                    _this = _super.call(this, message) || this;
                    _this.message = message;
                    _this.name = _this.constructor.name;
                    return _this;
                }
                return ParchmentError;
            }(Error);
            exports.ParchmentError = ParchmentError;
            var attributes = {};
            var classes = {};
            var tags = {};
            var types = {};
            exports.DATA_KEY = '__blot';
            var Scope;
            (function(Scope) {
                Scope[Scope["TYPE"] = 3] = "TYPE";
                Scope[Scope["LEVEL"] = 12] = "LEVEL";
                Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
                Scope[Scope["BLOT"] = 14] = "BLOT";
                Scope[Scope["INLINE"] = 7] = "INLINE";
                Scope[Scope["BLOCK"] = 11] = "BLOCK";
                Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
                Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
                Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
                Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
                Scope[Scope["ANY"] = 15] = "ANY";
            })(Scope = exports.Scope || (exports.Scope = {}));
            function create(input, value) {
                var match = query(input);
                if (match == null) throw new ParchmentError("Unable to create " + input + " blot");
                var BlotClass = match;
                var node = // @ts-ignore
                input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
                return new BlotClass(node, value);
            }
            exports.create = create;
            function find(node, bubble) {
                if (bubble === void 0) bubble = false;
                if (node == null) return null;
                // @ts-ignore
                if (node[exports.DATA_KEY] != null) return node[exports.DATA_KEY].blot;
                if (bubble) return find(node.parentNode, bubble);
                return null;
            }
            exports.find = find;
            function query(query, scope) {
                if (scope === void 0) scope = Scope.ANY;
                var match;
                if (typeof query === 'string') match = types[query] || attributes[query];
                else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) match = types['text'];
                else if (typeof query === 'number') {
                    if (query & Scope.LEVEL & Scope.BLOCK) match = types['block'];
                    else if (query & Scope.LEVEL & Scope.INLINE) match = types['inline'];
                } else if (query instanceof HTMLElement) {
                    var names = (query.getAttribute('class') || '').split(/\s+/);
                    for(var i in names){
                        match = classes[names[i]];
                        if (match) break;
                    }
                    match = match || tags[query.tagName];
                }
                if (match == null) return null;
                // @ts-ignore
                if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope) return match;
                return null;
            }
            exports.query = query;
            function register() {
                var Definitions = [];
                for(var _i = 0; _i < arguments.length; _i++)Definitions[_i] = arguments[_i];
                if (Definitions.length > 1) return Definitions.map(function(d) {
                    return register(d);
                });
                var Definition = Definitions[0];
                if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') throw new ParchmentError('Invalid definition');
                else if (Definition.blotName === 'abstract') throw new ParchmentError('Cannot register abstract class');
                types[Definition.blotName || Definition.attrName] = Definition;
                if (typeof Definition.keyName === 'string') attributes[Definition.keyName] = Definition;
                else {
                    if (Definition.className != null) classes[Definition.className] = Definition;
                    if (Definition.tagName != null) {
                        if (Array.isArray(Definition.tagName)) Definition.tagName = Definition.tagName.map(function(tagName) {
                            return tagName.toUpperCase();
                        });
                        else Definition.tagName = Definition.tagName.toUpperCase();
                        var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [
                            Definition.tagName
                        ];
                        tagNames.forEach(function(tag) {
                            if (tags[tag] == null || Definition.className == null) tags[tag] = Definition;
                        });
                    }
                }
                return Definition;
            }
            exports.register = register;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            var diff = __webpack_require__(51);
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var op = __webpack_require__(20);
            var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
            var Delta = function Delta(ops) {
                // Assume we are given a well formed ops
                if (Array.isArray(ops)) this.ops = ops;
                else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
                else this.ops = [];
            };
            Delta.prototype.insert = function(text, attributes) {
                var newOp = {};
                if (text.length === 0) return this;
                newOp.insert = text;
                if (attributes != null && (typeof attributes === "undefined" ? "undefined" : (0, $ewv1T._)(attributes)) === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype['delete'] = function(length) {
                if (length <= 0) return this;
                return this.push({
                    'delete': length
                });
            };
            Delta.prototype.retain = function(length, attributes) {
                if (length <= 0) return this;
                var newOp = {
                    retain: length
                };
                if (attributes != null && (typeof attributes === "undefined" ? "undefined" : (0, $ewv1T._)(attributes)) === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype.push = function(newOp) {
                var index = this.ops.length;
                var lastOp = this.ops[index - 1];
                newOp = extend(true, {}, newOp);
                if ((typeof lastOp === "undefined" ? "undefined" : (0, $ewv1T._)(lastOp)) === 'object') {
                    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
                        this.ops[index - 1] = {
                            'delete': lastOp['delete'] + newOp['delete']
                        };
                        return this;
                    }
                    // Since it does not matter if we insert before or after deleting at the same index,
                    // always prefer to insert first
                    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
                        index -= 1;
                        lastOp = this.ops[index - 1];
                        if ((typeof lastOp === "undefined" ? "undefined" : (0, $ewv1T._)(lastOp)) !== 'object') {
                            this.ops.unshift(newOp);
                            return this;
                        }
                    }
                    if (equal(newOp.attributes, lastOp.attributes)) {
                        if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                            this.ops[index - 1] = {
                                insert: lastOp.insert + newOp.insert
                            };
                            if ((0, $ewv1T._)(newOp.attributes) === 'object') this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                            this.ops[index - 1] = {
                                retain: lastOp.retain + newOp.retain
                            };
                            if ((0, $ewv1T._)(newOp.attributes) === 'object') this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        }
                    }
                }
                if (index === this.ops.length) this.ops.push(newOp);
                else this.ops.splice(index, 0, newOp);
                return this;
            };
            Delta.prototype.chop = function() {
                var lastOp = this.ops[this.ops.length - 1];
                if (lastOp && lastOp.retain && !lastOp.attributes) this.ops.pop();
                return this;
            };
            Delta.prototype.filter = function(predicate) {
                return this.ops.filter(predicate);
            };
            Delta.prototype.forEach = function(predicate) {
                this.ops.forEach(predicate);
            };
            Delta.prototype.map = function(predicate) {
                return this.ops.map(predicate);
            };
            Delta.prototype.partition = function(predicate) {
                var passed = [], failed = [];
                this.forEach(function(op) {
                    var target = predicate(op) ? passed : failed;
                    target.push(op);
                });
                return [
                    passed,
                    failed
                ];
            };
            Delta.prototype.reduce = function(predicate, initial) {
                return this.ops.reduce(predicate, initial);
            };
            Delta.prototype.changeLength = function() {
                return this.reduce(function(length, elem) {
                    if (elem.insert) return length + op.length(elem);
                    else if (elem.delete) return length - elem.delete;
                    return length;
                }, 0);
            };
            Delta.prototype.length = function() {
                return this.reduce(function(length, elem) {
                    return length + op.length(elem);
                }, 0);
            };
            Delta.prototype.slice = function(start, end) {
                start = start || 0;
                if (typeof end !== 'number') end = Infinity;
                var ops = [];
                var iter = op.iterator(this.ops);
                var index = 0;
                while(index < end && iter.hasNext()){
                    var nextOp;
                    if (index < start) nextOp = iter.next(start - index);
                    else {
                        nextOp = iter.next(end - index);
                        ops.push(nextOp);
                    }
                    index += op.length(nextOp);
                }
                return new Delta(ops);
            };
            Delta.prototype.compose = function(other) {
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var ops = [];
                var firstOther = otherIter.peek();
                if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
                    var firstLeft = firstOther.retain;
                    while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                        firstLeft -= thisIter.peekLength();
                        ops.push(thisIter.next());
                    }
                    if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
                }
                var delta = new Delta(ops);
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
                    else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (typeof otherOp.retain === 'number') {
                            var newOp = {};
                            if (typeof thisOp.retain === 'number') newOp.retain = length;
                            else newOp.insert = thisOp.insert;
                            // Preserve null when composing with a retain, otherwise remove it for inserts
                            var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                            if (attributes) newOp.attributes = attributes;
                            delta.push(newOp);
                            // Optimization if rest of other is just retain
                            if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                                var rest = new Delta(thisIter.rest());
                                return delta.concat(rest).chop();
                            }
                        // Other op should be delete, we could be an insert or retain
                        // Insert + delete cancels out
                        } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') delta.push(otherOp);
                    }
                }
                return delta.chop();
            };
            Delta.prototype.concat = function(other) {
                var delta = new Delta(this.ops.slice());
                if (other.ops.length > 0) {
                    delta.push(other.ops[0]);
                    delta.ops = delta.ops.concat(other.ops.slice(1));
                }
                return delta;
            };
            Delta.prototype.diff = function(other, index) {
                if (this.ops === other.ops) return new Delta();
                var strings = [
                    this,
                    other
                ].map(function(delta) {
                    return delta.map(function(op) {
                        if (op.insert != null) return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
                        var prep = delta === other ? 'on' : 'with';
                        throw new Error('diff() called ' + prep + ' non-document');
                    }).join('');
                });
                var delta = new Delta();
                var diffResult = diff(strings[0], strings[1], index);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                diffResult.forEach(function(component) {
                    var length = component[1].length;
                    while(length > 0){
                        var opLength = 0;
                        switch(component[0]){
                            case diff.INSERT:
                                opLength = Math.min(otherIter.peekLength(), length);
                                delta.push(otherIter.next(opLength));
                                break;
                            case diff.DELETE:
                                opLength = Math.min(length, thisIter.peekLength());
                                thisIter.next(opLength);
                                delta['delete'](opLength);
                                break;
                            case diff.EQUAL:
                                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                                var thisOp = thisIter.next(opLength);
                                var otherOp = otherIter.next(opLength);
                                if (equal(thisOp.insert, otherOp.insert)) delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                                else delta.push(otherOp)['delete'](opLength);
                                break;
                        }
                        length -= opLength;
                    }
                });
                return delta.chop();
            };
            Delta.prototype.eachLine = function(predicate, newline) {
                newline = newline || '\n';
                var iter = op.iterator(this.ops);
                var line = new Delta();
                var i = 0;
                while(iter.hasNext()){
                    if (iter.peekType() !== 'insert') return;
                    var thisOp = iter.peek();
                    var start = op.length(thisOp) - iter.peekLength();
                    var index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
                    if (index < 0) line.push(iter.next());
                    else if (index > 0) line.push(iter.next(index));
                    else {
                        if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                        i += 1;
                        line = new Delta();
                    }
                }
                if (line.length() > 0) predicate(line, {}, i);
            };
            Delta.prototype.transform = function(other, priority) {
                priority = !!priority;
                if (typeof other === 'number') return this.transformPosition(other, priority);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var delta = new Delta();
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain(op.length(thisIter.next()));
                    else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (thisOp['delete']) continue;
                        else if (otherOp['delete']) delta.push(otherOp);
                        else // We retain either their retain or insert
                        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
                    }
                }
                return delta.chop();
            };
            Delta.prototype.transformPosition = function(index, priority) {
                priority = !!priority;
                var thisIter = op.iterator(this.ops);
                var offset = 0;
                while(thisIter.hasNext() && offset <= index){
                    var length = thisIter.peekLength();
                    var nextType = thisIter.peekType();
                    thisIter.next();
                    if (nextType === 'delete') {
                        index -= Math.min(length, index - offset);
                        continue;
                    } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
                    offset += length;
                }
                return index;
            };
            module1.exports = Delta;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            'use strict';
            var hasOwn = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;
            var defineProperty = Object.defineProperty;
            var gOPD = Object.getOwnPropertyDescriptor;
            var isArray = function isArray(arr) {
                if (typeof Array.isArray === 'function') return Array.isArray(arr);
                return toStr.call(arr) === '[object Array]';
            };
            var isPlainObject = function isPlainObject(obj) {
                if (!obj || toStr.call(obj) !== '[object Object]') return false;
                var hasOwnConstructor = hasOwn.call(obj, 'constructor');
                var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
                // Not own constructor property must be Object
                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
                // Own properties are enumerated firstly, so to speed up,
                // if last one is own, then all properties are own.
                var key;
                for(key in obj);
                return typeof key === 'undefined' || hasOwn.call(obj, key);
            };
            // If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
            var setProperty = function setProperty(target, options) {
                if (defineProperty && options.name === '__proto__') defineProperty(target, options.name, {
                    enumerable: true,
                    configurable: true,
                    value: options.newValue,
                    writable: true
                });
                else target[options.name] = options.newValue;
            };
            // Return undefined instead of __proto__ if '__proto__' is not an own property
            var getProperty = function getProperty(obj, name) {
                if (name === '__proto__') {
                    if (!hasOwn.call(obj, name)) return void 0;
                    else if (gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
                    // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
                    return gOPD(obj, name).value;
                }
                return obj[name];
            };
            module1.exports = function extend() {
                var options, name, src, copy, copyIsArray, clone;
                var target = arguments[0];
                var i = 1;
                var length = arguments.length;
                var deep = false;
                // Handle a deep copy situation
                if (typeof target === 'boolean') {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }
                if (target == null || (typeof target === "undefined" ? "undefined" : (0, $ewv1T._)(target)) !== 'object' && typeof target !== 'function') target = {};
                for(; i < length; ++i){
                    options = arguments[i];
                    // Only deal with non-null/undefined values
                    if (options != null) // Extend the base object
                    for(name in options){
                        src = getProperty(target, name);
                        copy = getProperty(options, name);
                        // Prevent never-ending loop
                        if (target !== copy) {
                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && isArray(src) ? src : [];
                                } else clone = src && isPlainObject(src) ? src : {};
                                // Never move original objects, clone them
                                setProperty(target, {
                                    name: name,
                                    newValue: extend(deep, clone, copy)
                                });
                            // Don't bring in undefined values
                            } else if (typeof copy !== 'undefined') setProperty(target, {
                                name: name,
                                newValue: copy
                            });
                        }
                    }
                }
                // Return the modified object
                return target;
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var NEWLINE_LENGTH = 1;
            var BlockEmbed = function(_Parchment$Embed) {
                _inherits(BlockEmbed, _Parchment$Embed);
                function BlockEmbed() {
                    _classCallCheck(this, BlockEmbed);
                    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
                }
                _createClass(BlockEmbed, [
                    {
                        key: 'attach',
                        value: function attach() {
                            _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
                            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
                        }
                    },
                    {
                        key: 'delta',
                        value: function delta() {
                            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
                            if (attribute != null) this.attributes.attribute(attribute, value);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            this.format(name, value);
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (typeof value === 'string' && value.endsWith('\n')) {
                                var block = _parchment2.default.create(Block.blotName);
                                this.parent.insertBefore(block, index === 0 ? this : this.next);
                                block.insertAt(0, value.slice(0, -1));
                            } else _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
                        }
                    }
                ]);
                return BlockEmbed;
            }(_parchment2.default.Embed);
            BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
            // It is important for cursor behavior BlockEmbeds use tags that are block level elements
            var Block = function(_Parchment$Block) {
                _inherits(Block, _Parchment$Block);
                function Block(domNode) {
                    _classCallCheck(this, Block);
                    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
                    _this2.cache = {};
                    return _this2;
                }
                _createClass(Block, [
                    {
                        key: 'delta',
                        value: function delta() {
                            if (this.cache.delta == null) this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function(delta, leaf) {
                                if (leaf.length() === 0) return delta;
                                else return delta.insert(leaf.value(), bubbleFormats(leaf));
                            }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
                            return this.cache.delta;
                        }
                    },
                    {
                        key: 'deleteAt',
                        value: function deleteAt(index, length) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (length <= 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                                if (index + length === this.length()) this.format(name, value);
                            } else _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
                            if (value.length === 0) return;
                            var lines = value.split('\n');
                            var text = lines.shift();
                            if (text.length > 0) {
                                if (index < this.length() - 1 || this.children.tail == null) _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
                                else this.children.tail.insertAt(this.children.tail.length(), text);
                                this.cache = {};
                            }
                            var block = this;
                            lines.reduce(function(index, line) {
                                block = block.split(index, true);
                                block.insertAt(0, line);
                                return line.length;
                            }, index + text.length);
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            var head = this.children.head;
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
                            if (head instanceof _break2.default) head.remove();
                            this.cache = {};
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            if (this.cache.length == null) this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
                            return this.cache.length;
                        }
                    },
                    {
                        key: 'moveChildren',
                        value: function moveChildren(target, ref) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'path',
                        value: function path(index) {
                            return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
                        }
                    },
                    {
                        key: 'removeChild',
                        value: function removeChild(child) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'split',
                        value: function split(index) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
                                var clone = this.clone();
                                if (index === 0) {
                                    this.parent.insertBefore(clone, this);
                                    return this;
                                } else {
                                    this.parent.insertBefore(clone, this.next);
                                    return clone;
                                }
                            } else {
                                var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
                                this.cache = {};
                                return next;
                            }
                        }
                    }
                ]);
                return Block;
            }(_parchment2.default.Block);
            Block.blotName = 'block';
            Block.tagName = 'P';
            Block.defaultChild = 'break';
            Block.allowedChildren = [
                _inline2.default,
                _parchment2.default.Embed,
                _text2.default
            ];
            function bubbleFormats(blot) {
                var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (blot == null) return formats;
                if (typeof blot.formats === 'function') formats = (0, _extend2.default)(formats, blot.formats());
                if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
                return bubbleFormats(blot.parent, formats);
            }
            exports.bubbleFormats = bubbleFormats;
            exports.BlockEmbed = BlockEmbed;
            exports.default = Block;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.overload = exports.expandConfig = undefined;
            var _typeof = typeof Symbol === "function" && (0, $ewv1T._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
                return typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            __webpack_require__(50);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _editor = __webpack_require__(14);
            var _editor2 = _interopRequireDefault(_editor);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _selection = __webpack_require__(15);
            var _selection2 = _interopRequireDefault(_selection);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)('quill');
            var Quill = function() {
                _createClass(Quill, null, [
                    {
                        key: 'debug',
                        value: function debug(limit) {
                            if (limit === true) limit = 'log';
                            _logger2.default.level(limit);
                        }
                    },
                    {
                        key: 'find',
                        value: function find(node) {
                            return node.__quill || _parchment2.default.find(node);
                        }
                    },
                    {
                        key: 'import',
                        value: function _import(name) {
                            if (this.imports[name] == null) debug.error('Cannot import ' + name + '. Are you sure it was registered?');
                            return this.imports[name];
                        }
                    },
                    {
                        key: 'register',
                        value: function register(path, target) {
                            var _this = this;
                            var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                            if (typeof path !== 'string') {
                                var name = path.attrName || path.blotName;
                                if (typeof name === 'string') // register(Blot | Attributor, overwrite)
                                this.register('formats/' + name, path, target);
                                else Object.keys(path).forEach(function(key) {
                                    _this.register(key, path[key], target);
                                });
                            } else {
                                if (this.imports[path] != null && !overwrite) debug.warn('Overwriting ' + path + ' with', target);
                                this.imports[path] = target;
                                if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') _parchment2.default.register(target);
                                else if (path.startsWith('modules') && typeof target.register === 'function') target.register();
                            }
                        }
                    }
                ]);
                function Quill(container) {
                    var _this2 = this;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, Quill);
                    this.options = expandConfig(container, options);
                    this.container = this.options.container;
                    if (this.container == null) return debug.error('Invalid Quill container', container);
                    if (this.options.debug) Quill.debug(this.options.debug);
                    var html = this.container.innerHTML.trim();
                    this.container.classList.add('ql-container');
                    this.container.innerHTML = '';
                    this.container.__quill = this;
                    this.root = this.addContainer('ql-editor');
                    this.root.classList.add('ql-blank');
                    this.root.setAttribute('data-gramm', false);
                    this.scrollingContainer = this.options.scrollingContainer || this.root;
                    this.emitter = new _emitter4.default();
                    this.scroll = _parchment2.default.create(this.root, {
                        emitter: this.emitter,
                        whitelist: this.options.formats
                    });
                    this.editor = new _editor2.default(this.scroll);
                    this.selection = new _selection2.default(this.scroll, this.emitter);
                    this.theme = new this.options.theme(this, this.options);
                    this.keyboard = this.theme.addModule('keyboard');
                    this.clipboard = this.theme.addModule('clipboard');
                    this.history = this.theme.addModule('history');
                    this.theme.init();
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type) {
                        if (type === _emitter4.default.events.TEXT_CHANGE) _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function(source, mutations) {
                        var range = _this2.selection.lastRange;
                        var index = range && range.length === 0 ? range.index : undefined;
                        modify.call(_this2, function() {
                            return _this2.editor.update(null, mutations, index);
                        }, source);
                    });
                    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
                    this.setContents(contents);
                    this.history.clear();
                    if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
                    if (this.options.readOnly) this.disable();
                }
                _createClass(Quill, [
                    {
                        key: 'addContainer',
                        value: function addContainer(container) {
                            var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            if (typeof container === 'string') {
                                var className = container;
                                container = document.createElement('div');
                                container.classList.add(className);
                            }
                            this.container.insertBefore(container, refNode);
                            return container;
                        }
                    },
                    {
                        key: 'blur',
                        value: function blur() {
                            this.selection.setRange(null);
                        }
                    },
                    {
                        key: 'deleteText',
                        value: function deleteText(index, length, source) {
                            var _this3 = this;
                            var _overload = overload(index, length, source);
                            var _overload2 = _slicedToArray(_overload, 4);
                            index = _overload2[0];
                            length = _overload2[1];
                            source = _overload2[3];
                            return modify.call(this, function() {
                                return _this3.editor.deleteText(index, length);
                            }, source, index, -1 * length);
                        }
                    },
                    {
                        key: 'disable',
                        value: function disable() {
                            this.enable(false);
                        }
                    },
                    {
                        key: 'enable',
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.scroll.enable(enabled);
                            this.container.classList.toggle('ql-disabled', !enabled);
                        }
                    },
                    {
                        key: 'focus',
                        value: function focus() {
                            var scrollTop = this.scrollingContainer.scrollTop;
                            this.selection.focus();
                            this.scrollingContainer.scrollTop = scrollTop;
                            this.scrollIntoView();
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            var _this4 = this;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                var range = _this4.getSelection(true);
                                var change = new _quillDelta2.default();
                                if (range == null) return change;
                                else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
                                else if (range.length === 0) {
                                    _this4.selection.format(name, value);
                                    return change;
                                } else change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
                                _this4.setSelection(range, _emitter4.default.sources.SILENT);
                                return change;
                            }, source);
                        }
                    },
                    {
                        key: 'formatLine',
                        value: function formatLine(index, length, name, value, source) {
                            var _this5 = this;
                            var formats = void 0;
                            var _overload3 = overload(index, length, name, value, source);
                            var _overload4 = _slicedToArray(_overload3, 4);
                            index = _overload4[0];
                            length = _overload4[1];
                            formats = _overload4[2];
                            source = _overload4[3];
                            return modify.call(this, function() {
                                return _this5.editor.formatLine(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: 'formatText',
                        value: function formatText(index, length, name, value, source) {
                            var _this6 = this;
                            var formats = void 0;
                            var _overload5 = overload(index, length, name, value, source);
                            var _overload6 = _slicedToArray(_overload5, 4);
                            index = _overload6[0];
                            length = _overload6[1];
                            formats = _overload6[2];
                            source = _overload6[3];
                            return modify.call(this, function() {
                                return _this6.editor.formatText(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: 'getBounds',
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var bounds = void 0;
                            if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
                            else bounds = this.selection.getBounds(index.index, index.length);
                            var containerBounds = this.container.getBoundingClientRect();
                            return {
                                bottom: bounds.bottom - containerBounds.top,
                                height: bounds.height,
                                left: bounds.left - containerBounds.left,
                                right: bounds.right - containerBounds.left,
                                top: bounds.top - containerBounds.top,
                                width: bounds.width
                            };
                        }
                    },
                    {
                        key: 'getContents',
                        value: function getContents() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload7 = overload(index, length);
                            var _overload8 = _slicedToArray(_overload7, 2);
                            index = _overload8[0];
                            length = _overload8[1];
                            return this.editor.getContents(index, length);
                        }
                    },
                    {
                        key: 'getFormat',
                        value: function getFormat() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            if (typeof index === 'number') return this.editor.getFormat(index, length);
                            else return this.editor.getFormat(index.index, index.length);
                        }
                    },
                    {
                        key: 'getIndex',
                        value: function getIndex(blot) {
                            return blot.offset(this.scroll);
                        }
                    },
                    {
                        key: 'getLength',
                        value: function getLength() {
                            return this.scroll.length();
                        }
                    },
                    {
                        key: 'getLeaf',
                        value: function getLeaf(index) {
                            return this.scroll.leaf(index);
                        }
                    },
                    {
                        key: 'getLine',
                        value: function getLine(index) {
                            return this.scroll.line(index);
                        }
                    },
                    {
                        key: 'getLines',
                        value: function getLines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
                            else return this.scroll.lines(index, length);
                        }
                    },
                    {
                        key: 'getModule',
                        value: function getModule(name) {
                            return this.theme.modules[name];
                        }
                    },
                    {
                        key: 'getSelection',
                        value: function getSelection() {
                            var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                            if (focus) this.focus();
                            this.update(); // Make sure we access getRange with editor in consistent state
                            return this.selection.getRange()[0];
                        }
                    },
                    {
                        key: 'getText',
                        value: function getText() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload9 = overload(index, length);
                            var _overload10 = _slicedToArray(_overload9, 2);
                            index = _overload10[0];
                            length = _overload10[1];
                            return this.editor.getText(index, length);
                        }
                    },
                    {
                        key: 'hasFocus',
                        value: function hasFocus() {
                            return this.selection.hasFocus();
                        }
                    },
                    {
                        key: 'insertEmbed',
                        value: function insertEmbed(index, embed, value) {
                            var _this7 = this;
                            var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
                            return modify.call(this, function() {
                                return _this7.editor.insertEmbed(index, embed, value);
                            }, source, index);
                        }
                    },
                    {
                        key: 'insertText',
                        value: function insertText(index, text, name, value, source) {
                            var _this8 = this;
                            var formats = void 0;
                            var _overload11 = overload(index, 0, name, value, source);
                            var _overload12 = _slicedToArray(_overload11, 4);
                            index = _overload12[0];
                            formats = _overload12[2];
                            source = _overload12[3];
                            return modify.call(this, function() {
                                return _this8.editor.insertText(index, text, formats);
                            }, source, index, text.length);
                        }
                    },
                    {
                        key: 'isEnabled',
                        value: function isEnabled() {
                            return !this.container.classList.contains('ql-disabled');
                        }
                    },
                    {
                        key: 'off',
                        value: function off() {
                            return this.emitter.off.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'on',
                        value: function on() {
                            return this.emitter.on.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'once',
                        value: function once() {
                            return this.emitter.once.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'pasteHTML',
                        value: function pasteHTML(index, html, source) {
                            this.clipboard.dangerouslyPasteHTML(index, html, source);
                        }
                    },
                    {
                        key: 'removeFormat',
                        value: function removeFormat(index, length, source) {
                            var _this9 = this;
                            var _overload13 = overload(index, length, source);
                            var _overload14 = _slicedToArray(_overload13, 4);
                            index = _overload14[0];
                            length = _overload14[1];
                            source = _overload14[3];
                            return modify.call(this, function() {
                                return _this9.editor.removeFormat(index, length);
                            }, source, index);
                        }
                    },
                    {
                        key: 'scrollIntoView',
                        value: function scrollIntoView() {
                            this.selection.scrollIntoView(this.scrollingContainer);
                        }
                    },
                    {
                        key: 'setContents',
                        value: function setContents(delta) {
                            var _this10 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                var length = _this10.getLength();
                                var deleted = _this10.editor.deleteText(0, length);
                                var applied = _this10.editor.applyDelta(delta);
                                var lastOp = applied.ops[applied.ops.length - 1];
                                if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
                                    _this10.editor.deleteText(_this10.getLength() - 1, 1);
                                    applied.delete(1);
                                }
                                var ret = deleted.compose(applied);
                                return ret;
                            }, source);
                        }
                    },
                    {
                        key: 'setSelection',
                        value: function setSelection(index, length, source) {
                            if (index == null) this.selection.setRange(null, length || Quill.sources.API);
                            else {
                                var _overload15 = overload(index, length, source);
                                var _overload16 = _slicedToArray(_overload15, 4);
                                index = _overload16[0];
                                length = _overload16[1];
                                source = _overload16[3];
                                this.selection.setRange(new _selection.Range(index, length), source);
                                if (source !== _emitter4.default.sources.SILENT) this.selection.scrollIntoView(this.scrollingContainer);
                            }
                        }
                    },
                    {
                        key: 'setText',
                        value: function setText(text) {
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            var delta = new _quillDelta2.default().insert(text);
                            return this.setContents(delta, source);
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
                            this.selection.update(source);
                            return change;
                        }
                    },
                    {
                        key: 'updateContents',
                        value: function updateContents(delta) {
                            var _this11 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                return _this11.editor.applyDelta(delta, source);
                            }, source, true);
                        }
                    }
                ]);
                return Quill;
            }();
            Quill.DEFAULTS = {
                bounds: null,
                formats: null,
                modules: {},
                placeholder: '',
                readOnly: false,
                scrollingContainer: null,
                strict: true,
                theme: 'default'
            };
            Quill.events = _emitter4.default.events;
            Quill.sources = _emitter4.default.sources;
            // eslint-disable-next-line no-undef
            Quill.version = "1.3.7";
            Quill.imports = {
                'delta': _quillDelta2.default,
                'parchment': _parchment2.default,
                'core/module': _module2.default,
                'core/theme': _theme2.default
            };
            function expandConfig(container, userConfig) {
                userConfig = (0, _extend2.default)(true, {
                    container: container,
                    modules: {
                        clipboard: true,
                        keyboard: true,
                        history: true
                    }
                }, userConfig);
                if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) userConfig.theme = _theme2.default;
                else {
                    userConfig.theme = Quill.import('themes/' + userConfig.theme);
                    if (userConfig.theme == null) throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
                }
                var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
                [
                    themeConfig,
                    userConfig
                ].forEach(function(config) {
                    config.modules = config.modules || {};
                    Object.keys(config.modules).forEach(function(module1) {
                        if (config.modules[module1] === true) config.modules[module1] = {};
                    });
                });
                var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
                var moduleConfig = moduleNames.reduce(function(config, name) {
                    var moduleClass = Quill.import('modules/' + name);
                    if (moduleClass == null) debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
                    else config[name] = moduleClass.DEFAULTS || {};
                    return config;
                }, {});
                // Special case toolbar shorthand
                if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) userConfig.modules.toolbar = {
                    container: userConfig.modules.toolbar
                };
                userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, {
                    modules: moduleConfig
                }, themeConfig, userConfig);
                [
                    'bounds',
                    'container',
                    'scrollingContainer'
                ].forEach(function(key) {
                    if (typeof userConfig[key] === 'string') userConfig[key] = document.querySelector(userConfig[key]);
                });
                userConfig.modules = Object.keys(userConfig.modules).reduce(function(config, name) {
                    if (userConfig.modules[name]) config[name] = userConfig.modules[name];
                    return config;
                }, {});
                return userConfig;
            }
            // Handle selection preservation and TEXT_CHANGE emission
            // common to modification APIs
            function modify(modifier, source, index, shift) {
                if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) return new _quillDelta2.default();
                var range = index == null ? null : this.getSelection();
                var oldDelta = this.editor.delta;
                var change = modifier();
                if (range != null) {
                    if (index === true) index = range.index;
                    if (shift == null) range = shiftRange(range, change, source);
                    else if (shift !== 0) range = shiftRange(range, index, shift, source);
                    this.setSelection(range, _emitter4.default.sources.SILENT);
                }
                if (change.length() > 0) {
                    var _emitter;
                    var args = [
                        _emitter4.default.events.TEXT_CHANGE,
                        change,
                        oldDelta,
                        source
                    ];
                    (_emitter = this.emitter).emit.apply(_emitter, [
                        _emitter4.default.events.EDITOR_CHANGE
                    ].concat(args));
                    if (source !== _emitter4.default.sources.SILENT) {
                        var _emitter2;
                        (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                    }
                }
                return change;
            }
            function overload(index, length, name, value, source) {
                var formats = {};
                if (typeof index.index === 'number' && typeof index.length === 'number') {
                    // Allow for throwaway end (used by insertText/insertEmbed)
                    if (typeof length !== 'number') source = value, value = name, name = length, length = index.length, index = index.index;
                    else length = index.length, index = index.index;
                } else if (typeof length !== 'number') source = value, value = name, name = length, length = 0;
                // Handle format being object, two format name/value strings or excluded
                if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
                    formats = name;
                    source = value;
                } else if (typeof name === 'string') {
                    if (value != null) formats[name] = value;
                    else source = name;
                }
                // Handle optional source
                source = source || _emitter4.default.sources.API;
                return [
                    index,
                    length,
                    formats,
                    source
                ];
            }
            function shiftRange(range, index, length, source) {
                if (range == null) return null;
                var start = void 0, end = void 0;
                if (index instanceof _quillDelta2.default) {
                    var _map = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
                    });
                    var _map2 = _slicedToArray(_map, 2);
                    start = _map2[0];
                    end = _map2[1];
                } else {
                    var _map3 = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
                        if (length >= 0) return pos + length;
                        else return Math.max(index, pos + length);
                    });
                    var _map4 = _slicedToArray(_map3, 2);
                    start = _map4[0];
                    end = _map4[1];
                }
                return new _selection.Range(start, end - start);
            }
            exports.expandConfig = expandConfig;
            exports.overload = overload;
            exports.default = Quill;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Inline = function(_Parchment$Inline) {
                _inherits(Inline, _Parchment$Inline);
                function Inline() {
                    _classCallCheck(this, Inline);
                    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
                }
                _createClass(Inline, [
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
                                var blot = this.isolate(index, length);
                                if (value) blot.wrap(name, value);
                            } else _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
                            if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                                var parent = this.parent.isolate(this.offset(), this.length());
                                this.moveChildren(parent);
                                parent.wrap(this);
                            }
                        }
                    }
                ], [
                    {
                        key: 'compare',
                        value: function compare(self1, other) {
                            var selfIndex = Inline.order.indexOf(self1);
                            var otherIndex = Inline.order.indexOf(other);
                            if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
                            else if (self1 === other) return 0;
                            else if (self1 < other) return -1;
                            else return 1;
                        }
                    }
                ]);
                return Inline;
            }(_parchment2.default.Inline);
            Inline.allowedChildren = [
                Inline,
                _parchment2.default.Embed,
                _text2.default
            ];
            // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
            Inline.order = [
                'cursor',
                'inline',
                'underline',
                'strike',
                'italic',
                'bold',
                'script',
                'link',
                'code' // Must be higher
            ];
            exports.default = Inline;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TextBlot = function(_Parchment$Text) {
                _inherits(TextBlot, _Parchment$Text);
                function TextBlot() {
                    _classCallCheck(this, TextBlot);
                    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
                }
                return TextBlot;
            }(_parchment2.default.Text);
            exports.default = TextBlot;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _eventemitter = __webpack_require__(54);
            var _eventemitter2 = _interopRequireDefault(_eventemitter);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:events');
            var EVENTS = [
                'selectionchange',
                'mousedown',
                'mouseup',
                'click'
            ];
            EVENTS.forEach(function(eventName) {
                document.addEventListener(eventName, function() {
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function(node) {
                        // TODO use WeakMap
                        if (node.__quill && node.__quill.emitter) {
                            var _node$__quill$emitter;
                            (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
                        }
                    });
                });
            });
            var Emitter = function(_EventEmitter) {
                _inherits(Emitter, _EventEmitter);
                function Emitter() {
                    _classCallCheck(this, Emitter);
                    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
                    _this.listeners = {};
                    _this.on('error', debug.error);
                    return _this;
                }
                _createClass(Emitter, [
                    {
                        key: 'emit',
                        value: function emit() {
                            debug.log.apply(debug, arguments);
                            _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
                        }
                    },
                    {
                        key: 'handleDOM',
                        value: function handleDOM(event) {
                            for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                            (this.listeners[event.type] || []).forEach(function(_ref) {
                                var node = _ref.node, handler = _ref.handler;
                                if (event.target === node || node.contains(event.target)) handler.apply(undefined, [
                                    event
                                ].concat(args));
                            });
                        }
                    },
                    {
                        key: 'listenDOM',
                        value: function listenDOM(eventName, node, handler) {
                            if (!this.listeners[eventName]) this.listeners[eventName] = [];
                            this.listeners[eventName].push({
                                node: node,
                                handler: handler
                            });
                        }
                    }
                ]);
                return Emitter;
            }(_eventemitter2.default);
            Emitter.events = {
                EDITOR_CHANGE: 'editor-change',
                SCROLL_BEFORE_UPDATE: 'scroll-before-update',
                SCROLL_OPTIMIZE: 'scroll-optimize',
                SCROLL_UPDATE: 'scroll-update',
                SELECTION_CHANGE: 'selection-change',
                TEXT_CHANGE: 'text-change'
            };
            Emitter.sources = {
                API: 'api',
                SILENT: 'silent',
                USER: 'user'
            };
            exports.default = Emitter;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Module = function Module(quill) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                _classCallCheck(this, Module);
                this.quill = quill;
                this.options = options;
            };
            Module.DEFAULTS = {};
            exports.default = Module;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var levels = [
                'error',
                'warn',
                'log',
                'info'
            ];
            var level = 'warn';
            function debug(method) {
                if (levels.indexOf(method) <= levels.indexOf(level)) {
                    var _console;
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
                }
            }
            function namespace(ns) {
                return levels.reduce(function(logger, method) {
                    logger[method] = debug.bind(console, method, ns);
                    return logger;
                }, {});
            }
            debug.level = namespace.level = function(newLevel) {
                level = newLevel;
            };
            exports.default = namespace;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            var pSlice = Array.prototype.slice;
            var objectKeys = __webpack_require__(52);
            var isArguments = __webpack_require__(53);
            var deepEqual = module1.exports = function deepEqual(actual, expected, opts) {
                if (!opts) opts = {};
                // 7.1. All identical values are equivalent, as determined by ===.
                if (actual === expected) return true;
                else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
                else if (!actual || !expected || (typeof actual === "undefined" ? "undefined" : (0, $ewv1T._)(actual)) != 'object' && (typeof expected === "undefined" ? "undefined" : (0, $ewv1T._)(expected)) != 'object') return opts.strict ? actual === expected : actual == expected;
                else return objEquiv(actual, expected, opts);
            };
            function isUndefinedOrNull(value) {
                return value === null || value === undefined;
            }
            function isBuffer(x) {
                if (!x || (typeof x === "undefined" ? "undefined" : (0, $ewv1T._)(x)) !== 'object' || typeof x.length !== 'number') return false;
                if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
                if (x.length > 0 && typeof x[0] !== 'number') return false;
                return true;
            }
            function objEquiv(a, b, opts) {
                var i, key;
                if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
                // an identical 'prototype' property.
                if (a.prototype !== b.prototype) return false;
                //~~~I've managed to break Object.keys through screwy arguments passing.
                //   Converting to array solves the problem.
                if (isArguments(a)) {
                    if (!isArguments(b)) return false;
                    a = pSlice.call(a);
                    b = pSlice.call(b);
                    return deepEqual(a, b, opts);
                }
                if (isBuffer(a)) {
                    if (!isBuffer(b)) return false;
                    if (a.length !== b.length) return false;
                    for(i = 0; i < a.length; i++){
                        if (a[i] !== b[i]) return false;
                    }
                    return true;
                }
                try {
                    var ka = objectKeys(a), kb = objectKeys(b);
                } catch (e) {
                    return false;
                }
                // having the same number of owned properties (keys incorporates
                // hasOwnProperty)
                if (ka.length != kb.length) return false;
                //the same set of keys (although not necessarily the same order),
                ka.sort();
                kb.sort();
                //~~~cheap key test
                for(i = ka.length - 1; i >= 0; i--){
                    if (ka[i] != kb[i]) return false;
                }
                //equivalent values for every corresponding key, and
                //~~~possibly expensive deep test
                for(i = ka.length - 1; i >= 0; i--){
                    key = ka[i];
                    if (!deepEqual(a[key], b[key], opts)) return false;
                }
                return (typeof a === "undefined" ? "undefined" : (0, $ewv1T._)(a)) === (typeof b === "undefined" ? "undefined" : (0, $ewv1T._)(b));
            }
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var Attributor = /** @class */ function() {
                function Attributor(attrName, keyName, options) {
                    if (options === void 0) options = {};
                    this.attrName = attrName;
                    this.keyName = keyName;
                    var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
                    if (options.scope != null) // Ignore type bits, force attribute bit
                    this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
                    else this.scope = Registry.Scope.ATTRIBUTE;
                    if (options.whitelist != null) this.whitelist = options.whitelist;
                }
                Attributor.keys = function(node) {
                    return [].map.call(node.attributes, function(item) {
                        return item.name;
                    });
                };
                Attributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    node.setAttribute(this.keyName, value);
                    return true;
                };
                Attributor.prototype.canAdd = function(node, value) {
                    var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
                    if (match == null) return false;
                    if (this.whitelist == null) return true;
                    if (typeof value === 'string') return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
                    else return this.whitelist.indexOf(value) > -1;
                };
                Attributor.prototype.remove = function(node) {
                    node.removeAttribute(this.keyName);
                };
                Attributor.prototype.value = function(node) {
                    var value = node.getAttribute(this.keyName);
                    if (this.canAdd(node, value) && value) return value;
                    return '';
                };
                return Attributor;
            }();
            exports.default = Attributor;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Code = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Code = function(_Inline) {
                _inherits(Code, _Inline);
                function Code() {
                    _classCallCheck(this, Code);
                    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
                }
                return Code;
            }(_inline2.default);
            Code.blotName = 'code';
            Code.tagName = 'CODE';
            var CodeBlock = function(_Block) {
                _inherits(CodeBlock, _Block);
                function CodeBlock() {
                    _classCallCheck(this, CodeBlock);
                    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
                }
                _createClass(CodeBlock, [
                    {
                        key: 'delta',
                        value: function delta() {
                            var _this3 = this;
                            var text = this.domNode.textContent;
                            if (text.endsWith('\n')) // Should always be true
                            text = text.slice(0, -1);
                            return text.split('\n').reduce(function(delta, frag) {
                                return delta.insert(frag).insert('\n', _this3.formats());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name === this.statics.blotName && value) return;
                            var _descendant = this.descendant(_text2.default, this.length() - 1), _descendant2 = _slicedToArray(_descendant, 1), text = _descendant2[0];
                            if (text != null) text.deleteAt(text.length() - 1, 1);
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (length === 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) return;
                            var nextNewline = this.newlineIndex(index);
                            if (nextNewline < 0 || nextNewline >= index + length) return;
                            var prevNewline = this.newlineIndex(index, true) + 1;
                            var isolateLength = nextNewline - prevNewline + 1;
                            var blot = this.isolate(prevNewline, isolateLength);
                            var next = blot.next;
                            blot.format(name, value);
                            if (next instanceof CodeBlock) next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null) return;
                            var _descendant3 = this.descendant(_text2.default, index), _descendant4 = _slicedToArray(_descendant3, 2), text = _descendant4[0], offset = _descendant4[1];
                            text.insertAt(offset, value);
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            var length = this.domNode.textContent.length;
                            if (!this.domNode.textContent.endsWith('\n')) return length + 1;
                            return length;
                        }
                    },
                    {
                        key: 'newlineIndex',
                        value: function newlineIndex(searchIndex) {
                            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (!reverse) {
                                var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
                                return offset > -1 ? searchIndex + offset : -1;
                            } else return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            if (!this.domNode.textContent.endsWith('\n')) this.appendChild(_parchment2.default.create('text', '\n'));
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
                                next.optimize(context);
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: 'replace',
                        value: function replace(target) {
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
                            [].slice.call(this.domNode.querySelectorAll('*')).forEach(function(node) {
                                var blot = _parchment2.default.find(node);
                                if (blot == null) node.parentNode.removeChild(node);
                                else if (blot instanceof _parchment2.default.Embed) blot.remove();
                                else blot.unwrap();
                            });
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
                            domNode.setAttribute('spellcheck', false);
                            return domNode;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return CodeBlock;
            }(_block2.default);
            CodeBlock.blotName = 'code-block';
            CodeBlock.tagName = 'PRE';
            CodeBlock.TAB = '  ';
            exports.Code = Code;
            exports.default = CodeBlock;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && (0, $ewv1T._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
                return typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var ASCII = /^[ -~]*$/;
            var Editor = function() {
                function Editor(scroll) {
                    _classCallCheck(this, Editor);
                    this.scroll = scroll;
                    this.delta = this.getDelta();
                }
                _createClass(Editor, [
                    {
                        key: 'applyDelta',
                        value: function applyDelta(delta) {
                            var _this = this;
                            var consumeNextNewline = false;
                            this.scroll.update();
                            var scrollLength = this.scroll.length();
                            this.scroll.batchStart();
                            delta = normalizeDelta(delta);
                            delta.reduce(function(index, op) {
                                var length = op.retain || op.delete || op.insert.length || 1;
                                var attributes = op.attributes || {};
                                if (op.insert != null) {
                                    if (typeof op.insert === 'string') {
                                        var text = op.insert;
                                        if (text.endsWith('\n') && consumeNextNewline) {
                                            consumeNextNewline = false;
                                            text = text.slice(0, -1);
                                        }
                                        if (index >= scrollLength && !text.endsWith('\n')) consumeNextNewline = true;
                                        _this.scroll.insertAt(index, text);
                                        var _scroll$line = _this.scroll.line(index), _scroll$line2 = _slicedToArray(_scroll$line, 2), line = _scroll$line2[0], offset = _scroll$line2[1];
                                        var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                                        if (line instanceof _block2.default) {
                                            var _line$descendant = line.descendant(_parchment2.default.Leaf, offset), _line$descendant2 = _slicedToArray(_line$descendant, 1), leaf = _line$descendant2[0];
                                            formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                                        }
                                        attributes = _op2.default.attributes.diff(formats, attributes) || {};
                                    } else if (_typeof(op.insert) === 'object') {
                                        var key = Object.keys(op.insert)[0]; // There should only be one key
                                        if (key == null) return index;
                                        _this.scroll.insertAt(index, key, op.insert[key]);
                                    }
                                    scrollLength += length;
                                }
                                Object.keys(attributes).forEach(function(name) {
                                    _this.scroll.formatAt(index, length, name, attributes[name]);
                                });
                                return index + length;
                            }, 0);
                            delta.reduce(function(index, op) {
                                if (typeof op.delete === 'number') {
                                    _this.scroll.deleteAt(index, op.delete);
                                    return index;
                                }
                                return index + (op.retain || op.insert.length || 1);
                            }, 0);
                            this.scroll.batchEnd();
                            return this.update(delta);
                        }
                    },
                    {
                        key: 'deleteText',
                        value: function deleteText(index, length) {
                            this.scroll.deleteAt(index, length);
                            return this.update(new _quillDelta2.default().retain(index).delete(length));
                        }
                    },
                    {
                        key: 'formatLine',
                        value: function formatLine(index, length) {
                            var _this2 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            this.scroll.update();
                            Object.keys(formats).forEach(function(format) {
                                if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
                                var lines = _this2.scroll.lines(index, Math.max(length, 1));
                                var lengthRemaining = length;
                                lines.forEach(function(line) {
                                    var lineLength = line.length();
                                    if (!(line instanceof _code2.default)) line.format(format, formats[format]);
                                    else {
                                        var codeIndex = index - line.offset(_this2.scroll);
                                        var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                                        line.formatAt(codeIndex, codeLength, format, formats[format]);
                                    }
                                    lengthRemaining -= lineLength;
                                });
                            });
                            this.scroll.optimize();
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'formatText',
                        value: function formatText(index, length) {
                            var _this3 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            Object.keys(formats).forEach(function(format) {
                                _this3.scroll.formatAt(index, length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'getContents',
                        value: function getContents(index, length) {
                            return this.delta.slice(index, index + length);
                        }
                    },
                    {
                        key: 'getDelta',
                        value: function getDelta() {
                            return this.scroll.lines().reduce(function(delta, line) {
                                return delta.concat(line.delta());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: 'getFormat',
                        value: function getFormat(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var lines = [], leaves = [];
                            if (length === 0) this.scroll.path(index).forEach(function(path) {
                                var _path = _slicedToArray(path, 1), blot = _path[0];
                                if (blot instanceof _block2.default) lines.push(blot);
                                else if (blot instanceof _parchment2.default.Leaf) leaves.push(blot);
                            });
                            else {
                                lines = this.scroll.lines(index, length);
                                leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
                            }
                            var formatsArr = [
                                lines,
                                leaves
                            ].map(function(blots) {
                                if (blots.length === 0) return {};
                                var formats = (0, _block.bubbleFormats)(blots.shift());
                                while(Object.keys(formats).length > 0){
                                    var blot = blots.shift();
                                    if (blot == null) return formats;
                                    formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
                                }
                                return formats;
                            });
                            return _extend2.default.apply(_extend2.default, formatsArr);
                        }
                    },
                    {
                        key: 'getText',
                        value: function getText(index, length) {
                            return this.getContents(index, length).filter(function(op) {
                                return typeof op.insert === 'string';
                            }).map(function(op) {
                                return op.insert;
                            }).join('');
                        }
                    },
                    {
                        key: 'insertEmbed',
                        value: function insertEmbed(index, embed, value) {
                            this.scroll.insertAt(index, embed, value);
                            return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
                        }
                    },
                    {
                        key: 'insertText',
                        value: function insertText(index, text) {
                            var _this4 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                            this.scroll.insertAt(index, text);
                            Object.keys(formats).forEach(function(format) {
                                _this4.scroll.formatAt(index, text.length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'isBlank',
                        value: function isBlank() {
                            if (this.scroll.children.length == 0) return true;
                            if (this.scroll.children.length > 1) return false;
                            var block = this.scroll.children.head;
                            if (block.statics.blotName !== _block2.default.blotName) return false;
                            if (block.children.length > 1) return false;
                            return block.children.head instanceof _break2.default;
                        }
                    },
                    {
                        key: 'removeFormat',
                        value: function removeFormat(index, length) {
                            var text = this.getText(index, length);
                            var _scroll$line3 = this.scroll.line(index + length), _scroll$line4 = _slicedToArray(_scroll$line3, 2), line = _scroll$line4[0], offset = _scroll$line4[1];
                            var suffixLength = 0, suffix = new _quillDelta2.default();
                            if (line != null) {
                                if (!(line instanceof _code2.default)) suffixLength = line.length() - offset;
                                else suffixLength = line.newlineIndex(offset) - offset + 1;
                                suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
                            }
                            var contents = this.getContents(index, length + suffixLength);
                            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
                            var delta = new _quillDelta2.default().retain(index).concat(diff);
                            return this.applyDelta(delta);
                        }
                    },
                    {
                        key: 'update',
                        value: function update(change) {
                            var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                            var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                            var oldDelta = this.delta;
                            if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
                                // Optimization for character changes
                                var textBlot = _parchment2.default.find(mutations[0].target);
                                var formats = (0, _block.bubbleFormats)(textBlot);
                                var index = textBlot.offset(this.scroll);
                                var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
                                var oldText = new _quillDelta2.default().insert(oldValue);
                                var newText = new _quillDelta2.default().insert(textBlot.value());
                                var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
                                change = diffDelta.reduce(function(delta, op) {
                                    if (op.insert) return delta.insert(op.insert, formats);
                                    else return delta.push(op);
                                }, new _quillDelta2.default());
                                this.delta = oldDelta.compose(change);
                            } else {
                                this.delta = this.getDelta();
                                if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, cursorIndex);
                            }
                            return change;
                        }
                    }
                ]);
                return Editor;
            }();
            function combineFormats(formats, combined) {
                return Object.keys(combined).reduce(function(merged, name) {
                    if (formats[name] == null) return merged;
                    if (combined[name] === formats[name]) merged[name] = combined[name];
                    else if (Array.isArray(combined[name])) {
                        if (combined[name].indexOf(formats[name]) < 0) merged[name] = combined[name].concat([
                            formats[name]
                        ]);
                    } else merged[name] = [
                        combined[name],
                        formats[name]
                    ];
                    return merged;
                }, {});
            }
            function normalizeDelta(delta) {
                return delta.reduce(function(delta, op) {
                    if (op.insert === 1) {
                        var attributes = (0, _clone2.default)(op.attributes);
                        delete attributes['image'];
                        return delta.insert({
                            image: op.attributes.image
                        }, attributes);
                    }
                    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
                        op = (0, _clone2.default)(op);
                        if (op.attributes.list) op.attributes.list = 'ordered';
                        else {
                            op.attributes.list = 'bullet';
                            delete op.attributes.bullet;
                        }
                    }
                    if (typeof op.insert === 'string') {
                        var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                        return delta.insert(text, op.attributes);
                    }
                    return delta.push(op);
                }, new _quillDelta2.default());
            }
            exports.default = Editor;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Range = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)('quill:selection');
            var Range = function Range(index) {
                var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _classCallCheck(this, Range);
                this.index = index;
                this.length = length;
            };
            var Selection = function() {
                function Selection(scroll, emitter) {
                    var _this = this;
                    _classCallCheck(this, Selection);
                    this.emitter = emitter;
                    this.scroll = scroll;
                    this.composing = false;
                    this.mouseDown = false;
                    this.root = this.scroll.domNode;
                    this.cursor = _parchment2.default.create('cursor', this);
                    // savedRange is last non-null range
                    this.lastRange = this.savedRange = new Range(0, 0);
                    this.handleComposition();
                    this.handleDragging();
                    this.emitter.listenDOM('selectionchange', document, function() {
                        if (!_this.mouseDown) setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
                    });
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type, delta) {
                        if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) _this.update(_emitter4.default.sources.SILENT);
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function() {
                        if (!_this.hasFocus()) return;
                        var native = _this.getNativeRange();
                        if (native == null) return;
                        if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
                        // TODO unclear if this has negative side effects
                        _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function() {
                            try {
                                _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                            } catch (ignored) {}
                        });
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function(mutations, context) {
                        if (context.range) {
                            var _context$range = context.range, startNode = _context$range.startNode, startOffset = _context$range.startOffset, endNode = _context$range.endNode, endOffset = _context$range.endOffset;
                            _this.setNativeRange(startNode, startOffset, endNode, endOffset);
                        }
                    });
                    this.update(_emitter4.default.sources.SILENT);
                }
                _createClass(Selection, [
                    {
                        key: 'handleComposition',
                        value: function handleComposition() {
                            var _this2 = this;
                            this.root.addEventListener('compositionstart', function() {
                                _this2.composing = true;
                            });
                            this.root.addEventListener('compositionend', function() {
                                _this2.composing = false;
                                if (_this2.cursor.parent) {
                                    var range = _this2.cursor.restore();
                                    if (!range) return;
                                    setTimeout(function() {
                                        _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                                    }, 1);
                                }
                            });
                        }
                    },
                    {
                        key: 'handleDragging',
                        value: function handleDragging() {
                            var _this3 = this;
                            this.emitter.listenDOM('mousedown', document.body, function() {
                                _this3.mouseDown = true;
                            });
                            this.emitter.listenDOM('mouseup', document.body, function() {
                                _this3.mouseDown = false;
                                _this3.update(_emitter4.default.sources.USER);
                            });
                        }
                    },
                    {
                        key: 'focus',
                        value: function focus() {
                            if (this.hasFocus()) return;
                            this.root.focus();
                            this.setRange(this.savedRange);
                        }
                    },
                    {
                        key: 'format',
                        value: function format(_format, value) {
                            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
                            this.scroll.update();
                            var nativeRange = this.getNativeRange();
                            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
                            if (nativeRange.start.node !== this.cursor.textNode) {
                                var blot = _parchment2.default.find(nativeRange.start.node, false);
                                if (blot == null) return;
                                // TODO Give blot ability to not split
                                if (blot instanceof _parchment2.default.Leaf) {
                                    var after = blot.split(nativeRange.start.offset);
                                    blot.parent.insertBefore(this.cursor, after);
                                } else blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
                                this.cursor.attach();
                            }
                            this.cursor.format(_format, value);
                            this.scroll.optimize();
                            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
                            this.update();
                        }
                    },
                    {
                        key: 'getBounds',
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var scrollLength = this.scroll.length();
                            index = Math.min(index, scrollLength - 1);
                            length = Math.min(index + length, scrollLength - 1) - index;
                            var node = void 0, _scroll$leaf = this.scroll.leaf(index), _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2), leaf = _scroll$leaf2[0], offset = _scroll$leaf2[1];
                            if (leaf == null) return null;
                            var _leaf$position = leaf.position(offset, true);
                            var _leaf$position2 = _slicedToArray(_leaf$position, 2);
                            node = _leaf$position2[0];
                            offset = _leaf$position2[1];
                            var range = document.createRange();
                            if (length > 0) {
                                range.setStart(node, offset);
                                var _scroll$leaf3 = this.scroll.leaf(index + length);
                                var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
                                leaf = _scroll$leaf4[0];
                                offset = _scroll$leaf4[1];
                                if (leaf == null) return null;
                                var _leaf$position3 = leaf.position(offset, true);
                                var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
                                node = _leaf$position4[0];
                                offset = _leaf$position4[1];
                                range.setEnd(node, offset);
                                return range.getBoundingClientRect();
                            } else {
                                var side = 'left';
                                var rect = void 0;
                                if (node instanceof Text) {
                                    if (offset < node.data.length) {
                                        range.setStart(node, offset);
                                        range.setEnd(node, offset + 1);
                                    } else {
                                        range.setStart(node, offset - 1);
                                        range.setEnd(node, offset);
                                        side = 'right';
                                    }
                                    rect = range.getBoundingClientRect();
                                } else {
                                    rect = leaf.domNode.getBoundingClientRect();
                                    if (offset > 0) side = 'right';
                                }
                                return {
                                    bottom: rect.top + rect.height,
                                    height: rect.height,
                                    left: rect[side],
                                    right: rect[side],
                                    top: rect.top,
                                    width: 0
                                };
                            }
                        }
                    },
                    {
                        key: 'getNativeRange',
                        value: function getNativeRange() {
                            var selection = document.getSelection();
                            if (selection == null || selection.rangeCount <= 0) return null;
                            var nativeRange = selection.getRangeAt(0);
                            if (nativeRange == null) return null;
                            var range = this.normalizeNative(nativeRange);
                            debug.info('getNativeRange', range);
                            return range;
                        }
                    },
                    {
                        key: 'getRange',
                        value: function getRange() {
                            var normalized = this.getNativeRange();
                            if (normalized == null) return [
                                null,
                                null
                            ];
                            var range = this.normalizedToRange(normalized);
                            return [
                                range,
                                normalized
                            ];
                        }
                    },
                    {
                        key: 'hasFocus',
                        value: function hasFocus() {
                            return document.activeElement === this.root;
                        }
                    },
                    {
                        key: 'normalizedToRange',
                        value: function normalizedToRange(range) {
                            var _this4 = this;
                            var positions = [
                                [
                                    range.start.node,
                                    range.start.offset
                                ]
                            ];
                            if (!range.native.collapsed) positions.push([
                                range.end.node,
                                range.end.offset
                            ]);
                            var indexes = positions.map(function(position) {
                                var _position = _slicedToArray(position, 2), node = _position[0], offset = _position[1];
                                var blot = _parchment2.default.find(node, true);
                                var index = blot.offset(_this4.scroll);
                                if (offset === 0) return index;
                                else if (blot instanceof _parchment2.default.Container) return index + blot.length();
                                else return index + blot.index(node, offset);
                            });
                            var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
                            var start = Math.min.apply(Math, [
                                end
                            ].concat(_toConsumableArray(indexes)));
                            return new Range(start, end - start);
                        }
                    },
                    {
                        key: 'normalizeNative',
                        value: function normalizeNative(nativeRange) {
                            if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) return null;
                            var range = {
                                start: {
                                    node: nativeRange.startContainer,
                                    offset: nativeRange.startOffset
                                },
                                end: {
                                    node: nativeRange.endContainer,
                                    offset: nativeRange.endOffset
                                },
                                native: nativeRange
                            };
                            [
                                range.start,
                                range.end
                            ].forEach(function(position) {
                                var node = position.node, offset = position.offset;
                                while(!(node instanceof Text) && node.childNodes.length > 0){
                                    if (node.childNodes.length > offset) {
                                        node = node.childNodes[offset];
                                        offset = 0;
                                    } else if (node.childNodes.length === offset) {
                                        node = node.lastChild;
                                        offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                                    } else break;
                                }
                                position.node = node, position.offset = offset;
                            });
                            return range;
                        }
                    },
                    {
                        key: 'rangeToNative',
                        value: function rangeToNative(range) {
                            var _this5 = this;
                            var indexes = range.collapsed ? [
                                range.index
                            ] : [
                                range.index,
                                range.index + range.length
                            ];
                            var args = [];
                            var scrollLength = this.scroll.length();
                            indexes.forEach(function(index, i) {
                                index = Math.min(scrollLength - 1, index);
                                var node = void 0, _scroll$leaf5 = _this5.scroll.leaf(index), _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2), leaf = _scroll$leaf6[0], offset = _scroll$leaf6[1];
                                var _leaf$position5 = leaf.position(offset, i !== 0);
                                var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
                                node = _leaf$position6[0];
                                offset = _leaf$position6[1];
                                args.push(node, offset);
                            });
                            if (args.length < 2) args = args.concat(args);
                            return args;
                        }
                    },
                    {
                        key: 'scrollIntoView',
                        value: function scrollIntoView(scrollingContainer) {
                            var range = this.lastRange;
                            if (range == null) return;
                            var bounds = this.getBounds(range.index, range.length);
                            if (bounds == null) return;
                            var limit = this.scroll.length() - 1;
                            var _scroll$line = this.scroll.line(Math.min(range.index, limit)), _scroll$line2 = _slicedToArray(_scroll$line, 1), first = _scroll$line2[0];
                            var last = first;
                            if (range.length > 0) {
                                var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
                                var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
                                last = _scroll$line4[0];
                            }
                            if (first == null || last == null) return;
                            var scrollBounds = scrollingContainer.getBoundingClientRect();
                            if (bounds.top < scrollBounds.top) scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
                            else if (bounds.bottom > scrollBounds.bottom) scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
                        }
                    },
                    {
                        key: 'setNativeRange',
                        value: function setNativeRange(startNode, startOffset) {
                            var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
                            var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
                            var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                            debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
                            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) return;
                            var selection = document.getSelection();
                            if (selection == null) return;
                            if (startNode != null) {
                                if (!this.hasFocus()) this.root.focus();
                                var native = (this.getNativeRange() || {}).native;
                                if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                                    if (startNode.tagName == "BR") {
                                        startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                                        startNode = startNode.parentNode;
                                    }
                                    if (endNode.tagName == "BR") {
                                        endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                                        endNode = endNode.parentNode;
                                    }
                                    var range = document.createRange();
                                    range.setStart(startNode, startOffset);
                                    range.setEnd(endNode, endOffset);
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                }
                            } else {
                                selection.removeAllRanges();
                                this.root.blur();
                                document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
                            }
                        }
                    },
                    {
                        key: 'setRange',
                        value: function setRange(range) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            if (typeof force === 'string') {
                                source = force;
                                force = false;
                            }
                            debug.info('setRange', range);
                            if (range != null) {
                                var args = this.rangeToNative(range);
                                this.setNativeRange.apply(this, _toConsumableArray(args).concat([
                                    force
                                ]));
                            } else this.setNativeRange(null);
                            this.update(source);
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var oldRange = this.lastRange;
                            var _getRange = this.getRange(), _getRange2 = _slicedToArray(_getRange, 2), lastRange = _getRange2[0], nativeRange = _getRange2[1];
                            this.lastRange = lastRange;
                            if (this.lastRange != null) this.savedRange = this.lastRange;
                            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
                                var _emitter;
                                if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) this.cursor.restore();
                                var args = [
                                    _emitter4.default.events.SELECTION_CHANGE,
                                    (0, _clone2.default)(this.lastRange),
                                    (0, _clone2.default)(oldRange),
                                    source
                                ];
                                (_emitter = this.emitter).emit.apply(_emitter, [
                                    _emitter4.default.events.EDITOR_CHANGE
                                ].concat(args));
                                if (source !== _emitter4.default.sources.SILENT) {
                                    var _emitter2;
                                    (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                                }
                            }
                        }
                    }
                ]);
                return Selection;
            }();
            function contains(parent, descendant) {
                try {
                    // Firefox inserts inaccessible nodes around video elements
                    descendant.parentNode;
                } catch (e) {
                    return false;
                }
                // IE11 has bug with Text nodes
                // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
                if (descendant instanceof Text) descendant = descendant.parentNode;
                return parent.contains(descendant);
            }
            exports.Range = Range;
            exports.default = Selection;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Break = function(_Parchment$Embed) {
                _inherits(Break, _Parchment$Embed);
                function Break() {
                    _classCallCheck(this, Break);
                    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
                }
                _createClass(Break, [
                    {
                        key: 'insertInto',
                        value: function insertInto(parent, ref) {
                            if (parent.children.length === 0) _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
                            else this.remove();
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            return 0;
                        }
                    },
                    {
                        key: 'value',
                        value: function value() {
                            return '';
                        }
                    }
                ], [
                    {
                        key: 'value',
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                return Break;
            }(_parchment2.default.Embed);
            Break.blotName = 'break';
            Break.tagName = 'BR';
            exports.default = Break;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var linked_list_1 = __webpack_require__(44);
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var ContainerBlot = /** @class */ function(_super) {
                __extends(ContainerBlot, _super);
                function ContainerBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.build();
                    return _this;
                }
                ContainerBlot.prototype.appendChild = function(other) {
                    this.insertBefore(other);
                };
                ContainerBlot.prototype.attach = function() {
                    _super.prototype.attach.call(this);
                    this.children.forEach(function(child) {
                        child.attach();
                    });
                };
                ContainerBlot.prototype.build = function() {
                    var _this = this;
                    this.children = new linked_list_1.default();
                    // Need to be reversed for if DOM nodes already in order
                    [].slice.call(this.domNode.childNodes).reverse().forEach(function(node) {
                        try {
                            var child = makeBlot(node);
                            _this.insertBefore(child, _this.children.head || undefined);
                        } catch (err) {
                            if (err instanceof Registry.ParchmentError) return;
                            else throw err;
                        }
                    });
                };
                ContainerBlot.prototype.deleteAt = function(index, length) {
                    if (index === 0 && length === this.length()) return this.remove();
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.deleteAt(offset, length);
                    });
                };
                ContainerBlot.prototype.descendant = function(criteria, index) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) return [
                        child,
                        offset
                    ];
                    else if (child instanceof ContainerBlot) return child.descendant(criteria, offset);
                    else return [
                        null,
                        -1
                    ];
                };
                ContainerBlot.prototype.descendants = function(criteria, index, length) {
                    if (index === void 0) index = 0;
                    if (length === void 0) length = Number.MAX_VALUE;
                    var descendants = [];
                    var lengthLeft = length;
                    this.children.forEachAt(index, length, function(child, index, length) {
                        if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) descendants.push(child);
                        if (child instanceof ContainerBlot) descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
                        lengthLeft -= length;
                    });
                    return descendants;
                };
                ContainerBlot.prototype.detach = function() {
                    this.children.forEach(function(child) {
                        child.detach();
                    });
                    _super.prototype.detach.call(this);
                };
                ContainerBlot.prototype.formatAt = function(index, length, name, value) {
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.formatAt(offset, length, name, value);
                    });
                };
                ContainerBlot.prototype.insertAt = function(index, value, def) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (child) child.insertAt(offset, value, def);
                    else {
                        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
                        this.appendChild(blot);
                    }
                };
                ContainerBlot.prototype.insertBefore = function(childBlot, refBlot) {
                    if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(child) {
                        return childBlot instanceof child;
                    })) throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
                    childBlot.insertInto(this, refBlot);
                };
                ContainerBlot.prototype.length = function() {
                    return this.children.reduce(function(memo, child) {
                        return memo + child.length();
                    }, 0);
                };
                ContainerBlot.prototype.moveChildren = function(targetParent, refNode) {
                    this.children.forEach(function(child) {
                        targetParent.insertBefore(child, refNode);
                    });
                };
                ContainerBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    if (this.children.length === 0) {
                        if (this.statics.defaultChild != null) {
                            var child = Registry.create(this.statics.defaultChild);
                            this.appendChild(child);
                            child.optimize(context);
                        } else this.remove();
                    }
                };
                ContainerBlot.prototype.path = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
                    var position = [
                        [
                            this,
                            index
                        ]
                    ];
                    if (child instanceof ContainerBlot) return position.concat(child.path(offset, inclusive));
                    else if (child != null) position.push([
                        child,
                        offset
                    ]);
                    return position;
                };
                ContainerBlot.prototype.removeChild = function(child) {
                    this.children.remove(child);
                };
                ContainerBlot.prototype.replace = function(target) {
                    if (target instanceof ContainerBlot) target.moveChildren(this);
                    _super.prototype.replace.call(this, target);
                };
                ContainerBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = this.clone();
                    this.parent.insertBefore(after, this.next);
                    this.children.forEachAt(index, this.length(), function(child, offset, length) {
                        child = child.split(offset, force);
                        after.appendChild(child);
                    });
                    return after;
                };
                ContainerBlot.prototype.unwrap = function() {
                    this.moveChildren(this.parent, this.next);
                    this.remove();
                };
                ContainerBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    var addedNodes = [];
                    var removedNodes = [];
                    mutations.forEach(function(mutation) {
                        if (mutation.target === _this.domNode && mutation.type === 'childList') {
                            addedNodes.push.apply(addedNodes, mutation.addedNodes);
                            removedNodes.push.apply(removedNodes, mutation.removedNodes);
                        }
                    });
                    removedNodes.forEach(function(node) {
                        // Check node has actually been removed
                        // One exception is Chrome does not immediately remove IFRAMEs
                        // from DOM but MutationRecord is correct in its reported removal
                        if (node.parentNode != null && // @ts-ignore
                        node.tagName !== 'IFRAME' && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
                        var blot = Registry.find(node);
                        if (blot == null) return;
                        if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) blot.detach();
                    });
                    addedNodes.filter(function(node) {
                        return node.parentNode == _this.domNode;
                    }).sort(function(a, b) {
                        if (a === b) return 0;
                        if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
                        return -1;
                    }).forEach(function(node) {
                        var refBlot = null;
                        if (node.nextSibling != null) refBlot = Registry.find(node.nextSibling);
                        var blot = makeBlot(node);
                        if (blot.next != refBlot || blot.next == null) {
                            if (blot.parent != null) blot.parent.removeChild(_this);
                            _this.insertBefore(blot, refBlot || undefined);
                        }
                    });
                };
                return ContainerBlot;
            }(shadow_1.default);
            function makeBlot(node) {
                var blot = Registry.find(node);
                if (blot == null) try {
                    blot = Registry.create(node);
                } catch (e) {
                    blot = Registry.create(Registry.Scope.INLINE);
                    [].slice.call(node.childNodes).forEach(function(child) {
                        // @ts-ignore
                        blot.domNode.appendChild(child);
                    });
                    if (node.parentNode) node.parentNode.replaceChild(blot.domNode, node);
                    blot.attach();
                }
                return blot;
            }
            exports.default = ContainerBlot;
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var store_1 = __webpack_require__(31);
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var FormatBlot = /** @class */ function(_super) {
                __extends(FormatBlot, _super);
                function FormatBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.attributes = new store_1.default(_this.domNode);
                    return _this;
                }
                FormatBlot.formats = function(domNode) {
                    if (typeof this.tagName === 'string') return true;
                    else if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
                    return undefined;
                };
                FormatBlot.prototype.format = function(name, value) {
                    var format = Registry.query(name);
                    if (format instanceof attributor_1.default) this.attributes.attribute(format, value);
                    else if (value) {
                        if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) this.replaceWith(name, value);
                    }
                };
                FormatBlot.prototype.formats = function() {
                    var formats = this.attributes.values();
                    var format = this.statics.formats(this.domNode);
                    if (format != null) formats[this.statics.blotName] = format;
                    return formats;
                };
                FormatBlot.prototype.replaceWith = function(name, value) {
                    var replacement = _super.prototype.replaceWith.call(this, name, value);
                    this.attributes.copy(replacement);
                    return replacement;
                };
                FormatBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    _super.prototype.update.call(this, mutations, context);
                    if (mutations.some(function(mutation) {
                        return mutation.target === _this.domNode && mutation.type === 'attributes';
                    })) this.attributes.build();
                };
                FormatBlot.prototype.wrap = function(name, value) {
                    var wrapper = _super.prototype.wrap.call(this, name, value);
                    if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) this.attributes.move(wrapper);
                    return wrapper;
                };
                return FormatBlot;
            }(container_1.default);
            exports.default = FormatBlot;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var LeafBlot = /** @class */ function(_super) {
                __extends(LeafBlot, _super);
                function LeafBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                LeafBlot.value = function(domNode) {
                    return true;
                };
                LeafBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return Math.min(offset, 1);
                    return -1;
                };
                LeafBlot.prototype.position = function(index, inclusive) {
                    var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                    if (index > 0) offset += 1;
                    return [
                        this.parent.domNode,
                        offset
                    ];
                };
                LeafBlot.prototype.value = function() {
                    var _a;
                    return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
                };
                LeafBlot.scope = Registry.Scope.INLINE_BLOT;
                return LeafBlot;
            }(shadow_1.default);
            exports.default = LeafBlot;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var lib = {
                attributes: {
                    compose: function compose(a, b, keepNull) {
                        if ((typeof a === "undefined" ? "undefined" : (0, $ewv1T._)(a)) !== 'object') a = {};
                        if ((typeof b === "undefined" ? "undefined" : (0, $ewv1T._)(b)) !== 'object') b = {};
                        var attributes = extend(true, {}, b);
                        if (!keepNull) attributes = Object.keys(attributes).reduce(function(copy, key) {
                            if (attributes[key] != null) copy[key] = attributes[key];
                            return copy;
                        }, {});
                        for(var key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    diff: function diff(a, b) {
                        if ((typeof a === "undefined" ? "undefined" : (0, $ewv1T._)(a)) !== 'object') a = {};
                        if ((typeof b === "undefined" ? "undefined" : (0, $ewv1T._)(b)) !== 'object') b = {};
                        var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function(attributes, key) {
                            if (!equal(a[key], b[key])) attributes[key] = b[key] === undefined ? null : b[key];
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    transform: function transform(a, b, priority) {
                        if ((typeof a === "undefined" ? "undefined" : (0, $ewv1T._)(a)) !== 'object') return b;
                        if ((typeof b === "undefined" ? "undefined" : (0, $ewv1T._)(b)) !== 'object') return undefined;
                        if (!priority) return b; // b simply overwrites us without priority
                        var attributes = Object.keys(b).reduce(function(attributes, key) {
                            if (a[key] === undefined) attributes[key] = b[key]; // null is a valid value
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    }
                },
                iterator: function iterator(ops) {
                    return new Iterator(ops);
                },
                length: function length(op) {
                    if (typeof op['delete'] === 'number') return op['delete'];
                    else if (typeof op.retain === 'number') return op.retain;
                    else return typeof op.insert === 'string' ? op.insert.length : 1;
                }
            };
            function Iterator(ops) {
                this.ops = ops;
                this.index = 0;
                this.offset = 0;
            }
            Iterator.prototype.hasNext = function() {
                return this.peekLength() < Infinity;
            };
            Iterator.prototype.next = function(length) {
                if (!length) length = Infinity;
                var nextOp = this.ops[this.index];
                if (nextOp) {
                    var offset = this.offset;
                    var opLength = lib.length(nextOp);
                    if (length >= opLength - offset) {
                        length = opLength - offset;
                        this.index += 1;
                        this.offset = 0;
                    } else this.offset += length;
                    if (typeof nextOp['delete'] === 'number') return {
                        'delete': length
                    };
                    else {
                        var retOp = {};
                        if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                        if (typeof nextOp.retain === 'number') retOp.retain = length;
                        else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                        else // offset should === 0, length should === 1
                        retOp.insert = nextOp.insert;
                        return retOp;
                    }
                } else return {
                    retain: Infinity
                };
            };
            Iterator.prototype.peek = function() {
                return this.ops[this.index];
            };
            Iterator.prototype.peekLength = function() {
                if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
                return lib.length(this.ops[this.index]) - this.offset;
                else return Infinity;
            };
            Iterator.prototype.peekType = function() {
                if (this.ops[this.index]) {
                    if (typeof this.ops[this.index]['delete'] === 'number') return 'delete';
                    else if (typeof this.ops[this.index].retain === 'number') return 'retain';
                    else return 'insert';
                }
                return 'retain';
            };
            Iterator.prototype.rest = function() {
                if (!this.hasNext()) return [];
                else if (this.offset === 0) return this.ops.slice(this.index);
                else {
                    var offset = this.offset;
                    var index = this.index;
                    var next = this.next();
                    var rest = this.ops.slice(this.index);
                    this.offset = offset;
                    this.index = index;
                    return [
                        next
                    ].concat(rest);
                }
            };
            module1.exports = lib;
        /***/ },
        /* 21 */ /***/ function(module1, exports) {
            var clone = function() {
                'use strict';
                function _instanceof(obj, type) {
                    return type != null && obj instanceof type;
                }
                var nativeMap;
                try {
                    nativeMap = Map;
                } catch (_) {
                    // maybe a reference error because no `Map`. Give it a dummy value that no
                    // value will ever be an instanceof.
                    nativeMap = function nativeMap() {};
                }
                var nativeSet;
                try {
                    nativeSet = Set;
                } catch (_) {
                    nativeSet = function nativeSet() {};
                }
                var nativePromise;
                try {
                    nativePromise = Promise;
                } catch (_) {
                    nativePromise = function nativePromise() {};
                }
                /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
                    if ((typeof circular === "undefined" ? "undefined" : (0, $ewv1T._)(circular)) === 'object') {
                        depth = circular.depth;
                        prototype = circular.prototype;
                        includeNonEnumerable = circular.includeNonEnumerable;
                        circular = circular.circular;
                    }
                    // maintain two arrays for circular references, where corresponding parents
                    // and children have the same index
                    var allParents = [];
                    var allChildren = [];
                    var useBuffer = typeof $852297f7037c6a27$require$Buffer != 'undefined';
                    if (typeof circular == 'undefined') circular = true;
                    if (typeof depth == 'undefined') depth = Infinity;
                    // recurse this function so we don't reset allParents and allChildren
                    function _clone(parent, depth) {
                        // cloning null always returns null
                        if (parent === null) return null;
                        if (depth === 0) return parent;
                        var child;
                        var proto;
                        if ((typeof parent === "undefined" ? "undefined" : (0, $ewv1T._)(parent)) != 'object') return parent;
                        if (_instanceof(parent, nativeMap)) child = new nativeMap();
                        else if (_instanceof(parent, nativeSet)) child = new nativeSet();
                        else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                            parent.then(function(value) {
                                resolve(_clone(value, depth - 1));
                            }, function(err) {
                                reject(_clone(err, depth - 1));
                            });
                        });
                        else if (clone.__isArray(parent)) child = [];
                        else if (clone.__isRegExp(parent)) {
                            child = new RegExp(parent.source, __getRegExpFlags(parent));
                            if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                        } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                        else if (useBuffer && $852297f7037c6a27$require$Buffer.isBuffer(parent)) {
                            if ($852297f7037c6a27$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                            child = $852297f7037c6a27$require$Buffer.allocUnsafe(parent.length);
                            else // Older Node.js versions
                            child = new $852297f7037c6a27$require$Buffer(parent.length);
                            parent.copy(child);
                            return child;
                        } else if (_instanceof(parent, Error)) child = Object.create(parent);
                        else if (typeof prototype == 'undefined') {
                            proto = Object.getPrototypeOf(parent);
                            child = Object.create(proto);
                        } else {
                            child = Object.create(prototype);
                            proto = prototype;
                        }
                        if (circular) {
                            var index = allParents.indexOf(parent);
                            if (index != -1) return allChildren[index];
                            allParents.push(parent);
                            allChildren.push(child);
                        }
                        if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                            var keyChild = _clone(key, depth - 1);
                            var valueChild = _clone(value, depth - 1);
                            child.set(keyChild, valueChild);
                        });
                        if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                            var entryChild = _clone(value, depth - 1);
                            child.add(entryChild);
                        });
                        for(var i in parent){
                            var attrs;
                            if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                            if (attrs && attrs.set == null) continue;
                            child[i] = _clone(parent[i], depth - 1);
                        }
                        if (Object.getOwnPropertySymbols) {
                            var symbols = Object.getOwnPropertySymbols(parent);
                            for(var i = 0; i < symbols.length; i++){
                                // Don't need to worry about cloning a symbol because it is a primitive,
                                // like a number or string.
                                var symbol = symbols[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                                child[symbol] = _clone(parent[symbol], depth - 1);
                                if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                                    enumerable: false
                                });
                            }
                        }
                        if (includeNonEnumerable) {
                            var allPropertyNames = Object.getOwnPropertyNames(parent);
                            for(var i = 0; i < allPropertyNames.length; i++){
                                var propertyName = allPropertyNames[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                                if (descriptor && descriptor.enumerable) continue;
                                child[propertyName] = _clone(parent[propertyName], depth - 1);
                                Object.defineProperty(child, propertyName, {
                                    enumerable: false
                                });
                            }
                        }
                        return child;
                    }
                    return _clone(parent, depth);
                }
                /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
                    if (parent === null) return null;
                    var c = function c() {};
                    c.prototype = parent;
                    return new c();
                };
                // private utility functions
                function __objToStr(o) {
                    return Object.prototype.toString.call(o);
                }
                clone.__objToStr = __objToStr;
                function __isDate(o) {
                    return (typeof o === "undefined" ? "undefined" : (0, $ewv1T._)(o)) === 'object' && __objToStr(o) === '[object Date]';
                }
                clone.__isDate = __isDate;
                function __isArray(o) {
                    return (typeof o === "undefined" ? "undefined" : (0, $ewv1T._)(o)) === 'object' && __objToStr(o) === '[object Array]';
                }
                clone.__isArray = __isArray;
                function __isRegExp(o) {
                    return (typeof o === "undefined" ? "undefined" : (0, $ewv1T._)(o)) === 'object' && __objToStr(o) === '[object RegExp]';
                }
                clone.__isRegExp = __isRegExp;
                function __getRegExpFlags(re) {
                    var flags = '';
                    if (re.global) flags += 'g';
                    if (re.ignoreCase) flags += 'i';
                    if (re.multiline) flags += 'm';
                    return flags;
                }
                clone.__getRegExpFlags = __getRegExpFlags;
                return clone;
            }();
            if ((typeof module1 === "undefined" ? "undefined" : (0, $ewv1T._)(module1)) === 'object' && module1.exports) module1.exports = clone;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            function isLine(blot) {
                return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
            }
            var Scroll = function(_Parchment$Scroll) {
                _inherits(Scroll, _Parchment$Scroll);
                function Scroll(domNode, config) {
                    _classCallCheck(this, Scroll);
                    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
                    _this.emitter = config.emitter;
                    if (Array.isArray(config.whitelist)) _this.whitelist = config.whitelist.reduce(function(whitelist, format) {
                        whitelist[format] = true;
                        return whitelist;
                    }, {});
                    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
                    _this.domNode.addEventListener('DOMNodeInserted', function() {});
                    _this.optimize();
                    _this.enable();
                    return _this;
                }
                _createClass(Scroll, [
                    {
                        key: 'batchStart',
                        value: function batchStart() {
                            this.batch = true;
                        }
                    },
                    {
                        key: 'batchEnd',
                        value: function batchEnd() {
                            this.batch = false;
                            this.optimize();
                        }
                    },
                    {
                        key: 'deleteAt',
                        value: function deleteAt(index, length) {
                            var _line = this.line(index), _line2 = _slicedToArray(_line, 2), first = _line2[0], offset = _line2[1];
                            var _line3 = this.line(index + length), _line4 = _slicedToArray(_line3, 1), last = _line4[0];
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
                            if (last != null && first !== last && offset > 0) {
                                if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                                    this.optimize();
                                    return;
                                }
                                if (first instanceof _code2.default) {
                                    var newlineIndex = first.newlineIndex(first.length(), true);
                                    if (newlineIndex > -1) {
                                        first = first.split(newlineIndex + 1);
                                        if (first === last) {
                                            this.optimize();
                                            return;
                                        }
                                    }
                                } else if (last instanceof _code2.default) {
                                    var _newlineIndex = last.newlineIndex(0);
                                    if (_newlineIndex > -1) last.split(_newlineIndex + 1);
                                }
                                var ref = last.children.head instanceof _break2.default ? null : last.children.head;
                                first.moveChildren(last, ref);
                                first.remove();
                            }
                            this.optimize();
                        }
                    },
                    {
                        key: 'enable',
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.domNode.setAttribute('contenteditable', enabled);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, format, value) {
                            if (this.whitelist != null && !this.whitelist[format]) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
                            this.optimize();
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null && this.whitelist != null && !this.whitelist[value]) return;
                            if (index >= this.length()) {
                                if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                                    var blot = _parchment2.default.create(this.statics.defaultChild);
                                    this.appendChild(blot);
                                    if (def == null && value.endsWith('\n')) value = value.slice(0, -1);
                                    blot.insertAt(0, value, def);
                                } else {
                                    var embed = _parchment2.default.create(value, def);
                                    this.appendChild(embed);
                                }
                            } else _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
                            this.optimize();
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
                                var wrapper = _parchment2.default.create(this.statics.defaultChild);
                                wrapper.appendChild(blot);
                                blot = wrapper;
                            }
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
                        }
                    },
                    {
                        key: 'leaf',
                        value: function leaf(index) {
                            return this.path(index).pop() || [
                                null,
                                -1
                            ];
                        }
                    },
                    {
                        key: 'line',
                        value: function line(index) {
                            if (index === this.length()) return this.line(index - 1);
                            return this.descendant(isLine, index);
                        }
                    },
                    {
                        key: 'lines',
                        value: function lines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            var getLines = function getLines(blot, index, length) {
                                var lines = [], lengthLeft = length;
                                blot.children.forEachAt(index, length, function(child, index, length) {
                                    if (isLine(child)) lines.push(child);
                                    else if (child instanceof _parchment2.default.Container) lines = lines.concat(getLines(child, index, lengthLeft));
                                    lengthLeft -= length;
                                });
                                return lines;
                            };
                            return getLines(this, index, length);
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize() {
                            var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            if (this.batch === true) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
                        }
                    },
                    {
                        key: 'path',
                        value: function path(index) {
                            return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations) {
                            if (this.batch === true) return;
                            var source = _emitter2.default.sources.USER;
                            if (typeof mutations === 'string') source = mutations;
                            if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
                        }
                    }
                ]);
                return Scroll;
            }(_parchment2.default.Scroll);
            Scroll.blotName = 'scroll';
            Scroll.className = 'ql-editor';
            Scroll.tagName = 'DIV';
            Scroll.defaultChild = 'block';
            Scroll.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                _container2.default
            ];
            exports.default = Scroll;
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SHORTKEY = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && (0, $ewv1T._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
                return typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:keyboard');
            var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
            var Keyboard = function(_Module) {
                _inherits(Keyboard, _Module);
                _createClass(Keyboard, null, [
                    {
                        key: 'match',
                        value: function match(evt, binding) {
                            binding = normalize(binding);
                            if ([
                                'altKey',
                                'ctrlKey',
                                'metaKey',
                                'shiftKey'
                            ].some(function(key) {
                                return !!binding[key] !== evt[key] && binding[key] !== null;
                            })) return false;
                            return binding.key === (evt.which || evt.keyCode);
                        }
                    }
                ]);
                function Keyboard(quill, options) {
                    _classCallCheck(this, Keyboard);
                    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
                    _this.bindings = {};
                    Object.keys(_this.options.bindings).forEach(function(name) {
                        if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) return;
                        if (_this.options.bindings[name]) _this.addBinding(_this.options.bindings[name]);
                    });
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        shiftKey: null
                    }, handleEnter);
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null
                    }, function() {});
                    if (/Firefox/i.test(navigator.userAgent)) {
                        // Need to handle delete and backspace for Firefox in the general case #1171
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true
                        }, handleDelete);
                    } else {
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true,
                            prefix: /^.?$/
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true,
                            suffix: /^.?$/
                        }, handleDelete);
                    }
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.DELETE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE,
                        altKey: null,
                        ctrlKey: null,
                        metaKey: null,
                        shiftKey: null
                    }, {
                        collapsed: true,
                        offset: 0
                    }, handleBackspace);
                    _this.listen();
                    return _this;
                }
                _createClass(Keyboard, [
                    {
                        key: 'addBinding',
                        value: function addBinding(key) {
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            var binding = normalize(key);
                            if (binding == null || binding.key == null) return debug.warn('Attempted to add invalid keyboard binding', binding);
                            if (typeof context === 'function') context = {
                                handler: context
                            };
                            if (typeof handler === 'function') handler = {
                                handler: handler
                            };
                            binding = (0, _extend2.default)(binding, context, handler);
                            this.bindings[binding.key] = this.bindings[binding.key] || [];
                            this.bindings[binding.key].push(binding);
                        }
                    },
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this2 = this;
                            this.quill.root.addEventListener('keydown', function(evt) {
                                if (evt.defaultPrevented) return;
                                var which = evt.which || evt.keyCode;
                                var bindings = (_this2.bindings[which] || []).filter(function(binding) {
                                    return Keyboard.match(evt, binding);
                                });
                                if (bindings.length === 0) return;
                                var range = _this2.quill.getSelection();
                                if (range == null || !_this2.quill.hasFocus()) return;
                                var _quill$getLine = _this2.quill.getLine(range.index), _quill$getLine2 = _slicedToArray(_quill$getLine, 2), line = _quill$getLine2[0], offset = _quill$getLine2[1];
                                var _quill$getLeaf = _this2.quill.getLeaf(range.index), _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2), leafStart = _quill$getLeaf2[0], offsetStart = _quill$getLeaf2[1];
                                var _ref = range.length === 0 ? [
                                    leafStart,
                                    offsetStart
                                ] : _this2.quill.getLeaf(range.index + range.length), _ref2 = _slicedToArray(_ref, 2), leafEnd = _ref2[0], offsetEnd = _ref2[1];
                                var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
                                var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
                                var curContext = {
                                    collapsed: range.length === 0,
                                    empty: range.length === 0 && line.length() <= 1,
                                    format: _this2.quill.getFormat(range),
                                    offset: offset,
                                    prefix: prefixText,
                                    suffix: suffixText
                                };
                                var prevented = bindings.some(function(binding) {
                                    if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                                    if (binding.empty != null && binding.empty !== curContext.empty) return false;
                                    if (binding.offset != null && binding.offset !== curContext.offset) return false;
                                    if (Array.isArray(binding.format)) {
                                        // any format is present
                                        if (binding.format.every(function(name) {
                                            return curContext.format[name] == null;
                                        })) return false;
                                    } else if (_typeof(binding.format) === 'object') {
                                        // all formats must match
                                        if (!Object.keys(binding.format).every(function(name) {
                                            if (binding.format[name] === true) return curContext.format[name] != null;
                                            if (binding.format[name] === false) return curContext.format[name] == null;
                                            return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                                        })) return false;
                                    }
                                    if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                                    if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                                    return binding.handler.call(_this2, range, curContext) !== true;
                                });
                                if (prevented) evt.preventDefault();
                            });
                        }
                    }
                ]);
                return Keyboard;
            }(_module2.default);
            Keyboard.keys = {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                ESCAPE: 27,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                DELETE: 46
            };
            Keyboard.DEFAULTS = {
                bindings: {
                    'bold': makeFormatHandler('bold'),
                    'italic': makeFormatHandler('italic'),
                    'underline': makeFormatHandler('underline'),
                    'indent': {
                        // highlight tab or tab at beginning of list, indent or blockquote
                        key: Keyboard.keys.TAB,
                        format: [
                            'blockquote',
                            'indent',
                            'list'
                        ],
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format('indent', '+1', _quill2.default.sources.USER);
                        }
                    },
                    'outdent': {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        format: [
                            'blockquote',
                            'indent',
                            'list'
                        ],
                        // highlight tab or tab at beginning of list, indent or blockquote
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format('indent', '-1', _quill2.default.sources.USER);
                        }
                    },
                    'outdent backspace': {
                        key: Keyboard.keys.BACKSPACE,
                        collapsed: true,
                        shiftKey: null,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null,
                        format: [
                            'indent',
                            'list'
                        ],
                        offset: 0,
                        handler: function handler(range, context) {
                            if (context.format.indent != null) this.quill.format('indent', '-1', _quill2.default.sources.USER);
                            else if (context.format.list != null) this.quill.format('list', false, _quill2.default.sources.USER);
                        }
                    },
                    'indent code-block': makeCodeBlockHandler(true),
                    'outdent code-block': makeCodeBlockHandler(false),
                    'remove tab': {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        collapsed: true,
                        prefix: /\t$/,
                        handler: function handler(range) {
                            this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
                        }
                    },
                    'tab': {
                        key: Keyboard.keys.TAB,
                        handler: function handler(range) {
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                        }
                    },
                    'list empty enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'list'
                        ],
                        empty: true,
                        handler: function handler(range, context) {
                            this.quill.format('list', false, _quill2.default.sources.USER);
                            if (context.format.indent) this.quill.format('indent', false, _quill2.default.sources.USER);
                        }
                    },
                    'checklist enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: {
                            list: 'checked'
                        },
                        handler: function handler(range) {
                            var _quill$getLine3 = this.quill.getLine(range.index), _quill$getLine4 = _slicedToArray(_quill$getLine3, 2), line = _quill$getLine4[0], offset = _quill$getLine4[1];
                            var formats = (0, _extend2.default)({}, line.formats(), {
                                list: 'checked'
                            });
                            var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, {
                                list: 'unchecked'
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    'header enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'header'
                        ],
                        suffix: /^$/,
                        handler: function handler(range, context) {
                            var _quill$getLine5 = this.quill.getLine(range.index), _quill$getLine6 = _slicedToArray(_quill$getLine5, 2), line = _quill$getLine6[0], offset = _quill$getLine6[1];
                            var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, {
                                header: null
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    'list autofill': {
                        key: ' ',
                        collapsed: true,
                        format: {
                            list: false
                        },
                        prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                        handler: function handler(range, context) {
                            var length = context.prefix.length;
                            var _quill$getLine7 = this.quill.getLine(range.index), _quill$getLine8 = _slicedToArray(_quill$getLine7, 2), line = _quill$getLine8[0], offset = _quill$getLine8[1];
                            if (offset > length) return true;
                            var value = void 0;
                            switch(context.prefix.trim()){
                                case '[]':
                                case '[ ]':
                                    value = 'unchecked';
                                    break;
                                case '[x]':
                                    value = 'checked';
                                    break;
                                case '-':
                                case '*':
                                    value = 'bullet';
                                    break;
                                default:
                                    value = 'ordered';
                            }
                            this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, {
                                list: value
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
                        }
                    },
                    'code exit': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'code-block'
                        ],
                        prefix: /\n\n$/,
                        suffix: /^\s+$/,
                        handler: function handler(range) {
                            var _quill$getLine9 = this.quill.getLine(range.index), _quill$getLine10 = _slicedToArray(_quill$getLine9, 2), line = _quill$getLine10[0], offset = _quill$getLine10[1];
                            var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, {
                                'code-block': null
                            }).delete(1);
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                        }
                    },
                    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
                    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
                    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
                    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
                }
            };
            function makeEmbedArrowHandler(key, shiftKey) {
                var _ref3;
                var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
                return _ref3 = {
                    key: key,
                    shiftKey: shiftKey,
                    altKey: null
                }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
                    var index = range.index;
                    if (key === Keyboard.keys.RIGHT) index += range.length + 1;
                    var _quill$getLeaf3 = this.quill.getLeaf(index), _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1), leaf = _quill$getLeaf4[0];
                    if (!(leaf instanceof _parchment2.default.Embed)) return true;
                    if (key === Keyboard.keys.LEFT) {
                        if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
                        else this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
                    } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
                    else this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
                    return false;
                }), _ref3;
            }
            function handleBackspace(range, context) {
                if (range.index === 0 || this.quill.getLength() <= 1) return;
                var _quill$getLine11 = this.quill.getLine(range.index), _quill$getLine12 = _slicedToArray(_quill$getLine11, 1), line = _quill$getLine12[0];
                var formats = {};
                if (context.offset === 0) {
                    var _quill$getLine13 = this.quill.getLine(range.index - 1), _quill$getLine14 = _slicedToArray(_quill$getLine13, 1), prev = _quill$getLine14[0];
                    if (prev != null && prev.length() > 1) {
                        var curFormats = line.formats();
                        var prevFormats = this.quill.getFormat(range.index - 1, 1);
                        formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
                    }
                }
                // Check for astral symbols
                var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
                this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
                this.quill.focus();
            }
            function handleDelete(range, context) {
                // Check for astral symbols
                var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
                if (range.index >= this.quill.getLength() - length) return;
                var formats = {}, nextLength = 0;
                var _quill$getLine15 = this.quill.getLine(range.index), _quill$getLine16 = _slicedToArray(_quill$getLine15, 1), line = _quill$getLine16[0];
                if (context.offset >= line.length() - 1) {
                    var _quill$getLine17 = this.quill.getLine(range.index + 1), _quill$getLine18 = _slicedToArray(_quill$getLine17, 1), next = _quill$getLine18[0];
                    if (next) {
                        var curFormats = line.formats();
                        var nextFormats = this.quill.getFormat(range.index, 1);
                        formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
                        nextLength = next.length();
                    }
                }
                this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
            }
            function handleDeleteRange(range) {
                var lines = this.quill.getLines(range);
                var formats = {};
                if (lines.length > 1) {
                    var firstFormats = lines[0].formats();
                    var lastFormats = lines[lines.length - 1].formats();
                    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
                }
                this.quill.deleteText(range, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
                this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
                this.quill.focus();
            }
            function handleEnter(range, context) {
                var _this3 = this;
                if (range.length > 0) this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
                var lineFormats = Object.keys(context.format).reduce(function(lineFormats, format) {
                    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) lineFormats[format] = context.format[format];
                    return lineFormats;
                }, {});
                this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
                // Earlier scroll.deleteAt might have messed up our selection,
                // so insertText's built in selection preservation is not reliable
                this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                this.quill.focus();
                Object.keys(context.format).forEach(function(name) {
                    if (lineFormats[name] != null) return;
                    if (Array.isArray(context.format[name])) return;
                    if (name === 'link') return;
                    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
                });
            }
            function makeCodeBlockHandler(indent) {
                return {
                    key: Keyboard.keys.TAB,
                    shiftKey: !indent,
                    format: {
                        'code-block': true
                    },
                    handler: function handler(range) {
                        var CodeBlock = _parchment2.default.query('code-block');
                        var index = range.index, length = range.length;
                        var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), block = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                        if (block == null) return;
                        var scrollIndex = this.quill.getIndex(block);
                        var start = block.newlineIndex(offset, true) + 1;
                        var end = block.newlineIndex(scrollIndex + offset + length);
                        var lines = block.domNode.textContent.slice(start, end).split('\n');
                        offset = 0;
                        lines.forEach(function(line, i) {
                            if (indent) {
                                block.insertAt(start + offset, CodeBlock.TAB);
                                offset += CodeBlock.TAB.length;
                                if (i === 0) index += CodeBlock.TAB.length;
                                else length += CodeBlock.TAB.length;
                            } else if (line.startsWith(CodeBlock.TAB)) {
                                block.deleteAt(start + offset, CodeBlock.TAB.length);
                                offset -= CodeBlock.TAB.length;
                                if (i === 0) index -= CodeBlock.TAB.length;
                                else length -= CodeBlock.TAB.length;
                            }
                            offset += line.length + 1;
                        });
                        this.quill.update(_quill2.default.sources.USER);
                        this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
                    }
                };
            }
            function makeFormatHandler(format) {
                return {
                    key: format[0].toUpperCase(),
                    shortKey: true,
                    handler: function handler(range, context) {
                        this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
                    }
                };
            }
            function normalize(binding) {
                if (typeof binding === 'string' || typeof binding === 'number') return normalize({
                    key: binding
                });
                if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') binding = (0, _clone2.default)(binding, false);
                if (typeof binding.key === 'string') {
                    if (Keyboard.keys[binding.key.toUpperCase()] != null) binding.key = Keyboard.keys[binding.key.toUpperCase()];
                    else if (binding.key.length === 1) binding.key = binding.key.toUpperCase().charCodeAt(0);
                    else return null;
                }
                if (binding.shortKey) {
                    binding[SHORTKEY] = binding.shortKey;
                    delete binding.shortKey;
                }
                return binding;
            }
            exports.default = Keyboard;
            exports.SHORTKEY = SHORTKEY;
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Cursor = function(_Parchment$Embed) {
                _inherits(Cursor, _Parchment$Embed);
                _createClass(Cursor, null, [
                    {
                        key: 'value',
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                function Cursor(domNode, selection) {
                    _classCallCheck(this, Cursor);
                    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
                    _this.selection = selection;
                    _this.textNode = document.createTextNode(Cursor.CONTENTS);
                    _this.domNode.appendChild(_this.textNode);
                    _this._length = 0;
                    return _this;
                }
                _createClass(Cursor, [
                    {
                        key: 'detach',
                        value: function detach() {
                            // super.detach() will also clear domNode.__blot
                            if (this.parent != null) this.parent.removeChild(this);
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (this._length !== 0) return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
                            var target = this, index = 0;
                            while(target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT){
                                index += target.offset(target.parent);
                                target = target.parent;
                            }
                            if (target != null) {
                                this._length = Cursor.CONTENTS.length;
                                target.optimize();
                                target.formatAt(index, Cursor.CONTENTS.length, name, value);
                                this._length = 0;
                            }
                        }
                    },
                    {
                        key: 'index',
                        value: function index(node, offset) {
                            if (node === this.textNode) return 0;
                            return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            return this._length;
                        }
                    },
                    {
                        key: 'position',
                        value: function position() {
                            return [
                                this.textNode,
                                this.textNode.data.length
                            ];
                        }
                    },
                    {
                        key: 'remove',
                        value: function remove() {
                            _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
                            this.parent = null;
                        }
                    },
                    {
                        key: 'restore',
                        value: function restore() {
                            if (this.selection.composing || this.parent == null) return;
                            var textNode = this.textNode;
                            var range = this.selection.getNativeRange();
                            var restoreText = void 0, start = void 0, end = void 0;
                            if (range != null && range.start.node === textNode && range.end.node === textNode) {
                                var _ref = [
                                    textNode,
                                    range.start.offset,
                                    range.end.offset
                                ];
                                restoreText = _ref[0];
                                start = _ref[1];
                                end = _ref[2];
                            }
                            // Link format will insert text outside of anchor tag
                            while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                            if (this.textNode.data !== Cursor.CONTENTS) {
                                var text = this.textNode.data.split(Cursor.CONTENTS).join('');
                                if (this.next instanceof _text2.default) {
                                    restoreText = this.next.domNode;
                                    this.next.insertAt(0, text);
                                    this.textNode.data = Cursor.CONTENTS;
                                } else {
                                    this.textNode.data = text;
                                    this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                                    this.textNode = document.createTextNode(Cursor.CONTENTS);
                                    this.domNode.appendChild(this.textNode);
                                }
                            }
                            this.remove();
                            if (start != null) {
                                var _map = [
                                    start,
                                    end
                                ].map(function(offset) {
                                    return Math.max(0, Math.min(restoreText.data.length, offset - 1));
                                });
                                var _map2 = _slicedToArray(_map, 2);
                                start = _map2[0];
                                end = _map2[1];
                                return {
                                    startNode: restoreText,
                                    startOffset: start,
                                    endNode: restoreText,
                                    endOffset: end
                                };
                            }
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations, context) {
                            var _this2 = this;
                            if (mutations.some(function(mutation) {
                                return mutation.type === 'characterData' && mutation.target === _this2.textNode;
                            })) {
                                var range = this.restore();
                                if (range) context.range = range;
                            }
                        }
                    },
                    {
                        key: 'value',
                        value: function value() {
                            return '';
                        }
                    }
                ]);
                return Cursor;
            }(_parchment2.default.Embed);
            Cursor.blotName = 'cursor';
            Cursor.className = 'ql-cursor';
            Cursor.tagName = 'span';
            Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
            exports.default = Cursor;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Container = function(_Parchment$Container) {
                _inherits(Container, _Parchment$Container);
                function Container() {
                    _classCallCheck(this, Container);
                    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
                }
                return Container;
            }(_parchment2.default.Container);
            Container.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                Container
            ];
            exports.default = Container;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorAttributor = function(_Parchment$Attributor) {
                _inherits(ColorAttributor, _Parchment$Attributor);
                function ColorAttributor() {
                    _classCallCheck(this, ColorAttributor);
                    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
                }
                _createClass(ColorAttributor, [
                    {
                        key: 'value',
                        value: function value(domNode) {
                            var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
                            if (!value.startsWith('rgb(')) return value;
                            value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
                            return '#' + value.split(',').map(function(component) {
                                return ('00' + parseInt(component).toString(16)).slice(-2);
                            }).join('');
                        }
                    }
                ]);
                return ColorAttributor;
            }(_parchment2.default.Attributor.Style);
            var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
                scope: _parchment2.default.Scope.INLINE
            });
            var ColorStyle = new ColorAttributor('color', 'color', {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.ColorAttributor = ColorAttributor;
            exports.ColorClass = ColorClass;
            exports.ColorStyle = ColorStyle;
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.sanitize = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Link = function(_Inline) {
                _inherits(Link, _Inline);
                function Link() {
                    _classCallCheck(this, Link);
                    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
                }
                _createClass(Link, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
                            value = this.constructor.sanitize(value);
                            this.domNode.setAttribute('href', value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
                            value = this.sanitize(value);
                            node.setAttribute('href', value);
                            node.setAttribute('rel', 'noopener noreferrer');
                            node.setAttribute('target', '_blank');
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return domNode.getAttribute('href');
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
                        }
                    }
                ]);
                return Link;
            }(_inline2.default);
            Link.blotName = 'link';
            Link.tagName = 'A';
            Link.SANITIZED_URL = 'about:blank';
            Link.PROTOCOL_WHITELIST = [
                'http',
                'https',
                'mailto',
                'tel'
            ];
            function _sanitize(url, protocols) {
                var anchor = document.createElement('a');
                anchor.href = url;
                var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
                return protocols.indexOf(protocol) > -1;
            }
            exports.default = Link;
            exports.sanitize = _sanitize;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && (0, $ewv1T._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
                return typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _dropdown = __webpack_require__(107);
            var _dropdown2 = _interopRequireDefault(_dropdown);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var optionsCounter = 0;
            function toggleAriaAttribute(element, attribute) {
                element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
            }
            var Picker = function() {
                function Picker(select) {
                    var _this = this;
                    _classCallCheck(this, Picker);
                    this.select = select;
                    this.container = document.createElement('span');
                    this.buildPicker();
                    this.select.style.display = 'none';
                    this.select.parentNode.insertBefore(this.container, this.select);
                    this.label.addEventListener('mousedown', function() {
                        _this.togglePicker();
                    });
                    this.label.addEventListener('keydown', function(event) {
                        switch(event.keyCode){
                            // Allows the "Enter" key to open the picker
                            case _keyboard2.default.keys.ENTER:
                                _this.togglePicker();
                                break;
                            // Allows the "Escape" key to close the picker
                            case _keyboard2.default.keys.ESCAPE:
                                _this.escape();
                                event.preventDefault();
                                break;
                            default:
                        }
                    });
                    this.select.addEventListener('change', this.update.bind(this));
                }
                _createClass(Picker, [
                    {
                        key: 'togglePicker',
                        value: function togglePicker() {
                            this.container.classList.toggle('ql-expanded');
                            // Toggle aria-expanded and aria-hidden to make the picker accessible
                            toggleAriaAttribute(this.label, 'aria-expanded');
                            toggleAriaAttribute(this.options, 'aria-hidden');
                        }
                    },
                    {
                        key: 'buildItem',
                        value: function buildItem(option) {
                            var _this2 = this;
                            var item = document.createElement('span');
                            item.tabIndex = '0';
                            item.setAttribute('role', 'button');
                            item.classList.add('ql-picker-item');
                            if (option.hasAttribute('value')) item.setAttribute('data-value', option.getAttribute('value'));
                            if (option.textContent) item.setAttribute('data-label', option.textContent);
                            item.addEventListener('click', function() {
                                _this2.selectItem(item, true);
                            });
                            item.addEventListener('keydown', function(event) {
                                switch(event.keyCode){
                                    // Allows the "Enter" key to select an item
                                    case _keyboard2.default.keys.ENTER:
                                        _this2.selectItem(item, true);
                                        event.preventDefault();
                                        break;
                                    // Allows the "Escape" key to close the picker
                                    case _keyboard2.default.keys.ESCAPE:
                                        _this2.escape();
                                        event.preventDefault();
                                        break;
                                    default:
                                }
                            });
                            return item;
                        }
                    },
                    {
                        key: 'buildLabel',
                        value: function buildLabel() {
                            var label = document.createElement('span');
                            label.classList.add('ql-picker-label');
                            label.innerHTML = _dropdown2.default;
                            label.tabIndex = '0';
                            label.setAttribute('role', 'button');
                            label.setAttribute('aria-expanded', 'false');
                            this.container.appendChild(label);
                            return label;
                        }
                    },
                    {
                        key: 'buildOptions',
                        value: function buildOptions() {
                            var _this3 = this;
                            var options = document.createElement('span');
                            options.classList.add('ql-picker-options');
                            // Don't want screen readers to read this until options are visible
                            options.setAttribute('aria-hidden', 'true');
                            options.tabIndex = '-1';
                            // Need a unique id for aria-controls
                            options.id = 'ql-picker-options-' + optionsCounter;
                            optionsCounter += 1;
                            this.label.setAttribute('aria-controls', options.id);
                            this.options = options;
                            [].slice.call(this.select.options).forEach(function(option) {
                                var item = _this3.buildItem(option);
                                options.appendChild(item);
                                if (option.selected === true) _this3.selectItem(item);
                            });
                            this.container.appendChild(options);
                        }
                    },
                    {
                        key: 'buildPicker',
                        value: function buildPicker() {
                            var _this4 = this;
                            [].slice.call(this.select.attributes).forEach(function(item) {
                                _this4.container.setAttribute(item.name, item.value);
                            });
                            this.container.classList.add('ql-picker');
                            this.label = this.buildLabel();
                            this.buildOptions();
                        }
                    },
                    {
                        key: 'escape',
                        value: function escape() {
                            var _this5 = this;
                            // Close menu and return focus to trigger label
                            this.close();
                            // Need setTimeout for accessibility to ensure that the browser executes
                            // focus on the next process thread and after any DOM content changes
                            setTimeout(function() {
                                return _this5.label.focus();
                            }, 1);
                        }
                    },
                    {
                        key: 'close',
                        value: function close() {
                            this.container.classList.remove('ql-expanded');
                            this.label.setAttribute('aria-expanded', 'false');
                            this.options.setAttribute('aria-hidden', 'true');
                        }
                    },
                    {
                        key: 'selectItem',
                        value: function selectItem(item) {
                            var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var selected = this.container.querySelector('.ql-selected');
                            if (item === selected) return;
                            if (selected != null) selected.classList.remove('ql-selected');
                            if (item == null) return;
                            item.classList.add('ql-selected');
                            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
                            if (item.hasAttribute('data-value')) this.label.setAttribute('data-value', item.getAttribute('data-value'));
                            else this.label.removeAttribute('data-value');
                            if (item.hasAttribute('data-label')) this.label.setAttribute('data-label', item.getAttribute('data-label'));
                            else this.label.removeAttribute('data-label');
                            if (trigger) {
                                if (typeof Event === 'function') this.select.dispatchEvent(new Event('change'));
                                else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
                                    // IE11
                                    var event = document.createEvent('Event');
                                    event.initEvent('change', true, true);
                                    this.select.dispatchEvent(event);
                                }
                                this.close();
                            }
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var option = void 0;
                            if (this.select.selectedIndex > -1) {
                                var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
                                option = this.select.options[this.select.selectedIndex];
                                this.selectItem(item);
                            } else this.selectItem(null);
                            var isActive = option != null && option !== this.select.querySelector('option[selected]');
                            this.label.classList.toggle('ql-active', isActive);
                        }
                    }
                ]);
                return Picker;
            }();
            exports.default = Picker;
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _scroll = __webpack_require__(22);
            var _scroll2 = _interopRequireDefault(_scroll);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _clipboard = __webpack_require__(55);
            var _clipboard2 = _interopRequireDefault(_clipboard);
            var _history = __webpack_require__(42);
            var _history2 = _interopRequireDefault(_history);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _quill2.default.register({
                'blots/block': _block2.default,
                'blots/block/embed': _block.BlockEmbed,
                'blots/break': _break2.default,
                'blots/container': _container2.default,
                'blots/cursor': _cursor2.default,
                'blots/embed': _embed2.default,
                'blots/inline': _inline2.default,
                'blots/scroll': _scroll2.default,
                'blots/text': _text2.default,
                'modules/clipboard': _clipboard2.default,
                'modules/history': _history2.default,
                'modules/keyboard': _keyboard2.default
            });
            _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
            exports.default = _quill2.default;
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var ShadowBlot = /** @class */ function() {
                function ShadowBlot(domNode) {
                    this.domNode = domNode;
                    // @ts-ignore
                    this.domNode[Registry.DATA_KEY] = {
                        blot: this
                    };
                }
                Object.defineProperty(ShadowBlot.prototype, "statics", {
                    // Hack for accessing inherited static methods
                    get: function get() {
                        return this.constructor;
                    },
                    enumerable: true,
                    configurable: true
                });
                ShadowBlot.create = function(value) {
                    if (this.tagName == null) throw new Registry.ParchmentError('Blot definition missing tagName');
                    var node;
                    if (Array.isArray(this.tagName)) {
                        if (typeof value === 'string') {
                            value = value.toUpperCase();
                            if (parseInt(value).toString() === value) value = parseInt(value);
                        }
                        if (typeof value === 'number') node = document.createElement(this.tagName[value - 1]);
                        else if (this.tagName.indexOf(value) > -1) node = document.createElement(value);
                        else node = document.createElement(this.tagName[0]);
                    } else node = document.createElement(this.tagName);
                    if (this.className) node.classList.add(this.className);
                    return node;
                };
                ShadowBlot.prototype.attach = function() {
                    if (this.parent != null) this.scroll = this.parent.scroll;
                };
                ShadowBlot.prototype.clone = function() {
                    var domNode = this.domNode.cloneNode(false);
                    return Registry.create(domNode);
                };
                ShadowBlot.prototype.detach = function() {
                    if (this.parent != null) this.parent.removeChild(this);
                    // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY];
                };
                ShadowBlot.prototype.deleteAt = function(index, length) {
                    var blot = this.isolate(index, length);
                    blot.remove();
                };
                ShadowBlot.prototype.formatAt = function(index, length, name, value) {
                    var blot = this.isolate(index, length);
                    if (Registry.query(name, Registry.Scope.BLOT) != null && value) blot.wrap(name, value);
                    else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
                        var parent = Registry.create(this.statics.scope);
                        blot.wrap(parent);
                        parent.format(name, value);
                    }
                };
                ShadowBlot.prototype.insertAt = function(index, value, def) {
                    var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
                    var ref = this.split(index);
                    this.parent.insertBefore(blot, ref);
                };
                ShadowBlot.prototype.insertInto = function(parentBlot, refBlot) {
                    if (refBlot === void 0) refBlot = null;
                    if (this.parent != null) this.parent.children.remove(this);
                    var refDomNode = null;
                    parentBlot.children.insertBefore(this, refBlot);
                    if (refBlot != null) refDomNode = refBlot.domNode;
                    if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) parentBlot.domNode.insertBefore(this.domNode, refDomNode);
                    this.parent = parentBlot;
                    this.attach();
                };
                ShadowBlot.prototype.isolate = function(index, length) {
                    var target = this.split(index);
                    target.split(length);
                    return target;
                };
                ShadowBlot.prototype.length = function() {
                    return 1;
                };
                ShadowBlot.prototype.offset = function(root) {
                    if (root === void 0) root = this.parent;
                    if (this.parent == null || this == root) return 0;
                    return this.parent.children.offset(this) + this.parent.offset(root);
                };
                ShadowBlot.prototype.optimize = function(context) {
                    // TODO clean up once we use WeakMap
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY] != null) // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY].mutations;
                };
                ShadowBlot.prototype.remove = function() {
                    if (this.domNode.parentNode != null) this.domNode.parentNode.removeChild(this.domNode);
                    this.detach();
                };
                ShadowBlot.prototype.replace = function(target) {
                    if (target.parent == null) return;
                    target.parent.insertBefore(this, target.next);
                    target.remove();
                };
                ShadowBlot.prototype.replaceWith = function(name, value) {
                    var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
                    replacement.replace(this);
                    return replacement;
                };
                ShadowBlot.prototype.split = function(index, force) {
                    return index === 0 ? this : this.next;
                };
                ShadowBlot.prototype.update = function(mutations, context) {
                // Nothing to do by default
                };
                ShadowBlot.prototype.wrap = function(name, value) {
                    var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
                    if (this.parent != null) this.parent.insertBefore(wrapper, this.next);
                    wrapper.appendChild(this);
                    return wrapper;
                };
                ShadowBlot.blotName = 'abstract';
                return ShadowBlot;
            }();
            exports.default = ShadowBlot;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var Registry = __webpack_require__(1);
            var AttributorStore = /** @class */ function() {
                function AttributorStore(domNode) {
                    this.attributes = {};
                    this.domNode = domNode;
                    this.build();
                }
                AttributorStore.prototype.attribute = function(attribute, value) {
                    // verb
                    if (value) {
                        if (attribute.add(this.domNode, value)) {
                            if (attribute.value(this.domNode) != null) this.attributes[attribute.attrName] = attribute;
                            else delete this.attributes[attribute.attrName];
                        }
                    } else {
                        attribute.remove(this.domNode);
                        delete this.attributes[attribute.attrName];
                    }
                };
                AttributorStore.prototype.build = function() {
                    var _this = this;
                    this.attributes = {};
                    var attributes = attributor_1.default.keys(this.domNode);
                    var classes = class_1.default.keys(this.domNode);
                    var styles = style_1.default.keys(this.domNode);
                    attributes.concat(classes).concat(styles).forEach(function(name) {
                        var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
                        if (attr instanceof attributor_1.default) _this.attributes[attr.attrName] = attr;
                    });
                };
                AttributorStore.prototype.copy = function(target) {
                    var _this = this;
                    Object.keys(this.attributes).forEach(function(key) {
                        var value = _this.attributes[key].value(_this.domNode);
                        target.format(key, value);
                    });
                };
                AttributorStore.prototype.move = function(target) {
                    var _this = this;
                    this.copy(target);
                    Object.keys(this.attributes).forEach(function(key) {
                        _this.attributes[key].remove(_this.domNode);
                    });
                    this.attributes = {};
                };
                AttributorStore.prototype.values = function() {
                    var _this = this;
                    return Object.keys(this.attributes).reduce(function(attributes, name) {
                        attributes[name] = _this.attributes[name].value(_this.domNode);
                        return attributes;
                    }, {});
                };
                return AttributorStore;
            }();
            exports.default = AttributorStore;
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function match(node, prefix) {
                var className = node.getAttribute('class') || '';
                return className.split(/\s+/).filter(function(name) {
                    return name.indexOf(prefix + "-") === 0;
                });
            }
            var ClassAttributor = /** @class */ function(_super) {
                __extends(ClassAttributor, _super);
                function ClassAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ClassAttributor.keys = function(node) {
                    return (node.getAttribute('class') || '').split(/\s+/).map(function(name) {
                        return name.split('-').slice(0, -1).join('-');
                    });
                };
                ClassAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    this.remove(node);
                    node.classList.add(this.keyName + "-" + value);
                    return true;
                };
                ClassAttributor.prototype.remove = function(node) {
                    var matches = match(node, this.keyName);
                    matches.forEach(function(name) {
                        node.classList.remove(name);
                    });
                    if (node.classList.length === 0) node.removeAttribute('class');
                };
                ClassAttributor.prototype.value = function(node) {
                    var result = match(node, this.keyName)[0] || '';
                    var value = result.slice(this.keyName.length + 1); // +1 for hyphen
                    return this.canAdd(node, value) ? value : '';
                };
                return ClassAttributor;
            }(attributor_1.default);
            exports.default = ClassAttributor;
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function camelize(name) {
                var parts = name.split('-');
                var rest = parts.slice(1).map(function(part) {
                    return part[0].toUpperCase() + part.slice(1);
                }).join('');
                return parts[0] + rest;
            }
            var StyleAttributor = /** @class */ function(_super) {
                __extends(StyleAttributor, _super);
                function StyleAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                StyleAttributor.keys = function(node) {
                    return (node.getAttribute('style') || '').split(';').map(function(value) {
                        var arr = value.split(':');
                        return arr[0].trim();
                    });
                };
                StyleAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = value;
                    return true;
                };
                StyleAttributor.prototype.remove = function(node) {
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = '';
                    if (!node.getAttribute('style')) node.removeAttribute('style');
                };
                StyleAttributor.prototype.value = function(node) {
                    // @ts-ignore
                    var value = node.style[camelize(this.keyName)];
                    return this.canAdd(node, value) ? value : '';
                };
                return StyleAttributor;
            }(attributor_1.default);
            exports.default = StyleAttributor;
        /***/ },
        /* 34 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Theme = function() {
                function Theme(quill, options) {
                    _classCallCheck(this, Theme);
                    this.quill = quill;
                    this.options = options;
                    this.modules = {};
                }
                _createClass(Theme, [
                    {
                        key: 'init',
                        value: function init() {
                            var _this = this;
                            Object.keys(this.options.modules).forEach(function(name) {
                                if (_this.modules[name] == null) _this.addModule(name);
                            });
                        }
                    },
                    {
                        key: 'addModule',
                        value: function addModule(name) {
                            var moduleClass = this.quill.constructor.import('modules/' + name);
                            this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
                            return this.modules[name];
                        }
                    }
                ]);
                return Theme;
            }();
            Theme.DEFAULTS = {
                modules: {}
            };
            Theme.themes = {
                'default': Theme
            };
            exports.default = Theme;
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var GUARD_TEXT = '\uFEFF';
            var Embed = function(_Parchment$Embed) {
                _inherits(Embed, _Parchment$Embed);
                function Embed(node) {
                    _classCallCheck(this, Embed);
                    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
                    _this.contentNode = document.createElement('span');
                    _this.contentNode.setAttribute('contenteditable', false);
                    [].slice.call(_this.domNode.childNodes).forEach(function(childNode) {
                        _this.contentNode.appendChild(childNode);
                    });
                    _this.leftGuard = document.createTextNode(GUARD_TEXT);
                    _this.rightGuard = document.createTextNode(GUARD_TEXT);
                    _this.domNode.appendChild(_this.leftGuard);
                    _this.domNode.appendChild(_this.contentNode);
                    _this.domNode.appendChild(_this.rightGuard);
                    return _this;
                }
                _createClass(Embed, [
                    {
                        key: 'index',
                        value: function index(node, offset) {
                            if (node === this.leftGuard) return 0;
                            if (node === this.rightGuard) return 1;
                            return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
                        }
                    },
                    {
                        key: 'restore',
                        value: function restore(node) {
                            var range = void 0, textNode = void 0;
                            var text = node.data.split(GUARD_TEXT).join('');
                            if (node === this.leftGuard) {
                                if (this.prev instanceof _text2.default) {
                                    var prevLength = this.prev.length();
                                    this.prev.insertAt(prevLength, text);
                                    range = {
                                        startNode: this.prev.domNode,
                                        startOffset: prevLength + text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            } else if (node === this.rightGuard) {
                                if (this.next instanceof _text2.default) {
                                    this.next.insertAt(0, text);
                                    range = {
                                        startNode: this.next.domNode,
                                        startOffset: text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            }
                            node.data = GUARD_TEXT;
                            return range;
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations, context) {
                            var _this2 = this;
                            mutations.forEach(function(mutation) {
                                if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                                    var range = _this2.restore(mutation.target);
                                    if (range) context.range = range;
                                }
                            });
                        }
                    }
                ]);
                return Embed;
            }(_parchment2.default.Embed);
            exports.default = Embed;
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    'right',
                    'center',
                    'justify'
                ]
            };
            var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
            var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
            var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
            exports.AlignAttribute = AlignAttribute;
            exports.AlignClass = AlignClass;
            exports.AlignStyle = AlignStyle;
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BackgroundStyle = exports.BackgroundClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _color = __webpack_require__(26);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
                scope: _parchment2.default.Scope.INLINE
            });
            var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.BackgroundClass = BackgroundClass;
            exports.BackgroundStyle = BackgroundStyle;
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    'rtl'
                ]
            };
            var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
            var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
            var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
            exports.DirectionAttribute = DirectionAttribute;
            exports.DirectionClass = DirectionClass;
            exports.DirectionStyle = DirectionStyle;
        /***/ },
        /* 39 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.FontClass = exports.FontStyle = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var config = {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    'serif',
                    'monospace'
                ]
            };
            var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
            var FontStyleAttributor = function(_Parchment$Attributor) {
                _inherits(FontStyleAttributor, _Parchment$Attributor);
                function FontStyleAttributor() {
                    _classCallCheck(this, FontStyleAttributor);
                    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
                }
                _createClass(FontStyleAttributor, [
                    {
                        key: 'value',
                        value: function value(node) {
                            return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
                        }
                    }
                ]);
                return FontStyleAttributor;
            }(_parchment2.default.Attributor.Style);
            var FontStyle = new FontStyleAttributor('font', 'font-family', config);
            exports.FontStyle = FontStyle;
            exports.FontClass = FontClass;
        /***/ },
        /* 40 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SizeStyle = exports.SizeClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    'small',
                    'large',
                    'huge'
                ]
            });
            var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    '10px',
                    '18px',
                    '32px'
                ]
            });
            exports.SizeClass = SizeClass;
            exports.SizeStyle = SizeStyle;
        /***/ },
        /* 41 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = {
                'align': {
                    '': __webpack_require__(76),
                    'center': __webpack_require__(77),
                    'right': __webpack_require__(78),
                    'justify': __webpack_require__(79)
                },
                'background': __webpack_require__(80),
                'blockquote': __webpack_require__(81),
                'bold': __webpack_require__(82),
                'clean': __webpack_require__(83),
                'code': __webpack_require__(58),
                'code-block': __webpack_require__(58),
                'color': __webpack_require__(84),
                'direction': {
                    '': __webpack_require__(85),
                    'rtl': __webpack_require__(86)
                },
                'float': {
                    'center': __webpack_require__(87),
                    'full': __webpack_require__(88),
                    'left': __webpack_require__(89),
                    'right': __webpack_require__(90)
                },
                'formula': __webpack_require__(91),
                'header': {
                    '1': __webpack_require__(92),
                    '2': __webpack_require__(93)
                },
                'italic': __webpack_require__(94),
                'image': __webpack_require__(95),
                'indent': {
                    '+1': __webpack_require__(96),
                    '-1': __webpack_require__(97)
                },
                'link': __webpack_require__(98),
                'list': {
                    'ordered': __webpack_require__(99),
                    'bullet': __webpack_require__(100),
                    'check': __webpack_require__(101)
                },
                'script': {
                    'sub': __webpack_require__(102),
                    'super': __webpack_require__(103)
                },
                'strike': __webpack_require__(104),
                'underline': __webpack_require__(105),
                'video': __webpack_require__(106)
            };
        /***/ },
        /* 42 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getLastChangeIndex = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var History = function(_Module) {
                _inherits(History, _Module);
                function History(quill, options) {
                    _classCallCheck(this, History);
                    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
                    _this.lastRecorded = 0;
                    _this.ignoreChange = false;
                    _this.clear();
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(eventName, delta, oldDelta, source) {
                        if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
                        if (!_this.options.userOnly || source === _quill2.default.sources.USER) _this.record(delta, oldDelta);
                        else _this.transform(delta);
                    });
                    _this.quill.keyboard.addBinding({
                        key: 'Z',
                        shortKey: true
                    }, _this.undo.bind(_this));
                    _this.quill.keyboard.addBinding({
                        key: 'Z',
                        shortKey: true,
                        shiftKey: true
                    }, _this.redo.bind(_this));
                    if (/Win/i.test(navigator.platform)) _this.quill.keyboard.addBinding({
                        key: 'Y',
                        shortKey: true
                    }, _this.redo.bind(_this));
                    return _this;
                }
                _createClass(History, [
                    {
                        key: 'change',
                        value: function change(source, dest) {
                            if (this.stack[source].length === 0) return;
                            var delta = this.stack[source].pop();
                            this.stack[dest].push(delta);
                            this.lastRecorded = 0;
                            this.ignoreChange = true;
                            this.quill.updateContents(delta[source], _quill2.default.sources.USER);
                            this.ignoreChange = false;
                            var index = getLastChangeIndex(delta[source]);
                            this.quill.setSelection(index);
                        }
                    },
                    {
                        key: 'clear',
                        value: function clear() {
                            this.stack = {
                                undo: [],
                                redo: []
                            };
                        }
                    },
                    {
                        key: 'cutoff',
                        value: function cutoff() {
                            this.lastRecorded = 0;
                        }
                    },
                    {
                        key: 'record',
                        value: function record(changeDelta, oldDelta) {
                            if (changeDelta.ops.length === 0) return;
                            this.stack.redo = [];
                            var undoDelta = this.quill.getContents().diff(oldDelta);
                            var timestamp = Date.now();
                            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
                                var delta = this.stack.undo.pop();
                                undoDelta = undoDelta.compose(delta.undo);
                                changeDelta = delta.redo.compose(changeDelta);
                            } else this.lastRecorded = timestamp;
                            this.stack.undo.push({
                                redo: changeDelta,
                                undo: undoDelta
                            });
                            if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
                        }
                    },
                    {
                        key: 'redo',
                        value: function redo() {
                            this.change('redo', 'undo');
                        }
                    },
                    {
                        key: 'transform',
                        value: function transform(delta) {
                            this.stack.undo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                            this.stack.redo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                        }
                    },
                    {
                        key: 'undo',
                        value: function undo() {
                            this.change('undo', 'redo');
                        }
                    }
                ]);
                return History;
            }(_module2.default);
            History.DEFAULTS = {
                delay: 1000,
                maxStack: 100,
                userOnly: false
            };
            function endsWithNewlineChange(delta) {
                var lastOp = delta.ops[delta.ops.length - 1];
                if (lastOp == null) return false;
                if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
                if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some(function(attr) {
                    return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
                });
                return false;
            }
            function getLastChangeIndex(delta) {
                var deleteLength = delta.reduce(function(length, op) {
                    length += op.delete || 0;
                    return length;
                }, 0);
                var changeIndex = delta.length() - deleteLength;
                if (endsWithNewlineChange(delta)) changeIndex -= 1;
                return changeIndex;
            }
            exports.default = History;
            exports.getLastChangeIndex = getLastChangeIndex;
        /***/ },
        /* 43 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BaseTooltip = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ALIGNS = [
                false,
                'center',
                'right',
                'justify'
            ];
            var COLORS = [
                "#000000",
                "#e60000",
                "#ff9900",
                "#ffff00",
                "#008a00",
                "#0066cc",
                "#9933ff",
                "#ffffff",
                "#facccc",
                "#ffebcc",
                "#ffffcc",
                "#cce8cc",
                "#cce0f5",
                "#ebd6ff",
                "#bbbbbb",
                "#f06666",
                "#ffc266",
                "#ffff66",
                "#66b966",
                "#66a3e0",
                "#c285ff",
                "#888888",
                "#a10000",
                "#b26b00",
                "#b2b200",
                "#006100",
                "#0047b2",
                "#6b24b2",
                "#444444",
                "#5c0000",
                "#663d00",
                "#666600",
                "#003700",
                "#002966",
                "#3d1466"
            ];
            var FONTS = [
                false,
                'serif',
                'monospace'
            ];
            var HEADERS = [
                '1',
                '2',
                '3',
                false
            ];
            var SIZES = [
                'small',
                false,
                'large',
                'huge'
            ];
            var BaseTheme = function(_Theme) {
                _inherits(BaseTheme, _Theme);
                function BaseTheme(quill, options) {
                    _classCallCheck(this, BaseTheme);
                    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
                    var listener = function listener(e) {
                        if (!document.body.contains(quill.root)) return document.body.removeEventListener('click', listener);
                        if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) _this.tooltip.hide();
                        if (_this.pickers != null) _this.pickers.forEach(function(picker) {
                            if (!picker.container.contains(e.target)) picker.close();
                        });
                    };
                    quill.emitter.listenDOM('click', document.body, listener);
                    return _this;
                }
                _createClass(BaseTheme, [
                    {
                        key: 'addModule',
                        value: function addModule(name) {
                            var module1 = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
                            if (name === 'toolbar') this.extendToolbar(module1);
                            return module1;
                        }
                    },
                    {
                        key: 'buildButtons',
                        value: function buildButtons(buttons, icons) {
                            buttons.forEach(function(button) {
                                var className = button.getAttribute('class') || '';
                                className.split(/\s+/).forEach(function(name) {
                                    if (!name.startsWith('ql-')) return;
                                    name = name.slice(3);
                                    if (icons[name] == null) return;
                                    if (name === 'direction') button.innerHTML = icons[name][''] + icons[name]['rtl'];
                                    else if (typeof icons[name] === 'string') button.innerHTML = icons[name];
                                    else {
                                        var value = button.value || '';
                                        if (value != null && icons[name][value]) button.innerHTML = icons[name][value];
                                    }
                                });
                            });
                        }
                    },
                    {
                        key: 'buildPickers',
                        value: function buildPickers(selects, icons) {
                            var _this2 = this;
                            this.pickers = selects.map(function(select) {
                                if (select.classList.contains('ql-align')) {
                                    if (select.querySelector('option') == null) fillSelect(select, ALIGNS);
                                    return new _iconPicker2.default(select, icons.align);
                                } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                                    var format = select.classList.contains('ql-background') ? 'background' : 'color';
                                    if (select.querySelector('option') == null) fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
                                    return new _colorPicker2.default(select, icons[format]);
                                } else {
                                    if (select.querySelector('option') == null) {
                                        if (select.classList.contains('ql-font')) fillSelect(select, FONTS);
                                        else if (select.classList.contains('ql-header')) fillSelect(select, HEADERS);
                                        else if (select.classList.contains('ql-size')) fillSelect(select, SIZES);
                                    }
                                    return new _picker2.default(select);
                                }
                            });
                            var update = function update() {
                                _this2.pickers.forEach(function(picker) {
                                    picker.update();
                                });
                            };
                            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
                        }
                    }
                ]);
                return BaseTheme;
            }(_theme2.default);
            BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            formula: function formula() {
                                this.quill.theme.tooltip.edit('formula');
                            },
                            image: function image() {
                                var _this3 = this;
                                var fileInput = this.container.querySelector('input.ql-image[type=file]');
                                if (fileInput == null) {
                                    fileInput = document.createElement('input');
                                    fileInput.setAttribute('type', 'file');
                                    fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
                                    fileInput.classList.add('ql-image');
                                    fileInput.addEventListener('change', function() {
                                        if (fileInput.files != null && fileInput.files[0] != null) {
                                            var reader = new FileReader();
                                            reader.onload = function(e) {
                                                var range = _this3.quill.getSelection(true);
                                                _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({
                                                    image: e.target.result
                                                }), _emitter2.default.sources.USER);
                                                _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                                                fileInput.value = "";
                                            };
                                            reader.readAsDataURL(fileInput.files[0]);
                                        }
                                    });
                                    this.container.appendChild(fileInput);
                                }
                                fileInput.click();
                            },
                            video: function video() {
                                this.quill.theme.tooltip.edit('video');
                            }
                        }
                    }
                }
            });
            var BaseTooltip = function(_Tooltip) {
                _inherits(BaseTooltip, _Tooltip);
                function BaseTooltip(quill, boundsContainer) {
                    _classCallCheck(this, BaseTooltip);
                    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
                    _this4.textbox = _this4.root.querySelector('input[type="text"]');
                    _this4.listen();
                    return _this4;
                }
                _createClass(BaseTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this5 = this;
                            this.textbox.addEventListener('keydown', function(event) {
                                if (_keyboard2.default.match(event, 'enter')) {
                                    _this5.save();
                                    event.preventDefault();
                                } else if (_keyboard2.default.match(event, 'escape')) {
                                    _this5.cancel();
                                    event.preventDefault();
                                }
                            });
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            this.hide();
                        }
                    },
                    {
                        key: 'edit',
                        value: function edit() {
                            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
                            var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            this.root.classList.remove('ql-hidden');
                            this.root.classList.add('ql-editing');
                            if (preview != null) this.textbox.value = preview;
                            else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
                            this.position(this.quill.getBounds(this.quill.selection.savedRange));
                            this.textbox.select();
                            this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
                            this.root.setAttribute('data-mode', mode);
                        }
                    },
                    {
                        key: 'restoreFocus',
                        value: function restoreFocus() {
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.quill.focus();
                            this.quill.scrollingContainer.scrollTop = scrollTop;
                        }
                    },
                    {
                        key: 'save',
                        value: function save() {
                            var value = this.textbox.value;
                            switch(this.root.getAttribute('data-mode')){
                                case 'link':
                                    var scrollTop = this.quill.root.scrollTop;
                                    if (this.linkRange) {
                                        this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
                                        delete this.linkRange;
                                    } else {
                                        this.restoreFocus();
                                        this.quill.format('link', value, _emitter2.default.sources.USER);
                                    }
                                    this.quill.root.scrollTop = scrollTop;
                                    break;
                                case 'video':
                                    value = extractVideoUrl(value);
                                case 'formula':
                                    if (!value) break;
                                    var range = this.quill.getSelection(true);
                                    if (range != null) {
                                        var index = range.index + range.length;
                                        this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
                                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
                                        this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                                    }
                                    break;
                                default:
                            }
                            this.textbox.value = '';
                            this.hide();
                        }
                    }
                ]);
                return BaseTooltip;
            }(_tooltip2.default);
            function extractVideoUrl(url) {
                var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
                if (match) return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
                if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) // eslint-disable-line no-cond-assign
                return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
                return url;
            }
            function fillSelect(select, values) {
                var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                values.forEach(function(value) {
                    var option = document.createElement('option');
                    if (value === defaultValue) option.setAttribute('selected', 'selected');
                    else option.setAttribute('value', value);
                    select.appendChild(option);
                });
            }
            exports.BaseTooltip = BaseTooltip;
            exports.default = BaseTheme;
        /***/ },
        /* 44 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var LinkedList = /** @class */ function() {
                function LinkedList() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
                LinkedList.prototype.append = function() {
                    var nodes = [];
                    for(var _i = 0; _i < arguments.length; _i++)nodes[_i] = arguments[_i];
                    this.insertBefore(nodes[0], null);
                    if (nodes.length > 1) this.append.apply(this, nodes.slice(1));
                };
                LinkedList.prototype.contains = function(node) {
                    var cur, next = this.iterator();
                    while(cur = next()){
                        if (cur === node) return true;
                    }
                    return false;
                };
                LinkedList.prototype.insertBefore = function(node, refNode) {
                    if (!node) return;
                    node.next = refNode;
                    if (refNode != null) {
                        node.prev = refNode.prev;
                        if (refNode.prev != null) refNode.prev.next = node;
                        refNode.prev = node;
                        if (refNode === this.head) this.head = node;
                    } else if (this.tail != null) {
                        this.tail.next = node;
                        node.prev = this.tail;
                        this.tail = node;
                    } else {
                        node.prev = null;
                        this.head = this.tail = node;
                    }
                    this.length += 1;
                };
                LinkedList.prototype.offset = function(target) {
                    var index = 0, cur = this.head;
                    while(cur != null){
                        if (cur === target) return index;
                        index += cur.length();
                        cur = cur.next;
                    }
                    return -1;
                };
                LinkedList.prototype.remove = function(node) {
                    if (!this.contains(node)) return;
                    if (node.prev != null) node.prev.next = node.next;
                    if (node.next != null) node.next.prev = node.prev;
                    if (node === this.head) this.head = node.next;
                    if (node === this.tail) this.tail = node.prev;
                    this.length -= 1;
                };
                LinkedList.prototype.iterator = function(curNode) {
                    if (curNode === void 0) curNode = this.head;
                    // TODO use yield when we can
                    return function() {
                        var ret = curNode;
                        if (curNode != null) curNode = curNode.next;
                        return ret;
                    };
                };
                LinkedList.prototype.find = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var cur, next = this.iterator();
                    while(cur = next()){
                        var length = cur.length();
                        if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                            cur,
                            index
                        ];
                        index -= length;
                    }
                    return [
                        null,
                        0
                    ];
                };
                LinkedList.prototype.forEach = function(callback) {
                    var cur, next = this.iterator();
                    while(cur = next())callback(cur);
                };
                LinkedList.prototype.forEachAt = function(index, length, callback) {
                    if (length <= 0) return;
                    var _a = this.find(index), startNode = _a[0], offset = _a[1];
                    var cur, curIndex = index - offset, next = this.iterator(startNode);
                    while((cur = next()) && curIndex < index + length){
                        var curLength = cur.length();
                        if (index > curIndex) callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
                        else callback(cur, 0, Math.min(curLength, index + length - curIndex));
                        curIndex += curLength;
                    }
                };
                LinkedList.prototype.map = function(callback) {
                    return this.reduce(function(memo, cur) {
                        memo.push(callback(cur));
                        return memo;
                    }, []);
                };
                LinkedList.prototype.reduce = function(callback, memo) {
                    var cur, next = this.iterator();
                    while(cur = next())memo = callback(memo, cur);
                    return memo;
                };
                return LinkedList;
            }();
            exports.default = LinkedList;
        /***/ },
        /* 45 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var OBSERVER_CONFIG = {
                attributes: true,
                characterData: true,
                characterDataOldValue: true,
                childList: true,
                subtree: true
            };
            var MAX_OPTIMIZE_ITERATIONS = 100;
            var ScrollBlot = /** @class */ function(_super) {
                __extends(ScrollBlot, _super);
                function ScrollBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.scroll = _this;
                    _this.observer = new MutationObserver(function(mutations) {
                        _this.update(mutations);
                    });
                    _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
                    _this.attach();
                    return _this;
                }
                ScrollBlot.prototype.detach = function() {
                    _super.prototype.detach.call(this);
                    this.observer.disconnect();
                };
                ScrollBlot.prototype.deleteAt = function(index, length) {
                    this.update();
                    if (index === 0 && length === this.length()) this.children.forEach(function(child) {
                        child.remove();
                    });
                    else _super.prototype.deleteAt.call(this, index, length);
                };
                ScrollBlot.prototype.formatAt = function(index, length, name, value) {
                    this.update();
                    _super.prototype.formatAt.call(this, index, length, name, value);
                };
                ScrollBlot.prototype.insertAt = function(index, value, def) {
                    this.update();
                    _super.prototype.insertAt.call(this, index, value, def);
                };
                ScrollBlot.prototype.optimize = function(mutations, context) {
                    var _this = this;
                    if (mutations === void 0) mutations = [];
                    if (context === void 0) context = {};
                    _super.prototype.optimize.call(this, context);
                    // We must modify mutations directly, cannot make copy and then modify
                    var records = [].slice.call(this.observer.takeRecords());
                    // Array.push currently seems to be implemented by a non-tail recursive function
                    // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
                    while(records.length > 0)mutations.push(records.pop());
                    // TODO use WeakMap
                    var mark = function mark1(blot, markParent) {
                        if (markParent === void 0) markParent = true;
                        if (blot == null || blot === _this) return;
                        if (blot.domNode.parentNode == null) return;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations = [];
                        if (markParent) mark(blot.parent);
                    };
                    var optimize = function optimize1(blot) {
                        // Post-order traversal
                        if (// @ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null || // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations == null) return;
                        if (blot instanceof container_1.default) blot.children.forEach(optimize);
                        blot.optimize(context);
                    };
                    var remaining = mutations;
                    for(var i = 0; remaining.length > 0; i += 1){
                        if (i >= MAX_OPTIMIZE_ITERATIONS) throw new Error('[Parchment] Maximum optimize iterations reached');
                        remaining.forEach(function(mutation) {
                            var blot = Registry.find(mutation.target, true);
                            if (blot == null) return;
                            if (blot.domNode === mutation.target) {
                                if (mutation.type === 'childList') {
                                    mark(Registry.find(mutation.previousSibling, false));
                                    [].forEach.call(mutation.addedNodes, function(node) {
                                        var child = Registry.find(node, false);
                                        mark(child, false);
                                        if (child instanceof container_1.default) child.children.forEach(function(grandChild) {
                                            mark(grandChild, false);
                                        });
                                    });
                                } else if (mutation.type === 'attributes') mark(blot.prev);
                            }
                            mark(blot);
                        });
                        this.children.forEach(optimize);
                        remaining = [].slice.call(this.observer.takeRecords());
                        records = remaining.slice();
                        while(records.length > 0)mutations.push(records.pop());
                    }
                };
                ScrollBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (context === void 0) context = {};
                    mutations = mutations || this.observer.takeRecords();
                    // TODO use WeakMap
                    mutations.map(function(mutation) {
                        var blot = Registry.find(mutation.target, true);
                        if (blot == null) return null;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations = [
                                mutation
                            ];
                            return blot;
                        } else {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                            return null;
                        }
                    }).forEach(function(blot) {
                        if (blot == null || blot === _this || //@ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null) return;
                        // @ts-ignore
                        blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
                    });
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY].mutations != null) // @ts-ignore
                    _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
                    this.optimize(mutations, context);
                };
                ScrollBlot.blotName = 'scroll';
                ScrollBlot.defaultChild = 'block';
                ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
                ScrollBlot.tagName = 'DIV';
                return ScrollBlot;
            }(container_1.default);
            exports.default = ScrollBlot;
        /***/ },
        /* 46 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            // Shallow object comparison
            function isEqual(obj1, obj2) {
                if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
                // @ts-ignore
                for(var prop in obj1){
                    // @ts-ignore
                    if (obj1[prop] !== obj2[prop]) return false;
                }
                return true;
            }
            var InlineBlot = /** @class */ function(_super) {
                __extends(InlineBlot, _super);
                function InlineBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InlineBlot.formats = function(domNode) {
                    if (domNode.tagName === InlineBlot.tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                InlineBlot.prototype.format = function(name, value) {
                    var _this = this;
                    if (name === this.statics.blotName && !value) {
                        this.children.forEach(function(child) {
                            if (!(child instanceof format_1.default)) child = child.wrap(InlineBlot.blotName, true);
                            _this.attributes.copy(child);
                        });
                        this.unwrap();
                    } else _super.prototype.format.call(this, name, value);
                };
                InlineBlot.prototype.formatAt = function(index, length, name, value) {
                    if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
                        var blot = this.isolate(index, length);
                        blot.format(name, value);
                    } else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                InlineBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    var formats = this.formats();
                    if (Object.keys(formats).length === 0) return this.unwrap(); // unformatted span
                    var next = this.next;
                    if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
                        next.moveChildren(this);
                        next.remove();
                    }
                };
                InlineBlot.blotName = 'inline';
                InlineBlot.scope = Registry.Scope.INLINE_BLOT;
                InlineBlot.tagName = 'SPAN';
                return InlineBlot;
            }(format_1.default);
            exports.default = InlineBlot;
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            var BlockBlot = /** @class */ function(_super) {
                __extends(BlockBlot, _super);
                function BlockBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                BlockBlot.formats = function(domNode) {
                    var tagName = Registry.query(BlockBlot.blotName).tagName;
                    if (domNode.tagName === tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                BlockBlot.prototype.format = function(name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) == null) return;
                    else if (name === this.statics.blotName && !value) this.replaceWith(BlockBlot.blotName);
                    else _super.prototype.format.call(this, name, value);
                };
                BlockBlot.prototype.formatAt = function(index, length, name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) != null) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                BlockBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) // Insert text or inline
                    _super.prototype.insertAt.call(this, index, value, def);
                    else {
                        var after = this.split(index);
                        var blot = Registry.create(value, def);
                        after.parent.insertBefore(blot, after);
                    }
                };
                BlockBlot.prototype.update = function(mutations, context) {
                    if (navigator.userAgent.match(/Trident/)) this.build();
                    else _super.prototype.update.call(this, mutations, context);
                };
                BlockBlot.blotName = 'block';
                BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
                BlockBlot.tagName = 'P';
                return BlockBlot;
            }(format_1.default);
            exports.default = BlockBlot;
        /***/ },
        /* 48 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var EmbedBlot = /** @class */ function(_super) {
                __extends(EmbedBlot, _super);
                function EmbedBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                EmbedBlot.formats = function(domNode) {
                    return undefined;
                };
                EmbedBlot.prototype.format = function(name, value) {
                    // super.formatAt wraps, which is what we want in general,
                    // but this allows subclasses to overwrite for formats
                    // that just apply to particular embeds
                    _super.prototype.formatAt.call(this, 0, this.length(), name, value);
                };
                EmbedBlot.prototype.formatAt = function(index, length, name, value) {
                    if (index === 0 && length === this.length()) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                EmbedBlot.prototype.formats = function() {
                    return this.statics.formats(this.domNode);
                };
                return EmbedBlot;
            }(leaf_1.default);
            exports.default = EmbedBlot;
        /***/ },
        /* 49 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var Registry = __webpack_require__(1);
            var TextBlot = /** @class */ function(_super) {
                __extends(TextBlot, _super);
                function TextBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.text = _this.statics.value(_this.domNode);
                    return _this;
                }
                TextBlot.create = function(value) {
                    return document.createTextNode(value);
                };
                TextBlot.value = function(domNode) {
                    var text = domNode.data;
                    // @ts-ignore
                    if (text['normalize']) text = text['normalize']();
                    return text;
                };
                TextBlot.prototype.deleteAt = function(index, length) {
                    this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
                };
                TextBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node) return offset;
                    return -1;
                };
                TextBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null) {
                        this.text = this.text.slice(0, index) + value + this.text.slice(index);
                        this.domNode.data = this.text;
                    } else _super.prototype.insertAt.call(this, index, value, def);
                };
                TextBlot.prototype.length = function() {
                    return this.text.length;
                };
                TextBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    this.text = this.statics.value(this.domNode);
                    if (this.text.length === 0) this.remove();
                    else if (this.next instanceof TextBlot && this.next.prev === this) {
                        this.insertAt(this.length(), this.next.value());
                        this.next.remove();
                    }
                };
                TextBlot.prototype.position = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    return [
                        this.domNode,
                        index
                    ];
                };
                TextBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = Registry.create(this.domNode.splitText(index));
                    this.parent.insertBefore(after, this.next);
                    this.text = this.statics.value(this.domNode);
                    return after;
                };
                TextBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (mutations.some(function(mutation) {
                        return mutation.type === 'characterData' && mutation.target === _this.domNode;
                    })) this.text = this.statics.value(this.domNode);
                };
                TextBlot.prototype.value = function() {
                    return this.text;
                };
                TextBlot.blotName = 'text';
                TextBlot.scope = Registry.Scope.INLINE_BLOT;
                return TextBlot;
            }(leaf_1.default);
            exports.default = TextBlot;
        /***/ },
        /* 50 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var elem = document.createElement('div');
            elem.classList.toggle('test-class', false);
            if (elem.classList.contains('test-class')) {
                var _toggle = DOMTokenList.prototype.toggle;
                DOMTokenList.prototype.toggle = function(token, force) {
                    if (arguments.length > 1 && !this.contains(token) === !force) return force;
                    else return _toggle.call(this, token);
                };
            }
            if (!String.prototype.startsWith) String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.substr(position, searchString.length) === searchString;
            };
            if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
                var subjectString = this.toString();
                if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
                position -= searchString.length;
                var lastIndex = subjectString.indexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
            if (!Array.prototype.find) Object.defineProperty(Array.prototype, "find", {
                value: function value(predicate) {
                    if (this === null) throw new TypeError('Array.prototype.find called on null or undefined');
                    if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
                    var list = Object(this);
                    var length = list.length >>> 0;
                    var thisArg = arguments[1];
                    var value;
                    for(var i = 0; i < length; i++){
                        value = list[i];
                        if (predicate.call(thisArg, value, i, list)) return value;
                    }
                    return undefined;
                }
            });
            document.addEventListener("DOMContentLoaded", function() {
                // Disable resizing in Firefox
                document.execCommand("enableObjectResizing", false, false);
                // Disable automatic linkifying in IE11
                document.execCommand("autoUrlDetect", false, false);
            });
        /***/ },
        /* 51 */ /***/ function(module1, exports) {
            /**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var DIFF_DELETE = -1;
            var DIFF_INSERT = 1;
            var DIFF_EQUAL = 0;
            /**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */ function diff_main(text1, text2, cursor_pos) {
                // Check for equality (speedup).
                if (text1 == text2) {
                    if (text1) return [
                        [
                            DIFF_EQUAL,
                            text1
                        ]
                    ];
                    return [];
                }
                // Check cursor_pos within bounds
                if (cursor_pos < 0 || text1.length < cursor_pos) cursor_pos = null;
                // Trim off common prefix (speedup).
                var commonlength = diff_commonPrefix(text1, text2);
                var commonprefix = text1.substring(0, commonlength);
                text1 = text1.substring(commonlength);
                text2 = text2.substring(commonlength);
                // Trim off common suffix (speedup).
                commonlength = diff_commonSuffix(text1, text2);
                var commonsuffix = text1.substring(text1.length - commonlength);
                text1 = text1.substring(0, text1.length - commonlength);
                text2 = text2.substring(0, text2.length - commonlength);
                // Compute the diff on the middle block.
                var diffs = diff_compute_(text1, text2);
                // Restore the prefix and suffix.
                if (commonprefix) diffs.unshift([
                    DIFF_EQUAL,
                    commonprefix
                ]);
                if (commonsuffix) diffs.push([
                    DIFF_EQUAL,
                    commonsuffix
                ]);
                diff_cleanupMerge(diffs);
                if (cursor_pos != null) diffs = fix_cursor(diffs, cursor_pos);
                diffs = fix_emoji(diffs);
                return diffs;
            }
            /**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function diff_compute_(text1, text2) {
                var diffs;
                if (!text1) // Just add some text (speedup).
                return [
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                if (!text2) // Just delete some text (speedup).
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ]
                ];
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                var i = longtext.indexOf(shorttext);
                if (i != -1) {
                    // Shorter text is inside the longer text (speedup).
                    diffs = [
                        [
                            DIFF_INSERT,
                            longtext.substring(0, i)
                        ],
                        [
                            DIFF_EQUAL,
                            shorttext
                        ],
                        [
                            DIFF_INSERT,
                            longtext.substring(i + shorttext.length)
                        ]
                    ];
                    // Swap insertions for deletions if diff is reversed.
                    if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = DIFF_DELETE;
                    return diffs;
                }
                if (shorttext.length == 1) // Single character string.
                // After the previous speedup, the character can't be an equality.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                // Check to see if the problem can be split in two.
                var hm = diff_halfMatch_(text1, text2);
                if (hm) {
                    // A half-match was found, sort out the return data.
                    var text1_a = hm[0];
                    var text1_b = hm[1];
                    var text2_a = hm[2];
                    var text2_b = hm[3];
                    var mid_common = hm[4];
                    // Send both pairs off for separate processing.
                    var diffs_a = diff_main(text1_a, text2_a);
                    var diffs_b = diff_main(text1_b, text2_b);
                    // Merge the results.
                    return diffs_a.concat([
                        [
                            DIFF_EQUAL,
                            mid_common
                        ]
                    ], diffs_b);
                }
                return diff_bisect_(text1, text2);
            }
            /**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function diff_bisect_(text1, text2) {
                // Cache the text lengths to prevent multiple calls.
                var text1_length = text1.length;
                var text2_length = text2.length;
                var max_d = Math.ceil((text1_length + text2_length) / 2);
                var v_offset = max_d;
                var v_length = 2 * max_d;
                var v1 = new Array(v_length);
                var v2 = new Array(v_length);
                // Setting all elements to -1 is faster in Chrome & Firefox than mixing
                // integers and undefined.
                for(var x = 0; x < v_length; x++){
                    v1[x] = -1;
                    v2[x] = -1;
                }
                v1[v_offset + 1] = 0;
                v2[v_offset + 1] = 0;
                var delta = text1_length - text2_length;
                // If the total number of characters is odd, then the front path will collide
                // with the reverse path.
                var front = delta % 2 != 0;
                // Offsets for start and end of k loop.
                // Prevents mapping of space beyond the grid.
                var k1start = 0;
                var k1end = 0;
                var k2start = 0;
                var k2end = 0;
                for(var d = 0; d < max_d; d++){
                    // Walk the front path one step.
                    for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
                        var k1_offset = v_offset + k1;
                        var x1;
                        if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
                        else x1 = v1[k1_offset - 1] + 1;
                        var y1 = x1 - k1;
                        while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                            x1++;
                            y1++;
                        }
                        v1[k1_offset] = x1;
                        if (x1 > text1_length) // Ran off the right of the graph.
                        k1end += 2;
                        else if (y1 > text2_length) // Ran off the bottom of the graph.
                        k1start += 2;
                        else if (front) {
                            var k2_offset = v_offset + delta - k1;
                            if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                                // Mirror x2 onto top-left coordinate system.
                                var x2 = text1_length - v2[k2_offset];
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                    // Walk the reverse path one step.
                    for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
                        var k2_offset = v_offset + k2;
                        var x2;
                        if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
                        else x2 = v2[k2_offset - 1] + 1;
                        var y2 = x2 - k2;
                        while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                            x2++;
                            y2++;
                        }
                        v2[k2_offset] = x2;
                        if (x2 > text1_length) // Ran off the left of the graph.
                        k2end += 2;
                        else if (y2 > text2_length) // Ran off the top of the graph.
                        k2start += 2;
                        else if (!front) {
                            var k1_offset = v_offset + delta - k2;
                            if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                                var x1 = v1[k1_offset];
                                var y1 = v_offset + x1 - k1_offset;
                                // Mirror x2 onto top-left coordinate system.
                                x2 = text1_length - x2;
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                }
                // Diff took too long and hit the deadline or
                // number of diffs equals number of characters, no commonality at all.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
            }
            /**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function diff_bisectSplit_(text1, text2, x, y) {
                var text1a = text1.substring(0, x);
                var text2a = text2.substring(0, y);
                var text1b = text1.substring(x);
                var text2b = text2.substring(y);
                // Compute both diffs serially.
                var diffs = diff_main(text1a, text2a);
                var diffsb = diff_main(text1b, text2b);
                return diffs.concat(diffsb);
            }
            /**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function diff_commonPrefix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerstart = 0;
                while(pointermin < pointermid){
                    if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                        pointermin = pointermid;
                        pointerstart = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function diff_commonSuffix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerend = 0;
                while(pointermin < pointermid){
                    if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                        pointermin = pointermid;
                        pointerend = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function diff_halfMatch_(text1, text2) {
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
                /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
                    // Start with a 1/4 length substring at position i as a seed.
                    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
                    var j = -1;
                    var best_common = '';
                    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
                    while((j = shorttext.indexOf(seed, j + 1)) != -1){
                        var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
                        var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
                        if (best_common.length < suffixLength + prefixLength) {
                            best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                            best_longtext_a = longtext.substring(0, i - suffixLength);
                            best_longtext_b = longtext.substring(i + prefixLength);
                            best_shorttext_a = shorttext.substring(0, j - suffixLength);
                            best_shorttext_b = shorttext.substring(j + prefixLength);
                        }
                    }
                    if (best_common.length * 2 >= longtext.length) return [
                        best_longtext_a,
                        best_longtext_b,
                        best_shorttext_a,
                        best_shorttext_b,
                        best_common
                    ];
                    else return null;
                }
                // First check if the second quarter is the seed for a half-match.
                var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
                // Check again based on the third quarter.
                var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
                var hm;
                if (!hm1 && !hm2) return null;
                else if (!hm2) hm = hm1;
                else if (!hm1) hm = hm2;
                else // Both matched.  Select the longest.
                hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
                // A half-match was found, sort out the return data.
                var text1_a, text1_b, text2_a, text2_b;
                if (text1.length > text2.length) {
                    text1_a = hm[0];
                    text1_b = hm[1];
                    text2_a = hm[2];
                    text2_b = hm[3];
                } else {
                    text2_a = hm[0];
                    text2_b = hm[1];
                    text1_a = hm[2];
                    text1_b = hm[3];
                }
                var mid_common = hm[4];
                return [
                    text1_a,
                    text1_b,
                    text2_a,
                    text2_b,
                    mid_common
                ];
            }
            /**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */ function diff_cleanupMerge(diffs) {
                diffs.push([
                    DIFF_EQUAL,
                    ''
                ]); // Add a dummy entry at the end.
                var pointer = 0;
                var count_delete = 0;
                var count_insert = 0;
                var text_delete = '';
                var text_insert = '';
                var commonlength;
                while(pointer < diffs.length)switch(diffs[pointer][0]){
                    case DIFF_INSERT:
                        count_insert++;
                        text_insert += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_DELETE:
                        count_delete++;
                        text_delete += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_EQUAL:
                        // Upon reaching an equality, check for prior redundancies.
                        if (count_delete + count_insert > 1) {
                            if (count_delete !== 0 && count_insert !== 0) {
                                // Factor out any common prefixies.
                                commonlength = diff_commonPrefix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                                    else {
                                        diffs.splice(0, 0, [
                                            DIFF_EQUAL,
                                            text_insert.substring(0, commonlength)
                                        ]);
                                        pointer++;
                                    }
                                    text_insert = text_insert.substring(commonlength);
                                    text_delete = text_delete.substring(commonlength);
                                }
                                // Factor out any common suffixies.
                                commonlength = diff_commonSuffix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                                    text_insert = text_insert.substring(0, text_insert.length - commonlength);
                                    text_delete = text_delete.substring(0, text_delete.length - commonlength);
                                }
                            }
                            // Delete the offending records and add the merged ones.
                            if (count_delete === 0) diffs.splice(pointer - count_insert, count_delete + count_insert, [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            else if (count_insert === 0) diffs.splice(pointer - count_delete, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ]);
                            else diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ], [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
                        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                            // Merge this equality with the previous one.
                            diffs[pointer - 1][1] += diffs[pointer][1];
                            diffs.splice(pointer, 1);
                        } else pointer++;
                        count_insert = 0;
                        count_delete = 0;
                        text_delete = '';
                        text_insert = '';
                        break;
                }
                if (diffs[diffs.length - 1][1] === '') diffs.pop(); // Remove the dummy entry at the end.
                // Second pass: look for single edits surrounded on both sides by equalities
                // which can be shifted sideways to eliminate an equality.
                // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
                var changes = false;
                pointer = 1;
                // Intentionally ignore the first and last element (don't need checking).
                while(pointer < diffs.length - 1){
                    if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                        // This is a single edit surrounded by equalities.
                        if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                            // Shift the edit over the previous equality.
                            diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                            diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                            diffs.splice(pointer - 1, 1);
                            changes = true;
                        } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                            // Shift the edit over the next equality.
                            diffs[pointer - 1][1] += diffs[pointer + 1][1];
                            diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                            diffs.splice(pointer + 1, 1);
                            changes = true;
                        }
                    }
                    pointer++;
                }
                // If shifts were made, the diff needs reordering and another shift sweep.
                if (changes) diff_cleanupMerge(diffs);
            }
            var diff = diff_main;
            diff.INSERT = DIFF_INSERT;
            diff.DELETE = DIFF_DELETE;
            diff.EQUAL = DIFF_EQUAL;
            module1.exports = diff;
            /*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */ function cursor_normalize_diff(diffs, cursor_pos) {
                if (cursor_pos === 0) return [
                    DIFF_EQUAL,
                    diffs
                ];
                for(var current_pos = 0, i = 0; i < diffs.length; i++){
                    var d = diffs[i];
                    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
                        var next_pos = current_pos + d[1].length;
                        if (cursor_pos === next_pos) return [
                            i + 1,
                            diffs
                        ];
                        else if (cursor_pos < next_pos) {
                            // copy to prevent side effects
                            diffs = diffs.slice();
                            // split d into two diff changes
                            var split_pos = cursor_pos - current_pos;
                            var d_left = [
                                d[0],
                                d[1].slice(0, split_pos)
                            ];
                            var d_right = [
                                d[0],
                                d[1].slice(split_pos)
                            ];
                            diffs.splice(i, 1, d_left, d_right);
                            return [
                                i + 1,
                                diffs
                            ];
                        } else current_pos = next_pos;
                    }
                }
                throw new Error('cursor_pos is out of bounds!');
            }
            /*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */ function fix_cursor(diffs, cursor_pos) {
                var norm = cursor_normalize_diff(diffs, cursor_pos);
                var ndiffs = norm[1];
                var cursor_pointer = norm[0];
                var d = ndiffs[cursor_pointer];
                var d_next = ndiffs[cursor_pointer + 1];
                if (d == null) // Text was deleted from end of original string,
                // cursor is now out of bounds in new string
                return diffs;
                else if (d[0] !== DIFF_EQUAL) // A modification happened at the cursor location.
                // This is the expected outcome, so we can return the original diff.
                return diffs;
                else {
                    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
                        // Case 1)
                        // It is possible to perform a naive shift
                        ndiffs.splice(cursor_pointer, 2, d_next, d);
                        return merge_tuples(ndiffs, cursor_pointer, 2);
                    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
                        // Case 2)
                        // d[1] is a prefix of d_next[1]
                        // We can assume that d_next[0] !== 0, since d[0] === 0
                        // Shift edit locations..
                        ndiffs.splice(cursor_pointer, 2, [
                            d_next[0],
                            d[1]
                        ], [
                            0,
                            d[1]
                        ]);
                        var suffix = d_next[1].slice(d[1].length);
                        if (suffix.length > 0) ndiffs.splice(cursor_pointer + 2, 0, [
                            d_next[0],
                            suffix
                        ]);
                        return merge_tuples(ndiffs, cursor_pointer, 3);
                    } else // Not possible to perform any modification
                    return diffs;
                }
            }
            /*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */ function fix_emoji(diffs) {
                var compact = false;
                var starts_with_pair_end = function starts_with_pair_end(str) {
                    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
                };
                var ends_with_pair_start = function ends_with_pair_start(str) {
                    return str.charCodeAt(str.length - 1) >= 0xD800 && str.charCodeAt(str.length - 1) <= 0xDBFF;
                };
                for(var i = 2; i < diffs.length; i += 1)if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
                    compact = true;
                    diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
                    diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
                    diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
                }
                if (!compact) return diffs;
                var fixed_diffs = [];
                for(var i = 0; i < diffs.length; i += 1)if (diffs[i][1].length > 0) fixed_diffs.push(diffs[i]);
                return fixed_diffs;
            }
            /*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */ function merge_tuples(diffs, start, length) {
                // Check from (start-1) to (start+length).
                for(var i = start + length - 1; i >= 0 && i >= start - 1; i--)if (i + 1 < diffs.length) {
                    var left_d = diffs[i];
                    var right_d = diffs[i + 1];
                    if (left_d[0] === right_d[1]) diffs.splice(i, 2, [
                        left_d[0],
                        left_d[1] + right_d[1]
                    ]);
                }
                return diffs;
            }
        /***/ },
        /* 52 */ /***/ function(module1, exports) {
            exports = module1.exports = typeof Object.keys === 'function' ? Object.keys : shim;
            exports.shim = shim;
            function shim(obj) {
                var keys = [];
                for(var key in obj)keys.push(key);
                return keys;
            }
        /***/ },
        /* 53 */ /***/ function(module1, exports) {
            var supportsArgumentsClass = function() {
                return Object.prototype.toString.call(arguments);
            }() == '[object Arguments]';
            exports = module1.exports = supportsArgumentsClass ? supported : unsupported;
            exports.supported = supported;
            function supported(object) {
                return Object.prototype.toString.call(object) == '[object Arguments]';
            }
            exports.unsupported = unsupported;
            function unsupported(object) {
                return object && (typeof object === "undefined" ? "undefined" : (0, $ewv1T._)(object)) == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
            }
        /***/ },
        /* 54 */ /***/ function(module1, exports) {
            'use strict';
            var has = Object.prototype.hasOwnProperty, prefix = '~';
            /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */ function Events() {}
            //
            // We try to not inherit from `Object.prototype`. In some engines creating an
            // instance in this way is faster than calling `Object.create(null)` directly.
            // If `Object.create(null)` is not supported we prefix the event names with a
            // character to make sure that the built-in object properties are not
            // overridden or used as an attack vector.
            //
            if (Object.create) {
                Events.prototype = Object.create(null);
                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__) prefix = false;
            }
            /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */ function EE(fn, context, once) {
                this.fn = fn;
                this.context = context;
                this.once = once || false;
            }
            /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */ function EventEmitter() {
                this._events = new Events();
                this._eventsCount = 0;
            }
            /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                var names = [], events, name;
                if (this._eventsCount === 0) return names;
                for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                return names;
            };
            /**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */ EventEmitter.prototype.listeners = function listeners(event, exists) {
                var evt = prefix ? prefix + event : event, available = this._events[evt];
                if (exists) return !!available;
                if (!available) return [];
                if (available.fn) return [
                    available.fn
                ];
                for(var i = 0, l = available.length, ee = new Array(l); i < l; i++)ee[i] = available[i].fn;
                return ee;
            };
            /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return false;
                var listeners = this._events[evt], len = arguments.length, args, i;
                if (listeners.fn) {
                    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                    switch(len){
                        case 1:
                            return listeners.fn.call(listeners.context), true;
                        case 2:
                            return listeners.fn.call(listeners.context, a1), true;
                        case 3:
                            return listeners.fn.call(listeners.context, a1, a2), true;
                        case 4:
                            return listeners.fn.call(listeners.context, a1, a2, a3), true;
                        case 5:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                        case 6:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                    }
                    for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                    listeners.fn.apply(listeners.context, args);
                } else {
                    var length = listeners.length, j;
                    for(i = 0; i < length; i++){
                        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                        switch(len){
                            case 1:
                                listeners[i].fn.call(listeners[i].context);
                                break;
                            case 2:
                                listeners[i].fn.call(listeners[i].context, a1);
                                break;
                            case 3:
                                listeners[i].fn.call(listeners[i].context, a1, a2);
                                break;
                            case 4:
                                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                break;
                            default:
                                if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                listeners[i].fn.apply(listeners[i].context, args);
                        }
                    }
                }
                return true;
            };
            /**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return this;
                if (!fn) {
                    if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                    return this;
                }
                var listeners = this._events[evt];
                if (listeners.fn) {
                    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                    //
                    // Reset the array, or remove it completely if we have no more listeners.
                    //
                    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                    else if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                }
                return this;
            };
            /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                    evt = prefix ? prefix + event : event;
                    if (this._events[evt]) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                return this;
            };
            //
            // Alias methods names because people roll like that.
            //
            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
            EventEmitter.prototype.addListener = EventEmitter.prototype.on;
            //
            // This function doesn't apply anymore.
            //
            EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
                return this;
            };
            //
            // Expose the prefix.
            //
            EventEmitter.prefixed = prefix;
            //
            // Allow `EventEmitter` to be imported as module namespace.
            //
            EventEmitter.EventEmitter = EventEmitter;
            //
            // Expose the module.
            //
            if ('undefined' !== typeof module1) module1.exports = EventEmitter;
        /***/ },
        /* 55 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && (0, $ewv1T._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
                return typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $ewv1T._)(obj);
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend2 = __webpack_require__(3);
            var _extend3 = _interopRequireDefault(_extend2);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _align = __webpack_require__(36);
            var _background = __webpack_require__(37);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _color = __webpack_require__(26);
            var _direction = __webpack_require__(38);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:clipboard');
            var DOM_KEY = '__ql-matcher';
            var CLIPBOARD_CONFIG = [
                [
                    Node.TEXT_NODE,
                    matchText
                ],
                [
                    Node.TEXT_NODE,
                    matchNewline
                ],
                [
                    'br',
                    matchBreak
                ],
                [
                    Node.ELEMENT_NODE,
                    matchNewline
                ],
                [
                    Node.ELEMENT_NODE,
                    matchBlot
                ],
                [
                    Node.ELEMENT_NODE,
                    matchSpacing
                ],
                [
                    Node.ELEMENT_NODE,
                    matchAttributor
                ],
                [
                    Node.ELEMENT_NODE,
                    matchStyles
                ],
                [
                    'li',
                    matchIndent
                ],
                [
                    'b',
                    matchAlias.bind(matchAlias, 'bold')
                ],
                [
                    'i',
                    matchAlias.bind(matchAlias, 'italic')
                ],
                [
                    'style',
                    matchIgnore
                ]
            ];
            var ATTRIBUTE_ATTRIBUTORS = [
                _align.AlignAttribute,
                _direction.DirectionAttribute
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var STYLE_ATTRIBUTORS = [
                _align.AlignStyle,
                _background.BackgroundStyle,
                _color.ColorStyle,
                _direction.DirectionStyle,
                _font.FontStyle,
                _size.SizeStyle
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var Clipboard = function(_Module) {
                _inherits(Clipboard, _Module);
                function Clipboard(quill, options) {
                    _classCallCheck(this, Clipboard);
                    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
                    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
                    _this.container = _this.quill.addContainer('ql-clipboard');
                    _this.container.setAttribute('contenteditable', true);
                    _this.container.setAttribute('tabindex', -1);
                    _this.matchers = [];
                    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function(_ref) {
                        var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], matcher = _ref2[1];
                        if (!options.matchVisual && matcher === matchSpacing) return;
                        _this.addMatcher(selector, matcher);
                    });
                    return _this;
                }
                _createClass(Clipboard, [
                    {
                        key: 'addMatcher',
                        value: function addMatcher(selector, matcher) {
                            this.matchers.push([
                                selector,
                                matcher
                            ]);
                        }
                    },
                    {
                        key: 'convert',
                        value: function convert(html) {
                            if (typeof html === 'string') {
                                this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
                                return this.convert();
                            }
                            var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
                            if (formats[_code2.default.blotName]) {
                                var text = this.container.innerText;
                                this.container.innerHTML = '';
                                return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
                            }
                            var _prepareMatching = this.prepareMatching(), _prepareMatching2 = _slicedToArray(_prepareMatching, 2), elementMatchers = _prepareMatching2[0], textMatchers = _prepareMatching2[1];
                            var delta = traverse(this.container, elementMatchers, textMatchers);
                            // Remove trailing newline
                            if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
                            debug.log('convert', this.container.innerHTML, delta);
                            this.container.innerHTML = '';
                            return delta;
                        }
                    },
                    {
                        key: 'dangerouslyPasteHTML',
                        value: function dangerouslyPasteHTML(index, html) {
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
                            if (typeof index === 'string') {
                                this.quill.setContents(this.convert(index), html);
                                this.quill.setSelection(0, _quill2.default.sources.SILENT);
                            } else {
                                var paste = this.convert(html);
                                this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
                                this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
                            }
                        }
                    },
                    {
                        key: 'onPaste',
                        value: function onPaste(e) {
                            var _this2 = this;
                            if (e.defaultPrevented || !this.quill.isEnabled()) return;
                            var range = this.quill.getSelection();
                            var delta = new _quillDelta2.default().retain(range.index);
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.container.focus();
                            this.quill.selection.update(_quill2.default.sources.SILENT);
                            setTimeout(function() {
                                delta = delta.concat(_this2.convert()).delete(range.length);
                                _this2.quill.updateContents(delta, _quill2.default.sources.USER);
                                // range.length contributes to delta.length()
                                _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
                                _this2.quill.scrollingContainer.scrollTop = scrollTop;
                                _this2.quill.focus();
                            }, 1);
                        }
                    },
                    {
                        key: 'prepareMatching',
                        value: function prepareMatching() {
                            var _this3 = this;
                            var elementMatchers = [], textMatchers = [];
                            this.matchers.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), selector = _pair[0], matcher = _pair[1];
                                switch(selector){
                                    case Node.TEXT_NODE:
                                        textMatchers.push(matcher);
                                        break;
                                    case Node.ELEMENT_NODE:
                                        elementMatchers.push(matcher);
                                        break;
                                    default:
                                        [].forEach.call(_this3.container.querySelectorAll(selector), function(node) {
                                            // TODO use weakmap
                                            node[DOM_KEY] = node[DOM_KEY] || [];
                                            node[DOM_KEY].push(matcher);
                                        });
                                        break;
                                }
                            });
                            return [
                                elementMatchers,
                                textMatchers
                            ];
                        }
                    }
                ]);
                return Clipboard;
            }(_module2.default);
            Clipboard.DEFAULTS = {
                matchers: [],
                matchVisual: true
            };
            function applyFormat(delta, format, value) {
                if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') return Object.keys(format).reduce(function(delta, key) {
                    return applyFormat(delta, key, format[key]);
                }, delta);
                else return delta.reduce(function(delta, op) {
                    if (op.attributes && op.attributes[format]) return delta.push(op);
                    else return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
                }, new _quillDelta2.default());
            }
            function computeStyle(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return {};
                var DOM_KEY = '__ql-computed-style';
                return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
            }
            function deltaEndsWith(delta, text) {
                var endText = "";
                for(var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i){
                    var op = delta.ops[i];
                    if (typeof op.insert !== 'string') break;
                    endText = op.insert + endText;
                }
                return endText.slice(-1 * text.length) === text;
            }
            function isLine(node) {
                if (node.childNodes.length === 0) return false; // Exclude embed blocks
                var style = computeStyle(node);
                return [
                    'block',
                    'list-item'
                ].indexOf(style.display) > -1;
            }
            function traverse(node, elementMatchers, textMatchers) {
                // Post-order
                if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce(function(delta, matcher) {
                    return matcher(node, delta);
                }, new _quillDelta2.default());
                else if (node.nodeType === node.ELEMENT_NODE) return [].reduce.call(node.childNodes || [], function(delta, childNode) {
                    var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
                    if (childNode.nodeType === node.ELEMENT_NODE) {
                        childrenDelta = elementMatchers.reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                        childrenDelta = (childNode[DOM_KEY] || []).reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                    }
                    return delta.concat(childrenDelta);
                }, new _quillDelta2.default());
                else return new _quillDelta2.default();
            }
            function matchAlias(format, node, delta) {
                return applyFormat(delta, format, true);
            }
            function matchAttributor(node, delta) {
                var attributes = _parchment2.default.Attributor.Attribute.keys(node);
                var classes = _parchment2.default.Attributor.Class.keys(node);
                var styles = _parchment2.default.Attributor.Style.keys(node);
                var formats = {};
                attributes.concat(classes).concat(styles).forEach(function(name) {
                    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
                    if (attr != null) {
                        formats[attr.attrName] = attr.value(node);
                        if (formats[attr.attrName]) return;
                    }
                    attr = ATTRIBUTE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
                    attr = STYLE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                        attr = STYLE_ATTRIBUTORS[name];
                        formats[attr.attrName] = attr.value(node) || undefined;
                    }
                });
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                return delta;
            }
            function matchBlot(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null) return delta;
                if (match.prototype instanceof _parchment2.default.Embed) {
                    var embed = {};
                    var value = match.value(node);
                    if (value != null) {
                        embed[match.blotName] = value;
                        delta = new _quillDelta2.default().insert(embed, match.formats(node));
                    }
                } else if (typeof match.formats === 'function') delta = applyFormat(delta, match.blotName, match.formats(node));
                return delta;
            }
            function matchBreak(node, delta) {
                if (!deltaEndsWith(delta, '\n')) delta.insert('\n');
                return delta;
            }
            function matchIgnore() {
                return new _quillDelta2.default();
            }
            function matchIndent(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) return delta;
                var indent = -1, parent = node.parentNode;
                while(!parent.classList.contains('ql-clipboard')){
                    if ((_parchment2.default.query(parent) || {}).blotName === 'list') indent += 1;
                    parent = parent.parentNode;
                }
                if (indent <= 0) return delta;
                return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, {
                    indent: indent
                }));
            }
            function matchNewline(node, delta) {
                if (!deltaEndsWith(delta, '\n')) {
                    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) delta.insert('\n');
                }
                return delta;
            }
            function matchSpacing(node, delta) {
                if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
                    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
                    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) delta.insert('\n');
                }
                return delta;
            }
            function matchStyles(node, delta) {
                var formats = {};
                var style = node.style || {};
                if (style.fontStyle && computeStyle(node).fontStyle === 'italic') formats.italic = true;
                if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) formats.bold = true;
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
                delta = new _quillDelta2.default().insert('\t').concat(delta);
                return delta;
            }
            function matchText(node, delta) {
                var text = node.data;
                // Word represents empty line with <o:p>&nbsp;</o:p>
                if (node.parentNode.tagName === 'O:P') return delta.insert(text.trim());
                if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) return delta;
                if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
                    // eslint-disable-next-line func-style
                    var replacer = function replacer(collapse, match) {
                        match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
                        return match.length < 1 && collapse ? ' ' : match;
                    };
                    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
                    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
                    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) text = text.replace(/^\s+/, replacer.bind(replacer, false));
                    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) text = text.replace(/\s+$/, replacer.bind(replacer, false));
                }
                return delta.insert(text);
            }
            exports.default = Clipboard;
            exports.matchAttributor = matchAttributor;
            exports.matchBlot = matchBlot;
            exports.matchNewline = matchNewline;
            exports.matchSpacing = matchSpacing;
            exports.matchText = matchText;
        /***/ },
        /* 56 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Bold = function(_Inline) {
                _inherits(Bold, _Inline);
                function Bold() {
                    _classCallCheck(this, Bold);
                    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
                }
                _createClass(Bold, [
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
                            if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create() {
                            return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return Bold;
            }(_inline2.default);
            Bold.blotName = 'bold';
            Bold.tagName = [
                'STRONG',
                'B'
            ];
            exports.default = Bold;
        /***/ },
        /* 57 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.addControls = exports.default = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:toolbar');
            var Toolbar = function(_Module) {
                _inherits(Toolbar, _Module);
                function Toolbar(quill, options) {
                    _classCallCheck(this, Toolbar);
                    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
                    if (Array.isArray(_this.options.container)) {
                        var container = document.createElement('div');
                        addControls(container, _this.options.container);
                        quill.container.parentNode.insertBefore(container, quill.container);
                        _this.container = container;
                    } else if (typeof _this.options.container === 'string') _this.container = document.querySelector(_this.options.container);
                    else _this.container = _this.options.container;
                    if (!(_this.container instanceof HTMLElement)) {
                        var _ret;
                        return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
                    }
                    _this.container.classList.add('ql-toolbar');
                    _this.controls = [];
                    _this.handlers = {};
                    Object.keys(_this.options.handlers).forEach(function(format) {
                        _this.addHandler(format, _this.options.handlers[format]);
                    });
                    [].forEach.call(_this.container.querySelectorAll('button, select'), function(input) {
                        _this.attach(input);
                    });
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(type, range) {
                        if (type === _quill2.default.events.SELECTION_CHANGE) _this.update(range);
                    });
                    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        var _this$quill$selection = _this.quill.selection.getRange(), _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1), range = _this$quill$selection2[0]; // quill.getSelection triggers update
                        _this.update(range);
                    });
                    return _this;
                }
                _createClass(Toolbar, [
                    {
                        key: 'addHandler',
                        value: function addHandler(format, handler) {
                            this.handlers[format] = handler;
                        }
                    },
                    {
                        key: 'attach',
                        value: function attach(input) {
                            var _this2 = this;
                            var format = [].find.call(input.classList, function(className) {
                                return className.indexOf('ql-') === 0;
                            });
                            if (!format) return;
                            format = format.slice(3);
                            if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
                            if (this.handlers[format] == null) {
                                if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                                    debug.warn('ignoring attaching to disabled format', format, input);
                                    return;
                                }
                                if (_parchment2.default.query(format) == null) {
                                    debug.warn('ignoring attaching to nonexistent format', format, input);
                                    return;
                                }
                            }
                            var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
                            input.addEventListener(eventName, function(e) {
                                var value = void 0;
                                if (input.tagName === 'SELECT') {
                                    if (input.selectedIndex < 0) return;
                                    var selected = input.options[input.selectedIndex];
                                    if (selected.hasAttribute('selected')) value = false;
                                    else value = selected.value || false;
                                } else {
                                    if (input.classList.contains('ql-active')) value = false;
                                    else value = input.value || !input.hasAttribute('value');
                                    e.preventDefault();
                                }
                                _this2.quill.focus();
                                var _quill$selection$getR = _this2.quill.selection.getRange(), _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1), range = _quill$selection$getR2[0];
                                if (_this2.handlers[format] != null) _this2.handlers[format].call(_this2, value);
                                else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                                    value = prompt('Enter ' + format);
                                    if (!value) return;
                                    _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
                                } else _this2.quill.format(format, value, _quill2.default.sources.USER);
                                _this2.update(range);
                            });
                            // TODO use weakmap
                            this.controls.push([
                                format,
                                input
                            ]);
                        }
                    },
                    {
                        key: 'update',
                        value: function update(range) {
                            var formats = range == null ? {} : this.quill.getFormat(range);
                            this.controls.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), format = _pair[0], input = _pair[1];
                                if (input.tagName === 'SELECT') {
                                    var option = void 0;
                                    if (range == null) option = null;
                                    else if (formats[format] == null) option = input.querySelector('option[selected]');
                                    else if (!Array.isArray(formats[format])) {
                                        var value = formats[format];
                                        if (typeof value === 'string') value = value.replace(/\"/g, '\\"');
                                        option = input.querySelector('option[value="' + value + '"]');
                                    }
                                    if (option == null) {
                                        input.value = ''; // TODO make configurable?
                                        input.selectedIndex = -1;
                                    } else option.selected = true;
                                } else {
                                    if (range == null) input.classList.remove('ql-active');
                                    else if (input.hasAttribute('value')) {
                                        // both being null should match (default values)
                                        // '1' should match with 1 (headers)
                                        var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
                                        input.classList.toggle('ql-active', isActive);
                                    } else input.classList.toggle('ql-active', formats[format] != null);
                                }
                            });
                        }
                    }
                ]);
                return Toolbar;
            }(_module2.default);
            Toolbar.DEFAULTS = {};
            function addButton(container, format, value) {
                var input = document.createElement('button');
                input.setAttribute('type', 'button');
                input.classList.add('ql-' + format);
                if (value != null) input.value = value;
                container.appendChild(input);
            }
            function addControls(container, groups) {
                if (!Array.isArray(groups[0])) groups = [
                    groups
                ];
                groups.forEach(function(controls) {
                    var group = document.createElement('span');
                    group.classList.add('ql-formats');
                    controls.forEach(function(control) {
                        if (typeof control === 'string') addButton(group, control);
                        else {
                            var format = Object.keys(control)[0];
                            var value = control[format];
                            if (Array.isArray(value)) addSelect(group, format, value);
                            else addButton(group, format, value);
                        }
                    });
                    container.appendChild(group);
                });
            }
            function addSelect(container, format, values) {
                var input = document.createElement('select');
                input.classList.add('ql-' + format);
                values.forEach(function(value) {
                    var option = document.createElement('option');
                    if (value !== false) option.setAttribute('value', value);
                    else option.setAttribute('selected', 'selected');
                    input.appendChild(option);
                });
                container.appendChild(input);
            }
            Toolbar.DEFAULTS = {
                container: null,
                handlers: {
                    clean: function clean() {
                        var _this3 = this;
                        var range = this.quill.getSelection();
                        if (range == null) return;
                        if (range.length == 0) {
                            var formats = this.quill.getFormat();
                            Object.keys(formats).forEach(function(name) {
                                // Clean functionality in existing apps only clean inline formats
                                if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) _this3.quill.format(name, false);
                            });
                        } else this.quill.removeFormat(range, _quill2.default.sources.USER);
                    },
                    direction: function direction(value) {
                        var align = this.quill.getFormat()['align'];
                        if (value === 'rtl' && align == null) this.quill.format('align', 'right', _quill2.default.sources.USER);
                        else if (!value && align === 'right') this.quill.format('align', false, _quill2.default.sources.USER);
                        this.quill.format('direction', value, _quill2.default.sources.USER);
                    },
                    indent: function indent(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        var indent = parseInt(formats.indent || 0);
                        if (value === '+1' || value === '-1') {
                            var modifier = value === '+1' ? 1 : -1;
                            if (formats.direction === 'rtl') modifier *= -1;
                            this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
                        }
                    },
                    link: function link(value) {
                        if (value === true) value = prompt('Enter link URL:');
                        this.quill.format('link', value, _quill2.default.sources.USER);
                    },
                    list: function list(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        if (value === 'check') {
                            if (formats['list'] === 'checked' || formats['list'] === 'unchecked') this.quill.format('list', false, _quill2.default.sources.USER);
                            else this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
                        } else this.quill.format('list', value, _quill2.default.sources.USER);
                    }
                }
            };
            exports.default = Toolbar;
            exports.addControls = addControls;
        /***/ },
        /* 58 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorPicker = function(_Picker) {
                _inherits(ColorPicker, _Picker);
                function ColorPicker(select, label) {
                    _classCallCheck(this, ColorPicker);
                    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
                    _this.label.innerHTML = label;
                    _this.container.classList.add('ql-color-picker');
                    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function(item) {
                        item.classList.add('ql-primary');
                    });
                    return _this;
                }
                _createClass(ColorPicker, [
                    {
                        key: 'buildItem',
                        value: function buildItem(option) {
                            var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
                            item.style.backgroundColor = option.getAttribute('value') || '';
                            return item;
                        }
                    },
                    {
                        key: 'selectItem',
                        value: function selectItem(item, trigger) {
                            _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
                            var colorLabel = this.label.querySelector('.ql-color-label');
                            var value = item ? item.getAttribute('data-value') || '' : '';
                            if (colorLabel) {
                                if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
                                else colorLabel.style.fill = value;
                            }
                        }
                    }
                ]);
                return ColorPicker;
            }(_picker2.default);
            exports.default = ColorPicker;
        /***/ },
        /* 60 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IconPicker = function(_Picker) {
                _inherits(IconPicker, _Picker);
                function IconPicker(select, icons) {
                    _classCallCheck(this, IconPicker);
                    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
                    _this.container.classList.add('ql-icon-picker');
                    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function(item) {
                        item.innerHTML = icons[item.getAttribute('data-value') || ''];
                    });
                    _this.defaultItem = _this.container.querySelector('.ql-selected');
                    _this.selectItem(_this.defaultItem);
                    return _this;
                }
                _createClass(IconPicker, [
                    {
                        key: 'selectItem',
                        value: function selectItem(item, trigger) {
                            _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
                            item = item || this.defaultItem;
                            this.label.innerHTML = item.innerHTML;
                        }
                    }
                ]);
                return IconPicker;
            }(_picker2.default);
            exports.default = IconPicker;
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Tooltip = function() {
                function Tooltip(quill, boundsContainer) {
                    var _this = this;
                    _classCallCheck(this, Tooltip);
                    this.quill = quill;
                    this.boundsContainer = boundsContainer || document.body;
                    this.root = quill.addContainer('ql-tooltip');
                    this.root.innerHTML = this.constructor.TEMPLATE;
                    if (this.quill.root === this.quill.scrollingContainer) this.quill.root.addEventListener('scroll', function() {
                        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
                    });
                    this.hide();
                }
                _createClass(Tooltip, [
                    {
                        key: 'hide',
                        value: function hide() {
                            this.root.classList.add('ql-hidden');
                        }
                    },
                    {
                        key: 'position',
                        value: function position(reference) {
                            var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
                            // root.scrollTop should be 0 if scrollContainer !== root
                            var top = reference.bottom + this.quill.root.scrollTop;
                            this.root.style.left = left + 'px';
                            this.root.style.top = top + 'px';
                            this.root.classList.remove('ql-flip');
                            var containerBounds = this.boundsContainer.getBoundingClientRect();
                            var rootBounds = this.root.getBoundingClientRect();
                            var shift = 0;
                            if (rootBounds.right > containerBounds.right) {
                                shift = containerBounds.right - rootBounds.right;
                                this.root.style.left = left + shift + 'px';
                            }
                            if (rootBounds.left < containerBounds.left) {
                                shift = containerBounds.left - rootBounds.left;
                                this.root.style.left = left + shift + 'px';
                            }
                            if (rootBounds.bottom > containerBounds.bottom) {
                                var height = rootBounds.bottom - rootBounds.top;
                                var verticalShift = reference.bottom - reference.top + height;
                                this.root.style.top = top - verticalShift + 'px';
                                this.root.classList.add('ql-flip');
                            }
                            return shift;
                        }
                    },
                    {
                        key: 'show',
                        value: function show() {
                            this.root.classList.remove('ql-editing');
                            this.root.classList.remove('ql-hidden');
                        }
                    }
                ]);
                return Tooltip;
            }();
            exports.default = Tooltip;
        /***/ },
        /* 62 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    {
                        header: [
                            '1',
                            '2',
                            '3',
                            false
                        ]
                    }
                ],
                [
                    'bold',
                    'italic',
                    'underline',
                    'link'
                ],
                [
                    {
                        list: 'ordered'
                    },
                    {
                        list: 'bullet'
                    }
                ],
                [
                    'clean'
                ]
            ];
            var SnowTheme = function(_BaseTheme) {
                _inherits(SnowTheme, _BaseTheme);
                function SnowTheme(quill, options) {
                    _classCallCheck(this, SnowTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
                    _this.quill.container.classList.add('ql-snow');
                    return _this;
                }
                _createClass(SnowTheme, [
                    {
                        key: 'extendToolbar',
                        value: function extendToolbar(toolbar) {
                            toolbar.container.classList.add('ql-snow');
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
                            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
                            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                                key: 'K',
                                shortKey: true
                            }, function(range, context) {
                                toolbar.handlers['link'].call(toolbar, !context.format.link);
                            });
                        }
                    }
                ]);
                return SnowTheme;
            }(_base2.default);
            SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (value) {
                                    var range = this.quill.getSelection();
                                    if (range == null || range.length == 0) return;
                                    var preview = this.quill.getText(range);
                                    if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = 'mailto:' + preview;
                                    var tooltip = this.quill.theme.tooltip;
                                    tooltip.edit('link', preview);
                                } else this.quill.format('link', false);
                            }
                        }
                    }
                }
            });
            var SnowTooltip = function(_BaseTooltip) {
                _inherits(SnowTooltip, _BaseTooltip);
                function SnowTooltip(quill, bounds) {
                    _classCallCheck(this, SnowTooltip);
                    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
                    _this2.preview = _this2.root.querySelector('a.ql-preview');
                    return _this2;
                }
                _createClass(SnowTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this3 = this;
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
                            this.root.querySelector('a.ql-action').addEventListener('click', function(event) {
                                if (_this3.root.classList.contains('ql-editing')) _this3.save();
                                else _this3.edit('link', _this3.preview.textContent);
                                event.preventDefault();
                            });
                            this.root.querySelector('a.ql-remove').addEventListener('click', function(event) {
                                if (_this3.linkRange != null) {
                                    var range = _this3.linkRange;
                                    _this3.restoreFocus();
                                    _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
                                    delete _this3.linkRange;
                                }
                                event.preventDefault();
                                _this3.hide();
                            });
                            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function(range, oldRange, source) {
                                if (range == null) return;
                                if (range.length === 0 && source === _emitter2.default.sources.USER) {
                                    var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), link = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                                    if (link != null) {
                                        _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                                        var preview = _link2.default.formats(link.domNode);
                                        _this3.preview.textContent = preview;
                                        _this3.preview.setAttribute('href', preview);
                                        _this3.show();
                                        _this3.position(_this3.quill.getBounds(_this3.linkRange));
                                        return;
                                    }
                                } else delete _this3.linkRange;
                                _this3.hide();
                            });
                        }
                    },
                    {
                        key: 'show',
                        value: function show() {
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
                            this.root.removeAttribute('data-mode');
                        }
                    }
                ]);
                return SnowTooltip;
            }(_base.BaseTooltip);
            SnowTooltip.TEMPLATE = [
                '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-action"></a>',
                '<a class="ql-remove"></a>'
            ].join('');
            exports.default = SnowTheme;
        /***/ },
        /* 63 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _core = __webpack_require__(29);
            var _core2 = _interopRequireDefault(_core);
            var _align = __webpack_require__(36);
            var _direction = __webpack_require__(38);
            var _indent = __webpack_require__(64);
            var _blockquote = __webpack_require__(65);
            var _blockquote2 = _interopRequireDefault(_blockquote);
            var _header = __webpack_require__(66);
            var _header2 = _interopRequireDefault(_header);
            var _list = __webpack_require__(67);
            var _list2 = _interopRequireDefault(_list);
            var _background = __webpack_require__(37);
            var _color = __webpack_require__(26);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            var _italic = __webpack_require__(68);
            var _italic2 = _interopRequireDefault(_italic);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _script = __webpack_require__(69);
            var _script2 = _interopRequireDefault(_script);
            var _strike = __webpack_require__(70);
            var _strike2 = _interopRequireDefault(_strike);
            var _underline = __webpack_require__(71);
            var _underline2 = _interopRequireDefault(_underline);
            var _image = __webpack_require__(72);
            var _image2 = _interopRequireDefault(_image);
            var _video = __webpack_require__(73);
            var _video2 = _interopRequireDefault(_video);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _formula = __webpack_require__(74);
            var _formula2 = _interopRequireDefault(_formula);
            var _syntax = __webpack_require__(75);
            var _syntax2 = _interopRequireDefault(_syntax);
            var _toolbar = __webpack_require__(57);
            var _toolbar2 = _interopRequireDefault(_toolbar);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            var _bubble = __webpack_require__(108);
            var _bubble2 = _interopRequireDefault(_bubble);
            var _snow = __webpack_require__(62);
            var _snow2 = _interopRequireDefault(_snow);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _core2.default.register({
                'attributors/attribute/direction': _direction.DirectionAttribute,
                'attributors/class/align': _align.AlignClass,
                'attributors/class/background': _background.BackgroundClass,
                'attributors/class/color': _color.ColorClass,
                'attributors/class/direction': _direction.DirectionClass,
                'attributors/class/font': _font.FontClass,
                'attributors/class/size': _size.SizeClass,
                'attributors/style/align': _align.AlignStyle,
                'attributors/style/background': _background.BackgroundStyle,
                'attributors/style/color': _color.ColorStyle,
                'attributors/style/direction': _direction.DirectionStyle,
                'attributors/style/font': _font.FontStyle,
                'attributors/style/size': _size.SizeStyle
            }, true);
            _core2.default.register({
                'formats/align': _align.AlignClass,
                'formats/direction': _direction.DirectionClass,
                'formats/indent': _indent.IndentClass,
                'formats/background': _background.BackgroundStyle,
                'formats/color': _color.ColorStyle,
                'formats/font': _font.FontClass,
                'formats/size': _size.SizeClass,
                'formats/blockquote': _blockquote2.default,
                'formats/code-block': _code2.default,
                'formats/header': _header2.default,
                'formats/list': _list2.default,
                'formats/bold': _bold2.default,
                'formats/code': _code.Code,
                'formats/italic': _italic2.default,
                'formats/link': _link2.default,
                'formats/script': _script2.default,
                'formats/strike': _strike2.default,
                'formats/underline': _underline2.default,
                'formats/image': _image2.default,
                'formats/video': _video2.default,
                'formats/list/item': _list.ListItem,
                'modules/formula': _formula2.default,
                'modules/syntax': _syntax2.default,
                'modules/toolbar': _toolbar2.default,
                'themes/bubble': _bubble2.default,
                'themes/snow': _snow2.default,
                'ui/icons': _icons2.default,
                'ui/picker': _picker2.default,
                'ui/icon-picker': _iconPicker2.default,
                'ui/color-picker': _colorPicker2.default,
                'ui/tooltip': _tooltip2.default
            }, true);
            exports.default = _core2.default;
        /***/ },
        /* 64 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.IndentClass = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IdentAttributor = function(_Parchment$Attributor) {
                _inherits(IdentAttributor, _Parchment$Attributor);
                function IdentAttributor() {
                    _classCallCheck(this, IdentAttributor);
                    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
                }
                _createClass(IdentAttributor, [
                    {
                        key: 'add',
                        value: function add(node, value) {
                            if (value === '+1' || value === '-1') {
                                var indent = this.value(node) || 0;
                                value = value === '+1' ? indent + 1 : indent - 1;
                            }
                            if (value === 0) {
                                this.remove(node);
                                return true;
                            } else return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
                        }
                    },
                    {
                        key: 'canAdd',
                        value: function canAdd(node, value) {
                            return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
                        }
                    },
                    {
                        key: 'value',
                        value: function value(node) {
                            return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
                        }
                    }
                ]);
                return IdentAttributor;
            }(_parchment2.default.Attributor.Class);
            var IndentClass = new IdentAttributor('indent', 'ql-indent', {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8
                ]
            });
            exports.IndentClass = IndentClass;
        /***/ },
        /* 65 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Blockquote = function(_Block) {
                _inherits(Blockquote, _Block);
                function Blockquote() {
                    _classCallCheck(this, Blockquote);
                    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
                }
                return Blockquote;
            }(_block2.default);
            Blockquote.blotName = 'blockquote';
            Blockquote.tagName = 'blockquote';
            exports.default = Blockquote;
        /***/ },
        /* 66 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Header = function(_Block) {
                _inherits(Header, _Block);
                function Header() {
                    _classCallCheck(this, Header);
                    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
                }
                _createClass(Header, null, [
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return this.tagName.indexOf(domNode.tagName) + 1;
                        }
                    }
                ]);
                return Header;
            }(_block2.default);
            Header.blotName = 'header';
            Header.tagName = [
                'H1',
                'H2',
                'H3',
                'H4',
                'H5',
                'H6'
            ];
            exports.default = Header;
        /***/ },
        /* 67 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.ListItem = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ListItem = function(_Block) {
                _inherits(ListItem, _Block);
                function ListItem() {
                    _classCallCheck(this, ListItem);
                    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
                }
                _createClass(ListItem, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name === List.blotName && !value) this.replaceWith(_parchment2.default.create(this.statics.scope));
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
                        }
                    },
                    {
                        key: 'remove',
                        value: function remove() {
                            if (this.prev == null && this.next == null) this.parent.remove();
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
                        }
                    },
                    {
                        key: 'replaceWith',
                        value: function replaceWith(name, value) {
                            this.parent.isolate(this.offset(this.parent), this.length());
                            if (name === this.parent.statics.blotName) {
                                this.parent.replaceWith(name, value);
                                return this;
                            } else {
                                this.parent.unwrap();
                                return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
                            }
                        }
                    }
                ], [
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
                        }
                    }
                ]);
                return ListItem;
            }(_block2.default);
            ListItem.blotName = 'list-item';
            ListItem.tagName = 'LI';
            var List = function(_Container) {
                _inherits(List, _Container);
                _createClass(List, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            var tagName = value === 'ordered' ? 'OL' : 'UL';
                            var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
                            if (value === 'checked' || value === 'unchecked') node.setAttribute('data-checked', value === 'checked');
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            if (domNode.tagName === 'OL') return 'ordered';
                            if (domNode.tagName === 'UL') {
                                if (domNode.hasAttribute('data-checked')) return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
                                else return 'bullet';
                            }
                            return undefined;
                        }
                    }
                ]);
                function List(domNode) {
                    _classCallCheck(this, List);
                    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
                    var listEventHandler = function listEventHandler(e) {
                        if (e.target.parentNode !== domNode) return;
                        var format = _this2.statics.formats(domNode);
                        var blot = _parchment2.default.find(e.target);
                        if (format === 'checked') blot.format('list', 'unchecked');
                        else if (format === 'unchecked') blot.format('list', 'checked');
                    };
                    domNode.addEventListener('touchstart', listEventHandler);
                    domNode.addEventListener('mousedown', listEventHandler);
                    return _this2;
                }
                _createClass(List, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (this.children.length > 0) this.children.tail.format(name, value);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            // We don't inherit from FormatBlot
                            return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            if (blot instanceof ListItem) _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
                            else {
                                var index = ref == null ? this.length() : ref.offset(this);
                                var after = this.split(index);
                                after.parent.insertBefore(blot, after);
                            }
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: 'replace',
                        value: function replace(target) {
                            if (target.statics.blotName !== this.statics.blotName) {
                                var item = _parchment2.default.create(this.statics.defaultChild);
                                target.moveChildren(item);
                                this.appendChild(item);
                            }
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
                        }
                    }
                ]);
                return List;
            }(_container2.default);
            List.blotName = 'list';
            List.scope = _parchment2.default.Scope.BLOCK_BLOT;
            List.tagName = [
                'OL',
                'UL'
            ];
            List.defaultChild = 'list-item';
            List.allowedChildren = [
                ListItem
            ];
            exports.ListItem = ListItem;
            exports.default = List;
        /***/ },
        /* 68 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Italic = function(_Bold) {
                _inherits(Italic, _Bold);
                function Italic() {
                    _classCallCheck(this, Italic);
                    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
                }
                return Italic;
            }(_bold2.default);
            Italic.blotName = 'italic';
            Italic.tagName = [
                'EM',
                'I'
            ];
            exports.default = Italic;
        /***/ },
        /* 69 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Script = function(_Inline) {
                _inherits(Script, _Inline);
                function Script() {
                    _classCallCheck(this, Script);
                    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
                }
                _createClass(Script, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            if (value === 'super') return document.createElement('sup');
                            else if (value === 'sub') return document.createElement('sub');
                            else return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            if (domNode.tagName === 'SUB') return 'sub';
                            if (domNode.tagName === 'SUP') return 'super';
                            return undefined;
                        }
                    }
                ]);
                return Script;
            }(_inline2.default);
            Script.blotName = 'script';
            Script.tagName = [
                'SUB',
                'SUP'
            ];
            exports.default = Script;
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Strike = function(_Inline) {
                _inherits(Strike, _Inline);
                function Strike() {
                    _classCallCheck(this, Strike);
                    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
                }
                return Strike;
            }(_inline2.default);
            Strike.blotName = 'strike';
            Strike.tagName = 'S';
            exports.default = Strike;
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Underline = function(_Inline) {
                _inherits(Underline, _Inline);
                function Underline() {
                    _classCallCheck(this, Underline);
                    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
                }
                return Underline;
            }(_inline2.default);
            Underline.blotName = 'underline';
            Underline.tagName = 'U';
            exports.default = Underline;
        /***/ },
        /* 72 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _link = __webpack_require__(27);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                'alt',
                'height',
                'width'
            ];
            var Image = function(_Parchment$Embed) {
                _inherits(Image, _Parchment$Embed);
                function Image() {
                    _classCallCheck(this, Image);
                    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
                }
                _createClass(Image, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
                            if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: 'match',
                        value: function match(url) {
                            return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return (0, _link.sanitize)(url, [
                                'http',
                                'https',
                                'data'
                            ]) ? url : '//:0';
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('src');
                        }
                    }
                ]);
                return Image;
            }(_parchment2.default.Embed);
            Image.blotName = 'image';
            Image.tagName = 'IMG';
            exports.default = Image;
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _block = __webpack_require__(4);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                'height',
                'width'
            ];
            var Video = function(_BlockEmbed) {
                _inherits(Video, _BlockEmbed);
                function Video() {
                    _classCallCheck(this, Video);
                    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
                }
                _createClass(Video, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
                            node.setAttribute('frameborder', '0');
                            node.setAttribute('allowfullscreen', true);
                            node.setAttribute('src', this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return _link2.default.sanitize(url);
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('src');
                        }
                    }
                ]);
                return Video;
            }(_block.BlockEmbed);
            Video.blotName = 'video';
            Video.className = 'ql-video';
            Video.tagName = 'IFRAME';
            exports.default = Video;
        /***/ },
        /* 74 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.FormulaBlot = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var FormulaBlot = function(_Embed) {
                _inherits(FormulaBlot, _Embed);
                function FormulaBlot() {
                    _classCallCheck(this, FormulaBlot);
                    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
                }
                _createClass(FormulaBlot, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
                            if (typeof value === 'string') {
                                window.katex.render(value, node, {
                                    throwOnError: false,
                                    errorColor: '#f00'
                                });
                                node.setAttribute('data-value', value);
                            }
                            return node;
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('data-value');
                        }
                    }
                ]);
                return FormulaBlot;
            }(_embed2.default);
            FormulaBlot.blotName = 'formula';
            FormulaBlot.className = 'ql-formula';
            FormulaBlot.tagName = 'SPAN';
            var Formula = function(_Module) {
                _inherits(Formula, _Module);
                _createClass(Formula, null, [
                    {
                        key: 'register',
                        value: function register() {
                            _quill2.default.register(FormulaBlot, true);
                        }
                    }
                ]);
                function Formula() {
                    _classCallCheck(this, Formula);
                    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
                    if (window.katex == null) throw new Error('Formula module requires KaTeX.');
                    return _this2;
                }
                return Formula;
            }(_module2.default);
            exports.FormulaBlot = FormulaBlot;
            exports.default = Formula;
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.CodeToken = exports.CodeBlock = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var SyntaxCodeBlock = function(_CodeBlock) {
                _inherits(SyntaxCodeBlock, _CodeBlock);
                function SyntaxCodeBlock() {
                    _classCallCheck(this, SyntaxCodeBlock);
                    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
                }
                _createClass(SyntaxCodeBlock, [
                    {
                        key: 'replaceWith',
                        value: function replaceWith(block) {
                            this.domNode.textContent = this.domNode.textContent;
                            this.attach();
                            _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
                        }
                    },
                    {
                        key: 'highlight',
                        value: function highlight(_highlight) {
                            var text = this.domNode.textContent;
                            if (this.cachedText !== text) {
                                if (text.trim().length > 0 || this.cachedText == null) {
                                    this.domNode.innerHTML = _highlight(text);
                                    this.domNode.normalize();
                                    this.attach();
                                }
                                this.cachedText = text;
                            }
                        }
                    }
                ]);
                return SyntaxCodeBlock;
            }(_code2.default);
            SyntaxCodeBlock.className = 'ql-syntax';
            var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
                scope: _parchment2.default.Scope.INLINE
            });
            var Syntax = function(_Module) {
                _inherits(Syntax, _Module);
                _createClass(Syntax, null, [
                    {
                        key: 'register',
                        value: function register() {
                            _quill2.default.register(CodeToken, true);
                            _quill2.default.register(SyntaxCodeBlock, true);
                        }
                    }
                ]);
                function Syntax(quill, options) {
                    _classCallCheck(this, Syntax);
                    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
                    if (typeof _this2.options.highlight !== 'function') throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
                    var timer = null;
                    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        clearTimeout(timer);
                        timer = setTimeout(function() {
                            _this2.highlight();
                            timer = null;
                        }, _this2.options.interval);
                    });
                    _this2.highlight();
                    return _this2;
                }
                _createClass(Syntax, [
                    {
                        key: 'highlight',
                        value: function highlight() {
                            var _this3 = this;
                            if (this.quill.selection.composing) return;
                            this.quill.update(_quill2.default.sources.USER);
                            var range = this.quill.getSelection();
                            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function(code) {
                                code.highlight(_this3.options.highlight);
                            });
                            this.quill.update(_quill2.default.sources.SILENT);
                            if (range != null) this.quill.setSelection(range, _quill2.default.sources.SILENT);
                        }
                    }
                ]);
                return Syntax;
            }(_module2.default);
            Syntax.DEFAULTS = {
                highlight: function() {
                    if (window.hljs == null) return null;
                    return function(text) {
                        var result = window.hljs.highlightAuto(text);
                        return result.value;
                    };
                }(),
                interval: 1000
            };
            exports.CodeBlock = SyntaxCodeBlock;
            exports.CodeToken = CodeToken;
            exports.default = Syntax;
        /***/ },
        /* 76 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 77 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 78 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 79 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 80 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
        /***/ },
        /* 81 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
        /***/ },
        /* 82 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
        /***/ },
        /* 83 */ /***/ function(module1, exports) {
            module1.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
        /***/ },
        /* 84 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
        /***/ },
        /* 85 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
        /***/ },
        /* 86 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
        /***/ },
        /* 87 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 88 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 89 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 90 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
        /***/ },
        /* 91 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
        /***/ },
        /* 92 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
        /***/ },
        /* 93 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
        /***/ },
        /* 94 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
        /***/ },
        /* 95 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
        /***/ },
        /* 96 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
        /***/ },
        /* 97 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
        /***/ },
        /* 98 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
        /***/ },
        /* 99 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
        /***/ },
        /* 100 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
        /***/ },
        /* 101 */ /***/ function(module1, exports) {
            module1.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
        /***/ },
        /* 102 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
        /***/ },
        /* 103 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
        /***/ },
        /* 104 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
        /***/ },
        /* 105 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
        /***/ },
        /* 106 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
        /***/ },
        /* 107 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
        /***/ },
        /* 108 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BubbleTooltip = undefined;
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && ((typeof call === "undefined" ? "undefined" : (0, $ewv1T._)(call)) === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $ewv1T._)(superClass)));
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    'bold',
                    'italic',
                    'link'
                ],
                [
                    {
                        header: 1
                    },
                    {
                        header: 2
                    },
                    'blockquote'
                ]
            ];
            var BubbleTheme = function(_BaseTheme) {
                _inherits(BubbleTheme, _BaseTheme);
                function BubbleTheme(quill, options) {
                    _classCallCheck(this, BubbleTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
                    _this.quill.container.classList.add('ql-bubble');
                    return _this;
                }
                _createClass(BubbleTheme, [
                    {
                        key: 'extendToolbar',
                        value: function extendToolbar(toolbar) {
                            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
                            this.tooltip.root.appendChild(toolbar.container);
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
                        }
                    }
                ]);
                return BubbleTheme;
            }(_base2.default);
            BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (!value) this.quill.format('link', false);
                                else this.quill.theme.tooltip.edit();
                            }
                        }
                    }
                }
            });
            var BubbleTooltip = function(_BaseTooltip) {
                _inherits(BubbleTooltip, _BaseTooltip);
                function BubbleTooltip(quill, bounds) {
                    _classCallCheck(this, BubbleTooltip);
                    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
                    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function(type, range, oldRange, source) {
                        if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
                        if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
                            _this2.show();
                            // Lock our width so we will expand beyond our offsetParent boundaries
                            _this2.root.style.left = '0px';
                            _this2.root.style.width = '';
                            _this2.root.style.width = _this2.root.offsetWidth + 'px';
                            var lines = _this2.quill.getLines(range.index, range.length);
                            if (lines.length === 1) _this2.position(_this2.quill.getBounds(range));
                            else {
                                var lastLine = lines[lines.length - 1];
                                var index = _this2.quill.getIndex(lastLine);
                                var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                                var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                                _this2.position(_bounds);
                            }
                        } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) _this2.hide();
                    });
                    return _this2;
                }
                _createClass(BubbleTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this3 = this;
                            _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
                            this.root.querySelector('.ql-close').addEventListener('click', function() {
                                _this3.root.classList.remove('ql-editing');
                            });
                            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function() {
                                // Let selection be restored by toolbar handlers before repositioning
                                setTimeout(function() {
                                    if (_this3.root.classList.contains('ql-hidden')) return;
                                    var range = _this3.quill.getSelection();
                                    if (range != null) _this3.position(_this3.quill.getBounds(range));
                                }, 1);
                            });
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            this.show();
                        }
                    },
                    {
                        key: 'position',
                        value: function position(reference) {
                            var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
                            var arrow = this.root.querySelector('.ql-tooltip-arrow');
                            arrow.style.marginLeft = '';
                            if (shift === 0) return shift;
                            arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
                        }
                    }
                ]);
                return BubbleTooltip;
            }(_base.BaseTooltip);
            BubbleTooltip.TEMPLATE = [
                '<span class="ql-tooltip-arrow"></span>',
                '<div class="ql-tooltip-editor">',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-close"></a>',
                '</div>'
            ].join('');
            exports.BubbleTooltip = BubbleTooltip;
            exports.default = BubbleTheme;
        /***/ },
        /* 109 */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(63);
        /***/ }
    ])["default"];
});


// packages/persist/src/index.js
function $40d4926a28a4e7b6$export$9a6132153fba2e0(Alpine) {
    var persist = function() {
        var alias;
        var storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            var dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor(function(initialValue, getter, setter, path, key) {
            var lookup = alias || "_x_".concat(path);
            var initial = $40d4926a28a4e7b6$var$storageHas(lookup, storage) ? $40d4926a28a4e7b6$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(function() {
                var value = getter();
                $40d4926a28a4e7b6$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, function(func) {
            func.as = function(key) {
                alias = key;
                return func;
            }, func.using = function(target) {
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: function() {
            return persist();
        }
    });
    Alpine.magic("persist", persist);
    Alpine.persist = function(key, param) {
        var get = param.get, set = param.set, storage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : localStorage;
        var initial = $40d4926a28a4e7b6$var$storageHas(key, storage) ? $40d4926a28a4e7b6$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(function() {
            var value = get();
            $40d4926a28a4e7b6$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $40d4926a28a4e7b6$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $40d4926a28a4e7b6$var$storageGet(key, storage) {
    var value = storage.getItem(key);
    if (value === void 0) return;
    return JSON.parse(value);
}
function $40d4926a28a4e7b6$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $40d4926a28a4e7b6$export$2e2bcd8739ae039 = $40d4926a28a4e7b6$export$9a6132153fba2e0;


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $ae6b57f0e78ec8ec$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $a7058b172c30126e$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $4bed39108b1fd025$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $a7058b172c30126e$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $4bed39108b1fd025$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $a7058b172c30126e$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $4bed39108b1fd025$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $a7058b172c30126e$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $d42475e99d0081f3$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(element) || !(0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $d42475e99d0081f3$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(element) || !(0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $d42475e99d0081f3$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $d42475e99d0081f3$var$applyStyles,
    effect: $d42475e99d0081f3$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $19d6436c0f4af3e9$export$8960430cfd85939f = Math.max;
var $19d6436c0f4af3e9$export$96ec731ed4dcb222 = Math.min;
var $19d6436c0f4af3e9$export$2077e0241d6afd3c = Math.round;



function $780cf07e4ea52393$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $d780c15d7700cc2d$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $780cf07e4ea52393$export$2e2bcd8739ae039)());
}


function $3a32eec84a10e866$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $19d6436c0f4af3e9$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $19d6436c0f4af3e9$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $4bed39108b1fd025$export$45a5e7f76e0caa8d)(element) ? (0, $a7058b172c30126e$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d780c15d7700cc2d$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $a237eda17481ca01$export$2e2bcd8739ae039(node) {
    var win = (0, $a7058b172c30126e$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $ef53d80b78e0a76b$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $351734f5300e4604$export$2e2bcd8739ae039(node) {
    if (node === (0, $a7058b172c30126e$export$2e2bcd8739ae039)(node) || !(0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(node)) return (0, $a237eda17481ca01$export$2e2bcd8739ae039)(node);
    else return (0, $ef53d80b78e0a76b$export$2e2bcd8739ae039)(node);
}






function $8377b4e6149020d8$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $4bed39108b1fd025$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $317e0ca24bb366f5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $3a32eec84a10e866$export$2e2bcd8739ae039)((0, $8377b4e6149020d8$export$2e2bcd8739ae039)(element)).left + (0, $a237eda17481ca01$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $ec46cf64abe23b28$export$2e2bcd8739ae039(element) {
    return (0, $a7058b172c30126e$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $d821b3b388347f60$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $d0e7921c158fe8af$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $19d6436c0f4af3e9$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $19d6436c0f4af3e9$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d0e7921c158fe8af$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(offsetParent) && $d0e7921c158fe8af$var$isElementScaled(offsetParent);
    var documentElement = (0, $8377b4e6149020d8$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $3a32eec84a10e866$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $d821b3b388347f60$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $351734f5300e4604$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $3a32eec84a10e866$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $317e0ca24bb366f5$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $99c3f4e91033a5ca$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $3a32eec84a10e866$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $5b94d6d5eef8d77f$export$2e2bcd8739ae039(element) {
    if ((0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $4bed39108b1fd025$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8377b4e6149020d8$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $0654747dfa294ac0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(node) && (0, $d821b3b388347f60$export$2e2bcd8739ae039)(node)) return node;
    return $0654747dfa294ac0$export$2e2bcd8739ae039((0, $5b94d6d5eef8d77f$export$2e2bcd8739ae039)(node));
}





function $8c32db821464bd8f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $0654747dfa294ac0$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $a7058b172c30126e$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $d821b3b388347f60$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($8c32db821464bd8f$export$2e2bcd8739ae039((0, $5b94d6d5eef8d77f$export$2e2bcd8739ae039)(target)));
}







function $6b36a62b0601d665$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(element)) >= 0;
}




function $ec19f1c872e2f1dc$var$getTrueOffsetParent(element) {
    if (!(0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $ec19f1c872e2f1dc$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $780cf07e4ea52393$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $780cf07e4ea52393$export$2e2bcd8739ae039)());
    if (isIE && (0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5b94d6d5eef8d77f$export$2e2bcd8739ae039)(element);
    if ((0, $4bed39108b1fd025$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $ec19f1c872e2f1dc$export$2e2bcd8739ae039(element) {
    var window = (0, $a7058b172c30126e$export$2e2bcd8739ae039)(element);
    var offsetParent = $ec19f1c872e2f1dc$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6b36a62b0601d665$export$2e2bcd8739ae039)(offsetParent) && (0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $ec19f1c872e2f1dc$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $ec19f1c872e2f1dc$var$getContainingBlock(element) || window;
}


var $11082a31956663b4$export$1e95b668f3b82d = 'top';
var $11082a31956663b4$export$40e543e69a8b3fbb = 'bottom';
var $11082a31956663b4$export$79ffe56a765070d2 = 'right';
var $11082a31956663b4$export$eabcd2c8791e7bf4 = 'left';
var $11082a31956663b4$export$dfb5619354ba860 = 'auto';
var $11082a31956663b4$export$aec2ce47c367b8c3 = [
    $11082a31956663b4$export$1e95b668f3b82d,
    $11082a31956663b4$export$40e543e69a8b3fbb,
    $11082a31956663b4$export$79ffe56a765070d2,
    $11082a31956663b4$export$eabcd2c8791e7bf4
];
var $11082a31956663b4$export$b3571188c770cc5a = 'start';
var $11082a31956663b4$export$bd5df0f255a350f8 = 'end';
var $11082a31956663b4$export$390fd549c5303b4d = 'clippingParents';
var $11082a31956663b4$export$d7b7311ec04a3e8f = 'viewport';
var $11082a31956663b4$export$ae5ab1c730825774 = 'popper';
var $11082a31956663b4$export$ca50aac9f3ba507f = 'reference';
var $11082a31956663b4$export$368f9a87e87fa4e1 = /*#__PURE__*/ $11082a31956663b4$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $11082a31956663b4$export$b3571188c770cc5a,
        placement + "-" + $11082a31956663b4$export$bd5df0f255a350f8
    ]);
}, []);
var $11082a31956663b4$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($11082a31956663b4$export$aec2ce47c367b8c3, [
    $11082a31956663b4$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $11082a31956663b4$export$b3571188c770cc5a,
        placement + "-" + $11082a31956663b4$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $11082a31956663b4$export$421679a7c3d56e = 'beforeRead';
var $11082a31956663b4$export$aafa59e2e03f2942 = 'read';
var $11082a31956663b4$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $11082a31956663b4$export$c65e99957a05207c = 'beforeMain';
var $11082a31956663b4$export$f22da7240b7add18 = 'main';
var $11082a31956663b4$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $11082a31956663b4$export$8d4d2d70e7d46032 = 'beforeWrite';
var $11082a31956663b4$export$68d8715fc104d294 = 'write';
var $11082a31956663b4$export$70a6e5159acce2e6 = 'afterWrite';
var $11082a31956663b4$export$d087d3878fdf71d5 = [
    $11082a31956663b4$export$421679a7c3d56e,
    $11082a31956663b4$export$aafa59e2e03f2942,
    $11082a31956663b4$export$6964f6c886723980,
    $11082a31956663b4$export$c65e99957a05207c,
    $11082a31956663b4$export$f22da7240b7add18,
    $11082a31956663b4$export$bab79516f2d662fe,
    $11082a31956663b4$export$8d4d2d70e7d46032,
    $11082a31956663b4$export$68d8715fc104d294,
    $11082a31956663b4$export$70a6e5159acce2e6
];


function $3eec420c72c2106a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3eec420c72c2106a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3eec420c72c2106a$var$order(modifiers); // order based on phase
    return (0, $11082a31956663b4$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $08b0eb2b9b9666a8$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $469556cce533b5fa$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $f9b0a08508f2953b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $f9b0a08508f2953b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $f9b0a08508f2953b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $f9b0a08508f2953b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $f9b0a08508f2953b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $4bed39108b1fd025$export$45a5e7f76e0caa8d)(reference) ? (0, $8c32db821464bd8f$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $8c32db821464bd8f$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $8c32db821464bd8f$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3eec420c72c2106a$export$2e2bcd8739ae039)((0, $469556cce533b5fa$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$f9b0a08508f2953b$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d0e7921c158fe8af$export$2e2bcd8739ae039)(_$reference, (0, $ec19f1c872e2f1dc$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $99c3f4e91033a5ca$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $08b0eb2b9b9666a8$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$f9b0a08508f2953b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $f9b0a08508f2953b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $f9b0a08508f2953b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e3cab82015899eed$var$passive = {
    passive: true
};
function $e3cab82015899eed$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $a7058b172c30126e$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e3cab82015899eed$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e3cab82015899eed$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e3cab82015899eed$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e3cab82015899eed$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e3cab82015899eed$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e3cab82015899eed$var$effect,
    data: {}
};



function $f98a69c21c9b0699$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $77e73c32bd9804f6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $afab05245a072803$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $2da7c3ff31e61a66$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $77e73c32bd9804f6$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $11082a31956663b4$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $11082a31956663b4$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $11082a31956663b4$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $11082a31956663b4$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $afab05245a072803$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $11082a31956663b4$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $11082a31956663b4$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ba8e6cf1d65280ba$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2da7c3ff31e61a66$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ba8e6cf1d65280ba$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ba8e6cf1d65280ba$var$popperOffsets,
    data: {}
};










var $af1d3781f5be3675$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $af1d3781f5be3675$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $19d6436c0f4af3e9$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $19d6436c0f4af3e9$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $af1d3781f5be3675$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $11082a31956663b4$export$eabcd2c8791e7bf4);
    var sideY = (0, $11082a31956663b4$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ec19f1c872e2f1dc$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $a7058b172c30126e$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $8377b4e6149020d8$export$2e2bcd8739ae039)(popper);
            if ((0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $11082a31956663b4$export$1e95b668f3b82d) || (placement === (0, $11082a31956663b4$export$eabcd2c8791e7bf4) || placement === (0, $11082a31956663b4$export$79ffe56a765070d2)) && variation === (0, $11082a31956663b4$export$bd5df0f255a350f8)) {
            sideY = (0, $11082a31956663b4$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $11082a31956663b4$export$eabcd2c8791e7bf4) || (placement === (0, $11082a31956663b4$export$1e95b668f3b82d) || placement === (0, $11082a31956663b4$export$40e543e69a8b3fbb)) && variation === (0, $11082a31956663b4$export$bd5df0f255a350f8)) {
            sideX = (0, $11082a31956663b4$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $af1d3781f5be3675$var$unsetSides);
    var _ref4 = roundOffsets === true ? $af1d3781f5be3675$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $a7058b172c30126e$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $af1d3781f5be3675$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $77e73c32bd9804f6$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $af1d3781f5be3675$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $af1d3781f5be3675$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $af1d3781f5be3675$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $af1d3781f5be3675$var$computeStyles,
    data: {}
};





function $b2cd51857ceebf7a$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $11082a31956663b4$export$eabcd2c8791e7bf4),
        (0, $11082a31956663b4$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $11082a31956663b4$export$eabcd2c8791e7bf4),
        (0, $11082a31956663b4$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $b2cd51857ceebf7a$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $11082a31956663b4$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $b2cd51857ceebf7a$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b2cd51857ceebf7a$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $b2cd51857ceebf7a$var$offset
};


var $851489ec79ead4fc$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $851489ec79ead4fc$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $851489ec79ead4fc$var$hash[matched];
    });
}



var $f97ac6e9b417a35d$var$hash = {
    start: 'end',
    end: 'start'
};
function $f97ac6e9b417a35d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f97ac6e9b417a35d$var$hash[matched];
    });
}







function $609b3fb062bbfeee$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $a7058b172c30126e$export$2e2bcd8739ae039)(element);
    var html = (0, $8377b4e6149020d8$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d780c15d7700cc2d$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $317e0ca24bb366f5$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e987f8a20c8e366a$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8377b4e6149020d8$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $a237eda17481ca01$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $19d6436c0f4af3e9$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $19d6436c0f4af3e9$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $317e0ca24bb366f5$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $19d6436c0f4af3e9$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $7bf8e8ee4e1db72b$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $4bed39108b1fd025$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $0efc2df7ba082ec8$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $d7f65760cbafc036$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $3a32eec84a10e866$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d7f65760cbafc036$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $11082a31956663b4$export$d7b7311ec04a3e8f) ? (0, $0efc2df7ba082ec8$export$2e2bcd8739ae039)((0, $609b3fb062bbfeee$export$2e2bcd8739ae039)(element, strategy)) : (0, $4bed39108b1fd025$export$45a5e7f76e0caa8d)(clippingParent) ? $d7f65760cbafc036$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $0efc2df7ba082ec8$export$2e2bcd8739ae039)((0, $e987f8a20c8e366a$export$2e2bcd8739ae039)((0, $8377b4e6149020d8$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d7f65760cbafc036$var$getClippingParents(element) {
    var clippingParents = (0, $8c32db821464bd8f$export$2e2bcd8739ae039)((0, $5b94d6d5eef8d77f$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $ec46cf64abe23b28$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $4bed39108b1fd025$export$1b3bfaa9684536aa)(element) ? (0, $ec19f1c872e2f1dc$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $4bed39108b1fd025$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $4bed39108b1fd025$export$45a5e7f76e0caa8d)(clippingParent) && (0, $7bf8e8ee4e1db72b$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $ae6b57f0e78ec8ec$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d7f65760cbafc036$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $d7f65760cbafc036$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d7f65760cbafc036$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $19d6436c0f4af3e9$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $19d6436c0f4af3e9$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $19d6436c0f4af3e9$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $19d6436c0f4af3e9$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $d7f65760cbafc036$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $76360d50df3bb7b8$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $5503f1f04f1f7f25$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $76360d50df3bb7b8$export$2e2bcd8739ae039)(), paddingObject);
}


function $2a108dded3a7cebc$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $94eaff7d6e5f4ebb$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $11082a31956663b4$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $11082a31956663b4$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $11082a31956663b4$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5503f1f04f1f7f25$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $2a108dded3a7cebc$export$2e2bcd8739ae039)(padding, (0, $11082a31956663b4$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $11082a31956663b4$export$ae5ab1c730825774) ? (0, $11082a31956663b4$export$ca50aac9f3ba507f) : (0, $11082a31956663b4$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $d7f65760cbafc036$export$2e2bcd8739ae039)((0, $4bed39108b1fd025$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $8377b4e6149020d8$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $3a32eec84a10e866$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $2da7c3ff31e61a66$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $0efc2df7ba082ec8$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $11082a31956663b4$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $11082a31956663b4$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $11082a31956663b4$export$79ffe56a765070d2),
                (0, $11082a31956663b4$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $11082a31956663b4$export$1e95b668f3b82d),
                (0, $11082a31956663b4$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $af2318c320f452bc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $11082a31956663b4$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $77e73c32bd9804f6$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $11082a31956663b4$export$368f9a87e87fa4e1) : (0, $11082a31956663b4$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $77e73c32bd9804f6$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $11082a31956663b4$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $94eaff7d6e5f4ebb$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a40714eabafca65f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(placement) === (0, $11082a31956663b4$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $851489ec79ead4fc$export$2e2bcd8739ae039)(placement);
    return [
        (0, $f97ac6e9b417a35d$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $f97ac6e9b417a35d$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a40714eabafca65f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $851489ec79ead4fc$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a40714eabafca65f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(placement) === (0, $11082a31956663b4$export$dfb5619354ba860) ? (0, $af2318c320f452bc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $77e73c32bd9804f6$export$2e2bcd8739ae039)(placement) === (0, $11082a31956663b4$export$b3571188c770cc5a);
        var isVertical = [
            (0, $11082a31956663b4$export$1e95b668f3b82d),
            (0, $11082a31956663b4$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $94eaff7d6e5f4ebb$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $11082a31956663b4$export$79ffe56a765070d2) : (0, $11082a31956663b4$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $11082a31956663b4$export$40e543e69a8b3fbb) : (0, $11082a31956663b4$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $851489ec79ead4fc$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $851489ec79ead4fc$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a40714eabafca65f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a40714eabafca65f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $ae86dd7a2b1bec39$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $545e4b32fb42e9c3$export$f28d906d67a997f3(min, value, max) {
    return (0, $19d6436c0f4af3e9$export$8960430cfd85939f)(min, (0, $19d6436c0f4af3e9$export$96ec731ed4dcb222)(value, max));
}
function $545e4b32fb42e9c3$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $545e4b32fb42e9c3$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $571ac0c4e81dffb6$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $94eaff7d6e5f4ebb$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $77e73c32bd9804f6$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $afab05245a072803$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $ae86dd7a2b1bec39$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $11082a31956663b4$export$1e95b668f3b82d) : (0, $11082a31956663b4$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $11082a31956663b4$export$40e543e69a8b3fbb) : (0, $11082a31956663b4$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $11082a31956663b4$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $11082a31956663b4$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $99c3f4e91033a5ca$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $76360d50df3bb7b8$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $545e4b32fb42e9c3$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ec19f1c872e2f1dc$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $545e4b32fb42e9c3$export$f28d906d67a997f3)(tether ? (0, $19d6436c0f4af3e9$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $19d6436c0f4af3e9$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $11082a31956663b4$export$1e95b668f3b82d) : (0, $11082a31956663b4$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $11082a31956663b4$export$40e543e69a8b3fbb) : (0, $11082a31956663b4$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $11082a31956663b4$export$1e95b668f3b82d),
            (0, $11082a31956663b4$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $545e4b32fb42e9c3$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $545e4b32fb42e9c3$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $571ac0c4e81dffb6$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $571ac0c4e81dffb6$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $f84c47e739f2173f$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5503f1f04f1f7f25$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $2a108dded3a7cebc$export$2e2bcd8739ae039)(padding, (0, $11082a31956663b4$export$aec2ce47c367b8c3)));
};
function $f84c47e739f2173f$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f98a69c21c9b0699$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $afab05245a072803$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $11082a31956663b4$export$eabcd2c8791e7bf4),
        (0, $11082a31956663b4$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f84c47e739f2173f$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $99c3f4e91033a5ca$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $11082a31956663b4$export$1e95b668f3b82d) : (0, $11082a31956663b4$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $11082a31956663b4$export$40e543e69a8b3fbb) : (0, $11082a31956663b4$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ec19f1c872e2f1dc$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $545e4b32fb42e9c3$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f84c47e739f2173f$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $7bf8e8ee4e1db72b$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f84c47e739f2173f$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f84c47e739f2173f$var$arrow,
    effect: $f84c47e739f2173f$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $de27804e54ae2718$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $de27804e54ae2718$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $11082a31956663b4$export$1e95b668f3b82d),
        (0, $11082a31956663b4$export$79ffe56a765070d2),
        (0, $11082a31956663b4$export$40e543e69a8b3fbb),
        (0, $11082a31956663b4$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $de27804e54ae2718$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $94eaff7d6e5f4ebb$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $94eaff7d6e5f4ebb$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $de27804e54ae2718$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $de27804e54ae2718$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $de27804e54ae2718$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $de27804e54ae2718$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $de27804e54ae2718$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $de27804e54ae2718$var$hide
};




var $ff149d7581fd18ab$export$d34966752335dd47 = [
    (0, $e3cab82015899eed$export$2e2bcd8739ae039),
    (0, $ba8e6cf1d65280ba$export$2e2bcd8739ae039),
    (0, $af1d3781f5be3675$export$2e2bcd8739ae039),
    (0, $d42475e99d0081f3$export$2e2bcd8739ae039),
    (0, $b2cd51857ceebf7a$export$2e2bcd8739ae039),
    (0, $a40714eabafca65f$export$2e2bcd8739ae039),
    (0, $571ac0c4e81dffb6$export$2e2bcd8739ae039),
    (0, $f84c47e739f2173f$export$2e2bcd8739ae039),
    (0, $de27804e54ae2718$export$2e2bcd8739ae039)
];
var $ff149d7581fd18ab$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $f9b0a08508f2953b$export$ed5e13716264f202)({
    defaultModifiers: $ff149d7581fd18ab$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $c627f24c7159c872$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $c627f24c7159c872$var$BOX_CLASS = "tippy-box";
var $c627f24c7159c872$var$CONTENT_CLASS = "tippy-content";
var $c627f24c7159c872$var$BACKDROP_CLASS = "tippy-backdrop";
var $c627f24c7159c872$var$ARROW_CLASS = "tippy-arrow";
var $c627f24c7159c872$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $c627f24c7159c872$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $c627f24c7159c872$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $c627f24c7159c872$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $c627f24c7159c872$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $c627f24c7159c872$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $c627f24c7159c872$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $c627f24c7159c872$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $c627f24c7159c872$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $c627f24c7159c872$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $c627f24c7159c872$var$normalizeToArray(value) {
    return [].concat(value);
}
function $c627f24c7159c872$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $c627f24c7159c872$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $c627f24c7159c872$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $c627f24c7159c872$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $c627f24c7159c872$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $c627f24c7159c872$var$div() {
    return document.createElement('div');
}
function $c627f24c7159c872$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $c627f24c7159c872$var$isType(value, type);
    });
}
function $c627f24c7159c872$var$isNodeList(value) {
    return $c627f24c7159c872$var$isType(value, 'NodeList');
}
function $c627f24c7159c872$var$isMouseEvent(value) {
    return $c627f24c7159c872$var$isType(value, 'MouseEvent');
}
function $c627f24c7159c872$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $c627f24c7159c872$var$getArrayOfElements(value) {
    if ($c627f24c7159c872$var$isElement(value)) return [
        value
    ];
    if ($c627f24c7159c872$var$isNodeList(value)) return $c627f24c7159c872$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $c627f24c7159c872$var$arrayFrom(document.querySelectorAll(value));
}
function $c627f24c7159c872$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $c627f24c7159c872$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $c627f24c7159c872$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $c627f24c7159c872$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $c627f24c7159c872$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $c627f24c7159c872$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $c627f24c7159c872$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $c627f24c7159c872$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $c627f24c7159c872$var$currentInput = {
    isTouch: false
};
var $c627f24c7159c872$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $c627f24c7159c872$var$onDocumentTouchStart() {
    if ($c627f24c7159c872$var$currentInput.isTouch) return;
    $c627f24c7159c872$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $c627f24c7159c872$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $c627f24c7159c872$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $c627f24c7159c872$var$lastMouseMoveTime < 20) {
        $c627f24c7159c872$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $c627f24c7159c872$var$onDocumentMouseMove);
    }
    $c627f24c7159c872$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $c627f24c7159c872$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($c627f24c7159c872$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $c627f24c7159c872$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $c627f24c7159c872$var$onDocumentTouchStart, $c627f24c7159c872$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $c627f24c7159c872$var$onWindowBlur);
}
var $c627f24c7159c872$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $c627f24c7159c872$var$isIE11 = $c627f24c7159c872$var$isBrowser ? !!window.msCrypto : false;
function $c627f24c7159c872$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $c627f24c7159c872$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $c627f24c7159c872$var$getDevMessage(message) {
    return $c627f24c7159c872$var$clean("\n  %ctippy.js\n\n  %c" + $c627f24c7159c872$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $c627f24c7159c872$var$getFormattedMessage(message) {
    return [
        $c627f24c7159c872$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $c627f24c7159c872$var$visitedMessages;
function $c627f24c7159c872$var$resetVisitedMessages() {
    $c627f24c7159c872$var$visitedMessages = new Set();
}
function $c627f24c7159c872$var$warnWhen(condition, message) {
    if (condition && !$c627f24c7159c872$var$visitedMessages.has(message)) {
        var _console;
        $c627f24c7159c872$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $c627f24c7159c872$var$getFormattedMessage(message));
    }
}
function $c627f24c7159c872$var$errorWhen(condition, message) {
    if (condition && !$c627f24c7159c872$var$visitedMessages.has(message)) {
        var _console2;
        $c627f24c7159c872$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $c627f24c7159c872$var$getFormattedMessage(message));
    }
}
function $c627f24c7159c872$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $c627f24c7159c872$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $c627f24c7159c872$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $c627f24c7159c872$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $c627f24c7159c872$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $c627f24c7159c872$var$defaultProps = Object.assign({
    appendTo: $c627f24c7159c872$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $c627f24c7159c872$var$pluginProps, $c627f24c7159c872$var$renderProps);
var $c627f24c7159c872$var$defaultKeys = Object.keys($c627f24c7159c872$var$defaultProps);
var $c627f24c7159c872$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $c627f24c7159c872$var$defaultProps[key] = partialProps[key];
    });
};
function $c627f24c7159c872$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $c627f24c7159c872$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $c627f24c7159c872$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($c627f24c7159c872$var$getExtendedPassedProps(Object.assign({}, $c627f24c7159c872$var$defaultProps, {
        plugins: plugins
    }))) : $c627f24c7159c872$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $c627f24c7159c872$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $c627f24c7159c872$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $c627f24c7159c872$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $c627f24c7159c872$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $c627f24c7159c872$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $c627f24c7159c872$var$removeProperties($c627f24c7159c872$var$defaultProps, Object.keys($c627f24c7159c872$var$pluginProps));
        var didPassUnknownProp = !$c627f24c7159c872$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $c627f24c7159c872$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $c627f24c7159c872$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $c627f24c7159c872$var$dangerouslySetInnerHTML(element, html) {
    element[$c627f24c7159c872$var$innerHTML()] = html;
}
function $c627f24c7159c872$var$createArrowElement(value) {
    var arrow = $c627f24c7159c872$var$div();
    if (value === true) arrow.className = $c627f24c7159c872$var$ARROW_CLASS;
    else {
        arrow.className = $c627f24c7159c872$var$SVG_ARROW_CLASS;
        if ($c627f24c7159c872$var$isElement(value)) arrow.appendChild(value);
        else $c627f24c7159c872$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $c627f24c7159c872$var$setContent(content, props) {
    if ($c627f24c7159c872$var$isElement(props.content)) {
        $c627f24c7159c872$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $c627f24c7159c872$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $c627f24c7159c872$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $c627f24c7159c872$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($c627f24c7159c872$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($c627f24c7159c872$var$ARROW_CLASS) || node.classList.contains($c627f24c7159c872$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($c627f24c7159c872$var$BACKDROP_CLASS);
        })
    };
}
function $c627f24c7159c872$var$render(instance) {
    var popper = $c627f24c7159c872$var$div();
    var box = $c627f24c7159c872$var$div();
    box.className = $c627f24c7159c872$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $c627f24c7159c872$var$div();
    content.className = $c627f24c7159c872$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $c627f24c7159c872$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $c627f24c7159c872$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $c627f24c7159c872$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($c627f24c7159c872$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($c627f24c7159c872$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$c627f24c7159c872$var$render.$$tippy = true;
var $c627f24c7159c872$var$idCounter = 1;
var $c627f24c7159c872$var$mouseMoveListeners = []; // Used by `hideAll()`
var $c627f24c7159c872$var$mountedInstances = [];
function $c627f24c7159c872$var$createTippy(reference, passedProps) {
    var props = $c627f24c7159c872$var$evaluateProps(reference, Object.assign({}, $c627f24c7159c872$var$defaultProps, $c627f24c7159c872$var$getExtendedPassedProps($c627f24c7159c872$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $c627f24c7159c872$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $c627f24c7159c872$var$idCounter++;
    var popperInstance = null;
    var plugins = $c627f24c7159c872$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $c627f24c7159c872$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $c627f24c7159c872$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $c627f24c7159c872$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $c627f24c7159c872$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $c627f24c7159c872$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $c627f24c7159c872$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $c627f24c7159c872$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $c627f24c7159c872$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $c627f24c7159c872$var$mouseMoveListeners = $c627f24c7159c872$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($c627f24c7159c872$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $c627f24c7159c872$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($c627f24c7159c872$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $c627f24c7159c872$var$actualContains(el, actualTarget);
        })) {
            if ($c627f24c7159c872$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $c627f24c7159c872$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $c627f24c7159c872$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $c627f24c7159c872$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $c627f24c7159c872$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $c627f24c7159c872$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $c627f24c7159c872$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $c627f24c7159c872$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $c627f24c7159c872$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $c627f24c7159c872$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $c627f24c7159c872$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $c627f24c7159c872$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($c627f24c7159c872$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $c627f24c7159c872$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $c627f24c7159c872$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($c627f24c7159c872$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $c627f24c7159c872$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $c627f24c7159c872$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $ff149d7581fd18ab$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $c627f24c7159c872$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $c627f24c7159c872$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $c627f24c7159c872$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($c627f24c7159c872$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $c627f24c7159c872$var$evaluateProps(reference, Object.assign({}, prevProps, $c627f24c7159c872$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $c627f24c7159c872$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $c627f24c7159c872$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $c627f24c7159c872$var$currentInput.isTouch && !instance.props.touch;
        var duration = $c627f24c7159c872$var$getValueAtIndexOrReturn(instance.props.duration, 0, $c627f24c7159c872$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $c627f24c7159c872$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $c627f24c7159c872$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $c627f24c7159c872$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $c627f24c7159c872$var$pushIfUnique($c627f24c7159c872$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $c627f24c7159c872$var$getValueAtIndexOrReturn(instance.props.duration, 1, $c627f24c7159c872$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $c627f24c7159c872$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $c627f24c7159c872$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $c627f24c7159c872$var$pushIfUnique($c627f24c7159c872$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $c627f24c7159c872$var$mountedInstances = $c627f24c7159c872$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $c627f24c7159c872$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $c627f24c7159c872$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $c627f24c7159c872$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $c627f24c7159c872$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $c627f24c7159c872$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $c627f24c7159c872$var$isElement(targets) ? instances[0] : instances;
}
$c627f24c7159c872$var$tippy.defaultProps = $c627f24c7159c872$var$defaultProps;
$c627f24c7159c872$var$tippy.setDefaultProps = $c627f24c7159c872$var$setDefaultProps;
$c627f24c7159c872$var$tippy.currentInput = $c627f24c7159c872$var$currentInput;
var $c627f24c7159c872$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $c627f24c7159c872$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $c627f24c7159c872$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $c627f24c7159c872$var$applyStylesModifier = Object.assign({}, (0, $d42475e99d0081f3$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $c627f24c7159c872$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $c627f24c7159c872$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $c627f24c7159c872$var$tippy($c627f24c7159c872$var$div(), Object.assign({}, $c627f24c7159c872$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $c627f24c7159c872$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $c627f24c7159c872$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $c627f24c7159c872$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $c627f24c7159c872$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $c627f24c7159c872$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $c627f24c7159c872$var$tippy(targets, parentProps);
    var normalizedReturnValue = $c627f24c7159c872$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $c627f24c7159c872$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($c627f24c7159c872$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $c627f24c7159c872$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $c627f24c7159c872$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $c627f24c7159c872$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $c627f24c7159c872$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $c627f24c7159c872$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $c627f24c7159c872$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $c627f24c7159c872$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $c627f24c7159c872$var$createBackdropElement() {
    var backdrop = $c627f24c7159c872$var$div();
    backdrop.className = $c627f24c7159c872$var$BACKDROP_CLASS;
    $c627f24c7159c872$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $c627f24c7159c872$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $c627f24c7159c872$var$activeInstances = [];
function $c627f24c7159c872$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $c627f24c7159c872$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $c627f24c7159c872$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $c627f24c7159c872$var$storeMouseCoords);
}
function $c627f24c7159c872$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $c627f24c7159c872$var$storeMouseCoords);
}
var $c627f24c7159c872$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $c627f24c7159c872$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $c627f24c7159c872$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $c627f24c7159c872$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $c627f24c7159c872$var$activeInstances = $c627f24c7159c872$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($c627f24c7159c872$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $c627f24c7159c872$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($c627f24c7159c872$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($c627f24c7159c872$var$isMouseEvent(event)) $c627f24c7159c872$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $c627f24c7159c872$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $c627f24c7159c872$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $c627f24c7159c872$var$getInlineBoundingClientRect($c627f24c7159c872$var$getBasePlacement(placement), reference.getBoundingClientRect(), $c627f24c7159c872$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($c627f24c7159c872$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($c627f24c7159c872$var$isMouseEvent(event)) {
                    var rects = $c627f24c7159c872$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $c627f24c7159c872$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $c627f24c7159c872$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $c627f24c7159c872$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $c627f24c7159c872$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $c627f24c7159c872$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$c627f24c7159c872$var$tippy.setDefaultProps({
    render: $c627f24c7159c872$var$render
});
var $c627f24c7159c872$export$2e2bcd8739ae039 = $c627f24c7159c872$var$tippy;




var $kNmtb = parcelRequire("kNmtb");

var $jIak6 = parcelRequire("jIak6");
var $d3f25f4d7d47f13e$var$_Chart;
($d3f25f4d7d47f13e$var$_Chart = (0, $jIak6.Chart)).register.apply($d3f25f4d7d47f13e$var$_Chart, (0, $kNmtb._)((0, $jIak6.registerables)));
var $d3f25f4d7d47f13e$export$2e2bcd8739ae039 = (0, $jIak6.Chart);


/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */ 
var $3zT2Z = parcelRequire("3zT2Z");


var $3zT2Z = parcelRequire("3zT2Z");

var $jIak6 = parcelRequire("jIak6");
var $3zT2Z = parcelRequire("3zT2Z");
var $55c1a76b4f1e9f00$var$devicePixelRatio = function() {
    if (typeof window !== 'undefined') {
        if (window.devicePixelRatio) return window.devicePixelRatio;
        // devicePixelRatio is undefined on IE10
        // https://stackoverflow.com/a/20204180/8837887
        // https://github.com/chartjs/chartjs-plugin-datalabels/issues/85
        var screen = window.screen;
        if (screen) return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
    }
    return 1;
}();
var $55c1a76b4f1e9f00$var$utils = {
    // @todo move this in Chart.helpers.toTextLines
    toTextLines: function toTextLines(inputs) {
        var lines = [];
        var input;
        inputs = [].concat(inputs);
        while(inputs.length){
            input = inputs.pop();
            if (typeof input === 'string') lines.unshift.apply(lines, input.split('\n'));
            else if (Array.isArray(input)) inputs.push.apply(inputs, input);
            else if (!(0, $3zT2Z.k)(inputs)) lines.unshift('' + input);
        }
        return lines;
    },
    // @todo move this in Chart.helpers.canvas.textSize
    // @todo cache calls of measureText if font doesn't change?!
    textSize: function textSize(ctx, lines, font) {
        var items = [].concat(lines);
        var ilen = items.length;
        var prev = ctx.font;
        var width = 0;
        var i;
        ctx.font = font.string;
        for(i = 0; i < ilen; ++i)width = Math.max(ctx.measureText(items[i]).width, width);
        ctx.font = prev;
        return {
            height: ilen * font.lineHeight,
            width: width
        };
    },
    /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */ bound: function bound(min, value, max) {
        return Math.max(min, Math.min(value, max));
    },
    /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */ arrayDiff: function arrayDiff(a0, a1) {
        var prev = a0.slice();
        var updates = [];
        var i, j, ilen, v;
        for(i = 0, ilen = a1.length; i < ilen; ++i){
            v = a1[i];
            j = prev.indexOf(v);
            if (j === -1) updates.push([
                v,
                1
            ]);
            else prev.splice(j, 1);
        }
        for(i = 0, ilen = prev.length; i < ilen; ++i)updates.push([
            prev[i],
            -1
        ]);
        return updates;
    },
    /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */ rasterize: function rasterize(v) {
        return Math.round(v * $55c1a76b4f1e9f00$var$devicePixelRatio) / $55c1a76b4f1e9f00$var$devicePixelRatio;
    }
};
function $55c1a76b4f1e9f00$var$orient(point, origin) {
    var x0 = origin.x;
    var y0 = origin.y;
    if (x0 === null) return {
        x: 0,
        y: -1
    };
    if (y0 === null) return {
        x: 1,
        y: 0
    };
    var dx = point.x - x0;
    var dy = point.y - y0;
    var ln = Math.sqrt(dx * dx + dy * dy);
    return {
        x: ln ? dx / ln : 0,
        y: ln ? dy / ln : -1
    };
}
function $55c1a76b4f1e9f00$var$aligned(x, y, vx, vy, align) {
    switch(align){
        case 'center':
            vx = vy = 0;
            break;
        case 'bottom':
            vx = 0;
            vy = 1;
            break;
        case 'right':
            vx = 1;
            vy = 0;
            break;
        case 'left':
            vx = -1;
            vy = 0;
            break;
        case 'top':
            vx = 0;
            vy = -1;
            break;
        case 'start':
            vx = -vx;
            vy = -vy;
            break;
        case 'end':
            break;
        default:
            // clockwise rotation (in degree)
            align *= Math.PI / 180;
            vx = Math.cos(align);
            vy = Math.sin(align);
            break;
    }
    return {
        x: x,
        y: y,
        vx: vx,
        vy: vy
    };
}
// Line clipping (Cohen–Sutherland algorithm)
// https://en.wikipedia.org/wiki/Cohen–Sutherland_algorithm
var $55c1a76b4f1e9f00$var$R_INSIDE = 0;
var $55c1a76b4f1e9f00$var$R_LEFT = 1;
var $55c1a76b4f1e9f00$var$R_RIGHT = 2;
var $55c1a76b4f1e9f00$var$R_BOTTOM = 4;
var $55c1a76b4f1e9f00$var$R_TOP = 8;
function $55c1a76b4f1e9f00$var$region(x, y, rect) {
    var res = $55c1a76b4f1e9f00$var$R_INSIDE;
    if (x < rect.left) res |= $55c1a76b4f1e9f00$var$R_LEFT;
    else if (x > rect.right) res |= $55c1a76b4f1e9f00$var$R_RIGHT;
    if (y < rect.top) res |= $55c1a76b4f1e9f00$var$R_TOP;
    else if (y > rect.bottom) res |= $55c1a76b4f1e9f00$var$R_BOTTOM;
    return res;
}
function $55c1a76b4f1e9f00$var$clipped(segment, area) {
    var x0 = segment.x0;
    var y0 = segment.y0;
    var x1 = segment.x1;
    var y1 = segment.y1;
    var r0 = $55c1a76b4f1e9f00$var$region(x0, y0, area);
    var r1 = $55c1a76b4f1e9f00$var$region(x1, y1, area);
    var r, x, y;
    // eslint-disable-next-line no-constant-condition
    while(true){
        if (!(r0 | r1) || r0 & r1) break;
        // at least one point is outside
        r = r0 || r1;
        if (r & $55c1a76b4f1e9f00$var$R_TOP) {
            x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
            y = area.top;
        } else if (r & $55c1a76b4f1e9f00$var$R_BOTTOM) {
            x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
            y = area.bottom;
        } else if (r & $55c1a76b4f1e9f00$var$R_RIGHT) {
            y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
            x = area.right;
        } else if (r & $55c1a76b4f1e9f00$var$R_LEFT) {
            y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
            x = area.left;
        }
        if (r === r0) {
            x0 = x;
            y0 = y;
            r0 = $55c1a76b4f1e9f00$var$region(x0, y0, area);
        } else {
            x1 = x;
            y1 = y;
            r1 = $55c1a76b4f1e9f00$var$region(x1, y1, area);
        }
    }
    return {
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1
    };
}
function $55c1a76b4f1e9f00$var$compute$1(range, config) {
    var anchor = config.anchor;
    var segment = range;
    var x, y;
    if (config.clamp) segment = $55c1a76b4f1e9f00$var$clipped(segment, config.area);
    if (anchor === 'start') {
        x = segment.x0;
        y = segment.y0;
    } else if (anchor === 'end') {
        x = segment.x1;
        y = segment.y1;
    } else {
        x = (segment.x0 + segment.x1) / 2;
        y = (segment.y0 + segment.y1) / 2;
    }
    return $55c1a76b4f1e9f00$var$aligned(x, y, range.vx, range.vy, config.align);
}
var $55c1a76b4f1e9f00$var$positioners = {
    arc: function arc(el, config) {
        var angle = (el.startAngle + el.endAngle) / 2;
        var vx = Math.cos(angle);
        var vy = Math.sin(angle);
        var r0 = el.innerRadius;
        var r1 = el.outerRadius;
        return $55c1a76b4f1e9f00$var$compute$1({
            x0: el.x + vx * r0,
            y0: el.y + vy * r0,
            x1: el.x + vx * r1,
            y1: el.y + vy * r1,
            vx: vx,
            vy: vy
        }, config);
    },
    point: function point(el, config) {
        var v = $55c1a76b4f1e9f00$var$orient(el, config.origin);
        var rx = v.x * el.options.radius;
        var ry = v.y * el.options.radius;
        return $55c1a76b4f1e9f00$var$compute$1({
            x0: el.x - rx,
            y0: el.y - ry,
            x1: el.x + rx,
            y1: el.y + ry,
            vx: v.x,
            vy: v.y
        }, config);
    },
    bar: function bar(el, config) {
        var v = $55c1a76b4f1e9f00$var$orient(el, config.origin);
        var x = el.x;
        var y = el.y;
        var sx = 0;
        var sy = 0;
        if (el.horizontal) {
            x = Math.min(el.x, el.base);
            sx = Math.abs(el.base - el.x);
        } else {
            y = Math.min(el.y, el.base);
            sy = Math.abs(el.base - el.y);
        }
        return $55c1a76b4f1e9f00$var$compute$1({
            x0: x,
            y0: y + sy,
            x1: x + sx,
            y1: y,
            vx: v.x,
            vy: v.y
        }, config);
    },
    fallback: function fallback(el, config) {
        var v = $55c1a76b4f1e9f00$var$orient(el, config.origin);
        return $55c1a76b4f1e9f00$var$compute$1({
            x0: el.x,
            y0: el.y,
            x1: el.x + (el.width || 0),
            y1: el.y + (el.height || 0),
            vx: v.x,
            vy: v.y
        }, config);
    }
};
var $55c1a76b4f1e9f00$var$rasterize = $55c1a76b4f1e9f00$var$utils.rasterize;
function $55c1a76b4f1e9f00$var$boundingRects(model) {
    var borderWidth = model.borderWidth || 0;
    var padding = model.padding;
    var th = model.size.height;
    var tw = model.size.width;
    var tx = -tw / 2;
    var ty = -th / 2;
    return {
        frame: {
            x: tx - padding.left - borderWidth,
            y: ty - padding.top - borderWidth,
            w: tw + padding.width + borderWidth * 2,
            h: th + padding.height + borderWidth * 2
        },
        text: {
            x: tx,
            y: ty,
            w: tw,
            h: th
        }
    };
}
function $55c1a76b4f1e9f00$var$getScaleOrigin(el, context) {
    var scale = context.chart.getDatasetMeta(context.datasetIndex).vScale;
    if (!scale) return null;
    if (scale.xCenter !== undefined && scale.yCenter !== undefined) return {
        x: scale.xCenter,
        y: scale.yCenter
    };
    var pixel = scale.getBasePixel();
    return el.horizontal ? {
        x: pixel,
        y: null
    } : {
        x: null,
        y: pixel
    };
}
function $55c1a76b4f1e9f00$var$getPositioner(el) {
    if (el instanceof (0, $jIak6.ArcElement)) return $55c1a76b4f1e9f00$var$positioners.arc;
    if (el instanceof (0, $jIak6.PointElement)) return $55c1a76b4f1e9f00$var$positioners.point;
    if (el instanceof (0, $jIak6.BarElement)) return $55c1a76b4f1e9f00$var$positioners.bar;
    return $55c1a76b4f1e9f00$var$positioners.fallback;
}
function $55c1a76b4f1e9f00$var$drawRoundedRect(ctx, x, y, w, h, radius) {
    var HALF_PI = Math.PI / 2;
    if (radius) {
        var r = Math.min(radius, h / 2, w / 2);
        var left = x + r;
        var top = y + r;
        var right = x + w - r;
        var bottom = y + h - r;
        ctx.moveTo(x, top);
        if (left < right && top < bottom) {
            ctx.arc(left, top, r, -Math.PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, Math.PI);
        } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, Math.PI + HALF_PI);
        } else if (top < bottom) {
            ctx.arc(left, top, r, -Math.PI, 0);
            ctx.arc(left, bottom, r, 0, Math.PI);
        } else ctx.arc(left, top, r, -Math.PI, Math.PI);
        ctx.closePath();
        ctx.moveTo(x, y);
    } else ctx.rect(x, y, w, h);
}
function $55c1a76b4f1e9f00$var$drawFrame(ctx, rect, model) {
    var bgColor = model.backgroundColor;
    var borderColor = model.borderColor;
    var borderWidth = model.borderWidth;
    if (!bgColor && (!borderColor || !borderWidth)) return;
    ctx.beginPath();
    $55c1a76b4f1e9f00$var$drawRoundedRect(ctx, $55c1a76b4f1e9f00$var$rasterize(rect.x) + borderWidth / 2, $55c1a76b4f1e9f00$var$rasterize(rect.y) + borderWidth / 2, $55c1a76b4f1e9f00$var$rasterize(rect.w) - borderWidth, $55c1a76b4f1e9f00$var$rasterize(rect.h) - borderWidth, model.borderRadius);
    ctx.closePath();
    if (bgColor) {
        ctx.fillStyle = bgColor;
        ctx.fill();
    }
    if (borderColor && borderWidth) {
        ctx.strokeStyle = borderColor;
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = 'miter';
        ctx.stroke();
    }
}
function $55c1a76b4f1e9f00$var$textGeometry(rect, align, font) {
    var h = font.lineHeight;
    var w = rect.w;
    var x = rect.x;
    var y = rect.y + h / 2;
    if (align === 'center') x += w / 2;
    else if (align === 'end' || align === 'right') x += w;
    return {
        h: h,
        w: w,
        x: x,
        y: y
    };
}
function $55c1a76b4f1e9f00$var$drawTextLine(ctx, text, cfg) {
    var shadow = ctx.shadowBlur;
    var stroked = cfg.stroked;
    var x = $55c1a76b4f1e9f00$var$rasterize(cfg.x);
    var y = $55c1a76b4f1e9f00$var$rasterize(cfg.y);
    var w = $55c1a76b4f1e9f00$var$rasterize(cfg.w);
    if (stroked) ctx.strokeText(text, x, y, w);
    if (cfg.filled) {
        if (shadow && stroked) // Prevent drawing shadow on both the text stroke and fill, so
        // if the text is stroked, remove the shadow for the text fill.
        ctx.shadowBlur = 0;
        ctx.fillText(text, x, y, w);
        if (shadow && stroked) ctx.shadowBlur = shadow;
    }
}
function $55c1a76b4f1e9f00$var$drawText(ctx, lines, rect, model) {
    var align = model.textAlign;
    var color = model.color;
    var filled = !!color;
    var font = model.font;
    var ilen = lines.length;
    var strokeColor = model.textStrokeColor;
    var strokeWidth = model.textStrokeWidth;
    var stroked = strokeColor && strokeWidth;
    var i;
    if (!ilen || !filled && !stroked) return;
    // Adjust coordinates based on text alignment and line height
    rect = $55c1a76b4f1e9f00$var$textGeometry(rect, align, font);
    ctx.font = font.string;
    ctx.textAlign = align;
    ctx.textBaseline = 'middle';
    ctx.shadowBlur = model.textShadowBlur;
    ctx.shadowColor = model.textShadowColor;
    if (filled) ctx.fillStyle = color;
    if (stroked) {
        ctx.lineJoin = 'round';
        ctx.lineWidth = strokeWidth;
        ctx.strokeStyle = strokeColor;
    }
    for(i = 0, ilen = lines.length; i < ilen; ++i)$55c1a76b4f1e9f00$var$drawTextLine(ctx, lines[i], {
        stroked: stroked,
        filled: filled,
        w: rect.w,
        x: rect.x,
        y: rect.y + rect.h * i
    });
}
var $55c1a76b4f1e9f00$var$Label = function Label(config, ctx, el, index) {
    var me = this;
    me._config = config;
    me._index = index;
    me._model = null;
    me._rects = null;
    me._ctx = ctx;
    me._el = el;
};
(0, $3zT2Z.a4)($55c1a76b4f1e9f00$var$Label.prototype, {
    /**
   * @private
   */ _modelize: function _modelize(display, lines, config, context) {
        var me = this;
        var index = me._index;
        var font = (0, $3zT2Z.a0)((0, $3zT2Z.a)([
            config.font,
            {}
        ], context, index));
        var color = (0, $3zT2Z.a)([
            config.color,
            (0, $3zT2Z.d).color
        ], context, index);
        return {
            align: (0, $3zT2Z.a)([
                config.align,
                'center'
            ], context, index),
            anchor: (0, $3zT2Z.a)([
                config.anchor,
                'center'
            ], context, index),
            area: context.chart.chartArea,
            backgroundColor: (0, $3zT2Z.a)([
                config.backgroundColor,
                null
            ], context, index),
            borderColor: (0, $3zT2Z.a)([
                config.borderColor,
                null
            ], context, index),
            borderRadius: (0, $3zT2Z.a)([
                config.borderRadius,
                0
            ], context, index),
            borderWidth: (0, $3zT2Z.a)([
                config.borderWidth,
                0
            ], context, index),
            clamp: (0, $3zT2Z.a)([
                config.clamp,
                false
            ], context, index),
            clip: (0, $3zT2Z.a)([
                config.clip,
                false
            ], context, index),
            color: color,
            display: display,
            font: font,
            lines: lines,
            offset: (0, $3zT2Z.a)([
                config.offset,
                4
            ], context, index),
            opacity: (0, $3zT2Z.a)([
                config.opacity,
                1
            ], context, index),
            origin: $55c1a76b4f1e9f00$var$getScaleOrigin(me._el, context),
            padding: (0, $3zT2Z.E)((0, $3zT2Z.a)([
                config.padding,
                4
            ], context, index)),
            positioner: $55c1a76b4f1e9f00$var$getPositioner(me._el),
            rotation: (0, $3zT2Z.a)([
                config.rotation,
                0
            ], context, index) * (Math.PI / 180),
            size: $55c1a76b4f1e9f00$var$utils.textSize(me._ctx, lines, font),
            textAlign: (0, $3zT2Z.a)([
                config.textAlign,
                'start'
            ], context, index),
            textShadowBlur: (0, $3zT2Z.a)([
                config.textShadowBlur,
                0
            ], context, index),
            textShadowColor: (0, $3zT2Z.a)([
                config.textShadowColor,
                color
            ], context, index),
            textStrokeColor: (0, $3zT2Z.a)([
                config.textStrokeColor,
                color
            ], context, index),
            textStrokeWidth: (0, $3zT2Z.a)([
                config.textStrokeWidth,
                0
            ], context, index)
        };
    },
    update: function update(context) {
        var me = this;
        var model = null;
        var rects = null;
        var index = me._index;
        var config = me._config;
        var value, label, lines;
        // We first resolve the display option (separately) to avoid computing
        // other options in case the label is hidden (i.e. display: false).
        var display = (0, $3zT2Z.a)([
            config.display,
            true
        ], context, index);
        if (display) {
            value = context.dataset.data[index];
            label = (0, $3zT2Z.v)((0, $3zT2Z.Q)(config.formatter, [
                value,
                context
            ]), value);
            lines = (0, $3zT2Z.k)(label) ? [] : $55c1a76b4f1e9f00$var$utils.toTextLines(label);
            if (lines.length) {
                model = me._modelize(display, lines, config, context);
                rects = $55c1a76b4f1e9f00$var$boundingRects(model);
            }
        }
        me._model = model;
        me._rects = rects;
    },
    geometry: function geometry() {
        return this._rects ? this._rects.frame : {};
    },
    rotation: function rotation() {
        return this._model ? this._model.rotation : 0;
    },
    visible: function visible() {
        return this._model && this._model.opacity;
    },
    model: function model() {
        return this._model;
    },
    draw: function draw(chart, center) {
        var me = this;
        var ctx = chart.ctx;
        var model = me._model;
        var rects = me._rects;
        var area;
        if (!this.visible()) return;
        ctx.save();
        if (model.clip) {
            area = model.area;
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        }
        ctx.globalAlpha = $55c1a76b4f1e9f00$var$utils.bound(0, model.opacity, 1);
        ctx.translate($55c1a76b4f1e9f00$var$rasterize(center.x), $55c1a76b4f1e9f00$var$rasterize(center.y));
        ctx.rotate(model.rotation);
        $55c1a76b4f1e9f00$var$drawFrame(ctx, rects.frame, model);
        $55c1a76b4f1e9f00$var$drawText(ctx, model.lines, rects.text, model);
        ctx.restore();
    }
});
var $55c1a76b4f1e9f00$var$MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991; // eslint-disable-line es/no-number-minsafeinteger
var $55c1a76b4f1e9f00$var$MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991; // eslint-disable-line es/no-number-maxsafeinteger
function $55c1a76b4f1e9f00$var$rotated(point, center, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var cx = center.x;
    var cy = center.y;
    return {
        x: cx + cos * (point.x - cx) - sin * (point.y - cy),
        y: cy + sin * (point.x - cx) + cos * (point.y - cy)
    };
}
function $55c1a76b4f1e9f00$var$projected(points, axis) {
    var min = $55c1a76b4f1e9f00$var$MAX_INTEGER;
    var max = $55c1a76b4f1e9f00$var$MIN_INTEGER;
    var origin = axis.origin;
    var i, pt, vx, vy, dp;
    for(i = 0; i < points.length; ++i){
        pt = points[i];
        vx = pt.x - origin.x;
        vy = pt.y - origin.y;
        dp = axis.vx * vx + axis.vy * vy;
        min = Math.min(min, dp);
        max = Math.max(max, dp);
    }
    return {
        min: min,
        max: max
    };
}
function $55c1a76b4f1e9f00$var$toAxis(p0, p1) {
    var vx = p1.x - p0.x;
    var vy = p1.y - p0.y;
    var ln = Math.sqrt(vx * vx + vy * vy);
    return {
        vx: (p1.x - p0.x) / ln,
        vy: (p1.y - p0.y) / ln,
        origin: p0,
        ln: ln
    };
}
var $55c1a76b4f1e9f00$var$HitBox = function HitBox() {
    this._rotation = 0;
    this._rect = {
        x: 0,
        y: 0,
        w: 0,
        h: 0
    };
};
(0, $3zT2Z.a4)($55c1a76b4f1e9f00$var$HitBox.prototype, {
    center: function center() {
        var r = this._rect;
        return {
            x: r.x + r.w / 2,
            y: r.y + r.h / 2
        };
    },
    update: function update(center, rect, rotation) {
        this._rotation = rotation;
        this._rect = {
            x: rect.x + center.x,
            y: rect.y + center.y,
            w: rect.w,
            h: rect.h
        };
    },
    contains: function contains(point) {
        var me = this;
        var margin = 1;
        var rect = me._rect;
        point = $55c1a76b4f1e9f00$var$rotated(point, me.center(), -me._rotation);
        return !(point.x < rect.x - margin || point.y < rect.y - margin || point.x > rect.x + rect.w + margin * 2 || point.y > rect.y + rect.h + margin * 2);
    },
    // Separating Axis Theorem
    // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
    intersects: function intersects(other) {
        var r0 = this._points();
        var r1 = other._points();
        var axes = [
            $55c1a76b4f1e9f00$var$toAxis(r0[0], r0[1]),
            $55c1a76b4f1e9f00$var$toAxis(r0[0], r0[3])
        ];
        var i, pr0, pr1;
        if (this._rotation !== other._rotation) // Only separate with r1 axis if the rotation is different,
        // else it's enough to separate r0 and r1 with r0 axis only!
        axes.push($55c1a76b4f1e9f00$var$toAxis(r1[0], r1[1]), $55c1a76b4f1e9f00$var$toAxis(r1[0], r1[3]));
        for(i = 0; i < axes.length; ++i){
            pr0 = $55c1a76b4f1e9f00$var$projected(r0, axes[i]);
            pr1 = $55c1a76b4f1e9f00$var$projected(r1, axes[i]);
            if (pr0.max < pr1.min || pr1.max < pr0.min) return false;
        }
        return true;
    },
    /**
   * @private
   */ _points: function _points() {
        var me = this;
        var rect = me._rect;
        var angle = me._rotation;
        var center = me.center();
        return [
            $55c1a76b4f1e9f00$var$rotated({
                x: rect.x,
                y: rect.y
            }, center, angle),
            $55c1a76b4f1e9f00$var$rotated({
                x: rect.x + rect.w,
                y: rect.y
            }, center, angle),
            $55c1a76b4f1e9f00$var$rotated({
                x: rect.x + rect.w,
                y: rect.y + rect.h
            }, center, angle),
            $55c1a76b4f1e9f00$var$rotated({
                x: rect.x,
                y: rect.y + rect.h
            }, center, angle)
        ];
    }
});
function $55c1a76b4f1e9f00$var$coordinates(el, model, geometry) {
    var point = model.positioner(el, model);
    var vx = point.vx;
    var vy = point.vy;
    if (!vx && !vy) // if aligned center, we don't want to offset the center point
    return {
        x: point.x,
        y: point.y
    };
    var w = geometry.w;
    var h = geometry.h;
    // take in account the label rotation
    var rotation = model.rotation;
    var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h / 2 * Math.sin(rotation));
    var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h / 2 * Math.cos(rotation));
    // scale the unit vector (vx, vy) to get at least dx or dy equal to
    // w or h respectively (else we would calculate the distance to the
    // ellipse inscribed in the bounding rect)
    var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
    dx *= vx * vs;
    dy *= vy * vs;
    // finally, include the explicit offset
    dx += model.offset * vx;
    dy += model.offset * vy;
    return {
        x: point.x + dx,
        y: point.y + dy
    };
}
function $55c1a76b4f1e9f00$var$collide(labels, collider) {
    var i, j, s0, s1;
    // IMPORTANT Iterate in the reverse order since items at the end of the
    // list have an higher weight/priority and thus should be less impacted
    // by the overlapping strategy.
    for(i = labels.length - 1; i >= 0; --i){
        s0 = labels[i].$layout;
        for(j = i - 1; j >= 0 && s0._visible; --j){
            s1 = labels[j].$layout;
            if (s1._visible && s0._box.intersects(s1._box)) collider(s0, s1);
        }
    }
    return labels;
}
function $55c1a76b4f1e9f00$var$compute(labels) {
    var i, ilen, label, state, geometry, center, proxy;
    // Initialize labels for overlap detection
    for(i = 0, ilen = labels.length; i < ilen; ++i){
        label = labels[i];
        state = label.$layout;
        if (state._visible) {
            // Chart.js 3 removed el._model in favor of getProps(), making harder to
            // abstract reading values in positioners. Also, using string arrays to
            // read values (i.e. var {a,b,c} = el.getProps(["a","b","c"])) would make
            // positioners inefficient in the normal case (i.e. not the final values)
            // and the code a bit ugly, so let's use a Proxy instead.
            proxy = new Proxy(label._el, {
                get: function(el, p) {
                    return el.getProps([
                        p
                    ], true)[p];
                }
            });
            geometry = label.geometry();
            center = $55c1a76b4f1e9f00$var$coordinates(proxy, label.model(), geometry);
            state._box.update(center, geometry, label.rotation());
        }
    }
    // Auto hide overlapping labels
    return $55c1a76b4f1e9f00$var$collide(labels, function(s0, s1) {
        var h0 = s0._hidable;
        var h1 = s1._hidable;
        if (h0 && h1 || h1) s1._visible = false;
        else if (h0) s0._visible = false;
    });
}
var $55c1a76b4f1e9f00$var$layout = {
    prepare: function prepare(datasets) {
        var labels = [];
        var i, j, ilen, jlen, label;
        for(i = 0, ilen = datasets.length; i < ilen; ++i)for(j = 0, jlen = datasets[i].length; j < jlen; ++j){
            label = datasets[i][j];
            labels.push(label);
            label.$layout = {
                _box: new $55c1a76b4f1e9f00$var$HitBox(),
                _hidable: false,
                _visible: true,
                _set: i,
                _idx: label._index
            };
        }
        // TODO New `z` option: labels with a higher z-index are drawn
        // of top of the ones with a lower index. Lowest z-index labels
        // are also discarded first when hiding overlapping labels.
        labels.sort(function(a, b) {
            var sa = a.$layout;
            var sb = b.$layout;
            return sa._idx === sb._idx ? sb._set - sa._set : sb._idx - sa._idx;
        });
        this.update(labels);
        return labels;
    },
    update: function update(labels) {
        var dirty = false;
        var i, ilen, label, model, state;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            model = label.model();
            state = label.$layout;
            state._hidable = model && model.display === 'auto';
            state._visible = label.visible();
            dirty |= state._hidable;
        }
        if (dirty) $55c1a76b4f1e9f00$var$compute(labels);
    },
    lookup: function lookup(labels, point) {
        var i, state;
        // IMPORTANT Iterate in the reverse order since items at the end of
        // the list have an higher z-index, thus should be picked first.
        for(i = labels.length - 1; i >= 0; --i){
            state = labels[i].$layout;
            if (state && state._visible && state._box.contains(point)) return labels[i];
        }
        return null;
    },
    draw: function draw(chart, labels) {
        var i, ilen, label, state, geometry, center;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            state = label.$layout;
            if (state._visible) {
                geometry = label.geometry();
                center = $55c1a76b4f1e9f00$var$coordinates(label._el, label.model(), geometry);
                state._box.update(center, geometry, label.rotation());
                label.draw(chart, center);
            }
        }
    }
};
var $55c1a76b4f1e9f00$var$formatter = function formatter(value) {
    if ((0, $3zT2Z.k)(value)) return null;
    var label = value;
    var keys, klen, k;
    if ((0, $3zT2Z.i)(value)) {
        if (!(0, $3zT2Z.k)(value.label)) label = value.label;
        else if (!(0, $3zT2Z.k)(value.r)) label = value.r;
        else {
            label = '';
            keys = Object.keys(value);
            for(k = 0, klen = keys.length; k < klen; ++k)label += (k !== 0 ? ', ' : '') + keys[k] + ': ' + value[keys[k]];
        }
    }
    return '' + label;
};
/**
 * IMPORTANT: make sure to also update tests and TypeScript definition
 * files (`/test/specs/defaults.spec.js` and `/types/options.d.ts`)
 */ var $55c1a76b4f1e9f00$var$defaults = {
    align: 'center',
    anchor: 'center',
    backgroundColor: null,
    borderColor: null,
    borderRadius: 0,
    borderWidth: 0,
    clamp: false,
    clip: false,
    color: undefined,
    display: true,
    font: {
        family: undefined,
        lineHeight: 1.2,
        size: undefined,
        style: undefined,
        weight: null
    },
    formatter: $55c1a76b4f1e9f00$var$formatter,
    labels: undefined,
    listeners: {},
    offset: 4,
    opacity: 1,
    padding: {
        top: 4,
        right: 4,
        bottom: 4,
        left: 4
    },
    rotation: 0,
    textAlign: 'start',
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    textShadowBlur: 0,
    textShadowColor: undefined
};
/**
 * @see https://github.com/chartjs/Chart.js/issues/4176
 */ var $55c1a76b4f1e9f00$var$EXPANDO_KEY = '$datalabels';
var $55c1a76b4f1e9f00$var$DEFAULT_KEY = '$default';
function $55c1a76b4f1e9f00$var$configure(dataset, options) {
    var override = dataset.datalabels;
    var listeners = {};
    var configs = [];
    var labels, keys;
    if (override === false) return null;
    if (override === true) override = {};
    options = (0, $3zT2Z.a4)({}, [
        options,
        override
    ]);
    labels = options.labels || {};
    keys = Object.keys(labels);
    delete options.labels;
    if (keys.length) keys.forEach(function(key) {
        if (labels[key]) configs.push((0, $3zT2Z.a4)({}, [
            options,
            labels[key],
            {
                _key: key
            }
        ]));
    });
    else // Default label if no "named" label defined.
    configs.push(options);
    // listeners: {<event-type>: {<label-key>: <fn>}}
    listeners = configs.reduce(function(target, config) {
        (0, $3zT2Z.F)(config.listeners || {}, function(fn, event) {
            target[event] = target[event] || {};
            target[event][config._key || $55c1a76b4f1e9f00$var$DEFAULT_KEY] = fn;
        });
        delete config.listeners;
        return target;
    }, {});
    return {
        labels: configs,
        listeners: listeners
    };
}
function $55c1a76b4f1e9f00$var$dispatchEvent(chart, listeners, label, event) {
    if (!listeners) return;
    var context = label.$context;
    var groups = label.$groups;
    var callback$1;
    if (!listeners[groups._set]) return;
    callback$1 = listeners[groups._set][groups._key];
    if (!callback$1) return;
    if ((0, $3zT2Z.Q)(callback$1, [
        context,
        event
    ]) === true) {
        // Users are allowed to tweak the given context by injecting values that can be
        // used in scriptable options to display labels differently based on the current
        // event (e.g. highlight an hovered label). That's why we update the label with
        // the output context and schedule a new chart render by setting it dirty.
        chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY]._dirty = true;
        label.update(context);
    }
}
function $55c1a76b4f1e9f00$var$dispatchMoveEvents(chart, listeners, previous, label, event) {
    var enter, leave;
    if (!previous && !label) return;
    if (!previous) enter = true;
    else if (!label) leave = true;
    else if (previous !== label) leave = enter = true;
    if (leave) $55c1a76b4f1e9f00$var$dispatchEvent(chart, listeners.leave, previous, event);
    if (enter) $55c1a76b4f1e9f00$var$dispatchEvent(chart, listeners.enter, label, event);
}
function $55c1a76b4f1e9f00$var$handleMoveEvents(chart, event) {
    var expando = chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY];
    var listeners = expando._listeners;
    var previous, label;
    if (!listeners.enter && !listeners.leave) return;
    if (event.type === 'mousemove') label = $55c1a76b4f1e9f00$var$layout.lookup(expando._labels, event);
    else if (event.type !== 'mouseout') return;
    previous = expando._hovered;
    expando._hovered = label;
    $55c1a76b4f1e9f00$var$dispatchMoveEvents(chart, listeners, previous, label, event);
}
function $55c1a76b4f1e9f00$var$handleClickEvents(chart, event) {
    var expando = chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY];
    var handlers = expando._listeners.click;
    var label = handlers && $55c1a76b4f1e9f00$var$layout.lookup(expando._labels, event);
    if (label) $55c1a76b4f1e9f00$var$dispatchEvent(chart, handlers, label, event);
}
var $55c1a76b4f1e9f00$export$2e2bcd8739ae039 = {
    id: 'datalabels',
    defaults: $55c1a76b4f1e9f00$var$defaults,
    beforeInit: function beforeInit(chart) {
        chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY] = {
            _actives: []
        };
    },
    beforeUpdate: function beforeUpdate(chart) {
        var expando = chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY];
        expando._listened = false;
        expando._listeners = {}; // {<event-type>: {<dataset-index>: {<label-key>: <fn>}}}
        expando._datasets = []; // per dataset labels: [Label[]]
        expando._labels = []; // layouted labels: Label[]
    },
    afterDatasetUpdate: function afterDatasetUpdate(chart, args, options) {
        var datasetIndex = args.index;
        var expando = chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY];
        var labels = expando._datasets[datasetIndex] = [];
        var visible = chart.isDatasetVisible(datasetIndex);
        var dataset = chart.data.datasets[datasetIndex];
        var config = $55c1a76b4f1e9f00$var$configure(dataset, options);
        var elements = args.meta.data || [];
        var ctx = chart.ctx;
        var i, j, ilen, jlen, cfg, key, el, label;
        ctx.save();
        for(i = 0, ilen = elements.length; i < ilen; ++i){
            el = elements[i];
            el[$55c1a76b4f1e9f00$var$EXPANDO_KEY] = [];
            if (visible && el && chart.getDataVisibility(i) && !el.skip) for(j = 0, jlen = config.labels.length; j < jlen; ++j){
                cfg = config.labels[j];
                key = cfg._key;
                label = new $55c1a76b4f1e9f00$var$Label(cfg, ctx, el, i);
                label.$groups = {
                    _set: datasetIndex,
                    _key: key || $55c1a76b4f1e9f00$var$DEFAULT_KEY
                };
                label.$context = {
                    active: false,
                    chart: chart,
                    dataIndex: i,
                    dataset: dataset,
                    datasetIndex: datasetIndex
                };
                label.update(label.$context);
                el[$55c1a76b4f1e9f00$var$EXPANDO_KEY].push(label);
                labels.push(label);
            }
        }
        ctx.restore();
        // Store listeners at the chart level and per event type to optimize
        // cases where no listeners are registered for a specific event.
        (0, $3zT2Z.a4)(expando._listeners, config.listeners, {
            merger: function merger(event, target, source) {
                target[event] = target[event] || {};
                target[event][args.index] = source[event];
                expando._listened = true;
            }
        });
    },
    afterUpdate: function afterUpdate(chart) {
        chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY]._labels = $55c1a76b4f1e9f00$var$layout.prepare(chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY]._datasets);
    },
    // Draw labels on top of all dataset elements
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
    afterDatasetsDraw: function afterDatasetsDraw(chart) {
        $55c1a76b4f1e9f00$var$layout.draw(chart, chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY]._labels);
    },
    beforeEvent: function beforeEvent(chart, args) {
        // If there is no listener registered for this chart, `listened` will be false,
        // meaning we can immediately ignore the incoming event and avoid useless extra
        // computation for users who don't implement label interactions.
        if (chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY]._listened) {
            var event = args.event;
            switch(event.type){
                case 'mousemove':
                case 'mouseout':
                    $55c1a76b4f1e9f00$var$handleMoveEvents(chart, event);
                    break;
                case 'click':
                    $55c1a76b4f1e9f00$var$handleClickEvents(chart, event);
                    break;
            }
        }
    },
    afterEvent: function afterEvent(chart) {
        var expando = chart[$55c1a76b4f1e9f00$var$EXPANDO_KEY];
        var previous = expando._actives;
        var actives = expando._actives = chart.getActiveElements();
        var updates = $55c1a76b4f1e9f00$var$utils.arrayDiff(previous, actives);
        var i, ilen, j, jlen, update, label, labels;
        for(i = 0, ilen = updates.length; i < ilen; ++i){
            update = updates[i];
            if (update[1]) {
                labels = update[0].element[$55c1a76b4f1e9f00$var$EXPANDO_KEY] || [];
                for(j = 0, jlen = labels.length; j < jlen; ++j){
                    label = labels[j];
                    label.$context.active = update[1] === 1;
                    label.update(label.$context);
                }
            }
        }
        if (expando._dirty || updates.length) {
            $55c1a76b4f1e9f00$var$layout.update(expando._labels);
            chart.render();
        }
        delete expando._dirty;
    }
};


window.htmx = (0, $4VdIx.default);
(0, $d3f25f4d7d47f13e$export$2e2bcd8739ae039).register((0, $55c1a76b4f1e9f00$export$2e2bcd8739ae039));
window.Alpine = (0, $06dab374eda57fc5$export$2e2bcd8739ae039);
(0, $06dab374eda57fc5$export$2e2bcd8739ae039).plugin((0, $b9dbeb345f84b541$export$2e2bcd8739ae039));
(0, $06dab374eda57fc5$export$2e2bcd8739ae039).plugin((0, $f2bdf6974bcee655$export$2e2bcd8739ae039));
(0, $06dab374eda57fc5$export$2e2bcd8739ae039).plugin((0, $40d4926a28a4e7b6$export$2e2bcd8739ae039));
var $276b24eba12f13fb$var$TOOLBAR_CONFIG = [
    //[{ header: ['1', '2', false] }],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
var $276b24eba12f13fb$var$SIMPLE_TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    //[{ list: 'ordered' }, { list: 'bullet' }],
    [
        'clean'
    ]
];
(0, $06dab374eda57fc5$export$2e2bcd8739ae039).store('shortcuts', {
    part_1: true,
    part_2: null
});
document.addEventListener('alpine:init', function() {
    var reloadFlatpickr = function reloadFlatpickr() {
        if (dates) dates.forEach(function(date) {
            return date.destroy();
        });
        if (times) times.forEach(function(time) {
            return time.destroy();
        });
        dates = (0, $d57b7be5ef1ae277$export$2e2bcd8739ae039)(".datepicker_date", {
            "locale": (0, $c788bd62cabaec58$exports.German),
            enableTime: false,
            dateFormat: "Y-m-d"
        });
        times = (0, $d57b7be5ef1ae277$export$2e2bcd8739ae039)(".datepicker_time", {
            "locale": (0, $c788bd62cabaec58$exports.German),
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i"
        });
    };
    var CountableField = function CountableField(textarea) {
        var countDisplay = document.getElementById(textarea.id + "_counter");
        var countDown = false;
        var minCount, maxCount;
        var hasQuill = textarea.getAttribute("data-quill") === 'true';
        var is_disabled = textarea.getAttribute("disabled") === 'disabled';
        if (textarea != null && countDisplay != null) {
            minCount = textarea.getAttribute("data-min-count");
            maxCount = textarea.getAttribute("data-max-count");
        }
        if (hasQuill && !is_disabled) {
            // hide textarea
            textarea.style.display = "none";
            // add editor container
            var quillContainer = document.createElement("div");
            quillContainer.setAttribute("id", textarea.id + "_container");
            quillContainer.setAttribute("class", "w-full bg-white mt-0.5");
            textarea.parentNode.insertBefore(quillContainer, textarea.nextSibling);
            // add editor div
            var quillEditor = document.createElement("div");
            quillEditor.setAttribute("id", textarea.id + "_editor");
            quillContainer.appendChild(quillEditor);
            // load data from textarea
            quillEditor.innerHTML = textarea.value;
            var quill = new (0, (/*@__PURE__*/$parcel$interopDefault($852297f7037c6a27$exports)))(quillEditor, {
                placeholder: 'Hier Text eingeben ...',
                modules: {
                    toolbar: $276b24eba12f13fb$var$TOOLBAR_CONFIG
                },
                theme: 'snow'
            });
            quill.on('text-change', function(delta, oldDelta, source) {
                if (source === 'user') {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4752ed738165a691$exports))).count(quill.root.innerHTML, updateCharatersLeft, {
                        stripTags: true
                    });
                    textarea.value = quill.root.innerHTML;
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($4752ed738165a691$exports))).count(quill.root.innerHTML, updateCharatersLeft, {
                stripTags: true
            });
        } else (0, (/*@__PURE__*/$parcel$interopDefault($4752ed738165a691$exports))).on(textarea, updateCharatersLeft);
        function updateCharatersLeft(counter) {
            var count = counter["all"];
            var left = maxCount - count;
            var currentDisplay = countDisplay.getElementsByClassName("text-count-current")[0];
            var maxDisplay = countDisplay.getElementsByClassName("text-count-max")[0];
            var overDisplay = countDisplay.getElementsByClassName("text-count-overmax")[0];
            if (left < 0) {
                currentDisplay.innerHTML = 0;
                overDisplay.style.display = "inline";
                maxDisplay.innerHTML = -left;
            } else {
                currentDisplay.innerHTML = left;
                overDisplay.style.display = "none";
            }
        }
    };
    var SimpleQuill = function SimpleQuill(textarea) {
        textarea.style.display = "none";
        // add editor container
        var quillContainer = document.createElement("div");
        quillContainer.setAttribute("id", textarea.id + "_container");
        quillContainer.setAttribute("class", "w-full bg-white mt-0.5");
        textarea.parentNode.insertBefore(quillContainer, textarea.nextSibling);
        // add editor div
        var quillEditor = document.createElement("div");
        quillEditor.setAttribute("id", textarea.id + "_editor");
        quillContainer.appendChild(quillEditor);
        // load data from textarea
        quillEditor.innerHTML = textarea.value;
        var quill = new (0, (/*@__PURE__*/$parcel$interopDefault($852297f7037c6a27$exports)))(quillEditor, {
            placeholder: 'Hier Text eingeben ...',
            modules: {
                toolbar: $276b24eba12f13fb$var$SIMPLE_TOOLBAR_CONFIG
            },
            theme: 'snow'
        });
        quill.on('text-change', function(delta, oldDelta, source) {
            if (source === 'user') textarea.value = quill.root.innerHTML;
        });
    };
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).data('toggleExtraField', function(initial, condition) {
        return {
            value: initial,
            isOpen: function() {
                return condition(this.value);
            },
            init: function() {
                var node = this.$el.querySelector('[x-model="value"]');
                if (node) this.value = node.value || '';
            }
        };
    });
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).data('toggleExtraFieldChecked', function(initial, condition) {
        return {
            value: initial,
            isOpen: function() {
                return condition(this.value);
            },
            init: function() {
                if (Array.isArray(initial)) this.value = (0, $kNmtb._)(this.$el.querySelectorAll('[x-model="value"]:checked')).map(function(node) {
                    return node.value;
                });
                else {
                    var node = this.$el.querySelector('[x-model="value"]:checked');
                    if (node) this.value = node.value;
                }
            }
        };
    });
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).data('toggleInnerExtraFieldChecked', function(initial, condition) {
        return {
            innerValue: initial,
            isOpen: function() {
                return condition(this.innerValue);
            },
            init: function() {
                if (Array.isArray(initial)) this.innerValue = (0, $kNmtb._)(this.$el.querySelectorAll('[x-model="innerValue"]:checked')).map(function(node) {
                    return node.value;
                });
                else {
                    var node = this.$el.querySelector('[x-model="innerValue"]:checked');
                    if (node) this.innerValue = node.value;
                }
            }
        };
    });
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).data('toggleExtraFieldSelected', function(initial, condition) {
        return {
            value: initial,
            isOpen: function() {
                return condition(this.value);
            },
            init: function() {
                if (Array.isArray(initial)) this.value = (0, $kNmtb._)(this.$el.querySelectorAll('[x-model="value"] option[selected]')).map(function(node) {
                    return node.value;
                });
                else {
                    console.log(this.$el);
                    this.value = this.$el.querySelector('[x-model="value"] option[selected]').value;
                }
            }
        };
    });
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).data('multiselect', function() {
        return {
            value: [],
            init: function() {
                var settings = {};
                new (0, $a5c702205a36cd19$export$2e2bcd8739ae039)(this.$el, settings);
            }
        };
    });
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).magic('tooltip', function(el) {
        return function(message) {
            var instance = (0, $c627f24c7159c872$export$2e2bcd8739ae039)(el, {
                content: message,
                trigger: 'manual'
            });
            instance.show();
            setTimeout(function() {
                instance.hide();
                setTimeout(function() {
                    return instance.destroy();
                }, 150);
            }, 2000);
        };
    });
    // Directive: x-tooltip
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).directive('tooltip', function(el, param) {
        var expression = param.expression;
        (0, $c627f24c7159c872$export$2e2bcd8739ae039)(el, {
            content: expression
        });
    });
    window.CountingField = function(limit, direction, ressource) {
        return {
            limit: limit,
            direction: direction || 'down',
            ressource: ressource || 'all',
            counter: 0,
            count: function() {
                return this.direction === 'down' ? this.limit - this.counter : this.counter;
            },
            reached: function() {
                return this.direction === 'down' ? this.counter === 0 : this.counter >= this.limit;
            },
            init: function() {
                var _this = this;
                var node = this.$refs.field;
                if (node) (0, (/*@__PURE__*/$parcel$interopDefault($4752ed738165a691$exports))).on(node, function(counter) {
                    _this.counter = counter[_this.ressource];
                });
            }
        };
    };
    var dates = (0, $d57b7be5ef1ae277$export$2e2bcd8739ae039)(".datepicker_date", {
        "locale": (0, $c788bd62cabaec58$exports.German),
        enableTime: false,
        dateFormat: "d.m.Y"
    });
    var times = (0, $d57b7be5ef1ae277$export$2e2bcd8739ae039)(".datepicker_time", {
        "locale": (0, $c788bd62cabaec58$exports.German),
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i"
    });
    var renderFlatpicker = function(el) {
        var picker = (0, $d57b7be5ef1ae277$export$2e2bcd8739ae039)(el, {
            "locale": (0, $c788bd62cabaec58$exports.German),
            enableTime: true,
            dateFormat: "d.m.Y H:i"
        });
    };
    var renderDateFlatpicker = function(el) {
        var picker = (0, $d57b7be5ef1ae277$export$2e2bcd8739ae039)(el, {
            "locale": (0, $c788bd62cabaec58$exports.German),
            enableTime: false,
            dateFormat: "d.m.Y"
        });
    };
    var renderTomSelect = function(el) {
        var settings = {};
        new (0, $a5c702205a36cd19$export$2e2bcd8739ae039)(el, settings);
    };
    var renderCreateSelect = function(el) {
        var settings = {
            create: true,
            createOnBlur: true,
            sortField: 'text'
        };
        new (0, $a5c702205a36cd19$export$2e2bcd8739ae039)(el, settings);
    };
    document.querySelectorAll('.multi-select').forEach(renderTomSelect);
    document.querySelectorAll('.create-select').forEach(renderCreateSelect);
    window.reloadFlatpickr = reloadFlatpickr;
    window.renderTomSelect = renderTomSelect;
    window.renderCreateSelect = renderCreateSelect;
    window.renderFlatpicker = renderFlatpicker;
    window.renderDateFlatpicker = renderDateFlatpicker;
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).data('loadQuill', function(initial) {
        return {
            init: function() {
                var _this = this;
                var quill = new (0, (/*@__PURE__*/$parcel$interopDefault($852297f7037c6a27$exports)))(this.$refs.quill, {
                    placeholder: 'Hier Text eingeben ...',
                    modules: {
                        toolbar: $276b24eba12f13fb$var$SIMPLE_TOOLBAR_CONFIG
                    },
                    theme: 'snow'
                });
                quill.root.innerHTML = initial;
                this.$refs.textarea.value = initial;
                this.$refs.textarea.style.display = "none";
                quill.on('text-change', function() {
                    _this.$refs.textarea._x_model.set(quill.root.innerHTML);
                });
            }
        };
    });
    window.toggleFeedBackField = function() {
        return {
            value: '',
            na: false,
            rating: null,
            open: false,
            isOpen: function() {
                return this.value || this.open;
            },
            init: function() {
                var node = this.$el.querySelector('[x-model="value"]');
                if (node) this.value = node.value;
                var rating = this.$el.querySelector('[x-model="rating"]:checked');
                if (rating) this.rating = rating.value;
                var na = this.$el.querySelector('[x-model="na"]:checked');
                if (na) this.na = na.value;
            }
        };
    };
    window.toggleExtraFieldSelected = function(initial, condition) {
        return {
            value: initial,
            isOpen: function() {
                return condition(this.value);
            },
            init: function() {
                if (Array.isArray(initial)) this.value = (0, $kNmtb._)(this.$el.querySelectorAll('[x-model="value"] option[selected]')).map(function(node) {
                    return node.value;
                });
                else this.value = this.$el.querySelector('[x-model="value"] option[selected]').value;
            }
        };
    };
    window.TotalRating = function(initialRating) {
        // {rating: {'fgdfgg': {'rating': x, 'weight': x, 'exclude': true}, ...}}
        return (0, $8lZHN._)({
            exclude: function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($jgg5e))).filter((0, (/*@__PURE__*/$parcel$interopDefault($jgg5e))).values(this.rating), function(o) {
                    return o.exclude;
                });
            },
            rated: function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($jgg5e))).filter((0, (/*@__PURE__*/$parcel$interopDefault($jgg5e))).values(this.rating), function(o) {
                    return o.rating !== null && !o.exclude;
                });
            },
            count: function() {
                return this.rated().length + this.exclude().length;
            },
            ratedCount: function() {
                return this.rated().length;
            },
            total: function() {
                var totalWeights = (0, (/*@__PURE__*/$parcel$interopDefault($jgg5e))).sumBy(this.rated(), function(o) {
                    return o.weight;
                });
                var total = (0, (/*@__PURE__*/$parcel$interopDefault($jgg5e))).sumBy(this.rated(), function(o) {
                    return o.weight * o.rating;
                }) / totalWeights;
                return total;
            },
            update: function(newRating) {
                // {label: 'fgdfgg', rating: x}
                var ratingValue = parseInt(newRating.rating);
                if (newRating.label in this.rating) {
                    if (isNaN(ratingValue)) this.rating[newRating.label].rating = null;
                    else this.rating[newRating.label].rating = ratingValue;
                    this.rating[newRating.label].exclude = newRating.exclude || false;
                }
            }
        }, initialRating);
    };
    window.InlineForms = function(params) {
        return {
            template: null,
            add: function() {
                var container = document.getElementById(this.container);
                container.insertAdjacentHTML('beforeend', this.template(this.TOTAL_FORMS));
                this.TOTAL_FORMS++;
            },
            loadTemplate: function(id) {
                var template = document.getElementById(id);
                this.template = function(id) {
                    return template.innerHTML.replace(/__prefix__/g, id).replace(/__number__/g, id + 1);
                };
            }
        };
    };
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).store('preview', {
        active: null,
        fullscreen: false,
        app: {
            id: '',
            rank: '',
            name: ''
        },
        pages: [],
        moderator_app_id: null,
        moderator_updated_at: null,
        setData: function(pages, app) {
            this.pages = pages;
            this.app = app;
            this.active = '#app';
        },
        activeUrl: function() {
            var _this = this;
            var active_page = this.pages.find(function(page) {
                return page.hash === _this.active;
            });
            return active_page ? active_page.url : null;
        },
        isModeratorApp: function(app_id) {
            return this.moderator_app_id === app_id;
        },
        setModeratorData: function(app_id, updated_at) {
            this.moderator_app_id = app_id;
            this.moderator_updated_at = updated_at;
        },
        isFreshModeratorData: function() {
            if (!this.moderator_updated_at || !this.moderator_app_id) return false;
            var updated_at = new Date(this.moderator_updated_at);
            var now = new Date();
            var diffSeconds = (now - updated_at) / 1000;
            return diffSeconds < 500; // consider data fresh if updated within the last 500 seconds
        }
    });
    var preview = (0, $06dab374eda57fc5$export$2e2bcd8739ae039).store('preview');
    window.PreviewIframe = function() {
        return {
            init: function() {
                var that = this;
                (0, $06dab374eda57fc5$export$2e2bcd8739ae039).watch('preview.active', function() {
                    return that.$el.contentWindow.location.replace(preview.activeUrl());
                });
            }
        };
    };
    document.addEventListener('DOMContentLoaded', function(e) {
        [].forEach.call(document.querySelectorAll('[data-count]'), CountableField);
        [].forEach.call(document.querySelectorAll('[data-simple-quill]'), SimpleQuill);
    });
    var barOptions_stacked = {
        tooltips: {
            enabled: false
        },
        hover: {
            animationDuration: 0
        },
        indexAxis: 'y',
        scales: {
            x: {
                ticks: {
                    beginAtZero: true,
                    fontFamily: "'Open Sans Bold', sans-serif",
                    fontSize: 11
                },
                scaleLabel: {
                    display: true
                },
                gridLines: {},
                stacked: true
            },
            y: {
                gridLines: {
                    display: false,
                    color: "#fff",
                    zeroLineColor: "#fff",
                    zeroLineWidth: 0
                },
                ticks: {
                    fontFamily: "'Open Sans Bold', sans-serif",
                    fontSize: 12
                },
                stacked: true
            }
        },
        legend: {
            display: false
        },
        pointLabelFontFamily: "Quadon Extra Bold",
        scaleFontFamily: "Quadon Extra Bold",
        plugins: {
            datalabels: {
                font: {
                    weight: 'bold'
                },
                display: function display(context) {
                    // skip first dataset if value is max in all datasets (to avoid double label)
                    if (context.datasetIndex === 0) {
                        // get max at same index in all datasets
                        var max = context.chart.data.datasets.map(function(e) {
                            return e.data[context.dataIndex];
                        }).reduce(function(a, b) {
                            return Math.max(a, b);
                        });
                        return context.dataset.data[context.dataIndex] !== max;
                    } else return true;
                },
                formatter: function formatter(value, context) {
                    // show total for last dataset
                    if (context.datasetIndex === context.chart.data.datasets.length - 1) {
                        var total = context.chart.data.datasets.map(function(e) {
                            return e.data[context.dataIndex];
                        }).reduce(function(a, b) {
                            return a + b;
                        });
                        return total;
                    } else return value;
                }
            }
        }
    };
    (0, $06dab374eda57fc5$export$2e2bcd8739ae039).data("chart", function(datasource) {
        return {
            chart: null,
            labels: null,
            datasets: null,
            init: function() {
                var data = JSON.parse(document.getElementById(datasource).textContent);
                this.labels = data.labels;
                this.datasets = data.datasets;
                this.chart = new (0, $d3f25f4d7d47f13e$export$2e2bcd8739ae039)(this.$el, {
                    type: "bar",
                    plugins: [
                        (0, $55c1a76b4f1e9f00$export$2e2bcd8739ae039)
                    ],
                    data: {
                        labels: this.labels,
                        datasets: this.datasets
                    },
                    options: barOptions_stacked
                });
            }
        };
    });
});
(0, $06dab374eda57fc5$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=assets.f25b6727.js.map
